import React, { useCallback, useState, useEffect, useRef, useMemo, useContext, useId, Fragment, Component } from 'react';
import { useLocation, Route, Redirect, Link, useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Layout, Button, Dropdown, Menu, Select, Input, Tag, Typography, List, Tooltip, Modal, message, Switch, Badge, Table, Collapse, Divider, InputNumber, notification, Spin, Form, Alert, TreeSelect } from 'antd';
import { MenuOutlined, LeftOutlined, RightOutlined, UserOutlined, FilterOutlined, CloseOutlined, CloseCircleOutlined, WarningFilled, CheckOutlined, LoadingOutlined, BellFilled, CaretRightOutlined } from '@ant-design/icons';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { FaCog, FaSignOutAlt, FaPen, FaQuestionCircle, FaPeopleCarry, FaCrosshairs, FaRegCopy, FaBell, FaCalendarAlt, FaInfoCircle, FaExclamationTriangle, FaTimesCircle } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import { persistReducer, createTransform, persistStore } from 'redux-persist';
import { createAsyncThunk, createEntityAdapter, createSlice, createSelector, configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import localforage from 'localforage';
import { combineReducers } from 'redux';
import storage from 'redux-persist/lib/storage';
import axios from 'axios';
import cloneDeep from 'lodash/cloneDeep';
import jwt_decode from 'jwt-decode';
import * as Sentry from '@sentry/react';
import snakeCase from 'lodash/snakeCase';
import area from '@turf/area';
import moment from 'moment';
import groupBy from 'lodash/groupBy';
import isNumber from 'lodash/isNumber';
import { StyleSheet, css } from 'aphrodite';
import { isEmpty } from 'lodash';
import 'antd/dist/antd.css';
import Moment from 'react-moment';
import CircularSlider from '@fseehawer/react-circular-slider';
import Highcharts from 'highcharts';
import HighchartsGantt from 'highcharts/highcharts-gantt.src';
import HighchartsReact from 'highcharts-react-official';
import NoDataToDisplay from 'highcharts/modules/no-data-to-display';
import ReactDOMServer from 'react-dom/server';
import WebMercatorViewport from 'viewport-mercator-project';
import bbox from '@turf/bbox';
import ReactResizeDetector from 'react-resize-detector';
import L$1 from 'leaflet';
import '@mapbox/mapbox-gl-draw';
import '@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css';
import { useLeaflet, GeoJSON, Marker, Map as Map$1, TileLayer } from 'react-leaflet';
import maplibregl$1 from 'maplibre-gl';
import 'react-leaflet-draw';
import 'leaflet-draw/dist/leaflet.draw-src.css';
import '@maplibre/maplibre-gl-leaflet';
import 'maplibre-gl/dist/maplibre-gl.css';
import 'dhtmlx-scheduler';
import 'dhtmlx-scheduler/codebase/dhtmlxscheduler_material.css';
import 'dhtmlx-scheduler/codebase/ext/dhtmlxscheduler_limit';
import 'dhtmlx-scheduler/codebase/ext/dhtmlxscheduler_multiselection';
import 'dhtmlx-scheduler/codebase/ext/dhtmlxscheduler_timeline';
import 'dhtmlx-scheduler/codebase/ext/dhtmlxscheduler_tooltip';
import 'dhtmlx-scheduler/codebase/ext/dhtmlxscheduler_multiselect';
import 'dhtmlx-scheduler/codebase/sources/skins/Timeline.css';
import 'dhtmlx-scheduler/codebase/ext/dhtmlxscheduler_minical';
import 'dhtmlx-scheduler/codebase/ext/dhtmlxscheduler_all_timed';

function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function () {
    return !!t;
  })();
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function (t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function (t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(typeof e + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function (e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function () {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function (e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function (t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function (t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    catch: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw Error("illegal catch attempt");
    },
    delegateYield: function (e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}

var _excluded$1 = ["component", "authService", "adminRequired"];
function PrivateRoute(_ref) {
  var Component = _ref.component,
    authService = _ref.authService,
    adminRequired = _ref.adminRequired,
    rest = _objectWithoutProperties(_ref, _excluded$1);
  var userInfo = authService.useAuth();
  var authorized = userInfo && (!adminRequired || userInfo.admin);
  var location = useLocation();
  var render = function render(props) {
    return /*#__PURE__*/React.createElement(Component, props);
  };
  return authorized ? /*#__PURE__*/React.createElement(Route, _extends({
    render: render
  }, rest)) : /*#__PURE__*/React.createElement(Redirect, {
    to: {
      pathname: '/login',
      state: {
        from: location
      }
    }
  });
}
PrivateRoute.propTypes = {
  component: PropTypes.elementType.isRequired,
  authService: PropTypes.shape({
    useAuth: PropTypes.func.isRequired
  }).isRequired,
  adminRequired: PropTypes.bool
};
PrivateRoute.defaultProps = {
  adminRequired: false
};

function useWindowSize() {
  var isClient = (typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object';
  var getSize = useCallback(function () {
    return {
      width: isClient ? window.innerWidth : undefined,
      height: isClient ? window.innerHeight : undefined
    };
  }, [isClient]);
  var _useState = useState(getSize),
    _useState2 = _slicedToArray(_useState, 2),
    windowSize = _useState2[0],
    setWindowSize = _useState2[1];
  var handleResize = useCallback(function () {
    setWindowSize(getSize());
  }, [setWindowSize, getSize]);
  useEffect(function () {
    if (!isClient) return false;
    window.addEventListener('resize', handleResize);
    return function () {
      return window.removeEventListener('resize', handleResize);
    };
  }, [handleResize, isClient]); // Empty array ensures that effect is only run on mount and unmount

  return windowSize;
}

var Header = Layout.Header,
  Content = Layout.Content;
function AppTemplate(props) {
  var size = useWindowSize();
  var scrollRef = useRef(null);
  var isMobile = size.width <= 600;
  var _useState = useState(isMobile),
    _useState2 = _slicedToArray(_useState, 2),
    collapsed = _useState2[0],
    setCollapsed = _useState2[1];
  var SidebarComponent = props.sidebarComponent,
    NavBarComponent = props.navBarComponent,
    EntitySideBarComponent = props.entitySideBarComponent,
    children = props.children,
    _props$title = props.title,
    title = _props$title === void 0 ? 'FarmX' : _props$title,
    logo = props.logo,
    headerMenu = props.headerMenu,
    theme = props.theme,
    RanchBlockBreadcrumb = props.ranchBlockBreadcrumb;
  var onCollapse = useCallback(function (collapse) {
    setCollapsed(collapse);
  }, [setCollapsed]);
  var fontColor = theme === 'dark' ? 'white' : '#555';
  var scroll = function scroll(scrollOffset) {
    scrollRef.current.scrollLeft += scrollOffset;
  };
  return /*#__PURE__*/React.createElement(Layout, {
    className: "layout"
  }, /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("title", null, title)), /*#__PURE__*/React.createElement(Header, null, /*#__PURE__*/React.createElement("div", {
    className: "menu-trigger"
  }, /*#__PURE__*/React.createElement(MenuOutlined, {
    className: "trigger",
    style: {
      fontSize: '25px',
      color: fontColor
    },
    onClick: function onClick() {
      return setCollapsed(!collapsed);
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "logo"
  }, /*#__PURE__*/React.createElement("img", {
    className: "header-logo",
    alt: "FarmX",
    src: logo
  })), NavBarComponent && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    className: "scroll-button",
    type: "primary",
    icon: /*#__PURE__*/React.createElement(LeftOutlined, null),
    onClick: function onClick() {
      return scroll(-25);
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "middle-menu",
    ref: scrollRef
  }, /*#__PURE__*/React.createElement(NavBarComponent, {
    isMobile: isMobile
  })), /*#__PURE__*/React.createElement(Button, {
    className: "scroll-button",
    type: "primary",
    icon: /*#__PURE__*/React.createElement(RightOutlined, null),
    onClick: function onClick() {
      return scroll(25);
    }
  })), RanchBlockBreadcrumb && /*#__PURE__*/React.createElement("div", {
    className: collapsed ? 'middle-menu' : 'breadcrumb-select-container-width middle-menu'
  }, /*#__PURE__*/React.createElement(RanchBlockBreadcrumb, null)), /*#__PURE__*/React.createElement("div", {
    className: "right-menu"
  }, headerMenu)), /*#__PURE__*/React.createElement(Layout, null, SidebarComponent && /*#__PURE__*/React.createElement(SidebarComponent, {
    isMobile: isMobile,
    onCollapse: onCollapse,
    collapsed: collapsed
  }), EntitySideBarComponent && /*#__PURE__*/React.createElement(EntitySideBarComponent, {
    isMobile: isMobile,
    onCollapse: onCollapse,
    collapsed: collapsed
  }), /*#__PURE__*/React.createElement(Content, {
    className: collapsed ? 'content-container collapsed' : 'content-container'
  }, children)));
}
AppTemplate.propTypes = {
  sidebarComponent: PropTypes.elementType,
  navBarComponent: PropTypes.elementType,
  entitySideBarComponent: PropTypes.elementType,
  children: PropTypes.element.isRequired,
  title: PropTypes.string,
  logo: PropTypes.string.isRequired,
  headerMenu: PropTypes.element.isRequired,
  theme: PropTypes.oneOf(['dark', 'light']),
  ranchBlockBreadcrumb: PropTypes.elementType
};
AppTemplate.defaultProps = {
  sidebarComponent: null,
  navBarComponent: null,
  entitySideBarComponent: null,
  title: 'FarmX',
  theme: 'light',
  ranchBlockBreadcrumb: null
};

var UserMenuOptions = {
  ADMIN_OPERATIONS: 'admin_operations',
  SETTINGS: 'settings',
  ORGANIZATION: 'organization',
  HELP: 'help',
  FEEDBACK: 'feedback',
  DIVIDER: 'divider',
  LOGOUT: 'logout'
};
var SETTINGS = UserMenuOptions.SETTINGS,
  HELP = UserMenuOptions.HELP,
  FEEDBACK = UserMenuOptions.FEEDBACK,
  DIVIDER = UserMenuOptions.DIVIDER,
  LOGOUT = UserMenuOptions.LOGOUT,
  ORGANIZATION = UserMenuOptions.ORGANIZATION,
  ADMIN_OPERATIONS = UserMenuOptions.ADMIN_OPERATIONS;
function UserMenu(props) {
  var userInfo = props.userInfo,
    onFeedbackMenuClick = props.onFeedbackMenuClick,
    options = props.options;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    optionList = _useState2[0],
    setOptionList = _useState2[1];
  var isAdmin = userInfo && userInfo.admin;
  useEffect(function () {
    var optList = [];
    var filteredOptions = options;
    if (!isAdmin) {
      filteredOptions = options.filter(function (opt) {
        return opt !== ADMIN_OPERATIONS;
      });
    }
    filteredOptions.forEach(function (opt, i) {
      optList.push(opt);
      if (i < filteredOptions.length - 1) optList.push(DIVIDER);
    });
    setOptionList(optList);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAdmin]);
  if (!userInfo) return null;
  var getDropdownOptions = function getDropdownOptions(option) {
    switch (option) {
      case SETTINGS:
        return /*#__PURE__*/React.createElement(Menu.Item, null, /*#__PURE__*/React.createElement(Link, {
          to: "/settings"
        }, /*#__PURE__*/React.createElement(FaCog, null), /*#__PURE__*/React.createElement("span", null, t('Settings'))));
      case ORGANIZATION:
        return /*#__PURE__*/React.createElement(Menu.Item, null, /*#__PURE__*/React.createElement(Link, {
          to: "/organization"
        }, /*#__PURE__*/React.createElement(FaPeopleCarry, null), /*#__PURE__*/React.createElement("span", null, t('Organization'))));
      case HELP:
        return /*#__PURE__*/React.createElement(Menu.Item, null, /*#__PURE__*/React.createElement(Link, {
          to: "/help"
        }, /*#__PURE__*/React.createElement(FaQuestionCircle, null), /*#__PURE__*/React.createElement("span", null, t('Resources And Help'))));
      case FEEDBACK:
        return /*#__PURE__*/React.createElement(Menu.Item, {
          onClick: onFeedbackMenuClick
        }, /*#__PURE__*/React.createElement(FaPen, null), /*#__PURE__*/React.createElement("span", {
          className: "menu-title margin-left-10"
        }, t('Submit Feedback')));
      case LOGOUT:
        return /*#__PURE__*/React.createElement(Menu.Item, null, /*#__PURE__*/React.createElement(Link, {
          to: "/logout"
        }, /*#__PURE__*/React.createElement(FaSignOutAlt, null), /*#__PURE__*/React.createElement("span", null, t('Logout'))));
      case ADMIN_OPERATIONS:
        return /*#__PURE__*/React.createElement(Menu.Item, null, /*#__PURE__*/React.createElement(Link, {
          to: "/admin-operations"
        }, /*#__PURE__*/React.createElement(FaCog, null), /*#__PURE__*/React.createElement("span", null, t('Admin Operations'))));
      case DIVIDER:
        return /*#__PURE__*/React.createElement(Menu.Divider, null);
      default:
        return null;
    }
  };
  return /*#__PURE__*/React.createElement(Dropdown, {
    placement: "bottomRight",
    trigger: ['click'],
    overlay: /*#__PURE__*/React.createElement(Menu, null, optionList.map(function (opt) {
      return getDropdownOptions(opt);
    }))
  }, userInfo ? /*#__PURE__*/React.createElement(Button, {
    type: "link",
    className: "ant-dropdown-link user-menu"
  }, /*#__PURE__*/React.createElement("span", {
    className: "user-title"
  }, userInfo.username), /*#__PURE__*/React.createElement(UserOutlined, {
    title: "My Account"
  })) : /*#__PURE__*/React.createElement(Button, null));
}
UserMenu.propTypes = {
  userInfo: PropTypes.shape({
    username: PropTypes.string.isRequired
  }),
  onFeedbackMenuClick: PropTypes.func,
  options: PropTypes.arrayOf(PropTypes.string)
};
UserMenu.defaultProps = {
  userInfo: null,
  onFeedbackMenuClick: null,
  options: [SETTINGS, LOGOUT]
};

var Sider = Layout.Sider;
var CollapsableSidebar = /*#__PURE__*/function (_React$Component) {
  function CollapsableSidebar() {
    var _this;
    _classCallCheck(this, CollapsableSidebar);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _possibleConstructorReturn(_this, (_this = _callSuper(this, CollapsableSidebar, [].concat(args)), _this.collapse = function () {
      var onCollapse = _this.props.onCollapse;
      onCollapse(true);
    }, _this.toggle = function () {
      var _this$props = _this.props,
        collapsed = _this$props.collapsed,
        onCollapse = _this$props.onCollapse;
      onCollapse(!collapsed);
    }, _this.toggleIfNotMobile = function () {
      var isMobile = _this.props.isMobile;
      if (!isMobile) {
        _this.toggle();
      }
    }, _assertThisInitialized(_this)));
  }
  _inherits(CollapsableSidebar, _React$Component);
  return _createClass(CollapsableSidebar, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        collapsed = _this$props2.collapsed,
        onCollapse = _this$props2.onCollapse,
        children = _this$props2.children,
        theme = _this$props2.theme;
      return /*#__PURE__*/React.createElement(Sider, {
        className: "nav",
        collapsible: true,
        collapsed: collapsed,
        onCollapse: onCollapse,
        collapsedWidth: 50,
        theme: theme
      }, children, /*#__PURE__*/React.createElement("div", {
        className: "sider-filler",
        role: "button",
        tabIndex: 0,
        onKeyDown: this.toggleIfNotMobile,
        onClick: this.toggleIfNotMobile
      }));
    }
  }]);
}(React.Component);
CollapsableSidebar.propTypes = {
  collapsed: PropTypes.bool,
  onCollapse: PropTypes.func,
  children: PropTypes.element,
  theme: PropTypes.oneOf(['light', 'dark']),
  isMobile: PropTypes.bool
};
CollapsableSidebar.defaultProps = {
  onCollapse: function onCollapse() {},
  collapsed: false,
  children: null,
  theme: 'dark',
  isMobile: false
};

// TODO: this file is duplicated between both the RN and web repos

var constants$1 = {
  APP_NAME: 'farmx-admin',
  VERSION: '0.1',
  API_URL: process.env.REACT_APP_API_URL,
  // PROD: "https://map.farmx.co", STAGING: https://staging.farmx.co, LOCAL: http://localhost:8000
  ADMIN_URL: process.env.REACT_APP_ADMIN_URL,
  // PROD: "https://map.farmx.co/admin", STAGING: https://staging.farmx.co/admin, LOCAL: http://localhost:8000/admin
  GOOGLE_AUTH_PATH: "/api/google-auth/redirect/",
  DEFAULT_HEADERS: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  },
  SENSOR_TYPES: {
    'farmx_dendrometer': {
      name: "Dendrometer",
      shortName: "DD"
    },
    'weather_station': {
      name: "Weather Station",
      shortName: "WS"
    },
    'gateway': {
      name: "Gateway",
      shortName: "BD"
    },
    'pixl_soil': {
      name: "Pixl Soil",
      shortName: "PX"
    },
    'water_pressure': {
      name: "Pressure",
      shortName: "PR"
    },
    'aquacheck_soil': {
      name: "AquaCheck Soil",
      shortName: "AQ"
    },
    'water_flow': {
      name: "Flowmeter",
      shortName: "FM"
    },
    'water_flow_analog': {
      name: "Flowmeter (mesh)",
      shortName: "FMX"
    },
    'vfd': {
      name: "VFD",
      shortName: "VFD"
    },
    'farmx_frost': {
      name: "Frost",
      shortName: "FR"
    },
    'farmx_infrared': {
      name: "Infrared",
      shortName: "IF"
    },
    'boxer_soil': {
      name: "Boxer Soil",
      shortName: "BX"
    },
    'boxer_station': {
      name: "Base Station",
      shortName: "BS"
    },
    'cavalier': {
      name: "Cavalier",
      shortName: "CAV"
    },
    'valve': {
      name: "Valve",
      shortName: "VL"
    },
    'temperature_humidity': {
      name: "Temperature Humidity",
      shortName: "T&H"
    }
  }
};
axios.defaults.baseURL = constants$1.API_URL;
const getSensorKey$1 = sensor => {
  if (sensor.identifier === null || sensor.identifier === undefined) return undefined;
  if (sensor.type === null || sensor.type === undefined) return undefined;
  return `${sensor.type}/${sensor.identifier}`;
};
const getSensorKeyId$1 = sensor => {
  if (sensor.id === null || sensor.id === undefined) return undefined;
  if (sensor.type === null || sensor.type === undefined) return undefined;
  return `${sensor.type}:${sensor.id}`;
};
const getSensorByTypeId$1 = (sensor, sensors) => {
  // TODO: error checking
  const key = getSensorKey$1(sensor);
  if (key === undefined) return undefined;
  return sensors.items[key];
};
const getSensorTempKey$1 = sensor => {
  return `tmp/${sensor.type}/${sensor.identifier}`;
};
const getBaseIdentifier$1 = identifier => {
  const regexes = [/_withdrawn/gi, /_removed/gi, /_deleting/gi];
  if (identifier === undefined) return undefined;
  regexes.forEach(regex => identifier = identifier.replace(regex, ''));
  return identifier;
};
const getSensorsForEntity$1 = async entityId => {
  return await axios.get(`/api/sensors/all/list/?entity=${entityId}`);
};
const loadSensors$1 = async installed => await axios.get('/api/sensors/all/');
const loadSensorsRanch$1 = async ranchId => await axios.get(`/api/sensors/ranch/${ranchId}/`);
const loadPaginatedSensorsList$1 = async ranchId => {
  return await axios.get(`/api/sensors/all/list/?ranch=${ranchId}`);
};
const loadGatewayMapData$1 = async gatewayId => {
  return await axios.get(`/api/map/gateway/${gatewayId}/`);
};
const loadSensorMapData$1 = async (sensorType, sensorIdentifier) => {
  return await axios.get(`/api/map/sensor/${sensorType}/${sensorIdentifier}/`);
};

// sensor stats apis
const fetchGatewayStatsList$1 = async () => axios.get('/api/stats/gateway/');
const fetchCavalierStatsList$1 = async () => axios.get('/api/stats/cavalier/');
const fetchSensorStatsList$1 = async () => axios.get('/api/stats/sensor/');
const fetchSensorStatsSingle$1 = async (sensorType, sensorIdentifier) => {
  const url = `/api/stats/sensor/single/?sensorType=${sensorType}&sensorIdentifier=${sensorIdentifier}`;
  return await axios.get(url);
};
const fetchBlockStatsList$1 = async (params = {}) => axios.get('/api/stats/block/', {
  params
});
const fetchSingleBlockStats$1 = async (type, blockId) => axios.get(`/api/stats/block/${blockId}`);
const fetchRanchStatsList$1 = async (params = {}) => axios.get('/api/stats/ranch/', {
  params
});
const fetchSingleRanchStats$1 = async (type, ranchId) => axios.get(`/api/stats/ranch/${ranchId}/`);

// sensor note apis
const fetchSensorNotes$1 = async () => axios.get('/api/sensor/notes/');
const fetchSensorImages$1 = async () => axios.get('/api/sensor/images/');
const loadSensorStatus$1$1 = async (sensorType, sensorIdentifier) => {
  const url = `/api/sensor/status/?sensorType=${sensorType}&sensorIdentifier=${sensorIdentifier}`;
  return await axios.get(url);
};
const loadSensorStatusForSelectorTypeAndId$1 = async (type, id, excludeType) => {
  return await axios.get(`/api/sensors/status/${type}/${id}/?exclude=${excludeType}`);
};
const loadSensorStatusForSelectorTypeAndIdWithParam$1 = async (type, id, paramStr) => {
  return await axios.get(`/api/sensors/status/${type}/${id}/${paramStr}`);
};
const loadNodeAssociatedSensors$1 = async identifier => {
  return await axios.get(`/api/node/associated-sensors/${identifier}/`);
};
const loadNodeMetaDataByNodeIdentifier$1 = async identifier => {
  return await axios.get(`/api/manufacturing/node/${identifier}/`);
};
const loadRanchInstallationCheck$1 = async ranchId => {
  return await axios.get(`/api/ranches/${ranchId}/installation-check/`);
};
const loadRanchInstallationCheckExport$1 = async ranchId => {
  return await axios.get(`/api/sensor/ranch/${ranchId}/installation-check/export/`, {
    responseType: 'blob'
  });
};
const loadSensorStatusForRanchId$1 = async (ranchId, excludeType) => {
  return await axios.get(`/api/sensor/status/ranch/${ranchId}/?exclude=${excludeType}`);
};
const loadSensorDetail$1 = async (sensorType, sensorIdentifier) => {
  const url = `/api/sensor/detail/?sensorType=${sensorType}&sensorIdentifier=${sensorIdentifier}`;
  return await axios.get(url);
};
const loadSensorDetailById$1 = async (sensorType, sensorId) => {
  const url = `/api/sensor/detail/?sensorType=${sensorType}&sensorId=${sensorId}`;
  return await axios.get(url);
};
const loadSensorTypes$1 = async () => {
  return await axios.get('/api/sensors/types/');
};
const loadAvailableSensors$1 = async sensorType => {
  return await axios.get(`/api/sensors/available/?sensorType=${sensorType}`);
};
const loadSensorCapabilities$1 = async (sensorType, sensorIdentifier) => {
  const url = `/api/sensors/capabilities/?sensorType=${sensorType}&sensorIdentifier=${sensorIdentifier}`;
  return await axios.get(url);
};
const loadSensorData$2 = async (sensorType, sensorId, variables, startDate, endDate, cached, apiVersion, sensorsString) => {
  if (cached === undefined) cached = true;
  const sensorString = sensorsString || `${sensorType}:${sensorId}`;
  let url = (apiVersion ? `/api/v${apiVersion}/data/graph/?sensor=` : '/api/data/graph/?sensors=') + sensorString;
  url += (apiVersion ? '&variables=' : '&variable=') + variables.join(',');
  console.log('url', url);
  if (startDate != null) {
    url += '&startDate=' + startDate.toISOString();
  }
  if (endDate != null) {
    url += '&endDate=' + endDate.toISOString();
  }
  url += `&cached=${cached}`;
  return await axios.get(`${url}/`);
};
const loadPixlRecentData$1 = async sensorId => await axios.get(`/api/data/pixl/recent/${sensorId}/`);
const postSensorNote$1 = async ({
  sensorType,
  sensorIdentifier,
  action,
  text,
  date
}) => {
  return await axios.post('/api/sensor/notes/', {
    sensorType,
    sensorIdentifier,
    action,
    text,
    date
  });
};
const postSensorImage$1 = async ({
  sensorType,
  sensorIdentifier,
  title,
  imageData,
  date
}) => {
  return await axios.post('/api/sensor/image/upload/', {
    sensorType,
    sensorIdentifier,
    title,
    image: imageData,
    date
  });
};
const updateSensorLocation$1 = async ({
  sensorType,
  sensorIdentifier,
  lat,
  lng
}) => {
  return await axios.post('/api/sensor/update/location/', {
    sensorType,
    sensorIdentifier,
    lat,
    lng
  });
};

// Milesight node reboot API
const rebootMilesightNode$1 = async ({
  sensorIdentifier
}) => {
  return await axios.post(`/api/lora/milesight/reboot/${sensorIdentifier}/`);
};
const createSensor$1 = async ({
  sensorType,
  sensorIdentifier
}) => {
  return await axios.post('/api/sensor/create/', {
    sensorType,
    identifier: sensorIdentifier
  });
};
const installSensor$1 = async ({
  sensorType,
  sensorIdentifier
}) => {
  return await axios.post('/api/sensor/install/', {
    sensorType,
    sensorIdentifier
  });
};
const uninstallSensor$1 = async ({
  sensorType,
  sensorIdentifier
}) => {
  return await axios.post('/api/sensor/uninstall/', {
    sensorType,
    sensorIdentifier
  });
};
const removeSensor$1 = async ({
  sensorType,
  sensorIdentifier,
  newState
}) => {
  return await axios.post('/api/sensor/remove/', {
    sensorType,
    sensorIdentifier,
    newState
  });
};
const removeCavalier$1 = async ({
  sensorType,
  sensorIdentifier,
  newState
}) => {
  return await axios.post('/api/sensor/remove/cavalier/', {
    sensorType,
    sensorIdentifier,
    newState
  });
};
const replaceSensor$1 = async ({
  sensorType,
  oldSensorIdentifier,
  newSensorIdentifier
}) => {
  return await axios.post('/api/sensor/replace/', {
    sensorType,
    oldSensorIdentifier,
    newSensorIdentifier
  });
};
const copySensorMetadataToCavalier$1 = async ({
  sensorType,
  sensorIdentifier
}) => {
  const data = {
    sensorType,
    sensorIdentifier
  };
  return await axios.post('/api/sensor/syncfromcav/', data);
};
const copyCavalierMetadataToSensor$1 = async ({
  sensorType,
  sensorIdentifier
}) => {
  const data = {
    sensorType,
    sensorIdentifier
  };
  return await axios.post('/api/sensor/synctocav/', data);
};
const setSensorMoistureData$1 = async ({
  sensorType,
  sensorIdentifier
}) => {
  const data = {
    sensor_type: sensorType,
    sensor_identifier: sensorIdentifier,
    soilgrid: false
  };
  return await axios.post('/api/soil-data/set-sensor-soil-depth-data/', data);
};

/*
 * Sensor type api
 */

const getSensorTypes$1 = () => {
  return Object.keys(constants$1.SENSOR_TYPES).map(sensorType => sensorType);
};
const getSensorTypeShortNames$1 = () => {
  return Object.keys(constants$1.SENSOR_TYPES).map(sensorType => constants$1.SENSOR_TYPES[sensorType].shortName);
};
const getSensorTypeForShortName$1 = shortName => {
  return Object.keys(constants$1.SENSOR_TYPES).find(key => constants$1.SENSOR_TYPES[key].shortName === shortName);
};
const getShortNameForSensorType$1 = sensorType => {
  const sensorTypeInfo = constants$1.SENSOR_TYPES[sensorType];
  if (!sensorTypeInfo) return undefined;
  return sensorTypeInfo.shortName;
};
const getNameForSensorType$2 = sensorType => {
  const sensorTypeInfo = constants$1.SENSOR_TYPES[sensorType];
  if (!sensorTypeInfo) return undefined;
  return sensorTypeInfo.name;
};
const getSensorTypeFromSensorKey$1 = sensorKey => {
  const regex = /^[^//]*/;
  const type = sensorKey.match(regex)[0];
  if (type !== '') return type;
  return undefined;
};
const getSensorObjectFromSensorKey$1 = sensorKey => {
  const parts = sensorKey.split('/', 2);
  if (parts.length === 2 && parts[0].length && parts[1].length) return {
    type: parts[0],
    identifier: parts[1]
  };
  return undefined;
};
const getSensorObjectFromSensorKeyId$1 = sensorKey => {
  const parts = sensorKey.split(':', 2);
  if (parts.length === 2 && parts[0].length && parts[1].length) return {
    type: parts[0],
    id: parseInt(parts[1])
  };
  return undefined;
};

/*
 * Install State
 */

const isInstallable$1 = sensor => {
  if (sensor === undefined || sensor.install_state === undefined) return false;
  return sensor.install_state !== 'installed';
};

/*
 * Data sanitation
 */

const sanitizeLocation$1 = location => {
  return {
    lat: location.lat.toFixed(6),
    lng: location.lng.toFixed(6)
  };
};
const sanitizeDeviceLocation$1 = location => {
  location = {
    lat: location.coords.latitude,
    lng: location.coords.longitude
  };
  return sanitizeLocation$1(location);
};
const fetchSoilStatus$1 = async () => axios.get('/api/entities/state/');
const fetchSoilStatusByRanchId$1 = async ranchId => {
  try {
    const {
      data
    } = await fetchSoilStatus$1();
    const dataLength = data.length;
    for (let i = 0; i < dataLength; i += 1) {
      const ranches = data[i].ranches;
      const ranchesLength = ranches.length;
      for (let j = 0; j < ranchesLength; j += 1) {
        const ranchState = ranches[j];
        if (ranches[j].id === ranchId) {
          return ranchState;
        }
      }
    }
    throw new Error(`Ranch ${ranchId} not found`);
  } catch (e) {
    console.log('ERROR fetchRanchSoilStatusAll', e);
    throw e;
  }
};
const fetchStatusForRanchSensors$1 = async sensorsAll => {
  try {
    const sensorsRanchByIdentifierAndType = {};
    const reqs = [];
    sensorsAll.forEach(sensor => {
      const item = cloneDeep(sensor);
      if (item.visible || ['valve', 'vfd'].includes(item.type)) {
        sensorsRanchByIdentifierAndType[`${item.type}/${item.identifier}`] = item;
      }
    });
    Object.keys(sensorsRanchByIdentifierAndType).forEach(key => {
      const item = cloneDeep(sensorsRanchByIdentifierAndType[key]);
      const {
        identifier,
        type
      } = item;
      if (item.location && item.visible || item.location && ['valve', 'vfd'].includes(item.type)) {
        reqs.push(loadSensorStatus$1$1(type, identifier));
      }
    });
    return Promise.allSettled(reqs);
  } catch (error) {
    throw error;
  }
};
const updateSoilSensorRefillPercent$1 = async ({
  type,
  id,
  data
}) => axios.put(`/api/sensors/${type}/${id}/refillpoint/`, data);
const getSoilSensorRefillPercent$1 = async ({
  type,
  id
}) => axios.get(`/api/sensors/${type}/${id}/refillpoint/`);
const getSoilSensorProperties$1 = async ({
  type = 'aquacheck_soil',
  id
}) => axios.get(`/api/sensors/${type}/${id}/soil-properties/`);
const updateSoilSensorProperties$1 = async ({
  id,
  data,
  type = 'aquacheck_soil'
}) => axios.put(`/api/sensors/${type}/${id}/soil-properties/`, data);
const copySoilSensorProperties$1 = async ({
  sensorType,
  sensorId,
  selectedSensors,
  selectedBlock,
  selectedRanch
}) => {
  return axios.post(`/api/sensors/copy-soil-sensor-properties/${sensorType}/${sensorId}/`, {
    target_sensors: selectedSensors,
    target_block: selectedBlock,
    target_ranch: selectedRanch
  });
};
const rebootNode$1 = async identifier => {
  return axios.post(`/api/nodes/${identifier}/reboot/`);
};
const rebootLoraNode$1 = async identifier => {
  return axios.post(`/api/lora/lora/reboot/${identifier}/`);
};

/*
// code from master branch. Can be removed if not used anymore.
export const fetchStatusForRanchSensorsOld = async (sensorsAll) => {
  try {
    const sensorsRanchByIdentifierAndType = {};

    const reqs = [];
    reqs.push(fetchRanchSoilStatusDummy());

    sensorsAll.forEach((sensor) => {
      const item = cloneDeep(sensor);
      if (item.visible || ['valve', 'vfd'].includes(item.type)) {
        sensorsRanchByIdentifierAndType[`${item.type}/${item.identifier}`] = item;
      }
    });

    Object.keys(sensorsRanchByIdentifierAndType).forEach((key) => {
      const item = cloneDeep(sensorsRanchByIdentifierAndType[key]);
      const { identifier, type } = item;
      if ((item.location && item.visible) || (item.location && ['valve', 'vfd'].includes(item.type))) {
        reqs.push(loadSensorStatus(type, identifier));
      }
    });

    const results = await Promise.allSettled(reqs);

    const now = (new Date()).getTime();
    const soilResult = results.shift();

    const soilStatusSensors = {};

    // const stateBlocks = soilResult.value.data.blocks.reduce((acc, curr) => {
    //   acc[curr.id] = cloneDeep(curr);
    //   curr.state.details.all_data.forEach((s) => {
    //     soilStatusSensors[s.sensor] = cloneDeep(s);
    //   });
    //   return acc;
    // }, {});

    // const stateRanch = cloneDeep(soilResult.value.data.state);

    soilResult.value.data.state.details.all_data.forEach((s) => {
      soilStatusSensors[s.sensor] = cloneDeep(s);
    });

    const okResults = results.filter((r) => r === Object(r) && r.value && r.value.data && r.value.data.id);

    const sensorFeatures = okResults
      .map((r) => { // make it reduce function to get new okResults with soil state
        const sensorBase = cloneDeep(sensorsRanchByIdentifierAndType[`${r.value.data.type}/${r.value.data.identifier}`]);
        const id = `${sensorBase.type}/${sensorBase.identifier}`;

        let lastPostedInMinutes = -1;
        if (r.value.data.earliestDate
          && r.value.data.latestDate) {
          const earliestDate = (new Date(r.value.data.earliestDate))
            .getTime();
          const lastPosted = (new Date(r.value.data.latestDate))
            .getTime();
          if (lastPosted >= earliestDate) {
            lastPostedInMinutes = Math.round((now - lastPosted) / 1000 / 60);
          }
        }

        const sensor = {
          id,
          type: 'Feature',
          geometry: {
            type: 'Point',
            coordinates: [sensorBase.location.lng, sensorBase.location.lat],
          },
          properties: {
            ...sensorBase,
            ...r.value.data,
            id,
            lastPostedInMinutes,
            dbIdStatus: r.value.data.id,
            dbIdBase: sensorBase.id,
            lastUpdated: Date.now(),
          },
        };

        if (soilStatusSensors[sensorBase.identifier]) {
          sensor.properties = {
            ...cloneDeep(sensor.properties),
            ...cloneDeep(soilStatusSensors[sensorBase.identifier]),
          }
        }

        return sensor;
      });

    let sensorsGeoJSON = {
      type: 'FeatureCollection',
      features: sensorFeatures,
    };

    sensorsGeoJSON = prepareZeroIslandSensors(sensorsGeoJSON);

    return sensorsGeoJSON.features;
  } catch (error) {
    throw error;
  }
}
*/

/**
 * Get sensor notes. Optionally filter by type, identifier and date.
 * @param {Object} filterOptions
 * @param {String} filterOptions.type
 * @param {String} filterOptions.identifier
 * @param {String} filterOptions.dateStart
 * @param {String} filterOptions.dateEnd
 * @param {String} filterOptions.sensorId
 * @param {String} filterOptions.page
 * @param {String} filterOptions.action
 * @param {String} filterOptions.user
 */
const getSensorNotes$1 = filterOptions => {
  let url = '/api/sensor/notes/new/';
  const params = {};
  if (filterOptions) {
    const {
      type,
      identifier,
      dateStart,
      dateEnd,
      sensorId,
      page,
      user,
      action
    } = filterOptions;
    if (type) params.sensor_type = type;
    if (identifier) params.sensor_identifier = identifier;
    if (dateStart) params.date_start = dateStart;
    if (dateEnd) params.date_end = dateEnd;
    if (sensorId) params.sensor_id = sensorId;
    if (page) params.page = page;
    if (action) params.action = action;
    if (user) params.user = user;
  }
  return axios.get(url, {
    params
  });
};
var sensorApi$1$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getSensorKey: getSensorKey$1,
  getSensorKeyId: getSensorKeyId$1,
  getSensorByTypeId: getSensorByTypeId$1,
  getSensorTempKey: getSensorTempKey$1,
  getBaseIdentifier: getBaseIdentifier$1,
  getSensorsForEntity: getSensorsForEntity$1,
  loadSensors: loadSensors$1,
  loadSensorsRanch: loadSensorsRanch$1,
  loadPaginatedSensorsList: loadPaginatedSensorsList$1,
  loadGatewayMapData: loadGatewayMapData$1,
  loadSensorMapData: loadSensorMapData$1,
  fetchGatewayStatsList: fetchGatewayStatsList$1,
  fetchCavalierStatsList: fetchCavalierStatsList$1,
  fetchSensorStatsList: fetchSensorStatsList$1,
  fetchSensorStatsSingle: fetchSensorStatsSingle$1,
  fetchBlockStatsList: fetchBlockStatsList$1,
  fetchSingleBlockStats: fetchSingleBlockStats$1,
  fetchRanchStatsList: fetchRanchStatsList$1,
  fetchSingleRanchStats: fetchSingleRanchStats$1,
  fetchSensorNotes: fetchSensorNotes$1,
  fetchSensorImages: fetchSensorImages$1,
  loadSensorStatus: loadSensorStatus$1$1,
  loadSensorStatusForSelectorTypeAndId: loadSensorStatusForSelectorTypeAndId$1,
  loadSensorStatusForSelectorTypeAndIdWithParam: loadSensorStatusForSelectorTypeAndIdWithParam$1,
  loadNodeAssociatedSensors: loadNodeAssociatedSensors$1,
  loadNodeMetaDataByNodeIdentifier: loadNodeMetaDataByNodeIdentifier$1,
  loadRanchInstallationCheck: loadRanchInstallationCheck$1,
  loadRanchInstallationCheckExport: loadRanchInstallationCheckExport$1,
  loadSensorStatusForRanchId: loadSensorStatusForRanchId$1,
  loadSensorDetail: loadSensorDetail$1,
  loadSensorDetailById: loadSensorDetailById$1,
  loadSensorTypes: loadSensorTypes$1,
  loadAvailableSensors: loadAvailableSensors$1,
  loadSensorCapabilities: loadSensorCapabilities$1,
  loadSensorData: loadSensorData$2,
  loadPixlRecentData: loadPixlRecentData$1,
  postSensorNote: postSensorNote$1,
  postSensorImage: postSensorImage$1,
  updateSensorLocation: updateSensorLocation$1,
  rebootMilesightNode: rebootMilesightNode$1,
  createSensor: createSensor$1,
  installSensor: installSensor$1,
  uninstallSensor: uninstallSensor$1,
  removeSensor: removeSensor$1,
  removeCavalier: removeCavalier$1,
  replaceSensor: replaceSensor$1,
  copySensorMetadataToCavalier: copySensorMetadataToCavalier$1,
  copyCavalierMetadataToSensor: copyCavalierMetadataToSensor$1,
  setSensorMoistureData: setSensorMoistureData$1,
  getSensorTypes: getSensorTypes$1,
  getSensorTypeShortNames: getSensorTypeShortNames$1,
  getSensorTypeForShortName: getSensorTypeForShortName$1,
  getShortNameForSensorType: getShortNameForSensorType$1,
  getNameForSensorType: getNameForSensorType$2,
  getSensorTypeFromSensorKey: getSensorTypeFromSensorKey$1,
  getSensorObjectFromSensorKey: getSensorObjectFromSensorKey$1,
  getSensorObjectFromSensorKeyId: getSensorObjectFromSensorKeyId$1,
  isInstallable: isInstallable$1,
  sanitizeLocation: sanitizeLocation$1,
  sanitizeDeviceLocation: sanitizeDeviceLocation$1,
  fetchSoilStatus: fetchSoilStatus$1,
  fetchSoilStatusByRanchId: fetchSoilStatusByRanchId$1,
  fetchStatusForRanchSensors: fetchStatusForRanchSensors$1,
  updateSoilSensorRefillPercent: updateSoilSensorRefillPercent$1,
  getSoilSensorRefillPercent: getSoilSensorRefillPercent$1,
  getSoilSensorProperties: getSoilSensorProperties$1,
  updateSoilSensorProperties: updateSoilSensorProperties$1,
  copySoilSensorProperties: copySoilSensorProperties$1,
  rebootNode: rebootNode$1,
  rebootLoraNode: rebootLoraNode$1,
  getSensorNotes: getSensorNotes$1
});
const getAllEntity$1 = async () => axios.get('/api/farm/entities/');
const getEntityDetail$2 = async entityId => axios.get(`/api/farm/entity/${entityId}/`);
const getRanchDetail$2 = async ranchId => axios.get(`/api/farm/ranch/${ranchId}/`);
const getBlockDetail$1 = async blockId => axios.get(`/api/farm/block/${blockId}/`);
const getEntityList$2 = async (filter = false) => {
  return axios.get('/api/farm/entity/', filter ? {
    params: {
      filter: 1
    }
  } : '');
};
const getRanchList$2 = async (filter = false) => {
  return axios.get('/api/farm/ranch/', filter ? {
    params: {
      filter: 1
    }
  } : '');
};
const getBlockList$1 = async (filter = false) => {
  return axios.get('/api/farm/block/', filter ? {
    params: {
      filter: 1
    }
  } : '');
};
const getEntityRanchList$1 = async entityId => {
  return axios.get(`/api/farm/entities/${entityId}/ranches/`);
};
const getEntityBlockList$1 = async entityId => {
  return axios.get(`/api/farm/block/detail/?entity=${entityId}`);
};
const getAvailableRanchList$1 = async () => axios.get('/api/farm/ranch/available/');
const postRanchGeoJson$1 = async ({
  entityId,
  ranchGeojson
}) => axios.post('/api/ranch/geojson/', {
  entityId,
  ranchGeojson
});
const getBlockAvailableWater$1 = async blockId => axios.get(`/api/block/${blockId}/soil/currentwater/`);
const updateBlockAutoSchedule$1 = async ({
  autoSchedule,
  blockId
}) => axios.patch(`/api/farm/block/${blockId}/`, {
  auto_schedule: autoSchedule
});
const updateBlockAutoSprinklerControl$1 = async ({
  autoSprinklerControl,
  blockId
}) => axios.patch(`/api/farm/block/${blockId}/`, {
  auto_sprinkler_control: autoSprinklerControl
});
const updateBlockAutoIrrigationControl$1 = async ({
  autoIrrigationControl,
  blockId
}) => axios.patch(`/api/farm/block/${blockId}/`, {
  auto_irrigation_control: autoIrrigationControl
});
const updateBlockAutoCoolingControl$1 = async ({
  autoCoolingControl,
  blockId
}) => axios.patch(`/api/farm/block/${blockId}/`, {
  auto_cooling_control: autoCoolingControl
});
const getChillHours$1 = ranchId => axios.get(`/api/ranches/${ranchId}/chillhours/`);
const getChillPortions$1 = ranchId => axios.get(`/api/ranches/${ranchId}/chillportions/`);
const getRanchPrecip$1 = ranchId => axios.get(`/api/ranches/${ranchId}/precip`);
const getRanchRainfallDaily$1 = ranchId => axios.get(`/api/ranches/${ranchId}/rainfall/daily/`);
const getCumulativePrecipitation$1 = ({
  ranchId,
  start,
  end
}) => axios.get(`/api/ranches/${ranchId}/precip/cumulative/?start=${start}&end=${end}`);
const getGDD$1 = ({
  ranchId,
  lower,
  upper
}) => axios.get(`/api/ranches/${ranchId}/gdd/?lower=${lower}&upper=${upper}`);
const getRanchSummary$1 = ranchId => axios.get(`/api/ranches/${ranchId}/summary/`);
var farmApi$1$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getAllEntity: getAllEntity$1,
  getEntityDetail: getEntityDetail$2,
  getRanchDetail: getRanchDetail$2,
  getBlockDetail: getBlockDetail$1,
  getEntityList: getEntityList$2,
  getRanchList: getRanchList$2,
  getBlockList: getBlockList$1,
  getEntityRanchList: getEntityRanchList$1,
  getEntityBlockList: getEntityBlockList$1,
  getAvailableRanchList: getAvailableRanchList$1,
  postRanchGeoJson: postRanchGeoJson$1,
  getBlockAvailableWater: getBlockAvailableWater$1,
  updateBlockAutoSchedule: updateBlockAutoSchedule$1,
  updateBlockAutoSprinklerControl: updateBlockAutoSprinklerControl$1,
  updateBlockAutoIrrigationControl: updateBlockAutoIrrigationControl$1,
  updateBlockAutoCoolingControl: updateBlockAutoCoolingControl$1,
  getChillHours: getChillHours$1,
  getChillPortions: getChillPortions$1,
  getRanchPrecip: getRanchPrecip$1,
  getRanchRainfallDaily: getRanchRainfallDaily$1,
  getCumulativePrecipitation: getCumulativePrecipitation$1,
  getGDD: getGDD$1,
  getRanchSummary: getRanchSummary$1
});
const getUsers$1 = async () => axios.get("/api/users/");
const getUserById$1 = async id => axios.get(`/api/users/${id}/`);
const changePassword$2 = async (currentPassword, newPassword) => axios.patch('/api/user/password/change/', {
  old_password: currentPassword,
  new_password: newPassword
});
const getUserSettings$1 = async () => await axios.get("/api/user/settings/");
const patchUserSettings$1 = async data => await axios.patch("/api/user/settings/", data);
const getUserAppConfig$1 = async () => {
  try {
    const response = await axios.get("/api/user/config/app/");
    return response.data;
  } catch (error) {
    return false;
  }
};
const updateUserAppConfig$1 = async data => {
  try {
    const response = await axios.patch("/api/user/config/app/", data);
    return response.data;
  } catch (error) {
    return false;
  }
};

// NOTE: copied here because import of feedApi was not working
const loadUserEvents$1 = async (args = {}) => {
  const {
    cursor,
    blockId,
    sensorIdentifier,
    sensorType,
    logLevel,
    active,
    eventType,
    eventCategory,
    dateStart,
    dateEnd,
    cancelToken,
    ranchId,
    entityId,
    q
  } = args;
  const params = {};
  if (cursor) params['cursor'] = cursor;
  if (blockId) params['block'] = blockId;
  if (ranchId) params['ranch'] = ranchId;
  if (entityId) params['entity'] = entityId;
  if (logLevel) params['log_level'] = logLevel;
  if (typeof active === 'boolean') params['active'] = active;
  if (eventType) params['event_type'] = eventType;
  if (eventCategory) params['event_category'] = eventCategory;
  if (dateStart) params['date_start'] = dateStart.toDate().toISOString();
  if (dateEnd) params['date_end'] = dateEnd.toDate().toISOString();
  if (q) params['q'] = q;
  if (sensorType) params['sensor_type'] = sensorType;
  if (sensorIdentifier) params['sensor_identifier'] = sensorIdentifier;
  if (q) params['q'] = q;
  const baseUrl = '/api/feed/events/';
  const queryString = '?' + new URLSearchParams(params).toString();
  const url = baseUrl + queryString;
  return await axios.get(url, {
    cancelToken
  });
};
const getCancelToken$1 = () => axios.CancelToken.source();
var userApi$1$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getUsers: getUsers$1,
  getUserById: getUserById$1,
  changePassword: changePassword$2,
  getUserSettings: getUserSettings$1,
  patchUserSettings: patchUserSettings$1,
  getUserAppConfig: getUserAppConfig$1,
  updateUserAppConfig: updateUserAppConfig$1,
  loadUserEvents: loadUserEvents$1,
  getCancelToken: getCancelToken$1
});
const fetchAllScheduledIrrigationEvents$1 = async () => {
  return await axios.get('/api/schedule/irrigation/');
};
const fetchBlockSchedule$1 = async blockId => {
  return await axios.get(`/api/schedule/block/${blockId}/`);
};
const fetchAllBlockSchedule$1 = async blockIds => {
  const reqs = blockIds.map(blockId => fetchBlockSchedule$1(blockId));
  const responses = await Promise.allSettled(reqs);
  return responses.filter(response => response.status === 'fulfilled' && response.value.status === 200).map(response => ({
    ...response.value.data
  }));
};
const createScheduledIrrigationEvent$1$1 = async ({
  start_date,
  stop_date,
  block
}) => {
  return await axios.post('/api/schedule/irrigation/', {
    start_date,
    stop_date,
    block
  });
};
const createOverride$2 = async ({
  sensorType,
  sensorIdentifier,
  state
}) => {
  return axios.post(`/api/sensors/${sensorType}/override/create/`, {
    sensorType,
    sensorIdentifier,
    state
  });
};
const endOverride$2 = async ({
  sensorType,
  sensorIdentifier
}) => {
  return axios.post(`/api/sensors/${sensorType}/override/end/`, {
    sensorType,
    sensorIdentifier
  });
};
const updateScheduledIrrigationEvent$1$1 = async ({
  id,
  start_date,
  stop_date,
  block
}) => {
  return await axios.put('api/schedule/irrigation/' + id + '/', {
    start_date,
    stop_date,
    block
  });
};
const deleteScheduledIrrigationEvent$1$1 = async ({
  id
}) => {
  return await axios.delete('api/schedule/irrigation/' + id + '/');
};
var controlApi$1$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  fetchAllScheduledIrrigationEvents: fetchAllScheduledIrrigationEvents$1,
  fetchBlockSchedule: fetchBlockSchedule$1,
  fetchAllBlockSchedule: fetchAllBlockSchedule$1,
  createScheduledIrrigationEvent: createScheduledIrrigationEvent$1$1,
  createOverride: createOverride$2,
  endOverride: endOverride$2,
  updateScheduledIrrigationEvent: updateScheduledIrrigationEvent$1$1,
  deleteScheduledIrrigationEvent: deleteScheduledIrrigationEvent$1$1
});
const fetchPlansByRanchId$1 = async ranchId => captureError$1(() => axios.get(`/api/plan/ranch/${ranchId}/`));

/**
 * Create - https://map.farmx.co/api/plan/create/
 * This endpoint allows for the creation of an installation plan.
 * It accepts all fields, although the following are the only required fields:
 * - ranch_name
 *  -ranch
 * @param {*} payload
 */
const createPlan$1 = async payload => captureError$1(() => axios.post('/api/plan/create/', payload));
const fetchPlanById$1 = async id => captureError$1(() => axios.get(`/api/plan/edit/${id}/`));
const updatePlanById$1 = async (id, payload) => captureError$1(() => axios.put(`/api/plan/edit/${id}/`, payload));
const patchPlanById$1 = async (id, payload) => captureError$1(() => axios.patch(`/api/plan/edit/${id}/`, payload));
const deletePlanById$1 = async id => captureError$1(() => axios.delete(`/api/plan/edit/${id}/`));
var plansApi$1$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  fetchPlansByRanchId: fetchPlansByRanchId$1,
  createPlan: createPlan$1,
  fetchPlanById: fetchPlanById$1,
  updatePlanById: updatePlanById$1,
  patchPlanById: patchPlanById$1,
  deletePlanById: deletePlanById$1
});
const get3DBlock$1 = async blockId => axios.get(`/api/data/3d/block/${blockId}/`);
const get3DBlockDateRange$1 = async (blockId, startDate, endDate) => axios.get(`/api/data/3d/?block=${blockId}&startDate=${startDate}&endDate=${endDate}/`);
const getBlockRootzoneVWCGraph$1 = async ({
  blockId,
  startDate,
  endDate
}) => {
  return axios.get(`/api/block/rootzone-vwc-graph/?block=${blockId}&startDate=${startDate}&endDate=${endDate}`);
};
const getBlockAnomaly$1 = async blockId => {
  return axios.get(`/api/anomaly/block/${blockId}/`);
};
const requestImagingServices$1 = async () => {
  return axios.post('/api/user/request/imaging/services/');
};
const anomalyErrorReport$1 = async errorObj => {
  return axios.post('/api/jira/anomaly/error/report/', errorObj);
};
const softDeleteAnomaly$1 = async deleteObj => {
  return axios.post(`https://map2.farmx.co/api/anomalyexclusion/create/`, deleteObj);
};
const createAnomaly$1 = async anomaly => {
  return axios.post(`/api/anomaly/create/`, anomaly);
};
const updateAnomaly$1 = async anomaly => {
  return axios.put(`/api/anomaly/edit/${anomaly.id}/`, anomaly);
};
const deleteAnomaly$1 = async anomalyId => {
  return axios.delete(`/api/anomaly/edit/${anomalyId}/`);
};
const getAnomalyComments$1 = async anomalyId => {
  return axios.get(`/api/anomaly/${anomalyId}/comment/`);
};
const createAnomalyComment$1 = async anomalyCommentData => {
  return axios.post('/api/anomaly/comment/create/', anomalyCommentData);
};
const updateAnomalyComment$1 = async (commentId, anomalyCommentData) => {
  return axios.patch(`/api/anomaly/comment/edit/${commentId}/`, anomalyCommentData);
};
const deleteAnomalyComment$1 = async commentId => {
  return axios.delete(`/api/anomaly/comment/edit/${commentId}/`);
};
const getPlantsListForBlock$1 = async blockId => {
  return axios.get(`/api/plant/block/${blockId}/list/`);
};
const getPlantsBlockAnalyticsData$1 = async blockId => {
  return axios.get(`/api/plant/block/${blockId}/analytics/`);
};
const setCropType$1 = async ({
  blockId,
  ...blockDetails
}) => {
  return axios.patch(`/api/block/update/${blockId}/`, blockDetails);
};
const getAnomalyArea$1 = async anomaly => {
  return axios.get(`/api/anomaly/imagery_anomaly_area/${anomaly.id}/`);
};
const getImageryAnomalyComparison$1 = async imageryAnomalyId => {
  return axios.get(`/api/recommendations/imagery_anomaly_comparison/?imagery_anomaly_id=${imageryAnomalyId}`);
};
const updateCustomKcForBlock$1 = async (blockId, customKcValue) => {
  return axios.put(`/api/block/update_custom_kc/${blockId}/`, customKcValue);
};
const updateKrdiForBlock$1 = async (blockId, data) => {
  return axios.patch(`/api/block/update_krdi/${blockId}/`, data);
};
const updateIrrigationTargetPointForBlock$1 = async (blockId, data) => {
  return axios.patch(`/api/block/${blockId}/update_irrigation_target_point/`, data);
};
const deleteAnomalyPolygonArea$1 = async anomalyAreaId => {
  return axios.delete(`/api/anomaly/polygon/delete/${anomalyAreaId}/`);
};
var blockApi$1$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  get3DBlock: get3DBlock$1,
  get3DBlockDateRange: get3DBlockDateRange$1,
  getBlockRootzoneVWCGraph: getBlockRootzoneVWCGraph$1,
  getBlockAnomaly: getBlockAnomaly$1,
  requestImagingServices: requestImagingServices$1,
  anomalyErrorReport: anomalyErrorReport$1,
  softDeleteAnomaly: softDeleteAnomaly$1,
  createAnomaly: createAnomaly$1,
  updateAnomaly: updateAnomaly$1,
  deleteAnomaly: deleteAnomaly$1,
  getAnomalyComments: getAnomalyComments$1,
  createAnomalyComment: createAnomalyComment$1,
  updateAnomalyComment: updateAnomalyComment$1,
  deleteAnomalyComment: deleteAnomalyComment$1,
  getPlantsListForBlock: getPlantsListForBlock$1,
  getPlantsBlockAnalyticsData: getPlantsBlockAnalyticsData$1,
  setCropType: setCropType$1,
  getAnomalyArea: getAnomalyArea$1,
  getImageryAnomalyComparison: getImageryAnomalyComparison$1,
  updateCustomKcForBlock: updateCustomKcForBlock$1,
  updateKrdiForBlock: updateKrdiForBlock$1,
  updateIrrigationTargetPointForBlock: updateIrrigationTargetPointForBlock$1,
  deleteAnomalyPolygonArea: deleteAnomalyPolygonArea$1
});
const getAvailableSatelliteData$1 = async (type, id) => axios.get(`/api/data/satellite/available/v2/?${type}=${id}`);

/**
 * Examples of URLs
 * https://map.farmx.co/api/data/satellite/?ranch=73661&DataType=NDVI&date=1621422000
 * https://map.farmx.co/api/data/satellite/?block=736277&DataType=NDVI&date=1620990000
 */
const getSatelliteDataByDataTypeAndDate$1 = async (type, id, dataType, time) => axios.get(`/api/data/satellite/?${type}=${id}&DataType=${dataType}&date=${time}`);
const getAvailableDroneDataForRanchId$1 = async id => axios.get(`/api/imagery/available/?ranchId=${id}`);
const getDroneImageryTiles$1 = async (assetType, ranchId, imageryTaskId, imageryProjectId) => axios.get(`/api/imagery/tile/?ranchId=${ranchId}&imageryTaskId=${imageryTaskId}&imageryProjectId=${imageryProjectId}&assetType=${assetType}`);
const getSatelliteCombinedDataByDataTypeAndDate$1 = async (type, id, dataType, sDate, eDate) => {
  const dateRange = sDate && eDate ? `&startDate=${sDate}&endDate=${eDate}` : '';
  return axios.get(`/api/data/satellite/combined/?${type}=${id}&DataType=${dataType}${dateRange}`);
};
var satelliteApi$1$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getAvailableSatelliteData: getAvailableSatelliteData$1,
  getSatelliteDataByDataTypeAndDate: getSatelliteDataByDataTypeAndDate$1,
  getAvailableDroneDataForRanchId: getAvailableDroneDataForRanchId$1,
  getDroneImageryTiles: getDroneImageryTiles$1,
  getSatelliteCombinedDataByDataTypeAndDate: getSatelliteCombinedDataByDataTypeAndDate$1
});

// Recommendation API
const retrieveIrrigationRecommendationsForUser$1 = async () => axios.get('/api/recommendations/');
const retrieveIrrigationRecommendationsForEntity$1 = async entityId => axios.get(`/api/recommendations/?entity_id=${entityId}`);
const retrieveIrrigationRecommendationForBlock$1 = async ({
  blockId
}) => axios.get(`/api/recommendations/block/${blockId}`);
const retrieveIrrigationRecommendation$1 = async ({
  id
}) => axios.get(`/api/recommendations/${id}/`);
const patchIrrigationRecommendation$1 = async ({
  id,
  type,
  data
}) => axios.patch(`/api/recommendations/${type}/${id}/`, data);
const retrieveIrrigationRecommendationStatus$1 = async ({
  id
}) => axios.get(`/api/recommendations/${id}/status/`);
const createRecommendationSchedule$1 = async data => axios.post('/api/recommendations/schedule/update/', data);
const refreshIrrigationRecommendation$1 = async data => axios.post('/api/recommendations/irrigation/refresh/', data);
const retrieveRecommendationMetadataRefreshStatus$1 = async ({
  blockId
}) => axios.get(`/api/recommendations/block/${blockId}/metadata-refresh-status/`);
const retrieveBlockDroneImageryAnalytics$1 = async id => axios.get(`/api/imagery/analytics/block/drone/${id}/`);
var recommendationApi$1$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  retrieveIrrigationRecommendationsForUser: retrieveIrrigationRecommendationsForUser$1,
  retrieveIrrigationRecommendationsForEntity: retrieveIrrigationRecommendationsForEntity$1,
  retrieveIrrigationRecommendationForBlock: retrieveIrrigationRecommendationForBlock$1,
  retrieveIrrigationRecommendation: retrieveIrrigationRecommendation$1,
  patchIrrigationRecommendation: patchIrrigationRecommendation$1,
  retrieveIrrigationRecommendationStatus: retrieveIrrigationRecommendationStatus$1,
  createRecommendationSchedule: createRecommendationSchedule$1,
  refreshIrrigationRecommendation: refreshIrrigationRecommendation$1,
  retrieveRecommendationMetadataRefreshStatus: retrieveRecommendationMetadataRefreshStatus$1,
  retrieveBlockDroneImageryAnalytics: retrieveBlockDroneImageryAnalytics$1
});

// Scheduled irrigation events

const retrieveAllBlockScheduledIrrigationEvents$1 = async () => axios.get('/api/schedule/irrigation/');
const retrieveBlockScheduledIrrigationEvents$1 = async blockId => axios.get(`/api/schedule/irrigation/block/${blockId}/`);
const createScheduledIrrigationEvent$2 = async scheduledIrrigationEvent => {
  return axios.post('/api/schedule/irrigation/new/', scheduledIrrigationEvent);
};
const retrieveScheduledIrrigationEvent$1 = async id => axios.get(`api/schedule/irrigation/${id}/`);
const updateScheduledIrrigationEvent$2 = async data => axios.put(`api/schedule/irrigation/${data.id}/`, data);
const patchScheduledIrrigationEvent$1 = async data => axios.patch(`api/schedule/irrigation/${data.id}/`, data);
const deleteScheduledIrrigationEvent$2 = async id => axios.delete(`api/schedule/irrigation/${id}/`);

// Rendered irrigation events

const retrieveBlockRenderedIrrigationEvents$1 = async ({
  blockId,
  dateStart,
  dateEnd
}) => {
  const query = `?dateStart=${dateStart.toISOString()}&dateEnd=${dateEnd.toISOString()}`;
  return axios.get(`/api/schedule/irrigation/block/${blockId}/rendered/${query}`);
};

// Event edits

const createBlockScheduledIrrigationEventEdit$1 = async scheduledIrrigationEventEdit => {
  return axios.post('/api/schedule/irrigation/edit/new/', scheduledIrrigationEventEdit);
};
const retrieveBlockScheduledIrrigationEventEdit$1 = async eventEditId => {
  return axios.get(`/api/schedule/irrigation/edit/${eventEditId}/`);
};
const retrieveBlockScheduledIrrigationEventEditByIndex$1 = async ({
  eventId,
  eventIndex
}) => {
  return axios.get(`/api/schedule/irrigation/${eventId}/edit/${eventIndex}/`);
};
const updateBlockScheduledIrrigationEventEdit$1 = async scheduledIrrigationEventEdit => {
  const {
    id: eventEditId
  } = scheduledIrrigationEventEdit;
  return axios.put(`/api/schedule/irrigation/edit/${eventEditId}/`, scheduledIrrigationEventEdit);
};
const deleteBlockScheduledIrrigationEventEdit$1 = async eventEditId => {
  return axios.delete(`/api/schedule/irrigation/edit/${eventEditId}/`);
};
const retrieveBlockWaterUsageData$1 = async ({
  blockIds,
  dateStart,
  dateEnd
}) => {
  return axios.get(`/api/block/water-usage/?blockIds=${blockIds.join(',')}&dateStart=${dateStart}&dateEnd=${dateEnd}`);
};
const emailWaterUsageData$1 = async emailContent => {
  return axios.post('/api/block/water-usage/email/', emailContent);
};
var scheduleApi$1$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  retrieveAllBlockScheduledIrrigationEvents: retrieveAllBlockScheduledIrrigationEvents$1,
  retrieveBlockScheduledIrrigationEvents: retrieveBlockScheduledIrrigationEvents$1,
  createScheduledIrrigationEvent: createScheduledIrrigationEvent$2,
  retrieveScheduledIrrigationEvent: retrieveScheduledIrrigationEvent$1,
  updateScheduledIrrigationEvent: updateScheduledIrrigationEvent$2,
  patchScheduledIrrigationEvent: patchScheduledIrrigationEvent$1,
  deleteScheduledIrrigationEvent: deleteScheduledIrrigationEvent$2,
  retrieveBlockRenderedIrrigationEvents: retrieveBlockRenderedIrrigationEvents$1,
  createBlockScheduledIrrigationEventEdit: createBlockScheduledIrrigationEventEdit$1,
  retrieveBlockScheduledIrrigationEventEdit: retrieveBlockScheduledIrrigationEventEdit$1,
  retrieveBlockScheduledIrrigationEventEditByIndex: retrieveBlockScheduledIrrigationEventEditByIndex$1,
  updateBlockScheduledIrrigationEventEdit: updateBlockScheduledIrrigationEventEdit$1,
  deleteBlockScheduledIrrigationEventEdit: deleteBlockScheduledIrrigationEventEdit$1,
  retrieveBlockWaterUsageData: retrieveBlockWaterUsageData$1,
  emailWaterUsageData: emailWaterUsageData$1
});
const getCustomerReport$1 = async users => axios.get(`/api/reports/customer/?users=${users.join(",")}`);
const getBlockReport$1 = async blockIds => axios.get(`/api/reports/block/?blockIds=${blockIds.join(",")}`);
const getAnomalySummaryReport$1 = async ({
  ranch,
  dateStart,
  dateEnd
}) => {
  return axios.get(`/api/reports/anomaly/${ranch}/?dateStart=${dateStart}&dateEnd=${dateEnd}`);
};
var reportsApi$1$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getCustomerReport: getCustomerReport$1,
  getBlockReport: getBlockReport$1,
  getAnomalySummaryReport: getAnomalySummaryReport$1
});

// helper to format key value pair in url encoded format, ignore null values
const format$1 = (k, v) => v !== null ? `${k}=${encodeURIComponent(v)}` : "";

// Convert object to url encoded query string
const toQueryString$1 = obj => {
  return Object.entries(obj).map(([k, v]) => {
    if (Array.isArray(v)) {
      return format$1(k, v.join(','));
    }
    return format$1(k, v);
  }).filter(x => x).join('&');
};
const listTeams$1 = async query => {
  return axios.get(`/api/teams/?` + toQueryString$1(query));
};
const retrieveTeam$1 = async (teamId, query) => {
  return axios.get(`/api/teams/${teamId}/?` + toQueryString$1(query));
};
const createTeam$1 = async team => {
  return axios.post(`/api/teams/`, team);
};
const updateTeam$1 = async (teamId, team) => {
  return axios.put(`/api/teams/${teamId}/`, team);
};
const deleteTeam$1 = async teamId => {
  return axios.delete(`/api/teams/${teamId}/`);
};

// Route: api/teams/{id}/update-ranch-list/
// ranchList = array of ranch id
const updateRanchList$1 = async (teamId, ranchList) => {
  return axios.put(`/api/teams/${teamId}/update-ranch-list/`, ranchList);
};
const listTeamRanches$1 = async (teamId, query) => {
  return axios.get(`/api/teams/${teamId}/ranches/?` + toQueryString$1(query));
};
var teamApi$1$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  listTeams: listTeams$1,
  retrieveTeam: retrieveTeam$1,
  createTeam: createTeam$1,
  updateTeam: updateTeam$1,
  deleteTeam: deleteTeam$1,
  updateRanchList: updateRanchList$1,
  listTeamRanches: listTeamRanches$1
});
const listTeamUserAccess$1 = async query => {
  return axios.get(`/api/team-user-access/?` + toQueryString$1(query));
};
const retrieveTeamUserAccess$1 = async (teamUserAccessId, query) => {
  return axios.get(`/api/team-user-access/${teamUserAccessId}/?` + toQueryString$1(query));
};
const createTeamUserAccess$1 = async teamUserAccessData => {
  return axios.post('/api/team-user-access/', teamUserAccessData);
};
const updateTeamUserAccess$1 = async (teamUserAccessId, teamUserAccessData) => {
  return axios.put(`/api/team-user-access/${teamUserAccessId}/`, teamUserAccessData);
};
const deleteTeamUserAccess$1 = async teamUserAccessId => {
  return axios.delete(`/api/team-user-access/${teamUserAccessId}/`);
};
var teamUserAccessApi$1$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  listTeamUserAccess: listTeamUserAccess$1,
  retrieveTeamUserAccess: retrieveTeamUserAccess$1,
  createTeamUserAccess: createTeamUserAccess$1,
  updateTeamUserAccess: updateTeamUserAccess$1,
  deleteTeamUserAccess: deleteTeamUserAccess$1
});

// returns a list of roles
const getRoles$1 = async () => {
  return axios.get(`/api/roles/`);
};
var roleApi$1$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getRoles: getRoles$1
});
const getEntityMonitoringData$1 = async ({
  date,
  region
}) => {
  const params = new URLSearchParams();
  if (date) params.append('date', date);
  if (region) params.append('region', region);
  const query = params.toString();
  return axios.get(`/api/entity/monitoring/${query ? `?${query}` : ''}`);
};
var entityMonitoringApi$1$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getEntityMonitoringData: getEntityMonitoringData$1
});
const listRanches$1 = async query => {
  return axios.get(`/api/v3/ranches/?` + toQueryString$1(query));
};
var ranchApi$1$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  listRanches: listRanches$1,
  getRanchMonitoringData: getEntityMonitoringData$1
});
const listFollowBlocks$1 = async query => {
  return axios.get(`/api/followblock/?` + toQueryString$1(query));
};
const retrieveFollowBlock$1 = async (followBlockId, query) => {
  return axios.get(`/api/followblock/${followBlockId}/?` + toQueryString$1(query));
};
const createFollowBlock$1 = async followBlock => {
  return axios.post(`/api/followblock/`, followBlock);
};
const deleteFollowBlock$1 = async followBlockId => {
  return axios.delete(`/api/followblock/${followBlockId}/`);
};
const followRanch$1 = async (ranchId, userId) => {
  return axios.put(`/api/followblock/follow-ranch/`, {
    ranch_id: ranchId,
    user_id: userId
  });
};
const unfollowRanch$1 = async (ranchId, userId) => {
  return axios.put(`/api/followblock/unfollow-ranch/`, {
    ranch_id: ranchId,
    user_id: userId
  });
};
var followBlockApi$1$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  listFollowBlocks: listFollowBlocks$1,
  retrieveFollowBlock: retrieveFollowBlock$1,
  createFollowBlock: createFollowBlock$1,
  deleteFollowBlock: deleteFollowBlock$1,
  followRanch: followRanch$1,
  unfollowRanch: unfollowRanch$1
});

// Sensor coordinations
const fetchSensorCoordinations$1 = async () => await axios.get('/api/sensor-coordinations/statuses/');

// Update sensor actionSubtype
const updateSensorCoordination$1 = async ({
  blockId,
  actionType,
  actionSubType,
  autoMode
}) => {
  return await axios.patch('/api/sensor-coordinations/block/toggle/action-subtype/auto-mode/', {
    follower_block_id: blockId,
    action_type: actionType,
    action_subtype: actionSubType,
    auto_mode: autoMode
  });
};
const fetchMainThresholds$1 = async () => await axios.get('/api/sensor-coordinations/main-thresholds/');
const createMainThresholds$1 = async thresholdSettings => {
  return await axios.post('/api/sensor-coordinations/main-thresholds/', thresholdSettings);
};
const updateMainThresholds$1 = async thresholdSettings => {
  const {
    id
  } = thresholdSettings || {};
  return await axios.patch(`/api/sensor-coordinations/main-thresholds/${id}/`, thresholdSettings);
};
const fetchAutonmousConfigs$1 = async ({
  ranchId,
  blockId
}) => {
  if (ranchId) return await axios.get(`/api/sensor-coordinations/automation-schedules/?ranch_id=${ranchId}`);
  if (blockId) return await axios.get(`/api/sensor-coordinations/automation-schedules/?block_id=${blockId}`);
  return new Promise(res => res({
    error: 'No ranchId or blockId passed'
  }));
};
const createAutonmousConfigs$1 = async thresholdSettings => {
  return await axios.post('/api/sensor-coordinations/automation-schedules/', thresholdSettings);
};
const updateAutonmousConfigs$1 = async ({
  scheduleId,
  schedule
}) => {
  return await axios.put(`/api/sensor-coordinations/automation-schedules/${scheduleId}/`, schedule);
};
const deleteAutonmousConfigs$1 = async scheduleId => {
  return await axios.delete(`/api/sensor-coordinations/automation-schedules/${scheduleId}`);
};
const fetchReservoirFailSafeSettings$1 = async () => {
  return await axios.get('/api/sensor-coordinations/reservoir-pressure-failsafe-configs/');
};
const createReservoirFailSafeSettings$1 = async config => {
  return await axios.post('/api/sensor-coordinations/reservoir-pressure-failsafe-configs/', config);
};
const updateReservoirFailSafeSettings$1 = async ({
  configId,
  config
}) => {
  return await axios.put(`/api/sensor-coordinations/reservoir-pressure-failsafe-configs/${configId}/`, config);
};
const deleteReservoirFailSafeSettings$1 = async configId => {
  return await axios.delete(`/api/sensor-coordinations/reservoir-pressure-failsafe-configs/${configId}/`);
};
var coordinationApi$1$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  fetchSensorCoordinations: fetchSensorCoordinations$1,
  updateSensorCoordination: updateSensorCoordination$1,
  fetchMainThresholds: fetchMainThresholds$1,
  createMainThresholds: createMainThresholds$1,
  updateMainThresholds: updateMainThresholds$1,
  fetchAutonmousConfigs: fetchAutonmousConfigs$1,
  createAutonmousConfigs: createAutonmousConfigs$1,
  updateAutonmousConfigs: updateAutonmousConfigs$1,
  deleteAutonmousConfigs: deleteAutonmousConfigs$1,
  fetchReservoirFailSafeSettings: fetchReservoirFailSafeSettings$1,
  createReservoirFailSafeSettings: createReservoirFailSafeSettings$1,
  updateReservoirFailSafeSettings: updateReservoirFailSafeSettings$1,
  deleteReservoirFailSafeSettings: deleteReservoirFailSafeSettings$1
});
const getFirmwareList$1 = async deviceType => {
  return axios.get(`/api/firmware/?device_type=${deviceType}`);
};
const firmwareUpgrade$1 = async (nodes, firmwareId, deviceType) => {
  return axios.post('/api/firmware/upgrade/', {
    nodes,
    firmwareId,
    deviceType
  });
};
const deleteFirmwareVersion$1 = async (payload = {}) => {
  return axios.delete('/api/firmware/delete/', {
    data: payload
  });
};
const getDeviceList$1 = async (deviceType, entityId) => {
  return axios.get(`/api/device/list?device_type=${deviceType}&entity=${entityId}`);
};
const refreshConfig$1 = deviceList => {
  return axios.post('/api/node/config/sync', {
    nodes: deviceList
  });
};
var firmwareApi$1$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getFirmwareList: getFirmwareList$1,
  firmwareUpgrade: firmwareUpgrade$1,
  deleteFirmwareVersion: deleteFirmwareVersion$1,
  getDeviceList: getDeviceList$1,
  refreshConfig: refreshConfig$1
});
var api$1 = {
  farmApi: farmApi$1$1,
  userApi: userApi$1$1,
  sensorApi: sensorApi$1$1,
  controlApi: controlApi$1$1,
  plansApi: plansApi$1$1,
  blockApi: blockApi$1$1,
  satelliteApi: satelliteApi$1$1,
  recommendationApi: recommendationApi$1$1,
  scheduleApi: scheduleApi$1$1,
  reportsApi: reportsApi$1$1,
  teamApi: teamApi$1$1,
  teamUserAccessApi: teamUserAccessApi$1$1,
  roleApi: roleApi$1$1,
  ranchApi: ranchApi$1$1,
  followBlockApi: followBlockApi$1$1,
  coordinationApi: coordinationApi$1$1,
  firmwareApi: firmwareApi$1$1,
  entityMonitoringApi: entityMonitoringApi$1$1
};

// TODO: this file is duplicated between both the RN and web repos
axios.defaults.baseURL = constants$1.API_URL;
let refreshTimer$1 = null;
let isLoggingOut$1 = false;
const HTTP_STATUS_UNAUTHORIZED$1 = 401;
const removeToken$1 = async tokenName => {
  // const cookies = new Cookies();
  // await cookies.remove(tokenName, info);
  // await cookies.set(tokenName, "removed123", info);
  await localStorage.removeItem(tokenName);
};
async function logout$1(dispatch) {
  clearTimeout(refreshTimer$1);
  await removeToken$1("userToken");
  await removeToken$1("refreshToken");
  localStorage.removeItem('persist:selected');
  axios.defaults.headers.common['Authorization'] = null;
  if (dispatch) {
    dispatch({
      type: 'RESET'
    });
  }
}

// Handles refresh token 401 globally
axios.interceptors.response.use(response => response, async error => {
  const originalRequest = error.config;
  if (error?.response?.status === HTTP_STATUS_UNAUTHORIZED$1 && originalRequest?.url?.includes("/api/token/refresh/")) {
    if (!isLoggingOut$1) {
      isLoggingOut$1 = true;
      console.log("Refresh token invalid. Logging out user.");
      await logout$1();
      window.location.href = "/login";
    }
  }
  return Promise.reject(error);
});
function setTagsForScope$1(tagsObj, scope) {
  try {
    if (tagsObj && Object.prototype.toString.call(tagsObj) === '[object Object]') {
      Object(tagsObj).keys.forEach(k => {
        scope.setTag(k, tagsObj[k]);
      });
    }
  } catch (error) {
    console.log('ERROR setting tags', error.message);
    console.log('SETTAGS Input', tagsObj);
  }
  return scope;
}
function handleMessage$1(level, data, tagsObj) {
  try {
    if (process.env.REACT_APP_LOG_LEVEL === 'debug') {
      console.log(`${level.toUpperCase()}: `, data);
    }
    if (!data) {
      return;
    }
    if (process.env.REACT_APP_SENTRY_ENABLED) {
      if (data instanceof Error) {
        Sentry.withScope(scope => {
          scope = setTagsForScope$1(tagsObj, scope);
          scope.setLevel(level);
          Sentry.captureException(data);
        });
        return;
      }
      let msg = cloneDeep(data);
      if (msg === Object(msg)) {
        msg = JSON.stringify(msg);
      } else {
        msg = `${msg}`;
      }
      Sentry.withScope(scope => {
        scope = setTagsForScope$1(tagsObj, scope);
        scope.setLevel(level);
        Sentry.captureMessage(msg);
      });
    }
  } catch (error) {
    console.log('ERROR in logger', error);
    console.log('LOGGER input', level, data);
  }
}
const logger$1 = {
  debug: (data, tagsObj) => {
    setTimeout(() => {
      handleMessage$1('debug', data, tagsObj);
    }, 0);
  },
  info: (data, tagsObj) => {
    setTimeout(() => {
      handleMessage$1('info', data, tagsObj);
    }, 0);
  },
  warning: (data, tagsObj) => {
    setTimeout(() => {
      handleMessage$1('warning', data, tagsObj);
    }, 0);
  },
  error: (data, tagsObj) => {
    setTimeout(() => {
      handleMessage$1('error', data, tagsObj);
    }, 0);
  }
};
async function captureError$1(cb) {
  try {
    return await cb();
  } catch (error) {
    logger$1.error(error);
    throw error;
  }
}
const {
  userApi: userApi$2,
  sensorApi: sensorApi$2,
  farmApi: farmApi$2,
  controlApi: controlApi$2,
  plansApi: plansApi$2,
  blockApi: blockApi$2,
  satelliteApi: satelliteApi$2,
  recommendationApi: recommendationApi$2,
  scheduleApi: scheduleApi$2,
  reportsApi: reportsApi$2,
  teamApi: teamApi$2,
  teamUserAccessApi: teamUserAccessApi$2,
  roleApi: roleApi$2,
  ranchApi: ranchApi$2,
  followBlockApi: followBlockApi$2,
  coordinationApi: coordinationApi$2,
  firmwareApi: firmwareApi$2,
  entityMonitoringApi: entityMonitoringApi$2
} = api$1;

// export {logger, initLogger, captureError };

const initialState$6 = {
  loading: false,
  currentRequestId: undefined,
  error: null,
  currentRequestTime: null
};
const selectLoadingState = ({
  loading,
  lastUpdated,
  error,
  currentRequestId
}) => ({
  loading,
  lastUpdated,
  error,
  currentRequestId
});
const requestList = (state, action) => {
  if (state.loading === false) {
    state.error = undefined;
    state.loading = true;
    state.currentRequestId = action.meta.requestId;
  }
};
const requestListThrottled = timeoutSeconds => (state, action) => {
  const requestTimeElapsed = state.currentRequestTime ? Math.round((Date.now() - state.currentRequestTime) / 1000) : 0;
  const secondsAllowed = timeoutSeconds || action.meta.arg || 20;
  if (state.loading === false && requestTimeElapsed > secondsAllowed || !state.currentRequestTime) {
    state.error = undefined;
    state.loading = true;
    state.currentRequestId = action.meta.requestId;
    state.currentRequestTime = Date.now();
  }
};
const receiveList = adapter => (state, action) => {
  const payload = action.payload;
  // Backward compatible: support both plain arrays and paginated API payloads.
  const items = Array.isArray(payload) ? payload : payload?.results || [];
  if (state.loading === true) {
    state.loading = false;
    const lastUpdated = Date.now();
    state.lastUpdated = lastUpdated;
    state.error = undefined;
    adapter.setAll(state, items);
    // Persist pagination metadata when endpoint returns paginated response.
    if (!Array.isArray(payload) && payload) {
      state.count = payload.count;
      state.next = payload.next;
      state.previous = payload.previous;
    }
    state.currentRequestId = undefined;
  }
};
const receiveListCheckDate = adapter => (state, action) => {
  const {
    requestId
  } = action.meta;
  const payload = action.payload;
  // Backward compatible: support both plain arrays and paginated API payloads.
  const isArrayPayload = Array.isArray(payload);
  const rawItems = isArrayPayload ? payload : payload?.results || [];
  const items = rawItems.filter(item => item && (item.id !== undefined && item.id !== null || item.identifier !== undefined && item.identifier !== null));
  if (state.loading === true && state.currentRequestId === requestId) {
    state.error = undefined;
    state.loading = false;
    const lastUpdated = Date.now();
    state.lastUpdated = lastUpdated;
    if (!isArrayPayload) {
      // For paginated endpoints, always replace with current page results.
      adapter.setAll(state, items);
    } else if (Object.keys(state.entities || {}).length === 0) {
      adapter.setAll(state, items);
    } else {
      for (const item of items) {
        const id = adapter.selectId(item);
        const current = state.entities ? state.entities[id] : undefined;
        if (!current || !current.date || !item.date || current.date < item.date) {
          adapter.upsertOne(state, item);
        }
      }
    }
    if (!isArrayPayload && payload) {
      // Persist pagination metadata when endpoint returns paginated response.
      state.count = payload.count;
      state.next = payload.next;
      state.previous = payload.previous;
    }
    state.currentRequestId = undefined;
  }
};
const requestListFailed = (state, action) => {
  const {
    requestId
  } = action.meta;
  if (state.loading === true && state.currentRequestId === requestId) {
    state.loading = false;
    state.error = action.error;
    state.currentRequestId = undefined;
  }
};
const requestItemById = adapter => (state, action) => {
  const id = action.meta.arg;
  adapter.upsertOne(state, {
    id,
    loading: true,
    currentRequestId: action.meta.requestId,
    error: undefined
  });
};
const receiveItem = adapter => (state, action) => {
  if (!action.payload) return;
  const {
    payload: item
  } = action;
  item.lastUpdated = Date.now();
  item.loading = false;
  item.error = undefined;
  adapter.upsertOne(state, item);
};
const receiveItemData = adapter => (state, action) => {
  if (!action.payload || !action.payload.data) return;
  const {
    payload: {
      data: item
    }
  } = action;
  item.lastUpdated = Date.now();
  item.loading = false;
  item.error = undefined;
  adapter.upsertOne(state, item);
};
const receiveItemCheckDate = adapter => (state, action) => {
  if (!action.payload) return;
  const {
    payload: item
  } = action;
  item.lastUpdated = Date.now();
  item.loading = false;
  item.error = undefined;
  const id = adapter.selectId(item);
  const current = state.entities ? state.entities[id] : undefined;
  if (!current || !current.date || !item.date || current.date < item.date) {
    adapter.upsertOne(state, item);
  }
};
const requestItemByIdFailed = adapter => (state, action) => {
  const id = action.meta.arg;
  adapter.upsertOne(state, {
    id,
    loading: false,
    error: action.error,
    currentRequestId: undefined
  });
};

/*
 * Methods that pass multiple params
 * These can be used for sensor request that take { type, identifier } as the args
 */
const requestItemByParams = adapter => (state, action) => {
  const item = action.meta.arg;
  adapter.upsertOne(state, {
    ...item,
    loading: true,
    error: undefined,
    currentRequestId: action.meta.requestId
  });
};
const receiveItemUpsertNested = adapter => (state, action) => {
  // if (!action.payload) return;
  const item = action.meta.arg;
  adapter.upsertOne(state, {
    ...item,
    loading: false,
    error: undefined,
    lastUpdated: Date.now(),
    items: action.payload
  });
};
const requestItemByParamsFailed = adapter => (state, action) => {
  const item = action.meta.arg;
  adapter.upsertOne(state, {
    ...item,
    loading: false,
    error: action.error,
    currentRequestId: undefined
  });
};
const loadList = ({
  getData,
  getRequestState
}) => async (arg, {
  getState,
  requestId
}) => {
  const {
    currentRequestId,
    loading
  } = getRequestState(getState());
  if (loading !== true) {
    return null;
  }
  const response = await getData(arg);
  return response.data;
};
const loadListById = ({
  getData
}) => async (id, {
  getState,
  requestId
}) => {
  const state = getState();
  const {
    currentRequestId,
    loading
  } = state.sensorsData.sensors;
  if (loading !== true) {
    return null;
  }
  if (requestId !== currentRequestId) {
    return null;
  }
  const response = await getData(id);
  return response.data;
};
const loadDetail = ({
  getData,
  getRequestState
}) => async (id, {
  getState,
  requestId
}) => {
  // current usage of loadDetail is buggy for some slices.
  // try catch is used here to prevent apis being skipped in these cases
  try {
    const {
      currentRequestId,
      loading
    } = getRequestState(id, getState());
    if (loading !== true || requestId !== currentRequestId) {
      return null;
    }
  } catch (e) {
    console.error(e);
  }
  const response = await getData(id);
  return response.data;
};
const loadByTypeIdentifier = ({
  getData,
  getRequestState
}) => async ({
  type,
  identifier
}, {
  getState,
  requestId
}) => {
  if (type === undefined || identifier === undefined) {
    return null;
  }
  const {
    currentRequestId,
    loading
  } = getRequestState(getState(), type, identifier);
  if (loading !== true || requestId !== currentRequestId) {
    return null;
  }
  const response = await getData(type, identifier);
  return response.data;
};
const loadByTypeId = ({
  getData,
  getRequestState
}) => async ({
  type,
  id
}, {
  getState,
  requestId
}) => {
  if (type === undefined || id === undefined) {
    return null;
  }
  const requestState = getRequestState(getState(), type, id);

  // if requestState is undefined, then no match could be found
  // in this case, no need to worry about existing loading state
  if (requestState) {
    const {
      currentRequestId,
      loading
    } = requestState;
    if (loading !== true || requestId !== currentRequestId) {
      return null;
    }
  }
  const response = await getData(type, id);
  return response.data;
};
const ENTITIES = 'entities';
const initialState$5 = {
  loading: false,
  currentRequestId: undefined,
  error: null,
  currentRequestTime: null,
  selectedEntityId: null
};

/**
 * TODO: This structure may change as and when the need arises
 * Entities Structure
    {
        "id": 7415,
        "name": "Test",
        "ranches": [
            {
                "id": 73970,
                "name": "R1",
                "blocks": [
                    {
                        "id": 738542,
                        "name": "B1"
                    }
                ]
            },
            {
                "id": 73781,
                "name": "Test",
                "blocks": []
            }
        ]
    },
    {
        "id": 7416,
        "name": "The Ray",
        "ranches": [
            {
                "id": 73782,
                "name": "Meadow site",
                "blocks": [
                    {
                        "id": 736945,
                        "name": "Block 1"
                    }
                ]
            }
        ]
    },
 */

const loadNewEntityList = createAsyncThunk('newEntity/loadList', async (_, {
  rejectWithValue
}) => {
  try {
    const res = await farmApi$2.getAllEntity();
    const {
      data
    } = res;
    return data;
  } catch (error) {
    return rejectWithValue(error);
  }
});
const entitiesAdapter = createEntityAdapter({
  sortComparer: (a, b) => a.name.localeCompare(b.name)
});
const entities$1 = createSlice({
  name: ENTITIES,
  initialState: entitiesAdapter.getInitialState(initialState$5),
  reducers: {
    setSelectedEntityId: (state, action) => {
      state.selectedEntityId = action.payload;
    }
  },
  extraReducers: builder => {
    builder.addCase(loadNewEntityList.pending, state => {
      state.loading = true;
    }).addCase(loadNewEntityList.fulfilled, (state, action) => {
      const lastUpdated = Date.now();
      state.lastUpdated = lastUpdated;
      state.loading = false;
      state.currentRequestId = undefined;
      state.error = undefined;
      entitiesAdapter.setAll(state, action.payload);
    }).addCase(loadNewEntityList.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  }
});
const setCurrentEntity = entityId => entities$1.actions.setSelectedEntityId(entityId);
var entities$2 = entities$1.reducer;
const RANCHES = 'ranches';
const initialState$4 = {
  loading: false,
  currentRequestId: undefined,
  error: null,
  currentRequestTime: null
};

/**
 * TODO: This structure may change as and when the need arises
 * Ranches Structure
[
    {
        "id": ranch_id,
        "name": ranch_name,
        "shortName": null,
        "bounds": {
            "type": "Polygon",
            "coordinates": [
                [
                    [
                        74.439865,
                        17.897663
                    ],
                    [
                        74.436597,
                        17.899304
                    ],
                    [
                        74.436815,
                        17.899658
                    ],
                    [
                        74.437093,
                        17.900035
                    ],
                    [
                        74.43964,
                        17.900696
                    ],
                    [
                        74.439865,
                        17.897663
                    ]
                ]
            ]
        },
        "crop": "none",
        "amFieldId": null,
        "dummy": false,
        "dummyType": "good",
        "newIrrigationDetect": false,
        "wbRanchId": null,
        "installState": "test",
        "dateCreated": "2024-08-13T23:58:43.609193-07:00",
        "dateUpdated": null,
        "isActive": true,
        "address": null,
        "externalId": null,
        "jiraOptionId": null,
        "entity": 26,
        "createdBy": 444,
        "updatedBy": 444
    },
    {
      ...
    },
 */

// Update when required
const loadNewRanchList = createAsyncThunk('newRanch/loadList', async (entityId, {
  rejectWithValue
}) => {
  try {
    const res = await farmApi$2.getEntityRanchList(entityId);
    const {
      data
    } = res;
    return data;
  } catch (error) {
    return rejectWithValue(error);
  }
});
const ranchesAdapter = createEntityAdapter({
  sortComparer: (a, b) => a.name.localeCompare(b.name)
});
const ranches$1 = createSlice({
  name: RANCHES,
  initialState: ranchesAdapter.getInitialState(initialState$4),
  reducers: {
    cleanRanchesListRequestState(state) {
      state.loading = false;
      state.currentRequestId = undefined;
      state.error = null;
    },
    setNewRanches: ranchesAdapter.setAll
  },
  extraReducers: builder => {
    builder.addCase(loadNewRanchList.pending, state => {
      state.loading = true;
    }).addCase(loadNewRanchList.fulfilled, (state, action) => {
      const lastUpdated = Date.now();
      state.lastUpdated = lastUpdated;
      state.loading = false;
      state.currentRequestId = undefined;
      state.error = undefined;
      ranchesAdapter.setAll(state, action.payload);
    }).addCase(loadNewRanchList.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload || 'Something went wrong!';
    });
  }
});
const {
  setNewRanches,
  cleanRanchesListRequestState: cleanRanchesListRequestState$1
} = ranches$1.actions;
var ranches$2 = ranches$1.reducer;
const BLOCKS = 'blocks';
const initialState$3 = {
  loading: false,
  currentRequestId: undefined,
  error: null,
  currentRequestTime: null
};
// TODO: Remove this once the block list api response is migrated to camelCase
function snakeCaseKeys(value) {
  if (Array.isArray(value)) {
    return value.map(snakeCaseKeys);
  }
  if (value && value.constructor === Object) {
    return Object.keys(value).reduce((result, key) => ({
      ...result,
      [snakeCase(key)]: snakeCaseKeys(value[key])
    }), {});
  }
  return value;
}

/**
 * TODO: This structure may change as and when the need arises
 * Blocks Structure

 */

const loadNewBlockList = createAsyncThunk('newBlocks/loadList', async (entityId, {
  rejectWithValue
}) => {
  try {
    const res = await farmApi$2.getEntityBlockList(entityId);
    const {
      data
    } = res;
    return data.results;
  } catch (error) {
    return rejectWithValue(error);
  }
});
const loadNewBlockDetail = createAsyncThunk('newBlocks/loadDetail', async (blockId, {
  rejectWithValue
}) => {
  try {
    const res = await farmApi$2.getBlockDetail(blockId);
    const {
      data
    } = res;
    // TODO: Remove this once block list api response is migrated to camelCase
    return snakeCaseKeys(data);
  } catch (error) {
    return rejectWithValue(error);
  }
});
const blocksAdapter = createEntityAdapter({
  sortComparer: (a, b) => a.name.localeCompare(b.name)
});
const blocks$1 = createSlice({
  name: BLOCKS,
  initialState: blocksAdapter.getInitialState(initialState$3),
  reducers: {
    cleanBlocksListRequestState(state) {
      state.loading = false;
      state.currentRequestId = undefined;
      state.error = null;
    },
    updateNewBlockItem: blocksAdapter.updateOne,
    setNewBlocks: blocksAdapter.setAll
  },
  extraReducers: builder => {
    builder.addCase(loadNewBlockList.pending, state => {
      state.loading = true;
    }).addCase(loadNewBlockList.fulfilled, (state, action) => {
      const lastUpdated = Date.now();
      state.lastUpdated = lastUpdated;
      state.loading = false;
      state.currentRequestId = undefined;
      state.error = undefined;
      blocksAdapter.setAll(state, action.payload);
    }).addCase(loadNewBlockList.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload || 'Something went wrong!';
    }).addCase(loadNewBlockDetail.pending, state => {
      state.loading = true;
    }).addCase(loadNewBlockDetail.fulfilled, (state, action) => {
      const lastUpdated = Date.now();
      state.lastUpdated = lastUpdated;
      state.loading = false;
      state.currentRequestId = undefined;
      state.error = undefined;
      blocksAdapter.upsertOne(state, action.payload);
    }).addCase(loadNewBlockDetail.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload || 'Something went wrong!';
    });
  }
});
const {
  setNewBlocks,
  cleanBlocksListRequestState: cleanBlocksListRequestState$1,
  updateNewBlockItem
} = blocks$1.actions;
var blocks$2 = blocks$1.reducer;
const sortByName$1 = (a, b) => {
  if (a.name > b.name) {
    return 1;
  }
  if (a.name < b.name) {
    return -1;
  }
  return 0;
};
const selectEntitiesState$1 = state => state.farm.entities;
const selectRanchesState$1 = state => state.farm.ranches;
const selectBlocksState$1 = state => state.farm.blocks;
const entitySelectors$1 = entitiesAdapter.getSelectors(selectEntitiesState$1);
const ranchSelectors$1 = ranchesAdapter.getSelectors(selectRanchesState$1);
const blockSelectors$1 = blocksAdapter.getSelectors(selectBlocksState$1);
const selectAllNewEntities = entitySelectors$1.selectAll;
const selectEntityId = state => {
  const {
    selectedEntityId
  } = state.farm.entities;
  return selectedEntityId;
};
const selectEntityById$1 = (state, id) => entitySelectors$1.selectById(state, id);
const selectAllRanchesByEntityId = (state, id) => {
  const entity = selectEntityById$1(state, id);
  return entity ? entity.ranches : [];
};
const selectAllNewBlockIds = state => blockSelectors$1.selectIds(state, []);
const selectAllNewRanchIds = state => ranchSelectors$1.selectIds(state, []);

// Ranch Selectors
const populateRanch$1 = (state, ranch) => ranch && {
  ...ranch,
  entity: selectEntityById$1(state, ranch.entity)
};
const selectAllNewRanches$1 = state => ranchSelectors$1.selectAll(state).map(ranch => populateRanch$1(state, ranch));
const selectNewRanchById$1 = (state, id) => {
  const ranch = ranchSelectors$1.selectById(state, id);
  return populateRanch$1(state, ranch);
};
const selectNewRanchesLoadingState = state => selectLoadingState(selectRanchesState$1(state));

// Block Selectors
const populateBlock$1 = (state, block) => block && {
  ...block,
  ranch: selectNewRanchById$1(state, block.ranch)
};
const selectNewBlockById$1 = blockSelectors$1.selectById;
const selectAllNewBlocks$1 = state => blockSelectors$1.selectAll(state).map(block => populateBlock$1(state, block));
const selectNewBlocksLoadingState$1 = state => selectLoadingState(selectBlocksState$1(state));
const selectNewBlocksLoaded = state => {
  const blockCount = blockSelectors$1.selectIds(state, []).length;
  if (blockCount) return true;
  return false;
};
// Select blocks for currently selected ranch or block
const selectNewBlocksForRanchId = (state, ranchId) => blockSelectors$1.selectAll(state).filter(block => block.ranch === ranchId).map(block => populateBlock$1(state, block));
const selectNewBlocksForRanchBlockSelection = (state, selectedObj) => {
  let blocks = [];
  const {
    type,
    value
  } = selectedObj || {};
  if (type && type === 'ranch') {
    blocks = selectNewBlocksForRanchId(state, Number(value));
  } else if (type && type === 'block') {
    const blockObj = selectNewBlockById$1(state, Number(value));
    blocks = blockObj && [blockObj];
  } else {
    blocks = selectAllNewBlocks$1(state);
  }
  return blocks && blocks.sort((a, b) => a && b && a.name.localeCompare(b.name));
};
const selectNewBlocksForRanchIdAlphabetically = createSelector(selectNewBlocksForRanchId, blocks => blocks.sort(sortByName$1));
const selectNewIsAutoScheduled = createSelector(selectAllNewBlocks$1, blocks => blocks.every(item => item.auto_schedule));

// Loading States
const selectNewEntitiesLoadingState = state => selectLoadingState(selectEntitiesState$1(state));
const selectBlockPressureSensors$1 = (state, blockId) => populateSensorStatus$1(state, selectSensorsForIrrigationBlockId(state, blockId, 'water_pressure', 'installed'));
const selectBlockPumpController$1 = (state, blockId) => {
  const block = selectNewBlockById$1(state, blockId);
  const vfdObj = block && block.vfd;
  if (vfdObj) {
    const sensor = selectSensorByParams(state, vfdObj);
    return {
      ...sensor,
      status: selectSensorStatus(state, sensor.type, sensor.identifier)
    };
  }
  return {};
};

/**
 * TODO: Given incorrect parameters, it can result into unexpected output: { undefined: {} }
 */
const selectBlockPumpControllers = (state, blockId) => {
  const block = selectNewBlockById$1(state, blockId);
  const vfd = block && block.vfd;
  const vfds = block && block.vfds || [vfd] || [];
  const pumpControllers = vfds.map(vfdObj => {
    if (vfdObj) {
      const sensor = selectSensorByParams(state, vfdObj);
      return {
        ...sensor,
        blockId,
        blockName: block.name,
        status: selectSensorStatus(state, sensor.type, sensor.identifier)
      };
    }
    return {};
  }).reduce((acc, obj) => {
    acc[obj.identifier] = obj;
    return acc;
  }, []);
  return pumpControllers;
};

/**
 * Select pump controller data for multiple blocks
 * @param {*} state
 * @param {Array} blockIds
 * @param {boolean} returnAsArray
 */
const selectPumpControllersForBlockIds = (state, blockIds = [], returnAsArray = false) => {
  const pumpControllers = blockIds.reduce((acc, curr) => ({
    ...acc,
    ...selectBlockPumpControllers(state, curr)
  }), {});
  if (returnAsArray) {
    return Object.keys(pumpControllers).map(pumpController => pumpControllers[pumpController]);
  }
  return pumpControllers;
};
const selectBlockValveController = (state, blockIds) => {
  if (blockIds && blockIds.length) {
    const valveControllerData = blockIds.map(blockId => {
      const block = selectNewBlockById$1(state, blockId);
      const valveObj = block && block.valve;
      if (valveObj) {
        const sensor = selectSensorByParams(state, valveObj);
        return {
          ...sensor,
          blockId,
          status: selectSensorStatus(state, sensor.type, sensor.identifier)
        };
      }
      return {};
    }).reduce((acc, obj) => {
      acc[obj.blockId] = obj;
      return acc;
    }, {});
    return valveControllerData;
  }
  return {};
};
const selectBlockValveControllers = (state, blockId) => {
  const block = selectNewBlockById$1(state, blockId);
  const vIdentifiers = block && block.valve;
  const valves = block && block.valves || [];
  let valveDataForRanch = [];
  const valveIdentifiers = selectSensorsForRanchId(state, block && block.ranch, 'valve').filter(d => d && valves.includes(d.id)).map(d => ({
    type: d.type,
    identifier: d.identifier
  }));
  if (valveIdentifiers.length) {
    valveDataForRanch = valveIdentifiers;
  } else valveDataForRanch = [vIdentifiers];
  const valveControllers = valveDataForRanch.map(valveObj => {
    let sensor;
    if (valveObj) sensor = selectSensorByParams(state, valveObj);else {
      const sensors = selectSensorsForBlockId(state, blockId, 'valve', 'installed');
      sensor = sensors.length && sensors[0];
    }
    return {
      ...sensor,
      blockId,
      status: selectSensorStatus(state, sensor.type, sensor.identifier)
    };
  }).reduce((acc, obj) => {
    acc[obj.identifier] = obj;
    return acc;
  }, []);
  return valveControllers;
};
const selectValveControllersForBlocks$2 = (state, blockIds) => {
  if (blockIds && blockIds.length) {
    const valveControllerDataArr = [];
    blockIds.forEach(blockId => {
      const block = selectNewBlockById$1(state, blockId);
      const vIdentifiers = block && block.valve;
      const valves = block && block.valves || [];
      let valveDataForRanch = [];
      const valveIdentifiers = selectSensorsForRanchId(state, block && block.ranch, 'valve').filter(d => d && valves.includes(d.id)).map(d => ({
        type: d.type,
        identifier: d.identifier
      }));
      if (valveIdentifiers.length) {
        valveDataForRanch = valveIdentifiers;
      } else valveDataForRanch = [vIdentifiers];
      const valveControllers = valveDataForRanch.map(valveObj => {
        if (valveObj) {
          const sensor = selectSensorByParams(state, valveObj);
          return {
            ...sensor,
            blockId,
            status: selectSensorStatus(state, sensor.type, sensor.identifier)
          };
        }
        return {};
      });
      valveControllerDataArr.push(...valveControllers);
    });
    const uniqueValveControllerArr = valveControllerDataArr.filter((value, index, self) => self.findIndex(v => v.id === value.id) === index);
    const valveControllerData = {};
    uniqueValveControllerArr.forEach(obj => {
      if (valveControllerData[obj.blockId]) {
        valveControllerData[obj.blockId].push(obj);
      } else {
        valveControllerData[obj.blockId] = [obj];
      }
    });
    return valveControllerData;
  }
  return {};
};
const selectBlockFlowMeter$1 = (state, blockId) => {
  const block = selectNewBlockById$1(state, blockId);
  const flowMeters = selectSensorsForRanchId(state, block && block.ranch, 'water_flow_analog', 'installed');
  return flowMeters && flowMeters.length && populateSensorStatus$1(state, flowMeters)[0];
};
const selectPumpControllerIrrigationBlocks = (state, vfd) => selectAllNewBlocks$1(state).filter(block => {
  if (!block.vfd) return false;
  if (block.vfd.identifier !== vfd.identifier) return false;
  return block.vfd.type === vfd.type;
});

// select block valve status
const selectBlockSensorStatus$2 = (state, blocks) => blocks.map(block => {
  let vid = null;
  if (block.valve) {
    vid = block.valve.identifier;
  }
  const valveState = selectSensorStatus(state, 'valve', vid);
  let online;
  let loading;
  if (valveState) {
    online = valveState.online;
    loading = valveState.loading;
  }
  let currState;
  let valveScheduledOpen;
  let valveScheduledClose;
  if (valveState && valveState.controlStatus) {
    currState = valveState.controlStatus.state;
  }
  if (valveState && valveState.scheduleStatus) {
    valveScheduledOpen = valveState.scheduleStatus.dateScheduledOpen;
    valveScheduledClose = valveState.scheduleStatus.dateScheduledClose;
  }
  let ovrdStatus = null;
  if (valveState && valveState.overrideStatus) {
    ovrdStatus = valveState.overrideStatus;
  }
  let pid = null;
  if (block.vfd) {
    pid = block.vfd.identifier;
  }
  const pumpState = selectSensorStatus(state, 'vfd', pid);
  let pumpCurrState;
  let pumpStart;
  let pumpStop;
  if (pumpState && pumpState.scheduleStatus) {
    pumpStart = pumpState.scheduleStatus.dateScheduledStart;
    pumpStop = pumpState.scheduleStatus.dateScheduledStop;
  }
  if (pumpState && pumpState.controlStatus) {
    pumpCurrState = pumpState.controlStatus.status;
  }
  return {
    blockId: block.id,
    blockName: block.name,
    valveIdentifier: vid,
    valveOnline: online,
    valveCurrentState: currState,
    valveOverrideStatus: ovrdStatus,
    valveControlEnabled: block.control_enabled,
    valveScheduledOpen,
    valveScheduledClose,
    vfdIdentifier: pid,
    pumpStartDate: pumpStart,
    pumpStopDate: pumpStop,
    valveLoading: loading,
    valveAlarmCount: valveState && valveState.alarmCount,
    blockAlarmCount: valveState && valveState.blockAlarmCount,
    pumpCurrentState: pumpCurrState
  };
});

// select block valve status
const selectPumpSensorStatus$1 = (state, pumps) => pumps.map(pump => {
  let pid = null;
  if (pump.identifier) {
    pid = pump.identifier;
  }
  const pumpState = selectSensorStatus(state, 'vfd', pid);
  let online;
  let loading;
  if (pumpState) {
    online = pumpState.online;
    loading = pumpState.loading;
  }
  let currState;
  let datePumpStart;
  let datePumpStop;
  if (pumpState && pumpState.controlStatus) {
    currState = pumpState.controlStatus.status;
  }
  if (pumpState && pumpState.scheduleStatus) {
    datePumpStart = pumpState.scheduleStatus.dateScheduledStart;
    datePumpStop = pumpState.scheduleStatus.dateScheduledStop;
  }
  let ovrdStatus = null;
  if (pumpState && pumpState.overrideStatus) {
    ovrdStatus = pumpState.overrideStatus;
  }
  return {
    pumpId: pump.id,
    pumpName: pump.name,
    pumpIdentifier: pid,
    pumpCurrentState: currState,
    pumpOverrideStatus: ovrdStatus,
    pumpStartDate: datePumpStart,
    pumpStopDate: datePumpStop,
    pumpOnline: online,
    pumpLoading: loading,
    alarmCount: pumpState && pumpState.alarmCount
  };
});

// Returns a map of blockId to blockAlarmCount given an array of blockIds
// TODO: Update it as per new block reducers
const selectBlockControlStatus = (state, blockIds) => blockIds.reduce((a, blockId) => {
  const block = selectNewBlockById$1(state, blockId);
  const valves = block && block.valves || [];
  let valveIdentifier = block && block.valve && block.valve.identifier;
  if (!valveIdentifier && valves.length) {
    valveIdentifier = selectSensorsForRanchId(state, block && block.ranch, 'valve').filter(d => d && valves.includes(d.id)).map(d => d.identifier);
  }
  const valveStatus = selectSensorStatus(state, 'valve', valveIdentifier);
  let vfdIdentifier = block && block.vfd && block.vfd.identifier;
  if (!vfdIdentifier && block && block.vfds) {
    vfdIdentifier = block && block.vfds && block.vfds[0] && block.vfds[0].identifier;
  }
  const vfdStatus = selectSensorStatus(state, 'vfd', vfdIdentifier);
  a[blockId] = {
    valveStatus,
    vfdStatus
  };
  return a;
}, {});

// TODO: Update as per new block reducer
const selectBlockControlStatusLoading = (state, blockIds) => blockIds.reduce((a, blockId) => {
  const block = selectNewBlockById$1(state, blockId);
  const valveIdentifier = block && block.valve && block.valve.identifier;
  const valveStatus = selectSensorStatus(state, 'valve', valveIdentifier);
  const vfdIdentifier = block && block.vfd && block.vfd.identifier;
  const vfdStatus = selectSensorStatus(state, 'vfd', vfdIdentifier);
  return a || valveStatus && valveStatus.loading || vfdStatus && vfdStatus.loading;
}, false);

// TODO: Update as per new block reducer
const selectBlocksForRanchBlockSelection = (state, selectedObj) => {
  let blocks = [];
  const {
    type,
    value
  } = selectedObj || {};
  if (type && type === 'ranch') {
    blocks = selectNewBlocksForRanchId(state, Number(value));
  } else if (type && type === 'block') {
    const blockObj = selectNewBlockById$1(state, Number(value));
    blocks = blockObj && [blockObj];
  } else {
    blocks = selectAllNewBlocks$1(state);
  }
  return blocks && blocks.sort((a, b) => a && b && a.name.localeCompare(b.name));
};

// returns array of ranches
const selectRanchesForRanchBlockSelection = (state, selectedObj) => {
  const {
    type,
    value
  } = selectedObj || {};
  if (type && type === 'ranch') {
    return [selectNewRanchById$1(state, Number(value))];
  }
  if (type && type === 'block') {
    const block = selectNewBlockById$1(state, Number(value));
    if (!block || !block.ranch) return [];
    const ranch = selectNewRanchById$1(state, block.ranch);
    return ranch ? [ranch] : [];
  }
  if (type && type === 'entity') {
    return selectAllRanchesByEntityId(state, Number(value));
  }
  return selectAllNewRanches$1(state);
};
const selectPressureDetails$1 = (state, blockId) => {
  let pressure = 0;
  let sensorList = [];
  let loading = false;
  const pressureSensorsList = [];
  let identifiers = [];
  const pressureCutoff = [];
  const pressureSensors = selectBlockPressureSensors$1(state, blockId);
  if (pressureSensors && pressureSensors.length) {
    pressureSensors.forEach(d => {
      const statusObj = d && d.status;
      if (statusObj) {
        const psi = Number(statusObj.waterPressure || 0);
        pressure += psi > 0 ? Math.abs(psi) : 0;
        pressureCutoff.push(statusObj.pressureCutoff);
      }
      pressureSensorsList.push({
        type: 'water_pressure',
        identifier: d && d.identifier,
        sensorId: d && d.id,
        alarmCount: statusObj && statusObj.alarmCount,
        lastUpdated: statusObj && statusObj.lastUpdated,
        name: d && d.name,
        sensorOnline: statusObj && statusObj.online,
        pressure: `${statusObj && statusObj.waterPressure > 0 ? (statusObj && statusObj.waterPressure).toFixed(2) : 0} psi`
      });
    });
    loading = pressureSensors.reduce((a, p) => !p || a || p.status && p.status.loading, false);
    pressure = pressure > 0 ? (pressure / pressureSensors.length).toFixed(2) : 0;
    sensorList = pressureSensors.map(d => d && d.name);
    identifiers = pressureSensors.map(d => d && d.identifier);
  }
  return {
    pressure: String(pressure),
    sensorList,
    pressureLoading: loading,
    pressureSensorsList,
    pressureSensorIdentifiers: JSON.stringify(identifiers),
    pressureCutoff
  };
};
var newFarmSelectors = /*#__PURE__*/Object.freeze({
  __proto__: null,
  selectAllNewEntities: selectAllNewEntities,
  selectEntityById: selectEntityById$1,
  selectEntityId: selectEntityId,
  selectAllNewRanches: selectAllNewRanches$1,
  selectAllNewBlocks: selectAllNewBlocks$1,
  selectNewRanchById: selectNewRanchById$1,
  selectNewBlockById: selectNewBlockById$1,
  selectAllNewRanchIds: selectAllNewRanchIds,
  selectAllNewBlockIds: selectAllNewBlockIds,
  selectNewBlocksForRanchId: selectNewBlocksForRanchId,
  selectNewBlocksForRanchBlockSelection: selectNewBlocksForRanchBlockSelection,
  selectNewBlocksForRanchIdAlphabetically: selectNewBlocksForRanchIdAlphabetically,
  selectNewIsAutoScheduled: selectNewIsAutoScheduled,
  selectNewEntitiesLoadingState: selectNewEntitiesLoadingState,
  selectNewRanchesLoadingState: selectNewRanchesLoadingState,
  selectNewBlocksLoadingState: selectNewBlocksLoadingState$1,
  selectNewBlocksLoaded: selectNewBlocksLoaded,
  selectRanchesForRanchBlockSelection: selectRanchesForRanchBlockSelection,
  selectPressureDetails: selectPressureDetails$1,
  selectBlockControlStatusLoading: selectBlockControlStatusLoading,
  selectBlockControlStatus: selectBlockControlStatus,
  selectBlockPumpController: selectBlockPumpController$1,
  selectBlockFlowMeter: selectBlockFlowMeter$1,
  selectBlockPressureSensors: selectBlockPressureSensors$1,
  selectBlockSensorStatus: selectBlockSensorStatus$2,
  selectBlocksForRanchBlockSelection: selectBlocksForRanchBlockSelection,
  selectPumpControllerIrrigationBlocks: selectPumpControllerIrrigationBlocks,
  selectPumpSensorStatus: selectPumpSensorStatus$1,
  selectBlockValveControllers: selectBlockValveControllers,
  selectBlockValveController: selectBlockValveController,
  selectBlockPumpControllers: selectBlockPumpControllers,
  selectPumpControllersForBlockIds: selectPumpControllersForBlockIds,
  selectValveControllersForBlocks: selectValveControllersForBlocks$2
});
const isNotNull = value => value !== undefined && value !== null;
const mean = arr => arr.length ? arr.reduce((acc, curr) => acc + curr, 0) / arr.length : 0;
const getAverageBy = (arr, key) => {
  if (!arr.length) return '';
  let sum = 0;
  let count = 0;
  arr.forEach(element => {
    if (isNotNull(element[key])) {
      sum += Number(element[key]);
      count += 1;
    }
  });
  if (!count) return '';
  return parseFloat((sum / count).toFixed(2));
};
const getPercentAvailable = (vwc, wiltingPoint, fieldCapacity) => {
  const fieldWiltingDifference = fieldCapacity - wiltingPoint;
  if (fieldWiltingDifference === 0) return 0;
  const percentAvailable = (vwc - wiltingPoint) / fieldWiltingDifference;
  return Number.isNaN(percentAvailable) ? 0 : percentAvailable;
};
const getPercentAndVolume = (depth, vwc, wiltingPoint, fieldCapacity) => {
  const percent = getPercentAvailable(vwc, wiltingPoint, fieldCapacity);
  const volume = depth * percent;
  return {
    percent,
    volume
  };
};

/*
 * A flat slice is for simple data keyed by a field 'id'
 */
const entityAdapter = createEntityAdapter();
const createFlatSlice = (name, getList, getDetail, getRequestState) => {
  const loadFlatList = createAsyncThunk(`${name}/loadList`, loadList({
    getData: getList,
    getRequestState
  }));
  const loadSingle = createAsyncThunk(`${name}/loadSingle`, loadDetail({
    getData: getDetail,
    getRequestState: (id, state) => {
      const {
        entities
      } = getRequestState(state);
      return entities[id];
    }
  }));
  const slice = createSlice({
    name,
    initialState: entityAdapter.getInitialState(initialState$6),
    reducers: {},
    extraReducers: {
      [loadFlatList.pending]: requestList,
      [loadFlatList.fulfilled]: receiveListCheckDate(entityAdapter),
      [loadFlatList.rejected]: requestListFailed,
      [loadSingle.pending]: requestItemById(entityAdapter),
      [loadSingle.fulfilled]: receiveItemCheckDate(entityAdapter),
      [loadSingle.rejected]: requestItemByIdFailed(entityAdapter)
    }
  });
  return {
    loadFlatList,
    loadSingle,
    entityAdapter,
    slice
  };
};
const {
  fetchSensorNotes: fetchSensorNotes$2
} = sensorApi$2;
const sensorNotes = createFlatSlice('notes', fetchSensorNotes$2, () => {},
// currently not implemented
state => state.sensorsData.notes);
const {
  loadFlatList: loadSensorNotesList,
  loadSingle: loadSensorNote,
  entityAdapter: sensorNotesAdapter
} = sensorNotes;
var notes = sensorNotes.slice.reducer;
const {
  fetchSensorImages: fetchSensorImages$2
} = sensorApi$2;
const sensorImages = createFlatSlice('images', fetchSensorImages$2, () => {},
// currently not implemented
state => state.sensorsData.images);
const {
  loadFlatList: loadSensorImagesList,
  loadSingle: loadSensorImage,
  entityAdapter: sensorImagesAdapter
} = sensorImages;
var images = sensorImages.slice.reducer;
const GEC_ENTITY_ID = Number(process.env.REACT_APP_GEC_ENTITY_ID);
const GEC_TEST_ENTITY_ID = Number(process.env.REACT_APP_GEC_TEST_ENTITY_ID);
const selectSelectedBlock = state => state.clientData.selected.block;
const selectSelectedRanch = state => state.clientData.selected.ranch;
const selectSelectedEntity = state => state.clientData.selected.entity;
const selectSelectedBlocks = state => state.clientData.selected.blocks;
const selectSelectedRanches = state => state.clientData.selected.ranches;
const selectEntitySidebarCollapseState$1 = state => state.clientData.selected.entitySidebarState;
const selectUrlLoad = state => state.clientData.selected.urlLoad;
const selectMobileScheduler = state => state.clientData.selected.mobileScheduler;
const selectRanchBlock = state => state.clientData.selected.ranchBlock;
const selectMapShowSoilType = state => state.clientData.settings.mapShowSoilType;
const selectMapShowTemperature = state => state.clientData.settings.mapShowTemperature;
const selectMapShowWind = state => state.clientData.settings.mapShowWind;
const selectMapShowLabels = state => state.clientData.settings.mapShowLabels;
const selectShowOnlyPresentionModeSensors = state => state.clientData.settings.showOnlyPresentionModeSensors;
const selectMapPresentationModes = state => state.clientData.settings.mapPresentationModes;
const selectLoginUserInfo = state => state.clientData.selected.userInfo;
const selectClientTimeFormat = state => {
  const entityArray = state.clientData.selected.entity?.payload;
  const entityId = Array.isArray(entityArray) ? entityArray[0] : entityArray;
  if (entityId === GEC_ENTITY_ID || entityId === GEC_TEST_ENTITY_ID) {
    return 'YYYY/MM/DD';
  }
  return 'YYYY-MM-DD';
};
const selectInstallState = state => state.clientData.selected.installState;
const selectSelectedPreset = state => state.clientData.selected.selectedPreset || 'soil';
const selectGraphDateRange = state => state.clientData.selected.dateRange;
const selectGraphSize = state => state.clientData.selected.graphSize || 'md';
const selectPresetChartSelection = state => state.clientData.selected.presetChartSelection;
var webSelectors = /*#__PURE__*/Object.freeze({
  __proto__: null,
  selectMapShowSoilType: selectMapShowSoilType,
  selectMapShowTemperature: selectMapShowTemperature,
  selectMapShowWind: selectMapShowWind,
  selectMapShowLabels: selectMapShowLabels,
  selectShowOnlyPresentionModeSensors: selectShowOnlyPresentionModeSensors,
  selectMapPresentationModes: selectMapPresentationModes,
  selectSelectedBlock: selectSelectedBlock,
  selectSelectedBlocks: selectSelectedBlocks,
  selectSelectedRanch: selectSelectedRanch,
  selectSelectedRanches: selectSelectedRanches,
  selectSelectedEntity: selectSelectedEntity,
  selectEntitySidebarCollapseState: selectEntitySidebarCollapseState$1,
  selectUrlLoad: selectUrlLoad,
  selectMobileScheduler: selectMobileScheduler,
  selectRanchBlock: selectRanchBlock,
  selectLoginUserInfo: selectLoginUserInfo,
  selectClientTimeFormat: selectClientTimeFormat,
  selectInstallState: selectInstallState,
  selectSelectedPreset: selectSelectedPreset,
  selectGraphDateRange: selectGraphDateRange,
  selectGraphSize: selectGraphSize,
  selectPresetChartSelection: selectPresetChartSelection
});
const {
  getSensorKey: getSensorKey$2
} = sensorApi$2;
const sensorsAdapter = createEntityAdapter({
  selectId: sensor => getSensorKey$2({
    type: sensor.type,
    identifier: sensor.identifier
  })
});
const blockStatsAdapter = createEntityAdapter({
  selectId: block => block.id || block.identifier
});
const ranchStatsAdapter = createEntityAdapter({
  selectId: ranch => ranch.id || ranch.identifier
});

// sensor selectors

// To fix the page breaking issue related to sensors data - FF-1079
const selectSensorsState = state => {
  const sensorObj = {
    ...state.sensorsData.sensors
  };
  sensorObj.ids = sensorObj.ids.filter(d => d);
  return sensorObj;
};

// This will be removed/uncommented in future
// const selectSensorsState = (state) => state.sensorsData.sensors;

const sensorsSelectors = sensorsAdapter.getSelectors(selectSensorsState);
const selectAllSensors$1 = sensorsSelectors.selectAll;
const selectSensorsForRanchId = (state, ranchId, sensorType, installState) => sensorsSelectors.selectAll(state).filter(sensor => {
  if (sensorType && sensorType !== sensor.type) return false;
  if (installState && installState !== sensor.install_state) return false;
  return sensor.ranch === ranchId;
});
const selectSensorsForEntity = (state, entityId) => {
  const sensorsObj = state.sensorsData?.sensors?.entities || {};
  return Object.values(sensorsObj).filter(sensor => sensor.entity === entityId);
};
const selectSensorsForRanchIds = (state, ranchIds, sensorType, installState) => sensorsSelectors.selectAll(state).filter(sensor => {
  if (sensorType && sensorType !== sensor.type) return false;
  if (installState && installState !== sensor.install_state) return false;
  return ranchIds.includes(sensor.ranch);
});
const selectSensorsByRanchId = (state, ranchId) => sensorsSelectors.selectAll(state).filter(sensor => sensor.ranch === ranchId);
const selectSensorsForIrrigationBlockId = (state, blockId, sensorType, installState) => sensorsSelectors.selectAll(state).filter(sensor => {
  if (sensorType && sensorType !== sensor.type) return false;
  if (installState && installState !== sensor.install_state) return false;
  return sensor.irrigation_block === blockId;
});
const selectSensorsForBlockId = (state, blockId, sensorType, installState) => sensorsSelectors.selectAll(state).filter(sensor => {
  if (sensorType && sensorType !== sensor.type) return false;
  if (installState && installState !== sensor.install_state) return false;
  return sensor.block === blockId;
});

// if blockIds are not passed, this method does not filter on blockIds and returns all
const selectAllSensorsForBlockIdsByType = (state, {
  blockIds
}) => sensorsSelectors.selectAll(state).reduce((sensorData, sensor) => {
  if (sensor) {
    // filter based on the sensor vfd data through blockID
    const block = selectNewBlockById$1(state, sensor.block);
    const installState = selectInstallState(state);
    const vfd = block && block.vfd;
    const vfds = block && block.vfds || [vfd] || [];
    const isVfdAssigned = sensor.type === 'vfd' ? vfds.filter(d => d && d.identifier === sensor.identifier).length : true;
    const checkBlockIds = blockIds ? blockIds.includes(sensor.block) : true;

    // Update condition to show only the installed sensors as needed
    const checkInstallState = installState ? installState === sensor.install_state : true;
    if (checkBlockIds && checkInstallState && isVfdAssigned) {
      if (sensorData[sensor.type]) {
        sensorData[sensor.type].push(sensor);
      } else {
        sensorData[sensor.type] = [sensor];
      }
    }
  }
  return sensorData;
}, {});
const selectSensorsForGatewayId = (state, gatewayId, sensorType, installState) => sensorsSelectors.selectAll(state).filter(sensor => {
  if (sensorType && sensorType !== sensor.type) return false;
  if (installState && installState !== sensor.install_state) return false;
  return sensor.gateway === gatewayId;
});
const selectSensor$1 = (state, type, identifier) => sensorsSelectors.selectById(state, getSensorKey$2({
  type,
  identifier
}));
const selectSensorById$1 = (state, type, id) => {
  const sensorsState = selectSensorsState(state);
  const sensorsArray = Object.values(sensorsState.entities);
  return sensorsArray.find(sensor => sensor.type === type && sensor.id === id);
};

/*
 * This method accepts sensor params of type and either id or identifier
 * It will try to resolve a sensor from the params
 * If no sensor is found, it returns the params
 * It prefers identifier if available
 */
const selectSensorByParams = (state, sensorParams) => {
  if (!sensorParams) return undefined;
  const {
    identifier,
    id,
    type
  } = sensorParams;
  if (type !== undefined && identifier !== undefined) {
    return selectSensor$1(state, type, identifier) || sensorParams;
  }
  if (type !== undefined && id !== undefined) {
    return selectSensorById$1(state, type, id) || sensorParams;
  }
  return sensorParams;
};
const selectLoadingSensors$1 = state => selectLoadingState(selectSensorsState(state));

// capabilities

const selectCapabilitiesState = state => state.sensorsData.capabilities;
const capabilitiesSelectors = sensorsAdapter.getSelectors(selectCapabilitiesState);
const selectSensorCapabilities = (state, type, identifier) => {
  const capabilities = capabilitiesSelectors.selectById(state, getSensorKey$2({
    type,
    identifier
  }));
  if (capabilities) {
    return capabilities.items || [];
  }
  return [];
};
const selectLoadingCapabilities = state => selectLoadingState(selectCapabilitiesState(state));

// status

const selectStatusState = state => state.sensorsData.status;
const statusSelectors = sensorsAdapter.getSelectors(selectStatusState);
const selectSensorStatus = (state, type, identifier) => statusSelectors.selectById(state, getSensorKey$2({
  type,
  identifier
}));
const selectValveStatusById = (state, id) => statusSelectors.selectAll(state).find(sensor => sensor.type === 'valve' && sensor.id === id);

/**
 * This selectors accepts valveIds and returns the details.
 * The details will contain data and status for every valve.
 * Details also include pressure data.
 * If passed sorted param as true, the output will be sorted
 * by valve name.
 */
const selectDetailsForValveIds = (state, ids = [], pressureSensors, sorted = false) => {
  if (ids.length) {
    const sensorsState = selectSensorsState(state);
    const sensorsArray = Object.values(sensorsState.entities);
    const pressureSensorsList = pressureSensors && pressureSensors.pressureSensorsList || [];
    // fetch data
    const filteredData = sensorsArray.filter(sensor => ids.includes(sensor.id));

    // fetch status and create details array
    const details = filteredData.reduce((acc, curr) => {
      const status = selectSensorStatus(state, 'valve', curr.identifier);
      const pressureData = pressureSensorsList.find(item => item.sensorId === curr.pressure_sensor) || {};
      pressureData.pressureCutoff = pressureSensors && pressureSensors.pressureCutoff || [];
      acc.push({
        ...curr,
        ...status,
        pressureData
      });
      return acc;
    }, []);
    if (sorted) {
      return details.sort((a, b) => {
        if (a.name > b.name) return 1;
        if (a.name < b.name) return -1;
        return 0;
      });
    }
    return details;
  }
  return [];
};
const selectLoadingStatus = state => selectLoadingState(selectStatusState(state));
const selectAllSensorStatusByType = (state, type) => statusSelectors.selectAll(state).filter(sensor => sensor.type === type);
const selectAllSensorsStatus = statusSelectors.selectEntities;
const selectIRSensorSummary = createSelector([selectAllSensorsStatus, (state, list) => list], (state, list) => {
  const aggregatedData = list.reduce((acc, curr) => {
    const status = state[`${curr.type}/${curr.identifier}`];
    if (status) {
      const {
        totalOnline
      } = acc;
      const onlineCount = status.online ? totalOnline + 1 : totalOnline;
      if (isNotNull(status.cwsi)) acc.cwsiArr.push(status.cwsi);
      if (status.cropStress) acc.cropStressSet.add(status.cropStress);
      if (curr.name) acc.stationNames.push(curr.name);
      return {
        ...acc,
        totalOnline: onlineCount,
        lastUpdated: status.lastUpdated,
        latestDate: status.latestDate
      };
    }
    return acc;
  }, {
    cwsiArr: [],
    totalOnline: 0,
    cropStressSet: new Set(),
    lastUpdated: '',
    latestDate: '',
    stationNames: []
  });
  return {
    cwsiVal: mean(aggregatedData.cwsiArr).toFixed(1),
    ...aggregatedData
  };
});
const selectSoilSummary = createSelector([selectAllSensorsStatus, (state, list) => list], (state, list) => {
  const summaryObj = list.reduce((acc, curr) => {
    let {
      onlineCount
    } = acc;
    const item = state[`${curr.type}/${curr.identifier}`];
    if (!item) {
      return acc;
    }
    if (curr.name) {
      acc.names.push(curr.name);
    }
    let depthSize = 1;
    if (isNotNull(item.depth1) && isNotNull(item.depth2)) {
      depthSize = item.depth2 - item.depth1;
    }
    const {
      percent,
      volume
    } = getPercentAndVolume(depthSize, item.vwcRootzone, item.wiltingPointRootzone, item.fieldCapacityRootzone);
    acc.percentArr.push(percent);
    acc.volumeArr.push(volume);
    if (isNotNull(item.vwcRootzone)) {
      acc.vwcRootzoneList.push(item.vwcRootzone);
    }
    if (isNotNull(item.vwc1)) {
      acc.vwcArr.push(...[item.vwc1, item.vwc2, item.vwc3, item.vwc4, item.vwc5, item.vwc6]);
    }
    if (isNotNull(item.units)) {
      acc.units = item.units;
    }
    if (item.online) {
      onlineCount += 1;
    }
    return {
      ...acc,
      onlineCount
    };
  }, {
    names: [],
    vwcRootzoneList: [],
    vwcArr: [],
    onlineCount: 0,
    units: {},
    percentArr: [],
    volumeArr: []
  });

  /**
   * If summaryObj.vwcArr is empty, passing an array with Zero value makes sure that
   * the min and the max doesn't appear as Infinity/-Infinity
   *
   * And filter out the array to remove non-number values
   */
  const vwcArr = summaryObj.vwcArr.length ? summaryObj.vwcArr.filter(item => typeof item === 'number') : [0];
  const min = parseFloat((Math.min(...vwcArr) * 100).toFixed(1));
  const max = parseFloat((Math.max(...vwcArr) * 100).toFixed(1));
  return {
    onlineCount: summaryObj.onlineCount,
    names: summaryObj.names,
    units: summaryObj.units,
    min: Number.isNaN(min) ? 0 : min,
    max: Number.isNaN(max) ? 0 : max,
    vwcRootzone: mean(summaryObj.vwcRootzoneList),
    percentAvailable: mean(summaryObj.percentArr) * 100,
    volumeAvailable: parseFloat(mean(summaryObj.volumeArr).toFixed(1))
  };
});
const selectPlantSummary = createSelector([selectAllSensorsStatus, (state, list) => list], (state, list) => {
  const aggregatedData = list.reduce((acc, curr) => {
    const status = state[`${curr.type}/${curr.identifier}`];
    if (status) {
      const {
        totalOnline
      } = acc;
      const onlineCount = status.online ? totalOnline + 1 : totalOnline;
      if (isNotNull(status.twdMin) && isNotNull(status.twdMax)) {
        acc.twdArr.push(mean([status.twdMin, status.twdMax]));
      }
      if (status.cropStress) acc.cropStressSet.add(status.cropStress);
      if (curr.name) acc.stationNames.push(curr.name);
      return {
        ...acc,
        totalOnline: onlineCount,
        lastUpdated: status.lastUpdated
      };
    }
    return acc;
  }, {
    twdArr: [],
    totalOnline: 0,
    cropStressSet: new Set(),
    lastUpdated: '',
    stationNames: []
  });
  return {
    ...aggregatedData,
    twdAvg: parseFloat(mean(aggregatedData.twdArr).toFixed(1))
  };
});
const selectWeatherSummary = createSelector([selectAllSensorsStatus, (state, list) => list], (state, list) => {
  const aggregatedData = list.reduce((acc, curr) => {
    const status = state[`${curr.type}/${curr.identifier}`];
    if (!status) return acc;
    const {
      totalOnline
    } = acc;
    const onlineCount = status.online ? totalOnline + 1 : totalOnline;
    if (status.weatherCurrent) acc.currentWeatherList.push(status.weatherCurrent);
    if (curr.name) acc.stationNames.push(curr.name);
    return {
      ...acc,
      totalOnline: onlineCount
    };
  }, {
    currentWeatherList: [],
    totalOnline: 0,
    stationNames: []
  });
  const {
    currentWeatherList,
    totalOnline,
    stationNames
  } = aggregatedData;
  return {
    airTemperature: getAverageBy(currentWeatherList, 'airTemperature'),
    precipitation: getAverageBy(currentWeatherList, 'precipitation'),
    windSpeed: getAverageBy(currentWeatherList, 'windSpeed'),
    totalOnline,
    stationNames
  };
});
const selectFrostSummary = createSelector([selectAllSensorsStatus, (state, list) => list], (state, list) => {
  const summaryObj = list.reduce((acc, curr) => {
    let {
      totalOnline
    } = acc;
    const item = state[`${curr.type}/${curr.identifier}`];
    if (!item) return acc;
    if (item.units) acc.status = item;
    if (curr.name) acc.names.push(curr.name);
    if (isNotNull(item.temperatureBud)) acc.temperatureBudArr.push(item.temperatureBud);
    if (isNotNull(item.temperatureLeaf)) acc.temperatureLeafArr.push(item.temperatureLeaf);
    totalOnline = item.online ? totalOnline + 1 : totalOnline;
    return {
      ...acc,
      totalOnline
    };
  }, {
    temperatureBudArr: [],
    temperatureLeafArr: [],
    status: {},
    names: [],
    totalOnline: 0
  });
  return {
    status: summaryObj.status,
    names: summaryObj.names,
    totalOnline: summaryObj.totalOnline,
    temperatureBud: parseFloat(mean(summaryObj.temperatureBudArr).toFixed(1)),
    temperatureLeaf: parseFloat(mean(summaryObj.temperatureLeafArr).toFixed(1))
  };
});
const selectValveSummary = createSelector([selectAllSensorsStatus, (state, list) => list], (state, list) => list.reduce((acc, curr) => {
  let {
    openValveCount,
    totalOnline
  } = acc;
  const item = state[`${curr.type}/${curr.identifier}`];
  if (!item) return acc;
  const isOpen = item.controlStatus && item.controlStatus.state === 'open';
  openValveCount = isOpen ? openValveCount + 1 : openValveCount;
  totalOnline = item.online ? totalOnline + 1 : totalOnline;
  const valveName = curr.name?.trim() || curr.identifier;
  if (valveName) {
    acc.allValvesName.push(valveName);
    if (isOpen) {
      acc.openValvesName.push(valveName);
    } else {
      acc.closedValvesName.push(valveName);
    }
  }
  return {
    ...acc,
    openValveCount,
    totalOnline
  };
}, {
  openValveCount: 0,
  openValvesName: [],
  closedValvesName: [],
  allValvesName: [],
  totalOnline: 0
}));
const selectFlowSummary = createSelector([selectAllSensorsStatus, (state, list) => list], (state, list) => {
  const summaryObj = list.reduce((acc, curr) => {
    let {
      status,
      totalOnline
    } = acc;
    const item = state[`${curr.type}/${curr.identifier}`];
    if (!item) return acc;
    totalOnline = item.online ? totalOnline + 1 : totalOnline;
    if (isNotNull(item.flowRate)) {
      status = item;
      acc.flowRateArr.push(item.flowRate);
    }
    if (curr.name) {
      acc.names.push(curr.name);
    }
    return {
      ...acc,
      status,
      totalOnline
    };
  }, {
    names: [],
    status: {},
    flowRateArr: [],
    totalOnline: 0
  });
  const flowRateArr = summaryObj.flowRateArr.length ? summaryObj.flowRateArr.filter(val => typeof val === 'number') : [0];
  const min = parseFloat(Math.min(...flowRateArr).toFixed(1));
  const max = parseFloat(Math.max(...flowRateArr).toFixed(1));
  return {
    ...summaryObj,
    flowRate: parseFloat(mean(flowRateArr).toFixed(1)),
    min: Number.isNaN(min) ? 0 : min,
    max: Number.isNaN(max) ? 0 : max
  };
});
const selectPumpSummary = createSelector([selectAllSensorsStatus, (state, list) => list], (state, list) => list.reduce((acc, curr) => {
  let {
    openPumpsCount,
    totalOnline
  } = acc;
  const item = state[`${curr.type}/${curr.identifier}`];
  if (!item) return acc;
  const isOpen = item.controlStatus && item.controlStatus.state === 'on';
  openPumpsCount = isOpen ? openPumpsCount + 1 : openPumpsCount;
  totalOnline = item.online ? totalOnline + 1 : totalOnline;
  if (curr.name) {
    acc.allPumpsName.push(curr.name);
    if (isOpen) {
      acc.openPumpsName.push(curr.name);
    } else {
      acc.closePumpsName.push(curr.name);
    }
  }
  return {
    ...acc,
    openPumpsCount,
    totalOnline
  };
}, {
  openPumpsCount: 0,
  openPumpsName: [],
  closePumpsName: [],
  allPumpsName: [],
  totalOnline: 0
}));
const selectPressureSummary = createSelector([selectAllSensorsStatus, (state, list) => list], (state, list) => {
  const summaryObj = list.reduce((acc, curr) => {
    let {
      onlineCount,
      irrigatingCount,
      totalCount
    } = acc;
    const item = state[`${curr.type}/${curr.identifier}`];
    if (!item) {
      return acc;
    }
    totalCount += 1;
    if (curr.name) {
      acc.names.push(curr.name);
    }
    if (isNotNull(item.waterPressure)) acc.waterPressureArr.push(item.waterPressure);
    if (isNotNull(item.waterPressure) && isNotNull(item.cutoffPressure)) {
      if (item.waterPressure > item.cutoffPressure) {
        irrigatingCount += 1;
      }
    }
    if (item.online) {
      onlineCount += 1;
    }
    return {
      ...acc,
      onlineCount,
      irrigatingCount,
      totalCount
    };
  }, {
    status: {},
    names: [],
    waterPressureArr: [],
    onlineCount: 0,
    irrigatingCount: 0,
    totalCount: 0
  });
  return {
    ...summaryObj,
    waterPressure: parseFloat(mean(summaryObj.waterPressureArr).toFixed(2))
  };
});
const selectSensorLoadingStatus = createSelector([selectAllSensorsStatus, (state, list) => list], (state, list) => list.some(i => {
  const status = state[`${i.type}/${i.identifier}`];
  if (status && status.id) {
    return status.loading;
  }
  return false;
}));

// if blockIds are not passed, this method does not filter on blockIds and returns all
const selectAllSensorStatusForBlockIdsByType = (state, blockIds) => statusSelectors.selectAll(state).reduce((statusData, status) => {
  if (status) {
    const checkBlockIds = blockIds ? blockIds.includes(status.block) : true;
    if (checkBlockIds) {
      if (statusData[status.type]) {
        statusData[status.type].push(status);
      } else {
        statusData[status.type] = [status];
      }
    }
  }
  return statusData;
}, {});
const populateSensorStatus$1 = (state, sensors) => sensors.map(sensor => ({
  ...sensor,
  status: selectSensorStatus(state, sensor.type, sensor.identifier)
}));

// sensor stats selectors

const selectSensorStatsState = state => state.sensorsData.stats.sensor;
const selectCavalierStatsState = state => state.sensorsData.stats.cavalier;
const selectGatewayStatsState = state => state.sensorsData.stats.gateway;
const selectBlockStatsState = state => state.sensorsData.stats.block;
const selectRanchStatsState = state => state.sensorsData.stats.ranch;
const sensorStatsSelectors = sensorsAdapter.getSelectors(selectSensorStatsState);
const cavalierStatsSelectors = sensorsAdapter.getSelectors(selectCavalierStatsState);
const gatewayStatsSelectors = sensorsAdapter.getSelectors(selectGatewayStatsState);
const blockStatsSelectors = blockStatsAdapter.getSelectors(selectBlockStatsState);
const ranchStatsSelectors = ranchStatsAdapter.getSelectors(selectRanchStatsState);
const selectSensorStats = (state, type, identifier) => {
  let selector = sensorStatsSelectors;
  if (type === 'gateway') selector = gatewayStatsSelectors;
  if (type === 'cavalier') selector = cavalierStatsSelectors;
  if (type === 'block') {
    return blockStatsSelectors.selectById(state, identifier) || blockStatsSelectors.selectById(state, Number(identifier));
  }
  if (type === 'ranch') {
    return ranchStatsSelectors.selectById(state, identifier) || ranchStatsSelectors.selectById(state, Number(identifier));
  }
  return selector.selectById(state, getSensorKey$2({
    type,
    identifier
  }));
};
const selectSensorErrors = (state, type, identifier) => {
  if (type !== 'cavalier') return null;
  const stats = selectSensorStats(state, type, identifier);
  return stats && stats.errors;
};
const selectAllSensorStats = sensorStatsSelectors.selectAll;
const selectLoadingSensorStats = state => selectLoadingState(selectSensorStatsState(state));
const selectAllCavalierStats = cavalierStatsSelectors.selectAll;
const selectLoadingCavalierStats = state => selectLoadingState(selectCavalierStatsState(state));
const selectAllGatewayStats = gatewayStatsSelectors.selectAll;
const selectLoadingGatewayStats = state => selectLoadingState(selectGatewayStatsState(state));
const selectAllBlockStats = blockStatsSelectors.selectAll;
const selectAllRanchStats = ranchStatsSelectors.selectAll;

// sensor note / image selectors

const selectSensorNotesState = state => state.sensorsData.notes;
const sensorNotesSelectors = sensorNotesAdapter.getSelectors(selectSensorNotesState);
const selectAllSensorNotes = sensorNotesSelectors.selectAll;
const selectLoadingSensorNotes = state => selectLoadingState(selectSensorNotesState(state));
const selectSensorImagesState = state => state.sensorsData.images;
const sensorImagesSelectors = sensorImagesAdapter.getSelectors(selectSensorImagesState);
const selectAllSensorImages = sensorImagesSelectors.selectAll;
const selectLoadingSensorImages = state => selectLoadingState(selectSensorImagesState(state));

// sensor relationships

const selectPumpFlowMeter$1 = (state, type, identifier) => {
  const pumpController = selectSensor$1(state, type, identifier);
  if (!pumpController) return undefined;
  const {
    gateway: gatewayId
  } = pumpController;
  if (!gatewayId) return undefined;
  const flowMeters = selectSensorsForGatewayId(state, gatewayId, 'water_flow_analog', 'installed');
  if (!flowMeters || !flowMeters.length) return null;
  return populateSensorStatus$1(state, [flowMeters[0]])[0];
};
const selectGatewayIsControlEnabled = (state, gatewayId) => {
  const vfds = selectSensorsForGatewayId(state, gatewayId, 'vfd');
  if (vfds && vfds.length) return true;
  const valves = selectSensorsForGatewayId(state, gatewayId, 'valve');
  if (valves && valves.length) return true;
  return false;
};
const selectControlGatewaysForRanchId$1 = (state, ranchId) => {
  const gateways = selectSensorsForRanchId(state, ranchId, 'gateway', 'installed');
  return gateways.filter(gateway => selectGatewayIsControlEnabled(state, gateway.id));
};
const selectSensorsStatus = (state, sensors) => {
  const status = sensors.map(sensor => selectSensorStatus(state, {
    type: sensor.sensor_type,
    identifier: sensor.identifier
  }));
  return status;
};
const selectWeatherStatusFirstRecordForBlockIds = (state, {
  blockIds,
  installState
}) => {
  try {
    const {
      weather_station: weatherList
    } = selectAllSensorsForBlockIdsByType(state, {
      blockIds,
      installState: installState.INSTALLED
    });
    if (weatherList) {
      const allSensors = selectAllSensorsStatus(state);
      if (isNotNull(allSensors)) {
        const record = weatherList.find(item => {
          const status = allSensors[`${item.type}/${item.identifier}`];
          return isNotNull(status) && isNotNull(status.weatherCurrent);
        });
        if (isNotNull(record)) {
          return {
            status: allSensors[`${record.type}/${record.identifier}`],
            isLoading: selectSensorLoadingStatus(state, weatherList)
          };
        }
      }
    }
    return {
      status: null,
      isLoading: false
    };
  } catch {
    return {
      status: null,
      isLoading: false
    };
  }
};

/**
 * Returns list of weather sensors and weather status for one of the sensor
 * which has proper data.
 * @param {*} state
 * @param {Array} blockIds
 * @returns {*}
 */
const selectWeatherDataAndList = (state, blockIds) => {
  const sensors = selectAllSensorsForBlockIdsByType(state, {
    blockIds,
    installState: 'installed'
  });
  const list = sensors.weather_station || [];
  const item = list.find(i => {
    const status = selectSensorStatus(state, i.type, i.identifier) || {};

    /**
     * This complexity can be reduced, if we can guarantee the api returns
     * data with weatherForecast and weatherHistory as not null/undefined.
     *
     * The additional check of status.weatherHistory[0].airTemperatureMin
     * Issue where weather history was not showing up, upon debugging found that the above
     * value was set to null for all weatherHistory items.
     */
    const weatherForecast = status.weatherForecast && status.weatherForecast[0];
    const weatherHistory = status.weatherHistory && status.weatherHistory[0];
    const airTemperatureMin = weatherHistory && weatherHistory.airTemperatureMin;
    return weatherForecast && airTemperatureMin;
  });
  return {
    list,
    weatherData: item ? selectSensorStatus(state, item.type, item.identifier) : {}
  };
};
const selectSensorsForBlockIds = (state, blockIds = [], type) => {
  const sensors = blockIds.map(blockId => {
    const obj = {};
    const sensorsForType = selectSensorsForBlockId(state, blockId, type, 'installed');
    obj[blockId] = sensorsForType;
    return obj;
  }).reduce((acc, obj) => {
    const key = Object.keys(obj)[0];
    acc[key] = obj[key];
    return acc;
  }, {});
  return sensors;
};
const selectSoilSensorsForBlockIds = (state, blockIds = [], type) => {
  const sensors = blockIds.map(blockId => {
    const obj = {};
    const sensorsForType = selectSensorsForBlockId(state, blockId, type, 'installed');
    obj[blockId] = sensorsForType.filter(d => d && d.type.indexOf('soil') !== -1);
    return obj;
  }).reduce((acc, obj) => {
    const key = Object.keys(obj)[0];
    acc[key] = obj[key];
    return acc;
  }, {});
  return sensors;
};
const selectTHSensorSummary = createSelector([selectAllSensorsStatus, (state, list) => list], (state, list) => {
  const summaryObj = list.reduce((acc, curr) => {
    let {
      onlineCount
    } = acc;
    const item = state[`${curr.type}/${curr.identifier}`];
    if (!item) {
      return acc;
    }
    if (curr.name) {
      acc.names.push(curr.name);
    }
    if (isNotNull(item.temperature)) {
      acc.temperatureArr.push(item.temperature);
    }
    if (isNotNull(item.humidity)) {
      acc.humidityArr.push(item.humidity);
    }
    if (item.online) {
      onlineCount += 1;
    }
    return {
      ...acc,
      onlineCount
    };
  }, {
    names: [],
    temperatureArr: [],
    humidityArr: [],
    onlineCount: 0
  });

  /**
   * If summaryObj.vwcArr is empty, passing an array with Zero value makes sure that
   * the min and the max doesn't appear as Infinity/-Infinity
   *
   * And filter out the array to remove non-number values
   */
  const temperatureArr = summaryObj.temperatureArr.length ? summaryObj.temperatureArr.filter(item => typeof item === 'number') : [0];
  const humidityArr = summaryObj.humidityArr.length ? summaryObj.humidityArr.filter(item => typeof item === 'number') : [0];
  const tMin = parseFloat(Math.min(...temperatureArr).toFixed(1));
  const tMax = parseFloat(Math.max(...temperatureArr).toFixed(1));
  const hMin = parseFloat(Math.min(...humidityArr).toFixed(1));
  const hMax = parseFloat(Math.max(...humidityArr).toFixed(1));
  return {
    onlineCount: summaryObj.onlineCount,
    names: summaryObj.names,
    tMin: Number.isNaN(tMin) ? 0 : tMin,
    tMax: Number.isNaN(tMax) ? 0 : tMax,
    hMin: Number.isNaN(hMin) ? 0 : hMin,
    hMax: Number.isNaN(hMax) ? 0 : hMax
  };
});
const selectSensorStatusByParam = (state, params) => params.reduce((a, param) => {
  const {
    type,
    identifier
  } = param || {};
  const status = selectSensorStatus(state, type, identifier);
  a[`${type}/${identifier}`] = {
    ...(status || {})
  };
  return a;
}, {});
var sensorSelectors = /*#__PURE__*/Object.freeze({
  __proto__: null,
  sensorsAdapter: sensorsAdapter,
  blockStatsAdapter: blockStatsAdapter,
  ranchStatsAdapter: ranchStatsAdapter,
  selectSensorsState: selectSensorsState,
  selectAllSensors: selectAllSensors$1,
  selectSensorsForEntity: selectSensorsForEntity,
  selectSensorsForIrrigationBlockId: selectSensorsForIrrigationBlockId,
  selectSensorsForRanchId: selectSensorsForRanchId,
  selectSensorsByRanchId: selectSensorsByRanchId,
  selectSensor: selectSensor$1,
  selectSensorById: selectSensorById$1,
  selectAllSensorsForBlockIdsByType: selectAllSensorsForBlockIdsByType,
  selectAllSensorStatusByType: selectAllSensorStatusByType,
  selectSensorsForBlockId: selectSensorsForBlockId,
  selectAllSensorStatusForBlockIdsByType: selectAllSensorStatusForBlockIdsByType,
  selectSensorByParams: selectSensorByParams,
  selectPumpFlowMeter: selectPumpFlowMeter$1,
  selectLoadingSensors: selectLoadingSensors$1,
  selectSensorsForGatewayId: selectSensorsForGatewayId,
  selectGatewayIsControlEnabled: selectGatewayIsControlEnabled,
  selectControlGatewaysForRanchId: selectControlGatewaysForRanchId$1,
  selectSensorLoadingStatus: selectSensorLoadingStatus,
  selectSensorCapabilities: selectSensorCapabilities,
  selectLoadingCapabilities: selectLoadingCapabilities,
  selectSensorStatus: selectSensorStatus,
  selectLoadingStatus: selectLoadingStatus,
  populateSensorStatus: populateSensorStatus$1,
  selectSensorsStatus: selectSensorsStatus,
  selectValveStatusById: selectValveStatusById,
  selectDetailsForValveIds: selectDetailsForValveIds,
  selectWeatherStatusFirstRecordForBlockIds: selectWeatherStatusFirstRecordForBlockIds,
  selectSensorStats: selectSensorStats,
  selectAllSensorStats: selectAllSensorStats,
  selectLoadingSensorStats: selectLoadingSensorStats,
  selectAllCavalierStats: selectAllCavalierStats,
  selectLoadingCavalierStats: selectLoadingCavalierStats,
  selectAllGatewayStats: selectAllGatewayStats,
  selectLoadingGatewayStats: selectLoadingGatewayStats,
  selectSensorErrors: selectSensorErrors,
  selectAllSensorNotes: selectAllSensorNotes,
  selectLoadingSensorNotes: selectLoadingSensorNotes,
  selectAllSensorImages: selectAllSensorImages,
  selectLoadingSensorImages: selectLoadingSensorImages,
  selectFrostSummary: selectFrostSummary,
  selectPumpSummary: selectPumpSummary,
  selectIRSensorSummary: selectIRSensorSummary,
  selectSoilSummary: selectSoilSummary,
  selectPlantSummary: selectPlantSummary,
  selectWeatherSummary: selectWeatherSummary,
  selectValveSummary: selectValveSummary,
  selectFlowSummary: selectFlowSummary,
  selectPressureSummary: selectPressureSummary,
  selectWeatherDataAndList: selectWeatherDataAndList,
  selectSensorsForBlockIds: selectSensorsForBlockIds,
  selectAllBlockStats: selectAllBlockStats,
  selectBlockStatsState: selectBlockStatsState,
  selectAllRanchStats: selectAllRanchStats,
  selectRanchStatsState: selectRanchStatsState,
  selectSoilSensorsForBlockIds: selectSoilSensorsForBlockIds,
  selectTHSensorSummary: selectTHSensorSummary,
  selectSensorsForRanchIds: selectSensorsForRanchIds,
  selectSensorStatusByParam: selectSensorStatusByParam
});
const name$i = 'sensors';
const loadAllSensors$1 = createAsyncThunk(`${name$i}/loadAll`, loadList({
  getData: sensorApi$2.loadSensors,
  getRequestState: selectSensorsState
}));
const loadSensorsRanch$2 = createAsyncThunk(`${name$i}/loadByRanchId`, loadListById({
  getData: sensorApi$2.loadSensorsRanch,
  getRequestState: selectSensorsState
}));
const loadSensorDetail$2 = createAsyncThunk(`${name$i}/loadSingle`, loadByTypeIdentifier({
  getData: sensorApi$2.loadSensorDetail,
  getRequestState: selectSensor$1
}));
const loadSensorDetailById$2 = createAsyncThunk(`${name$i}/loadSingleById`, loadByTypeId({
  getData: sensorApi$2.loadSensorDetailById,
  getRequestState: selectSensorById$1
}));
const loadPaginatedSensorsRanch = createAsyncThunk(`${name$i}/loadByRanchIdAndPagination`, loadListById({
  getData: id => sensorApi$2.loadPaginatedSensorsList(id),
  getRequestState: selectSensorsState
}));
const loadSensorsForEntity = createAsyncThunk(`${name$i}/loadByEntityId`, loadListById({
  getData: id => sensorApi$2.getSensorsForEntity(id),
  getRequestState: selectSensorsState
}));

/*
 * Sensor Actions
 */

const processActionApi = async (args, api) => {
  try {
    const value = await api(args);
    return value;
  } catch (error) {
    throw new Error(error.message);
  }
};
const updateSensorLocation$2 = createAsyncThunk(`${name$i}/updateLocation`, async args => processActionApi(args, sensorApi$2.updateSensorLocation));
const rebootMilesightNode$2 = createAsyncThunk(`${name$i}/reboot`, async args => processActionApi(args, sensorApi$2.rebootMilesightNode));
const createSensor$2 = createAsyncThunk(`${name$i}/create`, async args => processActionApi(args, sensorApi$2.createSensor));
const installSensor$2 = createAsyncThunk(`${name$i}/install`, async args => processActionApi(args, sensorApi$2.installSensor));
const uninstallSensor$2 = createAsyncThunk(`${name$i}/uninstall`, async args => processActionApi(args, sensorApi$2.uninstallSensor));
const removeSensor$2 = createAsyncThunk(`${name$i}/remove`, async args => processActionApi(args, sensorApi$2.removeSensor));
const replaceSensor$2 = createAsyncThunk(`${name$i}/replace`, async args => processActionApi(args, sensorApi$2.replaceSensor));
const copySensorMetadataToCav = createAsyncThunk(`${name$i}/copySensorMetadataToCav`, async args => processActionApi(args, sensorApi$2.copySensorMetadataToCavalier));
const copySensorMetadataFromCav = createAsyncThunk(`${name$i}/copySensorMetadataFromCav`, async args => processActionApi(args, sensorApi$2.copyCavalierMetadataToSensor));
const copySoilSensorProperties$2 = createAsyncThunk(`${name$i}/copySoilSensorProperties`, async args => processActionApi(args, sensorApi$2.copySoilSensorProperties));
const setSensorMoistureData$2 = createAsyncThunk(`${name$i}/setSensorMoistureData`, async args => processActionApi(args, sensorApi$2.setSensorMoistureData));
const sensors = createSlice({
  name: name$i,
  initialState: sensorsAdapter.getInitialState(initialState$6),
  reducers: {
    // there's a possibility that persisted state might have incorrect request state saved
    cleanSensorsFetchState(state) {
      state.loading = false;
      state.error = undefined;
      state.currentRequestId = undefined;
    }
  },
  extraReducers: {
    [loadAllSensors$1.pending]: requestList,
    [loadAllSensors$1.fulfilled]: receiveList(sensorsAdapter),
    [loadAllSensors$1.rejected]: requestListFailed,
    [loadSensorsRanch$2.pending]: requestList,
    [loadSensorsRanch$2.fulfilled]: receiveList(sensorsAdapter),
    [loadSensorsRanch$2.rejected]: requestListFailed,
    [loadSensorsForEntity.pending]: requestList,
    [loadSensorsForEntity.fulfilled]: (state, action) => {
      if (state.loading === true && action.payload) {
        state.loading = false;
        const lastUpdated = Date.now();
        state.lastUpdated = lastUpdated;
        state.error = undefined;
        const {
          results
        } = action.payload || {};
        sensorsAdapter.setAll(state, results || []);
        state.currentRequestId = undefined;
      }
    },
    [loadSensorsForEntity.rejected]: requestListFailed,
    [loadPaginatedSensorsRanch.pending]: requestList,
    [loadPaginatedSensorsRanch.fulfilled]: (state, action) => {
      if (state.loading === true && action.payload) {
        state.loading = false;
        const lastUpdated = Date.now();
        state.lastUpdated = lastUpdated;
        state.error = undefined;
        const {
          results
        } = action.payload || {};
        sensorsAdapter.setAll(state, results || []);
        state.currentRequestId = undefined;
      }
    },
    [loadPaginatedSensorsRanch.rejected]: requestListFailed,
    [loadSensorDetail$2.pending]: requestItemByParams(sensorsAdapter),
    [loadSensorDetail$2.fulfilled]: receiveItem(sensorsAdapter),
    [loadSensorDetail$2.rejected]: requestItemByParamsFailed(sensorsAdapter),
    // TODO: test by Id reducers
    [loadSensorDetailById$2.pending]: (state, action) => {
      // NOTE: I wasnt able to get the normal selectSensorById selector to work
      const {
        id,
        type
      } = action.meta.arg;
      const allSensors = Object.values(sensorsAdapter.getSelectors().selectEntities(state));
      const item = allSensors.find(sensor => sensor.type === type && sensor.id === id);
      // in some cases the item wont be found, thats ok
      // but if it does exist, it needs to be updated
      if (item && (item.loading === undefined || item.loading === false)) {
        sensorsAdapter.upsertOne(state, {
          ...item,
          loading: true,
          currentRequestId: action.meta.requestId
        });
      }
    },
    [loadSensorDetailById$2.fulfilled]: receiveItem(sensorsAdapter),
    [loadSensorDetailById$2.rejected]: (state, action) => {
      // NOTE: I wasnt able to get the normal selectSensorById selector to work
      const {
        id,
        type
      } = action.meta.arg;
      const allSensors = Object.values(sensorsAdapter.getSelectors().selectEntities(state));
      const current = allSensors.find(sensor => sensor.type === type && sensor.id === id);
      if (current) {
        sensorsAdapter.upsertOne(state, {
          ...current,
          loading: false,
          error: action.error,
          currentRequestId: undefined
        });
      }
    },
    [updateSensorLocation$2.fulfilled]: (state, action) => {
      const {
        sensorType: type,
        sensorIdentifier: identifier,
        lat,
        lng
      } = action.meta.arg;
      sensorsAdapter.upsertOne(state, {
        type,
        identifier,
        location: {
          lat,
          lng
        }
      });
    },
    [createSensor$2.fulfilled]: (state, action) => {
      sensorsAdapter.upsertOne(state, {
        ...action.payload
      });
    },
    [installSensor$2.fulfilled]: (state, action) => {
      const {
        sensorType: type,
        sensorIdentifier: identifier
      } = action.meta.arg;
      sensorsAdapter.upsertOne(state, {
        type,
        identifier,
        install_state: 'installed',
        visible: true
      });
    },
    [uninstallSensor$2.fulfilled]: (state, action) => {
      const {
        sensorType: type,
        sensorIdentifier: identifier
      } = action.meta.arg;
      sensorsAdapter.upsertOne(state, {
        type,
        identifier,
        install_state: 'inventory',
        visible: false,
        location: {
          lat: 0,
          lng: 0
        },
        name: null
      });
    }
  }
});
const {
  cleanSensorsFetchState
} = sensors.actions;
var sensors$1 = sensors.reducer;
const name$h = 'status';
const loadSensorStatus$6 = createAsyncThunk(`${name$h}/loadSingle`, loadByTypeIdentifier({
  getData: sensorApi$2.loadSensorStatus,
  getRequestState: selectSensorStatus
}));
const status = createSlice({
  name: name$h,
  initialState: sensorsAdapter.getInitialState(initialState$6),
  reducers: {
    addItems(state, {
      payload
    }) {
      const records = {};
      payload.forEach(req => {
        const {
          data: s
        } = req.value;
        const id = `${s.type}/${s.identifier}`;
        records[id] = {
          ...s,
          lastUpdated: Date.now(),
          loading: false,
          error: undefined,
          currentRequestId: undefined
        };
      });
      if (Object.keys(records).length) {
        sensorsAdapter.upsertMany(state, records);
      }
    }
  },
  extraReducers: {
    [loadSensorStatus$6.pending]: requestItemByParams(sensorsAdapter),
    [loadSensorStatus$6.fulfilled]: (state, action) => {
      if (!action.payload) return;
      const {
        payload: item
      } = action;
      // check if it is an empty object
      if (Object.keys(item).length === 0) {
        item.type = action.meta.arg.type;
        item.identifier = action.meta.arg.identifier;
      }
      item.lastUpdated = Date.now();
      item.loading = false;
      item.error = undefined;
      sensorsAdapter.upsertOne(state, item);
    },
    [loadSensorStatus$6.rejected]: requestItemByParamsFailed(sensorsAdapter)
  }
});
const {
  addItems
} = status.actions;
var status$1 = status.reducer;

/* eslint-disable import/no-extraneous-dependencies */
const name$g = 'sensorsgeojson';
const sensorsGeoJSON = createSlice({
  name: name$g,
  initialState: {},
  reducers: {
    setSensorsStateForGeoJSON(state, {
      payload: {
        sensorsFeatures
      }
    }) {
      if (!Object.keys(sensorsFeatures).length) {
        return state;
      }
      const ranchIdsObj = Object.values(sensorsFeatures).reduce((acc, sensorFeature) => {
        acc[sensorFeature.properties.ranchId] = sensorFeature.properties.ranchId;
        return acc;
      }, {});
      const sensorsFeaturesRemaining = Object.values(state).filter(sensorFeature => !ranchIdsObj[sensorFeature.properties.ranchId]).reduce((acc, sensorFeature) => {
        acc[sensorFeature.properties.id] = cloneDeep(sensorFeature);
        return acc;
      }, {});
      return cloneDeep({
        ...sensorsFeaturesRemaining,
        ...sensorsFeatures
      });
    }
  }
});
const {
  setSensorsStateForGeoJSON
} = sensorsGeoJSON.actions;
var sensorsgeojson = sensorsGeoJSON.reducer;
const name$f = 'capabilities';
const getCapabilitiesState = state => state.sensorsData.capabilities;
const loadSensorCapabilities$2 = createAsyncThunk(`${name$f}/loadSingle`, loadByTypeIdentifier({
  getData: sensorApi$2.loadSensorCapabilities,
  getRequestState: (state, type, identifier) => {
    const id = sensorsAdapter.selectId({
      type,
      identifier
    });
    return sensorsAdapter.getSelectors(getCapabilitiesState).selectById(state, id);
  }
}));
const capabilities = createSlice({
  name: name$f,
  initialState: sensorsAdapter.getInitialState(initialState$6),
  reducers: {},
  extraReducers: {
    [loadSensorCapabilities$2.pending]: requestItemByParams(sensorsAdapter),
    [loadSensorCapabilities$2.fulfilled]: receiveItemUpsertNested(sensorsAdapter),
    [loadSensorCapabilities$2.rejected]: requestItemByParamsFailed(sensorsAdapter)
  }
});
var capabilities$1 = capabilities.reducer;
const {
  fetchSensorStatsList: fetchSensorStatsList$2,
  fetchCavalierStatsList: fetchCavalierStatsList$2,
  fetchGatewayStatsList: fetchGatewayStatsList$2,
  fetchSensorStatsSingle: fetchSensorStatsSingle$2,
  fetchBlockStatsList: fetchBlockStatsList$2,
  fetchSingleBlockStats: fetchSingleBlockStats$2,
  fetchRanchStatsList: fetchRanchStatsList$2,
  fetchSingleRanchStats: fetchSingleRanchStats$2
} = sensorApi$2;
const createStatsSlice = (name, getList, getDetail, getRequestState, optionalAdapter) => {
  const loadStatsList = createAsyncThunk(`stats/${name}/loadList`, loadList({
    getData: getList,
    getRequestState
  }));
  const loadStatsSingle = createAsyncThunk(`stats/${name}/loadSingle`, loadByTypeIdentifier({
    getData: getDetail,
    getRequestState: selectSensorStats
  }));
  const adapter = optionalAdapter || sensorsAdapter;
  const slice = createSlice({
    name,
    initialState: adapter.getInitialState(initialState$6),
    reducers: {},
    extraReducers: {
      [loadStatsList.pending]: requestList,
      [loadStatsList.fulfilled]: receiveListCheckDate(adapter),
      [loadStatsList.rejected]: requestListFailed,
      [loadStatsSingle.pending]: requestItemByParams(adapter),
      [loadStatsSingle.fulfilled]: receiveItem(adapter),
      [loadStatsSingle.rejected]: requestItemByParamsFailed(adapter)
    }
  });
  return {
    loadStatsList,
    loadStatsSingle,
    slice
  };
};
const sensorStats = createStatsSlice('sensor', fetchSensorStatsList$2, fetchSensorStatsSingle$2, state => state.sensorsData.stats.sensor);
const cavalierStats = createStatsSlice('cavalier', fetchCavalierStatsList$2, fetchSensorStatsSingle$2, state => state.sensorsData.stats.cavalier);
const gatewayStats = createStatsSlice('gateway', fetchGatewayStatsList$2, fetchSensorStatsSingle$2, state => state.sensorsData.stats.gateway);
const blockStats = createStatsSlice('blockStats', fetchBlockStatsList$2, fetchSingleBlockStats$2, state => state.sensorsData.stats.block, blockStatsAdapter);
const ranchStats = createStatsSlice('ranchStats', fetchRanchStatsList$2, fetchSingleRanchStats$2, state => state.sensorsData.stats.ranch, ranchStatsAdapter);
const {
  loadStatsList: loadSensorStatsList,
  loadStatsSingle: loadSensorStatsSingle
} = sensorStats;
const {
  loadStatsList: loadCavalierStatsList,
  loadStatsSingle: loadCavalierStatsSingle
} = cavalierStats;
const {
  loadStatsList: loadGatewayStatsList,
  loadStatsSingle: loadGatewayStatsSingle
} = gatewayStats;
const {
  loadStatsList: loadBlockStatsList,
  loadStatsSingle: loadBlockStatsSingle
} = blockStats;
const {
  loadStatsList: loadRanchStatsList,
  loadStatsSingle: loadRanchStatsSingle
} = ranchStats;
var stats = combineReducers({
  sensor: sensorStats.slice.reducer,
  cavalier: cavalierStats.slice.reducer,
  gateway: gatewayStats.slice.reducer,
  block: blockStats.slice.reducer,
  ranch: ranchStats.slice.reducer
});
var sensorsData = combineReducers({
  sensors: sensors$1,
  status: status$1,
  capabilities: capabilities$1,
  stats,
  images,
  notes,
  sensorsgeojson
});
const farmAdapter = createEntityAdapter();
const createFarmSlice = (name, getList, getDetail, getRequestState) => {
  const loadListThunk = createAsyncThunk(`${name}/loadList`, loadList({
    getData: getList,
    getRequestState
  }));
  const loadDetailThunk = createAsyncThunk(`${name}/loadDetail`, loadDetail({
    getData: getDetail,
    getRequestState: (id, state) => {
      const {
        entities
      } = getRequestState(state);
      return entities[id];
    }
  }));
  const slice = createSlice({
    name,
    initialState: {
      ...farmAdapter.getInitialState(initialState$6),
      selectedEntityId: null
    },
    reducers: {
      cleanListRequestState(state) {
        state.loading = false;
        state.currentRequestId = undefined;
        state.error = null;
      },
      updateItem: farmAdapter.updateOne,
      setSelectedEntityId: (state, action) => {
        state.selectedEntityId = action.payload;
      }
    },
    extraReducers: {
      [loadListThunk.pending]: requestListThrottled(),
      [loadListThunk.fulfilled]: receiveList(farmAdapter),
      [loadListThunk.rejected]: requestListFailed,
      [loadDetailThunk.pending]: requestItemById(farmAdapter),
      [loadDetailThunk.fulfilled]: receiveItem(farmAdapter),
      [loadDetailThunk.rejected]: requestItemByIdFailed(farmAdapter)
    }
  });
  return {
    loadListThunk,
    loadDetailThunk,
    slice
  };
};
const {
  getEntityList: getEntityList$1,
  getEntityDetail: getEntityDetail$1
} = farmApi$2;
const {
  loadListThunk: loadEntityList,
  loadDetailThunk: loadEntityDetail,
  slice: entitiesSlice
} = createFarmSlice('entities', getEntityList$1, getEntityDetail$1, state => state.farmData.entities);
const {
  cleanListRequestState: cleanListRequestState$4
} = entitiesSlice.actions;
const cleanEntitiesListRequestState = () => cleanListRequestState$4();
const selectActiveEntity$1 = entityId => entitiesSlice.actions.setSelectedEntityId(entityId);
var entities = entitiesSlice.reducer;
const {
  getRanchList: getRanchList$1,
  getRanchDetail: getRanchDetail$1
} = farmApi$2;
const {
  loadListThunk: loadRanchList,
  loadDetailThunk: loadRanchDetail,
  slice: ranchesSlice
} = createFarmSlice('ranches', getRanchList$1, getRanchDetail$1, state => state.farmData.ranches);
const {
  cleanListRequestState: cleanListRequestState$3
} = ranchesSlice.actions;
const cleanRanchesListRequestState = () => cleanListRequestState$3();
var ranches = ranchesSlice.reducer;
const {
  getEntityList: getEntityList$3,
  getEntityDetail: getEntityDetail$3
} = farmApi$2;
const {
  loadListThunk: loadAvailableEntityList,
  loadDetailThunk: loadAvailableEntityDetail,
  slice: availableEntitiesSlice
} = createFarmSlice('availableEntities', getEntityList$3, getEntityDetail$3, state => state.farmData.availableEntities);
availableEntitiesSlice.actions;
var availableEntities = availableEntitiesSlice.reducer;
const {
  getRanchList: getRanchList$3,
  getRanchDetail: getRanchDetail$3
} = farmApi$2;
const {
  loadListThunk: loadAvailableRanchList,
  loadDetailThunk: loadAvailableRanchDetail,
  slice: availableRanchesSlice
} = createFarmSlice('availableRanches', getRanchList$3, getRanchDetail$3, state => state.farmData.availableRanches);
availableRanchesSlice.actions;
var availableRanches = availableRanchesSlice.reducer;
const {
  getBlockList: getBlockList$2,
  getBlockDetail: getBlockDetail$2
} = farmApi$2;
const {
  loadListThunk: loadBlockList,
  loadDetailThunk: loadBlockDetail,
  slice: blocksSlice
} = createFarmSlice('blocks', getBlockList$2, getBlockDetail$2, state => state.farmData.blocks);
const {
  cleanListRequestState: cleanListRequestState$2,
  updateItem: updateBlockItem
} = blocksSlice.actions;
const cleanBlocksListRequestState = () => cleanListRequestState$2();
var blocks = blocksSlice.reducer;
const name$e = 'plans';
const initialState$2 = {
  loading: false,
  currentRequestId: undefined,
  error: null
};
const plansAdapter = createEntityAdapter();
const loadPlansByRanchId = createAsyncThunk(`${name$e}/fetchByRanchId`, async ranchId => {
  const response = await plansApi$2.fetchPlansByRanchId(ranchId);
  return response.data;
});
const loadPlanById = createAsyncThunk(`${name$e}/fetchById`, async id => {
  const response = await plansApi$2.fetchPlanById(id);
  return response.data;
});
const plansSlice = createSlice({
  name: name$e,
  initialState: plansAdapter.getInitialState(initialState$2),
  reducers: {},
  extraReducers: {
    [loadPlansByRanchId.pending]: (state, action) => {
      if (state.loading === false) {
        state.loading = true;
        state.error = undefined;
        state.currentRequestId = action.meta.requestId;
      }
    },
    [loadPlansByRanchId.fulfilled]: (state, action) => {
      const {
        requestId
      } = action.meta;
      if (state.loading === true && state.currentRequestId === requestId) {
        const lastUpdated = Date.now();
        state.lastUpdated = lastUpdated;
        state.loading = false;
        state.currentRequestId = undefined;
        state.error = undefined;
        plansAdapter.setAll(state, action.payload);
      }
    },
    [loadPlansByRanchId.rejected]: (state, action) => {
      const {
        requestId
      } = action.meta;
      if (state.loading === true && state.currentRequestId === requestId) {
        state.loading = false;
        state.error = action.error;
        state.currentRequestId = undefined;
      }
    },
    [loadPlanById.pending]: (state, action) => {
      const id = action.meta.arg;
      plansAdapter.upsertOne(state, {
        id,
        loading: true,
        error: undefined,
        currentRequestId: action.meta.requestId
      });
    },
    [loadPlanById.fulfilled]: (state, action) => {
      if (!action.payload) {
        return;
      }
      const {
        payload: item
      } = action;
      item.lastUpdated = Date.now();
      item.loading = false;
      item.currentRequestId = undefined;
      item.error = undefined;
      plansAdapter.upsertOne(state, {
        ...item,
        error: undefined
      });
    },
    [loadPlanById.rejected]: (state, action) => {
      const id = action.meta.arg;
      plansAdapter.upsertOne(state, {
        id,
        loading: false,
        error: action.error,
        currentRequestId: undefined
      });
    }
  }
});
var plans = plansSlice.reducer;
const patchPlan = createAsyncThunk(`${name$e}/patch`, async (planData, {
  rejectWithValue
}) => {
  try {
    const {
      id
    } = planData;
    const response = await plansApi$2.patchPlanById(id, planData);
    return response.data;
  } catch (err) {
    const error = err;
    if (!error.response) {
      throw err;
    }
    return rejectWithValue(error.response.data);
  }
});
const updatePlan = createAsyncThunk(`${name$e}/update`, async (planData, {
  rejectWithValue
}) => {
  try {
    const {
      id
    } = planData;
    const response = await plansApi$2.updatePlanById(id, planData);
    return response.data;
  } catch (err) {
    const error = err;
    if (!error.response) {
      throw err;
    }
    return rejectWithValue(error.response.data);
  }
});
const createPlan$2 = createAsyncThunk(`${name$e}/create`, async (planData, {
  rejectWithValue
}) => {
  try {
    const response = await plansApi$2.createPlan(planData);
    return response.data;
  } catch (err) {
    const error = err;
    if (!error.response) {
      throw err;
    }
    return rejectWithValue(error.response.data);
  }
});
const name$d = 'blocksgeojson';
const blocksGeoJSON$1 = createSlice({
  name: name$d,
  initialState: {},
  reducers: {
    setBlocksGeoJSON(state, {
      payload: {
        blocksFeatures
      }
    }) {
      if (!Object.keys(blocksFeatures).length) {
        return state;
      }
      const ranchIdsObj = Object.values(blocksFeatures).reduce((acc, blockFeature) => {
        acc[blockFeature.properties.ranchId] = blockFeature.properties.ranchId;
        return acc;
      }, {});
      const blocksFeaturesRemaining = Object.values(state).filter(blockFeature => !ranchIdsObj[blockFeature.properties.ranchId]).reduce((acc, blockFeature) => {
        acc[blockFeature.properties.id] = cloneDeep(blockFeature);
        return acc;
      }, {});
      return {
        ...cloneDeep(blocksFeaturesRemaining),
        ...cloneDeep(blocksFeatures)
      };
    }
  }
});
blocksGeoJSON$1.actions;
var blocksgeojson$1 = blocksGeoJSON$1.reducer;
const name$c = 'ranchesgeojson';
const ranchesGeoJSON$1 = createSlice({
  name: name$c,
  initialState: {},
  reducers: {
    setRanchesGeoJSON(state, {
      payload: {
        ranchesFeatures
      }
    }) {
      if (!Object.keys(ranchesFeatures).length) {
        return state;
      }
      const ranchesFeaturesRemaining = Object.values(state).filter(ranchFeature => !ranchesFeatures[ranchFeature.properties]).reduce((acc, ranchFeature) => {
        acc[ranchFeature.properties.id] = cloneDeep(ranchFeature);
        return acc;
      }, {});
      return {
        ...cloneDeep(ranchesFeaturesRemaining),
        ...cloneDeep(ranchesFeatures)
      };
    }
  }
});
ranchesGeoJSON$1.actions;
var ranchesgeojson$1 = ranchesGeoJSON$1.reducer;
const name$b = 'soilstate';
const initialState$1 = {
  loading: false,
  currentRequestId: undefined,
  error: null,
  lastUpdated: null
};
const soilstateAdapter = createEntityAdapter();
const loadSoilState = createAsyncThunk(`${name$b}/loadList`, async () => {
  const response = await sensorApi$2.fetchSoilStatus();
  return response.data;
});

// datastructure is accessible by ranch id
const soilstateSlice = createSlice({
  name: name$b,
  initialState: soilstateAdapter.getInitialState(initialState$1),
  reducers: {},
  extraReducers: {
    [loadSoilState.pending]: (state, action) => {
      if (state.loading === false) {
        state.loading = true;
        state.error = undefined;
        state.currentRequestId = action.meta.requestId;
      }
    },
    [loadSoilState.fulfilled]: (state, action) => {
      const {
        requestId
      } = action.meta;
      if (state.loading === true && state.currentRequestId === requestId) {
        const lastUpdated = Date.now();
        state.lastUpdated = lastUpdated;
        state.loading = false;
        state.currentRequestId = undefined;
        state.error = undefined;
        if (action.payload instanceof Array) {
          const soilstateData = action.payload.reduce((acc, entity) => {
            const {
              id: entityId
            } = entity;
            entity.ranches.forEach(ranch => {
              acc.push({
                ...cloneDeep(ranch),
                entityId,
                lastUpdated
              });
            });
            return acc;
          }, []);
          soilstateAdapter.setAll(state, soilstateData);
        } else {
          soilstateAdapter.setAll(state, []);
        }
      }
    },
    [loadSoilState.rejected]: (state, action) => {
      const {
        requestId
      } = action.meta;
      if (state.loading === true && state.currentRequestId === requestId) {
        state.loading = false;
        state.error = action.error;
        state.currentRequestId = undefined;
      }
    }
  }
});
var soilstate = soilstateSlice.reducer;
const farmReducer = combineReducers({
  entities,
  ranches,
  availableEntities,
  availableRanches,
  blocks,
  plans,
  blocksgeojson: blocksgeojson$1,
  ranchesgeojson: ranchesgeojson$1,
  soilstate
});
const {
  fetchBlockSchedule: fetchBlockSchedule$2,
  fetchAllBlockSchedule: fetchAllBlockSchedule$2
} = controlApi$2;
const scheduleAdapter = createEntityAdapter();
const name$a = 'schedule';
const loadBlockSchedule = createAsyncThunk(`${name$a}/loadBlockSchedule`, loadDetail({
  getData: fetchBlockSchedule$2,
  getRequestState: (id, state) => state.controlData.schedule.entities[id]
}));
const loadAllBlockSchedule = createAsyncThunk(`${name$a}/loadAllBlockSchedule`, async blockIds => fetchAllBlockSchedule$2(blockIds));
const scheduleSlice = createSlice({
  name: name$a,
  initialState: scheduleAdapter.getInitialState(initialState$6),
  reducers: {
    cleanListRequestState(state) {
      state.loading = false;
      state.currentRequestId = undefined;
      state.error = null;
    }
  },
  extraReducers: {
    [loadBlockSchedule.pending]: requestItemById(scheduleAdapter),
    [loadBlockSchedule.fulfilled]: receiveItem(scheduleAdapter),
    [loadBlockSchedule.rejected]: requestItemByIdFailed(scheduleAdapter),
    [loadAllBlockSchedule.pending]: (state, action) => {
      if (state.loading === false) {
        state.loading = true;
        state.error = undefined;
        state.currentRequestId = action.meta.requestId;
      }
    },
    [loadAllBlockSchedule.fulfilled]: (state, action) => {
      const {
        requestId
      } = action.meta;
      if (state.loading === true && state.currentRequestId === requestId) {
        const lastUpdated = Date.now();
        state.lastUpdated = lastUpdated;
        state.loading = false;
        state.currentRequestId = undefined;
        state.error = undefined;
        if (action.payload instanceof Array) {
          scheduleAdapter.setAll(state, action.payload);
        }
      }
    },
    [loadAllBlockSchedule.rejected]: (state, action) => {
      const {
        requestId
      } = action.meta;
      if (state.loading === true && state.currentRequestId === requestId) {
        state.loading = false;
        state.error = action.error;
        state.currentRequestId = undefined;
      }
    }
  }
});
var schedule = scheduleSlice.reducer;
const controlReducer = combineReducers({
  schedule
});
const name$9 = 'selected';
const selectedSlice = createSlice({
  name: name$9,
  initialState: {
    blocks: [],
    ranches: [],
    block: [],
    ranch: [],
    entity: [],
    entitySidebarState: true,
    urlLoad: {
      payload: true
    },
    ranchBlock: {
      payload: {
        key: undefined,
        value: undefined
      }
    },
    userInfo: {
      payload: undefined
    },
    installState: 'installed',
    selectedPreset: 'soil',
    dateRange: undefined,
    graphSize: 'md',
    presetChartSelection: {}
  },
  reducers: {
    setSelectedBlock: (state, data) => {
      state.block = data;
    },
    setSelectedRanch: (state, data) => {
      state.ranch = data;
    },
    setSelectedEntity: (state, data) => {
      state.entity = data;
    },
    setSelectedBlocks: (state, data) => {
      state.blocks = data;
    },
    setSelectedRanches: (state, data) => {
      state.ranches = data;
    },
    setEntitySidebarCollapseState: (state, data) => {
      state.entitySidebarState = data;
    },
    setUrlLoad: (state, data) => {
      state.urlLoad = data;
    },
    setRanchBlock: (state, data) => {
      state.ranchBlock = data;
    },
    setLoginUserInfo: (state, data) => {
      state.userInfo = data;
    },
    setInstallState: (state, action) => {
      state.installState = action.payload;
    },
    setSelectedPreset: (state, action) => {
      state.selectedPreset = action.payload;
    },
    setGraphDateRange: (state, action) => {
      state.dateRange = action.payload;
    },
    setGraphSize: (state, action) => {
      state.graphSize = action.payload;
    },
    setPresetChartSelection: (state, action) => {
      const {
        preset,
        value
      } = action.payload;
      const selections = state.presetChartSelection;
      state.presetChartSelection = {
        ...(!Array.isArray(selections) && selections ? selections : {}),
        [preset]: value
      };
    }
  }
});
const setActions = selectedSlice.actions;
var selected = selectedSlice.reducer;
const name$8 = 'settings';
const mapPresentationModesFalse = {
  irrigationRecommendation: false,
  soilstatus: false,
  connectivity: false,
  waterpressure: false,
  control: false,
  provision: false,
  anomaly: false,
  cropHealth: false,
  plants: false
};
const settingsSlice = createSlice({
  name: name$8,
  initialState: {
    // mapPresentationModes are used to render customer devices on the field
    mapPresentationModes: {
      ...mapPresentationModesFalse,
      soilstatus: true
    },
    // There are filtered selections of data we want to show the user in Map views
    // e.g. different presentation modes for soil sensors, waterpressure sensors, gateways
    // This sets up a flag to initially show only markers determined by Presentation mode
    // When showOnlyPresentionModeSensors gets set to false all sensors are shown regardless
    // of the selected presentation mode.
    showOnlyPresentionModeSensors: true,
    mapShowLabels: false,
    mapShowSoilType: false,
    mapShowTemperature: false,
    mapShowWind: false
  },
  reducers: {
    setMapShowSoilType: (state, action) => {
      state.mapShowSoilType = action.payload;
    },
    setMapShowTemperature: (state, action) => {
      state.mapShowTemperature = action.payload;
    },
    setMapShowWind: (state, action) => {
      state.mapShowWind = action.payload;
    },
    setMapShowLabels: (state, action) => {
      state.mapShowLabels = action.payload;
    },
    setShowOnlyPresentionModeSensors: (state, action) => {
      state.showOnlyPresentionModeSensors = action.payload;
    },
    // Example payload { waterpressure: false}
    setMapPresentationModes: (state, action) => {
      state.mapPresentationModes = {
        ...mapPresentationModesFalse,
        ...action.payload
      };
    }
  }
});
const {
  setMapShowSoilType,
  setMapShowTemperature,
  setMapShowWind,
  setMapShowLabels,
  setShowOnlyPresentionModeSensors,
  setMapPresentationModes
} = settingsSlice.actions;
var settings = settingsSlice.reducer;
const clientReducer = combineReducers({
  settings,
  selected: persistReducer({
    key: 'selected',
    storage,
    blacklist: ['urlLoad']
  }, selected)
});
const name$7 = 'userSettings';
const loadUserSettings = createAsyncThunk(`${name$7}/loadUserSettings`, async (arg, {
  getState,
  requestId
}) => {
  const {
    currentRequestId,
    loading
  } = getState().settingsData.userSettings;
  if (loading !== true || requestId !== currentRequestId) {
    return null;
  }
  const response = await userApi$2.getUserSettings();
  return response.data;
});
const patchUserSettings$2 = createAsyncThunk(`${name$7}/patchUserSettings`, async (data, {
  rejectWithValue
}) => {
  try {
    const response = await userApi$2.patchUserSettings(data);
    return response.data;
  } catch (err) {
    const error = err;
    if (!error.response) {
      throw err;
    }
    return rejectWithValue(error.response.data);
  }
});
const userSettingsSlice = createSlice({
  name: name$7,
  initialState: {
    loading: false,
    error: undefined
  },
  extraReducers: builder => {
    builder.addCase(loadUserSettings.pending, (state, action) => {
      state.loading = true;
      state.error = undefined;
      state.currentRequestId = action.meta.requestId;
    });
    builder.addCase(loadUserSettings.fulfilled, (state, action) => {
      const lastUpdated = Date.now();
      state.lastUpdated = lastUpdated;
      state.loading = false;
      state.currentRequestId = undefined;
      state.error = undefined;
      state.data = action.payload;
    });
    builder.addCase(loadUserSettings.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
      state.currentRequestId = undefined;
    });
    builder.addCase(patchUserSettings$2.pending, (state, action) => {
      state.data = {
        ...state.data,
        ...action.meta.arg
      };
      state.loading = true;
    });
    builder.addCase(patchUserSettings$2.fulfilled, state => {
      state.loading = false;
    });
    builder.addCase(patchUserSettings$2.rejected, state => {
      state.loading = false;
    });
  }
});
var userSettings = userSettingsSlice.reducer;
const settingsReducer = combineReducers({
  userSettings
});

// Irrigation Recommendations
const {
  retrieveIrrigationRecommendationsForUser: retrieveIrrigationRecommendationsForUser$2,
  retrieveIrrigationRecommendationsForEntity: retrieveIrrigationRecommendationsForEntity$2,
  retrieveIrrigationRecommendationForBlock: retrieveIrrigationRecommendationForBlock$2,
  patchIrrigationRecommendation: patchIrrigationRecommendation$2
} = recommendationApi$2;
const recommendationAdapter = createEntityAdapter({
  selectId: entity => entity.block && entity.type ? `${entity.block}-${entity.type}${entity.type === 'imagery_anomaly' ? `-${entity.anomalyType}` : ''}` : `${entity.block}-ground_mission`
});
const name$6 = 'recommendation';
const loadRecommendationForBlock = createAsyncThunk(`${name$6}/loadRecommendationForBlock`, loadDetail({
  getData: id => retrieveIrrigationRecommendationForBlock$2({
    blockId: id
  }),
  getRequestState: (id, state) => state.recommendationData.recommendation.entities[id]
}));
const updateRecommendation = createAsyncThunk(`${name$6}/updateRecommendation`, async ({
  id,
  data,
  type
}) => patchIrrigationRecommendation$2({
  id,
  data,
  type
}));
const loadRecommendations = createAsyncThunk(`${name$6}/loadRecommendationsForEntity`, loadList({
  getData: entityId => retrieveIrrigationRecommendationsForEntity$2(entityId),
  getRequestState: state => state.recommendationData.recommendation
}));
const recommendationSlice = createSlice({
  name: name$6,
  initialState: recommendationAdapter.getInitialState(initialState$6),
  reducers: {
    cleanListRequestState(state) {
      state.loading = false;
      state.currentRequestId = undefined;
      state.error = null;
    }
  },
  extraReducers: {
    [loadRecommendationForBlock.pending]: (state, action) => {
      const blockId = action.meta.arg;
      recommendationAdapter.upsertOne(state, {
        block: blockId,
        loading: true,
        currentRequestId: action.meta.requestId,
        error: undefined
      });
    },
    [loadRecommendationForBlock.fulfilled]: receiveItem(recommendationAdapter),
    [loadRecommendationForBlock.rejected]: (state, action) => {
      const blockId = action.meta.arg;
      recommendationAdapter.upsertOne(state, {
        block: blockId,
        loading: false,
        error: action.error,
        currentRequestId: undefined
      });
    },
    [loadRecommendations.pending]: requestList,
    [loadRecommendations.fulfilled]: receiveList(recommendationAdapter),
    [loadRecommendations.rejected]: requestListFailed,
    [updateRecommendation.fulfilled]: receiveItemData(recommendationAdapter)
  }
});
var recommendation = recommendationSlice.reducer;
const recommendationReducer = combineReducers({
  recommendation
});
const renderedEventsAdapter = createEntityAdapter();
const name$5 = 'renderedEvents';
const loadBlockRenderedSchedule = createAsyncThunk(`${name$5}/loadBlockRenderedSchedule`, async ({
  blockId,
  dateStart,
  dateEnd
}) => {
  const response = await scheduleApi$2.retrieveBlockRenderedIrrigationEvents({
    blockId,
    dateStart,
    dateEnd
  });
  return response.data;
});

// for now, only the last time range that was requested is stored
// TODO: update to keep cache of old data

const renderedEventsSlice = createSlice({
  name: name$5,
  initialState: renderedEventsAdapter.getInitialState({}),
  reducers: [],
  extraReducers: {
    [loadBlockRenderedSchedule.pending]: (state, action) => {
      const {
        blockId
      } = action.meta.arg;
      renderedEventsAdapter.upsertOne(state, {
        id: blockId,
        loading: true,
        currentRequestId: action.meta.requestId,
        error: undefined
      });
    },
    [loadBlockRenderedSchedule.fulfilled]: (state, action) => {
      if (!action.payload) return;
      const {
        blockId
      } = action.meta.arg;
      const {
        payload: events
      } = action;
      const item = {
        id: blockId,
        loading: false,
        error: undefined,
        lastUpdated: Date.now(),
        events
      };
      renderedEventsAdapter.upsertOne(state, item);
    },
    [loadBlockRenderedSchedule.rejected]: (state, action) => {
      const {
        blockId
      } = action.meta.arg;
      renderedEventsAdapter.upsertOne(state, {
        id: blockId,
        loading: false,
        error: action.error,
        currentRequestId: undefined
      });
    }
  }
});
var renderedEvents = renderedEventsSlice.reducer;
const scheduledEventsAdapter = createEntityAdapter();
const name$4 = 'scheduledEvents';
const loadBlockIrrigationSchedule = createAsyncThunk(`${name$4}/loadBlockIrrigationSchedule`, async blockId => {
  const response = await scheduleApi$2.retrieveBlockScheduledIrrigationEvents(blockId);
  return response.data;
});
const scheduledEventsSlice = createSlice({
  name: name$4,
  initialState: scheduledEventsAdapter.getInitialState({}),
  reducers: [],
  extraReducers: {
    [loadBlockIrrigationSchedule.pending]: (state, action) => {
      const blockId = action.meta.arg;
      scheduledEventsAdapter.upsertOne(state, {
        id: blockId,
        loading: true,
        currentRequestId: action.meta.requestId,
        error: undefined
      });
    },
    [loadBlockIrrigationSchedule.fulfilled]: (state, action) => {
      if (!action.payload) return;
      const blockId = action.meta.arg;
      const item = {
        id: blockId,
        loading: false,
        error: undefined,
        lastUpdated: Date.now(),
        events: action.payload
      };
      scheduledEventsAdapter.upsertOne(state, item);
    },
    [loadBlockIrrigationSchedule.rejected]: (state, action) => {
      const blockId = action.meta.arg;
      scheduledEventsAdapter.upsertOne(state, {
        id: blockId,
        loading: false,
        error: action.error,
        currentRequestId: undefined
      });
    }
  }
});
var scheduledEvents = scheduledEventsSlice.reducer;
const scheduleReducer = combineReducers({
  renderedEvents,
  scheduledEvents
});
const name$3 = 'anomaly';
const anomalyAdapter = createEntityAdapter();
const loadAnomaliesForBlock = createAsyncThunk(`${name$3}/loadAnomaliesForBlock`, async blockIds => {
  const responses = blockIds.map(blockId => blockApi$2.getBlockAnomaly(blockId));
  return Promise.allSettled(responses);
});
const anomalySlice = createSlice({
  name: name$3,
  initialState: anomalyAdapter.getInitialState(initialState$6),
  reducers: {
    cleanListRequestState(state) {
      state.loading = false;
      state.currentRequestId = undefined;
      state.error = null;
    }
  },
  extraReducers: {
    [loadAnomaliesForBlock.pending]: requestList,
    [loadAnomaliesForBlock.fulfilled]: (state, action) => {
      const {
        payload: items
      } = action;
      const anomalies = [];
      items.forEach(item => {
        if (item && item.value && item.value.data && item.value.data.length) {
          anomalies.push(...(item && item.value && item.value.data));
        }
      });
      anomalyAdapter.setAll(state, anomalies);
    },
    [loadAnomaliesForBlock.rejected]: requestListFailed
  }
});
var anomalies = anomalySlice.reducer;
const anomalyReducer = combineReducers({
  anomalies
});
const name$2 = 'coordination';
const coordinationAdapter = createEntityAdapter({
  selectId: state => state.block_id
});
const loadCoordinationList = createAsyncThunk(`${name$2}/loadList`, async () => {
  const res = await coordinationApi$2.fetchSensorCoordinations();
  return res.data;
});
const coordinationSlice = createSlice({
  name: name$2,
  initialState: coordinationAdapter.getInitialState(initialState$6),
  reducers: {
    cleanListRequestState(state) {
      state.loading = false;
      state.currentRequestId = undefined;
      state.error = null;
    },
    updateConfigField(state, action) {
      const {
        blockId,
        configType,
        field
      } = action.payload;
      const block = state.entities[blockId];
      if (block && block.configs[configType]) {
        // Create a new configuration where only the specified field
        // is true and all others are false
        const updatedConfig = Object.fromEntries(Object.keys(block.configs[configType]).map(key => [key, key === field]));
        // Update the block's configuration
        block.configs[configType] = cloneDeep(updatedConfig);
      }
    }
  },
  extraReducers: {
    [loadCoordinationList.pending]: requestList,
    [loadCoordinationList.fulfilled]: receiveList(coordinationAdapter),
    [loadCoordinationList.rejected]: requestListFailed
  }
});
const {
  cleanListRequestState: cleanListRequestState$1,
  updateConfigField
} = coordinationSlice.actions;
var coordination = coordinationSlice.reducer;
const coordinationReducer = combineReducers({
  coordination
});

// Took it as it is from /farm/ranches-geojson.js
const name$1 = 'ranchesgeojson';
const ranchesGeoJSON = createSlice({
  name: name$1,
  initialState: {},
  reducers: {
    setRanchesGeoJSON(state, {
      payload: {
        ranchesFeatures
      }
    }) {
      if (!Object.keys(ranchesFeatures).length) {
        return state;
      }
      const ranchesFeaturesRemaining = Object.values(state).filter(ranchFeature => !ranchesFeatures[ranchFeature.properties]).reduce((acc, ranchFeature) => {
        acc[ranchFeature.properties.id] = cloneDeep(ranchFeature);
        return acc;
      }, {});
      return {
        ...cloneDeep(ranchesFeaturesRemaining),
        ...cloneDeep(ranchesFeatures)
      };
    }
  }
});
const {
  setRanchesGeoJSON
} = ranchesGeoJSON.actions;
var ranchesgeojson = ranchesGeoJSON.reducer;

// Took it as it is from /farm/blocks-geojson.js
const name = 'blocksgeojson';
const blocksGeoJSON = createSlice({
  name,
  initialState: {},
  reducers: {
    setBlocksGeoJSON(state, {
      payload: {
        blocksFeatures
      }
    }) {
      if (!Object.keys(blocksFeatures).length) {
        return state;
      }
      const ranchIdsObj = Object.values(blocksFeatures).reduce((acc, blockFeature) => {
        acc[blockFeature.properties.ranchId] = blockFeature.properties.ranchId;
        return acc;
      }, {});
      const blocksFeaturesRemaining = Object.values(state).filter(blockFeature => !ranchIdsObj[blockFeature.properties.ranchId]).reduce((acc, blockFeature) => {
        acc[blockFeature.properties.id] = cloneDeep(blockFeature);
        return acc;
      }, {});
      return {
        ...cloneDeep(blocksFeaturesRemaining),
        ...cloneDeep(blocksFeatures)
      };
    }
  }
});
const {
  setBlocksGeoJSON
} = blocksGeoJSON.actions;
var blocksgeojson = blocksGeoJSON.reducer;
const newFarmReducer = combineReducers({
  entities: entities$2,
  ranches: ranches$2,
  blocks: blocks$2,
  ranchesgeojson,
  blocksgeojson
});

// If you want to delete the persisted localstorage state on user
// browsers just increment this storeVersion number and commit
const storeVersion = 0;
const appReducer = combineReducers({
  farm: newFarmReducer,
  sensorsData,
  farmData: farmReducer,
  controlData: controlReducer,
  settingsData: settingsReducer,
  recommendationData: recommendationReducer,
  scheduleData: scheduleReducer,
  clientData: persistReducer({
    key: 'clientData',
    storage,
    blacklist: ['selected']
  }, clientReducer),
  anomalyData: anomalyReducer,
  coordinationData: coordinationReducer,
  version: persistReducer({
    key: 'version',
    storage
  }, (state = {
    val: storeVersion
  }) => state)
});

// This logic will check storeVersion value set in this file
// and the one in persisted store and deletes persisted data
// if mismatch
if (localStorage.getItem('persist:version')) {
  const version = JSON.parse(localStorage.getItem('persist:version'));
  if (version.val !== String(storeVersion)) {
    localStorage.removeItem('persist:version');
    localStorage.removeItem('persist:root');
  }
}
const initialState$7 = {};
function rootReducer(state = initialState$7, action) {
  let appState = state;
  if (action.type === 'RESET') {
    // for all keys defined in your persistConfig(s)
    storage.removeItem('persist:root');
    storage.removeItem('persist:selected');
    appState = undefined;
    localStorage.removeItem('sensorsByRanchesObj');
  } else if (action.type === 'persist/REHYDRATE') ;
  return appReducer(appState, action);
}
const transform = createTransform(
// transform state on its way to being serialized and persisted.
inboundState => inboundState,
// transform state being rehydrated
outboundState => {
  outboundState.stats.sensor.loading = false;
  outboundState.stats.gateway.loading = false;
  outboundState.stats.cavalier.loading = false;
  return {
    ...outboundState
  };
},
// define which reducers this transform gets called for.
{
  whitelist: ['sensorsData']
});
const farmDataTransform = createTransform(
// transform state on its way to being serialized and persisted.
inboundState => inboundState,
// transform state being rehydrated
outboundState => {
  outboundState.blocks.loading = false;
  outboundState.ranches.loading = false;
  outboundState.entities.loading = false;
  return {
    ...outboundState
  };
},
// define which reducers this transform gets called for.
{
  whitelist: ['farmData']
});
const persistConfig = {
  key: 'root',
  storage: localforage,
  blacklist: ['clientData'],
  transforms: [transform, farmDataTransform]
};
const persistedReducer = persistReducer(persistConfig, rootReducer);
const store = configureStore({
  reducer: persistedReducer,
  // https://redux-toolkit.js.org/api/getDefaultMiddleware#customizing-the-included-middleware
  // map page becomes unresponsive to develop without excluding those two
  middleware: getDefaultMiddleware({
    serializableCheck: false,
    immutableCheck: false
  })
});
persistStore(store);
const loadSensorErrors = loadCavalierStatsSingle;
var sensorActions = /*#__PURE__*/Object.freeze({
  __proto__: null,
  loadAllSensors: loadAllSensors$1,
  loadSensorsRanch: loadSensorsRanch$2,
  loadSensorDetail: loadSensorDetail$2,
  loadSensorDetailById: loadSensorDetailById$2,
  loadPaginatedSensorsRanch: loadPaginatedSensorsRanch,
  loadSensorsForEntity: loadSensorsForEntity,
  updateSensorLocation: updateSensorLocation$2,
  createSensor: createSensor$2,
  installSensor: installSensor$2,
  uninstallSensor: uninstallSensor$2,
  removeSensor: removeSensor$2,
  replaceSensor: replaceSensor$2,
  copySensorMetadataToCav: copySensorMetadataToCav,
  copySensorMetadataFromCav: copySensorMetadataFromCav,
  cleanSensorsFetchState: cleanSensorsFetchState,
  loadSensorCapabilities: loadSensorCapabilities$2,
  loadSensorStatus: loadSensorStatus$6,
  addItems: addItems,
  copySoilSensorProperties: copySoilSensorProperties$2,
  setSensorMoistureData: setSensorMoistureData$2,
  rebootMilesightNode: rebootMilesightNode$2,
  loadSensorStatsList: loadSensorStatsList,
  loadSensorStatsSingle: loadSensorStatsSingle,
  loadCavalierStatsList: loadCavalierStatsList,
  loadCavalierStatsSingle: loadCavalierStatsSingle,
  loadGatewayStatsList: loadGatewayStatsList,
  loadGatewayStatsSingle: loadGatewayStatsSingle,
  loadSensorErrors: loadSensorErrors,
  loadSensorNotesList: loadSensorNotesList,
  loadSensorImagesList: loadSensorImagesList,
  setSensorsStateForGeoJSON: setSensorsStateForGeoJSON,
  loadBlockStatsList: loadBlockStatsList,
  loadBlockStatsSingle: loadBlockStatsSingle,
  loadRanchStatsList: loadRanchStatsList,
  loadRanchStatsSingle: loadRanchStatsSingle
});
const selectEntitiesState = state => state.farmData.entities;
const selectRanchesState = state => state.farmData.ranches;
const selectBlocksState = state => state.farmData.blocks;
const selectPlansState = state => state.farmData.plans;
const selectAvailableRanches = state => state.farmData.availableRanches;
const selectAvailableEntities = state => state.farmData.availableEntities;
const entitySelectors = farmAdapter.getSelectors(selectEntitiesState);
const ranchSelectors = farmAdapter.getSelectors(selectRanchesState);
const blockSelectors = farmAdapter.getSelectors(selectBlocksState);
const plansSelectors = plansAdapter.getSelectors(selectPlansState);
const availableRanchSelectors = farmAdapter.getSelectors(selectAvailableRanches);
const availableEntitySelectors = farmAdapter.getSelectors(selectAvailableEntities);

// select Entity for admin
const selectAvailableEntityById = availableEntitySelectors.selectById;

// Select All Ranches for admin
const selectAllAvailableRanches = state => availableRanchSelectors.selectAll(state).map(ranch => populateAvailableRanch(state, ranch));
const populateAvailableRanch = (state, ranch) => ranch && {
  ...ranch,
  entity: selectAvailableEntityById(state, ranch.entity)
};

// Entity Selectors
const selectEntityById = entitySelectors.selectById;
const selectAllEntities$1 = entitySelectors.selectAll;
const selectActiveEntity = state => {
  const selectedEntityId = state.farmData.entities.selectedEntityId;
  return selectedEntityId;
};

// Ranch Selectors
const populateRanch = (state, ranch) => ranch && {
  ...ranch,
  entity: selectEntityById(state, ranch.entity)
};
const selectRanchById = (state, id) => {
  const ranch = ranchSelectors.selectById(state, id);
  return populateRanch(state, ranch);
};
const selectRanchesForEntityId = (state, entityId) => ranchSelectors.selectAll(state).filter(ranch => ranch.entity === entityId).map(ranch => populateRanch(state, ranch));
const selectAllRanches$1 = state => ranchSelectors.selectAll(state).map(ranch => populateRanch(state, ranch));
const sortByName$2 = (a, b) => {
  if (a.name > b.name) {
    return 1;
  }
  if (a.name < b.name) {
    return -1;
  }
  return 0;
};
const selectAllRanchesAlphabetically = createSelector(selectAllRanches$1, ranches => ranches.sort(sortByName$2));

// Block Selectors
const populateBlock = (state, block) => block && {
  ...block,
  ranch: selectRanchById(state, block.ranch)
};
const selectBlockById = blockSelectors.selectById;
const selectAllBlocks$1 = state => blockSelectors.selectAll(state).map(block => populateBlock(state, block));
const selectBlocksForRanchId = (state, ranchId) => blockSelectors.selectAll(state).filter(block => block.ranch === ranchId).map(block => populateBlock(state, block));
const selectBlocksForRanchIdAlphabetically = createSelector(selectBlocksForRanchId, blocks => blocks.sort(sortByName$2));
const selectIsAutoScheduled = createSelector(selectAllBlocks$1, blocks => blocks.every(item => item.auto_schedule));

// Loading state selectors
const selectEntitiesLoadingState = state => selectLoadingState(selectEntitiesState(state));
const selectRanchesLoadingState = state => selectLoadingState(selectRanchesState(state));
const selectBlocksLoadingState = state => selectLoadingState(selectBlocksState(state));
const selectAvailableRanchesLoadingState = state => selectLoadingState(selectAvailableRanches(state));
const selectAvailableEntitiesLoadingState = state => selectLoadingState(selectAvailableEntities(state));
const selectFarmDataLoadingState = state => {
  const entitiesLoadingState = selectEntitiesLoadingState(state);
  const ranchesLoadingState = selectRanchesLoadingState(state);
  const blocksLoadingState = selectBlocksLoadingState(state);
  const availableRanchesLoadingState = selectAvailableRanchesLoadingState(state);
  const availableEntitiesLoadingState = selectAvailableEntitiesLoadingState(state);
  const loading = entitiesLoadingState.loading || ranchesLoadingState.loading || blocksLoadingState.loading;
  return {
    loading,
    entitiesLoadingState,
    ranchesLoadingState,
    blocksLoadingState,
    availableEntitiesLoadingState,
    availableRanchesLoadingState
  };
};

// TODO: Shifted to newFarm selectors
// const selectBlockPressureSensors = (state, blockId) => populateSensorStatus(
//   state,
//   selectSensorsForIrrigationBlockId(state, blockId, 'water_pressure', 'installed'),
// );

// const selectBlockPumpController = (state, blockId) => {
//   const block = selectBlockById(state, blockId);
//   const vfdObj = block && block.vfd;
//   if (vfdObj) {
//     const sensor = selectSensorByParams(state, vfdObj);
//     return {
//       ...sensor,
//       status: selectSensorStatus(state, sensor.type, sensor.identifier),
//     };
//   }
//   return {};
// };

// /**
//  * TODO: Given incorrect parameters, it can result into unexpected output: { undefined: {} }
//  */
// const selectBlockPumpControllers = (state, blockId) => {
//   const block = selectBlockById(state, blockId);
//   const vfd = (block && block.vfd);
//   const vfds = (block && block.vfds) || [vfd] || [];
//   const pumpControllers = vfds.map((vfdObj) => {
//     if (vfdObj) {
//       const sensor = selectSensorByParams(state, vfdObj);
//       return {
//         ...sensor,
//         blockId,
//         blockName: block.name,
//         status: selectSensorStatus(state, sensor.type, sensor.identifier),
//       };
//     }
//     return {};
//   }).reduce((acc, obj) => {
//     acc[obj.identifier] = obj;
//     return acc;
//   }, []);
//   return pumpControllers;
// };

// /**
//  * Select pump controller data for multiple blocks
//  * @param {*} state
//  * @param {Array} blockIds
//  * @param {boolean} returnAsArray
//  */
// const selectPumpControllersForBlockIds = (state, blockIds = [], returnAsArray = false) => {
//   const pumpControllers = blockIds.reduce((acc, curr) => ({
//     ...acc,
//     ...selectBlockPumpControllers(state, curr),
//   }), {});
//   if (returnAsArray) {
//     return Object.keys(pumpControllers).map((pumpController) => pumpControllers[pumpController]);
//   }
//   return pumpControllers;
// };

// const selectBlockValveController = (state, blockIds) => {
//   if (blockIds && blockIds.length) {
//     const valveControllerData = blockIds.map((blockId) => {
//       const block = selectBlockById(state, blockId);
//       const valveObj = block && block.valve;
//       if (valveObj) {
//         const sensor = selectSensorByParams(state, valveObj);
//         return {
//           ...sensor,
//           blockId,
//           status: selectSensorStatus(state, sensor.type, sensor.identifier),
//         };
//       }
//       return {};
//     }).reduce((acc, obj) => {
//       acc[obj.blockId] = obj;
//       return acc;
//     }, {});
//     return valveControllerData;
//   }
//   return {};
// };

// const selectBlockValveControllers = (state, blockId) => {
//   const block = selectBlockById(state, blockId);
//   const vIdentifiers = block && block.valve;
//   const valves = (block && block.valves) || [];
//   let valveDataForRanch = [];
//   const valveIdentifiers = selectSensorsForRanchId(state, block && block.ranch, 'valve')
//     .filter((d) => d && valves.includes(d.id))
//     .map((d) => ({ type: d.type, identifier: d.identifier }));
//   if (valveIdentifiers.length) {
//     valveDataForRanch = valveIdentifiers;
//   } else valveDataForRanch = [vIdentifiers];
//   const valveControllers = valveDataForRanch.map((valveObj) => {
//     let sensor;
//     if (valveObj) sensor = selectSensorByParams(state, valveObj);
//     else {
//       const sensors = selectSensorsForBlockId(state, blockId, 'valve', 'installed');
//       sensor = sensors.length && sensors[0];
//     }
//     return {
//       ...sensor,
//       blockId,
//       status: selectSensorStatus(state, sensor.type, sensor.identifier),
//     };
//   }).reduce((acc, obj) => {
//     acc[obj.identifier] = obj;
//     return acc;
//   }, []);
//   return valveControllers;
// };

// const selectValveControllersForBlocks = (state, blockIds) => {
//   if (blockIds && blockIds.length) {
//     const valveControllerDataArr = [];
//     blockIds.forEach((blockId) => {
//       const block = selectBlockById(state, blockId);
//       const vIdentifiers = block && block.valve;
//       const valves = (block && block.valves) || [];
//       let valveDataForRanch = [];
//       const valveIdentifiers = selectSensorsForRanchId(state, block && block.ranch, 'valve')
//         .filter((d) => d && valves.includes(d.id))
//         .map((d) => ({ type: d.type, identifier: d.identifier }));
//       if (valveIdentifiers.length) {
//         valveDataForRanch = valveIdentifiers;
//       } else valveDataForRanch = [vIdentifiers];
//       const valveControllers = valveDataForRanch.map((valveObj) => {
//         if (valveObj) {
//           const sensor = selectSensorByParams(state, valveObj);
//           return {
//             ...sensor,
//             blockId,
//             status: selectSensorStatus(state, sensor.type, sensor.identifier),
//           };
//         }
//         return {};
//       });
//       valveControllerDataArr.push(...valveControllers);
//     });
//     const uniqueValveControllerArr = valveControllerDataArr
//       .filter((value, index, self) => self.findIndex((v) => v.id === value.id) === index);
//     const valveControllerData = {};
//     uniqueValveControllerArr.forEach((obj) => {
//       if (valveControllerData[obj.blockId]) {
//         valveControllerData[obj.blockId].push(obj);
//       } else {
//         valveControllerData[obj.blockId] = [obj];
//       }
//     });
//     return valveControllerData;
//   }
//   return {};
// };

// const selectBlockFlowMeter = (state, blockId) => {
//   const block = selectBlockById(state, blockId);
//   const flowMeters = selectSensorsForRanchId(state, block && block.ranch, 'water_flow_analog', 'installed');
//   return flowMeters && flowMeters.length && populateSensorStatus(state, flowMeters)[0];
// };

// const selectPumpControllerIrrigationBlocks = (state, vfd) => selectAllBlocks(state).filter(
//   (block) => {
//     if (!block.vfd) return false;
//     if (block.vfd.identifier !== vfd.identifier) return false;
//     return block.vfd.type === vfd.type;
//   },
// );

// // select block valve status
// const selectBlockSensorStatus = (state, blocks) => blocks.map((block) => {
//   let vid = null;
//   if (block.valve) {
//     vid = block.valve.identifier;
//   }
//   const valveState = selectSensorStatus(state, 'valve', vid);
//   let online;
//   let loading;
//   if (valveState) {
//     online = valveState.online;
//     loading = valveState.loading;
//   }

//   let currState;
//   let valveScheduledOpen;
//   let valveScheduledClose;
//   if (valveState && valveState.controlStatus) {
//     currState = valveState.controlStatus.state;
//   }

//   if (valveState && valveState.scheduleStatus) {
//     valveScheduledOpen = valveState.scheduleStatus.dateScheduledOpen;
//     valveScheduledClose = valveState.scheduleStatus.dateScheduledClose;
//   }

//   let ovrdStatus = null;
//   if (valveState && valveState.overrideStatus) {
//     ovrdStatus = valveState.overrideStatus;
//   }

//   let pid = null;
//   if (block.vfd) {
//     pid = block.vfd.identifier;
//   }
//   const pumpState = selectSensorStatus(state, 'vfd', pid);

//   let pumpCurrState;
//   let pumpStart;
//   let pumpStop;
//   if (pumpState && pumpState.scheduleStatus) {
//     pumpStart = pumpState.scheduleStatus.dateScheduledStart;
//     pumpStop = pumpState.scheduleStatus.dateScheduledStop;
//   }
//   if (pumpState && pumpState.controlStatus) {
//     pumpCurrState = pumpState.controlStatus.status;
//   }

//   return {
//     blockId: block.id,
//     blockName: block.name,
//     valveIdentifier: vid,
//     valveOnline: online,
//     valveCurrentState: currState,
//     valveOverrideStatus: ovrdStatus,
//     valveControlEnabled: block.control_enabled,
//     valveScheduledOpen,
//     valveScheduledClose,
//     vfdIdentifier: pid,
//     pumpStartDate: pumpStart,
//     pumpStopDate: pumpStop,
//     valveLoading: loading,
//     valveAlarmCount: valveState && valveState.alarmCount,
//     blockAlarmCount: valveState && valveState.blockAlarmCount,
//     pumpCurrentState: pumpCurrState,
//   };
// });

// // select block valve status
// const selectPumpSensorStatus = (state, pumps) => pumps.map((pump) => {
//   let pid = null;
//   if (pump.identifier) {
//     pid = pump.identifier;
//   }
//   const pumpState = selectSensorStatus(state, 'vfd', pid);
//   let online;
//   let loading;
//   if (pumpState) {
//     online = pumpState.online;
//     loading = pumpState.loading;
//   }
//   let currState;
//   let datePumpStart;
//   let datePumpStop;
//   if (pumpState && pumpState.controlStatus) {
//     currState = pumpState.controlStatus.status;
//   }

//   if (pumpState && pumpState.scheduleStatus) {
//     datePumpStart = pumpState.scheduleStatus.dateScheduledStart;
//     datePumpStop = pumpState.scheduleStatus.dateScheduledStop;
//   }

//   let ovrdStatus = null;
//   if (pumpState && pumpState.overrideStatus) {
//     ovrdStatus = pumpState.overrideStatus;
//   }

//   return {
//     pumpId: pump.id,
//     pumpName: pump.name,
//     pumpIdentifier: pid,
//     pumpCurrentState: currState,
//     pumpOverrideStatus: ovrdStatus,
//     pumpStartDate: datePumpStart,
//     pumpStopDate: datePumpStop,
//     pumpOnline: online,
//     pumpLoading: loading,
//     alarmCount: pumpState && pumpState.alarmCount,
//   };
// });

// // Returns a map of blockId to blockAlarmCount given an array of blockIds
// // TODO: Update it as per new block reducers
// const selectBlockControlStatus = (state, blockIds) => blockIds.reduce((a, blockId) => {
//   const block = selectBlockById(state, blockId);
//   const valves = (block && block.valves) || [];
//   let valveIdentifier = block && block.valve && block.valve.identifier;
//   if (!valveIdentifier && valves.length) {
//     valveIdentifier = selectSensorsForRanchId(state, block && block.ranch, 'valve')
//       .filter((d) => d && valves.includes(d.id))
//       .map((d) => d.identifier);
//   }
//   const valveStatus = selectSensorStatus(state, 'valve', valveIdentifier);
//   let vfdIdentifier = block && block.vfd && block.vfd.identifier;
//   if (!vfdIdentifier && (block && block.vfds)) {
//     vfdIdentifier = block && block.vfds && block.vfds[0] && block.vfds[0].identifier;
//   }
//   const vfdStatus = selectSensorStatus(state, 'vfd', vfdIdentifier);
//   a[blockId] = {
//     valveStatus,
//     vfdStatus,
//   };
//   return a;
// }, {});

// // TODO: Update as per new block reducer
// const selectBlockControlStatusLoading = (state, blockIds) => blockIds.reduce((a, blockId) => {
//   const block = selectBlockById(state, blockId);
//   const valveIdentifier = block && block.valve && block.valve.identifier;
//   const valveStatus = selectSensorStatus(state, 'valve', valveIdentifier);
//   const vfdIdentifier = block && block.vfd && block.vfd.identifier;
//   const vfdStatus = selectSensorStatus(state, 'vfd', vfdIdentifier);
//   return a || (valveStatus && valveStatus.loading) || (vfdStatus && vfdStatus.loading);
// }, false);

// // TODO: Update as per new block reducer
// const selectBlocksForRanchBlockSelection = (state, selectedObj) => {
//   let blocks = [];
//   const { type, value } = selectedObj || {};
//   if (type && type === 'ranch') {
//     blocks = selectBlocksForRanchId(state, Number(value));
//   } else if (type && type === 'block') {
//     const blockObj = selectBlockById(state, Number(value));
//     blocks = blockObj && [blockObj];
//   } else {
//     blocks = selectAllBlocks(state);
//   }

//   return blocks && blocks.sort((a, b) => a && b && a.name.localeCompare(b.name));
// };

// // returns array of ranches
// const selectRanchesForRanchBlockSelection = (state, selectedObj) => {
//   const { type, value } = selectedObj || {};
//   if (type && type === 'ranch') {
//     return [selectRanchById(state, Number(value))];
//   }
//   if (type && type === 'block') {
//     const block = selectBlockById(state, Number(value));
//     if (!block || !block.ranch) return [];
//     const ranch = selectRanchById(state, block.ranch);
//     return ranch ? [ranch] : [];
//   }

//   return selectAllRanches(state);
// };

// const selectPressureDetails = (state, blockId) => {
//   let pressure = 0;
//   let sensorList = [];
//   let loading = false;
//   const pressureSensorsList = [];
//   let identifiers = [];
//   const pressureCutoff = [];
//   const pressureSensors = selectBlockPressureSensors(state, blockId);

//   if (pressureSensors && pressureSensors.length) {
//     pressureSensors.forEach((d) => {
//       const statusObj = d && d.status;
//       if (statusObj) {
//         const psi = (Number(statusObj.waterPressure || 0));
//         pressure += psi > 0 ? Math.abs(psi) : 0;
//         pressureCutoff.push(statusObj.pressureCutoff);
//       }
//       pressureSensorsList.push({
//         type: 'water_pressure',
//         identifier: d && d.identifier,
//         sensorId: d && d.id,
//         alarmCount: statusObj && statusObj.alarmCount,
//         lastUpdated: statusObj && statusObj.lastUpdated,
//         name: d && d.name,
//         sensorOnline: statusObj && statusObj.online,
//         pressure: `${statusObj && statusObj.waterPressure > 0 ? (statusObj && statusObj.waterPressure).toFixed(2) : 0} psi`,
//       });
//     });

//     loading = pressureSensors.reduce((a, p) => !p || a || (p.status && p.status.loading), false);
//     pressure = pressure > 0 ? (pressure / pressureSensors.length).toFixed(2) : 0;
//     sensorList = pressureSensors.map((d) => d && d.name);
//     identifiers = pressureSensors.map((d) => d && d.identifier);
//   }

//   return {
//     pressure: String(pressure),
//     sensorList,
//     pressureLoading: loading,
//     pressureSensorsList,
//     pressureSensorIdentifiers: JSON.stringify(identifiers),
//     pressureCutoff,
//   };
// };

const selectEntityIdForRanchBlock = (state, ranchId, blockId) => {
  let entityId = [];
  if (ranchId) {
    const ranchObj = selectRanchById(state, ranchId);
    if (ranchObj) {
      entityId = [ranchObj].map(ranch => ranch && ranch.entity && ranch.entity.id);
    }
  }
  if (blockId) {
    const block = selectBlockById(state, blockId);
    const ranchObj = selectRanchById(state, block && block.ranch);
    if (ranchObj) {
      entityId = [ranchObj].map(ranch => ranch && ranch.entity && ranch.entity.id);
    }
  }
  return entityId;
};
const selectAllBlockIds = state => blockSelectors.selectIds(state, []);
const selectAllRanchIds = state => ranchSelectors.selectIds(state, []);
const selectBlockCount = state => blockSelectors.selectIds(state, []).length;
const selectBlocksLoaded = state => {
  const blockCount = blockSelectors.selectIds(state, []).length;
  if (blockCount) return true;
  return false;
};
var farmSelectors = /*#__PURE__*/Object.freeze({
  __proto__: null,
  selectFarmDataLoadingState: selectFarmDataLoadingState,
  selectEntitiesLoadingState: selectEntitiesLoadingState,
  selectEntityById: selectEntityById,
  selectAllEntities: selectAllEntities$1,
  selectActiveEntity: selectActiveEntity,
  selectRanchesLoadingState: selectRanchesLoadingState,
  selectRanchById: selectRanchById,
  selectRanchesForEntityId: selectRanchesForEntityId,
  selectAllRanches: selectAllRanches$1,
  selectAllRanchesAlphabetically: selectAllRanchesAlphabetically,
  selectBlocksLoadingState: selectBlocksLoadingState,
  selectBlockById: selectBlockById,
  selectAllBlocks: selectAllBlocks$1,
  selectBlocksForRanchId: selectBlocksForRanchId,
  selectBlocksForRanchIdAlphabetically: selectBlocksForRanchIdAlphabetically,
  ranchSelectors: ranchSelectors,
  entitySelectors: entitySelectors,
  plansSelectors: plansSelectors,
  selectEntityIdForRanchBlock: selectEntityIdForRanchBlock,
  selectAllBlockIds: selectAllBlockIds,
  selectAllRanchIds: selectAllRanchIds,
  selectBlockCount: selectBlockCount,
  selectBlocksLoaded: selectBlocksLoaded,
  selectIsAutoScheduled: selectIsAutoScheduled,
  selectAllAvailableRanches: selectAllAvailableRanches
});
const {
  setSelectedEntity,
  setSelectedBlock,
  setSelectedRanch,
  setSelectedBlocks,
  setSelectedRanches,
  setEntitySidebarCollapseState,
  setUrlLoad: setUrlLoad$1,
  setRanchBlock,
  setLoginUserInfo,
  setInstallState,
  setSelectedPreset,
  setGraphDateRange,
  setGraphSize,
  setPresetChartSelection
} = setActions;
const setEntity = entityId => dispatch => {
  if (entityId) dispatch(setSelectedEntity([Number(entityId)] || []));
};
const setRanches = ranchId => dispatch => {
  const {
    ranches
  } = store.getState().clientData.selected; // Get ranches from selected reducer
  if (ranches.payload && ranches.payload.indexOf(String(ranchId)) === -1) {
    let selectedRanches = ranches.payload;
    // If array add in the existing array or create new array with ranch id (string)
    if (selectedRanches.length) {
      selectedRanches = selectedRanches.concat(String(ranchId));
    } else {
      selectedRanches = [String(ranchId)];
    }
    dispatch(setSelectedRanches(selectedRanches));
  } else if (ranches && !ranches.payload && !ranches.length) {
    dispatch(setSelectedRanches([String(ranchId)]));
  }
};
const setBlocks = blockIds => dispatch => {
  if (blockIds) {
    const stateObject = store.getState().farm.blocks; // blocks state from store
    const blocks = Object.values(stateObject.entities); // blocks array
    let ranchIdForBlockId = [];
    if (blocks.length) {
      ranchIdForBlockId = blocks.filter(e => blockIds.indexOf(e.id) > -1).map(e => e.ranch).filter((v, i, a) => a.indexOf(v) === i);
    }
    if (blockIds && blockIds.length === 1) {
      dispatch(setSelectedBlock(blockIds));
      dispatch(setSelectedBlocks(blockIds));
      if (ranchIdForBlockId[0]) {
        const {
          ranch
        } = store.getState().clientData.selected;
        if (ranch.payload && ranch.payload.indexOf(ranchIdForBlockId[0]) === -1) {
          dispatch(setSelectedRanch(ranchIdForBlockId));
        } else if (ranch && !ranch.length) {
          dispatch(setSelectedRanch(ranchIdForBlockId));
        }
      }
    } else if (blockIds && blockIds.length > 1) {
      dispatch(setSelectedBlock([]));
      dispatch(setSelectedBlocks(blockIds));
      if (ranchIdForBlockId.length > 1) {
        dispatch(setSelectedRanch([]));
      } else dispatch(setSelectedRanch(ranchIdForBlockId));
    } else {
      dispatch(setSelectedRanch([]));
      dispatch(setSelectedBlock([]));
      dispatch(setSelectedBlocks([]));
    }
  }
};
const setRanch = ranchId => dispatch => {
  if (ranchId) {
    dispatch(setSelectedRanch([ranchId]));
    dispatch(setSelectedBlock([]));
    const stateObject = store.getState().farm.blocks;
    const blocks = Object.values(stateObject.entities);
    if (blocks.length) {
      const blockIdsForRanchId = blocks.filter(e => e.ranch === ranchId).map(e => e.id);
      dispatch(setSelectedBlocks(blockIdsForRanchId));
    }
  } else {
    dispatch(setSelectedRanch([]));
    dispatch(setSelectedBlock([]));
    dispatch(setSelectedBlocks([]));
  }
};
const setEntityMobile = entityId => dispatch => {
  dispatch(setSelectedEntity([entityId]));
  dispatch(setSelectedRanch([]));
  dispatch(setSelectedBlock([]));
};
const setRanchMobile = ranchId => dispatch => {
  if (ranchId) {
    dispatch(setSelectedRanch([ranchId]));
    dispatch(setSelectedBlock([]));
  } else {
    dispatch(setSelectedRanch([]));
  }
};
const setBlockMobile = blockIds => dispatch => {
  if (blockIds) {
    dispatch(setSelectedBlock(blockIds));
    dispatch(setSelectedRanch([]));
  } else {
    dispatch(setSelectedBlock([]));
  }
};
const setRanchBlockSelection = (obj, tracking) => dispatch => {
  if (obj && obj.value !== undefined) {
    if (obj.type === 'ranch') {
      dispatch(setRanchMobile(Number(obj.value)));
      if (tracking) tracking.track('Selected Ranch', {
        ranchId: obj.value
      });
    }
    if (obj.type === 'block') {
      dispatch(setBlockMobile([Number(obj.value)]));
      if (tracking) tracking.track('Selected Block', {
        blockId: obj.value
      });
    }
    if (obj.type === 'entity') {
      dispatch(setEntityMobile(Number(obj.value)));
      if (tracking) tracking.track('Selected Entity', {
        entityId: obj.value
      });
    }
    if (!obj.value || obj.value === 'All Ranches') {
      dispatch(setRanchMobile());
      dispatch(setBlockMobile([]));
      if (tracking) tracking.track('Selected All Ranches');
    }
  }
};
var webActions = /*#__PURE__*/Object.freeze({
  __proto__: null,
  setSelectedBlock: setSelectedBlock,
  setSelectedRanch: setSelectedRanch,
  setSelectedBlocks: setSelectedBlocks,
  setSelectedRanches: setSelectedRanches,
  setMapShowSoilType: setMapShowSoilType,
  setMapShowTemperature: setMapShowTemperature,
  setMapShowWind: setMapShowWind,
  setMapShowLabels: setMapShowLabels,
  setShowOnlyPresentionModeSensors: setShowOnlyPresentionModeSensors,
  setMapPresentationModes: setMapPresentationModes,
  setUrlLoad: setUrlLoad$1,
  setEntitySidebarCollapseState: setEntitySidebarCollapseState,
  setBlocks: setBlocks,
  setRanch: setRanch,
  setRanches: setRanches,
  setEntity: setEntity,
  setRanchBlock: setRanchBlock,
  setBlockMobile: setBlockMobile,
  setRanchMobile: setRanchMobile,
  setLoginUserInfo: setLoginUserInfo,
  setRanchBlockSelection: setRanchBlockSelection,
  setInstallState: setInstallState,
  setSelectedPreset: setSelectedPreset,
  setGraphDateRange: setGraphDateRange,
  setGraphSize: setGraphSize,
  setPresetChartSelection: setPresetChartSelection
});
function hasEntity(entities, entityId) {
  return entities.some(entity => entity.id === Number(entityId));
}
const setActiveEntity = entityId => dispatch => {
  dispatch(setCurrentEntity(entityId));
};
const setRanchBlockData = entityId => dispatch => {
  const state = store.getState();
  const entities = selectAllNewEntities(state);
  const activeEntityId = selectEntityId(state);
  const persistingEntityId = selectSelectedEntity(state).payload;
  const userInfo = selectLoginUserInfo(state).payload;
  const isAdmin = userInfo && userInfo.admin;
  let selectedEntity = null;
  if (entityId !== undefined && hasEntity(entities, entityId)) {
    selectedEntity = selectEntityById$1(state, entityId);
  } else if (persistingEntityId && hasEntity(entities, persistingEntityId)) {
    selectedEntity = selectEntityById$1(state, persistingEntityId);
  } else if (isAdmin && hasEntity(entities, process.env.REACT_APP_DEFAULT_ENTITY_ID)) {
    selectedEntity = selectEntityById$1(state, process.env.REACT_APP_DEFAULT_ENTITY_ID);
  } else {
    selectedEntity = {
      ...entities[0]
    };
  }
  // Set ranches and blocks for selected entity
  if (selectedEntity) {
    const {
      id: entId
    } = selectedEntity;
    if (activeEntityId !== entId) {
      dispatch(setActiveEntity(entId));
      dispatch(setEntity(entId));
    }

    // Load new detail block list for entity and upsert the block reducer
    dispatch(loadNewRanchList(entId));
    dispatch(loadNewBlockList(entId));
    dispatch(loadSensorsForEntity(entId));
  }
};
var newFarmActions = /*#__PURE__*/Object.freeze({
  __proto__: null,
  loadNewEntityList: loadNewEntityList,
  loadNewRanchList: loadNewRanchList,
  loadNewBlockList: loadNewBlockList,
  loadNewBlockDetail: loadNewBlockDetail,
  setRanchBlockData: setRanchBlockData,
  setNewRanches: setNewRanches,
  setNewBlocks: setNewBlocks,
  updateNewBlockItem: updateNewBlockItem,
  setActiveEntity: setActiveEntity,
  setRanchesGeoJSON: setRanchesGeoJSON,
  setBlocksGeoJSON: setBlocksGeoJSON
});
const loadFarmData = filter => dispatch => {
  dispatch(loadBlockList(filter));
  dispatch(loadRanchList(filter));
  dispatch(loadEntityList(filter));
};
const loadNewFarmData = () => async dispatch => {
  await dispatch(loadNewEntityList());
  await dispatch(setRanchBlockData());
};

/**
 * Select an entity - used in the Organization Settings screen to select the active Entity to view
 * @param {number} entityId
 * @returns {void} - dispatches action to select an entity
 */
const selectEntity = entityId => dispatch => {
  dispatch(selectActiveEntity$1(entityId));
};

//  load all Available entity / ranch List for Admin
const loadAvailableFarmData = filter => dispatch => {
  dispatch(loadAvailableRanchList(filter));
  dispatch(loadAvailableEntityList(filter));
};
const loadBlockControlStatus = blockId => (dispatch, getState) => {
  const block = selectBlockById(getState(), blockId);
  if (block && block.valve) {
    dispatch(loadSensorStatus$6(block.valve));
  }
  if (block && block.vfd) {
    dispatch(loadSensorStatus$6(block.vfd));
  }
};
var farmActions = /*#__PURE__*/Object.freeze({
  __proto__: null,
  selectEntity: selectEntity,
  loadBlockList: loadBlockList,
  loadBlockDetail: loadBlockDetail,
  cleanBlocksListRequestState: cleanBlocksListRequestState,
  loadRanchList: loadRanchList,
  loadEntityList: loadEntityList,
  loadEntityDetail: loadEntityDetail,
  cleanEntitiesListRequestState: cleanEntitiesListRequestState,
  loadRanchDetail: loadRanchDetail,
  cleanRanchesListRequestState: cleanRanchesListRequestState,
  loadFarmData: loadFarmData,
  loadNewFarmData: loadNewFarmData,
  loadPlansByRanchId: loadPlansByRanchId,
  loadPlanById: loadPlanById,
  patchPlan: patchPlan,
  createPlan: createPlan$2,
  updatePlan: updatePlan,
  loadBlockControlStatus: loadBlockControlStatus,
  loadSoilState: loadSoilState,
  updateBlockItem: updateBlockItem,
  loadAvailableFarmData: loadAvailableFarmData,
  loadAvailableRanchDetail: loadAvailableRanchDetail,
  loadAvailableRanchList: loadAvailableRanchList,
  loadAvailableEntityDetail: loadAvailableEntityDetail,
  loadAvailableEntityList: loadAvailableEntityList
});
const {
  cleanListRequestState
} = scheduleSlice.actions;
const cleanScheduleListRequestState = () => cleanListRequestState();
const secondsAllowed = 10;
const loadBlocksWithSchedules = blockIds => async (dispatch, getState) => {
  dispatch(cleanBlocksListRequestState());
  dispatch(cleanRanchesListRequestState());
  dispatch(cleanScheduleListRequestState());
  const blocksLastUpdated = getState().farmData.blocks.lastUpdated || 100000000;
  const blocksElapsedSecondsUpdate = Math.round((Date.now() - blocksLastUpdated) / 1000);
  if (blocksElapsedSecondsUpdate > secondsAllowed) {
    await Promise.allSettled([dispatch(loadRanchList()), dispatch(loadBlockList())]);
  }
  const blockEntities = getState().farmData.blocks.entities;
  let blockIdsHavingSchedule = [];
  if (blockIds) {
    blockIdsHavingSchedule = Object.values(blockEntities).filter(blockEntity => blockIds.indexOf(blockEntity.id) >= 0).filter(blockEntity => blockEntity.scheduling_enabled).map(blockEntity => blockEntity.id);
  } else {
    blockIdsHavingSchedule = Object.values(blockEntities).filter(blockEntity => blockEntity.scheduling_enabled).map(blockEntity => blockEntity.id);
  }
  return dispatch(loadAllBlockSchedule(blockIdsHavingSchedule));
};
var controlActions = /*#__PURE__*/Object.freeze({
  __proto__: null,
  loadBlockSchedule: loadBlockSchedule,
  loadBlocksWithSchedules: loadBlocksWithSchedules,
  loadAllBlockSchedule: loadAllBlockSchedule
});
const selectScheduleState = state => state.controlData.schedule;
const scheduleSelectors$1 = scheduleAdapter.getSelectors(selectScheduleState);
const selectBlockSchedule = scheduleSelectors$1.selectById;
const selectAllBlockSchedule = scheduleSelectors$1.selectAll;
const selectLoadingBlockSchedule = (state, blockId) => {
  const blockSchedule = selectBlockSchedule(state, blockId);
  if (!blockSchedule) return initialState$6;
  return selectLoadingState(blockSchedule);
};
const selectSchedulerTimelineData = (state, dates, blockIds, irrigationTypes, mobileScreen, colorObj) => {
  const chartData = [];
  const sections = [];
  const jsonKeys = {
    recommended: 'recommended_events',
    past: 'past_events',
    scheduled: 'scheduled_events'
  };
  const irrIds = {
    recommended: 1,
    past: 2,
    scheduled: 3
  };
  const colors = {
    recommended: 'rgb(193, 218, 214)',
    past: 'rgb(232, 208, 169)',
    scheduled: 'lightblue'
  };
  const dummyStartDate = moment(moment(dates[1]).format('YYYY-MM-DD 23:59:57')).toISOString();
  const dummayEndDate = moment(moment(dates[1]).format('YYYY-MM-DD 23:59:58')).toISOString();
  const dateRange = dates[1].diff(dates[0], 'day') === 0 ? [moment(dates[0]).subtract('1', 'day'), moment(dates[1]).add('1', 'day')] : [moment(dates[0]).subtract('1', 'week'), moment(dates[1]).add('1', 'week')];
  const allBlockScheduleData = selectAllBlockSchedule(state);
  const blockScheduleData = allBlockScheduleData.filter(bSch => bSch && blockIds.some(d => d === bSch.id));
  const blockControlStatus = selectBlockControlStatus(state, blockIds);

  //= =============== DATA Preparation ==================================
  function getAlarmListUrl(blockId) {
    const params = {
      blockId,
      logLevel: 'error',
      active: true
    };
    const paramStr = new URLSearchParams(params).toString();
    return `/events?${paramStr}`;
  }
  function getControlPageUrl(blockId) {
    const params = {
      blockId
    };
    const paramStr = new URLSearchParams(params).toString();
    return `/control?${paramStr}`;
  }
  function renderOverrideNotice(block) {
    if (!block.overrideActive) return null;
    return `
      <a
        class="overrideAlert"
        href=${getControlPageUrl(block.blockId)}
      >
        Override Active
      </a>`;
  }
  const blocks = selectAllNewBlocks$1(state);
  const filteredBlocks = blocks.filter(d => blockIds.some(id => id === d.id));
  const blockNames = filteredBlocks.reduce((a, block) => {
    a[block.id] = block.name;
    return a;
  }, {});
  const abbrDuration = duration => {
    const durationHr = duration.asHours();
    if (durationHr % 1 !== 0) return `${durationHr.toFixed(1)} hrs`;
    return `${durationHr.toFixed()} hrs`;
  };
  const abbrPeriod = data => {
    const duration = moment.duration(moment(data[1]).diff(moment(data[0])));
    return abbrDuration(duration);
  };
  function addColorToBlocks(blockSch, irrgType) {
    return mobileScreen ? colorObj[blockSch.id] : colors[irrgType];
  }
  const loading = blockScheduleData.reduce((a, p) => !p || a || p.loading, false);
  if (!loading) {
    blockScheduleData.forEach(blockSch => {
      Object.keys(jsonKeys).forEach(irrgType => {
        if (blockSch[jsonKeys[irrgType]] && irrigationTypes.includes(irrgType)) {
          // Filter by selected dates
          let events = [];
          let dummyEvent = true;
          if (mobileScreen) {
            events = blockSch[jsonKeys[irrgType]];
          } else {
            events = blockSch[jsonKeys[irrgType]].filter(event => moment(event.start_date).diff(dateRange[0]) >= 0 && moment(event.stop_date).diff(dateRange[1]) <= 0 || moment(event.start_date).isBetween(dateRange[0], dateRange[1]) || moment(event.stop_date).isBetween(dateRange[0], dateRange[1]));
          }
          events.forEach(event => {
            chartData.push({
              name: blockNames[blockSch.id],
              id: event.id,
              irrId: irrIds[irrgType],
              start_date: event.start_date,
              end_date: event.stop_date,
              text: abbrPeriod([event.start_date, event.stop_date]),
              type: jsonKeys[irrgType],
              color: addColorToBlocks(blockSch, irrgType),
              section_id: blockSch.id
            });
            if (moment(dummyStartDate).isBetween(event.started, event.stopped, 'hours') || moment(dummyStartDate).isBetween(event.start_date, event.stop_date, 'hours')) {
              dummyEvent = false;
            }
          });
          // Adding dummy event for event ordering
          if (irrgType !== 'recommended' && !mobileScreen && dummyEvent) {
            chartData.push({
              name: blockNames[blockSch.id],
              id: events.id,
              irrId: irrIds[irrgType],
              start_date: dummyStartDate,
              end_date: dummayEndDate,
              text: '',
              type: jsonKeys[irrgType],
              color: colors[irrgType],
              section_id: blockSch.id
            });
          }
        }
      });
      const pumpOverride = blockControlStatus && blockControlStatus[blockSch.id].vfdStatus && blockControlStatus[blockSch.id].vfdStatus.overrideStatus;
      const valveOverride = blockControlStatus && blockControlStatus[blockSch.id].valveStatus && blockControlStatus[blockSch.id].valveStatus.overrideStatus;
      const overrideActive = !!(valveOverride || pumpOverride);

      // Object for override active
      const obj = {
        name: blockNames[blockSch.id],
        blockId: blockSch.id,
        overrideActive,
        alarmCount: blockControlStatus && blockControlStatus[blockSch.id].valveStatus && blockControlStatus[blockSch.id].valveStatus.blockAlarmCount
      };
      sections.push({
        key: blockSch.id,
        label: `<div class="container">
            <div class="sub-container"><div class="name">${blockNames[blockSch.id]}</div>
            ${obj.overrideActive ? `<div class="active-name">${renderOverrideNotice(obj)}</div>` : ''}
          </div>
          <div class="image">
            <a href="${getAlarmListUrl(blockSch.id)}" class="notification">
                <span class="svg-container">
                  <button class="btn">
                    <svg viewBox="64 64 896 896" id="bell_svg" focusable="false" class="" data-icon="bell" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M816 768h-24V428c0-141.1-104.3-257.8-240-277.2V112c0-22.1-17.9-40-40-40s-40 17.9-40 40v38.8C336.3 170.2 232 286.9 232 428v340h-24c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h216c0 61.8 50.2 112 112 112s112-50.2 112-112h216c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM512 888c-26.5 0-48-21.5-48-48h96c0 26.5-21.5 48-48 48z"></path></svg>
                  </button>
                </span>
                ${obj.alarmCount ? `<span class="badge">${obj.alarmCount}</span>` : '<span class="nobadge"></span>'}
              </a>
          </div>
        </div>`
      });
    });
  }
  return [chartData, sections, loading];
};
const selectSchedulesPreparedData = createSelector([selectAllBlockSchedule, selectAllNewBlocks$1], (schedules, blocks) => {
  if (!(schedules.length && blocks.length)) {
    return [];
  }
  const blocksObj = groupBy(blocks, 'id');
  // TODO remove .subtract(X, 'months'), this is demo purposes only
  const today = moment().subtract(2, 'months').startOf('day');
  return Object.values(schedules.map(blockSchedule => ({
    ...blockSchedule,
    block: blocksObj[blockSchedule.id][0],
    blockName: blocksObj[blockSchedule.id][0].name
  })).reduce((acc, curr) => {
    if (!acc[curr.block.ranch.id]) {
      acc[curr.block.ranch.id] = {};
      acc[curr.block.ranch.id].blocks = [];
    }
    acc[curr.block.ranch.id].id = curr.block.ranch.id;
    acc[curr.block.ranch.id].name = curr.block.ranch.name;
    curr.upcomingSchedules = curr.scheduled_events.filter(scheduledEvent => {
      /*
        block: 738131
        flow: null
        gpm: "20.000"
        id: 4272
        start_date: "2021-10-26T18:20:00Z"
        started: null
        stop_date: "2021-10-28T18:20:00Z"
        stopped: null
        user: 346
      */

      // Not sure about the correct approach here
      // checking if the stop date is in the future
      // for scheduled event

      // Per discussion with Robin - there will be new api to resolve
      // recurring schedules

      // TODO implement data of reccuring schedules here
      const diff = moment(moment(scheduledEvent.stop_date)).diff(today, 'days');
      return diff >= 0;
    });
    acc[curr.block.ranch.id].blocks.push(curr);
    return acc;
  }, {}));
});

// TODO continue from here after map PR work
const selectScheduleById = id => createSelector([selectSchedulesPreparedData], schedules => {
  let schedule = {};
  if (!schedules.length) {
    return schedule;
  }
  schedules.some(r => r.blocks.some(b => b.upcomingSchedules.some(s => {
    if (s.id === Number(id)) {
      schedule = Object.assign(schedule, {
        ranchInfo: cloneDeep(r)
      });
      schedule = Object.assign(schedule, {
        blockInfo: cloneDeep(b)
      });
      schedule = Object.assign(schedule, cloneDeep(s));
      const startMoment = moment(s.start_date);
      const stopMoment = moment(s.stop_date);
      const diff = stopMoment.diff(startMoment, 'seconds');
      schedule.duration = moment.utc(moment.duration(diff, 'seconds').asMilliseconds()).format('hh:mm');
      schedule.startTime = moment(s.start_date).format('ddd, MMM, Do, hh:mm A');
      schedule.endTime = moment(s.stop_date).format('ddd, MMM, Do, hh:mm A');
      schedule.repeats = s.is_recurring;
      schedule.blockName = schedule.blockInfo.blockName;
      return true;
    }
    return false;
  })));
  return schedule;
});
var controlSelectors = /*#__PURE__*/Object.freeze({
  __proto__: null,
  selectBlockSchedule: selectBlockSchedule,
  selectLoadingBlockSchedule: selectLoadingBlockSchedule,
  selectAllBlockSchedule: selectAllBlockSchedule,
  selectSchedulerTimelineData: selectSchedulerTimelineData,
  selectSchedulesPreparedData: selectSchedulesPreparedData,
  selectScheduleById: selectScheduleById
});
const loadAnomaliesForBlocks = blockIds => dispatch => {
  if (blockIds && blockIds.length) {
    dispatch(loadAnomaliesForBlock(blockIds));
  }
};
var anomalyActions = /*#__PURE__*/Object.freeze({
  __proto__: null,
  loadAnomaliesForBlock: loadAnomaliesForBlock,
  loadAnomaliesForBlocks: loadAnomaliesForBlocks
});
const loadRecommendationsWithAnomaly = blockIds => dispatch => {
  dispatch(loadRecommendations());
  if (blockIds && blockIds.length) dispatch(loadAnomaliesForBlocks(blockIds));
};
var recommendationActions = /*#__PURE__*/Object.freeze({
  __proto__: null,
  loadRecommendations: loadRecommendations,
  loadRecommendationForBlock: loadRecommendationForBlock,
  updateRecommendation: updateRecommendation,
  loadRecommendationsWithAnomaly: loadRecommendationsWithAnomaly
});

// This will be removed/uncommented in future
// const selectRecommendationState = (state) => state.recommendationData.recommendation;

const selectRecommendationState = state => {
  const recommendationObj = {
    ...state.recommendationData.recommendation
  };
  recommendationObj.ids = recommendationObj.ids.filter(d => !d.includes('undefined'));
  return recommendationObj;
};
const recommendationSelectors = recommendationAdapter.getSelectors(selectRecommendationState);
const selectRecommendationIdentifierForBlock = (state, blockId) => {
  const recommendationsIdentifier = recommendationSelectors.selectAll(state).filter(d => Number(blockId) === d.block).map(d => d.block && d.type ? `${d.block}-${d.type}${d.type === 'imagery_anomaly' ? `-${d.anomalyType}` : ''}` : `${d.block}-ground_mission`);
  return recommendationsIdentifier;
};
const selectRecommendationForBlock = (state, blockId) => {
  const recommendationsIdentifier = selectRecommendationIdentifierForBlock(state, blockId);
  const recommendationObj = recommendationsIdentifier.map(identifier => {
    const recommendation = recommendationSelectors.selectById(state, identifier);
    if (!recommendation || !(recommendation && recommendation.type)) return undefined;
    const block = selectNewBlockById$1(state, recommendation.block);
    return {
      ...recommendation,
      blockName: block && block.name
    };
  });
  return recommendationObj;
};
const selectRecommendationsForBlocks = (state, blockIds) => blockIds.reduce((result, blockId) => {
  const recommendation = selectRecommendationForBlock(state, blockId);
  if (recommendation && recommendation.length) {
    result.push(...recommendation);
  }
  return result;
}, []);
const selectRecommendations = recommendationSelectors.selectAll;
const selectLoadingRecommendations = state => selectLoadingState(selectRecommendationState(state));
var recommendationSelectors$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  selectRecommendationForBlock: selectRecommendationForBlock,
  selectRecommendationsForBlocks: selectRecommendationsForBlocks,
  selectRecommendations: selectRecommendations,
  selectLoadingRecommendations: selectLoadingRecommendations
});
var scheduleActions = /*#__PURE__*/Object.freeze({
  __proto__: null,
  loadBlockRenderedSchedule: loadBlockRenderedSchedule,
  loadBlockIrrigationSchedule: loadBlockIrrigationSchedule
});

// scheduled events
const selectScheduledEventsState = state => state.scheduleData.scheduledEvents;
const scheduledEventsSelectors = scheduledEventsAdapter.getSelectors(selectScheduledEventsState);
const selectBlockScheduledEvents = (state, blockId) => {
  const blockScheduledEvents = scheduledEventsSelectors.selectById(state, blockId);
  if (!blockScheduledEvents || blockScheduledEvents.events === undefined) {
    return [];
  }
  return blockScheduledEvents.events;
};
const selectLoadingBlockScheduledEvents = (state, blockId) => {
  const blockScheduledEvents = scheduledEventsSelectors.selectById(state, blockId);
  return blockScheduledEvents && blockScheduledEvents.loading;
};
const selectCurrentBlockScheduledEvents = (state, blockId) => {
  const currentDate = moment();
  return selectBlockScheduledEvents(state, blockId).filter(event => {
    if (moment(event.stop_date) >= currentDate) {
      return true;
    }
    if (!event.is_recurring) {
      return false;
    }
    if (event.repeat_end_type === 'never') {
      return true;
    }
    if (event.repeat_end_type === 'date') {
      return currentDate < moment(event.repeat_end_date);
    }
    // TODO: handle repeat_end_type === 'count'
    return true;
  });
};
const selectScheduledEventById = (state, {
  id,
  blockId
}) => selectBlockScheduledEvents(state, blockId).find(event => event.id === id);

// rendered events

const selectRenderedEventsState = state => state.scheduleData.renderedEvents;
const renderedEventsSelectors = renderedEventsAdapter.getSelectors(selectRenderedEventsState);
const selectBlockRenderedSchedule = (state, {
  blockId,
  dateStart,
  dateEnd
}) => {
  const blockRenderedSchedule = renderedEventsSelectors.selectById(state, blockId);
  if (!blockRenderedSchedule) {
    return {
      blockId,
      events: null,
      loading: false
    };
  }
  const events = blockRenderedSchedule.events && blockRenderedSchedule.events.filter(event => moment(event.start_date) < dateEnd && moment(event.stop_date) > dateStart);
  return {
    blockId,
    loading: blockRenderedSchedule.loading,
    events
  };
};
const selectLatestBlockRenderedSchedule = (state, {
  blockId,
  dateStart,
  dateEnd
}) => {
  const {
    events
  } = selectBlockRenderedSchedule(state, {
    blockId,
    dateStart,
    dateEnd
  });
  if (events && events.length) {
    return events.sort((a, b) => {
      if (a.start_date > b.start_date) return 1;
      if (a.start_date < b.start_date) return -1;
      return 0;
    })[0];
  }
  return null;
};
const selectLoadingBlockRenderedSchedule = (state, blockId) => {
  const blockRenderedSchedule = renderedEventsSelectors.selectById(state, blockId);
  return blockRenderedSchedule && blockRenderedSchedule.loading;
};
const selectBlockRenderedSchedules = (state, {
  blockIds,
  dateStart,
  dateEnd
}) => {
  if (!blockIds) return [];
  return blockIds.map(blockId => selectBlockRenderedSchedule(state, {
    blockId,
    dateStart,
    dateEnd
  }));
};
const selectLoadingBlockRenderedSchedules = (state, blockIds) => {
  const loadingBlocks = blockIds.map(blockId => selectLoadingBlockRenderedSchedule(state, blockId));
  return loadingBlocks.filter(loading => loading === true).length > 0;
};
const selectBlockRenderedScheduleEvent = (state, {
  blockId,
  eventId,
  eventIndex
}) => {
  const schedule = renderedEventsSelectors.selectById(state, blockId);
  if (!schedule || !schedule.events) return null;
  return schedule.events.find(event => event.id === eventId && event.event_index === eventIndex);
};
const selectSchedulerTimelineDataRendered = (state, {
  blockIds,
  dateStart,
  dateEnd,
  blockColors
}) => selectBlockRenderedSchedules(state, {
  blockIds,
  dateStart,
  dateEnd
}).reduce((events, schedule) => {
  if (!schedule.events) {
    return events;
  }
  const blockEvents = schedule.events.map(event => ({
    ...event,
    id: event.uid,
    rootId: event.id,
    start_date: moment(event.start_date),
    end_date: moment(event.stop_date),
    irrId: 3,
    // scheduled
    name: null,
    // block name
    text: null,
    // text to display on event
    section_id: event.block,
    type: 'scheduled_events',
    color: blockColors[event.block]
  }));
  return events.concat(blockEvents);
}, []);
var scheduleSelectors = /*#__PURE__*/Object.freeze({
  __proto__: null,
  selectBlockScheduledEvents: selectBlockScheduledEvents,
  selectCurrentBlockScheduledEvents: selectCurrentBlockScheduledEvents,
  selectLoadingBlockScheduledEvents: selectLoadingBlockScheduledEvents,
  selectScheduledEventById: selectScheduledEventById,
  selectBlockRenderedSchedule: selectBlockRenderedSchedule,
  selectBlockRenderedSchedules: selectBlockRenderedSchedules,
  selectLoadingBlockRenderedSchedules: selectLoadingBlockRenderedSchedules,
  selectSchedulerTimelineDataRendered: selectSchedulerTimelineDataRendered,
  selectBlockRenderedScheduleEvent: selectBlockRenderedScheduleEvent,
  selectLatestBlockRenderedSchedule: selectLatestBlockRenderedSchedule
});
const selectUserSettingsState = state => state.settingsData.userSettings;
const selectUserSettings = createSelector(selectUserSettingsState, state => state.data);
const selectLoadingUserSettings = createSelector(selectUserSettingsState, state => ({
  loading: state.loading,
  lastUpdated: state.lastUpdated
}));
const selectUserTimeFormat = state => {
  const userSettings = selectUserSettings(state);
  return userSettings ? userSettings.units_time : '12_hour';
};
const selectUserTimeMomentFormat = createSelector(selectUserTimeFormat, userTime => userTime === '12_hour' ? 'h:mm A' : 'HH:mm');
const selectUserLengthFormat = state => {
  const userSettings = selectUserSettings(state);
  return userSettings ? userSettings.units_length : 'feet';
};
const selectUserDepthFormat = state => {
  const userSettings = selectUserSettings(state);
  if (!userSettings) {
    return 'inches';
  }
  return userSettings.units_length === 'feet' ? 'inches' : 'centimeters';
};
const selectUserVolumeFormat = state => {
  const userSettings = selectUserSettings(state);
  return userSettings ? userSettings.units_volume : 'gallons';
};
const selectUserAreaFormat = state => {
  const userSettings = selectUserSettings(state);
  return userSettings ? userSettings.units_area : 'acres';
};
const selectUserFlowRateFormat = state => {
  const userSettings = selectUserSettings(state);
  return userSettings ? userSettings.units_flow_rate : 'gallons_per_minute';
};
const selectUserPowerFormat = state => {
  const userSettings = selectUserSettings(state);
  return userSettings ? userSettings.units_power : 'horsepower';
};
const selectUserTemperatureFormat = state => {
  const userSettings = selectUserSettings(state);
  return userSettings ? userSettings.units_temperature : 'degrees_fahrenheit';
};
const selectUserPressureFormat = state => {
  const userSettings = selectUserSettings(state);
  return userSettings ? userSettings.units_pressure : 'pounds_per_square_inch';
};
const selectUserLanguage = state => {
  const userSettings = selectUserSettings(state);
  let {
    language
  } = userSettings || {};
  if (userSettings && userSettings.language === 'system') {
    const languageCode = navigator.language.split('-')[0];
    language = languageCode.toLowerCase();
  }
  return userSettings ? language : 'en-us';
};
var settingsSelectors = /*#__PURE__*/Object.freeze({
  __proto__: null,
  selectUserSettings: selectUserSettings,
  selectLoadingUserSettings: selectLoadingUserSettings,
  selectUserTimeFormat: selectUserTimeFormat,
  selectUserTimeMomentFormat: selectUserTimeMomentFormat,
  selectUserLengthFormat: selectUserLengthFormat,
  selectUserDepthFormat: selectUserDepthFormat,
  selectUserVolumeFormat: selectUserVolumeFormat,
  selectUserAreaFormat: selectUserAreaFormat,
  selectUserFlowRateFormat: selectUserFlowRateFormat,
  selectUserPowerFormat: selectUserPowerFormat,
  selectUserTemperatureFormat: selectUserTemperatureFormat,
  selectUserPressureFormat: selectUserPressureFormat,
  selectUserLanguage: selectUserLanguage
});

// Filter the valid ids to avoid logic issues
const selectAnomaliesState = state => {
  const anomalyObj = {
    ...state.anomalyData.anomalies
  };
  anomalyObj.ids = anomalyObj.ids.filter(id => id);
  return anomalyObj;
};
const anomalySelectors = anomalyAdapter.getSelectors(selectAnomaliesState);
const prepareAnomalyDataFormat = anomalies => {
  const changedAnomalyData = [];
  if (anomalies && anomalies.length) {
    anomalies.forEach(anomaly => {
      const anomalyObj = {
        id: `${anomaly.name}/${anomaly.anomaly_type}`,
        type: 'Feature',
        geometry: anomaly.center,
        name: anomaly.name,
        properties: anomaly
      };
      changedAnomalyData.push(anomalyObj);
    });
  }
  return changedAnomalyData;
};
const selectAnomaliesForBlock = (state, blockId) => {
  const anomalies = prepareAnomalyDataFormat(anomalySelectors.selectAll(state)).filter(d => d.properties.block === Number(blockId));
  if (!anomalies) return undefined;
  const block = selectNewBlockById$1(state, blockId);
  const anomalyDataWithBlockName = anomalies.map(d => ({
    ...d,
    blockName: block && block.name
  }));
  return anomalyDataWithBlockName;
};
const selectAnomaliesForBlocks = (state, blockIds) => blockIds.reduce((result, blockId) => {
  const anomalies = selectAnomaliesForBlock(state, blockId);
  if (anomalies && anomalies.length) {
    result.push(...anomalies);
  }
  return result;
}, []);
const selectAnomalies = state => prepareAnomalyDataFormat(anomalySelectors.selectAll(state));
const selectLoadingAnomalies = state => selectLoadingState(selectAnomaliesState(state));
var anomalySelectors$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  selectAnomalies: selectAnomalies,
  selectAnomaliesForBlock: selectAnomaliesForBlock,
  selectAnomaliesForBlocks: selectAnomaliesForBlocks,
  selectLoadingAnomalies: selectLoadingAnomalies
});
const loadAllCoordination = () => async dispatch => {
  dispatch(loadCoordinationList());
};
var coordinationActions = /*#__PURE__*/Object.freeze({
  __proto__: null,
  loadAllCoordination: loadAllCoordination,
  updateConfigField: updateConfigField
});
const selectCoordinationState = state => state.coordinationData.coordination;
const coordinationSelectors = coordinationAdapter.getSelectors(selectCoordinationState);

// Select coordination by block id
const selectCoordinationByBlockId = (state, blockId) => coordinationSelectors.selectById(state, blockId);
const selectAllCoordination = coordinationSelectors.selectAll;

// select irrigation config by block id
const selectIrrigationConfigByBlockId = (state, blockId) => {
  const irrigationConfig = selectCoordinationByBlockId(state, blockId);
  if (irrigationConfig && irrigationConfig.configs) {
    return irrigationConfig.configs.irrigation || {};
  }
  return {};
};

// select cooling config by block id
const selectCoolingConfigByBlockId = (state, blockId) => {
  const coolingConfig = selectCoordinationByBlockId(state, blockId);
  if (coolingConfig && coolingConfig.configs) {
    return coolingConfig.configs.cooling || {};
  }
  return {};
};

// select Sprinkler config by block id
const selectSprinklerConfigByBlockId = (state, blockId) => {
  const sprinklerConfig = selectCoordinationByBlockId(state, blockId);
  if (sprinklerConfig && sprinklerConfig.configs) {
    return sprinklerConfig.configs.sprinkler || {};
  }
  return {};
};
const selectCoordinationLoading = state => selectCoordinationState(state).loading;
var coordinationSelectors$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  selectCoordinationByBlockId: selectCoordinationByBlockId,
  selectAllCoordination: selectAllCoordination,
  selectIrrigationConfigByBlockId: selectIrrigationConfigByBlockId,
  selectCoolingConfigByBlockId: selectCoolingConfigByBlockId,
  selectSprinklerConfigByBlockId: selectSprinklerConfigByBlockId,
  selectCoordinationLoading: selectCoordinationLoading
});
const selectSensorsFeaturesByRanchId = (state, ranchId) => Object.values(state.sensorsData.sensorsgeojson).filter(({
  properties
}) => properties.ranchId === ranchId);
const selectBlocksFeaturesByRanchId = (state, ranchId) => Object.values(state.farm.blocksgeojson).filter(({
  properties
}) => properties.ranchId === ranchId);
const selectRanchesFeatures = state => Object.values(state.farm.ranchesgeojson);
const selectRanchFeaturesByRanchId = (state, ranchId) => Object.values(state.farm.ranchesgeojson).filter(({
  properties
}) => properties.id === ranchId);
const selectSoilStateCollectionObj = state => state.farmData.soilstate.entities;

/* eslint-disable prefer-destructuring */
const scheduleLink = 'https://web.farmx.co/schedule';
const controlLink = ranchId => `https://web.farmx.co/control?ranchId=${ranchId}`;
const soilStateMap = {
  very_dry: 1,
  dry: 2,
  drying: 3,
  over_irrigated: 4,
  well_irrigated: 5
};
const soilStateMapString = {
  1: 'very_dry',
  2: 'dry',
  3: 'drying',
  4: 'over_irrigated',
  5: 'well_irrigated'
};

/**
 * Accepts a set of crop stress and returns
 * state for the worst stress.
 */
const getCropStateByStress = cropStressSet => {
  let cropState = 0;
  if (cropStressSet.has('severe_stress')) cropState = 2;else if (cropStressSet.has('moderate_stress')) cropState = 3;else if (cropStressSet.has('low_stress') || cropStressSet.has('no_stress')) cropState = 5;
  return cropState;
};

/**
 * This function aggregates up different states
 * e.g. if one sensor is not provision in the group,
 * then the group gets state set to "not provisioned"
 * @param {Array} sensorCollection
 * @param {Bool} isMarker
 * @returns {Object}
 */
const calculateGroupStateForPresentationModes = (sensorCollection, isMarker) => {
  let soilState = 0;
  let soilStateString = '';
  let connectivityState = 0; // Blank 0 gray
  let waterPressureState = 0;
  let controlState = 0;
  let provisionState = 5;
  let minutes = 0;
  let stateKnown = false;
  let stateAggregated = 10;
  let cropState = 0;
  try {
    const sensorFeatures = sensorCollection.map(featureOrMarker => {
      if (isMarker) {
        return featureOrMarker.feature;
      }
      return featureOrMarker;
    });
    const wp = sensorFeatures.filter(s => s.properties.type === 'water_pressure').reduce((acc, curr) => {
      if (typeof curr.properties.water_pressure !== 'undefined' && typeof curr.properties.pressure_cutoff !== 'undefined') {
        return {
          count: acc.count + 1,
          p: acc.p + curr.properties.water_pressure,
          c: acc.c + curr.properties.pressure_cutoff
        };
      }
      return acc;
    }, {
      count: 0,
      p: 0,
      c: 0
    });
    if (wp.count > 0) {
      const avgPressure = wp.p / wp.count;
      const avgCutoff = wp.c / wp.count;
      if (avgPressure >= avgCutoff) {
        waterPressureState = 4;
      }
    }
    for (let i = 0; i < sensorFeatures.length; i += 1) {
      const sensorFeature = sensorFeatures[i];
      const {
        type: sensorType
      } = sensorFeature.properties;

      // soilstate
      if (['aquacheck_soil', 'pixl_soil'].includes(sensorType)) {
        const {
          soil_state: sensorSoilState
        } = sensorFeature.properties;
        if (sensorSoilState) {
          stateKnown = true;
          if (soilStateMap[sensorSoilState] < stateAggregated) {
            stateAggregated = soilStateMap[sensorSoilState];
          }
        }
      }

      // connectivity
      if (sensorType !== 'cavalier') {
        const lastPosted = sensorFeature.properties.lastPostedInMinutes;
        if (lastPosted === undefined) {
          minutes = undefined;
        }
        if (lastPosted !== undefined && lastPosted === -1) {
          minutes = -1;
        }
        if (lastPosted !== undefined && lastPosted !== -1 && lastPosted > minutes) {
          minutes = lastPosted;
        }
      }
      if (minutes === undefined) {
        connectivityState = 0; // Blank 0 gray
      } else if (minutes === -1 || minutes > 120) {
        // If any one sensor is offline OR
        // any one sensor's lastUpdated minute is more than 2 hours, then its "Bad"
        connectivityState = 2; // Offline, Bad 2 red
      } else if (minutes > 30 && minutes <= 120) {
        // If any one sensor's lastUpdated minute is > 30minutes and within 2 hours
        connectivityState = 3; // Warning 3 yellow
      } else if (minutes <= 30) {
        // If lastUpdated is >= 0 and less than 30minutes
        connectivityState = 5; // Good - 5 green
      }

      // control
      if (controlState === 0 && ['valve', 'vfd', 'water_flow', 'water_flow_analog', 'water_pressure'].includes(sensorType) && sensorFeature.properties.controlSateON) {
        controlState = 4;
      }

      // provision has only two states 2 and 5
      if (provisionState === 5 && !sensorFeature.properties.provisioned) {
        provisionState = 2;
      }
    }

    // soilstate continues
    if (stateKnown) {
      switch (stateAggregated) {
        case 1:
          soilState = 1;
          soilStateString = soilStateMapString[1];
          break;
        case 2:
          soilState = 2;
          soilStateString = soilStateMapString[2];
          break;
        case 3:
          soilState = 3;
          soilStateString = soilStateMapString[3];
          break;
        case 4:
          soilState = 4;
          soilStateString = soilStateMapString[4];
          break;
        case 5:
          soilState = 5;
          soilStateString = soilStateMapString[5];
          break;
        default:
          soilState = 0;
          soilStateString = soilStateMapString[0];
      }
    }
    const cropSensors = sensorCollection.filter(sensorItem => {
      const {
        properties
      } = sensorItem || {};
      const {
        type
      } = properties || {};
      return type === 'farmx_dendrometer' || type === 'farmx_infrared';
    });
    if (cropSensors && cropSensors.length) {
      const cropSensorsStress = cropSensors.map(cropSensorItem => cropSensorItem.properties.crop_stress);
      const cropSensorsStressSet = new Set(cropSensorsStress);
      cropState = getCropStateByStress(cropSensorsStressSet);
    }
  } catch (error) {
    console.log('ERROR calculating state of marker groups', error);
  }
  return {
    connectivityState,
    waterPressureState,
    provisionState,
    soilState,
    soilStateString,
    controlState,
    cropState
  };
};

/**
 * Prepares GeoJSON data for sensors, ranches, blocks.
 * Calculates states using calculateGroupStateForPresentationModes
 * Parameters sensorStates & soilState are optional
 * @param {Object} param0
 * @returns {Object}
 */
const prepareData = ({
  sensors,
  blocks,
  ranches,
  sensorStates,
  soilState,
  recommendationBlocks
}) => {
  const blockInfoObj = blocks.reduce((acc, curr) => {
    acc.blockIds.push(curr.id);
    if (curr.vfd) {
      acc.blockNames.push(curr.name);
    }
    acc.blocksObj[curr.id] = curr;
    return acc;
  }, {
    blockIds: [],
    blockNames: [],
    blocksObj: {}
  });
  const blockIds = blockInfoObj.blockIds.join(',');
  const blockNames = blockInfoObj.blockNames.join(', ');
  const {
    blocksObj
  } = blockInfoObj;
  const sensorsInfo = cloneDeep(sensors);
  const sensorsInfoObj = sensorsInfo.reduce((acc, curr) => {
    if (curr.type === 'vfd') {
      acc.vfdObj[`vfd/${curr.identifier}`] = curr;
    }
    return acc;
  }, {
    vfdObj: {}
  });
  const {
    vfdObj
  } = sensorsInfoObj;
  const sensorsFeatures = {};
  sensors.filter(i => {
    if (i === Object(i) && i.location === Object(i.location)) {
      return isNumber(i.location.lat) && isNumber(i.location.lng);
    }
    return false;
  }).forEach(sensor => {
    if (sensor.visible || ['valve', 'vfd'].includes(sensor.type)) {
      const id = `${sensor.type}/${sensor.identifier}`;
      const sensorFeature = {
        id,
        type: 'Feature',
        geometry: {
          type: 'Point',
          coordinates: [sensor.location.lng, sensor.location.lat]
        },
        properties: {
          ...cloneDeep(sensor),
          id,
          noStatusAvailable: true,
          idDb: sensor.id,
          ranchId: sensor.ranch === Object(sensor.ranch) ? sensor.ranch.id : sensor.ranch
        }
      };
      sensorFeature.properties.blockId = sensor.block === Object(sensor.block) ? sensor.block.id : sensor.block;
      if (sensorFeature.properties.type === 'valve') {
        sensorFeature.properties.scheduleLink = scheduleLink;
        if (sensorFeature.properties.irrigation_block) {
          if (blockInfoObj.blocksObj[sensorFeature.properties.irrigation_block]) {
            sensorFeature.properties.downstreamBlock = blockInfoObj.blocksObj[sensorFeature.properties.irrigation_block].name;
          } else {
            sensorFeature.properties.downstreamBlock = '';
          }
          sensorFeature.properties.scheduleLink = `https://web.farmx.co/schedule?irrigationTypes=scheduled&blockId=${sensorFeature.properties.irrigation_block}`;
          const irrigationBlock = blocksObj[sensorFeature.properties.irrigation_block];
          if (irrigationBlock === Object(irrigationBlock) && irrigationBlock.properties && irrigationBlock.properties.vfd) {
            sensorFeature.properties.pumpControl = vfdObj[`vfd/${irrigationBlock.properties.vfd.identifier}`] ? vfdObj[`vfd/${irrigationBlock.properties.vfd.identifier}`].properties.name : '';
          }
        }
        sensorFeature.properties.controlLink = controlLink(sensorFeature.properties.ranchId);
      }
      if (sensorFeature.properties.type === 'vfd') {
        sensorFeature.properties.supplies = blockNames;
        sensorFeature.properties.scheduleLink = `https://web.farmx.co/schedule?irrigationTypes=scheduled&blockId=${blockIds}`;
        sensorFeature.properties.controlLink = controlLink;
      }
      sensorsFeatures[id] = sensorFeature;
    }
  });
  const blocksFeatures = blocks.filter(i => {
    if (i === Object(i) && i.bounds === Object(i.bounds)) {
      return i.bounds.coordinates instanceof Array && i.bounds.coordinates.length && i.bounds.type;
    }
    return false;
  }).reduce((acc, block) => {
    const properties = cloneDeep(block);
    if (recommendationBlocks && recommendationBlocks[block.id] instanceof Array && recommendationBlocks[block.id].length) {
      const [recommendation] = recommendationBlocks[block.id].filter(rec => rec.type === 'irrigation');
      properties.recommendationInfo = recommendation;
    } else {
      properties.recommendationInfo = {};
    }
    const blockFeature = {
      id: block.id,
      type: 'Feature',
      geometry: cloneDeep(block.bounds),
      properties
    };
    blockFeature.properties.ranchId = block.ranch === Object(block.ranch) ? block.ranch.id : block.ranch;
    blockFeature.properties.type = 'block';
    try {
      blockFeature.properties.squareMeters = area(blockFeature);
    } catch (error) {
      console.log('ERROR with block data in utils.js', error);
    }
    blockFeature.properties.acres = Number((blockFeature.properties.squareMeters / 4046.86).toFixed(1));
    blockFeature.properties.noStatusAvailable = true;
    acc[block.id] = blockFeature;
    return acc;
  }, {});
  const ranchesFeatures = ranches.filter(i => {
    if (i === Object(i) && i.bounds === Object(i.bounds)) {
      return i.bounds.coordinates instanceof Array && i.bounds.coordinates.length && i.bounds.type;
    }
    return false;
  }).reduce((acc, ranch) => {
    const ranchFeature = {
      id: ranch.id,
      type: 'Feature',
      geometry: cloneDeep(ranch.bounds),
      properties: cloneDeep(ranch)
    };
    ranchFeature.properties.entityId = ranch.entity === Object(ranch.entity) ? ranch.entity.id : ranch.entity;
    ranchFeature.properties.type = 'ranch';
    try {
      ranchFeature.properties.squareMeters = area(ranchFeature);
    } catch (error) {
      console.log('ERROR with ranch data in utils.js', error);
    }
    ranchFeature.properties.acres = Number((ranchFeature.properties.squareMeters / 4046.86).toFixed(1));
    ranchFeature.properties.noStatusAvailable = true;
    acc[ranch.id] = ranchFeature;
    return acc;
  }, {});
  if (!sensorStates) {
    return {
      sensorFeatures: sensorsFeatures,
      blockFeatures: blocksFeatures,
      ranchFeatures: ranchesFeatures
    };
  }
  let sensorsWithSoilStateFeatures;
  let blocksWithSoilStateFeatures;
  let ranchesWithSoilStateFeatures;
  if (soilState) {
    const soilStatusSensors = {};
    if (soilState === Object(soilState)) {
      soilState.blocks.forEach(block => {
        if (block === Object(block) && block.state && block.state.details && block.state.details.all_data && block.state.details.all_data.length) {
          block.state.details.all_data.forEach(s => {
            soilStatusSensors[s.sensor] = cloneDeep(s);
          });
        }
      });
      if (soilState.state === Object(soilState.state) && soilState.state.details && soilState.state.details.all_data && soilState.state.details.all_data.length) {
        soilState.state.details.all_data.forEach(s => {
          soilStatusSensors[s.sensor] = cloneDeep(s);
        });
      }
    }
    sensorsWithSoilStateFeatures = Object.values(sensorsFeatures).reduce((acc, sensorBase) => {
      const sensor = cloneDeep(sensorBase);
      sensor.properties.noStatusAvailable = false;
      sensor.properties.soilStatusAvailable = true;
      if (soilStatusSensors[sensorBase.properties.identifier]) {
        sensor.properties = {
          ...cloneDeep(sensor.properties),
          ...cloneDeep(soilStatusSensors[sensorBase.properties.identifier])
        };
      }
      acc[sensorBase.id] = cloneDeep(sensor);
      return acc;
    }, {});
    let blocksSoilSate = {};
    if (soilState === Object(soilState) && soilState.blocks instanceof Array) {
      blocksSoilSate = soilState.blocks.reduce((acc, block) => {
        acc[block.id] = cloneDeep(block);
        return acc;
      }, {});
    }
    blocksWithSoilStateFeatures = Object.values(blocksFeatures).reduce((acc, blockFeature) => {
      if (blocksSoilSate[blockFeature.id]) {
        blockFeature.properties = {
          ...cloneDeep(blockFeature.properties),
          ...cloneDeep(blocksSoilSate[blockFeature.id]),
          noStatusAvailable: false,
          soilStatusAvailable: true
        };
      }
      acc[blockFeature.id] = blockFeature;
      return acc;
    }, {});
    ranchesWithSoilStateFeatures = Object.values(ranchesFeatures).reduce((acc, ranchFeature) => {
      if (soilState === Object(soilState) && soilState.id === ranchFeature.id) {
        ranchFeature.properties = {
          ...cloneDeep(ranchFeature.properties),
          ...cloneDeep(soilState),
          noStatusAvailable: false,
          soilStatusAvailable: true
        };
      }
      acc[ranchFeature.id] = cloneDeep(ranchFeature);
      return acc;
    }, {});
  }
  if (!sensorStates) {
    return {
      sensorFeatures: sensorsWithSoilStateFeatures,
      blockFeatures: blocksWithSoilStateFeatures,
      ranchFeatures: ranchesWithSoilStateFeatures
    };
  }
  const now = new Date().getTime();
  const maxWaterPressure = sensorStates.reduce((acc, curr) => {
    if (curr.type !== 'water_pressure') {
      return acc;
    }
    if (curr.pressure_cutoff && curr.water_pressure) {
      return Math.max(acc, curr.pressure_cutoff, curr.water_pressure);
    }
    if (curr.pressure_cutoff) {
      return Math.max(acc, curr.pressure_cutoff);
    }
    if (curr.water_pressure) {
      return Math.max(acc, curr.water_pressure);
    }
    return acc;
  }, 0);
  const okStateResults = sensorStates.reduce((acc, r) => {
    const id = `${r.type}/${r.identifier}`;
    let lastPostedInMinutes;
    if (r.earliest_date && r.latest_date) {
      const earliestDate = new Date(r.earliest_date).getTime();
      const lastPosted = new Date(r.latest_date).getTime();
      if (lastPosted >= earliestDate) {
        lastPostedInMinutes = Math.round((now - lastPosted) / 1000 / 60);
      }
    }
    if (r.type === 'water_pressure') {
      if (r.water_pressure || r.water_pressure === 0) {
        if (r.water_pressure < 0) {
          r.water_pressure = 0;
          r.psi = 0;
        } else if (r.water_pressure < 10) {
          r.water_pressure = Number(r.water_pressure.toFixed(1));
          r.psi = r.water_pressure;
        } else {
          r.water_pressure = Number(r.water_pressure.toFixed());
          r.psi = r.water_pressure;
        }
        r.controlSateON = true;
      } else {
        r.missingWaterPressure = true;
      }
    } else if (r.type === 'valve') {
      // Can be open, closed, unknown
      // based on design req 'open' means 'On'
      if (r.control_status === Object(r.control_status) && r.control_status.state === 'open') {
        r.controlSateON = true;
      }
    } else if (r.type === 'vfd') {
      if (r.control_status === Object(r.control_status) && r.control_status.state === 'on') {
        r.controlSateON = true;
      }
    } else if (r.type === 'water_flow' || r.type === 'water_flow_analog') {
      if (isNumber(r.flow_rate) && r.flow_rate > 0) {
        r.controlSateON = true;
      }
    }
    acc[id] = {
      ...r,
      idDbStatus: r.id,
      lastPostedInMinutes,
      lastUpdated: now,
      id
    };
    return acc;
  }, {});
  const sensorsWithStatusAndByBlocks = Object.values(sensorsWithSoilStateFeatures || sensorsFeatures).reduce((acc, sensorBase) => {
    const sensor = cloneDeep(sensorBase);
    sensor.properties.noStatusAvailable = false;
    if (okStateResults[sensorBase.id]) {
      sensor.properties = {
        ...cloneDeep(sensor.properties),
        ...cloneDeep(okStateResults[sensorBase.id]),
        otherStatesAvailable: true
      };
    }
    if (sensor.properties.type === 'water_pressure' && sensor.properties.missingWaterPressure) {
      sensor.properties.waterPressureColor = 'gray';
    } else if (sensor.properties.type === 'water_pressure') {
      const waterPressure = sensor.properties.water_pressure || 0;
      if (waterPressure === 0) {
        sensor.properties.waterPressureColor = 'white';
        sensor.properties.waterPressureRatio = 0.01;
      } else if (Math.round(waterPressure) === Math.round(maxWaterPressure)) {
        sensor.properties.waterPressureColor = 'blue';
        sensor.properties.waterPressureRatio = 1;
      } else {
        const ratioWP = waterPressure / maxWaterPressure;
        let hex = Number(Math.round(255 - ratioWP * 255)).toString(16);
        if (hex.length < 2) {
          hex = `0${hex}`;
        }
        sensor.properties.waterPressureColor = `#${hex}${hex}ff`;
        sensor.properties.waterPressureRatio = ratioWP;
      }
    }
    acc.sensorsFeaturesWithStatus[sensorBase.id] = cloneDeep(sensor);
    if (!acc.sensorsGroupedByBlock[sensorBase.properties.blockId]) {
      acc.sensorsGroupedByBlock[sensorBase.properties.blockId] = [];
    }
    acc.sensorsGroupedByBlock[sensorBase.properties.blockId].push(cloneDeep(sensor));
    return acc;
  }, {
    sensorsFeaturesWithStatus: {},
    sensorsGroupedByBlock: {}
  });
  const {
    sensorsGroupedByBlock
  } = sensorsWithStatusAndByBlocks;
  const blocksWithStatusAndByRanch = Object.values(blocksWithSoilStateFeatures || blocksFeatures).reduce((acc, blockFeature) => {
    let connectivityState = 0;
    let waterPressureState = 0;
    let controlState = 0;
    let provisionState = 5;
    let soilStateOfBlock = 0;
    let soilStateStringOfBlock;
    let cropState = 0;
    if (sensorsGroupedByBlock[blockFeature.id]) {
      const states = calculateGroupStateForPresentationModes(sensorsGroupedByBlock[blockFeature.id]);
      connectivityState = states.connectivityState;
      waterPressureState = states.waterPressureState;
      controlState = states.controlState;
      provisionState = states.provisionState;
      soilStateOfBlock = states.soilState;
      soilStateStringOfBlock = states.soilStateString;
      cropState = states.cropState;
    }
    if (!sensorsGroupedByBlock[blockFeature.id]) {
      provisionState = 0;
    }
    blockFeature.properties.connectivityState = connectivityState;
    blockFeature.properties.provisionState = provisionState;
    blockFeature.properties.cropState = cropState;
    blockFeature.properties.waterPressureState = waterPressureState;
    blockFeature.properties.controlState = controlState;
    blockFeature.properties.otherStatesAvailable = true;
    blockFeature.properties.soilStateOfBlock = soilStateOfBlock;
    blockFeature.properties.soilStateStringOfBlock = soilStateStringOfBlock;
    acc.blocksFeaturesWithStatus[blockFeature.id] = blockFeature;
    if (!acc.blocksGroupedByRanch[blockFeature.properties.ranchId]) {
      acc.blocksGroupedByRanch[blockFeature.properties.ranchId] = [];
    }
    acc.blocksGroupedByRanch[blockFeature.properties.ranchId].push(cloneDeep(blockFeature));
    return acc;
  }, {
    blocksFeaturesWithStatus: {},
    blocksGroupedByRanch: {}
  });
  const {
    blocksGroupedByRanch
  } = blocksWithStatusAndByRanch;
  const ranchesFeaturesWithStatus = Object.values(ranchesWithSoilStateFeatures || ranchesFeatures).reduce((acc, ranchFeature) => {
    if (soilState === Object(soilState) && soilState.id === ranchFeature.id) {
      ranchFeature.properties = {
        ...cloneDeep(ranchFeature.properties),
        ...cloneDeep(soilState)
      };
    }
    let connectivityState = 5;
    let waterPressureState = 0;
    let controlState = 0;
    let provisionState = 5;
    if (blocksGroupedByRanch[ranchFeature.id]) {
      const blockFeaturesByRanchId = blocksGroupedByRanch[ranchFeature.id];
      for (let i = 0; i < blockFeaturesByRanchId.length; i += 1) {
        const {
          connectivityState: blockConnectivityState,
          waterPressureState: blockWaterPressureState,
          controlState: blockControlState,
          provisionState: blockProvisionState
        } = blockFeaturesByRanchId[i].properties;
        if (blockConnectivityState < connectivityState) {
          connectivityState = blockConnectivityState;
        }
        if (blockWaterPressureState > waterPressureState) {
          waterPressureState = blockWaterPressureState;
        }
        if (blockControlState > controlState) {
          controlState = blockControlState;
        }
        if (blockProvisionState < provisionState) {
          provisionState = blockProvisionState;
        }
      }
    }
    ranchFeature.properties.connectivityState = connectivityState;
    ranchFeature.properties.provisionState = provisionState;
    ranchFeature.properties.waterPressureState = waterPressureState;
    ranchFeature.properties.controlState = controlState;
    ranchFeature.properties.otherStatesAvailable = true;
    acc[ranchFeature.id] = cloneDeep(ranchFeature);
    return acc;
  }, {});
  return {
    sensorFeatures: cloneDeep(sensorsWithStatusAndByBlocks.sensorsFeaturesWithStatus),
    blockFeatures: cloneDeep(blocksWithStatusAndByRanch.blocksFeaturesWithStatus),
    ranchFeatures: cloneDeep(ranchesFeaturesWithStatus)
  };
};

// TODO: Move this to component level for map components
const prepareRanchesData = ({
  ranches,
  soilState
}) => {
  const ranchesFeatures = ranches.reduce((acc, ranch) => {
    if (!ranch.bounds) {
      return acc;
    }
    try {
      const ranchFeature = {
        id: ranch.id,
        type: 'Feature',
        geometry: cloneDeep(ranch.bounds),
        properties: cloneDeep(ranch)
      };
      ranchFeature.properties.entityId = ranch.entity === Object(ranch.entity) ? ranch.entity.id : ranch.entity;
      ranchFeature.properties.type = 'ranch';
      try {
        ranchFeature.properties.squareMeters = area(ranchFeature);
      } catch (error) {
        console.log('ERROR ranchFeature in utils.js', ranchFeature, error);
      }
      ranchFeature.properties.acres = Number((ranchFeature.properties.squareMeters / 4046.86).toFixed(1));
      acc[ranch.id] = ranchFeature;
    } catch (e) {
      console.log('ERROR broken data for the ranch in utils.js', ranch, e);
    }
    return acc;
  }, {});
  if (!soilState) {
    return {
      ranchesFeatures,
      noState: true
    };
  }
  const ranchesFeaturesWithStatus = Object.values(ranchesFeatures).reduce((acc, ranchFeature) => {
    if (soilState[ranchFeature.id]) {
      ranchFeature.properties = {
        ...cloneDeep(ranchFeature.properties),
        ...cloneDeep(soilState[ranchFeature.id])
      };
    }
    acc[ranchFeature.id] = cloneDeep(ranchFeature);
    return acc;
  }, {});
  return {
    ranchesFeaturesWithStatus
  };
};

/* eslint-disable no-await-in-loop */
function prepareRanchBlockData(dispatch, sensors, blocks, ranches, soilState, recommendationBlocks, sensorStates) {
  const {
    sensorFeatures,
    blockFeatures,
    ranchFeatures
  } = prepareData({
    sensors,
    blocks,
    ranches,
    soilState,
    sensorStates,
    recommendationBlocks
  });
  if (Object.keys(ranchFeatures).length) {
    dispatch(setRanchesGeoJSON({
      ranchesFeatures: ranchFeatures
    }));
  }
  if (Object.keys(blockFeatures).length) {
    dispatch(setBlocksGeoJSON({
      blocksFeatures: blockFeatures
    }));
  }
  if (Object.keys(sensorFeatures).length) {
    dispatch(setSensorsStateForGeoJSON({
      sensorsFeatures: sensorFeatures
    }));
  }
}
/**
 * If ranchIds is undefined or [] then only GeoJSON for ranches gets prepared
 * @param {*} ranchIds
 * @returns
 */
const loadAndPrepareMapDataByRanchIds = (ranchIds, filterSensor, skipSensorsCall, isAllRanches, type) => async (dispatch, getState) => {
  // Clear existing request state entry from redux-state for the API calls
  await dispatch(cleanBlocksListRequestState$1());
  await dispatch(cleanRanchesListRequestState$1());
  await dispatch(cleanEntitiesListRequestState());
  await dispatch(cleanSensorsFetchState());

  // TODO: seleted entity can be a a single object for active entity instead of an array
  const activeEntity = selectSelectedEntity(getState()).payload[0];

  // TODO:Reducer is it the same as getting all ranches the current implementation only has the blocks related to the ranch
  // Get all ranches data
  const ranches = selectAllNewRanches$1(getState()) || [];
  const ranchId = ranchIds[0]; // To prepare data when single ranch is selected

  // Get all blocks data that for the selected ranch
  const blocks = selectNewBlocksForRanchId(getState(), ranchId) || [];

  // Get all sensors data that for the selected ranch
  const allSensors = selectSensorsByRanchId(getState(), ranchId) || [];
  const blockIds = blocks.map(b => b.id); // To get block ids from block data
  // Get recommendations data for the block ids
  const recommendationBlocks = groupBy(selectRecommendationsForBlocks(getState(), blockIds), 'block');
  if (!ranches.length) await Promise.allSettled([dispatch(loadNewRanchList(activeEntity))]);
  if (!isAllRanches && !blocks.length) await Promise.allSettled([dispatch(loadNewBlockList(activeEntity))]);

  // To prepare ranches features to render ranch markers and ranch boundary
  const {
    ranchesFeatures
  } = prepareRanchesData({
    ranches
  });

  // This will be uncommented/removed in the future after confirmation
  // Reason: Currently, aggregated "entities/state" for all the ranches takes more time
  //        and it's affecting the performance. so Robin asked to HOLD on that
  //        So, We are not showing the aggregated status for the ranches on the map.
  // const soilStateLastUpdated = getState().farmData.soilstate.lastUpdated || 100000000;
  // const soilStateElapsedSecondsUpdate = Math.round((Date.now() - soilStateLastUpdated) / 1000);

  // setTimeout(async () => {
  //   try {
  //     if (!skipSensorsCall) {
  //       if (soilStateElapsedSecondsUpdate > secondsAllowed) {
  //         await dispatch(loadSoilState());
  //       }

  //       const soilState = selectSoilStateCollectionObj(getState());
  //       const { ranchesFeaturesWithStatus } = prepareRanchesData({
  //         ranches,
  //         soilState,
  //       });

  //       if (Object.keys(ranchesFeaturesWithStatus).length) {
  //         dispatch(setRanchesGeoJSON({
  //           ranchesFeatures: ranchesFeaturesWithStatus,
  //         }));
  //       }
  //     }
  //   } catch (error) {
  //     console.log('loadSoilState all error', error);
  //   }
  // }, 0);

  // Setting ranch features at "all ranches" level
  // to render ranch markers on the map page if ranch data available
  // Below logic will set the ranchFeatures and exit from the function at "all ranches" level
  if (isAllRanches && ranches.length) {
    if (Object.keys(ranchesFeatures).length) {
      dispatch(setRanchesGeoJSON({
        ranchesFeatures
      }));
    }
    return;
  }
  let sensorFeaturesAll = {};
  let blockFeaturesAll = {};
  let ranchFeaturesAll = {};
  let sensorsAll = [];
  let sensorsByRanchesObj = [];
  const errMsg = [];
  let sensors = [];
  let soilState = {};
  // To skip accessing soil state data from state or some presentation modes
  // like (irrigation recommendation, anomalies and plants)
  if (!skipSensorsCall) soilState = selectSoilStateCollectionObj(getState());
  if (!skipSensorsCall) await dispatch(loadSensorsRanch$2(ranchId));

  // To call the sensors/all API when there is no data in redux-state
  // To skip calling API for some presentation modes
  // like (irrigation recommendation, anomalies and plants)
  if (!skipSensorsCall && !allSensors.length && !isAllRanches) {
    await dispatch(loadPaginatedSensorsRanch(ranchId));
  }
  if (!skipSensorsCall) {
    // Filter sensors by installed_state is 'installed' and visible is true
    if (allSensors && allSensors.length) {
      sensors = allSensors.filter(sensor => sensor && sensor.install_state === 'installed' && sensor.visible);
    }
  }

  // To prepare the ranch, block and sensor features with sensor status
  // If the sensor status data available in "localstorage"
  const prevSensorsByRanchesObj = localStorage.getItem('sensorsByRanchesObj');
  const prevSensorStates = JSON.parse(prevSensorsByRanchesObj);
  if (prevSensorStates && prevSensorStates[ranchId]) {
    prepareRanchBlockData(dispatch, sensors, blocks, ranches, soilState[ranchId], recommendationBlocks, prevSensorStates && prevSensorStates[ranchId]);
  }

  // To get sensor state for the sensors that for the selected ranch
  // This logic will execute only for single ranch/block selections
  //      - and for some presentation modes like (irrigation recommendation, anomalies and plants)
  // Skip the sensor status filtering logic when the block is selected,
  // as sensors are already filtered at the ranch level.
  if (!skipSensorsCall && !isAllRanches && type !== 'block') {
    sensorsAll = sensorsAll.concat(sensors);
    if (filterSensor) {
      sensorsAll.filter(d => d && d.type !== filterSensor);
    }
    const sensorRanchRelationObj = sensorsAll.reduce((acc, sensor) => {
      acc[sensor.id] = sensor.ranch;
      return acc;
    }, {});

    // To get sensor state for the sensors by ranchID with exclude sensor types
    const [sensorsState] = await Promise.allSettled([sensorApi$2.loadSensorStatusForSelectorTypeAndId(type, ranchId, filterSensor)]);
    if (sensorsState.status !== 'fulfilled') {
      errMsg.push('Problem loading sensors state.');
    }
    sensorsByRanchesObj = sensorsState.value.data.reduce((acc, curr) => {
      if (curr && curr.id && sensorRanchRelationObj[curr.id]) {
        const ranchIdFromObj = sensorRanchRelationObj[curr.id];
        if (!acc[ranchIdFromObj]) {
          acc[ranchIdFromObj] = [];
        }
        acc[ranchIdFromObj].push(curr);
      }
      return acc;
    }, {});

    // Refill the sensors data for the ranch if it's available in "localstorage"
    // when page auto refresh
    if (sensorsByRanchesObj && !sensorsByRanchesObj[ranchId] && prevSensorStates && prevSensorStates[ranchId]) {
      sensorsByRanchesObj = prevSensorStates;
    }

    // To set sensor status by ranchid to "localstorage"
    if (sensorsByRanchesObj && sensorsState && sensorsState.value) {
      localStorage.setItem('sensorsByRanchesObj', JSON.stringify(sensorsByRanchesObj));
    }
  }

  // To prepare ranch, block, and sensor features with sensor status
  const {
    sensorFeatures,
    blockFeatures,
    ranchFeatures
  } = prepareData({
    sensors,
    blocks,
    ranches,
    soilState: soilState[ranchId],
    sensorStates: sensorsByRanchesObj[ranchId],
    recommendationBlocks
  });
  sensorFeaturesAll = {
    ...sensorFeatures,
    ...cloneDeep(sensorFeaturesAll)
  };
  blockFeaturesAll = {
    ...blockFeatures,
    ...cloneDeep(blockFeaturesAll)
  };
  ranchFeaturesAll = {
    ...ranchFeatures,
    ...cloneDeep(ranchFeaturesAll)
  };
  if (Object.keys(ranchFeaturesAll).length) {
    dispatch(setRanchesGeoJSON({
      ranchesFeatures: ranchFeaturesAll
    }));
  }
  if (Object.keys(blockFeaturesAll).length) {
    dispatch(setBlocksGeoJSON({
      blocksFeatures: blockFeaturesAll
    }));
  }
  if (Object.keys(sensorFeaturesAll).length) {
    dispatch(setSensorsStateForGeoJSON({
      sensorsFeatures: sensorFeaturesAll
    }));
  }
  if (errMsg.length) {
    throw new Error(errMsg.join(' '));
  }
};
function useSensor(sensor = {}) {
  const dispatch = useDispatch();
  const sensorFound = useSelector(state => selectSensorByParams(state, sensor));
  // if sensor params change, load sensor from database
  // uses original params (sensor) not sensorFound
  const {
    identifier,
    type,
    id
  } = sensor || {};
  useEffect(() => {
    if (type && identifier) {
      dispatch(loadSensorDetail$2({
        type,
        identifier
      }));
    } else if (type && id) {
      dispatch(loadSensorDetailById$2({
        type,
        id
      }));
    }
  }, [identifier, type, id, dispatch]);
  return sensorFound;
}
function useSensorNames(entityId, sensorTypeAllowedForMode, installState) {
  const ranchIds = useSelector(state => selectAllNewRanchIds(state)) || [];
  const sensors = useSelector(state => selectSensorsForRanchIds(state, ranchIds, sensorTypeAllowedForMode, installState)) || [];
  return sensors.reduce((a, d) => ({
    ...a,
    [`${d.type}/${d.identifier}`]: d.name
  }), {});
}
function useSensorsForEntity(entityId, sensorTypeAllowedForMode, installState) {
  const entities = useSelector(state => selectAllNewEntities(state)) || [];
  const ranchIds = entities.filter(entity => entity.id === entityId).map(entity => entity.ranches).flat().map(ranch => ranch.id);
  const sensors = useSelector(state => selectSensorsForRanchIds(state, ranchIds, sensorTypeAllowedForMode, installState)) || [];
  return sensors.reduce((a, d) => ({
    ...a,
    [`${d.type}/${d.identifier}`]: d
  }), {});
}
function useEntity(id) {
  const dispatch = useDispatch();
  const entity = useSelector(state => selectEntityById(state, id));
  useEffect(() => {
    // TODO: load entity by id, rather than whole list
    dispatch(loadEntityList());
  }, [dispatch]);
  return entity;
}
function useEntityNames(ids) {
  const entities = useSelector(state => selectAllNewEntities(state));
  if (!ids || !ids.length) return {};
  const filteredEntities = entities.filter(d => ids.some(id => id === d.id));
  return filteredEntities.reduce((a, entity) => {
    a[entity.id] = entity.name;
    return a;
  }, {});
}
function useEntities$2() {
  const entities = useSelector(selectAllNewEntities);
  const loadingState = useSelector(selectNewEntitiesLoadingState);
  const selectPersistedEntityId = useSelector(state => selectSelectedEntity(state)).payload;
  const persistedEntityId = selectPersistedEntityId ? selectPersistedEntityId[0] : null;
  const userInfo = useSelector(state => selectLoginUserInfo(state)).payload;
  const isAdmin = userInfo && userInfo.admin;
  const activeEntityId = useSelector(selectEntityId);
  const [currentEntityId, setCurrentEntityId] = useState(null);
  useEffect(() => {
    if (activeEntityId && hasEntity(entities, activeEntityId)) {
      setCurrentEntityId(activeEntityId);
    } else if (persistedEntityId && hasEntity(entities, persistedEntityId)) {
      setCurrentEntityId(persistedEntityId);
    } else if (isAdmin && hasEntity(entities, process.env.REACT_APP_DEFAULT_ENTITY_ID)) {
      setCurrentEntityId(process.env.REACT_APP_DEFAULT_ENTITY_ID);
    } else if (entities.length > 0) {
      setCurrentEntityId(entities[0].id);
    }
  }, [isAdmin, entities, activeEntityId, persistedEntityId]);
  useEffect(() => {}, [currentEntityId, persistedEntityId]);
  const selectedEntity = useSelector(state => selectEntityById$1(state, currentEntityId));
  return {
    entities,
    selectedEntity,
    activeEntityId,
    loadingState
  };
}
function useRanch(id) {
  const dispatch = useDispatch();
  const ranch = useSelector(state => selectNewRanchById$1(state, id));
  useEffect(() => {
    // dispatch(loadRanchList());
  }, [dispatch]);
  return ranch;
}
function useRanchNames$1(ids, useOldFarmData = false) {
  const ranches = useSelector(state => selectAllNewRanches$1(state));
  const olApiRanches = useSelector(selectAllRanches$1);
  if (!ids || !ids.length) return {};
  let allRanches = ranches;
  if (useOldFarmData) allRanches = olApiRanches;
  const filteredRanches = allRanches.filter(d => ids.some(id => id === d.id));
  return filteredRanches.reduce((a, ranch) => {
    a[ranch.id] = ranch.name;
    return a;
  }, {});
}

// Nowhere used
function useEntityRanchBlock$1(data) {
  const finalData = useRef([]);
  const entity = useRef([]);
  const ranch = useRef([]);
  const block = useRef([]);
  // Get all entities, blocks and ranches
  // const allEntities = useSelector((state) => selectAllEntities(state));
  // const allRanches = useSelector((state) => selectAllRanches(state));
  // const allBlocks = useSelector((state) => selectAllBlocks(state));

  const {
    selectedEntity
  } = useEntities$2();
  const allEntities = [selectedEntity];
  const allRanches = useSelector(state => selectAllNewRanches$1(state));
  const allBlocks = useSelector(state => selectAllNewBlocks$1(state));
  useEffect(() => {
    if (JSON.stringify(entity.current) !== JSON.stringify(allEntities)) {
      entity.current = allEntities;
    }
    if (JSON.stringify(ranch.current) !== JSON.stringify(allRanches)) {
      ranch.current = allRanches;
    }
    if (JSON.stringify(block.current) !== JSON.stringify(allBlocks)) {
      block.current = allBlocks;
    }
  }, [allBlocks, allEntities, allRanches]);

  // Function to process data and return array of data objects
  const processData = useCallback((entityData, blockData, ranchData) => {
    const resultData = [];
    // Get ranchIds, BlockIds and entityIds from blockData
    const entityIdFromBlock = blockData.map(d => d.ranch && d.ranch.entity && d.ranch.entity.id);
    const ranchIdFromBlock = blockData.map(d => d.ranch && d.ranch.id);
    const blockIdFromBlock = blockData.map(d => d && d.id);

    // Get ranchIds, BlockIds and entityIds from ranchData
    const entityIdFromRanch = ranchData.map(d => d.entity && d.entity.id);
    const ranchIdFromRanch = ranchData.map(d => d && d.id);
    const BlockIdFromRanch = [];
    ranchData.forEach(d => {
      const bid = block.current.filter(b => b.ranch && b.ranch.id === d.id);
      if (bid.length) {
        bid.forEach(bi => BlockIdFromRanch.push(bi.id));
      }
    });

    // Get ranchIds, BlockIds and entityIds from entityData
    const entityIdFromEntity = entityData.map(d => d && d.id);
    const ranchIdFromEntity = [];
    entityData.forEach(d => {
      const rid = ranch.current.filter(r => r.entity && r.entity.id === d.id);
      if (rid.length) {
        rid.forEach(ri => ranchIdFromEntity.push(ri.id));
      }
    });
    const BlockIdFromEntity = [];
    entityData.forEach(d => {
      const bid = block.current.filter(b => b.ranch && b.ranch.entity && b.ranch.entity.id === d.id);
      if (bid.length) {
        bid.forEach(bi => BlockIdFromEntity.push(bi.id));
      }
    });

    // Merge all entityIds and get unique list from that
    // Similarly it does the same process for blockIds and ranchIds also
    const allEntity = entityIdFromBlock.concat(entityIdFromRanch.concat(entityIdFromEntity)).filter((v, i, a) => a.indexOf(v) === i);
    const allRanch = ranchIdFromBlock.concat(ranchIdFromRanch.concat(ranchIdFromEntity)).filter((v, i, a) => a.indexOf(v) === i);
    const allBlock = blockIdFromBlock.concat(BlockIdFromRanch.concat(BlockIdFromEntity)).filter((v, i, a) => a.indexOf(v) === i);

    // Filter the data objects based on merged ids
    const filteredEntity = entity.current.filter(d => allEntity.indexOf(d.id) >= 0);
    const filteredRanch = ranch.current.filter(d => allRanch.indexOf(d.id) >= 0 && allEntity.indexOf(d.entity && d.entity.id) >= 0);
    const filteredBlock = block.current.filter(d => allBlock.indexOf(d.id) >= 0 && allRanch.indexOf(d.ranch && d.ranch.id) >= 0);

    // Get data objects for each entity and push to resultData
    filteredEntity.forEach(eEntity => {
      const obj = {
        id: eEntity.id,
        name: eEntity.name,
        ranches: [],
        isLoading: true
      };
      const ranchFromFilteredRanch = filteredRanch.filter(e => e.entity && e.entity.id === eEntity.id);
      if (ranchFromFilteredRanch.length) {
        ranchFromFilteredRanch.forEach(eRanch => {
          const rObj = {
            id: eRanch.id,
            name: eRanch.name,
            blocks: [],
            isLoading: true
          };
          const blockFromFilteredBlock = filteredBlock.filter(e => e.ranch && e.ranch.id === eRanch.id);
          if (blockFromFilteredBlock.length) {
            blockFromFilteredBlock.forEach((eBlock, eBlockIndex) => {
              const bObj = {
                id: eBlock.id,
                name: eBlock.name,
                crop: eBlock.crop
              };
              rObj.isLoading = false;
              rObj.blocks.push(bObj);
              if (blockFromFilteredBlock.length === eBlockIndex + 1) {
                obj.isLoading = false;
                obj.ranches.push(rObj);
              }
            });
          } else {
            obj.isLoading = false;
            obj.ranches.push(rObj);
            if (block.current.length) rObj.isLoading = null;
          }
        });
      } else if (ranch.current.length) obj.isLoading = null;
      resultData.push(obj);
    });
    return resultData;
  }, []);
  function definedStructure(obj, attrs) {
    let tmp = obj;
    for (let i = 0; i < attrs.length; i += 1) {
      if (tmp[attrs[i]] && !tmp[attrs[i]].length) {
        return false;
      }
      if (tmp[attrs[i]] && tmp[attrs[i]].length) {
        const innerObj = tmp[attrs[i]][0];
        tmp = innerObj;
      }
    }
    return true;
  }

  // Check for valid structure of options
  let isValidOption = false;
  if (data && data.length) {
    for (let i = 0; i < data.length; i += 1) {
      isValidOption = definedStructure(data[i], ['ranches', 'blocks']); // option must have these keys
      if (isValidOption) break;
    }
  }
  const newList = processData(entity.current || [], block.current || [], ranch.current || []);
  useEffect(() => {
    if (JSON.stringify(finalData.current) !== JSON.stringify(newList)) {
      finalData.current = newList;
    }
  }, [newList]);
  const isSameOptions = JSON.stringify(finalData.current) === JSON.stringify(data);
  useEffect(() => {
    if (!finalData.current.length) return;
    // To generate option if invalid or if new ranch is removed or added
    if (!isValidOption || !isSameOptions) {
      // sort data in alphabetical order
      if (finalData.current && finalData.current.length) {
        finalData.current = finalData.current.map(d => {
          const obj = d;
          obj.ranches.sort((a, b) => a && a.name.toLowerCase().localeCompare(b && b.name.toLowerCase()));
          obj.ranches.map(r => {
            const rObj = r;
            rObj.blocks.sort((a, b) => a && a.name.toLowerCase().localeCompare(b && b.name.toLowerCase()));
            return rObj;
          });
          return obj;
        });
        finalData.current = finalData.current.sort((a, b) => a && a.name.toLowerCase().localeCompare(b && b.name.toLowerCase()));
      }
    }
  }, [isSameOptions, isValidOption]);
  return finalData.current;
}

/**
 * Custom hook to generate a key-value pair based on the provided entity ID,
 * ranch IDs, and block IDs.
 *
 * @param {string} entityId - Id of the entity.
 * @param {Array<string>} ranchIds - An array of ranch IDs.
 * @param {Array<string>} blockIds - An array of block IDs.
 * @returns {Object} An object containing the generated key, value, and type.
 * @returns {string} return.key - key based on input.
 * @returns {string} return.value - value based on input.
 * @returns {string} return.type - type based on input (e.g., 'block', 'ranch', 'entity', or 'All Ranches').
 *
 */
function useKeyGeneration(entityId = [], ranchIds = [], blockIds = []) {
  let value;
  let key;
  let type;
  const blockIdsFromState = useSelector(state => selectAllNewBlockIds(state));
  const ranchIdsFromState = useSelector(state => selectAllNewRanchIds(state));
  let isValidRanch;
  if (ranchIds && ranchIds.length) {
    isValidRanch = ranchIdsFromState.indexOf(ranchIds[0]) >= 0;
  }
  let isValidBlock;
  if (blockIds && blockIds.length) {
    isValidBlock = blockIdsFromState.indexOf(blockIds[0]) >= 0;
  }
  if (isValidBlock && blockIds && blockIds.length) {
    value = `${blockIds[0]}`;
    key = `${blockIds[0]}`;
    type = 'block';
  } else if (isValidRanch && entityId && entityId.length && ranchIds && ranchIds.length) {
    value = `${ranchIds[0]}`;
    key = `${entityId[0]}_${ranchIds[0]}`;
    type = 'ranch';
  } else if (entityId && entityId.length) {
    value = `${entityId[0]}`;
    key = `${entityId[0]}`;
    type = 'entity';
  } else if (!isValidBlock && !isValidRanch) {
    key = 'All Ranches';
    type = 'All Ranches';
    value = 'All Ranches';
  }
  return {
    key,
    value,
    type
  };
}
function useRanchBlockSelection() {
  const block = useSelector(state => selectSelectedBlock(state)).payload || [];
  const ranch = useSelector(state => selectSelectedRanch(state)).payload || [];
  const entity = useSelector(state => selectSelectedEntity(state)).payload || [];
  const selectedObjFromState = useKeyGeneration(entity, ranch, block);
  const blocksFromState = useSelector(state => selectNewBlocksForRanchBlockSelection(state, selectedObjFromState));

  // Memoized blocks array
  const blockArray = useMemo(() => blocksFromState.map(b => ({
    id: b.id,
    name: b.name,
    vfd: b.vfd,
    valve: b.valve,
    ranchId: b.ranch,
    valves: b.valves,
    vfds: b.vfds
  })), [blocksFromState]);

  // Memoized blocks ids
  const blockIds = useMemo(() => blocksFromState.map(b => b.id), [blocksFromState]);

  // Memoized new Object
  const newObj = useMemo(() => ({
    block,
    ranch,
    entity,
    selectedObjFromState,
    blockArray,
    blockIds
  }), [block, ranch, entity, selectedObjFromState, blockArray, blockIds]);
  return newObj;
}
function useBlock(id) {
  const dispatch = useDispatch();
  const block = useSelector(state => selectNewBlockById$1(state, id));
  useEffect(() => {
    dispatch(loadBlockList());
  }, [dispatch]);
  return block;
}
function useBlockNames$2(ids, useOldFarmData = false) {
  const blocks = useSelector(state => selectAllNewBlocks$1(state));
  const olApiBlocks = useSelector(selectAllBlocks$1);
  if (!ids || !ids.length) return {};
  let allBlocks = blocks;
  if (useOldFarmData) allBlocks = olApiBlocks;
  const filteredBlocks = allBlocks.filter(d => ids.some(id => id === d.id));
  return filteredBlocks.reduce((a, block) => {
    a[block.id] = block.name;
    return a;
  }, {});
}
function useRanchNamesForBlocks(ids) {
  const blocks = useSelector(state => selectAllNewBlocks$1(state));
  if (!ids || !ids.length) return {};
  const filteredBlocks = blocks.filter(d => ids.some(id => id === d.id));
  return filteredBlocks.reduce((a, block) => {
    a[block.id] = block.ranch && block.ranch.name;
    return a;
  }, {});
}
function useBlockIdsForRanchIds() {
  const entites = useSelector(state => selectAllNewEntities(state));
  const ranches = entites.map(d => d.ranches).flat();
  const ranchObj = ranches.reduce((a, b) => {
    const obj = {
      ...a
    };
    obj[b.id] = b.blocks.map(d => d.id);
    return obj;
  }, {});
  return ranchObj;
}
const isMobile$1 = window.innerWidth < 599;

// Set URL param from state
function useSetURLFromState(urlSearch, search, pathname, scheduleInputData, locationState) {
  /**
   * Funtion to create param string
   * @param {*} blocks - Input blocks from state
   * @returns param string
   */
  function createParamStr(blocks) {
    const startDate = scheduleInputData.dateRange.length ? scheduleInputData.dateRange[0] : null;
    const endDate = scheduleInputData.dateRange.length ? scheduleInputData.dateRange[1] : null;
    const params = {};

    // create sensor params
    if (blocks && blocks.length) {
      params.blockId = blocks.join(',');
    }
    if (scheduleInputData.irrigationTypes) params.irrigationTypes = scheduleInputData.irrigationTypes.join(',');
    if (startDate) params.startDate = startDate.toISOString();
    if (endDate) params.endDate = endDate.toISOString();
    if (scheduleInputData.radioOption) params.radioOption = scheduleInputData.radioOption;
    let paramStr = Object.keys(params).map(key => `${key}=${params[key]}`).join('&');
    if (paramStr.length) paramStr = `?${paramStr}`;
    return paramStr;
  }
  const ranchId = useSelector(selectSelectedRanch).payload;
  const blockIds = useSelector(selectSelectedBlocks).payload || [];
  const blockIdMobile = useSelector(selectSelectedBlock).payload || [];
  const history = useHistory();
  let paramStr;
  if (scheduleInputData) {
    paramStr = createParamStr(blockIds);
  }
  useEffect(() => {
    if (!isMobile$1) {
      // If not mobile screen and ranchId exist in state
      if (ranchId && ranchId.length && (pathname.includes('control') || pathname.includes('dashboard')) && (!urlSearch.current.includes(ranchId[0]) || !search.includes(ranchId[0]))) {
        history.push({
          search: `?ranchId=${ranchId[0]}`
        });
        urlSearch.current = `?ranchId=${ranchId[0]}`;
      }
      // Handle the schedule page URL update logic
      if (blockIds && scheduleInputData && pathname.includes('schedule') && !urlSearch.current.includes('ranchId') && (!urlSearch.current || search !== paramStr)) {
        history.replace({
          pathname,
          search: paramStr
        });
        urlSearch.current = paramStr;
      }
    } else if (isMobile$1 && ranchId && ranchId.length && blockIdMobile && !blockIdMobile.length && !urlSearch.current.includes(ranchId[0])) {
      // If mobile screen and only ranchId exist in state
      history.push({
        search: `?ranchId=${ranchId[0]}`,
        state: locationState
      });
      urlSearch.current = `?ranchId=${ranchId[0]}`;
    } else if (isMobile$1 && ranchId && !ranchId.length && blockIdMobile && blockIdMobile.length && !urlSearch.current.includes(blockIdMobile[0])) {
      // If mobile screen and only blockId exist in state
      history.push({
        search: `?blockId=${blockIdMobile[0]}`,
        state: locationState
      });
      urlSearch.current = `?blockId=${blockIdMobile[0]}`;
    }
  }, [blockIds, scheduleInputData, history, paramStr, pathname, ranchId, search, urlSearch, locationState, blockIdMobile]);
}

// Reading URL param and set to state
function useSetStateFromURL(urlSearch) {
  const ranchId = useSelector(selectSelectedRanch).payload || [];
  const blockIds = useSelector(selectSelectedBlocks).payload || [];
  const urlLoad = useSelector(selectUrlLoad).payload;
  const dispatch = useDispatch();
  if (urlSearch.current) {
    const params = new URLSearchParams(urlSearch.current);
    const ranchIdParam = params.get('ranchId');
    const blockIdParam = params.get('blockId');
    let blockIdsFromURL;
    if (blockIdParam) {
      blockIdsFromURL = blockIdParam.split(',').filter(d => d.length > 0).map(d => Number(d));
    }

    // If not mobile screen
    if (!isMobile$1) {
      // Only for control page and ranchId param exist in the URL
      // Set ranchId to state only if not already exist
      if (urlLoad && ranchIdParam && ranchId && Number(ranchIdParam) && !urlSearch.current.includes(ranchId[0]) && !urlSearch.current.includes('blockId')) {
        dispatch(setRanch(Number(ranchIdParam)));
        dispatch(setUrlLoad$1(false));
      }
      // Only for schedule page and blockId param exist in the URL
      // Set blockIds to state only if not already exist
      if (urlLoad && (blockIdsFromURL || blockIds && blockIds.length) && !urlSearch.current.includes(`blockId=${blockIds.join(',')}&`) && !urlSearch.current.includes('ranchId')) {
        dispatch(setBlocks(blockIdsFromURL));
        dispatch(setUrlLoad$1(false));
      }
    } else if (isMobile$1 && urlLoad && ranchIdParam && Number(ranchIdParam) && !blockIdParam) {
      // If mobile screen and only ranchId exist in URL
      dispatch(setRanchMobile(Number(ranchIdParam)));
      dispatch(setUrlLoad$1(false));
    } else if (isMobile$1 && urlLoad && blockIdParam && Number(blockIdParam)) {
      // If mobile screen and blockId exist in URL
      dispatch(setBlockMobile([Number(blockIdParam)]));
      dispatch(setUrlLoad$1(false));
    }
  }
}
const REFRESH_INTERVAL$1 = 1000 * 60 * Number(process.env.REACT_APP_DEVICE_PAGE_REFRESH_INTERVAL_MIN || 15);
function useLoadStatus(list, autoRefresh = true) {
  const dispatch = useDispatch();
  const [prevList, setPrevList] = useState([]);
  const [execute, setExecute] = useState(false);
  const intervalIds = useRef([]);

  // To avoid re-rendering for same values
  const prevListStr = JSON.stringify(prevList);
  const currListStr = JSON.stringify(list);
  function refreshUntilUnmount() {
    const intervalId = setInterval(() => {
      setPrevList([]);
      if (sessionStorage.getItem('sensorList')) {
        sessionStorage.removeItem('sensorList');
      }
    }, REFRESH_INTERVAL$1);
    if (!intervalIds.current.includes(intervalId)) {
      intervalIds.current = [...intervalIds.current, intervalId];
    }
  }
  function clearRefreshInterval() {
    if (intervalIds.current.length) {
      intervalIds.current.forEach((id, i) => {
        clearInterval(id);
        if (intervalIds.current.length === i + 1) {
          intervalIds.current = [];
        }
      });
    }
  }

  // Trigger the refresh interval when component loads
  useEffect(() => {
    if (!autoRefresh) return;
    refreshUntilUnmount();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [autoRefresh]);

  // Clear the interval when component unmounts
  useEffect(() => () => {
    clearRefreshInterval();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // To update the previous list by comparing current list
  useEffect(() => {
    if (prevListStr !== currListStr && list.length) {
      setPrevList(list);
      setExecute(true);
    }
  }, [currListStr, list, prevListStr]);
  useEffect(() => {
    if (prevList.length > 0 && execute) {
      const sensorList = JSON.parse(sessionStorage.getItem('sensorList')) || [];
      const sensorType = JSON.parse(sessionStorage.getItem('sensorType'));
      const {
        type
      } = prevList[0];

      // Set data to sessionStorage only if there is a change
      if (sensorType) {
        const updateSensorType = JSON.stringify({
          ...sensorType,
          [type]: true
        });
        if (sessionStorage.getItem('sensorType') !== updateSensorType) {
          sessionStorage.setItem('sensorType', updateSensorType);
        }
      } else {
        const newSensorType = JSON.stringify({
          [type]: true
        });
        if (sessionStorage.getItem('sensorType') !== newSensorType) {
          sessionStorage.setItem('sensorType', newSensorType);
        }
      }

      /**
       * When ranch block selection is changed,
       * only load status for missing items.
       */
      const itemsToBeFetched = prevList.filter(item => {
        const index = sensorList.findIndex(sl => sl === `${item.type}/${item.identifier}`);
        if (index === -1) {
          const sensorKey = `${item.type}/${item.identifier}`;
          if (!sensorList.includes(sensorKey)) {
            sensorList.push(sensorKey);
            return true;
          }
        }
        return false;
      });

      // To avoid setting same data multiple times to storage
      if (sessionStorage.getItem('sensorList') !== JSON.stringify(sensorList)) {
        sessionStorage.setItem('sensorList', JSON.stringify(sensorList));
      }
      itemsToBeFetched.forEach(item => {
        dispatch(loadSensorStatus$6({
          type: item.type,
          identifier: item.identifier
        }));
      });
      setExecute(false);
    }
  }, [dispatch, execute, prevList]);
}
function useLoadUserSettings() {
  const dispatch = useDispatch();
  useEffect(() => {
    const userSettingsLoaded = JSON.parse(sessionStorage.getItem('userSettingsLoaded'));
    if (!userSettingsLoaded) {
      sessionStorage.setItem('userSettingsLoaded', true);
      dispatch(loadUserSettings());
    }
  }, [dispatch]);
}

/**
 * @param {Number} value
 * @param {String} fromUnits
 * @param {String} toUnits
 * @returns {Number}
 */
function getConversion(value, fromUnits, toUnits, decimalPlaces = 1) {
  try {
    if (value === null || value === undefined || value === '') return 0;
    const key = `${fromUnits}_to_${toUnits}`;
    const convertMap = {
      // Flow units conversion
      gallons_per_minute_to_liters_per_minute: (value * 3.785412).toFixed(decimalPlaces),
      gallons_per_minute_to_gallons_per_hour: (value * 60).toFixed(decimalPlaces),
      gallons_per_minute_to_liters_per_hour: (value * 227.1247070).toFixed(decimalPlaces),
      gallons_per_hour_to_liters_per_minute: (value * 0.0630902).toFixed(decimalPlaces),
      gallons_per_hour_to_gallons_per_minute: (value / 60).toFixed(decimalPlaces),
      gallons_per_hour_to_liters_per_hour: (value * 3.78541).toFixed(decimalPlaces),
      // Power units conversion
      horsepower_to_kilowatts: (value * 0.7457).toFixed(decimalPlaces),
      // Temperature conversion
      degrees_fahrenheit_to_degrees_celsius: ((value - 32) * (5 / 9)).toFixed(decimalPlaces),
      degrees_celsius_to_degrees_fahrenheit: (value * (9 / 5) + 32).toFixed(decimalPlaces),
      // Length conversion
      feet_to_meters: (value * 0.3048).toFixed(decimalPlaces),
      meters_to_feet: (value * 3.28084).toFixed(decimalPlaces),
      inches_to_centimeters: (value * 2.54).toFixed(decimalPlaces),
      centimeters_to_inches: (value / 2.54).toFixed(decimalPlaces),
      millimeters_to_inches: (value / 25.4).toFixed(decimalPlaces),
      millimeters_to_centimeters: (value / 10).toFixed(decimalPlaces),
      inches_to_millimeters: (value * 25.4).toFixed(decimalPlaces),
      inches_to_cubic_meters: (value * 0.0254).toFixed(decimalPlaces),
      millimeters_to_cubic_meters: (value * 0.001).toFixed(decimalPlaces),
      inches_to_meters: (value * 0.0254).toFixed(decimalPlaces),
      cubic_meters_to_cubic_centimeters: (value * 1000000).toFixed(decimalPlaces),
      cubic_centimeters_to_cubic_inches: (value / 16.387).toFixed(decimalPlaces),
      cubic_inches_to_inches: (value / 1550).toFixed(decimalPlaces),
      meters_to_inches: (value * 39.3701).toFixed(decimalPlaces),
      meters_to_millimeters: (value * 1000).toFixed(decimalPlaces),
      // Volume conversion
      gallons_to_liters: (value * 3.785412).toFixed(decimalPlaces),
      gallons_to_acre_inches: (value / 27154.285714).toFixed(decimalPlaces),
      gallons_to_acre_feet: (value / 325851.4318891248).toFixed(decimalPlaces),
      gallons_to_cubic_meters: (value * 0.00378541).toFixed(decimalPlaces),
      cubic_meters_to_gallons: (value * 264.172052).toFixed(decimalPlaces),
      // 1 liter=0.264172 gallons
      liters_to_gallons: (value * 0.264172).toFixed(decimalPlaces),
      // 1 cubic meter is equal to 1000 liters
      cubic_meters_to_liters: (value * 1000).toFixed(decimalPlaces),
      liters_to_cubic_meters: (value / 1000).toFixed(decimalPlaces),
      gallons_to_cubic_inches: (value * 231).toFixed(decimalPlaces),
      liters_to_cubic_inches: (value * 61.0237).toFixed(decimalPlaces),
      // Area conversion
      acres_to_hectares: (value * 0.404686).toFixed(decimalPlaces),
      acres_to_square_miles: (value * 0.0015625).toFixed(decimalPlaces),
      acres_to_square_kilometers: (value * 0.00404686).toFixed(decimalPlaces),
      square_meters_to_square_kilometers: (value / 1000000).toFixed(decimalPlaces),
      square_meters_to_acres: (value / 4046.86).toFixed(decimalPlaces),
      square_meters_to_hectares: (value / 10000).toFixed(decimalPlaces),
      square_feet_to_square_meters: (value * 0.092903).toFixed(decimalPlaces),
      /**
       * 1 acre = 4046.86 square meters
       * 1 acre = 43560 square feet
       * 1 hectare = 10000 square meters
       * 1 square kilometer = 1,000,000 square meters
       * 1 mile = 5280 feet
       * 1 meter = 3.28084 feet
      */
      // Convert to square meeters
      square_kilometers_to_square_meters: (value * 1000000).toFixed(decimalPlaces),
      acres_to_square_meters: (value * 4046.86).toFixed(decimalPlaces),
      square_miles_to_square_meters: (value * 2589988.110336).toFixed(decimalPlaces),
      feet_to_square_meters: (value * 0.092903).toFixed(decimalPlaces),
      hectares_to_square_meters: (value * 10000).toFixed(decimalPlaces),
      meters_to_square_meters: (value * value).toFixed(decimalPlaces),
      // Convert to square feet
      square_kilometers_to_square_feet: (value * 10763910.4167).toFixed(decimalPlaces),
      acres_to_square_feet: (value * 43560).toFixed(decimalPlaces),
      square_miles_to_square_feet: (value * 27878400).toFixed(decimalPlaces),
      feet_to_square_feet: (value * value).toFixed(decimalPlaces),
      hectares_to_square_feet: (value * 107639.104167).toFixed(decimalPlaces),
      meters_to_square_feet: (value * 10.7639).toFixed(decimalPlaces),
      //  Convert from square meters
      square_meters_to_feet: (value * 3.28084).toFixed(decimalPlaces),
      square_meters_to_square_feet: (value * 10.7639).toFixed(decimalPlaces),
      square_meters_to_miles: (value / 1609.34).toFixed(decimalPlaces),
      square_meters_to_square_miles: (value / 2.59e6).toFixed(decimalPlaces),
      // Pressure conversion
      pounds_per_square_inch_to_mega_pascal: (value / 145.038).toFixed(decimalPlaces),
      mega_pascal_to_pounds_per_square_inch: (value * 145.038).toFixed(decimalPlaces)
    };
    return convertMap[key] !== undefined ? parseFloat(convertMap[key]) : parseFloat(Number(value).toFixed(decimalPlaces));
  } catch {
    return value;
  }
}

/**
 * @param {String} toUnits
 * @returns {String}
 */
const getShortLabel = toUnits => ({
  // Flow Units
  gallons_per_minute: 'GPM',
  gallons_per_hour: 'GPH',
  liters_per_minute: 'LPM',
  liters_per_hour: 'LPH',
  // Area Units
  square_miles: 'Sq Miles',
  square_kilometers: 'Sq Kms',
  // Volume Units
  acre_inches: 'Acre In',
  acre_feet: 'Acre Ft',
  cubic_meters: 'm³',
  // Length Units
  inches: 'in',
  centimeters: 'cm',
  millimeters: 'mm',
  // Power Units
  horsepower: 'HP',
  kilowatts: 'KW',
  // Temperature Units
  degrees_fahrenheit: '°F',
  degrees_celsius: '°C',
  // Frequency Units
  hertz: 'Hz',
  // Speed Units
  revolutions_per_minute: 'RPM',
  // Pressure Units
  pounds_per_square_inch: 'psi',
  mega_pascal: 'MPa'
})[toUnits] || toUnits;

/**
 * @param {String} toUnits
 * @returns {String}
 */
const getLongLabel = toUnits => ({
  // Flow Units
  gallons_per_minute: 'gallons per minute',
  gallons_per_hour: 'gallons per hour',
  liters_per_minute: 'liters per minute',
  liters_per_hour: 'liters per hour',
  // Area Units
  square_miles: 'square miles',
  square_kilometers: 'square kilometers',
  // Volume Units
  acre_inches: 'acre inches',
  acre_feet: 'acre feet',
  cubic_meters: 'cubic meters',
  // Length Units
  inches: 'inches',
  centimeters: 'centimeters',
  millimeters: 'millimeters',
  // Power Units
  horsepower: 'horsepower',
  kilowatts: 'kilowatts',
  // Temperature Units
  degrees_fahrenheit: 'degrees fahrenheit',
  degrees_celsius: 'degrees celsius',
  // Frequency Units
  hertz: 'hertz',
  // Speed Units
  revolutions_per_minute: 'revolutions per minute'
})[toUnits] || toUnits;

/**
 * @param {String} toUnits
 * @param {String} labelType
 * @returns {String}
 */
function getLabel(toUnits, labelType = 'short') {
  if (labelType === 'short') {
    return getShortLabel(toUnits);
  }
  return getLongLabel(toUnits);
}

/**
 * Example usage
 * const getUserUnits = useUnits();;
 * const convertedFlowRate = getUserUnits(flowRate, units.flowRate, 'flow_rate', options);
 * const toDisplay = `${convertedFlowRate.value} ${t(convertedFlowRate.label)}`;
 *
 * options may contain
 * {
 *   labelType: 'long',
 *   decimalPlaces: 2,
 * }
 */
function useUnits$1() {
  useLoadUserSettings();
  const toUnits = {
    length: useSelector(selectUserLengthFormat),
    depth: useSelector(selectUserDepthFormat),
    volume: useSelector(selectUserVolumeFormat),
    area: useSelector(selectUserAreaFormat),
    flow_rate: useSelector(selectUserFlowRateFormat),
    power: useSelector(selectUserPowerFormat),
    temperature: useSelector(selectUserTemperatureFormat),
    pressure: useSelector(selectUserPressureFormat)
  };
  function getUserUnits(value, fromUnit, unitType, options = {}, inputUnit) {
    const toUnit = toUnits[unitType] || fromUnit;
    const {
      labelType,
      decimalPlaces,
      inputUnit: optionsInputUnit
    } = options;
    const targetUnit = inputUnit || optionsInputUnit || toUnit;
    const convertedValue = getConversion(value, fromUnit, targetUnit, decimalPlaces);
    const unitsLabel = getLabel(targetUnit, labelType);

    // TODO remove after testing
    // console.log('value, fromUnit, inputUnit,toUnit, decimalPlaces',
    // value, fromUnit, inputUnit, toUnit, decimalPlaces);

    return {
      value: convertedValue,
      label: unitsLabel
    };
  }
  return getUserUnits;
}
const apiVersion = 'v2';
const baseUrl = 'https://farmx.zendesk.com/api';
const auth = `Basic ${process.env.REACT_APP_ZENDESK_API_AUTH}`;
const fetchZendeskContent = path => {
  const url = `${baseUrl}/${apiVersion}/${path}`;
  try {
    const options = {
      headers: {
        Authorization: auth,
        'Content-Type': 'application/json',
        Accept: 'application/json'
      }
    };
    return fetch(url, options).then(res => {
      if (res && res.status !== 200) {
        return {
          error: 'Unable to load data'
        };
      }
      return res.json();
    }).catch(res => {
      if (res && !res.error) {
        return res;
      }
      return {
        error: res.description || res.error
      };
    });
  } catch (e) {
    return Promise.resolve({
      error: e || 'Unable to load data'
    });
  }
};
function useZendesk() {
  useLoadUserSettings();
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const loadData = useCallback(async path => {
    setLoading(true);
    const response = await fetchZendeskContent(path);
    if (response.error) {
      setError(response.error);
      setData(null);
    } else {
      setError(null);
      setData(response);
    }
    setLoading(false);
  }, []);
  return [data, loading, error, loadData];
}

/**
 * Load article from Zendesk help center
 * @param {*} articleId
 * @returns {Array} [data, loading, error]
 */
function useZendeskHelpContent(articleId) {
  const locale = useSelector(selectUserLanguage);
  const userLocale = locale === 'en' ? 'en-us' : locale;
  const path = `help_center/${userLocale}/articles/${articleId}`;
  const [data, loading, error, loadContent] = useZendesk();
  useEffect(() => {
    loadContent(path);
  }, [loadContent, path]);
  return [data, loading, error];
}

/**
 * Perform search on Zendesk articles. The fourth item in the array is function.
 * This function can be called with search parameter to perform search.
 * @returns {Array} [data, loading, error, searchApi]
 */
function useZendeskSearch() {
  useLoadUserSettings();
  const locale = useSelector(selectUserLanguage);
  const userLocale = locale === 'en' ? 'en-us' : locale;
  const [data, loading, error, loadContent] = useZendesk();
  const getArticle = useCallback(query => {
    const params = new URLSearchParams({
      locale: userLocale,
      query
    });
    const path = `help_center/articles/search.json?${params}`;
    loadContent(path);
  }, [loadContent, userLocale]);
  return [data, loading, error, getArticle];
}

/**
 * Get all the help articles
 * TODO: Support pagination
 * @returns {Array} [data, loading, error]
 */
function useZendeskArticles() {
  const locale = useSelector(selectUserLanguage);
  const userLocale = locale === 'en' ? 'en-us' : locale;
  const path = `help_center/${userLocale}/articles`;
  const [data, loading, error, loadContent] = useZendesk();
  useEffect(() => {
    loadContent(path);
  }, [loadContent, path]);
  return [data, loading, error];
}
const getBase64 = file => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = () => resolve(reader.result);
  reader.onerror = error => reject(error);
});
/**
 * useCommentList: This functions takes the anomalyId and fetches the comment list
 * for the same.
 * It also returns the loading and error status and function to fetch the comment list.
 *
 * @param {*} anomalyId
 * @returns {list, loading, error, fetchCommentList}
 */
function useCommentList(anomalyId) {
  const [loading, setLoading] = useState(false);
  const [list, setList] = useState();
  const [error, setError] = useState();
  const fetchCommentList = useCallback(async () => {
    setError(null);
    setLoading(true);
    try {
      const response = await blockApi$2.getAnomalyComments(anomalyId);
      const {
        data
      } = response || {};
      setList(data || []);
      setLoading(false);
    } catch (e) {
      setError(e);
      setLoading(false);
    }
  }, [anomalyId]);
  const addComment = async (details, translate, onSuccess, onFailure) => {
    const {
      text,
      image
    } = details;
    if (!text && !image) {
      onFailure({
        message: `${translate('Please enter a comment or upload image')}.`
      });
      return;
    }
    try {
      const imageData = image ? await getBase64(image) : null;
      await blockApi$2.createAnomalyComment({
        text,
        image_path: imageData,
        anomaly: anomalyId
      });
      onSuccess();
      fetchCommentList();
    } catch (e) {
      onFailure({
        message: translate('Error in posting comment')
      });
    }
  };
  const editComment = async (details, translate, onSuccess, onFailure) => {
    const {
      text,
      image,
      id
    } = details;
    if (!text && !image) {
      onFailure({
        message: `${translate('Please enter a comment or upload image')}.`
      });
      return;
    }
    try {
      const imageData = image ? await getBase64(image) : null;
      await blockApi$2.updateAnomalyComment(id, {
        text,
        image_path: imageData
      });
      onSuccess();
      fetchCommentList();
    } catch {
      onFailure({
        message: `${translate('Error in updating comment')}.`
      });
    }
  };
  const deleteComment = async (id, translate, onSuccess, onFailure) => {
    try {
      await blockApi$2.deleteAnomalyComment(id);
      onSuccess();
      fetchCommentList();
    } catch {
      onFailure({
        message: `${translate('Error in deleting comment')}.`
      });
    }
  };
  useEffect(() => {
    fetchCommentList();
  }, [fetchCommentList]);
  return {
    list,
    loading,
    error,
    fetchCommentList,
    addComment,
    editComment,
    deleteComment
  };
}
var hooks = {
  useSensor,
  useLoadStatus,
  useBlock,
  useRanch,
  useEntity,
  useEntities: useEntities$2,
  useBlockNames: useBlockNames$2,
  useSetURLFromState,
  useSetStateFromURL,
  useEntityRanchBlock: useEntityRanchBlock$1,
  useKeyGeneration,
  useLoadUserSettings,
  useUnits: useUnits$1,
  useRanchBlockSelection,
  useRanchNamesForBlocks,
  useZendeskHelpContent,
  useZendeskSearch,
  useZendeskArticles,
  useRanchNames: useRanchNames$1,
  useCommentList,
  useBlockIdsForRanchIds,
  useSensorNames,
  useEntityNames,
  useSensorsForEntity
};
const actions = {
  ...sensorActions,
  ...farmActions,
  ...controlActions,
  ...webActions,
  ...recommendationActions,
  ...scheduleActions,
  ...anomalyActions,
  ...coordinationActions,
  ...newFarmActions,
  // TODO: rename it later
  loadAndPrepareMapDataByRanchIds,
  loadUserSettings,
  patchUserSettings: patchUserSettings$2
};
const selectors = {
  ...sensorSelectors,
  ...farmSelectors,
  ...controlSelectors,
  ...webSelectors,
  ...settingsSelectors,
  ...recommendationSelectors$1,
  ...scheduleSelectors,
  ...anomalySelectors$1,
  ...coordinationSelectors$1,
  ...newFarmSelectors,
  // TODO: rename it later
  selectSensorsFeaturesByRanchId,
  selectBlocksFeaturesByRanchId,
  selectRanchFeaturesByRanchId,
  selectRanchesFeatures
};

/**
 * Source fastclick.js
 */

/**
* Windows Phone 8.1 fakes user agent string to look like Android and iPhone.
*/
const deviceIsWindowsPhone = navigator.userAgent.indexOf('Windows Phone') >= 0;

/**
 * Android
 */
const deviceIsAndroid = navigator.userAgent.indexOf('Android') > 0 && !deviceIsWindowsPhone;

/**
 * iOS requires exceptions.
 */
const deviceIsIOS = /iP(ad|hone|od)/.test(navigator.userAgent) && !deviceIsWindowsPhone;

/**
 * iOS 4 requires an exception for select elements.
 */
deviceIsIOS && /OS 4_\d(_\d)?/.test(navigator.userAgent);

/**
 * iOS 6.0-7.*
 */
deviceIsIOS && /OS [6-7]_\d/.test(navigator.userAgent);

/**
 * BlackBerry
 */
const deviceIsBlackBerry10 = navigator.userAgent.indexOf('BB10') > 0;

/**
 * Device is Mobile
 */
const isMobile = deviceIsIOS || deviceIsAndroid || deviceIsBlackBerry10 || deviceIsWindowsPhone;

// TODO: this file is duplicated between both the RN and web repos

var constants = {
  APP_NAME: 'farmx-admin',
  VERSION: '0.1',
  API_URL: process.env.REACT_APP_API_URL,
  // PROD: "https://map.farmx.co", STAGING: https://staging.farmx.co, LOCAL: http://localhost:8000
  ADMIN_URL: process.env.REACT_APP_ADMIN_URL,
  // PROD: "https://map.farmx.co/admin", STAGING: https://staging.farmx.co/admin, LOCAL: http://localhost:8000/admin
  GOOGLE_AUTH_PATH: "/api/google-auth/redirect/",
  DEFAULT_HEADERS: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  },
  SENSOR_TYPES: {
    'farmx_dendrometer': {
      name: "Dendrometer",
      shortName: "DD"
    },
    'weather_station': {
      name: "Weather Station",
      shortName: "WS"
    },
    'gateway': {
      name: "Gateway",
      shortName: "BD"
    },
    'pixl_soil': {
      name: "Pixl Soil",
      shortName: "PX"
    },
    'water_pressure': {
      name: "Pressure",
      shortName: "PR"
    },
    'aquacheck_soil': {
      name: "AquaCheck Soil",
      shortName: "AQ"
    },
    'water_flow': {
      name: "Flowmeter",
      shortName: "FM"
    },
    'water_flow_analog': {
      name: "Flowmeter (mesh)",
      shortName: "FMX"
    },
    'vfd': {
      name: "VFD",
      shortName: "VFD"
    },
    'farmx_frost': {
      name: "Frost",
      shortName: "FR"
    },
    'farmx_infrared': {
      name: "Infrared",
      shortName: "IF"
    },
    'boxer_soil': {
      name: "Boxer Soil",
      shortName: "BX"
    },
    'boxer_station': {
      name: "Base Station",
      shortName: "BS"
    },
    'cavalier': {
      name: "Cavalier",
      shortName: "CAV"
    },
    'valve': {
      name: "Valve",
      shortName: "VL"
    },
    'temperature_humidity': {
      name: "Temperature Humidity",
      shortName: "T&H"
    }
  }
};

axios.defaults.baseURL = constants.API_URL;
const getSensorKey = sensor => {
  if (sensor.identifier === null || sensor.identifier === undefined) return undefined;
  if (sensor.type === null || sensor.type === undefined) return undefined;
  return `${sensor.type}/${sensor.identifier}`;
};
const getSensorKeyId = sensor => {
  if (sensor.id === null || sensor.id === undefined) return undefined;
  if (sensor.type === null || sensor.type === undefined) return undefined;
  return `${sensor.type}:${sensor.id}`;
};
const getSensorByTypeId = (sensor, sensors) => {
  // TODO: error checking
  const key = getSensorKey(sensor);
  if (key === undefined) return undefined;
  return sensors.items[key];
};
const getSensorTempKey = sensor => {
  return `tmp/${sensor.type}/${sensor.identifier}`;
};
const getBaseIdentifier = identifier => {
  const regexes = [/_withdrawn/gi, /_removed/gi, /_deleting/gi];
  if (identifier === undefined) return undefined;
  regexes.forEach(regex => identifier = identifier.replace(regex, ''));
  return identifier;
};
const getSensorsForEntity = async entityId => {
  return await axios.get(`/api/sensors/all/list/?entity=${entityId}`);
};
const loadSensors = async installed => await axios.get('/api/sensors/all/');
const loadSensorsRanch = async ranchId => await axios.get(`/api/sensors/ranch/${ranchId}/`);
const loadPaginatedSensorsList = async ranchId => {
  return await axios.get(`/api/sensors/all/list/?ranch=${ranchId}`);
};
const loadGatewayMapData = async gatewayId => {
  return await axios.get(`/api/map/gateway/${gatewayId}/`);
};
const loadSensorMapData = async (sensorType, sensorIdentifier) => {
  return await axios.get(`/api/map/sensor/${sensorType}/${sensorIdentifier}/`);
};

// sensor stats apis
const fetchGatewayStatsList = async () => axios.get('/api/stats/gateway/');
const fetchCavalierStatsList = async () => axios.get('/api/stats/cavalier/');
const fetchSensorStatsList = async () => axios.get('/api/stats/sensor/');
const fetchSensorStatsSingle = async (sensorType, sensorIdentifier) => {
  const url = `/api/stats/sensor/single/?sensorType=${sensorType}&sensorIdentifier=${sensorIdentifier}`;
  return await axios.get(url);
};
const fetchBlockStatsList = async (params = {}) => axios.get('/api/stats/block/', {
  params
});
const fetchSingleBlockStats = async (type, blockId) => axios.get(`/api/stats/block/${blockId}`);
const fetchRanchStatsList = async (params = {}) => axios.get('/api/stats/ranch/', {
  params
});
const fetchSingleRanchStats = async (type, ranchId) => axios.get(`/api/stats/ranch/${ranchId}/`);

// sensor note apis
const fetchSensorNotes = async () => axios.get('/api/sensor/notes/');
const fetchSensorImages = async () => axios.get('/api/sensor/images/');
const loadSensorStatus$5 = async (sensorType, sensorIdentifier) => {
  const url = `/api/sensor/status/?sensorType=${sensorType}&sensorIdentifier=${sensorIdentifier}`;
  return await axios.get(url);
};
const loadSensorStatusForSelectorTypeAndId = async (type, id, excludeType) => {
  return await axios.get(`/api/sensors/status/${type}/${id}/?exclude=${excludeType}`);
};
const loadSensorStatusForSelectorTypeAndIdWithParam = async (type, id, paramStr) => {
  return await axios.get(`/api/sensors/status/${type}/${id}/${paramStr}`);
};
const loadNodeAssociatedSensors = async identifier => {
  return await axios.get(`/api/node/associated-sensors/${identifier}/`);
};
const loadNodeMetaDataByNodeIdentifier = async identifier => {
  return await axios.get(`/api/manufacturing/node/${identifier}/`);
};
const loadRanchInstallationCheck = async ranchId => {
  return await axios.get(`/api/ranches/${ranchId}/installation-check/`);
};
const loadRanchInstallationCheckExport = async ranchId => {
  return await axios.get(`/api/sensor/ranch/${ranchId}/installation-check/export/`, {
    responseType: 'blob'
  });
};
const loadSensorStatusForRanchId = async (ranchId, excludeType) => {
  return await axios.get(`/api/sensor/status/ranch/${ranchId}/?exclude=${excludeType}`);
};
const loadSensorDetail = async (sensorType, sensorIdentifier) => {
  const url = `/api/sensor/detail/?sensorType=${sensorType}&sensorIdentifier=${sensorIdentifier}`;
  return await axios.get(url);
};
const loadSensorDetailById = async (sensorType, sensorId) => {
  const url = `/api/sensor/detail/?sensorType=${sensorType}&sensorId=${sensorId}`;
  return await axios.get(url);
};
const loadSensorTypes = async () => {
  return await axios.get('/api/sensors/types/');
};
const loadAvailableSensors = async sensorType => {
  return await axios.get(`/api/sensors/available/?sensorType=${sensorType}`);
};
const loadSensorCapabilities = async (sensorType, sensorIdentifier) => {
  const url = `/api/sensors/capabilities/?sensorType=${sensorType}&sensorIdentifier=${sensorIdentifier}`;
  return await axios.get(url);
};
const loadSensorData$1 = async (sensorType, sensorId, variables, startDate, endDate, cached, apiVersion, sensorsString) => {
  if (cached === undefined) cached = true;
  const sensorString = sensorsString || `${sensorType}:${sensorId}`;
  let url = (apiVersion ? `/api/v${apiVersion}/data/graph/?sensor=` : '/api/data/graph/?sensors=') + sensorString;
  url += (apiVersion ? '&variables=' : '&variable=') + variables.join(',');
  console.log('url', url);
  if (startDate != null) {
    url += '&startDate=' + startDate.toISOString();
  }
  if (endDate != null) {
    url += '&endDate=' + endDate.toISOString();
  }
  url += `&cached=${cached}`;
  return await axios.get(`${url}/`);
};
const loadPixlRecentData = async sensorId => await axios.get(`/api/data/pixl/recent/${sensorId}/`);
const postSensorNote = async ({
  sensorType,
  sensorIdentifier,
  action,
  text,
  date
}) => {
  return await axios.post('/api/sensor/notes/', {
    sensorType,
    sensorIdentifier,
    action,
    text,
    date
  });
};
const postSensorImage = async ({
  sensorType,
  sensorIdentifier,
  title,
  imageData,
  date
}) => {
  return await axios.post('/api/sensor/image/upload/', {
    sensorType,
    sensorIdentifier,
    title,
    image: imageData,
    date
  });
};
const updateSensorLocation = async ({
  sensorType,
  sensorIdentifier,
  lat,
  lng
}) => {
  return await axios.post('/api/sensor/update/location/', {
    sensorType,
    sensorIdentifier,
    lat,
    lng
  });
};

// Milesight node reboot API
const rebootMilesightNode = async ({
  sensorIdentifier
}) => {
  return await axios.post(`/api/lora/milesight/reboot/${sensorIdentifier}/`);
};
const createSensor = async ({
  sensorType,
  sensorIdentifier
}) => {
  return await axios.post('/api/sensor/create/', {
    sensorType,
    identifier: sensorIdentifier
  });
};
const installSensor = async ({
  sensorType,
  sensorIdentifier
}) => {
  return await axios.post('/api/sensor/install/', {
    sensorType,
    sensorIdentifier
  });
};
const uninstallSensor = async ({
  sensorType,
  sensorIdentifier
}) => {
  return await axios.post('/api/sensor/uninstall/', {
    sensorType,
    sensorIdentifier
  });
};
const removeSensor = async ({
  sensorType,
  sensorIdentifier,
  newState
}) => {
  return await axios.post('/api/sensor/remove/', {
    sensorType,
    sensorIdentifier,
    newState
  });
};
const removeCavalier = async ({
  sensorType,
  sensorIdentifier,
  newState
}) => {
  return await axios.post('/api/sensor/remove/cavalier/', {
    sensorType,
    sensorIdentifier,
    newState
  });
};
const replaceSensor = async ({
  sensorType,
  oldSensorIdentifier,
  newSensorIdentifier
}) => {
  return await axios.post('/api/sensor/replace/', {
    sensorType,
    oldSensorIdentifier,
    newSensorIdentifier
  });
};
const copySensorMetadataToCavalier = async ({
  sensorType,
  sensorIdentifier
}) => {
  const data = {
    sensorType,
    sensorIdentifier
  };
  return await axios.post('/api/sensor/syncfromcav/', data);
};
const copyCavalierMetadataToSensor = async ({
  sensorType,
  sensorIdentifier
}) => {
  const data = {
    sensorType,
    sensorIdentifier
  };
  return await axios.post('/api/sensor/synctocav/', data);
};
const setSensorMoistureData = async ({
  sensorType,
  sensorIdentifier
}) => {
  const data = {
    sensor_type: sensorType,
    sensor_identifier: sensorIdentifier,
    soilgrid: false
  };
  return await axios.post('/api/soil-data/set-sensor-soil-depth-data/', data);
};

/*
 * Sensor type api
 */

const getSensorTypes = () => {
  return Object.keys(constants.SENSOR_TYPES).map(sensorType => sensorType);
};
const getSensorTypeShortNames = () => {
  return Object.keys(constants.SENSOR_TYPES).map(sensorType => constants.SENSOR_TYPES[sensorType].shortName);
};
const getSensorTypeForShortName = shortName => {
  return Object.keys(constants.SENSOR_TYPES).find(key => constants.SENSOR_TYPES[key].shortName === shortName);
};
const getShortNameForSensorType = sensorType => {
  const sensorTypeInfo = constants.SENSOR_TYPES[sensorType];
  if (!sensorTypeInfo) return undefined;
  return sensorTypeInfo.shortName;
};
const getNameForSensorType$1 = sensorType => {
  const sensorTypeInfo = constants.SENSOR_TYPES[sensorType];
  if (!sensorTypeInfo) return undefined;
  return sensorTypeInfo.name;
};
const getSensorTypeFromSensorKey = sensorKey => {
  const regex = /^[^//]*/;
  const type = sensorKey.match(regex)[0];
  if (type !== '') return type;
  return undefined;
};
const getSensorObjectFromSensorKey = sensorKey => {
  const parts = sensorKey.split('/', 2);
  if (parts.length === 2 && parts[0].length && parts[1].length) return {
    type: parts[0],
    identifier: parts[1]
  };
  return undefined;
};
const getSensorObjectFromSensorKeyId = sensorKey => {
  const parts = sensorKey.split(':', 2);
  if (parts.length === 2 && parts[0].length && parts[1].length) return {
    type: parts[0],
    id: parseInt(parts[1])
  };
  return undefined;
};

/*
 * Install State
 */

const isInstallable = sensor => {
  if (sensor === undefined || sensor.install_state === undefined) return false;
  return sensor.install_state !== 'installed';
};

/*
 * Data sanitation
 */

const sanitizeLocation = location => {
  return {
    lat: location.lat.toFixed(6),
    lng: location.lng.toFixed(6)
  };
};
const sanitizeDeviceLocation = location => {
  location = {
    lat: location.coords.latitude,
    lng: location.coords.longitude
  };
  return sanitizeLocation(location);
};
const fetchSoilStatus = async () => axios.get('/api/entities/state/');
const fetchSoilStatusByRanchId = async ranchId => {
  try {
    const {
      data
    } = await fetchSoilStatus();
    const dataLength = data.length;
    for (let i = 0; i < dataLength; i += 1) {
      const ranches = data[i].ranches;
      const ranchesLength = ranches.length;
      for (let j = 0; j < ranchesLength; j += 1) {
        const ranchState = ranches[j];
        if (ranches[j].id === ranchId) {
          return ranchState;
        }
      }
    }
    throw new Error(`Ranch ${ranchId} not found`);
  } catch (e) {
    console.log('ERROR fetchRanchSoilStatusAll', e);
    throw e;
  }
};
const fetchStatusForRanchSensors = async sensorsAll => {
  try {
    const sensorsRanchByIdentifierAndType = {};
    const reqs = [];
    sensorsAll.forEach(sensor => {
      const item = cloneDeep(sensor);
      if (item.visible || ['valve', 'vfd'].includes(item.type)) {
        sensorsRanchByIdentifierAndType[`${item.type}/${item.identifier}`] = item;
      }
    });
    Object.keys(sensorsRanchByIdentifierAndType).forEach(key => {
      const item = cloneDeep(sensorsRanchByIdentifierAndType[key]);
      const {
        identifier,
        type
      } = item;
      if (item.location && item.visible || item.location && ['valve', 'vfd'].includes(item.type)) {
        reqs.push(loadSensorStatus$5(type, identifier));
      }
    });
    return Promise.allSettled(reqs);
  } catch (error) {
    throw error;
  }
};
const updateSoilSensorRefillPercent = async ({
  type,
  id,
  data
}) => axios.put(`/api/sensors/${type}/${id}/refillpoint/`, data);
const getSoilSensorRefillPercent = async ({
  type,
  id
}) => axios.get(`/api/sensors/${type}/${id}/refillpoint/`);
const getSoilSensorProperties = async ({
  type = 'aquacheck_soil',
  id
}) => axios.get(`/api/sensors/${type}/${id}/soil-properties/`);
const updateSoilSensorProperties = async ({
  id,
  data,
  type = 'aquacheck_soil'
}) => axios.put(`/api/sensors/${type}/${id}/soil-properties/`, data);
const copySoilSensorProperties = async ({
  sensorType,
  sensorId,
  selectedSensors,
  selectedBlock,
  selectedRanch
}) => {
  return axios.post(`/api/sensors/copy-soil-sensor-properties/${sensorType}/${sensorId}/`, {
    target_sensors: selectedSensors,
    target_block: selectedBlock,
    target_ranch: selectedRanch
  });
};
const rebootNode = async identifier => {
  return axios.post(`/api/nodes/${identifier}/reboot/`);
};
const rebootLoraNode = async identifier => {
  return axios.post(`/api/lora/lora/reboot/${identifier}/`);
};

/*
// code from master branch. Can be removed if not used anymore.
export const fetchStatusForRanchSensorsOld = async (sensorsAll) => {
  try {
    const sensorsRanchByIdentifierAndType = {};

    const reqs = [];
    reqs.push(fetchRanchSoilStatusDummy());

    sensorsAll.forEach((sensor) => {
      const item = cloneDeep(sensor);
      if (item.visible || ['valve', 'vfd'].includes(item.type)) {
        sensorsRanchByIdentifierAndType[`${item.type}/${item.identifier}`] = item;
      }
    });

    Object.keys(sensorsRanchByIdentifierAndType).forEach((key) => {
      const item = cloneDeep(sensorsRanchByIdentifierAndType[key]);
      const { identifier, type } = item;
      if ((item.location && item.visible) || (item.location && ['valve', 'vfd'].includes(item.type))) {
        reqs.push(loadSensorStatus(type, identifier));
      }
    });

    const results = await Promise.allSettled(reqs);

    const now = (new Date()).getTime();
    const soilResult = results.shift();

    const soilStatusSensors = {};

    // const stateBlocks = soilResult.value.data.blocks.reduce((acc, curr) => {
    //   acc[curr.id] = cloneDeep(curr);
    //   curr.state.details.all_data.forEach((s) => {
    //     soilStatusSensors[s.sensor] = cloneDeep(s);
    //   });
    //   return acc;
    // }, {});

    // const stateRanch = cloneDeep(soilResult.value.data.state);

    soilResult.value.data.state.details.all_data.forEach((s) => {
      soilStatusSensors[s.sensor] = cloneDeep(s);
    });

    const okResults = results.filter((r) => r === Object(r) && r.value && r.value.data && r.value.data.id);

    const sensorFeatures = okResults
      .map((r) => { // make it reduce function to get new okResults with soil state
        const sensorBase = cloneDeep(sensorsRanchByIdentifierAndType[`${r.value.data.type}/${r.value.data.identifier}`]);
        const id = `${sensorBase.type}/${sensorBase.identifier}`;

        let lastPostedInMinutes = -1;
        if (r.value.data.earliestDate
          && r.value.data.latestDate) {
          const earliestDate = (new Date(r.value.data.earliestDate))
            .getTime();
          const lastPosted = (new Date(r.value.data.latestDate))
            .getTime();
          if (lastPosted >= earliestDate) {
            lastPostedInMinutes = Math.round((now - lastPosted) / 1000 / 60);
          }
        }

        const sensor = {
          id,
          type: 'Feature',
          geometry: {
            type: 'Point',
            coordinates: [sensorBase.location.lng, sensorBase.location.lat],
          },
          properties: {
            ...sensorBase,
            ...r.value.data,
            id,
            lastPostedInMinutes,
            dbIdStatus: r.value.data.id,
            dbIdBase: sensorBase.id,
            lastUpdated: Date.now(),
          },
        };

        if (soilStatusSensors[sensorBase.identifier]) {
          sensor.properties = {
            ...cloneDeep(sensor.properties),
            ...cloneDeep(soilStatusSensors[sensorBase.identifier]),
          }
        }

        return sensor;
      });

    let sensorsGeoJSON = {
      type: 'FeatureCollection',
      features: sensorFeatures,
    };

    sensorsGeoJSON = prepareZeroIslandSensors(sensorsGeoJSON);

    return sensorsGeoJSON.features;
  } catch (error) {
    throw error;
  }
}
*/

/**
 * Get sensor notes. Optionally filter by type, identifier and date.
 * @param {Object} filterOptions
 * @param {String} filterOptions.type
 * @param {String} filterOptions.identifier
 * @param {String} filterOptions.dateStart
 * @param {String} filterOptions.dateEnd
 * @param {String} filterOptions.sensorId
 * @param {String} filterOptions.page
 * @param {String} filterOptions.action
 * @param {String} filterOptions.user
 */
const getSensorNotes = filterOptions => {
  let url = '/api/sensor/notes/new/';
  const params = {};
  if (filterOptions) {
    const {
      type,
      identifier,
      dateStart,
      dateEnd,
      sensorId,
      page,
      user,
      action
    } = filterOptions;
    if (type) params.sensor_type = type;
    if (identifier) params.sensor_identifier = identifier;
    if (dateStart) params.date_start = dateStart;
    if (dateEnd) params.date_end = dateEnd;
    if (sensorId) params.sensor_id = sensorId;
    if (page) params.page = page;
    if (action) params.action = action;
    if (user) params.user = user;
  }
  return axios.get(url, {
    params
  });
};

var sensorApi$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getSensorKey: getSensorKey,
  getSensorKeyId: getSensorKeyId,
  getSensorByTypeId: getSensorByTypeId,
  getSensorTempKey: getSensorTempKey,
  getBaseIdentifier: getBaseIdentifier,
  getSensorsForEntity: getSensorsForEntity,
  loadSensors: loadSensors,
  loadSensorsRanch: loadSensorsRanch,
  loadPaginatedSensorsList: loadPaginatedSensorsList,
  loadGatewayMapData: loadGatewayMapData,
  loadSensorMapData: loadSensorMapData,
  fetchGatewayStatsList: fetchGatewayStatsList,
  fetchCavalierStatsList: fetchCavalierStatsList,
  fetchSensorStatsList: fetchSensorStatsList,
  fetchSensorStatsSingle: fetchSensorStatsSingle,
  fetchBlockStatsList: fetchBlockStatsList,
  fetchSingleBlockStats: fetchSingleBlockStats,
  fetchRanchStatsList: fetchRanchStatsList,
  fetchSingleRanchStats: fetchSingleRanchStats,
  fetchSensorNotes: fetchSensorNotes,
  fetchSensorImages: fetchSensorImages,
  loadSensorStatus: loadSensorStatus$5,
  loadSensorStatusForSelectorTypeAndId: loadSensorStatusForSelectorTypeAndId,
  loadSensorStatusForSelectorTypeAndIdWithParam: loadSensorStatusForSelectorTypeAndIdWithParam,
  loadNodeAssociatedSensors: loadNodeAssociatedSensors,
  loadNodeMetaDataByNodeIdentifier: loadNodeMetaDataByNodeIdentifier,
  loadRanchInstallationCheck: loadRanchInstallationCheck,
  loadRanchInstallationCheckExport: loadRanchInstallationCheckExport,
  loadSensorStatusForRanchId: loadSensorStatusForRanchId,
  loadSensorDetail: loadSensorDetail,
  loadSensorDetailById: loadSensorDetailById,
  loadSensorTypes: loadSensorTypes,
  loadAvailableSensors: loadAvailableSensors,
  loadSensorCapabilities: loadSensorCapabilities,
  loadSensorData: loadSensorData$1,
  loadPixlRecentData: loadPixlRecentData,
  postSensorNote: postSensorNote,
  postSensorImage: postSensorImage,
  updateSensorLocation: updateSensorLocation,
  rebootMilesightNode: rebootMilesightNode,
  createSensor: createSensor,
  installSensor: installSensor,
  uninstallSensor: uninstallSensor,
  removeSensor: removeSensor,
  removeCavalier: removeCavalier,
  replaceSensor: replaceSensor,
  copySensorMetadataToCavalier: copySensorMetadataToCavalier,
  copyCavalierMetadataToSensor: copyCavalierMetadataToSensor,
  setSensorMoistureData: setSensorMoistureData,
  getSensorTypes: getSensorTypes,
  getSensorTypeShortNames: getSensorTypeShortNames,
  getSensorTypeForShortName: getSensorTypeForShortName,
  getShortNameForSensorType: getShortNameForSensorType,
  getNameForSensorType: getNameForSensorType$1,
  getSensorTypeFromSensorKey: getSensorTypeFromSensorKey,
  getSensorObjectFromSensorKey: getSensorObjectFromSensorKey,
  getSensorObjectFromSensorKeyId: getSensorObjectFromSensorKeyId,
  isInstallable: isInstallable,
  sanitizeLocation: sanitizeLocation,
  sanitizeDeviceLocation: sanitizeDeviceLocation,
  fetchSoilStatus: fetchSoilStatus,
  fetchSoilStatusByRanchId: fetchSoilStatusByRanchId,
  fetchStatusForRanchSensors: fetchStatusForRanchSensors,
  updateSoilSensorRefillPercent: updateSoilSensorRefillPercent,
  getSoilSensorRefillPercent: getSoilSensorRefillPercent,
  getSoilSensorProperties: getSoilSensorProperties,
  updateSoilSensorProperties: updateSoilSensorProperties,
  copySoilSensorProperties: copySoilSensorProperties,
  rebootNode: rebootNode,
  rebootLoraNode: rebootLoraNode,
  getSensorNotes: getSensorNotes
});

const getAllEntity = async () => axios.get('/api/farm/entities/');
const getEntityDetail = async entityId => axios.get(`/api/farm/entity/${entityId}/`);
const getRanchDetail = async ranchId => axios.get(`/api/farm/ranch/${ranchId}/`);
const getBlockDetail = async blockId => axios.get(`/api/farm/block/${blockId}/`);
const getEntityList = async (filter = false) => {
  return axios.get('/api/farm/entity/', filter ? {
    params: {
      filter: 1
    }
  } : '');
};
const getRanchList = async (filter = false) => {
  return axios.get('/api/farm/ranch/', filter ? {
    params: {
      filter: 1
    }
  } : '');
};
const getBlockList = async (filter = false) => {
  return axios.get('/api/farm/block/', filter ? {
    params: {
      filter: 1
    }
  } : '');
};
const getEntityRanchList = async entityId => {
  return axios.get(`/api/farm/entities/${entityId}/ranches/`);
};
const getEntityBlockList = async entityId => {
  return axios.get(`/api/farm/block/detail/?entity=${entityId}`);
};
const getAvailableRanchList = async () => axios.get('/api/farm/ranch/available/');
const postRanchGeoJson = async ({
  entityId,
  ranchGeojson
}) => axios.post('/api/ranch/geojson/', {
  entityId,
  ranchGeojson
});
const getBlockAvailableWater = async blockId => axios.get(`/api/block/${blockId}/soil/currentwater/`);
const updateBlockAutoSchedule = async ({
  autoSchedule,
  blockId
}) => axios.patch(`/api/farm/block/${blockId}/`, {
  auto_schedule: autoSchedule
});
const updateBlockAutoSprinklerControl = async ({
  autoSprinklerControl,
  blockId
}) => axios.patch(`/api/farm/block/${blockId}/`, {
  auto_sprinkler_control: autoSprinklerControl
});
const updateBlockAutoIrrigationControl = async ({
  autoIrrigationControl,
  blockId
}) => axios.patch(`/api/farm/block/${blockId}/`, {
  auto_irrigation_control: autoIrrigationControl
});
const updateBlockAutoCoolingControl = async ({
  autoCoolingControl,
  blockId
}) => axios.patch(`/api/farm/block/${blockId}/`, {
  auto_cooling_control: autoCoolingControl
});
const getChillHours = ranchId => axios.get(`/api/ranches/${ranchId}/chillhours/`);
const getChillPortions = ranchId => axios.get(`/api/ranches/${ranchId}/chillportions/`);
const getRanchPrecip = ranchId => axios.get(`/api/ranches/${ranchId}/precip`);
const getRanchRainfallDaily = ranchId => axios.get(`/api/ranches/${ranchId}/rainfall/daily/`);
const getCumulativePrecipitation = ({
  ranchId,
  start,
  end
}) => axios.get(`/api/ranches/${ranchId}/precip/cumulative/?start=${start}&end=${end}`);
const getGDD = ({
  ranchId,
  lower,
  upper
}) => axios.get(`/api/ranches/${ranchId}/gdd/?lower=${lower}&upper=${upper}`);
const getRanchSummary = ranchId => axios.get(`/api/ranches/${ranchId}/summary/`);

var farmApi$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getAllEntity: getAllEntity,
  getEntityDetail: getEntityDetail,
  getRanchDetail: getRanchDetail,
  getBlockDetail: getBlockDetail,
  getEntityList: getEntityList,
  getRanchList: getRanchList,
  getBlockList: getBlockList,
  getEntityRanchList: getEntityRanchList,
  getEntityBlockList: getEntityBlockList,
  getAvailableRanchList: getAvailableRanchList,
  postRanchGeoJson: postRanchGeoJson,
  getBlockAvailableWater: getBlockAvailableWater,
  updateBlockAutoSchedule: updateBlockAutoSchedule,
  updateBlockAutoSprinklerControl: updateBlockAutoSprinklerControl,
  updateBlockAutoIrrigationControl: updateBlockAutoIrrigationControl,
  updateBlockAutoCoolingControl: updateBlockAutoCoolingControl,
  getChillHours: getChillHours,
  getChillPortions: getChillPortions,
  getRanchPrecip: getRanchPrecip,
  getRanchRainfallDaily: getRanchRainfallDaily,
  getCumulativePrecipitation: getCumulativePrecipitation,
  getGDD: getGDD,
  getRanchSummary: getRanchSummary
});

const getUsers = async () => axios.get("/api/users/");
const getUserById = async id => axios.get(`/api/users/${id}/`);
const changePassword$1 = async (currentPassword, newPassword) => axios.patch('/api/user/password/change/', {
  old_password: currentPassword,
  new_password: newPassword
});
const getUserSettings = async () => await axios.get("/api/user/settings/");
const patchUserSettings = async data => await axios.patch("/api/user/settings/", data);
const getUserAppConfig = async () => {
  try {
    const response = await axios.get("/api/user/config/app/");
    return response.data;
  } catch (error) {
    return false;
  }
};
const updateUserAppConfig = async data => {
  try {
    const response = await axios.patch("/api/user/config/app/", data);
    return response.data;
  } catch (error) {
    return false;
  }
};

// NOTE: copied here because import of feedApi was not working
const loadUserEvents = async (args = {}) => {
  const {
    cursor,
    blockId,
    sensorIdentifier,
    sensorType,
    logLevel,
    active,
    eventType,
    eventCategory,
    dateStart,
    dateEnd,
    cancelToken,
    ranchId,
    entityId,
    q
  } = args;
  const params = {};
  if (cursor) params['cursor'] = cursor;
  if (blockId) params['block'] = blockId;
  if (ranchId) params['ranch'] = ranchId;
  if (entityId) params['entity'] = entityId;
  if (logLevel) params['log_level'] = logLevel;
  if (typeof active === 'boolean') params['active'] = active;
  if (eventType) params['event_type'] = eventType;
  if (eventCategory) params['event_category'] = eventCategory;
  if (dateStart) params['date_start'] = dateStart.toDate().toISOString();
  if (dateEnd) params['date_end'] = dateEnd.toDate().toISOString();
  if (q) params['q'] = q;
  if (sensorType) params['sensor_type'] = sensorType;
  if (sensorIdentifier) params['sensor_identifier'] = sensorIdentifier;
  if (q) params['q'] = q;
  const baseUrl = '/api/feed/events/';
  const queryString = '?' + new URLSearchParams(params).toString();
  const url = baseUrl + queryString;
  return await axios.get(url, {
    cancelToken
  });
};
const getCancelToken = () => axios.CancelToken.source();

var userApi$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getUsers: getUsers,
  getUserById: getUserById,
  changePassword: changePassword$1,
  getUserSettings: getUserSettings,
  patchUserSettings: patchUserSettings,
  getUserAppConfig: getUserAppConfig,
  updateUserAppConfig: updateUserAppConfig,
  loadUserEvents: loadUserEvents,
  getCancelToken: getCancelToken
});

const fetchAllScheduledIrrigationEvents = async () => {
  return await axios.get('/api/schedule/irrigation/');
};
const fetchBlockSchedule = async blockId => {
  return await axios.get(`/api/schedule/block/${blockId}/`);
};
const fetchAllBlockSchedule = async blockIds => {
  const reqs = blockIds.map(blockId => fetchBlockSchedule(blockId));
  const responses = await Promise.allSettled(reqs);
  return responses.filter(response => response.status === 'fulfilled' && response.value.status === 200).map(response => ({
    ...response.value.data
  }));
};
const createScheduledIrrigationEvent$1 = async ({
  start_date,
  stop_date,
  block
}) => {
  return await axios.post('/api/schedule/irrigation/', {
    start_date,
    stop_date,
    block
  });
};
const createOverride$1 = async ({
  sensorType,
  sensorIdentifier,
  state
}) => {
  return axios.post(`/api/sensors/${sensorType}/override/create/`, {
    sensorType,
    sensorIdentifier,
    state
  });
};
const endOverride$1 = async ({
  sensorType,
  sensorIdentifier
}) => {
  return axios.post(`/api/sensors/${sensorType}/override/end/`, {
    sensorType,
    sensorIdentifier
  });
};
const updateScheduledIrrigationEvent$1 = async ({
  id,
  start_date,
  stop_date,
  block
}) => {
  return await axios.put('api/schedule/irrigation/' + id + '/', {
    start_date,
    stop_date,
    block
  });
};
const deleteScheduledIrrigationEvent$1 = async ({
  id
}) => {
  return await axios.delete('api/schedule/irrigation/' + id + '/');
};

var controlApi$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  fetchAllScheduledIrrigationEvents: fetchAllScheduledIrrigationEvents,
  fetchBlockSchedule: fetchBlockSchedule,
  fetchAllBlockSchedule: fetchAllBlockSchedule,
  createScheduledIrrigationEvent: createScheduledIrrigationEvent$1,
  createOverride: createOverride$1,
  endOverride: endOverride$1,
  updateScheduledIrrigationEvent: updateScheduledIrrigationEvent$1,
  deleteScheduledIrrigationEvent: deleteScheduledIrrigationEvent$1
});

const fetchPlansByRanchId = async ranchId => captureError(() => axios.get(`/api/plan/ranch/${ranchId}/`));

/**
 * Create - https://map.farmx.co/api/plan/create/
 * This endpoint allows for the creation of an installation plan.
 * It accepts all fields, although the following are the only required fields:
 * - ranch_name
 *  -ranch
 * @param {*} payload
 */
const createPlan = async payload => captureError(() => axios.post('/api/plan/create/', payload));
const fetchPlanById = async id => captureError(() => axios.get(`/api/plan/edit/${id}/`));
const updatePlanById = async (id, payload) => captureError(() => axios.put(`/api/plan/edit/${id}/`, payload));
const patchPlanById = async (id, payload) => captureError(() => axios.patch(`/api/plan/edit/${id}/`, payload));
const deletePlanById = async id => captureError(() => axios.delete(`/api/plan/edit/${id}/`));

var plansApi$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  fetchPlansByRanchId: fetchPlansByRanchId,
  createPlan: createPlan,
  fetchPlanById: fetchPlanById,
  updatePlanById: updatePlanById,
  patchPlanById: patchPlanById,
  deletePlanById: deletePlanById
});

const get3DBlock = async blockId => axios.get(`/api/data/3d/block/${blockId}/`);
const get3DBlockDateRange = async (blockId, startDate, endDate) => axios.get(`/api/data/3d/?block=${blockId}&startDate=${startDate}&endDate=${endDate}/`);
const getBlockRootzoneVWCGraph = async ({
  blockId,
  startDate,
  endDate
}) => {
  return axios.get(`/api/block/rootzone-vwc-graph/?block=${blockId}&startDate=${startDate}&endDate=${endDate}`);
};
const getBlockAnomaly = async blockId => {
  return axios.get(`/api/anomaly/block/${blockId}/`);
};
const requestImagingServices = async () => {
  return axios.post('/api/user/request/imaging/services/');
};
const anomalyErrorReport = async errorObj => {
  return axios.post('/api/jira/anomaly/error/report/', errorObj);
};
const softDeleteAnomaly = async deleteObj => {
  return axios.post(`https://map2.farmx.co/api/anomalyexclusion/create/`, deleteObj);
};
const createAnomaly = async anomaly => {
  return axios.post(`/api/anomaly/create/`, anomaly);
};
const updateAnomaly = async anomaly => {
  return axios.put(`/api/anomaly/edit/${anomaly.id}/`, anomaly);
};
const deleteAnomaly = async anomalyId => {
  return axios.delete(`/api/anomaly/edit/${anomalyId}/`);
};
const getAnomalyComments = async anomalyId => {
  return axios.get(`/api/anomaly/${anomalyId}/comment/`);
};
const createAnomalyComment = async anomalyCommentData => {
  return axios.post('/api/anomaly/comment/create/', anomalyCommentData);
};
const updateAnomalyComment = async (commentId, anomalyCommentData) => {
  return axios.patch(`/api/anomaly/comment/edit/${commentId}/`, anomalyCommentData);
};
const deleteAnomalyComment = async commentId => {
  return axios.delete(`/api/anomaly/comment/edit/${commentId}/`);
};
const getPlantsListForBlock = async blockId => {
  return axios.get(`/api/plant/block/${blockId}/list/`);
};
const getPlantsBlockAnalyticsData = async blockId => {
  return axios.get(`/api/plant/block/${blockId}/analytics/`);
};
const setCropType = async ({
  blockId,
  ...blockDetails
}) => {
  return axios.patch(`/api/block/update/${blockId}/`, blockDetails);
};
const getAnomalyArea = async anomaly => {
  return axios.get(`/api/anomaly/imagery_anomaly_area/${anomaly.id}/`);
};
const getImageryAnomalyComparison = async imageryAnomalyId => {
  return axios.get(`/api/recommendations/imagery_anomaly_comparison/?imagery_anomaly_id=${imageryAnomalyId}`);
};
const updateCustomKcForBlock = async (blockId, customKcValue) => {
  return axios.put(`/api/block/update_custom_kc/${blockId}/`, customKcValue);
};
const updateKrdiForBlock = async (blockId, data) => {
  return axios.patch(`/api/block/update_krdi/${blockId}/`, data);
};
const updateIrrigationTargetPointForBlock = async (blockId, data) => {
  return axios.patch(`/api/block/${blockId}/update_irrigation_target_point/`, data);
};
const deleteAnomalyPolygonArea = async anomalyAreaId => {
  return axios.delete(`/api/anomaly/polygon/delete/${anomalyAreaId}/`);
};

var blockApi$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  get3DBlock: get3DBlock,
  get3DBlockDateRange: get3DBlockDateRange,
  getBlockRootzoneVWCGraph: getBlockRootzoneVWCGraph,
  getBlockAnomaly: getBlockAnomaly,
  requestImagingServices: requestImagingServices,
  anomalyErrorReport: anomalyErrorReport,
  softDeleteAnomaly: softDeleteAnomaly,
  createAnomaly: createAnomaly,
  updateAnomaly: updateAnomaly,
  deleteAnomaly: deleteAnomaly,
  getAnomalyComments: getAnomalyComments,
  createAnomalyComment: createAnomalyComment,
  updateAnomalyComment: updateAnomalyComment,
  deleteAnomalyComment: deleteAnomalyComment,
  getPlantsListForBlock: getPlantsListForBlock,
  getPlantsBlockAnalyticsData: getPlantsBlockAnalyticsData,
  setCropType: setCropType,
  getAnomalyArea: getAnomalyArea,
  getImageryAnomalyComparison: getImageryAnomalyComparison,
  updateCustomKcForBlock: updateCustomKcForBlock,
  updateKrdiForBlock: updateKrdiForBlock,
  updateIrrigationTargetPointForBlock: updateIrrigationTargetPointForBlock,
  deleteAnomalyPolygonArea: deleteAnomalyPolygonArea
});

const getAvailableSatelliteData = async (type, id) => axios.get(`/api/data/satellite/available/v2/?${type}=${id}`);

/**
 * Examples of URLs
 * https://map.farmx.co/api/data/satellite/?ranch=73661&DataType=NDVI&date=1621422000
 * https://map.farmx.co/api/data/satellite/?block=736277&DataType=NDVI&date=1620990000
 */
const getSatelliteDataByDataTypeAndDate = async (type, id, dataType, time) => axios.get(`/api/data/satellite/?${type}=${id}&DataType=${dataType}&date=${time}`);
const getAvailableDroneDataForRanchId = async id => axios.get(`/api/imagery/available/?ranchId=${id}`);
const getDroneImageryTiles = async (assetType, ranchId, imageryTaskId, imageryProjectId) => axios.get(`/api/imagery/tile/?ranchId=${ranchId}&imageryTaskId=${imageryTaskId}&imageryProjectId=${imageryProjectId}&assetType=${assetType}`);
const getSatelliteCombinedDataByDataTypeAndDate = async (type, id, dataType, sDate, eDate) => {
  const dateRange = sDate && eDate ? `&startDate=${sDate}&endDate=${eDate}` : '';
  return axios.get(`/api/data/satellite/combined/?${type}=${id}&DataType=${dataType}${dateRange}`);
};

var satelliteApi$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getAvailableSatelliteData: getAvailableSatelliteData,
  getSatelliteDataByDataTypeAndDate: getSatelliteDataByDataTypeAndDate,
  getAvailableDroneDataForRanchId: getAvailableDroneDataForRanchId,
  getDroneImageryTiles: getDroneImageryTiles,
  getSatelliteCombinedDataByDataTypeAndDate: getSatelliteCombinedDataByDataTypeAndDate
});

// Recommendation API
const retrieveIrrigationRecommendationsForUser = async () => axios.get('/api/recommendations/');
const retrieveIrrigationRecommendationsForEntity = async entityId => axios.get(`/api/recommendations/?entity_id=${entityId}`);
const retrieveIrrigationRecommendationForBlock = async ({
  blockId
}) => axios.get(`/api/recommendations/block/${blockId}`);
const retrieveIrrigationRecommendation = async ({
  id
}) => axios.get(`/api/recommendations/${id}/`);
const patchIrrigationRecommendation = async ({
  id,
  type,
  data
}) => axios.patch(`/api/recommendations/${type}/${id}/`, data);
const retrieveIrrigationRecommendationStatus = async ({
  id
}) => axios.get(`/api/recommendations/${id}/status/`);
const createRecommendationSchedule = async data => axios.post('/api/recommendations/schedule/update/', data);
const refreshIrrigationRecommendation = async data => axios.post('/api/recommendations/irrigation/refresh/', data);
const retrieveRecommendationMetadataRefreshStatus = async ({
  blockId
}) => axios.get(`/api/recommendations/block/${blockId}/metadata-refresh-status/`);
const retrieveBlockDroneImageryAnalytics = async id => axios.get(`/api/imagery/analytics/block/drone/${id}/`);

var recommendationApi$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  retrieveIrrigationRecommendationsForUser: retrieveIrrigationRecommendationsForUser,
  retrieveIrrigationRecommendationsForEntity: retrieveIrrigationRecommendationsForEntity,
  retrieveIrrigationRecommendationForBlock: retrieveIrrigationRecommendationForBlock,
  retrieveIrrigationRecommendation: retrieveIrrigationRecommendation,
  patchIrrigationRecommendation: patchIrrigationRecommendation,
  retrieveIrrigationRecommendationStatus: retrieveIrrigationRecommendationStatus,
  createRecommendationSchedule: createRecommendationSchedule,
  refreshIrrigationRecommendation: refreshIrrigationRecommendation,
  retrieveRecommendationMetadataRefreshStatus: retrieveRecommendationMetadataRefreshStatus,
  retrieveBlockDroneImageryAnalytics: retrieveBlockDroneImageryAnalytics
});

// Scheduled irrigation events

const retrieveAllBlockScheduledIrrigationEvents = async () => axios.get('/api/schedule/irrigation/');
const retrieveBlockScheduledIrrigationEvents = async blockId => axios.get(`/api/schedule/irrigation/block/${blockId}/`);
const createScheduledIrrigationEvent = async scheduledIrrigationEvent => {
  return axios.post('/api/schedule/irrigation/new/', scheduledIrrigationEvent);
};
const retrieveScheduledIrrigationEvent = async id => axios.get(`api/schedule/irrigation/${id}/`);
const updateScheduledIrrigationEvent = async data => axios.put(`api/schedule/irrigation/${data.id}/`, data);
const patchScheduledIrrigationEvent = async data => axios.patch(`api/schedule/irrigation/${data.id}/`, data);
const deleteScheduledIrrigationEvent = async id => axios.delete(`api/schedule/irrigation/${id}/`);

// Rendered irrigation events

const retrieveBlockRenderedIrrigationEvents = async ({
  blockId,
  dateStart,
  dateEnd
}) => {
  const query = `?dateStart=${dateStart.toISOString()}&dateEnd=${dateEnd.toISOString()}`;
  return axios.get(`/api/schedule/irrigation/block/${blockId}/rendered/${query}`);
};

// Event edits

const createBlockScheduledIrrigationEventEdit = async scheduledIrrigationEventEdit => {
  return axios.post('/api/schedule/irrigation/edit/new/', scheduledIrrigationEventEdit);
};
const retrieveBlockScheduledIrrigationEventEdit = async eventEditId => {
  return axios.get(`/api/schedule/irrigation/edit/${eventEditId}/`);
};
const retrieveBlockScheduledIrrigationEventEditByIndex = async ({
  eventId,
  eventIndex
}) => {
  return axios.get(`/api/schedule/irrigation/${eventId}/edit/${eventIndex}/`);
};
const updateBlockScheduledIrrigationEventEdit = async scheduledIrrigationEventEdit => {
  const {
    id: eventEditId
  } = scheduledIrrigationEventEdit;
  return axios.put(`/api/schedule/irrigation/edit/${eventEditId}/`, scheduledIrrigationEventEdit);
};
const deleteBlockScheduledIrrigationEventEdit = async eventEditId => {
  return axios.delete(`/api/schedule/irrigation/edit/${eventEditId}/`);
};
const retrieveBlockWaterUsageData = async ({
  blockIds,
  dateStart,
  dateEnd
}) => {
  return axios.get(`/api/block/water-usage/?blockIds=${blockIds.join(',')}&dateStart=${dateStart}&dateEnd=${dateEnd}`);
};
const emailWaterUsageData = async emailContent => {
  return axios.post('/api/block/water-usage/email/', emailContent);
};

var scheduleApi$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  retrieveAllBlockScheduledIrrigationEvents: retrieveAllBlockScheduledIrrigationEvents,
  retrieveBlockScheduledIrrigationEvents: retrieveBlockScheduledIrrigationEvents,
  createScheduledIrrigationEvent: createScheduledIrrigationEvent,
  retrieveScheduledIrrigationEvent: retrieveScheduledIrrigationEvent,
  updateScheduledIrrigationEvent: updateScheduledIrrigationEvent,
  patchScheduledIrrigationEvent: patchScheduledIrrigationEvent,
  deleteScheduledIrrigationEvent: deleteScheduledIrrigationEvent,
  retrieveBlockRenderedIrrigationEvents: retrieveBlockRenderedIrrigationEvents,
  createBlockScheduledIrrigationEventEdit: createBlockScheduledIrrigationEventEdit,
  retrieveBlockScheduledIrrigationEventEdit: retrieveBlockScheduledIrrigationEventEdit,
  retrieveBlockScheduledIrrigationEventEditByIndex: retrieveBlockScheduledIrrigationEventEditByIndex,
  updateBlockScheduledIrrigationEventEdit: updateBlockScheduledIrrigationEventEdit,
  deleteBlockScheduledIrrigationEventEdit: deleteBlockScheduledIrrigationEventEdit,
  retrieveBlockWaterUsageData: retrieveBlockWaterUsageData,
  emailWaterUsageData: emailWaterUsageData
});

const getCustomerReport = async users => axios.get(`/api/reports/customer/?users=${users.join(",")}`);
const getBlockReport = async blockIds => axios.get(`/api/reports/block/?blockIds=${blockIds.join(",")}`);
const getAnomalySummaryReport = async ({
  ranch,
  dateStart,
  dateEnd
}) => {
  return axios.get(`/api/reports/anomaly/${ranch}/?dateStart=${dateStart}&dateEnd=${dateEnd}`);
};

var reportsApi$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getCustomerReport: getCustomerReport,
  getBlockReport: getBlockReport,
  getAnomalySummaryReport: getAnomalySummaryReport
});

const toTitleCase$1 = str => {
  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
};
const fieldToHeader$1 = str => {
  const find = '_';
  const re = new RegExp(find, 'g');
  return toTitleCase$1(str.replace(re, " "));
};

// helper to format key value pair in url encoded format, ignore null values
const format = (k, v) => v !== null ? `${k}=${encodeURIComponent(v)}` : "";

// Convert object to url encoded query string
const toQueryString = obj => {
  return Object.entries(obj).map(([k, v]) => {
    if (Array.isArray(v)) {
      return format(k, v.join(','));
    }
    return format(k, v);
  }).filter(x => x).join('&');
};

const listTeams = async query => {
  return axios.get(`/api/teams/?` + toQueryString(query));
};
const retrieveTeam = async (teamId, query) => {
  return axios.get(`/api/teams/${teamId}/?` + toQueryString(query));
};
const createTeam = async team => {
  return axios.post(`/api/teams/`, team);
};
const updateTeam = async (teamId, team) => {
  return axios.put(`/api/teams/${teamId}/`, team);
};
const deleteTeam = async teamId => {
  return axios.delete(`/api/teams/${teamId}/`);
};

// Route: api/teams/{id}/update-ranch-list/
// ranchList = array of ranch id
const updateRanchList = async (teamId, ranchList) => {
  return axios.put(`/api/teams/${teamId}/update-ranch-list/`, ranchList);
};
const listTeamRanches = async (teamId, query) => {
  return axios.get(`/api/teams/${teamId}/ranches/?` + toQueryString(query));
};

var teamApi$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  listTeams: listTeams,
  retrieveTeam: retrieveTeam,
  createTeam: createTeam,
  updateTeam: updateTeam,
  deleteTeam: deleteTeam,
  updateRanchList: updateRanchList,
  listTeamRanches: listTeamRanches
});

const listTeamUserAccess = async query => {
  return axios.get(`/api/team-user-access/?` + toQueryString(query));
};
const retrieveTeamUserAccess = async (teamUserAccessId, query) => {
  return axios.get(`/api/team-user-access/${teamUserAccessId}/?` + toQueryString(query));
};
const createTeamUserAccess = async teamUserAccessData => {
  return axios.post('/api/team-user-access/', teamUserAccessData);
};
const updateTeamUserAccess = async (teamUserAccessId, teamUserAccessData) => {
  return axios.put(`/api/team-user-access/${teamUserAccessId}/`, teamUserAccessData);
};
const deleteTeamUserAccess = async teamUserAccessId => {
  return axios.delete(`/api/team-user-access/${teamUserAccessId}/`);
};

var teamUserAccessApi$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  listTeamUserAccess: listTeamUserAccess,
  retrieveTeamUserAccess: retrieveTeamUserAccess,
  createTeamUserAccess: createTeamUserAccess,
  updateTeamUserAccess: updateTeamUserAccess,
  deleteTeamUserAccess: deleteTeamUserAccess
});

// returns a list of roles
const getRoles = async () => {
  return axios.get(`/api/roles/`);
};

var roleApi$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getRoles: getRoles
});

const getEntityMonitoringData = async ({
  date,
  region
}) => {
  const params = new URLSearchParams();
  if (date) params.append('date', date);
  if (region) params.append('region', region);
  const query = params.toString();
  return axios.get(`/api/entity/monitoring/${query ? `?${query}` : ''}`);
};

var entityMonitoringApi$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getEntityMonitoringData: getEntityMonitoringData
});

const listRanches = async query => {
  return axios.get(`/api/v3/ranches/?` + toQueryString(query));
};

var ranchApi$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  listRanches: listRanches,
  getRanchMonitoringData: getEntityMonitoringData
});

const listFollowBlocks = async query => {
  return axios.get(`/api/followblock/?` + toQueryString(query));
};
const retrieveFollowBlock = async (followBlockId, query) => {
  return axios.get(`/api/followblock/${followBlockId}/?` + toQueryString(query));
};
const createFollowBlock = async followBlock => {
  return axios.post(`/api/followblock/`, followBlock);
};
const deleteFollowBlock = async followBlockId => {
  return axios.delete(`/api/followblock/${followBlockId}/`);
};
const followRanch = async (ranchId, userId) => {
  return axios.put(`/api/followblock/follow-ranch/`, {
    ranch_id: ranchId,
    user_id: userId
  });
};
const unfollowRanch = async (ranchId, userId) => {
  return axios.put(`/api/followblock/unfollow-ranch/`, {
    ranch_id: ranchId,
    user_id: userId
  });
};

var followBlockApi$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  listFollowBlocks: listFollowBlocks,
  retrieveFollowBlock: retrieveFollowBlock,
  createFollowBlock: createFollowBlock,
  deleteFollowBlock: deleteFollowBlock,
  followRanch: followRanch,
  unfollowRanch: unfollowRanch
});

// Sensor coordinations
const fetchSensorCoordinations = async () => await axios.get('/api/sensor-coordinations/statuses/');

// Update sensor actionSubtype
const updateSensorCoordination = async ({
  blockId,
  actionType,
  actionSubType,
  autoMode
}) => {
  return await axios.patch('/api/sensor-coordinations/block/toggle/action-subtype/auto-mode/', {
    follower_block_id: blockId,
    action_type: actionType,
    action_subtype: actionSubType,
    auto_mode: autoMode
  });
};
const fetchMainThresholds = async () => await axios.get('/api/sensor-coordinations/main-thresholds/');
const createMainThresholds = async thresholdSettings => {
  return await axios.post('/api/sensor-coordinations/main-thresholds/', thresholdSettings);
};
const updateMainThresholds = async thresholdSettings => {
  const {
    id
  } = thresholdSettings || {};
  return await axios.patch(`/api/sensor-coordinations/main-thresholds/${id}/`, thresholdSettings);
};
const fetchAutonmousConfigs = async ({
  ranchId,
  blockId
}) => {
  if (ranchId) return await axios.get(`/api/sensor-coordinations/automation-schedules/?ranch_id=${ranchId}`);
  if (blockId) return await axios.get(`/api/sensor-coordinations/automation-schedules/?block_id=${blockId}`);
  return new Promise(res => res({
    error: 'No ranchId or blockId passed'
  }));
};
const createAutonmousConfigs = async thresholdSettings => {
  return await axios.post('/api/sensor-coordinations/automation-schedules/', thresholdSettings);
};
const updateAutonmousConfigs = async ({
  scheduleId,
  schedule
}) => {
  return await axios.put(`/api/sensor-coordinations/automation-schedules/${scheduleId}/`, schedule);
};
const deleteAutonmousConfigs = async scheduleId => {
  return await axios.delete(`/api/sensor-coordinations/automation-schedules/${scheduleId}`);
};
const fetchReservoirFailSafeSettings = async () => {
  return await axios.get('/api/sensor-coordinations/reservoir-pressure-failsafe-configs/');
};
const createReservoirFailSafeSettings = async config => {
  return await axios.post('/api/sensor-coordinations/reservoir-pressure-failsafe-configs/', config);
};
const updateReservoirFailSafeSettings = async ({
  configId,
  config
}) => {
  return await axios.put(`/api/sensor-coordinations/reservoir-pressure-failsafe-configs/${configId}/`, config);
};
const deleteReservoirFailSafeSettings = async configId => {
  return await axios.delete(`/api/sensor-coordinations/reservoir-pressure-failsafe-configs/${configId}/`);
};

var coordinationApi$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  fetchSensorCoordinations: fetchSensorCoordinations,
  updateSensorCoordination: updateSensorCoordination,
  fetchMainThresholds: fetchMainThresholds,
  createMainThresholds: createMainThresholds,
  updateMainThresholds: updateMainThresholds,
  fetchAutonmousConfigs: fetchAutonmousConfigs,
  createAutonmousConfigs: createAutonmousConfigs,
  updateAutonmousConfigs: updateAutonmousConfigs,
  deleteAutonmousConfigs: deleteAutonmousConfigs,
  fetchReservoirFailSafeSettings: fetchReservoirFailSafeSettings,
  createReservoirFailSafeSettings: createReservoirFailSafeSettings,
  updateReservoirFailSafeSettings: updateReservoirFailSafeSettings,
  deleteReservoirFailSafeSettings: deleteReservoirFailSafeSettings
});

const getFirmwareList = async deviceType => {
  return axios.get(`/api/firmware/?device_type=${deviceType}`);
};
const firmwareUpgrade = async (nodes, firmwareId, deviceType) => {
  return axios.post('/api/firmware/upgrade/', {
    nodes,
    firmwareId,
    deviceType
  });
};
const deleteFirmwareVersion = async (payload = {}) => {
  return axios.delete('/api/firmware/delete/', {
    data: payload
  });
};
const getDeviceList = async (deviceType, entityId) => {
  return axios.get(`/api/device/list?device_type=${deviceType}&entity=${entityId}`);
};
const refreshConfig = deviceList => {
  return axios.post('/api/node/config/sync', {
    nodes: deviceList
  });
};

var firmwareApi$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getFirmwareList: getFirmwareList,
  firmwareUpgrade: firmwareUpgrade,
  deleteFirmwareVersion: deleteFirmwareVersion,
  getDeviceList: getDeviceList,
  refreshConfig: refreshConfig
});

var api = {
  farmApi: farmApi$1,
  userApi: userApi$1,
  sensorApi: sensorApi$1,
  controlApi: controlApi$1,
  plansApi: plansApi$1,
  blockApi: blockApi$1,
  satelliteApi: satelliteApi$1,
  recommendationApi: recommendationApi$1,
  scheduleApi: scheduleApi$1,
  reportsApi: reportsApi$1,
  teamApi: teamApi$1,
  teamUserAccessApi: teamUserAccessApi$1,
  roleApi: roleApi$1,
  ranchApi: ranchApi$1,
  followBlockApi: followBlockApi$1,
  coordinationApi: coordinationApi$1,
  firmwareApi: firmwareApi$1,
  entityMonitoringApi: entityMonitoringApi$1
};

// TODO: this file is duplicated between both the RN and web repos
axios.defaults.baseURL = constants.API_URL;
let refreshTimer = null;
let isLoggingOut = false;
const HTTP_STATUS_UNAUTHORIZED = 401;
const REFRESH_BUFFER_SECONDS = 60;
const MAX_REFRESH_SECONDS = 86400; // 24 hours
// const info = { path: '/', domain: window.location.hostname, sameSite: 'lax' };
// Some good resources:
// authorize and refresh token using saga:
// https://stackoverflow.com/questions/34930735/pros-cons-of-using-redux-saga-with-es6-generators-vs-redux-thunk-with-es2017-asy
//

const setAuthHeader = token => {
  axios.defaults.headers.common['Authorization'] = "JWT " + token;
  // axios.defaults.headers.common["Set-Cookie"] = "HttpOnly;Secure;SameSite=Strict";
  axios.defaults.withCredentials = true;
};
const setToken = async (tokenName, token) => {
  // const cookies = new Cookies();
  // return await cookies.set(tokenName, token, info);
  await localStorage.setItem(tokenName, token);
};
const getToken = async tokenName => {
  // const cookies = new Cookies();
  // return await cookies.get(tokenName);
  return await localStorage.getItem(tokenName);
};
const removeToken = async tokenName => {
  // const cookies = new Cookies();
  // await cookies.remove(tokenName, info);
  // await cookies.set(tokenName, "removed123", info);
  await localStorage.removeItem(tokenName);
};
const setUserToken = async (token, refreshToken) => {
  await setToken('userToken', token);
  await setToken('refreshToken', refreshToken);
  setAuthHeader(token);
  scheduleRefresh(token);
};
const login = async (username, password) => {
  try {
    const response = await axios.post("/api/token/login/", {
      username: username,
      password: password
    });
    await setUserToken(response.data.access, response.data.refresh);
    return true;
  } catch (error) {
    return false;
  }
};
const loginUsingTokens = async (accessToken, refreshToken) => {
  await setUserToken(accessToken, refreshToken);
  return true;
};
async function logout(dispatch) {
  clearTimeout(refreshTimer);
  await removeToken("userToken");
  await removeToken("refreshToken");
  localStorage.removeItem('persist:selected');
  axios.defaults.headers.common['Authorization'] = null;
  if (dispatch) {
    dispatch({
      type: 'RESET'
    });
  }
}
async function refreshToken() {
  // console.log('Refreshing token');
  const token = await getToken('refreshToken');
  if (!token) {
    console.debug("No token value set");
    return false;
  }
  try {
    const response = await axios.post("/api/token/refresh/", {
      refresh: token
    });
    await setUserToken(response.data.access, response.data.refresh);
    return true;
  } catch (error) {
    if (error?.response?.status === HTTP_STATUS_UNAUTHORIZED) {
      console.log("Refresh token expired");
      await logout();
      window.location.href = "/login";
    }
    return false;
  }
}
function scheduleRefresh(token) {
  clearTimeout(refreshTimer);
  let decodedToken;
  try {
    decodedToken = jwt_decode(token);
  } catch {
    return false;
  }
  const expiration = new Date(decodedToken.exp * 1000);
  const seconds = (expiration - new Date()) / 1000;

  // if in the future, schedule a refresh
  if (seconds > REFRESH_BUFFER_SECONDS) {
    // console.log('Scheduling refresh', seconds - REFRESH_BUFFER_SECONDS);
    let timeout = seconds - REFRESH_BUFFER_SECONDS;
    if (timeout > MAX_REFRESH_SECONDS) timeout = MAX_REFRESH_SECONDS;
    refreshTimer = setTimeout(refreshToken, timeout * 1000);
    return true;
  } else {
    // console.log("timer expired");
    return false;
  }
}
async function refreshTokenOrSchedule() {
  clearTimeout(refreshTimer);
  const token = await getToken('userToken');
  if (token) {
    if (!scheduleRefresh(token)) return await refreshToken();else return true;
  }
  return false;
}
async function getJWTInfo() {
  const refresh = await refreshTokenOrSchedule();
  if (!refresh) return undefined;
  const token = await getToken('userToken');
  if (token) {
    setAuthHeader(token);
    try {
      return jwt_decode(token);
    } catch {
      return undefined;
    }
  }
  return undefined;
}
const fetchStreamAuth = async () => await axios.get('/api/feed/auth/');
function useStream(initialValue) {
  const [value, setValue] = React.useState();
  React.useEffect(() => {
    const fetchToken = async () => {
      try {
        const {
          data
        } = await fetchStreamAuth();
        const {
          token
        } = data;
        setValue(token);
      } catch (error) {
        setValue(initialValue);
      }
    };
    fetchToken();
  }, []);
  return value;
}
async function isAdmin() {
  const userInfo = await getJWTInfo();
  return userInfo && userInfo.admin;
}
function useAuth() {
  refreshTokenOrSchedule();
  const token = localStorage.getItem('userToken');
  if (token) {
    setAuthHeader(token);
    try {
      const decodedToken = jwt_decode(token);
      const expiration = new Date(decodedToken.exp * 1000);
      if (!decodedToken || !decodedToken.user_id || expiration <= new Date()) {
        return undefined;
      }
      return decodedToken;
    } catch {
      return undefined;
    }
  }
}

// Handles refresh token 401 globally
axios.interceptors.response.use(response => response, async error => {
  const originalRequest = error.config;
  if (error?.response?.status === HTTP_STATUS_UNAUTHORIZED && originalRequest?.url?.includes("/api/token/refresh/")) {
    if (!isLoggingOut) {
      isLoggingOut = true;
      console.log("Refresh token invalid. Logging out user.");
      await logout();
      window.location.href = "/login";
    }
  }
  return Promise.reject(error);
});
const validateUserToResetPassword = async email => {
  try {
    await axios.post("/api/password-reset/", {
      email
    });
    return true;
  } catch (error) {
    return false;
  }
};
const validateToken = async token => {
  try {
    await axios.post("/api/password-reset/validate_token/", {
      token
    });
    return true;
  } catch (error) {
    return false;
  }
};
const confirmNewPassword = async (token, newPassword) => {
  try {
    await axios.post("/api/password-reset/confirm/", {
      password: newPassword,
      token
    });
    return true;
  } catch (error) {
    return false;
  }
};
var authService = {
  login,
  loginUsingTokens,
  logout,
  getUserInfo: getJWTInfo,
  isAdmin,
  useAuth,
  useStream,
  validateUserToResetPassword,
  confirmNewPassword,
  validateToken
};

function setTagsForScope(tagsObj, scope) {
  try {
    if (tagsObj && Object.prototype.toString.call(tagsObj) === '[object Object]') {
      Object(tagsObj).keys.forEach(k => {
        scope.setTag(k, tagsObj[k]);
      });
    }
  } catch (error) {
    console.log('ERROR setting tags', error.message);
    console.log('SETTAGS Input', tagsObj);
  }
  return scope;
}
function handleMessage(level, data, tagsObj) {
  try {
    if (process.env.REACT_APP_LOG_LEVEL === 'debug') {
      console.log(`${level.toUpperCase()}: `, data);
    }
    if (!data) {
      return;
    }
    if (process.env.REACT_APP_SENTRY_ENABLED) {
      if (data instanceof Error) {
        Sentry.withScope(scope => {
          scope = setTagsForScope(tagsObj, scope);
          scope.setLevel(level);
          Sentry.captureException(data);
        });
        return;
      }
      let msg = cloneDeep(data);
      if (msg === Object(msg)) {
        msg = JSON.stringify(msg);
      } else {
        msg = `${msg}`;
      }
      Sentry.withScope(scope => {
        scope = setTagsForScope(tagsObj, scope);
        scope.setLevel(level);
        Sentry.captureMessage(msg);
      });
    }
  } catch (error) {
    console.log('ERROR in logger', error);
    console.log('LOGGER input', level, data);
  }
}
const logger = {
  debug: (data, tagsObj) => {
    setTimeout(() => {
      handleMessage('debug', data, tagsObj);
    }, 0);
  },
  info: (data, tagsObj) => {
    setTimeout(() => {
      handleMessage('info', data, tagsObj);
    }, 0);
  },
  warning: (data, tagsObj) => {
    setTimeout(() => {
      handleMessage('warning', data, tagsObj);
    }, 0);
  },
  error: (data, tagsObj) => {
    setTimeout(() => {
      handleMessage('error', data, tagsObj);
    }, 0);
  }
};
async function captureError(cb) {
  try {
    return await cb();
  } catch (error) {
    logger.error(error);
    throw error;
  }
}

const {
  userApi,
  sensorApi,
  farmApi,
  controlApi,
  plansApi,
  blockApi,
  satelliteApi,
  recommendationApi,
  scheduleApi,
  reportsApi,
  teamApi,
  teamUserAccessApi,
  roleApi,
  ranchApi,
  followBlockApi,
  coordinationApi,
  firmwareApi,
  entityMonitoringApi
} = api;

// export {logger, initLogger, captureError };

var excludedNodeKeys = ['key', 'provider', 'networkType', 'date', 'rebootTime', 'chargingStatus', 'chargingState', 'rebootReason', 'index'];
var nodeStatusUnits = {
  rssi: {
    name: 'decibel',
    shortName: 'dB'
  },
  battery: {
    name: 'volts',
    shortName: 'V'
  },
  interval: 'minutes',
  sequence: 'count',
  bandwidth: {
    name: 'kilohertz',
    shortName: 'kHz'
  },
  core_temp: {
    name: 'degrees_celsius',
    shortName: '°C'
  },
  frequency: {
    name: 'hertz',
    shortName: 'Hz'
  },
  cap_charge: {
    name: 'volts',
    shortName: 'V'
  },
  battery_vdd: {
    name: 'volts',
    shortName: 'V'
  },
  gateway_snr: 'ratio',
  temperature: {
    name: 'degrees_fahrenheit',
    shortName: '°F'
  },
  battery_temp: {
    name: 'degrees_fahrenheit',
    shortName: '°F'
  },
  gateway_rssi: {
    name: 'decibel',
    shortName: 'dB'
  },
  sequence_diff: 'count',
  solar_voltage: {
    name: 'milivolts',
    shortName: 'mV'
  },
  battery_voltage: {
    name: 'volts',
    shortName: 'mV'
  },
  sequence_number: 'count',
  charging_current: {
    name: 'mini_amps',
    shortName: 'mA'
  },
  external_voltage: {
    name: 'milivolts',
    shortName: 'mV'
  },
  spreading_factor: 'ratio',
  heamp_memory_free: {
    name: 'bytes',
    shortName: 'B'
  },
  heap_memory_free: {
    name: 'bytes',
    shortName: 'B'
  },
  battery_percentage: {
    name: 'percentage',
    shortName: '%'
  },
  signal_noise_ratio: 'ratio',
  external_memory_free: {
    name: 'bytes',
    shortName: 'B'
  },
  field_node_battery_voltage: {
    name: 'milivolts',
    shortName: 'mV'
  },
  upTime: 'seconds',
  fwAPartFree: {
    name: 'bytes',
    shortName: 'B'
  },
  configAPartFree: {
    name: 'bytes',
    shortName: 'B'
  },
  fwBPartFree: {
    name: 'bytes',
    shortName: 'B'
  },
  configBPartFree: {
    name: 'bytes',
    shortName: 'B'
  },
  sensorDataPartFree: {
    name: 'bytes',
    shortName: 'B'
  },
  systemLogsPartFree: {
    name: 'bytes',
    shortName: 'B'
  },
  scratchAreaPartFree: {
    name: 'bytes',
    shortName: 'B'
  }
};
var nodeStatusKeys = {
  subType: 'sub_type',
  coreTemp: 'core_temp',
  alarmCount: 'alarm_count',
  latestDate: 'latest_date',
  networkType: 'network_type',
  earliestDate: 'earliest_date',
  solarVoltage: 'solar_voltage',
  batteryVoltage: 'battery_voltage',
  dataCount24hr: 'data_count_24hr',
  chargingCurrent: 'charging_current',
  externalVoltage: 'external_voltage',
  heapMemoryFree: 'heap_memory_free',
  dataCountExpected: 'data_count_expected',
  externalMemoryFree: 'external_memory_free',
  rebootTime: 'rebootTime',
  rebootReason: 'rebootReason',
  chargingState: 'chargingState',
  chargingStatus: 'chargingStatus',
  upTime: 'upTime',
  rssi: 'rssi',
  fwAPartFree: 'fwAPartFree',
  configAPartFree: 'configAPartFree',
  fwBPartFree: 'fwBPartFree',
  configBPartFree: 'configBPartFree',
  sensorDataPartFree: 'sensorDataPartFree',
  systemLogsPartFree: 'systemLogsPartFree',
  scratchAreaPartFree: 'scratchAreaPartFree',
  sub_type: 'subType',
  core_temp: 'coreTemp',
  alarm_count: 'alarmCount',
  latest_date: 'latestDate',
  network_type: 'networkType',
  earliest_date: 'earliestDate',
  solar_voltage: 'solarVoltage',
  battery_voltage: 'batteryVoltage',
  data_count_24hr: 'dataCount24hr',
  charging_current: 'chargingCurrent',
  external_voltage: 'externalVoltage',
  heap_memory_free: 'heapMemoryFree',
  data_count_expected: 'dataCountExpected',
  external_memory_free: 'externalMemoryFree'
};
var nodeOperationsTableFieldNames = {
  index: 'S.No',
  id: 'Id',
  date: 'Date Time',
  rssi: 'RSSI',
  type: 'Type',
  online: 'Online',
  subType: 'SubType',
  coreTemp: 'Core Temp',
  identifier: 'Identifier',
  alarmCount: 'Alarm Count',
  latestDate: 'Last Reported',
  provisioned: 'Provisioned',
  networkType: 'Network Type',
  earliestDate: 'Earliest Date',
  solarVoltage: 'Solar Voltage',
  batteryVoltage: 'Battery Voltage',
  dataCount24hr: 'Data Count 24hr',
  chargingCurrent: 'Charging Current',
  externalVoltage: 'External Voltage',
  heapMemoryFree: 'Heap Memory Free',
  dataCountExpected: 'Data Count Expected',
  externalMemoryFree: 'External Memory Free',
  provider: 'Provider',
  rebootTime: 'Reboot Time',
  rebootReason: 'Reboot Reason',
  chargingState: 'Charging State',
  chargingStatus: 'Charging Status',
  upTime: 'Up Time',
  fwAPartFree: 'Firmware partition A free memory',
  configAPartFree: 'Configuration partition A free memory ',
  fwBPartFree: 'Firmware partition B free memory',
  configBPartFree: 'Configuration partition B free memory',
  sensorDataPartFree: 'Sensor data partition free memory',
  systemLogsPartFree: 'System logs partition free memory',
  scratchAreaPartFree: 'Scratch area free memory',
  name: 'Name',
  sub_type: 'SubType',
  core_temp: 'Core Temp',
  alarm_count: 'Alarm Count',
  latest_date: 'Last Reported',
  network_type: 'Network Type',
  earliest_date: 'Earliest Date',
  solar_voltage: 'Solar Voltage',
  battery_voltage: 'Battery Voltage',
  data_count_24hr: 'Data Count 24hr',
  charging_current: 'Charging Current',
  external_voltage: 'External Voltage',
  heap_memory_free: 'Heap Memory Free',
  data_count_expected: 'Data Count Expected',
  external_memory_free: 'External Memory Free',
  reboot_time: 'Reboot Time',
  reboot_reason: 'Reboot Reason',
  fw_version: 'Firmware Version',
  git_info: 'Build',
  spreading_factor: 'Spreading Factor',
  bandwidth: 'Bandwidth',
  frequency: 'Frequency',
  cap_charge: 'Cap Charge',
  gateway_snr: 'Gateway SNR',
  temperature: 'Temperature',
  gateway_rssi: 'Gateway RSSI',
  sequence_number: 'Sequence Number',
  battery_percentage: 'Battery Percentage',
  online24: 'Online 24',
  interval: 'Interval'
};
var monitoringTableFieldNames = {
  id: 'ID',
  ranch_id: 'Ranch ID',
  ranch_name: 'Ranch Name',
  ranch: 'Ranch Name (ID)',
  entity: 'Entity Name (ID)',
  entity_id: 'Entity ID',
  entity_name: 'Entity Name',
  date: 'Date',
  region: 'Region',
  p0_issues: 'P0 Issues',
  p1_issues: 'P1 Issues',
  p0_issues_count: 'P0 Issues (count)',
  p1_issues_count: 'P1 Issues (count)',
  issues: 'Issues',
  type: 'Type',
  priority: 'Priority',
  category: 'Category',
  description: 'Description',
  device_name: 'Device Name',
  sensor_identifier: 'Sensor Identifier',
  device_type: 'Device Type',
  device_id: 'Device ID',
  severity: 'Severity',
  last_seen: 'Last Seen',
  gateway_identifier: 'Gateway Identifier',
  device_topology: 'Device Topology',
  device_status_logs: 'Device Status Logs',
  status: 'Status',
  gateway_id: 'Gateway ID',
  online_gateways: 'Online Gateways',
  offline_gateways: 'Offline Gateways',
  online_sensors: 'Online Sensors',
  offline_sensors: 'Offline Sensors',
  online_nodes: 'Online Nodes',
  offline_nodes: 'Offline Nodes',
  last_recommendation_time: 'Last Recommendation Time'
};

// This color map is used for both map and status tag
// in mobile-ui irrigation recommendation
var stateTagColorCodes = {
  critical: '#e8101e',
  bad: '#F26F30',
  poor: '#faad14',
  good: 'rgb(61, 200, 115)',
  over: '#2196f3',
  unknown: '#989898'
};
var stateTagTextColorCodes = {
  critical: 'white',
  bad: 'white',
  poor: 'black',
  good: 'black',
  over: 'white'
};

// This will be refactored using legend styles
function getAnomalyIconColor(type) {
  if (type === 'disease') {
    return '#000000';
  }
  if (type === 'missing') {
    return '#3dc873';
  }
  if (type === 'irrigation') {
    return '#429aff';
  }
  return '#999999';
}
function getAnomalyIcon(type) {
  if (type === 'disease') {
    return 'icon-air';
  }
  if (type === 'missing') {
    return 'icon-tree';
  }
  if (type === 'under_irrigated' || type === 'over_irrigated' || type === 'standing_water') {
    return 'icon-waterdrop';
  }
  return 'icon-sound';
}
var getColorCodeForIrrigationState = function getColorCodeForIrrigationState(irrigationState) {
  if (irrigationState === 'over_irrigated') {
    return stateTagColorCodes.over;
  }
  if (irrigationState === 'well_irrigated') {
    return stateTagColorCodes.good;
  }
  if (irrigationState === 'drying') {
    return stateTagColorCodes.poor;
  }
  if (irrigationState === 'dry') {
    return stateTagColorCodes.bad;
  }
  if (irrigationState === 'very_dry') {
    return stateTagColorCodes.critical;
  }
  return stateTagColorCodes.unknown;
};
function getAnomalyIconColorBySeverity(type) {
  if (type === 'low') {
    return getColorCodeForIrrigationState('well_irrigated');
  }
  if (type === 'moderate') {
    return getColorCodeForIrrigationState('drying');
  }
  if (type === 'major') {
    return getColorCodeForIrrigationState('dry');
  }
  if (type === 'critical') {
    return getColorCodeForIrrigationState('very_dry');
  }
  return '#999999';
}

// soil state color codes
var soilStateColorCodes = {
  critical: '#e8101e',
  bad: '#F26F30',
  poor: '#faad14',
  good: 'rgb(61, 200, 115)',
  unknown: '#989898',
  over: '#2196f3'
};
var getColorCodeForSoilState = function getColorCodeForSoilState(soilState) {
  if (soilState === 'over_irrigated') {
    return soilStateColorCodes.over;
  }
  if (soilState === 'well_irrigated') {
    return soilStateColorCodes.good;
  }
  if (soilState === 'drying') {
    return soilStateColorCodes.poor;
  }
  if (soilState === 'dry') {
    return soilStateColorCodes.bad;
  }
  if (soilState === 'very_dry') {
    return soilStateColorCodes.critical;
  }
  return soilStateColorCodes.unknown;
};
var stateColorCode = [{
  // Blank 0 gray
  iconColor: '#ffffff',
  markerColor: '#cccccc',
  fillColor: '#cccccc',
  textColor: '#000000'
}, {
  // Offline 1 gray
  iconColor: '#ffffff',
  markerColor: '#cccccc',
  fillColor: '#cccccc',
  textColor: '#000000'
}, {
  // Bad 2 red
  iconColor: '#ff98a4',
  markerColor: '#e23549',
  fillColor: '#e23549',
  textColor: '#35e2ce'
}, {
  // Warning 3 yellow
  iconColor: '#fff4cc',
  markerColor: '#FFCC00',
  fillColor: '#FFCC00',
  textColor: '#0033ff'
}, {
  // Over - 4 blue
  iconColor: '#a0ccff',
  markerColor: '#429aff',
  fillColor: '#429aff',
  textColor: '#fa742'
}, {
  // Good - 5 green
  iconColor: '#4DFA90',
  markerColor: '#3dc873',
  fillColor: '#3dc873',
  textColor: '#c83d92'
}];
var icons = {
  dendrometer: 'icon-leaf',
  farmx_dendrometer: 'icon-leaf',
  ir_plant: 'icon-camera',
  farmx_infrared: 'icon-camera',
  weather_station: 'icon-ios-rainy',
  water_pressure: 'icon-gauge',
  water_flow: 'icon-water-meter',
  water_flow_analog: 'icon-water-meter',
  gateway: 'icon-radio-tower',
  boxer_station: 'icon-radio-tower',
  aquacheck_soil: 'icon-eyedropper',
  pixl_soil: 'icon-eyedropper',
  valve: 'icon-pipe-valve',
  vfd: 'icon-water-pump',
  cavalier: 'icon-radio-waves',
  temperature_humidity: 'icon-thermometer'
};
var sensorTitles = _defineProperty(_defineProperty({
  dendrometer: {
    singular: 'Dendrometer',
    plural: 'Dendrometers'
  },
  farmx_dendrometer: {
    singular: 'Dendrometer',
    plural: 'Dendrometers'
  },
  ir_plant: {
    singular: 'IR Sensor',
    plural: 'IR Sensors'
  },
  farmx_infrared: {
    singular: 'IR Sensor',
    plural: 'IR Sensors'
  },
  weather_station: {
    singular: 'Weather Station',
    plural: 'Weather Stations'
  },
  water_pressure: {
    singular: 'Pressure Sensor',
    plural: 'Pressure Sensors'
  },
  water_flow: {
    singular: 'Flow Meter',
    plural: 'Flow Meters'
  },
  water_flow_analog: {
    singular: 'Flow Meter',
    plural: 'Flow Meters'
  },
  gateway: {
    singular: 'Gateway',
    plural: 'Gateways'
  },
  boxer_station: {
    singular: 'Boxer Station',
    plural: 'Boxer Stations'
  },
  aquacheck_soil: {
    singular: 'Soil Sensor',
    plural: 'Soil Sensors'
  },
  pixl_soil: {
    singular: 'Pixl Soil Sensor',
    plural: 'Pixl Soil Sensors'
  },
  cavalier: {
    singular: 'Cavalier',
    plural: 'Cavaliers'
  },
  valve: {
    singular: 'Valve',
    plural: 'Valves'
  },
  vfd: {
    singular: 'VFD',
    plural: 'VFDs'
  }
}, "farmx_infrared", {
  singular: 'IR Sensor',
  plural: 'IR Sensors'
}), "temperature_humidity", {
  singular: 'Temperature Humidity Sensor',
  plural: 'Temperature Humidity Sensors'
});

/**
  aquacheck_soil,
  cavalier,
  farmx_dendrometer,
  farmx_frost,
  farmx_infrared,
  gateway,
  pixl_soil,
  valve,
  vfd,
  water_flow,
  water_flow_analog,
  water_pressure,
  weather_station,
*/
var mapPresentationModes = {
  connectivity: {
    title: 'Connectivity',
    excludedSensors: ['cavalier']
  },
  waterpressure: {
    title: 'Water pressure',
    includedSensors: ['water_pressure'],
    // TODO redundant psiLevel defined
    psiLevel: 5
  },
  provision: {
    title: 'Provision',
    excludedSensors: []
  },
  soilstatus: {
    title: 'Soil Status',
    excludedSensors: []
  },
  control: {
    title: 'Control',
    includedSensors: ['valve', 'vfd', 'water_flow', 'water_flow_analog', 'water_pressure']
  },
  irrigationRecommendation: {
    // Irrigation Recommendation has no sensor displayed
    // status is displayed via block colors
    title: 'Irrigation Recommendation',
    includedSensors: []
  },
  anomaly: {
    title: 'Anomalies',
    excludedSensors: []
  },
  cropHealth: {
    title: 'Crop Health',
    includedSensors: ['farmx_dendrometer', 'farmx_infrared']
  }
};
function sensorTypeAllowedForMode(presentationMode, sensorProperties, isSensorByTypeOnly) {
  var sensorType = sensorProperties.type,
    block = sensorProperties.block;
  if (presentationMode === 'plants') return true;
  if (presentationMode === 'soilstatus' && isSensorByTypeOnly) {
    return ['aquacheck_soil', 'pixl_soil'].includes(sensorType) && block;
  }
  if (presentationMode === 'waterpressure' && isSensorByTypeOnly) {
    return sensorType === 'water_pressure';
  }
  if (mapPresentationModes[presentationMode].excludedSensors && !mapPresentationModes[presentationMode].includedSensors) {
    return !mapPresentationModes[presentationMode].excludedSensors.includes(sensorType);
  }
  if (mapPresentationModes[presentationMode].includedSensors && !mapPresentationModes[presentationMode].excludedSensors) {
    return mapPresentationModes[presentationMode].includedSensors.includes(sensorType);
  }
  if (!mapPresentationModes[presentationMode]) {
    throw new Error("".concat(presentationMode, " is not defined in mapPresentationModes"));
  }
  throw new Error('mapPresentationModes can not have both includedSensors and excludedSensors');
}
function prepareNumberForDisplay(n) {
  if (!isNumber(n)) {
    return n;
  }
  if (Math.abs(n) < 1) {
    return n.toFixed(3);
  }
  return n.toFixed(1);
}
function getMarkerTooltipByPresentationMode(feature, presentationMode) {
  if (presentationMode === 'waterpressure') {
    return prepareNumberForDisplay(feature.properties.psi);
  }
  return feature.properties.identifier.slice(-5);
}

var selectPressureDetails = selectors.selectPressureDetails;
var loadSensorData = sensorApi.loadSensorData;
var fieldToHeader = fieldToHeader$1;
var prepareGraphData = function prepareGraphData(rawData) {
  var excluded = excludedNodeKeys;
  var result = {};
  rawData.forEach(function (dataItem) {
    var timestamp = dataItem.date;
    Object.entries(dataItem).forEach(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];
      if (excluded.includes(key) || key === 'date') return;
      if (result[key]) {
        var _result$key, _result$key2;
        result[key] = _defineProperty({}, key, _objectSpread2(_objectSpread2({}, (_result$key = result[key]) === null || _result$key === void 0 ? void 0 : _result$key[key]), {}, {
          data: [].concat(_toConsumableArray(((_result$key2 = result[key]) === null || _result$key2 === void 0 || (_result$key2 = _result$key2[key]) === null || _result$key2 === void 0 ? void 0 : _result$key2.data) || []), [[timestamp, value]])
        }));
      } else {
        var _nodeStatusUnits$node;
        result[key] = _defineProperty({}, key, {
          data: [[timestamp, value]],
          units: nodeStatusUnits === null || nodeStatusUnits === void 0 || (_nodeStatusUnits$node = nodeStatusUnits[nodeStatusKeys === null || nodeStatusKeys === void 0 ? void 0 : nodeStatusKeys[key]]) === null || _nodeStatusUnits$node === void 0 ? void 0 : _nodeStatusUnits$node.shortName,
          variable: key,
          name: nodeOperationsTableFieldNames === null || nodeOperationsTableFieldNames === void 0 ? void 0 : nodeOperationsTableFieldNames[key]
        });
      }
    });
  });
  return result;
};
function prepareNodeHealthGraphData(rawData) {
  return prepareGraphData(rawData);
}
function calculatedHeightForMobile() {
  var mainDivElement = document.querySelector('.main-content');
  var footerDivElement = document.querySelector('.bottom-tabbar-container');
  var mainDivHeight = mainDivElement ? mainDivElement.offsetHeight : 0;
  var footerHeight = footerDivElement ? footerDivElement.offsetHeight : 0;
  return mainDivHeight || footerHeight ? mainDivHeight + footerHeight : window.innerHeight;
}

/**
 * @param {*} state - redux state
 * @param {*} blockIds - array of block ids to get pressure details
 * @returns the pressure detail object with waterPressureState
 */
function getPressureDetailsForBlockIds(state, blockIds) {
  var pressureSensors = [];
  if (blockIds && blockIds.length) {
    blockIds.forEach(function (blockId) {
      var pressureDetail = selectPressureDetails(state, blockId);
      var averagePressureCutOff = pressureDetail.pressureCutoff.reduce(function (p, c) {
        return p + c;
      }, 0) / pressureDetail.pressureCutoff.length;
      var averagePressure = Number(pressureDetail.pressure);
      var waterPressureState = 0;
      if (averagePressure >= averagePressureCutOff) {
        waterPressureState = 4;
      } else if (averagePressure < averagePressureCutOff) {
        waterPressureState = 1;
      }
      var pressureDetailWithState = pressureDetail;
      pressureDetail.waterPressureState = waterPressureState;
      pressureSensors.push({
        blockId: blockId,
        pressureDetail: pressureDetailWithState
      });
    });
  }
  var pressureSensorsObj = pressureSensors.reduce(function (acc, obj) {
    acc[obj.blockId] = obj.pressureDetail;
    return acc;
  }, {});
  return pressureSensorsObj;
}

/**
 * @param {*} waterPressureState - number 0 to 4
 * @returns the irrigation state and color
 */
function getBlockIrrigationStateByWaterPressureState(waterPressureState) {
  var irrigationState = 'unknown';
  var color = stateColorCode[waterPressureState].markerColor;
  if (waterPressureState === 4) irrigationState = 'irrigating';
  if (waterPressureState === 1) irrigationState = 'not irrigating';
  return {
    irrigationState: irrigationState,
    color: color
  };
}

// A function to check if new api call is to be used
var newApiCallNeeded = function newApiCallNeeded(type, capabilities) {
  var _process$env;
  var sensorTypesForNewApi = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ['cavalier', 'pixl_soil', 'water_pressure', 'water_flow_analog'];
  var sensorTypesV1 = ((_process$env = process.env) === null || _process$env === void 0 || (_process$env = _process$env.REACT_APP_SENSORTYPES_V1) === null || _process$env === void 0 ? void 0 : _process$env.split(',')) || [];
  if ([].concat(_toConsumableArray(sensorTypesV1), _toConsumableArray(sensorTypesForNewApi !== null && sensorTypesForNewApi !== void 0 && sensorTypesForNewApi.length ? sensorTypesForNewApi : [])).includes(type)) {
    return true;
  }
  if (type === 'cavalier' && capabilities !== null && capabilities !== void 0 && capabilities.length) {
    var gatewayVarList = ['gateway_rssi', 'gateway_snr'];
    var containsRssiOrSnr = capabilities && capabilities.reduce(function (acc, variable) {
      return acc || gatewayVarList.includes(variable);
    }, false);
    return containsRssiOrSnr;
  }
  return false;
};

/**
 * Processes an array of data points to include gaps where data are missing.
 * If the time difference between consecutive timestamps is more than 1 hour,
 * inserts a data point with null value to indicate a gap.
 *
 * @param {Array} d - Array of data points where each point is [timestamp, value].
 * @returns {Array} Processed array of data points including data gaps [timestamp, value].
 */
var processDataGap = function processDataGap(d) {
  var hours = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var processedData = [];
  var HOURS = hours * 3600 * 1000; // hours in milliseconds
  if (d !== null && d !== void 0 && d.length && d !== null && d !== void 0 && d[0]) {
    d.forEach(function (v, i) {
      if (i !== 0) {
        var prevTimestamp = d[i - 1][0];
        var currentTimestamp = v[0];
        var timeDifference = currentTimestamp - prevTimestamp;

        // Insert null value if time difference is more than given HOURS in milliseconds)
        if (timeDifference > HOURS) {
          var averageTimestamp = (prevTimestamp + currentTimestamp) / 2;
          processedData.push([averageTimestamp, null]);
        }
      }
      processedData.push(v);
    });
  }
  return processedData;
};
function getYminMax(data) {
  // eslint-disable-next-line no-restricted-globals
  var values = (data === null || data === void 0 ? void 0 : data.filter(function (d) {
    return !isNaN(d[1]);
  }).map(function (d) {
    return Number(d[1]);
  })) || [];
  var min = Math.min.apply(Math, _toConsumableArray(values));
  var max = Math.max.apply(Math, _toConsumableArray(values));
  return {
    min: min,
    max: max
  };
}
var convertToCelsius = function convertToCelsius(data, getUserUnits) {
  var _getUserUnits = getUserUnits(data, 'degrees_fahrenheit', 'temperature', {
      decimalPlaces: 2
    }),
    value = _getUserUnits.value,
    label = _getUserUnits.label;
  return {
    value: value,
    label: label
  };
};
var convertToFahrenheit = function convertToFahrenheit(data, getUserUnits) {
  var _getUserUnits2 = getUserUnits(data, 'degrees_celsius', 'temperature', {
      decimalPlaces: 2
    }),
    value = _getUserUnits2.value,
    label = _getUserUnits2.label;
  return {
    value: value,
    label: label
  };
};
function psiToUserUnit(value, getUserUnits) {
  var decimalPlaces = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  if (value === null || value === undefined || value === '') return 0;
  var convertedValue = getUserUnits(value, 'pounds_per_square_inch', 'pressure', {
    decimalPlaces: decimalPlaces
  }).value;
  return convertedValue;
}
function getMultiplierAndData(value, getUserUnits) {
  var _variableData, _variableData2, _variableData9, _variableData12;
  var multiplier = 1;
  var chartData = _objectSpread2({}, value);
  var variableData = chartData.data;
  var units = chartData.units || ((_variableData = variableData) === null || _variableData === void 0 || (_variableData = _variableData[0]) === null || _variableData === void 0 ? void 0 : _variableData.units) || '';

  // detect values as strings and convert
  if (typeof ((_variableData2 = variableData) === null || _variableData2 === void 0 || (_variableData2 = _variableData2[0]) === null || _variableData2 === void 0 || (_variableData2 = _variableData2.data) === null || _variableData2 === void 0 || (_variableData2 = _variableData2[0]) === null || _variableData2 === void 0 ? void 0 : _variableData2[1]) === 'string') {
    var _variableData3, _variableData4;
    variableData = [_objectSpread2(_objectSpread2({}, ((_variableData3 = variableData) === null || _variableData3 === void 0 ? void 0 : _variableData3[0]) || {}), {}, {
      data: (_variableData4 = variableData) === null || _variableData4 === void 0 || (_variableData4 = _variableData4[0]) === null || _variableData4 === void 0 || (_variableData4 = _variableData4.data) === null || _variableData4 === void 0 ? void 0 : _variableData4.map(function (datum) {
        return [datum[0], parseFloat(datum[1])];
      })
    })];
  }
  var _getYminMax = getYminMax(variableData[0].data),
    min = _getYminMax.min,
    max = _getYminMax.max;
  chartData.min = min;
  chartData.max = max;

  // fix units of %
  if (units === '%') {
    var _variableData5;
    if ((_variableData5 = variableData) !== null && _variableData5 !== void 0 && _variableData5.length) {
      var _variableData6, _variableData7;
      variableData = [_objectSpread2(_objectSpread2({}, ((_variableData6 = variableData) === null || _variableData6 === void 0 ? void 0 : _variableData6[0]) || {}), {}, {
        data: (_variableData7 = variableData) === null || _variableData7 === void 0 || (_variableData7 = _variableData7[0]) === null || _variableData7 === void 0 || (_variableData7 = _variableData7.data) === null || _variableData7 === void 0 ? void 0 : _variableData7.map(function (datum) {
          return [typeof datum[0] === 'string' ? Date.parse(datum[0]) : datum[0], 100 * datum[1]];
        }),
        min: chartData.min * (!getUserUnits ? 100 : 1),
        max: chartData.max * (!getUserUnits ? 100 : 1)
      })];
    }
    multiplier = 100;
  } else {
    var _variableData8;
    variableData = [_objectSpread2(_objectSpread2({}, ((_variableData8 = variableData) === null || _variableData8 === void 0 ? void 0 : _variableData8[0]) || {}), {}, {
      min: chartData.min,
      max: chartData.max
    })];
  }

  // for psi units
  if (units === 'psi' && (_variableData9 = variableData) !== null && _variableData9 !== void 0 && _variableData9.length && getUserUnits) {
    var _variableData10, _variableData11;
    variableData = [_objectSpread2(_objectSpread2({}, ((_variableData10 = variableData) === null || _variableData10 === void 0 ? void 0 : _variableData10[0]) || {}), {}, {
      data: (_variableData11 = variableData) === null || _variableData11 === void 0 || (_variableData11 = _variableData11[0]) === null || _variableData11 === void 0 ? void 0 : _variableData11.data.map(function (datum) {
        var convertedPressure = psiToUserUnit(datum[1], getUserUnits, 4);
        return [datum[0], convertedPressure];
      })
    })];
  }

  // for temperature units
  var regex = /&deg;{1}|°F{1}|°C{1}/;
  var found = (units === null || units === void 0 ? void 0 : units.match) && (units === null || units === void 0 ? void 0 : units.match(regex)) || [];
  var celsius = (found === null || found === void 0 ? void 0 : found.length) && (units === null || units === void 0 ? void 0 : units.indexOf('C')) > 0;
  var fahrenheit = (found === null || found === void 0 ? void 0 : found.length) && (units === null || units === void 0 ? void 0 : units.indexOf('F')) > 0;
  if ((celsius || fahrenheit) && (_variableData12 = variableData) !== null && _variableData12 !== void 0 && _variableData12.length && getUserUnits) {
    var _variableData13, _variableData14, _variableData15, _variableData16;
    variableData = celsius ? [_objectSpread2(_objectSpread2({}, ((_variableData13 = variableData) === null || _variableData13 === void 0 ? void 0 : _variableData13[0]) || {}), {}, {
      data: (_variableData14 = variableData) === null || _variableData14 === void 0 || (_variableData14 = _variableData14[0]) === null || _variableData14 === void 0 || (_variableData14 = _variableData14.data) === null || _variableData14 === void 0 ? void 0 : _variableData14.map(function (datum) {
        var convertedTemperature = convertToFahrenheit(datum[1], getUserUnits);
        return [datum[0], convertedTemperature.value];
      })
    })] : [_objectSpread2(_objectSpread2({}, ((_variableData15 = variableData) === null || _variableData15 === void 0 ? void 0 : _variableData15[0]) || {}), {}, {
      data: (_variableData16 = variableData) === null || _variableData16 === void 0 || (_variableData16 = _variableData16[0]) === null || _variableData16 === void 0 || (_variableData16 = _variableData16.data) === null || _variableData16 === void 0 ? void 0 : _variableData16.map(function (datum) {
        var convertedTemperature = convertToCelsius(datum[1], getUserUnits);
        return [datum[0], convertedTemperature.value];
      })
    })];
    if (celsius) {
      var _convertToFahrenheit, _convertToFahrenheit2;
      chartData.min = (_convertToFahrenheit = convertToFahrenheit(chartData.min, getUserUnits)) === null || _convertToFahrenheit === void 0 ? void 0 : _convertToFahrenheit.value;
      chartData.max = (_convertToFahrenheit2 = convertToFahrenheit(chartData.max, getUserUnits)) === null || _convertToFahrenheit2 === void 0 ? void 0 : _convertToFahrenheit2.value;
    } else {
      var _convertToCelsius, _convertToCelsius2;
      chartData.min = (_convertToCelsius = convertToCelsius(chartData.min, getUserUnits)) === null || _convertToCelsius === void 0 ? void 0 : _convertToCelsius.value;
      chartData.max = (_convertToCelsius2 = convertToCelsius(chartData.max, getUserUnits)) === null || _convertToCelsius2 === void 0 ? void 0 : _convertToCelsius2.value;
    }
    multiplier = 1;
  }
  return {
    multiplier: multiplier,
    data: variableData,
    chartData: chartData
  };
}

// config for new api version data
function buildConfigV1(seriesData, mergeAxes, compact, hours, getUserUnits) {
  var _Object$keys;
  if (!seriesData) return {};
  var yAxisByUnit = {};
  var yAxisByUnitForUnMergeAxes = {};
  var allSeries = Object.entries(seriesData).map(function (_ref3, i) {
    var _value$data, _grphData$data, _variableData$, _variableData$2, _chartData$variable;
    var _ref4 = _slicedToArray(_ref3, 2),
      key = _ref4[0],
      value = _ref4[1];
    // TODO remove after testing
    // console.log('key', key, 'value', value);
    if (isEmpty(value) || !((_value$data = value.data) !== null && _value$data !== void 0 && _value$data.length)) return undefined;
    var grphData = _objectSpread2({}, value);
    if (!(grphData !== null && grphData !== void 0 && (_grphData$data = grphData.data) !== null && _grphData$data !== void 0 && _grphData$data.length)) return undefined;
    var _getMultiplierAndData = getMultiplierAndData(value, getUserUnits),
      multiplier = _getMultiplierAndData.multiplier,
      variableData = _getMultiplierAndData.data,
      chartData = _getMultiplierAndData.chartData;

    // if int, dont set decimal places, otherwise set to 2
    var isFloat = (variableData === null || variableData === void 0 || (_variableData$ = variableData[0]) === null || _variableData$ === void 0 || (_variableData$ = _variableData$.data) === null || _variableData$ === void 0 || (_variableData$ = _variableData$[0]) === null || _variableData$ === void 0 ? void 0 : _variableData$[1]) % 1 !== 0;
    var decimals = isFloat ? 2 : undefined;
    var chartUnits = chartData.units || (variableData === null || variableData === void 0 || (_variableData$2 = variableData[0]) === null || _variableData$2 === void 0 ? void 0 : _variableData$2.units) || '';
    var axisKeyForUnMergeAxes = chartUnits + key;
    var axisKey = mergeAxes ? chartUnits || key : axisKeyForUnMergeAxes;
    var regex = /&deg;/g;
    var units = (chartUnits === null || chartUnits === void 0 ? void 0 : chartUnits.replace) && (chartUnits === null || chartUnits === void 0 ? void 0 : chartUnits.replace(regex, 'º')) || '';
    var unitsStr = " (".concat(units, ")");
    var variableName = fieldToHeader(key);
    var legendTitle = variableName + unitsStr;
    var yAxis = yAxisByUnit[axisKey];
    yAxisByUnitForUnMergeAxes[axisKeyForUnMergeAxes];
    if (!yAxis) {
      var axisTitle = variableName + unitsStr;
      yAxis = {
        title: {
          text: axisTitle
        },
        id: axisKey,
        opposite: !compact,
        min: parseFloat(chartData.min),
        max: parseFloat(chartData.max)
      };
      yAxisByUnit[axisKey] = yAxis;
      yAxisByUnitForUnMergeAxes[axisKeyForUnMergeAxes] = yAxis;
      // TODO: remove after testing
      // console.log('yAxis', yAxis);
      // console.log('chartData', chartData);
    } else if (yAxis) {
      var _yAxis;
      if ((_yAxis = yAxis) !== null && _yAxis !== void 0 && (_yAxis = _yAxis.title) !== null && _yAxis !== void 0 && _yAxis.text) yAxis.title.text = units;
      yAxis.min = Math.min(yAxis.min, chartData.min);
      yAxis.max = Math.max(yAxis.max, chartData.max);
    }
    if (compact) {
      yAxis.title = null;
      yAxis.labels = {
        x: 0,
        y: -2,
        align: 'left'
      };
    }

    // handle custom coloring for percent max wetness
    var zones;
    if (chartData !== null && chartData !== void 0 && (_chartData$variable = chartData.variable) !== null && _chartData$variable !== void 0 && _chartData$variable.startsWith('percent_max_wetness')) {
      zones = [{
        color: '#e8101e',
        value: 0
      }, {
        color: '#faad14',
        value: 50
      }, {
        color: 'rgb(61, 200, 115)',
        value: 100
      }, {
        color: '#e8101e'
      }];
    }
    return {
      id: "series-".concat(i),
      actualKey: key,
      actualChartKey: chartData === null || chartData === void 0 ? void 0 : chartData.actualChartKey,
      originalUnit: chartData === null || chartData === void 0 ? void 0 : chartData.originalUnit,
      multiplier: multiplier,
      min: chartData.min,
      max: chartData.max,
      variableName: variableName,
      unitsStr: unitsStr,
      name: "".concat(legendTitle, " ").concat(variableData === null || variableData === void 0 ? void 0 : variableData[0].gateway),
      zones: zones,
      type: 'line',
      data: variableData,
      yAxis: axisKey,
      yAxisForUnMergeAxes: axisKeyForUnMergeAxes,
      tooltip: {
        valueDecimals: decimals
      }
    };
  }).reduce(function (acc, series) {
    if (series) {
      var _data$;
      var data = series.data;
      if (data && data.length) {
        data.forEach(function (d, j) {
          acc.push(_objectSpread2(_objectSpread2({}, series), {}, {
            id: "series-".concat(series.variableName, " ").concat(d.gateway || ''),
            data: processDataGap(d.data, hours),
            name: "".concat(series.variableName, " ").concat(d.gateway || '', " ").concat(series.unitsStr),
            yAxis: "".concat(series.yAxis).concat(d.gateway || '')
          }));
          yAxisByUnit["".concat(series.yAxis).concat(d.gateway || '')] = _objectSpread2(_objectSpread2({}, yAxisByUnit[series.yAxis] || {}), {}, {
            min: d.min,
            max: d.max,
            id: "".concat(series.yAxis).concat(d.gateway || '')
          });
          yAxisByUnitForUnMergeAxes["".concat(series.yAxisForUnMergeAxes).concat(d.gateway || '')] = _objectSpread2(_objectSpread2({}, yAxisByUnitForUnMergeAxes[series.yAxisForUnMergeAxes] || {}), {}, {
            min: d.min,
            max: d.max,
            id: "".concat(series.yAxisForUnMergeAxes).concat(d.gateway || '')
          });
        });
      }
      if (data !== null && data !== void 0 && (_data$ = data[0]) !== null && _data$ !== void 0 && _data$.gateway) delete yAxisByUnit[series.yAxis];
    }
    return acc;
  }, []);

  // To adjust the min max when mergeAxes is true (admin-web)
  var yAxisObj;
  if (mergeAxes && ((_Object$keys = Object.keys(yAxisByUnit)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.length) === 1) {
    var _Object$values, _Object$keys$map;
    var minMaxArr = (_Object$values = Object.values(yAxisByUnitForUnMergeAxes)) === null || _Object$values === void 0 || (_Object$values = _Object$values.map(function (item) {
      return [item === null || item === void 0 ? void 0 : item.min, item === null || item === void 0 ? void 0 : item.max];
    })) === null || _Object$values === void 0 || (_Object$values = _Object$values.flat()) === null || _Object$values === void 0 ? void 0 : _Object$values.filter(function (val) {
      return typeof val === 'number' && Number.isFinite(val);
    });
    yAxisObj = (_Object$keys$map = Object.keys(yAxisByUnit).map(function (key) {
      var obj = _objectSpread2({}, yAxisByUnit[key]);
      obj.min = Math.min.apply(Math, _toConsumableArray(minMaxArr));
      obj.max = Math.max.apply(Math, _toConsumableArray(minMaxArr));
      return _defineProperty({}, key, obj);
    })) === null || _Object$keys$map === void 0 ? void 0 : _Object$keys$map.reduce(function (acc, obj) {
      return _objectSpread2(_objectSpread2({}, acc), obj);
    }, {});
  }
  return {
    yAxis: Object.values(yAxisObj || yAxisByUnit),
    series: allSeries.filter(Boolean)
  };
}
var getName = function getName(sensorDetails) {
  var sType = sensorDetails.type,
    sIdentifier = sensorDetails.identifier,
    sName = sensorDetails.name;
  if (!isEmpty(sName)) return sName;
  return "".concat(sType, "/").concat(sIdentifier);
};
function toTitleCase(str) {
  var _str$replace;
  return (str === null || str === void 0 || (_str$replace = str.replace(/_/g, ' ')) === null || _str$replace === void 0 ? void 0 : _str$replace.replace(/\b\w/g, function (_char) {
    return _char.toUpperCase();
  })) || '';
}
var useGetSensorData = function useGetSensorData() {
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    data = _useState2[0],
    setData = _useState2[1];
  var _useState3 = useState({}),
    _useState4 = _slicedToArray(_useState3, 2),
    newData = _useState4[0],
    setNewData = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    loading = _useState6[0],
    setLoading = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    error = _useState8[0],
    setError = _useState8[1];
  var multipleData = useRef(null);
  var fetchSensorData = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(apiCall, onSuccess, onError, id) {
      var response;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            setLoading(true);
            _context.next = 4;
            return apiCall();
          case 4:
            response = _context.sent;
            if (!(response && response.status === 200)) {
              _context.next = 10;
              break;
            }
            onSuccess(response.data);
            setLoading(false);
            _context.next = 12;
            break;
          case 10:
            setLoading(false);
            throw new Error('Invalid response');
          case 12:
            _context.next = 19;
            break;
          case 14:
            _context.prev = 14;
            _context.t0 = _context["catch"](0);
            console.error("Graph Data API call Error for sensor id ".concat(id), _context.t0);
            onError(_context.t0);
            setLoading(false);
          case 19:
            _context.prev = 19;
            setLoading(false);
            return _context.finish(19);
          case 22:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 14, 19, 22]]);
    }));
    return function fetchSensorData(_x, _x2, _x3, _x4) {
      return _ref6.apply(this, arguments);
    };
  }();
  var getSensorData = /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(sensor, variables, startDate, endDate, sensorTypesForNewApi, sensorsString) {
      var _sensorsString$split;
      var _ref8, type, id, sensors, isMultipleSensors, promises;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _ref8 = sensor || {}, type = _ref8.type, id = _ref8.id;
            sensors = sensorsString === null || sensorsString === void 0 || (_sensorsString$split = sensorsString.split(',')) === null || _sensorsString$split === void 0 ? void 0 : _sensorsString$split.map(function (item) {
              var strArr = item === null || item === void 0 ? void 0 : item.split('/');
              return {
                type: strArr === null || strArr === void 0 ? void 0 : strArr[0],
                id: Number(strArr === null || strArr === void 0 ? void 0 : strArr[1]),
                identifier: strArr === null || strArr === void 0 ? void 0 : strArr[2],
                name: strArr === null || strArr === void 0 ? void 0 : strArr[3]
              };
            });
            isMultipleSensors = (sensors === null || sensors === void 0 ? void 0 : sensors.length) > 1;
            if (!isMultipleSensors) {
              _context2.next = 9;
              break;
            }
            multipleData.current = null; // reset

            // collect promises
            promises = sensors.map(function (param) {
              var _ref9 = param || {},
                sensorType = _ref9.type,
                sensorId = _ref9.id,
                name = _ref9.name;
              if (newApiCallNeeded(sensorType, variables, sensorTypesForNewApi) && sensorType && sensorId) {
                return fetchSensorData(function () {
                  return loadSensorData(sensorType, sensorId, variables, startDate, endDate, undefined, 1);
                }, function (responseData) {
                  var keys = Object.keys((responseData === null || responseData === void 0 ? void 0 : responseData.graph_data) || {});
                  keys.forEach(function (key) {
                    var _responseData$graph_d, _responseData$graph_d2, _multipleData$current, _multipleData$current3;
                    var updatedData = _objectSpread2(_objectSpread2({}, responseData === null || responseData === void 0 || (_responseData$graph_d = responseData.graph_data) === null || _responseData$graph_d === void 0 ? void 0 : _responseData$graph_d[key]), {}, {
                      sensor_uid: sensorId,
                      sensor_type: sensorType,
                      sensor_name: name,
                      name: toTitleCase(responseData === null || responseData === void 0 || (_responseData$graph_d2 = responseData.graph_data) === null || _responseData$graph_d2 === void 0 || (_responseData$graph_d2 = _responseData$graph_d2[key]) === null || _responseData$graph_d2 === void 0 ? void 0 : _responseData$graph_d2.variable)
                    });
                    if (!((_multipleData$current = multipleData.current) !== null && _multipleData$current !== void 0 && _multipleData$current[key])) {
                      multipleData.current = _defineProperty({}, key, [updatedData]);
                    } else if ((_multipleData$current3 = multipleData.current) !== null && _multipleData$current3 !== void 0 && _multipleData$current3[key]) {
                      var _multipleData$current4;
                      multipleData.current = _defineProperty({}, key, [].concat(_toConsumableArray((_multipleData$current4 = multipleData.current) === null || _multipleData$current4 === void 0 ? void 0 : _multipleData$current4[key]), [updatedData]));
                    }
                  });
                });
              }
              return null;
            });
            _context2.next = 8;
            return Promise.all(promises);
          case 8:
            // update state once
            setNewData(function (prev) {
              return _objectSpread2(_objectSpread2({}, prev), {}, _defineProperty({}, getName(sensor), multipleData.current));
            });
          case 9:
            if (newApiCallNeeded(type, variables, sensorTypesForNewApi) && !isMultipleSensors) {
              fetchSensorData(function () {
                return loadSensorData(type, id, variables, startDate, endDate, undefined, 1, sensorsString);
              }, function (responseData) {
                setNewData(function (prev) {
                  return _objectSpread2(_objectSpread2({}, prev), {}, _defineProperty({}, getName(sensor), responseData === null || responseData === void 0 ? void 0 : responseData.graph_data));
                });
              }, function (e) {
                return setError({
                  code: -1,
                  message: e.message || 'Error while retrieving data from server!',
                  object: e
                });
              }, id);
            } else if (!isMultipleSensors) {
              fetchSensorData(function () {
                return loadSensorData(type, id, variables, startDate, endDate, undefined, undefined, sensorsString);
              }, function (responseData) {
                setData(function (prev) {
                  return _objectSpread2(_objectSpread2({}, prev), {}, _defineProperty({}, getName(sensor), responseData));
                });
              }, function (e) {
                return setError({
                  code: -1,
                  message: e.message || 'Error while retrieving data from server!',
                  object: e
                });
              }, id);
            }
          case 10:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function getSensorData(_x5, _x6, _x7, _x8, _x9, _x10) {
      return _ref7.apply(this, arguments);
    };
  }();
  var resetData = function resetData(keysOld, keysNew, names) {
    // Clear previous state for the removed sensor
    setData(function (prev) {
      var dataObject;
      if (prev) {
        dataObject = _objectSpread2({}, prev);
        keysOld.forEach(function (key) {
          if (!names.includes(key)) {
            delete dataObject[key];
          }
        });
      }
      return dataObject || prev;
    });
    setNewData(function (prev) {
      var dataObject;
      if (prev) {
        dataObject = _objectSpread2({}, prev);
        keysNew.forEach(function (key) {
          if (!names.includes(key)) {
            delete dataObject[key];
          }
        });
      }
      return dataObject || prev;
    });
  };
  var clearState = function clearState() {
    setData({});
    setNewData({});
  };
  return {
    getSensorData: getSensorData,
    loading: loading,
    data: data,
    newData: newData,
    error: error,
    resetData: resetData,
    clearState: clearState
  };
};

function ItemSelect(props) {
  var onChange = props.onChange,
    onSelect = props.onSelect,
    onBlur = props.onBlur,
    mode = props.mode,
    renderItem = props.renderItem,
    items = props.items,
    tagRender = props.tagRender,
    placeholder = props.placeholder,
    defaultOption = props.defaultOption,
    filterOption = props.filterOption,
    value = props.value,
    dropdownRender = props.dropdownRender,
    dropdownStyle = props.dropdownStyle,
    menuIsOpen = props.menuIsOpen,
    dropdownStyleValues = props.dropdownStyleValues,
    loading = props.loading,
    showSearch = props.showSearch,
    listHeightOffset = props.listHeightOffset,
    onDropdownVisibleChange = props.onDropdownVisibleChange,
    bordered = props.bordered,
    size = props.size,
    listItemHeight = props.listItemHeight,
    disabled = props.disabled;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var children = [];
  if (items && items.length > 0) {
    items.forEach(function (d) {
      children.push(renderItem(d));
    });
  }
  var getDropDownClass = function getDropDownClass(dropDownStyle) {
    var sideBar = document.querySelector('.ant-layout-sider-trigger');
    var styleClassName;
    if (window.innerWidth > 950) {
      if (dropDownStyle && dropDownStyle.leftValue) {
        var createdStyles = StyleSheet.create({
          leftposition: {
            left: "".concat(dropDownStyle.leftValue.current, " !important"),
            width: "".concat(dropDownStyle.minWidthValue.current, " !important")
          }
        });
        styleClassName = "".concat(css(createdStyles.leftposition));
      }
    }
    if (isMobile && window.innerWidth <= 950) {
      // Style for narrow screens
      if (sideBar && sideBar.offsetWidth > 50) {
        var _createdStyles = StyleSheet.create({
          leftposition: {
            left: "".concat(sideBar.offsetWidth + 20, "px !important")
          }
        });
        styleClassName = "".concat(css(_createdStyles.leftposition));
      }
    }
    if (isMobile) {
      // Style for only mobile screens
      var _createdStyles2 = StyleSheet.create({
        leftposition: {
          left: '0px !important',
          width: '100% !important',
          top: '0px !important'
        }
      });
      styleClassName = "".concat(css(_createdStyles2.leftposition));
    }
    return styleClassName;
  };
  var divHeight = calculatedHeightForMobile();
  return /*#__PURE__*/React.createElement("div", {
    id: "select-component-wrapper"
  }, value ? /*#__PURE__*/React.createElement(Select, {
    defaultActiveFirstOption: isMobile,
    showSearch: showSearch,
    filterOption: filterOption,
    mode: mode,
    style: {
      width: '100%'
    },
    placeholder: placeholder || t('Please select'),
    defaultValue: defaultOption || [],
    value: value || undefined,
    onSelect: onSelect,
    onChange: onChange,
    onBlur: onBlur,
    allowClear: true,
    tagRender: tagRender,
    dropdownRender: dropdownRender
    // The below change was done to avoid closing of sensor selecot dropdown
    // when any items in filter dropdown was selected
    // it has to be tested for impact on other functionalities
    ,
    onMouseDown: function onMouseDown(e) {
      e.stopPropagation();
    },
    dropdownStyle: dropdownStyle,
    optionLabelProp: "label",
    dropdownClassName: getDropDownClass(dropdownStyleValues),
    open: menuIsOpen != null ? menuIsOpen : undefined,
    listHeight: isMobile ? divHeight - (listHeightOffset || 70) : 330,
    loading: loading,
    onFocus: onDropdownVisibleChange,
    getPopupContainer: isMobile ? null : function () {
      return document.getElementById('select-component-wrapper');
    },
    bordered: bordered,
    size: size,
    listItemHeight: listItemHeight,
    virtual: items.length > 9,
    disabled: disabled
  }, children) : /*#__PURE__*/React.createElement(Select, {
    defaultActiveFirstOption: isMobile,
    showSearch: showSearch,
    filterOption: filterOption,
    mode: mode,
    style: {
      width: '100%'
    },
    placeholder: t(placeholder || 'Please select'),
    defaultValue: defaultOption || [],
    onSelect: onSelect,
    onChange: onChange,
    onBlur: onBlur,
    allowClear: true,
    tagRender: tagRender,
    dropdownRender: dropdownRender
    // The below change was done to avoid closing of sensor selecot dropdown
    // when any items in filter dropdown was selected
    // it has to be tested for impact on other functionalities
    ,
    onMouseDown: function onMouseDown(e) {
      e.stopPropagation();
    },
    dropdownStyle: dropdownStyle,
    optionLabelProp: "label",
    dropdownClassName: getDropDownClass(dropdownStyleValues),
    open: menuIsOpen != null ? menuIsOpen : undefined,
    listHeight: isMobile ? divHeight - (listHeightOffset || 70) : 330,
    loading: loading,
    onDropdownVisibleChange: onDropdownVisibleChange,
    getPopupContainer: isMobile ? null : function () {
      return document.getElementById('select-component-wrapper');
    },
    bordered: bordered,
    size: size,
    listItemHeight: listItemHeight,
    virtual: items.length > 9,
    disabled: disabled
  }, children));
}
ItemSelect.propTypes = {
  onChange: PropTypes.func,
  onSelect: PropTypes.func,
  onBlur: PropTypes.func,
  mode: PropTypes.string,
  renderItem: PropTypes.func,
  items: PropTypes.arrayOf(PropTypes.any),
  tagRender: PropTypes.func,
  placeholder: PropTypes.string,
  defaultOption: PropTypes.arrayOf(PropTypes.any),
  filterOption: PropTypes.func,
  value: PropTypes.arrayOf(PropTypes.any),
  dropdownRender: PropTypes.func,
  dropdownStyle: PropTypes.shape({}),
  menuIsOpen: PropTypes.bool,
  dropdownStyleValues: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({})]),
  loading: PropTypes.bool,
  showSearch: PropTypes.bool,
  listHeightOffset: PropTypes.number,
  onDropdownVisibleChange: PropTypes.func,
  bordered: PropTypes.bool,
  size: PropTypes.string,
  listItemHeight: PropTypes.number,
  disabled: PropTypes.bool
};
ItemSelect.defaultProps = {
  onChange: null,
  onSelect: null,
  onBlur: null,
  mode: null,
  renderItem: null,
  items: [],
  tagRender: null,
  placeholder: null,
  defaultOption: null,
  filterOption: null,
  value: null,
  dropdownRender: null,
  dropdownStyle: {},
  menuIsOpen: null,
  dropdownStyleValues: null,
  loading: false,
  showSearch: true,
  listHeightOffset: null,
  onDropdownVisibleChange: null,
  bordered: true,
  size: 'middle',
  listItemHeight: null,
  disabled: false
};

var styles$8 = {"left-align":"CommonStyle_left-align__DiRJy","right-align":"CommonStyle_right-align__F1aMb","extra-list-items":"CommonStyle_extra-list-items__M84ct","chart-container-div":"CommonStyle_chart-container-div__nst9H","loader-style":"CommonStyle_loader-style__Do-77","select-dropdown":"CommonStyle_select-dropdown__mXtRR","dropdown-optiondiv":"CommonStyle_dropdown-optiondiv__urAXF","collapse-content":"CommonStyle_collapse-content__ZvmSJ","collapse-content-collapse-selected":"CommonStyle_collapse-content-collapse-selected__2J0be","header":"CommonStyle_header__Y8Cqq","selected-block":"CommonStyle_selected-block__NMdSV","selected-block-text":"CommonStyle_selected-block-text__LqRr6","selected-ranch-header":"CommonStyle_selected-ranch-header__-64Rg","collapsible-list-selected":"CommonStyle_collapsible-list-selected__GnmXm","collapsible-list":"CommonStyle_collapsible-list__GynK6","ant-collapse":"CommonStyle_ant-collapse__WMug9","ant-collapse-item":"CommonStyle_ant-collapse-item__JCtzf","ant-collapse-header":"CommonStyle_ant-collapse-header__FyYEs","list-content":"CommonStyle_list-content__jIMcj","ant-collapse-content":"CommonStyle_ant-collapse-content__SFBxP","ant-collapse-content-box":"CommonStyle_ant-collapse-content-box__IXFJX","selected-value":"CommonStyle_selected-value__en1pU","panel-statusbox":"CommonStyle_panel-statusbox__OPoXL","status-box":"CommonStyle_status-box__mmjd7","ant-tooltip-inner":"CommonStyle_ant-tooltip-inner__2q3I7","list-name":"CommonStyle_list-name__dlxRh","loading-icon":"CommonStyle_loading-icon__IVeen","block-select-tag":"CommonStyle_block-select-tag__qD--s","add-color-to-even-rows":"CommonStyle_add-color-to-even-rows__fpz9M"};

var BlockOption = function BlockOption(_ref) {
  var block = _ref.block;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
    className: styles$8['left-align']
  }, block.name), /*#__PURE__*/React.createElement("span", {
    className: styles$8['right-align']
  }, block.ranch && block.ranch.name));
};
BlockOption.propTypes = {
  block: PropTypes.shape({
    name: PropTypes.string,
    ranch: PropTypes.shape({
      name: PropTypes.string
    })
  }).isRequired
};

var styles$7 = {"color-state-unknown":"SensorSelect_color-state-unknown__eQKNw","color-state-over":"SensorSelect_color-state-over__vKeGF","color-state-ok":"SensorSelect_color-state-ok__-wxs-","color-state-warning":"SensorSelect_color-state-warning__z4fx2","color-state-error":"SensorSelect_color-state-error__4-MpH","color-state-critical":"SensorSelect_color-state-critical__CDkEN","color-state-not-irrigating":"SensorSelect_color-state-not-irrigating__yU3FL","color-state-disease":"SensorSelect_color-state-disease__mwWo2","color-state-missing":"SensorSelect_color-state-missing__hdzON","color-state-irrigation":"SensorSelect_color-state-irrigation__pJ5wp","text-color-normal":"SensorSelect_text-color-normal__C9W5m","text-color-unknown":"SensorSelect_text-color-unknown__jhfRB","ant-typography":"SensorSelect_ant-typography__ihyCm","text-color-over":"SensorSelect_text-color-over__pTIHA","text-color-ok":"SensorSelect_text-color-ok__ZTTBQ","text-color-warning":"SensorSelect_text-color-warning__1x84k","text-color-error":"SensorSelect_text-color-error__4i2SZ","text-color-critical":"SensorSelect_text-color-critical__uIpG0","modal-select-header":"SensorSelect_modal-select-header__OA1d6","mobile-select-dropdown-style":"SensorSelect_mobile-select-dropdown-style__6wBWL","mobile-select-scrollable-div":"SensorSelect_mobile-select-scrollable-div__lUv-7","cancel-button-color":"SensorSelect_cancel-button-color__p6kMA","search-box":"SensorSelect_search-box__3oZVl","custom-input-wrapper":"SensorSelect_custom-input-wrapper__Z0h6k","custom-search-box":"SensorSelect_custom-search-box__YrS1e","clear-btn":"SensorSelect_clear-btn__BEFzH","flex-container":"SensorSelect_flex-container__aExDR","button-centered":"SensorSelect_button-centered__dZDDb","modal-select-header-text":"SensorSelect_modal-select-header-text__7GZfe","sensor-select-outer":"SensorSelect_sensor-select-outer__Rjl8Z","sensor-option-div":"SensorSelect_sensor-option-div__s8D5O","sensor-option-scrolldiv-outer":"SensorSelect_sensor-option-scrolldiv-outer__lurJI","sensor-option-scrolldiv-inner":"SensorSelect_sensor-option-scrolldiv-inner__8Hxzw","filter-outerdiv":"SensorSelect_filter-outerdiv__N3XLZ","scrollbar":"SensorSelect_scrollbar__jGi2s","rc-virtual-list-scrollbar":"SensorSelect_rc-virtual-list-scrollbar__LeRDj","select-filter":"SensorSelect_select-filter__5CPBi","filter-icon":"SensorSelect_filter-icon__4k8-G","select-filter-dropdown":"SensorSelect_select-filter-dropdown__n5RjV","ant-select-selection-item":"SensorSelect_ant-select-selection-item__NxObs","ant-select":"SensorSelect_ant-select__E1WYi","item-select":"SensorSelect_item-select__cAF1l","add-button-style":"SensorSelect_add-button-style__MIlcS","add-text-button-style":"SensorSelect_add-text-button-style__Yu-bR","sensor-options":"SensorSelect_sensor-options__57Wv7","filter-options":"SensorSelect_filter-options__5Z26A","before-add-button":"SensorSelect_before-add-button__lSCAV","option-button":"SensorSelect_option-button__yj3Mu","option-or-button":"SensorSelect_option-or-button__q9D21","option-one":"SensorSelect_option-one__puO3A","option-two":"SensorSelect_option-two__9iwbN","option-three":"SensorSelect_option-three__eG3uU","option-four":"SensorSelect_option-four__7BWPR","sensor-name":"SensorSelect_sensor-name__rJFUF","ranch-name":"SensorSelect_ranch-name__GBP61","identifier":"SensorSelect_identifier__HIUYz","block-name":"SensorSelect_block-name__hg06s","ant-select-item-option-state":"SensorSelect_ant-select-item-option-state__gD1Ea","close-button-style":"SensorSelect_close-button-style__r9xwZ","sensor-select-scroll":"SensorSelect_sensor-select-scroll__EpkNU","sensor-add-button-style":"SensorSelect_sensor-add-button-style__MqJYZ","sensor-filter-color":"SensorSelect_sensor-filter-color__4qvi8","sensor-filter-color-after":"SensorSelect_sensor-filter-color-after__dNh41","sensor-button-color":"SensorSelect_sensor-button-color__dB7MJ","sensor-button-color-after":"SensorSelect_sensor-button-color-after__X2lHZ","sensor-select-filter-background":"SensorSelect_sensor-select-filter-background__7EGbG","sensor-select-filter-background-after":"SensorSelect_sensor-select-filter-background-after__83rN7","tree-select-dropdown":"SensorSelect_tree-select-dropdown__aen6w","mobile-select-modal":"SensorSelect_mobile-select-modal__cLZad","mobile-dropdown-modal-button":"SensorSelect_mobile-dropdown-modal-button__p6UTv","modal-custom-button":"SensorSelect_modal-custom-button__Rdlxk","sensor-select":"SensorSelect_sensor-select__6ZGey","go-back":"SensorSelect_go-back__ZL-oW","custom-modal":"SensorSelect_custom-modal__oe-s4","ant-modal-content":"SensorSelect_ant-modal-content__kp477","ant-modal-body":"SensorSelect_ant-modal-body__zrFR6"};

var Searchbox = function Searchbox(_ref) {
  var onChange = _ref.onChange;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Input, {
    className: styles$7['search-box'],
    placeholder: t('Type to Search'),
    allowClear: true,
    onChange: onChange,
    onKeyDown: function onKeyDown(e) {
      e.stopPropagation();
    }
  }));
};
Searchbox.propTypes = {
  onChange: PropTypes.func
};
Searchbox.defaultProps = {
  onChange: null
};

var DropdownModal = function DropdownModal(_ref) {
  var title = _ref.title,
    displayOptions = _ref.displayOptions,
    mobileScreen = _ref.mobileScreen,
    _onClick = _ref.onClick,
    onChange = _ref.onChange,
    displaySearch = _ref.displaySearch,
    buttonText = _ref.buttonText,
    size = _ref.size,
    showFullHeight = _ref.showFullHeight;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var listHeight = calculatedHeightForMobile();
  var btnHeight = 110; // Custom value to display options properly on sidebar
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: styles$7['flex-container'],
    style: {
      height: mobileScreen && !showFullHeight ? "".concat(listHeight, "px") : "".concat(listHeight - btnHeight, "px")
    }
  }, mobileScreen ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: styles$7['modal-select-header']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$7['modal-select-header-text']
  }, t(title)), /*#__PURE__*/React.createElement("div", null)), displaySearch ? /*#__PURE__*/React.createElement(Searchbox, {
    onChange: onChange
  }) : null) : null, /*#__PURE__*/React.createElement("div", {
    className: styles$7['sensor-option-div'],
    onClick: function onClick(d) {
      return buttonText === 'cancel' ? _onClick(d) : null;
    },
    onKeyPress: function onKeyPress(d) {
      return buttonText === 'cancel' ? _onClick(d) : null;
    },
    role: "button",
    tabIndex: "0"
  }, displayOptions)), mobileScreen ? /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles$7['button-centered'], " custom-button")
  }, /*#__PURE__*/React.createElement(Button, {
    id: "goBack",
    type: "primary",
    className: styles$7['cancel-button-color'],
    size: size,
    onClick: _onClick,
    block: true
  }, t(buttonText))) : null);
};
DropdownModal.propTypes = {
  title: PropTypes.string,
  displayOptions: PropTypes.shape({}),
  mobileScreen: PropTypes.bool,
  onClick: PropTypes.func,
  onChange: PropTypes.func,
  displaySearch: PropTypes.bool,
  buttonText: PropTypes.string,
  size: PropTypes.string,
  showFullHeight: PropTypes.bool
};
DropdownModal.defaultProps = {
  title: null,
  displayOptions: null,
  mobileScreen: false,
  onClick: null,
  onChange: null,
  displaySearch: false,
  buttonText: 'done',
  size: 'middle',
  showFullHeight: null
};

var SensorSelectContext = /*#__PURE__*/React.createContext(3);
SensorSelectContext.Provider;

var Option$5 = Select.Option;
var selectAllBlocks = selectors.selectAllBlocks,
  selectAllNewBlocks = selectors.selectAllNewBlocks,
  selectNewBlocksLoadingState = selectors.selectNewBlocksLoadingState;
var blockTagRender$1 = function blockTagRender(args) {
  var closable = args.closable,
    onClose = args.onClose,
    label = args.label;
  return /*#__PURE__*/React.createElement(Tag, {
    closable: closable,
    onClose: onClose,
    className: styles$8['block-select-tag']
  }, label.props ? label.props.block.name : label);
};
var defaultItemRenderer$3 = function defaultItemRenderer(d) {
  return /*#__PURE__*/React.createElement(Option$5, {
    className: styles$8['add-color-to-even-rows'],
    key: d.id,
    value: d.id,
    label: d.name,
    "data-testid": "".concat(d.name)
  }, /*#__PURE__*/React.createElement(BlockOption, {
    block: d
  }));
};
var BlockSelect = function BlockSelect(_ref) {
  var loadItems = _ref.loadItems,
    items = _ref.items,
    mode = _ref.mode,
    renderItem = _ref.renderItem,
    onSelect = _ref.onSelect,
    onChange = _ref.onChange,
    tagRender = _ref.tagRender,
    placeholder = _ref.placeholder,
    defaultOption = _ref.defaultOption,
    value = _ref.value,
    bordered = _ref.bordered,
    title = _ref.title,
    applyFilter = _ref.applyFilter,
    disabled = _ref.disabled,
    useAllBlockData = _ref.useAllBlockData;
  var dispatch = useDispatch();
  // Using the old selector to retrieve the complete block list for admin-web.
  // This will be removed once the entity scope implementation is done for admin-web.
  var conditionCheck = useAllBlockData ? selectAllBlocks : selectAllNewBlocks;
  var data = useSelector(conditionCheck);
  var blocks = items || data;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    modal = _useState2[0],
    setModalState = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    searchText = _useState4[0],
    setSearchText = _useState4[1];
  var dropdownStyleValues = useContext(SensorSelectContext);
  var blockLoading = useSelector(function (state) {
    return selectNewBlocksLoadingState(state);
  });
  useEffect(function () {
    if (loadItems) loadItems();
    // TODO: Remove it after PR-993 is merged
    // else dispatch(loadFarmData(applyFilter));
  }, [applyFilter, dispatch, loadItems]);
  var dropdownStyle = {
    minWidth: '300px'
  };
  if (isMobile) dropdownStyle = {
    minWidth: '60%'
  };
  function onSelectAction(d) {
    if (onSelect) onSelect(d);
    if (!isMobile) {
      setModalState(false);
    }
  }
  function customFilterMobile(searchStr) {
    var filterResult = blocks.filter(function (d) {
      return d && d.name && d.name.toLowerCase().indexOf(searchStr.toLowerCase()) >= 0 || d && d.ranch && d.ranch.name.toLowerCase().indexOf(searchStr.toLowerCase()) >= 0;
    });
    return filterResult;
  }
  return /*#__PURE__*/React.createElement(ItemSelect, {
    mode: mode,
    renderItem: renderItem,
    items: !isMobile ? blocks : customFilterMobile(searchText),
    onSelect: onSelectAction,
    onChange: onChange,
    tagRender: tagRender || blockTagRender$1,
    placeholder: placeholder,
    defaultOption: defaultOption,
    value: value,
    loading: blockLoading.loading,
    filterOption: function filterOption(input, option) {
      return option.children.props.block.name.toLowerCase().indexOf(input.toLowerCase()) >= 0 || option.children.props.block.ranch && option.children.props.block.ranch.name.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    dropdownStyle: dropdownStyle,
    menuIsOpen: isMobile ? modal : undefined,
    dropdownRender: isMobile ? function (menu) {
      return /*#__PURE__*/React.createElement(DropdownModal, {
        title: title,
        displayOptions: menu,
        mobileScreen: isMobile,
        onClick: function onClick() {
          return setModalState(false);
        },
        onChange: function onChange(d) {
          return setSearchText(d.target.value);
        },
        displaySearch: true,
        size: isMobile ? 'large' : 'middle'
      });
    } : undefined,
    dropdownStyleValues: dropdownStyleValues,
    onDropdownVisibleChange: isMobile ? function () {
      return setModalState(true);
    } : undefined,
    showSearch: !isMobile,
    bordered: bordered,
    listItemHeight: 40 // 40 is the option height
    ,
    disabled: disabled
  });
};
BlockSelect.propTypes = {
  mode: PropTypes.string,
  loadItems: PropTypes.func,
  renderItem: PropTypes.func,
  items: PropTypes.arrayOf(PropTypes.object),
  onSelect: PropTypes.func,
  onChange: PropTypes.func,
  tagRender: PropTypes.func,
  placeholder: PropTypes.string,
  defaultOption: PropTypes.arrayOf(PropTypes.any),
  value: PropTypes.arrayOf(PropTypes.any),
  bordered: PropTypes.bool,
  title: PropTypes.string,
  applyFilter: PropTypes.bool,
  disabled: PropTypes.bool,
  useAllBlockData: PropTypes.bool
};
BlockSelect.defaultProps = {
  mode: null,
  loadItems: null,
  items: null,
  renderItem: defaultItemRenderer$3,
  onSelect: null,
  onChange: null,
  tagRender: null,
  placeholder: null,
  defaultOption: [],
  value: null,
  bordered: true,
  title: 'Block Select',
  applyFilter: true,
  disabled: false,
  useAllBlockData: false
};

var RanchOption = function RanchOption(_ref) {
  var ranch = _ref.ranch;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
    className: styles$8['left-align']
  }, ranch.name), /*#__PURE__*/React.createElement("span", {
    className: styles$8['right-align']
  }, ranch.entity && ranch.entity.name));
};
RanchOption.propTypes = {
  ranch: PropTypes.shape({
    name: PropTypes.string,
    entity: PropTypes.shape({
      name: PropTypes.string
    })
  }).isRequired
};

var mobileScreen$2 = window.innerWidth < 599;
var Option$4 = Select.Option;
var selectAllNewRanches = selectors.selectAllNewRanches,
  selectAllRanches = selectors.selectAllRanches;
var ranchTagRender = function ranchTagRender(args) {
  var label = args.label,
    closable = args.closable,
    onClose = args.onClose;
  return /*#__PURE__*/React.createElement(Tag, {
    closable: closable,
    onClose: onClose,
    style: {
      marginRight: 3
    }
  }, label.props ? label.props.ranch.name : label);
};
var defaultItemRenderer$2 = function defaultItemRenderer(d) {
  return /*#__PURE__*/React.createElement(Option$4, {
    className: styles$8['add-color-to-even-rows'],
    key: d.id,
    value: d.id,
    label: d.name,
    "data-testid": "".concat(d.name)
  }, /*#__PURE__*/React.createElement(RanchOption, {
    ranch: d
  }));
};
var RanchSelect = function RanchSelect(_ref) {
  var loadItems = _ref.loadItems,
    items = _ref.items,
    mode = _ref.mode,
    renderItem = _ref.renderItem,
    onSelect = _ref.onSelect,
    onChange = _ref.onChange,
    tagRender = _ref.tagRender,
    placeholder = _ref.placeholder,
    defaultOption = _ref.defaultOption,
    value = _ref.value,
    applyFilter = _ref.applyFilter,
    disabled = _ref.disabled,
    useAllRanchData = _ref.useAllRanchData,
    dropdownStyle = _ref.dropdownStyle;
  var dispatch = useDispatch();
  // Using the old selector to retrieve the complete ranch list for admin-web.
  // This will be removed once the entity scope implementation is done for admin-web.
  var conditionCheck = useAllRanchData ? selectAllRanches : selectAllNewRanches;
  var data = useSelector(conditionCheck);
  var ranches = items || data;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    modal = _useState2[0],
    setModalState = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    searchText = _useState4[0],
    setSearchText = _useState4[1];
  var dropdownStyleValues = useContext(SensorSelectContext);
  useEffect(function () {
    if (loadItems) loadItems();
    // TODO: Remove it after PR-993 is merged
    // else dispatch(loadFarmData(applyFilter));
  }, [applyFilter, dispatch, loadItems]);
  var dynamicDropdownStyle = {
    minWidth: '300px'
  };
  if (window.innerWidth < 599) dynamicDropdownStyle = {
    minWidth: '60%'
  };
  function onSelectAction(d) {
    if (onSelect) onSelect(d);
    if (!mobileScreen$2) setModalState(false);
  }
  function customFilterMobile(searchStr) {
    var filterResult = ranches.filter(function (d) {
      return d && d.name && d.name.toLowerCase().indexOf(searchStr.toLowerCase()) >= 0 || d && d.entity && d.entity.name.toLowerCase().indexOf(searchStr.toLowerCase()) >= 0;
    });
    return filterResult;
  }
  return /*#__PURE__*/React.createElement("div", {
    id: "ranch-select-div"
  }, /*#__PURE__*/React.createElement(ItemSelect, {
    mode: mode,
    renderItem: renderItem,
    items: !mobileScreen$2 ? ranches : customFilterMobile(searchText),
    onSelect: onSelectAction,
    onChange: onChange,
    tagRender: tagRender || ranchTagRender,
    placeholder: placeholder,
    defaultOption: defaultOption,
    value: value,
    filterOption: function filterOption(input, option) {
      return option.children.props.ranch.name.toLowerCase().indexOf(input.toLowerCase()) >= 0 || option.children.props.ranch.entity && option.children.props.ranch.entity.name.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    dropdownStyle: dynamicDropdownStyle,
    menuIsOpen: mobileScreen$2 ? modal : undefined,
    dropdownRender: mobileScreen$2 ? function (menu) {
      return /*#__PURE__*/React.createElement(DropdownModal, {
        title: "Ranch Select",
        displayOptions: menu,
        mobileScreen: mobileScreen$2,
        onClick: function onClick() {
          return setModalState(false);
        },
        onChange: function onChange(d) {
          return setSearchText(d.target.value);
        },
        displaySearch: true,
        size: mobileScreen$2 ? 'large' : 'middle'
      });
    } : undefined,
    dropdownStyleValues: _objectSpread2(_objectSpread2({}, dropdownStyleValues), dropdownStyle || {}),
    onDropdownVisibleChange: mobileScreen$2 ? function () {
      return setModalState(true);
    } : undefined,
    showSearch: !mobileScreen$2,
    disabled: disabled
  }));
};
RanchSelect.propTypes = {
  mode: PropTypes.string,
  loadItems: PropTypes.func,
  renderItem: PropTypes.func,
  items: PropTypes.arrayOf(PropTypes.object),
  onSelect: PropTypes.func,
  onChange: PropTypes.func,
  tagRender: PropTypes.func,
  placeholder: PropTypes.string,
  defaultOption: PropTypes.arrayOf(PropTypes.any),
  value: PropTypes.arrayOf(PropTypes.any),
  applyFilter: PropTypes.bool,
  disabled: PropTypes.bool,
  useAllRanchData: PropTypes.bool,
  dropdownStyle: PropTypes.shape({})
};
RanchSelect.defaultProps = {
  mode: null,
  loadItems: null,
  items: null,
  renderItem: defaultItemRenderer$2,
  onSelect: null,
  onChange: null,
  tagRender: null,
  placeholder: null,
  defaultOption: [],
  value: null,
  applyFilter: true,
  disabled: false,
  useAllRanchData: false,
  dropdownStyle: null
};

var EntityOption = function EntityOption(_ref) {
  var entity = _ref.entity;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
    className: styles$8['left-align']
  }, entity.name));
};
EntityOption.propTypes = {
  entity: PropTypes.shape({
    name: PropTypes.string
  }).isRequired
};

var mobileScreen$1 = window.innerWidth < 599;
var Option$3 = Select.Option;
var selectAllEntities = selectors.selectAllEntities;
var useEntities$1 = hooks.useEntities;
var entityTagRender = function entityTagRender(args) {
  var label = args.label,
    closable = args.closable,
    onClose = args.onClose;
  return /*#__PURE__*/React.createElement(Tag, {
    closable: closable,
    onClose: onClose,
    style: {
      marginRight: 3
    }
  }, label.props ? label.props.entity.name : label);
};
var defaultItemRenderer$1 = function defaultItemRenderer(d) {
  return /*#__PURE__*/React.createElement(Option$3, {
    className: styles$8['add-color-to-even-rows'],
    key: d.id,
    value: d.id,
    label: d.name,
    "data-testid": "".concat(d.name)
  }, /*#__PURE__*/React.createElement(EntityOption, {
    entity: d
  }));
};
var EntitySelect = function EntitySelect(_ref) {
  var loadItems = _ref.loadItems,
    items = _ref.items,
    mode = _ref.mode,
    renderItem = _ref.renderItem,
    onSelect = _ref.onSelect,
    onChange = _ref.onChange,
    tagRender = _ref.tagRender,
    placeholder = _ref.placeholder,
    defaultOption = _ref.defaultOption,
    applyFilter = _ref.applyFilter,
    value = _ref.value;
  var dispatch = useDispatch();
  var data = useSelector(selectAllEntities);

  // To get new entities
  var _useEntities = useEntities$1(),
    entities = _useEntities.entities;
  var ranches = (items === null || items === void 0 ? void 0 : items.length) && items || (entities === null || entities === void 0 ? void 0 : entities.length) && entities || data;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    modal = _useState2[0],
    setModalState = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    searchText = _useState4[0],
    setSearchText = _useState4[1];
  var dropdownStyle = {
    minWidth: '300px'
  };
  if (mobileScreen$1) dropdownStyle = {
    minWidth: '60%'
  };
  var dropdownStyleValues = useContext(SensorSelectContext);
  useEffect(function () {
    if (loadItems) loadItems();
    // This will be uncommented/removed
    // else dispatch(loadFarmData(applyFilter));
  }, [applyFilter, dispatch, loadItems]);
  function customFilterMobile(searchStr) {
    var filterResult = ranches.filter(function (d) {
      return d && d.name && d.name.toLowerCase().indexOf(searchStr.toLowerCase()) >= 0;
    });
    return filterResult;
  }
  return /*#__PURE__*/React.createElement(ItemSelect, {
    mode: mode,
    renderItem: renderItem,
    items: !mobileScreen$1 ? ranches : customFilterMobile(searchText),
    onSelect: onSelect,
    onChange: onChange,
    tagRender: tagRender || entityTagRender,
    placeholder: placeholder,
    defaultOption: defaultOption,
    value: value,
    filterOption: function filterOption(input, option) {
      return option.children.props.entity.name.toLowerCase().indexOf(input.toLowerCase()) >= 0 || option.children.props.entity && option.children.props.entity.name.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    dropdownStyle: dropdownStyle,
    menuIsOpen: mobileScreen$1 ? modal : undefined,
    dropdownRender: mobileScreen$1 ? function (menu) {
      return /*#__PURE__*/React.createElement(DropdownModal, {
        title: "Entity Select",
        displayOptions: menu,
        mobileScreen: mobileScreen$1,
        onClick: function onClick() {
          return setModalState(false);
        },
        onChange: function onChange(d) {
          return setSearchText(d.target.value);
        },
        displaySearch: true,
        size: mobileScreen$1 ? 'large' : 'middle'
      });
    } : undefined,
    dropdownStyleValues: dropdownStyleValues,
    onDropdownVisibleChange: mobileScreen$1 ? function () {
      return setModalState(true);
    } : undefined,
    showSearch: !mobileScreen$1
  });
};
EntitySelect.propTypes = {
  mode: PropTypes.string,
  loadItems: PropTypes.func,
  renderItem: PropTypes.func,
  items: PropTypes.arrayOf(PropTypes.object),
  onSelect: PropTypes.func,
  onChange: PropTypes.func,
  tagRender: PropTypes.func,
  placeholder: PropTypes.string,
  defaultOption: PropTypes.arrayOf(PropTypes.any),
  applyFilter: PropTypes.bool,
  value: PropTypes.arrayOf(PropTypes.any)
};
EntitySelect.defaultProps = {
  mode: null,
  loadItems: null,
  items: null,
  renderItem: defaultItemRenderer$1,
  onSelect: null,
  onChange: null,
  tagRender: null,
  placeholder: null,
  defaultOption: [],
  applyFilter: true,
  value: null
};

var getNameForSensorType = sensorApi.getNameForSensorType;
function SensorTypeTag(_ref) {
  var sensorType = _ref.sensorType;
  function getColorForType(type) {
    switch (type) {
      case 'weather_station':
        return 'geekblue';
      case 'cavalier':
        return 'purple';
      case 'aquacheck_soil':
        return 'volcano';
      case 'water_pressure':
        return 'blue';
      case 'farmx_dendrometer':
        return 'green';
      case 'pixl_soil':
        return 'orange';
      case 'farmx_infrared':
        return 'lime';
      case 'farmx_frost':
        return 'cyan';
      default:
        return null;
    }
  }
  var color = getColorForType(sensorType);
  return /*#__PURE__*/React.createElement(Tag, {
    color: color
  }, getNameForSensorType(sensorType));
}
SensorTypeTag.propTypes = {
  sensorType: PropTypes.string.isRequired
};

function InstallStateTag(_ref) {
  var state = _ref.state;
  function getColorForState(installState) {
    switch (installState) {
      case 'removed':
        return 'red';
      case 'installed':
        return 'green';
      case 'planned':
        return 'cyan';
      case 'withdrawn':
        return 'purple';
      case 'inventory':
        return 'blue';
      case 'unknown':
        return 'geekblue';
      case 'dead':
        return 'black';
      case 'maintenance':
        return 'magenta';
      default:
        return null;
    }
  }
  return /*#__PURE__*/React.createElement(Tag, {
    color: getColorForState(state)
  }, state);
}
InstallStateTag.propTypes = {
  state: PropTypes.string
};
InstallStateTag.defaultProps = {
  state: null
};

var Text$6 = Typography.Text;
var selectNewRanchById = selectors.selectNewRanchById,
  selectNewBlockById = selectors.selectNewBlockById;
var SensorOption = function SensorOption(_ref) {
  var sensor = _ref.sensor;
  var ranch = useSelector(function (state) {
    return selectNewRanchById(state, sensor.ranch);
  });
  var block = useSelector(function (state) {
    return selectNewBlockById(state, sensor.block);
  });
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("div", {
    id: "sensorOption"
  }, /*#__PURE__*/React.createElement(List, {
    className: styles$7['sensor-options']
  }, /*#__PURE__*/React.createElement(List.Item, {
    className: styles$7['list-sensor-options']
  }, /*#__PURE__*/React.createElement(List.Item.Meta, {
    className: styles$7['option-one'],
    title: sensor.name ? /*#__PURE__*/React.createElement(Text$6, {
      className: styles$7['sensor-name'],
      ellipsis: true,
      title: "".concat(sensor.name)
    }, "".concat(sensor.name)) : /*#__PURE__*/React.createElement(Text$6, {
      style: {
        color: 'lightgray'
      },
      title: "No Name"
    }, t('No Name')),
    description: /*#__PURE__*/React.createElement(Text$6, {
      className: styles$7.identifier,
      ellipsis: true,
      title: "".concat(sensor.identifier)
    }, "".concat(sensor.identifier))
  }), /*#__PURE__*/React.createElement(List.Item.Meta, {
    title: /*#__PURE__*/React.createElement(Text$6, {
      className: styles$7['ranch-name'],
      ellipsis: true,
      title: ranch && ranch.name ? ranch.name : ''
    }, ranch && ranch.name ? ranch.name : ''),
    description: /*#__PURE__*/React.createElement(Text$6, {
      className: styles$7['block-name'],
      ellipsis: true,
      title: block && block.name ? block.name : ''
    }, block && block.name ? block.name : ''),
    className: styles$7['option-two']
  }), /*#__PURE__*/React.createElement("div", {
    className: styles$7['option-three']
  }, /*#__PURE__*/React.createElement(InstallStateTag, {
    state: sensor.install_state
  })), /*#__PURE__*/React.createElement("div", {
    className: styles$7['option-four']
  }, /*#__PURE__*/React.createElement(SensorTypeTag, {
    styles: {
      "float": 'right'
    },
    sensorType: sensor.type
  })))));
};
SensorOption.propTypes = {
  sensor: PropTypes.shape({
    name: PropTypes.string,
    identifier: PropTypes.string,
    ranch: PropTypes.number,
    block: PropTypes.number,
    type: PropTypes.string,
    install_state: PropTypes.string
  }).isRequired
};

var Option$2 = Select.Option;
function InstallStateSelect(props) {
  var selectedState = props.selectedState,
    installStates = props.installStates,
    onChange = props.onChange,
    onSelect = props.onSelect,
    disabled = props.disabled;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    modal = _useState2[0],
    setModalState = _useState2[1];
  var mobileScreen = window.innerWidth < 599;
  var dropdownStyle = null;
  if (mobileScreen) dropdownStyle = {
    minWidth: '60%'
  };
  var dropdownStyleValues = useContext(SensorSelectContext);
  // Generate a unique ID to avoid dropdown rendering and positioning issues
  var id = useId();
  var wrapperId = "install-state-select-wrapper".concat(id);
  var getDropDownClass = function getDropDownClass(dropDownStyle) {
    var styleClassName;
    if (window.innerWidth > 599) {
      if (dropDownStyle && dropDownStyle.leftValue) {
        var createdStyles = StyleSheet.create({
          leftposition: {
            left: "".concat(dropDownStyle.leftValue.current, " !important"),
            width: "".concat(dropDownStyle.minWidthValue.current, " !important")
          }
        });
        styleClassName = "".concat(css(createdStyles.leftposition));
      }
    }
    if (window.innerWidth < 599) {
      styleClassName = "".concat(styles$8['select-dropdown'], " ");
    }
    return styleClassName;
  };
  return /*#__PURE__*/React.createElement("div", {
    id: wrapperId
  }, /*#__PURE__*/React.createElement(Select, {
    disabled: installStates.length === 1 && selectedState || disabled,
    style: {
      width: '100%'
    },
    allowClear: true,
    value: selectedState,
    placeholder: t('Install State'),
    optionLabelProp: "label",
    dropdownMatchSelectWidth: false,
    onChange: onChange,
    onSelect: !mobileScreen ? function (d) {
      setModalState(false);
      if (onSelect) onSelect(d);
    } : null,
    dropdownStyle: dropdownStyle,
    open: mobileScreen ? modal : undefined,
    dropdownClassName: getDropDownClass(dropdownStyleValues),
    dropdownRender: mobileScreen ? function (menu) {
      return /*#__PURE__*/React.createElement(DropdownModal, {
        title: "InstallState Select",
        displayOptions: menu,
        mobileScreen: mobileScreen,
        onClick: function onClick() {
          return setModalState(false);
        }
      });
    } : undefined,
    onDropdownVisibleChange: mobileScreen ? function () {
      return setModalState(true);
    } : undefined
    // To avoid overflow, z-index, and positioning issues with the dropdown for desktop mode
    // Conditionally return a function that retrieves the DOM element later
    ,
    getPopupContainer: isMobile ? null : function () {
      return document.getElementById(wrapperId);
    }
  }, installStates.map(function (value, i) {
    return /*#__PURE__*/React.createElement(Option$2, {
      key: String(i),
      label: t(value),
      value: value,
      "data-testid": "".concat(value)
    }, t(value));
  })));
}
InstallStateSelect.propTypes = {
  selectedState: PropTypes.string,
  installStates: PropTypes.arrayOf(PropTypes.any),
  onChange: PropTypes.func,
  onSelect: PropTypes.func,
  disabled: PropTypes.bool
};
InstallStateSelect.defaultProps = {
  selectedState: undefined,
  installStates: [],
  onChange: function onChange() {},
  onSelect: null,
  disabled: false
};

var Option$1 = Select.Option;
function SensorTypeSelect(props) {
  var selectedType = props.selectedType,
    sensorTypes = props.sensorTypes,
    onChange = props.onChange,
    disabled = props.disabled;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    modal = _useState2[0],
    setModalState = _useState2[1];
  var mobileScreen = window.innerWidth < 599;
  var dropdownStyle = null;
  if (mobileScreen) dropdownStyle = {
    minWidth: '60%'
  };
  var dropdownStyleValues = useContext(SensorSelectContext);
  // Generate a unique ID to avoid dropdown rendering and positioning issues
  var id = useId();
  var wrapperId = "sensor-type-select-wrapper".concat(id);
  var getDropDownClass = function getDropDownClass(dropDownStyle) {
    var styleClassName;
    if (window.innerWidth > 599) {
      if (dropDownStyle && dropDownStyle.leftValue) {
        var createdStyles = StyleSheet.create({
          leftposition: {
            left: "".concat(dropDownStyle.leftValue.current, " !important"),
            width: "".concat(dropDownStyle.minWidthValue.current, " !important")
          }
        });
        styleClassName = "".concat(css(createdStyles.leftposition));
      }
    }
    if (window.innerWidth < 599) {
      styleClassName = "".concat(styles$8['select-dropdown'], " ");
    }
    return styleClassName;
  };
  return /*#__PURE__*/React.createElement("div", {
    id: wrapperId
  }, /*#__PURE__*/React.createElement(Select, {
    disabled: sensorTypes.length === 1 && selectedType || disabled,
    style: {
      width: '100%'
    },
    allowClear: true,
    value: selectedType,
    placeholder: t('Type'),
    optionLabelProp: "label",
    dropdownMatchSelectWidth: false,
    onChange: onChange,
    onSelect: !mobileScreen ? function () {
      return setModalState(false);
    } : null,
    dropdownStyle: dropdownStyle,
    open: mobileScreen ? modal : undefined,
    dropdownClassName: getDropDownClass(dropdownStyleValues),
    dropdownRender: mobileScreen ? function (menu) {
      return /*#__PURE__*/React.createElement("div", {
        className: styles$8['dropdown-option-div']
      }, /*#__PURE__*/React.createElement(DropdownModal, {
        title: t('SensorType Select'),
        displayOptions: menu,
        mobileScreen: mobileScreen,
        onClick: function onClick() {
          return setModalState(false);
        }
      }));
    } : undefined,
    onDropdownVisibleChange: mobileScreen ? function () {
      return setModalState(true);
    } : undefined
    // To avoid overflow, z-index, and positioning issues with the dropdown for desktop mode
    // Conditionally return a function that retrieves the DOM element later
    ,
    getPopupContainer: isMobile ? null : function () {
      return document.getElementById(wrapperId);
    }
  }, sensorTypes.map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    return /*#__PURE__*/React.createElement(Option$1, {
      key: key,
      label: t(value.name),
      "data-testid": "".concat(value.name)
    }, t(value.name));
  })));
}
var sensorTypePropType = PropTypes.string;
SensorTypeSelect.propTypes = {
  selectedType: sensorTypePropType,
  sensorTypes: PropTypes.arrayOf(PropTypes.any),
  onChange: PropTypes.func,
  disabled: PropTypes.bool
};
SensorTypeSelect.defaultProps = {
  selectedType: undefined,
  sensorTypes: [],
  onChange: function onChange() {},
  disabled: false
};

var OP = {
  OR: 'OR',
  AND: 'AND',
  NOT: 'NOT'
}; // FILTER OPERATIONS

var FilterListItem = function FilterListItem(_ref) {
  var onAdd = _ref.onAdd,
    onChange = _ref.onChange,
    changeIndex = _ref.changeIndex,
    onRemove = _ref.onRemove,
    type = _ref.type,
    typeFilter = _ref.typeFilter,
    value = _ref.value,
    op = _ref.op,
    noEdit = _ref.noEdit,
    noDelete = _ref.noDelete,
    showFilter = _ref.showFilter,
    onSetShowFilter = _ref.onSetShowFilter,
    hideFilterOptions = _ref.hideFilterOptions,
    useAllFarmData = _ref.useAllFarmData;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    selectType = _useState2[0],
    setSelectType = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    selectVal = _useState4[0],
    setSelectVal = _useState4[1];
  var _useState5 = useState(OP.AND),
    _useState6 = _slicedToArray(_useState5, 2),
    opVal = _useState6[0],
    setOpVal = _useState6[1];
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    modal = _useState8[0],
    setModalState = _useState8[1];
  var mobileScreen = window.innerWidth < 599;
  var CONDITION_CHECK_1 = (!selectType || !type) && (!value || !selectVal);
  var CONDITION_CHECK_2 = !selectVal || !selectType;
  var INSTALL_STATE = {
    unknown: 'unknown',
    inventory: 'inventory',
    planned: 'planned',
    installed: 'installed',
    removed: 'removed',
    withdrawn: 'withdrawn',
    maintenance: 'maintenance',
    dead: 'dead'
  };
  var onAutomaticAdd = function onAutomaticAdd(val) {
    if (onAdd) {
      setOpVal(OP.AND);
      onAdd({
        type: selectType,
        value: val,
        op: opVal
      });
      setSelectType(undefined);
      setSelectVal(undefined);
      onSetShowFilter(true);
    }
  };
  var onSensorTypeOrStateSelect = function onSensorTypeOrStateSelect(val) {
    if (onChange) {
      setSelectVal(val);
      onChange({
        index: changeIndex,
        type: selectType,
        value: val,
        op: opVal
      });
    }
    onAutomaticAdd(val);
  };
  var getSensorTypes = function getSensorTypes() {
    var allTypes = Object.entries(constants.SENSOR_TYPES);
    if (typeFilter) return allTypes.filter(function (sType) {
      return typeFilter.indexOf(sType[0]) >= 0;
    });
    return allTypes;
  };
  var sensorTypes = getSensorTypes();
  var selectedType;
  if (sensorTypes.length === 1) {
    var selType = sensorTypes[0][0];
    selectedType = selType;
  } else if (value) selectedType = value;
  var installStates = Object.values(INSTALL_STATE);
  var selectedState;
  if (installStates.length === 1) {
    var _selType = installStates[0];
    selectedState = _selType;
  } else if (value) selectedState = value;
  useEffect(function () {
    if (type) setSelectType(type);
    if (value) setSelectVal(value);
    if (op) setOpVal(op);
  }, [type, value, op]);
  var onSelectType = function onSelectType(d) {
    setSelectType(d);
    if (changeIndex >= 0) {
      setSelectVal(undefined);
      onChange({
        index: changeIndex,
        type: d,
        value: undefined,
        op: opVal
      });
    }
    // Work-around for filter clearing while scrolling FF-2974
    if (!changeIndex) {
      if (onAdd) {
        onAdd({
          type: d,
          value: undefined,
          op: opVal
        });
        onSetShowFilter(true);
      }
    }
    if (!mobileScreen) setModalState(false);
  };
  var onSelectVal = function onSelectVal(val) {
    setSelectVal(val);
  };
  var onClickIcon = function onClickIcon() {
    if (!value && !type) {
      if (selectType && selectVal) onAdd({
        type: selectType,
        value: selectVal,
        op: opVal
      });
    } else onRemove({
      index: changeIndex
    });
  };
  var onChangeType = function onChangeType(d) {
    if (value) {
      if (changeIndex >= 0) setSelectVal(undefined);
      onChange({
        index: changeIndex,
        type: d,
        value: changeIndex >= 0 ? undefined : selectVal,
        op: opVal
      });
    }
  };
  var onChangeVal = function onChangeVal(val) {
    onChange({
      index: changeIndex,
      type: selectType,
      value: val,
      op: opVal
    });
    onAutomaticAdd(val);
  };
  var onChangeOp = function onChangeOp(e) {
    var opValue = OP.AND;
    if (e.target.textContent === OP.AND) {
      opValue = OP.OR;
      setOpVal(OP.OR);
    } else setOpVal(OP.AND);
    onChange({
      index: changeIndex,
      type: selectType,
      value: selectVal,
      op: opValue
    });
  };
  var displayOp = function displayOp() {
    return /*#__PURE__*/React.createElement("div", {
      "data-testid": "".concat(opVal || op, "_").concat(value || selectVal)
    }, op && /*#__PURE__*/React.createElement(Button, {
      disabled: noEdit,
      className: styles$7['option-or-button'],
      onClick: onChangeOp
    }, t(opVal) || t(op)));
  };
  function getComponentForType(selectedFilterType) {
    switch (selectedFilterType) {
      case 'ranch':
        return /*#__PURE__*/React.createElement(RanchSelect, {
          disabled: noEdit,
          onSelect: onSelectVal,
          onChange: onChangeVal,
          defaultOption: [value],
          placeholder: "Select Ranch",
          loadItems: function loadItems() {
            return null;
          },
          useAllRanchData: useAllFarmData
        });
      case 'block':
        return /*#__PURE__*/React.createElement(BlockSelect, {
          disabled: noEdit,
          onSelect: onSelectVal,
          onChange: onChangeVal,
          defaultOption: [value],
          value: noEdit && value,
          placeholder: "Select Block",
          loadItems: function loadItems() {
            return null;
          },
          useAllBlockData: useAllFarmData
        });
      case 'entity':
        return /*#__PURE__*/React.createElement(EntitySelect, {
          onSelect: onSelectVal,
          onChange: onChangeVal,
          defaultOption: [value],
          placeholder: "Select Entity",
          loadItems: function loadItems() {
            return null;
          }
        });
      case 'install_state':
        return /*#__PURE__*/React.createElement(InstallStateSelect, {
          disabled: noEdit,
          onSelect: onSelectVal,
          onChange: onSensorTypeOrStateSelect,
          selectedState: selectedState,
          installStates: installStates === null || installStates === void 0 ? void 0 : installStates.filter(function (installState) {
            var _hideFilterOptions$in;
            return !(hideFilterOptions !== null && hideFilterOptions !== void 0 && (_hideFilterOptions$in = hideFilterOptions.installStates) !== null && _hideFilterOptions$in !== void 0 && _hideFilterOptions$in.includes(installState));
          })
        });
      case 'type':
        return /*#__PURE__*/React.createElement(SensorTypeSelect, {
          disabled: noEdit,
          onChange: onSensorTypeOrStateSelect,
          selectedType: selectedType,
          sensorTypes: sensorTypes === null || sensorTypes === void 0 ? void 0 : sensorTypes.filter(function (sensorType) {
            var _hideFilterOptions$se;
            return !(hideFilterOptions !== null && hideFilterOptions !== void 0 && (_hideFilterOptions$se = hideFilterOptions.sensorTypes) !== null && _hideFilterOptions$se !== void 0 && _hideFilterOptions$se.includes(sensorType[0]));
          })
        });
      default:
        return /*#__PURE__*/React.createElement(Select, {
          style: {
            width: '100%'
          },
          options: [],
          placeholder: "--".concat(t('Select'), "--"),
          getPopupContainer: function getPopupContainer(trigger) {
            return trigger.parentNode;
          },
          notFoundContent: t('No Data')
        });
    }
  }
  function renderFilterControls(argType) {
    return /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(FilterOutlined, {
      className: "".concat(styles$7['filter-icon'], " \n            ").concat(styles$7['sensor-filter-color'], " ").concat(type ? styles$7['sensor-filter-color-after'] : '')
    })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Select, {
      disabled: noEdit,
      className: styles$7['select-filter-dropdown'],
      onSelect: onSelectType,
      onChange: onChangeType,
      placeholder: t('Select type'),
      defaultValue: argType,
      value: argType,
      dropdownStyle: {
        minWidth: '100px'
      },
      options: [{
        label: t('ranch'),
        value: 'ranch'
      }, {
        label: t('block'),
        value: 'block'
      }, {
        label: t('entity'),
        value: 'entity'
      }, {
        label: t('install state'),
        value: 'install_state'
      }, {
        label: t('sensor type'),
        value: 'type'
      }],
      onDropdownVisibleChange: mobileScreen ? function () {
        return setModalState(true);
      } : undefined,
      open: mobileScreen ? modal : undefined,
      dropdownClassName: styles$8['select-dropdown'],
      dropdownRender: mobileScreen ? function (menu) {
        return /*#__PURE__*/React.createElement(DropdownModal, {
          title: t('Select Type'),
          displayOptions: menu,
          mobileScreen: mobileScreen,
          onClick: function onClick() {
            return setModalState(false);
          }
        });
      } : undefined,
      getPopupContainer: mobileScreen ? null : function (trigger) {
        return trigger.parentNode;
      }
    })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
      className: styles$7['item-select']
    }, getComponentForType(argType))), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
      className: styles$7['option-button']
    }, displayOp())), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
      className: styles$7['before-add-button']
    }, value || type ? !noDelete && /*#__PURE__*/React.createElement("div", {
      className: "".concat(styles$7['close-button-style'], " \n                        ").concat(styles$7['sensor-add-button-style'])
    }, /*#__PURE__*/React.createElement(CloseOutlined, {
      className: "".concat(styles$7['sensor-button-color'], " \n                          ").concat(type ? styles$7['sensor-button-color-after'] : ''),
      onClick: onClickIcon,
      "data-testid": "".concat(value || selectVal, "_CloseIcon")
    })) : null)));
  }
  return /*#__PURE__*/React.createElement("div", null, showFilter && CONDITION_CHECK_1 && CONDITION_CHECK_2 ? /*#__PURE__*/React.createElement("div", {
    className: styles$7['add-text-button-style'],
    id: "sensor-settings-button-style"
  }, /*#__PURE__*/React.createElement(Button, {
    id: "add_filter",
    type: "primary",
    block: true,
    onClick: function onClick() {
      return onSetShowFilter(false);
    }
  }, t('Add Filter'))) : /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles$7['select-filter'], " \n          ").concat(type ? styles$7['sensor-select-filter-background'] : styles$7['sensor-select-filter-background-after'])
  }, /*#__PURE__*/React.createElement("table", {
    className: styles$7['filter-options']
  }, /*#__PURE__*/React.createElement("tbody", null, type && renderFilterControls(type || selectType), !showFilter && CONDITION_CHECK_1 && renderFilterControls(selectType)))));
};
FilterListItem.propTypes = {
  onAdd: PropTypes.func,
  onChange: PropTypes.func,
  changeIndex: PropTypes.number,
  onRemove: PropTypes.func,
  type: PropTypes.string,
  typeFilter: PropTypes.arrayOf(PropTypes.string),
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  op: PropTypes.string,
  noEdit: PropTypes.bool,
  noDelete: PropTypes.bool,
  showFilter: PropTypes.bool,
  onSetShowFilter: PropTypes.func,
  hideFilterOptions: PropTypes.shape({}),
  useAllFarmData: PropTypes.bool
};
FilterListItem.defaultProps = {
  onAdd: null,
  onChange: null,
  changeIndex: null,
  onRemove: null,
  type: null,
  typeFilter: null,
  value: null,
  op: null,
  noEdit: null,
  noDelete: null,
  showFilter: true,
  onSetShowFilter: null,
  hideFilterOptions: null,
  useAllFarmData: false
};

var Option = Select.Option;
var Text$5 = Typography.Text;
var loadAllSensors = actions.loadAllSensors;
var selectAllSensors = selectors.selectAllSensors,
  selectLoadingSensors = selectors.selectLoadingSensors,
  selectSensor = selectors.selectSensor,
  selectSensorById = selectors.selectSensorById;
var sensorTagRender = function sensorTagRender(args) {
  var closable = args.closable,
    onClose = args.onClose,
    label = args.label;
  return /*#__PURE__*/React.createElement(Tag, {
    closable: closable,
    onClose: onClose,
    style: {
      marginRight: 3
    }
  }, /*#__PURE__*/React.createElement(Text$5, {
    style: {
      maxWidth: isMobile ? '89%' : '100%'
    },
    ellipsis: {
      suffix: '...'
    }
  }, label.props ? label.props.sensor.name : label));
};
var defaultItemRenderer = function defaultItemRenderer(d) {
  var valueObject = JSON.stringify({
    type: d.type,
    identifier: d.identifier,
    id: d.id
  });
  if (!d.count && !d.filterItem) {
    return /*#__PURE__*/React.createElement(Option, {
      key: "".concat(d.identifier, " ").concat(d.name),
      value: valueObject,
      label: d.name ? d.name : 'No Name',
      "data-testid": "".concat(d.name)
    }, /*#__PURE__*/React.createElement(SensorOption, {
      sensor: d
    }));
  }
  if (d.count && !d.filterItem) {
    return /*#__PURE__*/React.createElement(Option, {
      key: "".concat(d.name),
      label: d.name,
      "data-testid": "".concat(d.name),
      disabled: true
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        textAlign: 'center',
        color: 'rgba(0, 0, 0, 0.45)'
      }
    }, d.name));
  }
  if (d.filterItem) {
    return /*#__PURE__*/React.createElement(Option, {
      key: "".concat(d.key),
      label: d.name,
      "data-testid": "".concat(d.name),
      disabled: true
    }, d.item);
  }
  return null;
};
var SensorSelect = function SensorSelect(_ref) {
  var loadItems = _ref.loadItems,
    items = _ref.items,
    mode = _ref.mode,
    renderItem = _ref.renderItem,
    onSelect = _ref.onSelect,
    onChange = _ref.onChange,
    tagRender = _ref.tagRender,
    placeholder = _ref.placeholder,
    defaultOption = _ref.defaultOption,
    dropdownStyle = _ref.dropdownStyle,
    sensorTypeConstraint = _ref.sensorTypeConstraint,
    sensorType = _ref.sensorType,
    sensorIdentifier = _ref.sensorIdentifier,
    sensorId = _ref.sensorId,
    selectedFilters = _ref.selectedFilters,
    onChangeFilters = _ref.onChangeFilters,
    applyFilter = _ref.applyFilter,
    hideFilterOptions = _ref.hideFilterOptions,
    useAllFarmData = _ref.useAllFarmData;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var dispatch = useDispatch();
  var data = useSelector(selectAllSensors);
  var sensors = items || data;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    filterItemList = _useState2[0],
    setFilterItemList = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    searchText = _useState4[0],
    setSearchText = _useState4[1]; // state to maintain search text
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    modal = _useState6[0],
    setModalState = _useState6[1];
  var mobileScreen = window.innerWidth < 599;
  var leftValue = useRef(null);
  var minWidthValue = useRef(null);
  var _useState7 = useState(true),
    _useState8 = _slicedToArray(_useState7, 2),
    showFilter = _useState8[0],
    setShowFilter = _useState8[1];
  var sensorsByPropValues = useSelector(function (state) {
    return selectSensor(state, sensorType, sensorIdentifier);
  });
  var sensorsByPropId = useSelector(function (state) {
    return selectSensorById(state, sensorType, sensorId);
  });
  var sensorLoading = useSelector(function (state) {
    return selectLoadingSensors(state);
  });
  useEffect(function () {
    if (sensorType && !filterItemList.length) {
      var obj = {
        type: 'type',
        value: sensorType,
        op: 'AND'
      };
      setFilterItemList([obj]);
    }
  }, [sensorType, filterItemList.length]);
  useEffect(function () {
    if (selectedFilters && selectedFilters.length) {
      var filters = _toConsumableArray(filterItemList);
      // Remove previously selected filter and keep new one when both type is same
      selectedFilters.forEach(function (newItem) {
        var index = filters.findIndex(function (item) {
          return (item === null || item === void 0 ? void 0 : item.type) === (newItem === null || newItem === void 0 ? void 0 : newItem.type) && (item === null || item === void 0 ? void 0 : item.value) === (newItem === null || newItem === void 0 ? void 0 : newItem.value);
        });
        if (index !== -1) {
          filters[index] = newItem;
        } else {
          filters.push(newItem);
        }
      });
      // Get unique filter and set state
      var uniqueFilters = filters === null || filters === void 0 ? void 0 : filters.filter(function (item, index, self) {
        return index === self.findIndex(function (obj) {
          return (obj === null || obj === void 0 ? void 0 : obj.type) === (item === null || item === void 0 ? void 0 : item.type) && (obj === null || obj === void 0 ? void 0 : obj.value) === (item === null || item === void 0 ? void 0 : item.value) && (obj === null || obj === void 0 ? void 0 : obj.op) === (item === null || item === void 0 ? void 0 : item.op);
        });
      });
      setFilterItemList(uniqueFilters);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFilters]);
  useEffect(function () {
    if (sensorTypeConstraint && sensorTypeConstraint.length > 0 && !filterItemList.length) {
      var objList = sensorTypeConstraint.map(function (d) {
        return {
          type: 'type',
          value: d,
          op: 'OR',
          noEdit: true,
          noDelete: true
        };
      });
      setFilterItemList(_toConsumableArray(objList));
    }
  }, [sensorTypeConstraint, filterItemList.length]);
  var sensorValue;
  if (sensorsByPropValues) {
    sensorValue = {
      type: sensorsByPropValues.type,
      identifier: sensorsByPropValues.identifier,
      id: sensorsByPropValues.id
    };
  } else if (sensorsByPropId) {
    sensorValue = {
      type: sensorsByPropId.type,
      identifier: sensorsByPropId.identifier,
      id: sensorsByPropId.id
    };
  } else if (sensorId && !sensorValue && sensorType && sensorIdentifier) {
    sensorValue = {
      type: sensorType,
      identifier: sensorIdentifier,
      id: sensorId
    };
  }
  useEffect(function () {
    var divElement = document.querySelector('#sensorSelect');
    if (divElement !== null && !leftValue.current) {
      setTimeout(function () {
        var declare = divElement.parentNode.parentNode.style;
        if (!declare.left.includes('-') && declare.left !== null) {
          leftValue.current = declare.left;
          minWidthValue.current = declare.minWidth;
        }
      }, 1000);
    }
  });
  var onChangeFilter = useCallback(function (dat) {
    if (onChangeFilters) onChangeFilters(dat);
  }, [onChangeFilters]);
  var filterItems = useMemo(function () {
    var _filterItemList$;
    // Get count of hidden filters from index 0
    var hiddenFiltersCount = ((_filterItemList$ = filterItemList[0]) === null || _filterItemList$ === void 0 ? void 0 : _filterItemList$.hide) && filterItemList.reduce(function (acc, p, i) {
      if (acc === i && p.hide) return acc + 1;
      return acc;
    }, 0);

    // display the list of selected filters
    var selectedFilterLists = filterItemList.map(function (item, index) {
      return /*#__PURE__*/React.createElement(FilterListItem, {
        key: String(index),
        type: item.type,
        value: item.value,
        onRemove: function onRemove(obj) {
          var filterItemListCopy = _toConsumableArray(filterItemList);
          filterItemListCopy.splice(obj.index, 1);

          // To keep the 'AND' operation as always default to the first filter rule
          //        - if no selected filters already
          // If selected filters are available, Then keep the 'AND' operation as default
          // to the next added filter rule based on the "obj.index"
          // (NOTE: The "obj.index" will be the index of the removed filter)
          var addedFilters = filterItemListCopy === null || filterItemListCopy === void 0 ? void 0 : filterItemListCopy.filter(function (d) {
            return !(d !== null && d !== void 0 && d.hide);
          });
          var hiddenFilters = filterItemListCopy === null || filterItemListCopy === void 0 ? void 0 : filterItemListCopy.filter(function (d) {
            return d === null || d === void 0 ? void 0 : d.hide;
          });
          var finalIndex = obj.index - (hiddenFiltersCount || 0);
          var updatedFilterItemList = addedFilters.map(function (d, fIndex) {
            if (!finalIndex && !fIndex && (d === null || d === void 0 ? void 0 : d.op) !== 'AND') return _objectSpread2(_objectSpread2({}, d), {}, {
              op: 'AND'
            });
            return d;
          });

          // Combine hiddenFilters and udpated filters
          var finalFilters = [].concat(_toConsumableArray(hiddenFilters), _toConsumableArray(updatedFilterItemList));
          setFilterItemList(_toConsumableArray(finalFilters));
          onChangeFilter(_toConsumableArray(finalFilters));
        },
        onChange: function onChange(obj) {
          var existingFilters = filterItemList === null || filterItemList === void 0 ? void 0 : filterItemList.filter(function (d) {
            return (d === null || d === void 0 ? void 0 : d.type) === (obj === null || obj === void 0 ? void 0 : obj.type) && (d === null || d === void 0 ? void 0 : d.value) === (obj === null || obj === void 0 ? void 0 : obj.value);
          });

          // Avoid updating duplicate filters
          if ((existingFilters === null || existingFilters === void 0 ? void 0 : existingFilters.length) <= 1) {
            filterItemList[obj.index] = {
              type: obj.type,
              value: obj.value,
              op: obj.op
            };
          }
          setFilterItemList(_toConsumableArray(filterItemList));
          onChangeFilter(_toConsumableArray(filterItemList));
        },
        changeIndex: index,
        op: index !== 0 && index !== hiddenFiltersCount && item.op // if index is not zero and
        // not hiddenFiltersCount, show AND or OR button
        || index === 0 && item.op === OP.NOT // if index is zero show only NOT
        ? item.op : '',
        typeFilter: sensorTypeConstraint,
        noEdit: item.noEdit,
        noDelete: item.noDelete,
        hideFilterOptions: hideFilterOptions,
        useAllFarmData: useAllFarmData
      });
    });

    // The main filter item to add to above list
    var defaultFilter = /*#__PURE__*/React.createElement(FilterListItem, {
      onAdd: function onAdd(obj) {
        setFilterItemList([].concat(_toConsumableArray(filterItemList), [obj]));
        onChangeFilter([].concat(_toConsumableArray(filterItemList), [obj]));
      },
      onChange: function onChange(obj) {
        filterItemList[obj.index] = {
          type: obj.type,
          value: obj.value,
          op: obj.op
        };
        setFilterItemList(_toConsumableArray(filterItemList));
        onChangeFilter(_toConsumableArray(filterItemList));
      },
      op: filterItemList.length > 0 ? OP.AND : '',
      typeFilter: sensorTypeConstraint,
      showFilter: showFilter,
      onSetShowFilter: function onSetShowFilter(d) {
        return setShowFilter(d);
      },
      hideFilterOptions: hideFilterOptions,
      useAllFarmData: useAllFarmData
    });
    return [].concat(_toConsumableArray(selectedFilterLists), [defaultFilter]);
  }, [filterItemList, hideFilterOptions, onChangeFilter, sensorTypeConstraint, showFilter]);
  var filteredSensorData = sensors.filter(function (sensor) {
    if (sensorTypeConstraint && sensorTypeConstraint.length > 0) {
      return sensorTypeConstraint.indexOf(sensor.type) >= 0;
    }
    return true;
  }).filter(function (sensor) {
    return (
      // NOT operation result is always AND with result till that point
      filterItemList.filter(function (curr) {
        return curr.op === OP.NOT;
      }).reduce(function (prev, curr) {
        return prev && sensor[curr.type] && sensor[curr.type] !== curr.value;
      }, true)
    );
  }).filter(function (sensor) {
    return filterItemList.filter(function (d) {
      return d.op !== OP.NOT;
    }).filter(function (d) {
      return d.value;
    }).reduce(function (prev, curr) {
      if (curr.op === OP.OR) {
        return prev || sensor[curr.type] === curr.value;
      }
      return prev && sensor[curr.type] === curr.value;
    }, true);
  });
  var countOfFilteredSensorData = [{
    name: "".concat(filteredSensorData.length, " ").concat(t('results')),
    count: true
  }];
  var filterOptionsList = filterItems.map(function (d, index) {
    var _filterItemList$index;
    return {
      filterItem: true,
      item: d,
      key: "Item_".concat(index),
      hide: (_filterItemList$index = filterItemList[index]) === null || _filterItemList$index === void 0 ? void 0 : _filterItemList$index.hide
    };
  });
  var sensorData = [].concat(_toConsumableArray(filterOptionsList.filter(function (d) {
    return !d.hide;
  })), countOfFilteredSensorData, _toConsumableArray(filteredSensorData));
  /**
   * Below filter function only for mobile
   * @param {*} searchStr - Input: searchText and sensorData
   * Output: Filtered sensorData based on searchText
   */
  function customFilterMobile(searchStr) {
    var filterResult = sensorData.filter(function (d) {
      return !d.count && !d.filterItem && (d && d.name && d.name.toLowerCase().indexOf(searchStr.toLowerCase()) >= 0 || d && d.type.toLowerCase().indexOf(searchStr.toLowerCase()) >= 0 || d && d.identifier && d.identifier.toLowerCase().indexOf(searchStr.toLowerCase()) >= 0 || d && d.install_state && d.install_state.toLowerCase().indexOf(searchStr.toLowerCase()) >= 0);
    });
    var countOfFilterResult = [{
      name: "".concat(filterResult.length, " ").concat(t('results')),
      count: true
    }];
    return [].concat(_toConsumableArray(filterOptionsList.filter(function (d) {
      return !d.hide;
    })), countOfFilterResult, _toConsumableArray(filterResult));
  }
  var listHeight = calculatedHeightForMobile();
  var dropdownRender = function dropdownRender(menu) {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      id: "sensorSelect",
      className: "".concat(styles$7['flex-container'], " ").concat(styles$7['sensor-select-scroll']),
      style: {
        height: mobileScreen ? "".concat(listHeight, "px") : 'auto'
      }
    }, mobileScreen ? /*#__PURE__*/React.createElement("div", {
      className: styles$7['modal-select-header']
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$7['modal-select-header-text']
    }, "Sensor Select"), /*#__PURE__*/React.createElement("div", null)) : null, mobileScreen ? /*#__PURE__*/React.createElement("div", {
      className: "custom-input-wrapper"
    }, /*#__PURE__*/React.createElement("input", {
      type: "text",
      className: styles$7['custom-search-box'],
      value: searchText,
      onChange: function onChange(e) {
        var _e$target;
        return setSearchText(e === null || e === void 0 || (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.value);
      },
      placeholder: t('Type to Search')
    }), searchText && /*#__PURE__*/React.createElement(CloseCircleOutlined, {
      onClick: function onClick() {
        return setSearchText('');
      },
      className: styles$7['clear-btn']
    })) : null, /*#__PURE__*/React.createElement("div", {
      className: styles$7['sensor-option-scrolldiv-outer']
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$7['sensor-option-scrolldiv-inner']
    }, menu))), mobileScreen ? /*#__PURE__*/React.createElement("div", {
      className: styles$7['button-centered']
    }, /*#__PURE__*/React.createElement(Button, {
      id: "goBack",
      type: "primary",
      block: true,
      onClick: function onClick() {
        return setModalState(false);
      }
    }, t('done'))) : null);
  };
  useEffect(function () {
    if (loadItems) loadItems();else if (useAllFarmData) {
      dispatch(loadAllSensors());
    }
  }, [loadItems, useAllFarmData, dispatch]);
  useEffect(function () {
    // TODO: Remove it after PR-993 is merged
    // dispatch(loadFarmData(applyFilter));
  }, [applyFilter, dispatch]);
  function onSelectAction(d) {
    if (onSelect) onSelect(d);
    if (!mobileScreen) setModalState(false);
  }
  var onChangeAction = function onChangeAction(d) {
    var multipleMode = mode === 'multiple';
    if (onChange && d && !multipleMode) {
      onChange(JSON.parse(d));
    } else if (onChange && d && multipleMode) {
      onChange(d.map(function (e) {
        return JSON.parse(e);
      }));
    } else if (onChange && !d) {
      onChange({
        id: undefined,
        type: undefined,
        identifier: undefined
      });
      onChangeFilter([]);
    }
  };
  var customFilter = function customFilter(input, option) {
    if (option.children.props.sensor && option.children.props.sensor.name && option.children.props.sensor.name.toLowerCase().indexOf(input.toLowerCase()) >= 0 || option.children.props.sensor && option.children.props.sensor.type.toLowerCase().indexOf(input.toLowerCase()) >= 0 || option.children.props.sensor && option.children.props.sensor.identifier && option.children.props.sensor.identifier.toLowerCase().indexOf(input.toLowerCase()) >= 0 || option.children.props.sensor && option.children.props.sensor.install_state && option.children.props.sensor.install_state.toLowerCase().indexOf(input.toLowerCase()) >= 0) {
      return true;
    }
    return false;
  };

  /**
   * Logic to calculate minWidth for dropDown style on narrow screens
   * 500px is the mininum width and 950px is the max width upto the dropdown in admin-web
   */
  var minWidthForDropdown = window.innerWidth > 500 && window.innerWidth < 950 ? {
    minWidth: "".concat(window.innerWidth - 360 > 450 ? window.innerWidth - 360 : 450, "px")
  } : {
    minWidth: '600px'
  };

  // Function to calculate minWidth on screen resize
  window.onresize = function onresize() {
    var _window = window,
      innerWidth = _window.innerWidth;
    mobileScreen = innerWidth < 599;
    if (innerWidth > 500 && innerWidth < 950) {
      minWidthForDropdown = {
        minWidth: "".concat(innerWidth - 360, "px")
      };
    }
  };

  // Logic to calculate minWidth on browser resize
  var fixedStyle = window.innerWidth <= 500 && window.innerHeight > 600 ? {
    minWidth: "".concat(window.innerWidth - 50, "px")
  } : undefined;
  return /*#__PURE__*/React.createElement(SensorSelectContext.Provider, {
    value: {
      leftValue: leftValue,
      minWidthValue: minWidthValue
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$7['sensor-select-outer'],
    id: "sensorScrollStyle"
  }, /*#__PURE__*/React.createElement(ItemSelect, {
    showSearch: !mobileScreen,
    mode: mode,
    renderItem: renderItem,
    items: !mobileScreen ? sensorData : customFilterMobile(searchText),
    onSelect: onSelectAction,
    onChange: onChangeAction,
    onBlur: function onBlur() {
      return !mobileScreen ? setModalState(false) : null;
    },
    tagRender: tagRender || sensorTagRender,
    placeholder: modal ? t('Type to Search') : placeholder,
    filterOption: function filterOption(input, option) {
      return customFilter(input, option);
    },
    dropdownRender: dropdownRender,
    defaultOption: defaultOption,
    value: sensorValue ? [JSON.stringify(sensorValue)] : null,
    dropdownStyle: mobileScreen ? fixedStyle : dropdownStyle || minWidthForDropdown,
    menuIsOpen: mobileScreen ? modal : undefined,
    loading: sensorLoading.loading,
    listItemHeight: 54 // 54 is the option height
    ,
    onDropdownVisibleChange: mobileScreen ? function () {
      return setModalState(true);
    } : undefined
  })));
};
SensorSelect.propTypes = {
  mode: PropTypes.string,
  loadItems: PropTypes.func,
  items: PropTypes.arrayOf(PropTypes.object),
  renderItem: PropTypes.func,
  onSelect: PropTypes.func,
  onChange: PropTypes.func,
  tagRender: PropTypes.func,
  placeholder: PropTypes.string,
  defaultOption: PropTypes.arrayOf(PropTypes.any),
  dropdownStyle: PropTypes.shape({}),
  sensorTypeConstraint: PropTypes.arrayOf(PropTypes.string),
  sensorId: PropTypes.number,
  sensorIdentifier: PropTypes.string,
  sensorType: PropTypes.string,
  selectedFilters: PropTypes.arrayOf(PropTypes.object),
  onChangeFilters: PropTypes.func,
  applyFilter: PropTypes.bool,
  hideFilterOptions: PropTypes.shape({}),
  useAllFarmData: PropTypes.bool
};
SensorSelect.defaultProps = {
  mode: null,
  loadItems: null,
  items: null,
  renderItem: defaultItemRenderer,
  onSelect: null,
  onChange: null,
  tagRender: null,
  placeholder: null,
  defaultOption: [],
  dropdownStyle: null,
  sensorTypeConstraint: null,
  sensorId: null,
  sensorIdentifier: null,
  sensorType: null,
  selectedFilters: null,
  onChangeFilters: null,
  applyFilter: false,
  hideFilterOptions: null,
  useAllFarmData: false
};

var getColorForValue$2 = function getColorForValue(value) {
  if (value) return 'green';
  return 'red';
};
function BooleanTag(_ref) {
  var value = _ref.value,
    labels = _ref.labels;
  if (value === undefined || value === null) return null;
  var _labels = _slicedToArray(labels, 2),
    labelTrue = _labels[0],
    labelFalse = _labels[1];
  return /*#__PURE__*/React.createElement(Tag, {
    color: getColorForValue$2(value)
  }, value ? labelTrue : labelFalse);
}
BooleanTag.propTypes = {
  value: PropTypes.bool,
  labels: PropTypes.arrayOf(PropTypes.string)
};
BooleanTag.defaultProps = {
  value: undefined,
  labels: ['yes', 'no']
};

var getColorForValue$1 = function getColorForValue(value) {
  if (value === 'ok') return 'green';
  if (value === 'warning') return 'yellow';
  if (value === 'error') return 'red';
  return undefined;
};
var values = ['ok', 'warning', 'error'];
function renderLabelForValue(value, labels) {
  var _labels = _slicedToArray(labels, 3),
    labelOk = _labels[0],
    labelWarning = _labels[1],
    labelError = _labels[2];
  if (value === 'ok') return labelOk;
  if (value === 'warning') return labelWarning;
  if (value === 'error') return labelError;
  return 'unknown';
}
function StoplightTag(_ref) {
  var value = _ref.value,
    labels = _ref.labels;
  if (value === undefined || value === null) return null;
  return /*#__PURE__*/React.createElement(Tag, {
    color: getColorForValue$1(value)
  }, renderLabelForValue(value, labels));
}
StoplightTag.propTypes = {
  value: PropTypes.oneOf([].concat(values, [undefined])),
  labels: PropTypes.arrayOf(PropTypes.string)
};
StoplightTag.defaultProps = {
  value: undefined,
  labels: values
};

var _excluded = ["component", "authService"];
function AdminRoute(_ref) {
  var Component = _ref.component,
    authService = _ref.authService,
    rest = _objectWithoutProperties(_ref, _excluded);
  var userInfo = authService.useAuth();
  var authorized = userInfo && userInfo.admin;
  var render = function render(props) {
    return /*#__PURE__*/React.createElement(Component, props);
  };
  return authorized ? /*#__PURE__*/React.createElement(Route, _extends({
    render: render
  }, rest)) : /*#__PURE__*/React.createElement(Redirect, {
    to: {
      pathname: '/'
    }
  });
}
AdminRoute.propTypes = {
  component: PropTypes.elementType.isRequired,
  authService: PropTypes.shape({
    useAuth: PropTypes.func.isRequired
  }).isRequired
};

var styles$6 = {"location-container":"LatLngButton_location-container__m0gXQ","location-btn":"LatLngButton_location-btn__SPfl2","copy-icon":"LatLngButton_copy-icon__FBHAH"};

function LatLngButton(props) {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var location = props.location;
  if (!location || _typeof(location) !== 'object') return null;
  var lat = location.lat,
    lng = location.lng;
  var newLat = Number(lat.toFixed(6));
  var newLng = Number(lng.toFixed(6));
  var NAVIGATION_URL = "https://www.google.com/maps?saddr=My+Location&daddr=".concat(lat, ",").concat(lng);
  var copyHandler = function copyHandler() {
    setIsOpen(true);
    navigator.clipboard.writeText("".concat(lat, ", ").concat(lng));
    setTimeout(function () {
      setIsOpen(false);
    }, 1000);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: styles$6['location-container']
  }, /*#__PURE__*/React.createElement(Tooltip, {
    title: t('Navigate')
  }, /*#__PURE__*/React.createElement("a", {
    className: styles$6['location-btn'],
    target: "_blank",
    href: NAVIGATION_URL
  }, /*#__PURE__*/React.createElement(FaCrosshairs, {
    className: "map-icon"
  }), /*#__PURE__*/React.createElement("span", null, "".concat(t('Lat'), " ").concat(newLat, ", ").concat(t('Long'), " ").concat(newLng)))), /*#__PURE__*/React.createElement("div", {
    className: "copy",
    onClick: copyHandler
  }, /*#__PURE__*/React.createElement(Tooltip, {
    open: isOpen,
    title: t('Copied')
  }, /*#__PURE__*/React.createElement(FaRegCopy, {
    className: styles$6['copy-icon']
  }))));
}
LatLngButton.propTypes = {
  location: PropTypes.shape({
    lat: PropTypes.number.isRequired,
    lng: PropTypes.number.isRequired
  }).isRequired
};

var styles$5 = {"custom-table":"CommonStyles_custom-table__SCzLD","configuration-message":"CommonStyles_configuration-message__lfBip","schedule-item-header":"CommonStyles_schedule-item-header__HfNf2","sensor-header":"CommonStyles_sensor-header__ky422","state-header":"CommonStyles_state-header__8qlyG","alarms-header":"CommonStyles_alarms-header__tOjcp","sub-header":"CommonStyles_sub-header__sPuvv","list-container":"CommonStyles_list-container__zi4JY","space-between":"CommonStyles_space-between__wkGjH","space-after":"CommonStyles_space-after__QrOOi","anticon":"CommonStyles_anticon__TW6mI","warning-icon":"CommonStyles_warning-icon__gWURq","indicator":"CommonStyles_indicator__aIbVn","schedule-header":"CommonStyles_schedule-header__aVp9-","blue":"CommonStyles_blue__5SdoP","red":"CommonStyles_red__h0-k3","light-grey":"CommonStyles_light-grey__7TLG-","red-border-text":"CommonStyles_red-border-text__YrKUQ","inner-table":"CommonStyles_inner-table__7x0S5","tag-icon":"CommonStyles_tag-icon__8kjwa","tag-icon-irrigation-state":"CommonStyles_tag-icon-irrigation-state__xdDN9","tag-icon-override":"CommonStyles_tag-icon-override__XAx8a","tag-icon-irrigating":"CommonStyles_tag-icon-irrigating__Ro6eq","icon-container":"CommonStyles_icon-container__59QGj","red-message":"CommonStyles_red-message__4qG0N","schedule-content":"CommonStyles_schedule-content__PhEkD","normal-message":"CommonStyles_normal-message__5GOe0","icon":"CommonStyles_icon__-Qnjd","switch":"CommonStyles_switch__k9fLn","switch-left":"CommonStyles_switch-left__DEKxk","switch-right":"CommonStyles_switch-right__darjO","bell-icon-button":"CommonStyles_bell-icon-button__yiLy-","bell-icon-size":"CommonStyles_bell-icon-size__3NfKW","mobile-sensor-alarm-button":"CommonStyles_mobile-sensor-alarm-button__8kWlY","bell-icon-enabled":"CommonStyles_bell-icon-enabled__TQCgV","bell-icon-disabled":"CommonStyles_bell-icon-disabled__0exTJ","status":"CommonStyles_status__uf1-q","no-data-message":"CommonStyles_no-data-message__vqJBU","hidden-column":"CommonStyles_hidden-column__WHj-S","override-header":"CommonStyles_override-header__CFPzX","anticon-warning":"CommonStyles_anticon-warning__ip3QK","connect":"CommonStyles_connect__cPdZi","last-data":"CommonStyles_last-data__ycJXO"};

var ConfirmValveOverrideDialog = function ConfirmValveOverrideDialog(_ref) {
  var title = _ref.title,
    displayText = _ref.displayText,
    buttonText = _ref.buttonText,
    onClick = _ref.onClick;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    modal = _useState2[0],
    setModalState = _useState2[1];
  function callOnClick(d) {
    if (d) setModalState(false);
    onClick(d.target.id);
  }
  return /*#__PURE__*/React.createElement("div", null, modal ? /*#__PURE__*/React.createElement(Modal, {
    title: t(title),
    centered: true,
    visible: modal,
    onCancel: callOnClick,
    footer: [/*#__PURE__*/React.createElement(Button, {
      key: "cancel",
      onClick: callOnClick
    }, t('Cancel')), /*#__PURE__*/React.createElement(Button, {
      id: buttonText[0],
      key: buttonText[0],
      value: buttonText[0],
      onClick: callOnClick,
      type: "primary",
      style: {
        background: 'red',
        borderColor: 'red'
      }
    }, /*#__PURE__*/React.createElement("span", {
      id: buttonText[0]
    }, t(buttonText[0]))), /*#__PURE__*/React.createElement(Button, {
      id: buttonText[1],
      key: buttonText[1],
      value: buttonText[1],
      onClick: callOnClick,
      type: "primary"
    }, /*#__PURE__*/React.createElement("span", {
      id: buttonText[1]
    }, t(buttonText[1])))],
    closable: true,
    maskClosable: false,
    destroyOnClose: true
  }, displayText.map(function (d, i) {
    return /*#__PURE__*/React.createElement("p", {
      key: String(i)
    }, t(d));
  })) : null);
};
ConfirmValveOverrideDialog.propTypes = {
  title: PropTypes.string,
  displayText: PropTypes.arrayOf(PropTypes.string),
  buttonText: PropTypes.arrayOf(PropTypes.string),
  onClick: PropTypes.func
};
ConfirmValveOverrideDialog.defaultProps = {
  title: null,
  displayText: null,
  buttonText: null,
  onClick: function onClick() {
    return null;
  }
};

var RefreshContext = /*#__PURE__*/React.createContext(3);
RefreshContext.Provider;

var VALVE_TYPE = 'valve';
var VFD_TYPE = 'vfd';
var loadSensorStatus$4 = actions.loadSensorStatus;
var createOverride = controlApi.createOverride,
  endOverride = controlApi.endOverride;
function OverrideStatus(_ref) {
  var type = _ref.type,
    overrideStatus = _ref.overrideStatus,
    valveIdentifier = _ref.valveIdentifier,
    vfdIdentifier = _ref.vfdIdentifier,
    confirmDialogMessages = _ref.confirmDialogMessages,
    currentState = _ref.currentState;
  var dispatch = useDispatch();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    toggleChanged = _useState2[0],
    setToggleChanged = _useState2[1];
  var HTTP_SUCCESS_RES_CODE = 200;
  var OVERRIDE_STATE_CHECK_INTERVAL = 5000;
  var OVERRIDE_STATE_CHECK_TIMEOUT = 15000;
  var refreshStatusInterval = useRef(null);
  var valveOverrideSyncState = useRef('pending');
  var refreshId = useContext(RefreshContext);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;

  // confirm override dialog attr
  var OVERRIDE_CONFIRM_DIALOG_TITLE = type === VALVE_TYPE ? 'Confirm Valve Override' : 'Confirm Pump Override';
  var buttonText = type === VALVE_TYPE ? ['CLOSE', 'OPEN'] : ['OFF', 'ON'];
  useEffect(function () {
    if (refreshId && valveIdentifier) {
      dispatch(loadSensorStatus$4({
        type: VALVE_TYPE,
        identifier: valveIdentifier
      }));
    }
    if (refreshId && vfdIdentifier) {
      dispatch(loadSensorStatus$4({
        type: VFD_TYPE,
        identifier: vfdIdentifier
      }));
    }
  }, [dispatch, valveIdentifier, vfdIdentifier, refreshId]);
  function refreshSensorStatus(param) {
    dispatch(loadSensorStatus$4(param));
  }
  function clearRefreshInterval() {
    if (refreshStatusInterval.current) {
      clearInterval(refreshStatusInterval.current);
      refreshStatusInterval.current = null;
    }
  }
  function refreshUntilSynced() {
    refreshStatusInterval.current = setInterval(function () {
      if (valveOverrideSyncState.current !== 'pending') {
        clearRefreshInterval();
      } else {
        if (type === VALVE_TYPE) {
          refreshSensorStatus({
            type: type,
            identifier: valveIdentifier
          });
        }
        if (type === VFD_TYPE) {
          refreshSensorStatus({
            type: type,
            identifier: vfdIdentifier
          });
        }
      }
    }, OVERRIDE_STATE_CHECK_INTERVAL);
    setTimeout(clearRefreshInterval, OVERRIDE_STATE_CHECK_TIMEOUT);
  }
  var onConfirmValveOverride = function onConfirmValveOverride(overOp) {
    if (overOp === 'OPEN' || overOp === 'CLOSE' || overOp === 'OFF' || overOp === 'ON') {
      var newState;
      var paramObj;
      if (type === VALVE_TYPE) {
        newState = overOp === 'OPEN' ? 'open' : 'closed';
        paramObj = {
          sensorType: VALVE_TYPE,
          sensorIdentifier: valveIdentifier,
          state: newState
        };
      } else if (type === VFD_TYPE) {
        newState = overOp === 'ON' ? 'on' : 'off';
        paramObj = {
          sensorType: VFD_TYPE,
          sensorIdentifier: vfdIdentifier,
          state: newState
        };
      }
      if (paramObj) {
        var response = createOverride({
          sensorType: type === VALVE_TYPE ? VALVE_TYPE : VFD_TYPE,
          sensorIdentifier: type === VALVE_TYPE ? valveIdentifier : vfdIdentifier,
          state: newState
        });
        response.then(function (res) {
          if (res.status === HTTP_SUCCESS_RES_CODE) {
            if (type === VALVE_TYPE) {
              refreshSensorStatus({
                type: VALVE_TYPE,
                identifier: valveIdentifier
              });
            } else {
              refreshSensorStatus({
                type: VFD_TYPE,
                identifier: vfdIdentifier
              });
            }
            message.success(t('Created override'));
            refreshUntilSynced();
            setToggleChanged(false);
          } else {
            message.error(t('Failed to create override'));
          }
        });
      }
    } else {
      setToggleChanged(false);
    }
  };
  var onChangeToggle = function onChangeToggle(checked) {
    if (!checked) {
      var paramObj;
      if (type === VALVE_TYPE) {
        paramObj = {
          sensorType: VALVE_TYPE,
          sensorIdentifier: valveIdentifier
        };
      } else if (type === VFD_TYPE) {
        paramObj = {
          sensorType: VFD_TYPE,
          sensorIdentifier: vfdIdentifier
        };
      }
      if (paramObj) {
        var response = endOverride(paramObj);
        response.then(function (res) {
          if (res.status === HTTP_SUCCESS_RES_CODE) {
            if (type === VALVE_TYPE) {
              refreshSensorStatus({
                type: VALVE_TYPE,
                identifier: valveIdentifier
              });
              message.success(t('Ended valve override'));
            } else {
              refreshSensorStatus({
                type: VFD_TYPE,
                identifier: vfdIdentifier
              });
              message.success(t('Ended pump override'));
            }
            refreshUntilSynced();
          } else if (type === VALVE_TYPE) {
            message.error(t('Failed to end valve override'));
          } else {
            message.error(t('Failed to end pump override'));
          }
        });
      }
    } else {
      setToggleChanged(true);
    }
  };
  var overrideActive = !!overrideStatus;
  if (overrideActive) {
    valveOverrideSyncState.current = overrideStatus.syncStatus;
  }
  function getOverrideStateColor(overrideStatusObj) {
    if (overrideStatusObj && overrideStatusObj.state) {
      if (overrideStatusObj.state === 'open' || overrideStatusObj.state === 'on') {
        return 'green';
      }
      return 'red';
    }
    return null;
  }
  function getValveOverrideStateTitle(overrideStatusObj) {
    if (overrideStatusObj && overrideStatusObj.state) {
      return overrideStatusObj.state.toUpperCase();
    }
    return 'unknown';
  }
  function getSyncStatusIcon(overrideStatusObj) {
    var icons;
    if (!overrideStatus || !overrideStatus.syncStatus) icons = null;
    if (overrideStatusObj) {
      if (overrideStatusObj.syncStatus === 'success') icons = /*#__PURE__*/React.createElement(CheckOutlined, null);
      if (overrideStatusObj.syncStatus === 'pending') icons = /*#__PURE__*/React.createElement(LoadingOutlined, null);
      if (overrideStatusObj.syncStatus === 'error') icons = /*#__PURE__*/React.createElement(WarningFilled, null);
      if (overrideStatusObj.syncStatus === 'aborted') icons = /*#__PURE__*/React.createElement(WarningFilled, null);
    }
    return icons;
  }
  function getControlColumn() {
    if (currentState) {
      return /*#__PURE__*/React.createElement(Switch, {
        style: {
          background: overrideActive ? getOverrideStateColor(overrideStatus) : null,
          width: 'auto',
          minWidth: '57px'
        },
        checkedChildren: t(getValveOverrideStateTitle(overrideStatus)),
        unCheckedChildren: t('NONE'),
        "data-testid": valveIdentifier || vfdIdentifier,
        checked: overrideActive,
        onChange: onChangeToggle
      });
    }
    if (currentState === 'unknown' || !currentState) {
      return /*#__PURE__*/React.createElement(WarningFilled, {
        className: styles$5['tag-icon-override']
      });
    }
    return '';
  }
  return /*#__PURE__*/React.createElement("div", {
    className: styles$5["switch"]
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$5['switch-left']
  }, getControlColumn()), /*#__PURE__*/React.createElement("div", {
    className: styles$5['switch-right']
  }, getSyncStatusIcon(overrideStatus)), /*#__PURE__*/React.createElement("div", null), toggleChanged ? /*#__PURE__*/React.createElement(ConfirmValveOverrideDialog, {
    title: OVERRIDE_CONFIRM_DIALOG_TITLE,
    displayText: confirmDialogMessages,
    buttonText: buttonText,
    onClick: onConfirmValveOverride
  }) : '');
}
OverrideStatus.propTypes = {
  type: PropTypes.string,
  overrideStatus: PropTypes.shape({
    state: PropTypes.string,
    syncStatus: PropTypes.string
  }),
  valveIdentifier: PropTypes.string,
  vfdIdentifier: PropTypes.string,
  confirmDialogMessages: PropTypes.arrayOf(PropTypes.string),
  currentState: PropTypes.string
};
OverrideStatus.defaultProps = {
  type: null,
  overrideStatus: null,
  valveIdentifier: null,
  vfdIdentifier: null,
  confirmDialogMessages: [],
  currentState: null
};

function getAlarmListUrl(_ref) {
  var type = _ref.type,
    identifier = _ref.identifier;
  var params = {
    sensorType: type,
    sensorIdentifier: identifier,
    logLevel: 'error',
    active: true
  };
  var paramStr = new URLSearchParams(params).toString();
  return "/events?".concat(paramStr);
}
function SensorAlarmButton(props) {
  var alarmCount = props.alarmCount,
    identifier = props.identifier,
    isMobileView = props.isMobileView,
    type = props.type;
  return /*#__PURE__*/React.createElement(Link, {
    to: getAlarmListUrl({
      type: type,
      identifier: identifier
    })
  }, /*#__PURE__*/React.createElement(Badge, {
    className: isMobileView ? styles$5['mobile-sensor-alarm-button'] : '',
    count: alarmCount
  }, /*#__PURE__*/React.createElement(Button, {
    className: styles$5['bell-icon-button'],
    title: "Notifications",
    icon: /*#__PURE__*/React.createElement(FaBell, {
      className: "".concat(styles$5['bell-icon-size'], ",\n              ").concat(styles$5['bell-icon'], ",\n              ").concat(alarmCount === 0 ? styles$5['bell-icon-disabled'] : styles$5['bell-icon-enabled'])
    })
  })));
}
SensorAlarmButton.propTypes = {
  type: PropTypes.string.isRequired,
  identifier: PropTypes.string.isRequired,
  alarmCount: PropTypes.number,
  isMobileView: PropTypes.bool
};
SensorAlarmButton.defaultProps = {
  alarmCount: null,
  isMobileView: false
};

function PumpStateTag(_ref) {
  var state = _ref.state,
    online = _ref.online;
  var color = state === 'on' ? '#1890FF' : '#D40202';
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  if (state) {
    if (state !== 'unknown') {
      if (online && state === 'off') {
        return /*#__PURE__*/React.createElement(Tag, {
          color: "",
          key: state,
          className: styles$5['tag-icon']
        }, t(state.toUpperCase()));
      }
      return /*#__PURE__*/React.createElement(Tag, {
        color: color,
        key: state,
        className: [styles$5['tag-icon'], styles$5['tag-icon-irrigating']]
      }, t(state.toUpperCase()));
    }
    return /*#__PURE__*/React.createElement(WarningFilled, {
      className: styles$5['warning-icon']
    });
  }
  if (!state) {
    return /*#__PURE__*/React.createElement(WarningFilled, {
      className: styles$5['warning-icon']
    });
  }
  return '';
}
PumpStateTag.propTypes = {
  state: PropTypes.string,
  online: PropTypes.bool
};
PumpStateTag.defaultProps = {
  state: null,
  online: null
};

var selectPumpFlowMeter = selectors.selectPumpFlowMeter;
var loadSensorStatus$3 = actions.loadSensorStatus;
function PumpControlSensorList(_ref) {
  var pumpType = _ref.pumpType,
    pumpIdentifier = _ref.pumpIdentifier;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t,
    i18n = _useTranslation.i18n;
  var dispatch = useDispatch();
  var refreshId = useContext(RefreshContext);
  var flowMeter = useSelector(function (state) {
    return selectPumpFlowMeter(state, pumpType, pumpIdentifier);
  });
  var _ref2 = flowMeter || {},
    flowMeterIdentifier = _ref2.identifier,
    flowMeterType = _ref2.type;
  useEffect(function () {
    if (refreshId && flowMeterIdentifier && flowMeterType) {
      var sensorParams = {
        type: flowMeterType,
        identifier: flowMeterIdentifier
      };
      dispatch(loadSensorStatus$3(sensorParams));
    }
  }, [dispatch, refreshId, flowMeterType, flowMeterIdentifier]);
  moment.locale(i18n.language);
  function renderSensorName(sensor) {
    if (!sensor.name) {
      return /*#__PURE__*/React.createElement("span", null, t('No Name'));
    }
    return /*#__PURE__*/React.createElement(Tooltip, {
      title: sensor.name
    }, /*#__PURE__*/React.createElement("span", null, sensor.name));
  }
  function renderFlow(sensor) {
    var status = sensor.status;
    if (!status || status.flowRate === null || status.flowRate === undefined) {
      return null;
    }
    return /*#__PURE__*/React.createElement("div", null, "".concat(status.flowRate.toFixed(1), " GPM"));
  }
  function renderSensorConnectivity(sensor) {
    if (!sensor.status) return null;
    return /*#__PURE__*/React.createElement(BooleanTag, {
      value: sensor.status.online,
      labels: [t('online'), t('offline')]
    });
  }
  function renderSensorAlarms(sensor) {
    return /*#__PURE__*/React.createElement(SensorAlarmButton, {
      type: sensor.type,
      identifier: sensor.identifier,
      alarmCount: sensor.status && sensor.status.alarmCount
    });
  }
  function renderLatestDate(sensor) {
    if (!sensor.status || !sensor.status.latestDate) return null;
    var date = sensor.status.latestDate;
    return /*#__PURE__*/React.createElement(Tooltip, {
      title: /*#__PURE__*/React.createElement(Moment, {
        format: "YYYY-MM-DD h:mm:ss A",
        local: true
      }, date),
      placement: "bottom"
    }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Moment, {
      fromNow: true
    }, date)));
  }
  function widthCalc(columns) {
    var maxWidth = 100;
    var result = columns().map(function (column) {
      if (column.key !== 'alarms') {
        return _objectSpread2(_objectSpread2({}, column), {}, {
          width: "".concat((maxWidth - 10) / (columns().length - 1), "%")
        });
      }
      return column;
    });
    return result;
  }
  var flowMeterColumns = function flowMeterColumns() {
    return [{
      title: t('Name'),
      key: 'name',
      className: styles$5['schedule-item-header'],
      render: function render(sensor) {
        return renderSensorName(sensor);
      }
    }, {
      title: t('Connectivity'),
      key: 'connectivity',
      width: 100,
      render: function render(sensor) {
        return renderSensorConnectivity(sensor);
      }
    }, {
      title: t('Flow'),
      key: 'flow',
      width: 100,
      render: function render(sensor) {
        return renderFlow(sensor);
      }
    }, {
      title: t('Last Data'),
      key: 'lastData',
      className: styles$5['last-data'],
      render: function render(sensor) {
        return renderLatestDate(sensor);
      }
    }, {
      title: t('Alarms'),
      key: 'alarms',
      className: styles$5['alarms-header'],
      width: 100,
      render: function render(sensor) {
        return renderSensorAlarms(sensor);
      }
    }];
  };
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
    className: styles$5['sub-header']
  }, t('Flow Meter')), flowMeter && /*#__PURE__*/React.createElement(Table, {
    dataSource: [flowMeter],
    columns: widthCalc(flowMeterColumns),
    rowKey: function rowKey(record) {
      return record.identifier;
    },
    size: "small",
    className: styles$5['inner-table'],
    pagination: false
  }), !flowMeter && /*#__PURE__*/React.createElement("div", {
    className: styles$5['no-data-message']
  }, t('No Flow Meter installed')));
}
PumpControlSensorList.propTypes = {
  pumpType: PropTypes.string.isRequired,
  pumpIdentifier: PropTypes.string.isRequired
};

function getTimeDiff(startDate, endDate) {
  var min = endDate.diff(startDate, 'minutes');
  var sec = endDate.diff(startDate, 'seconds');
  if (min < 0 || sec < 0) {
    return null;
  }
  if (min > 59) {
    var hr = Math.floor(min / 60);
    var m = min % 60;
    return "".concat(hr, " hrs and ").concat(m, " mins");
  }
  if (sec > 59) {
    return "".concat(min, " mins");
  }
  return "".concat(sec, " secs");
}
function getTimingAttr(openTime, closeTime) {
  var timeOpen;
  var timeClose;
  var opensFirst;
  if (openTime) {
    timeOpen = getTimeDiff(moment(), moment(openTime));
  }
  if (closeTime) {
    timeClose = getTimeDiff(moment(), moment(closeTime));
  }
  if (openTime && closeTime) {
    opensFirst = !!getTimeDiff(moment(openTime), moment(closeTime));
  }
  return [timeOpen, timeClose, opensFirst];
}

// Get the schedule message for valve
var getValveScheduleMessage = function getValveScheduleMessage(t, online, state, openTime, closeTime, overrideState) {
  var _getTimingAttr = getTimingAttr(openTime, closeTime),
    _getTimingAttr2 = _slicedToArray(_getTimingAttr, 3),
    timeOpen = _getTimingAttr2[0],
    timeClose = _getTimingAttr2[1],
    opensFirst = _getTimingAttr2[2];
  if (state) {
    if (timeOpen && opensFirst) {
      if (state !== 'closed' && overrideState !== state) {
        return "".concat(t('Closing, scheduled to open in'), " ").concat(timeOpen);
      }
      if (overrideState !== undefined) {
        return "".concat(t('Scheduled to open in'), " ").concat(timeOpen, ".");
      }
      return "".concat(t('Opens in'), " ").concat(timeOpen);
    }
    if (timeClose && !opensFirst) {
      if (state !== 'open' && overrideState !== state) {
        return "".concat(t('Opening, scheduled to close in'), " ").concat(timeClose);
      }
      if (overrideState !== undefined) {
        return "".concat(t('Scheduled to close in'), " ").concat(timeClose, ".");
      }
      return "".concat(t('Closes in'), " ").concat(timeClose);
    }
    if (state === 'unknown') {
      return t('Disconnected');
    }
    if (!online && state === 'closed') {
      return t('Disconnected (Closed)');
    }
    if (state !== 'closed' && !overrideState) {
      return t('Closing');
    }
    return t('Nothing Scheduled');
  }
  return '';
};

// Get the schedule message for pump
var getPumpScheduleMessageBasic = function getPumpScheduleMessageBasic(t, startDate, stopDate) {
  var _getTimingAttr3 = getTimingAttr(startDate, stopDate),
    _getTimingAttr4 = _slicedToArray(_getTimingAttr3, 3),
    timeOn = _getTimingAttr4[0],
    timeOff = _getTimingAttr4[1],
    onFirst = _getTimingAttr4[2];
  if (timeOn && onFirst) {
    return "".concat(t('On in'), " ").concat(timeOn, ".");
  }
  if (timeOff && !onFirst) {
    return "".concat(t('Off in'), " ").concat(timeOff, ".");
  }
  return null;
};

// Get the schedule message for pump
var getPumpScheduleMessage = function getPumpScheduleMessage(t, online, state, startDate, stopDate, overrideState) {
  var _getTimingAttr5 = getTimingAttr(startDate, stopDate),
    _getTimingAttr6 = _slicedToArray(_getTimingAttr5, 3),
    timeOn = _getTimingAttr6[0],
    timeOff = _getTimingAttr6[1],
    onFirst = _getTimingAttr6[2];
  if (state) {
    if (timeOn && onFirst) {
      if (state !== 'off' && overrideState !== state) {
        return "".concat(t('Turning off, scheduled to turn on in'), " ").concat(timeOn);
      }
      if (overrideState !== undefined) {
        return "".concat(t('Scheduled to turn on in'), " ").concat(timeOn, ".");
      }
      return "".concat(t('On in'), " ").concat(timeOn, ".");
    }
    if (timeOff && !onFirst) {
      if (state !== 'on' && overrideState !== state) {
        return "".concat(t('Turning on, scheduled to turn off in'), " ").concat(timeOff);
      }
      if (overrideState !== undefined) {
        return "".concat(t('Scheduled to turn off in'), " ").concat(timeOff, ".");
      }
      return "".concat(t('Off in'), " ").concat(timeOff, ".");
    }
    if (state === 'unknown') {
      return t('Disconnected');
    }
    if (!online && state === 'off') {
      return t('Disconnected (off)');
    }
    if (state !== 'off' && !overrideState) {
      return t('Turning off');
    }
    return t('Nothing Scheduled');
  }
  return '';
};

var Panel$3 = Collapse.Panel;
var Text$4 = Typography.Text;

// TODO: This is currently in farm reducer and can be moved to sensors
var selectPumpSensorStatus = selectors.selectPumpSensorStatus;
function PumpControlList(_ref) {
  var pumps = _ref.pumps,
    onClickCalendar = _ref.onClickCalendar,
    pumpLoading = _ref.pumpLoading;
  var pumpData = useSelector(function (state) {
    return selectPumpSensorStatus(state, pumps);
  });
  var spinner = pumpData.reduce(function (a, p) {
    return !p || a || p.pumpLoading;
  }, false);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var getMessageClassName = function getMessageClassName(state, online) {
    var styleStr = "".concat(styles$5['red-message'], " ");
    var styleStrNot = "".concat(styles$5['normal-message'], " ");
    if (state === 'unknown' || !online && state === 'off') {
      return styleStr;
    }
    if (!state) return styleStr;
    return styleStrNot;
  };
  var getSchedule = function getSchedule(pump, text) {
    return /*#__PURE__*/React.createElement("div", {
      className: styles$5['icon-container'],
      onClick: function onClick() {
        return onClickCalendar({
          identifier: pump.pumpIdentifier
        });
      },
      role: "presentation"
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$5.icon
    }, /*#__PURE__*/React.createElement(FaCalendarAlt, null)), /*#__PURE__*/React.createElement("div", {
      className: getMessageClassName(pump.pumpCurrentState, pump.pumpOnline)
    }, /*#__PURE__*/React.createElement("span", {
      className: styles$5['schedule-content']
    }, text)));
  };
  var getIndClass = function getIndClass(_ref2) {
    var online = _ref2.pumpOnline,
      status = _ref2.pumpCurrentState,
      loading = _ref2.pumpLoading;
    var styleStr = "".concat(styles$5.indicator, " ");
    if (!loading) {
      if (!online) return styleStr + styles$5.red;
      if (online && status === 'off') return styleStr + styles$5['light-grey'];
      if (online && status === 'on') return styleStr + styles$5.blue;
    }
    return styleStr + styles$5['light-grey'];
  };
  var getCurrentState = function getCurrentState(pump) {
    return /*#__PURE__*/React.createElement(PumpStateTag, {
      state: pump.pumpCurrentState,
      online: pump.pumpOnline
    });
  };
  var getRowClassName = function getRowClassName(record) {
    if (record.pumpCurrentState) {
      if (record.pumpCurrentState === 'unknown' || !record.pumpOnline && (!record.pumpCurrentState || record.pumpCurrentState === 'off')) {
        return styles$5['red-border-text'];
      }
    }
    var className = getIndClass(record);
    return className;
  };
  function widthCalc(columns) {
    var maxwid = 100;
    var result = columns().map(function (element) {
      var values = element;
      if (element.title === 'Alarm') {
        values.width = 100;
      }
      if (element.title === 'Override') {
        values.width = 100;
      }
      if (element.title !== 'Override' && element.title !== 'Alarm') {
        values.width = "".concat((maxwid - 10) / (columns().length - 2), "%");
      }
      return values;
    });
    return result;
  }
  var columns = function columns() {
    return [{
      title: t('Pump'),
      className: styles$5['schedule-item-header'],
      render: function render(pump) {
        if (pump.pumpName) {
          return /*#__PURE__*/React.createElement(Tooltip, {
            title: pump.pumpName
          }, /*#__PURE__*/React.createElement("span", null, pump.pumpName));
        }
        return /*#__PURE__*/React.createElement("span", {
          style: {
            color: 'lightgray'
          }
        }, t('No Name'));
      }
    }, {
      title: t('Schedule'),
      className: styles$5['schedule-header'],
      render: function render(pump) {
        return getSchedule(pump, getPumpScheduleMessage(t, pump.pumpOnline, pump.pumpCurrentState, pump.pumpStartDate, pump.pumpStopDate, pump.pumpOverrideStatus && pump.pumpOverrideStatus.state));
      }
    }, {
      title: t('Override'),
      className: styles$5['override-header'],
      render: function render(pump) {
        return /*#__PURE__*/React.createElement(OverrideStatus, {
          type: VFD_TYPE,
          overrideStatus: pump.pumpOverrideStatus,
          vfdIdentifier: pump.pumpIdentifier,
          currentState: pump.pumpCurrentState,
          confirmDialogMessages: [getPumpScheduleMessage(t, pump.pumpOnline, pump.pumpCurrentState, pump.pumpStartDate, pump.pumpStopDate)]
        });
      }
    }, {
      title: t('State'),
      className: styles$5['state-header'],
      render: function render(pump) {
        return /*#__PURE__*/React.createElement("div", {
          className: styles$5.status
        }, getCurrentState(pump));
      }
    }, {
      title: t('Alarms'),
      className: styles$5['alarms-header'],
      render: function render(pump) {
        return /*#__PURE__*/React.createElement(SensorAlarmButton, {
          type: "vfd",
          identifier: pump.pumpIdentifier,
          alarmCount: pump.alarmCount
        });
      }
    }];
  };
  return /*#__PURE__*/React.createElement("div", {
    className: styles$5['list-container']
  }, /*#__PURE__*/React.createElement(Collapse, {
    expandIconPosition: "right",
    defaultActiveKey: ['1']
  }, /*#__PURE__*/React.createElement(Panel$3, {
    header: /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Text$4, {
      style: {
        fontSize: '16px'
      }
    }, t('Pumps')), pumpLoading || spinner ? /*#__PURE__*/React.createElement(LoadingOutlined, {
      style: {
        marginLeft: '10px',
        fontSize: '16px'
      }
    }) : ''),
    key: "1",
    className: styles$5['collapse-header']
  }, pumpData.length ? /*#__PURE__*/React.createElement(Table, {
    className: styles$5['custom-table'],
    rowClassName: getRowClassName,
    dataSource: pumpData,
    columns: widthCalc(columns),
    pagination: false,
    rowKey: function rowKey(record) {
      return String(record.pumpId);
    },
    expandable: {
      expandRowByClick: true,
      rowExpandable: function rowExpandable() {
        return true;
      },
      expandedRowRender: function expandedRowRender(pump) {
        return /*#__PURE__*/React.createElement(PumpControlSensorList, {
          pumpType: "vfd",
          pumpIdentifier: pump.pumpIdentifier
        });
      }
    }
  }) : /*#__PURE__*/React.createElement("section", {
    className: styles$5['configuration-message']
  }, t('No Pumps Configured')))));
}
PumpControlList.propTypes = {
  pumps: PropTypes.arrayOf(PropTypes.object),
  onClickCalendar: PropTypes.func,
  pumpLoading: PropTypes.bool
};
PumpControlList.defaultProps = {
  pumps: [],
  onClickCalendar: null,
  pumpLoading: null
};

moment.updateLocale('en', {
  relativeTime: {
    future: 'in %s',
    past: '%s ago',
    s: 'a few secs',
    ss: '%d secs',
    m: 'a min',
    mm: '%d mins',
    h: 'an hr',
    hh: '%d hrs',
    d: 'a day',
    dd: '%d days',
    w: 'a week',
    ww: '%d weeks',
    M: 'a month',
    MM: '%d months',
    y: 'a year',
    yy: '%d years'
  }
});
var selectBlockPressureSensors = selectors.selectBlockPressureSensors,
  selectBlockPumpController = selectors.selectBlockPumpController,
  selectBlockFlowMeter = selectors.selectBlockFlowMeter,
  selectValveControllersForBlocks$1 = selectors.selectValveControllersForBlocks;
var loadSensorStatus$2 = actions.loadSensorStatus;
var useBlockNames$1 = hooks.useBlockNames,
  useUnits = hooks.useUnits;
function BlockControlSensorList(props) {
  var controlStatus = props.controlStatus,
    valves = props.valves,
    showBlockList = props.showBlockList;
  var blockId = controlStatus.blockId;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t,
    i18n = _useTranslation.i18n;
  var dispatch = useDispatch();
  var refreshId = useContext(RefreshContext);
  var getUserUnits = useUnits();
  var pressureSensors = useSelector(function (state) {
    return selectBlockPressureSensors(state, blockId);
  });
  var pumpController = useSelector(function (state) {
    return selectBlockPumpController(state, blockId);
  });
  var flowMeter = useSelector(function (state) {
    return selectBlockFlowMeter(state, blockId);
  }) || []; // returning empty array to hide '0' in Pressure Sensors section [FF-897]
  moment.locale(i18n.language);
  var valvesIds = controlStatus.valves ? controlStatus.valves.valveIds || [] : [];
  var filteredValveObjArr = valves.filter(function (d) {
    return d && d.irrigation_blocks.includes(blockId) && valvesIds.includes(d.id);
  });
  var valveBlockIds = [];
  var vIdentifiers = [];
  filteredValveObjArr.forEach(function (d) {
    if (d) {
      vIdentifiers.push({
        type: d.type,
        identifier: d.identifier
      });
    }
    if (d && d.irrigation_blocks && d.irrigation_blocks.length && !vIdentifiers.includes({
      type: d.type,
      identifier: d.identifier
    })) {
      valveBlockIds.push.apply(valveBlockIds, _toConsumableArray(d.irrigation_blocks));
    }
  });
  var uniqueValveBlockIds = valveBlockIds.filter(function (v, i, a) {
    return a.indexOf(v) === i;
  });
  var valveControllerObj = useSelector(function (state) {
    return selectValveControllersForBlocks$1(state, uniqueValveBlockIds.length ? uniqueValveBlockIds : [blockId]);
  });
  var valveControllersFromObj = Object.values(valveControllerObj).length ? Object.values(valveControllerObj) : [];
  var valveController = valveControllerObj[blockId];
  var valveControllers = [];
  valveControllersFromObj.forEach(function (items) {
    items.forEach(function (item) {
      if (item.irrigation_blocks && item.irrigation_blocks.includes(blockId)) {
        var i = valveControllers.findIndex(function (x) {
          return x.identifier === item.identifier;
        });
        if (i <= -1) {
          valveControllers.push(item);
        }
      }
    });
  });

  // To show associated block list for valve under valves section
  var blockIds = controlStatus && controlStatus.irrigation_blocks;
  var blockNames = useBlockNames$1(blockIds);
  var pressureSensorsObj = useSelector(function (state) {
    return getPressureDetailsForBlockIds(state, blockIds);
  });
  var blockArr = [];
  if (showBlockList && blockIds !== null && blockIds !== void 0 && blockIds.length) {
    blockIds.forEach(function (d, i) {
      var blockObj = {
        blockName: blockNames[d],
        blockId: d,
        type: controlStatus.irrigation_blocks[i] === d && controlStatus.type,
        identifier: controlStatus.irrigation_blocks[i] === d && controlStatus.identifier,
        status: {
          alarmCount: controlStatus.blockAlarmCount
        }
      };
      blockArr.push(blockObj);
    });
  }
  var pumpControllerIdentifier = pumpController.identifier,
    pumpControllerType = pumpController.type;
  var _ref = flowMeter || {},
    flowMeterIdentifier = _ref.identifier,
    flowMeterType = _ref.type;
  var valveControllerIdentifier = valveController.identifier,
    valveControllerType = valveController.type;
  var valveIdentifiers = '';
  if (!vIdentifiers.includes({
    identifier: valveControllerIdentifier,
    type: valveControllerType
  })) {
    valveIdentifiers = JSON.stringify([].concat(vIdentifiers, [{
      identifier: valveControllerIdentifier,
      type: valveControllerType
    }]));
  }
  var pressureSensorIdentifiers = JSON.stringify(pressureSensors.map(function (sensor) {
    return sensor.identifier;
  }));
  var refreshPressureSensorStatus = useCallback(function () {
    if (refreshId) {
      JSON.parse(pressureSensorIdentifiers).forEach(function (identifier) {
        var sensorParams = {
          type: 'water_pressure',
          identifier: identifier
        };
        dispatch(loadSensorStatus$2(sensorParams));
      });
    }
  }, [dispatch, refreshId, pressureSensorIdentifiers]);
  useEffect(function () {
    refreshPressureSensorStatus();
  }, [refreshPressureSensorStatus]);
  useEffect(function () {
    var sensorParams = {
      type: pumpControllerType,
      identifier: pumpControllerIdentifier
    };
    if (pumpControllerIdentifier) {
      dispatch(loadSensorStatus$2(sensorParams));
    }
  }, [dispatch, pumpControllerType, pumpControllerIdentifier]);
  useEffect(function () {
    if (refreshId && flowMeterIdentifier && flowMeterType) {
      var sensorParams = {
        type: flowMeterType,
        identifier: flowMeterIdentifier
      };
      dispatch(loadSensorStatus$2(sensorParams));
    }
  }, [dispatch, refreshId, flowMeterType, flowMeterIdentifier]);
  useEffect(function () {
    if (JSON.parse(valveIdentifiers).length) {
      JSON.parse(valveIdentifiers).forEach(function (sensorParams) {
        dispatch(loadSensorStatus$2(sensorParams));
      });
    }
  }, [dispatch, valveIdentifiers]);
  var getCurrentState = function getCurrentState(valveState, valveOnline) {
    var color = valveState === 'open' ? '#1890FF' : '#D40202';
    if (valveState) {
      if (valveState !== 'unknown') {
        if (valveOnline && valveState === 'closed') {
          return /*#__PURE__*/React.createElement(Tag, {
            color: "",
            key: valveState,
            className: styles$5['tag-icon']
          }, t('Closed').toUpperCase());
        }
        var state = valveState === 'open' ? t('Open_status').toUpperCase() : valveState;
        return /*#__PURE__*/React.createElement(Tag, {
          color: color,
          key: valveState,
          className: [styles$5['tag-icon'], styles$5['tag-icon-irrigating']]
        }, t(state).toUpperCase());
      }
      return /*#__PURE__*/React.createElement(WarningFilled, {
        className: styles$5['warning-icon']
      });
    }
    if (!valveState) {
      return /*#__PURE__*/React.createElement(WarningFilled, {
        className: styles$5['warning-icon']
      });
    }
    return '';
  };
  function renderSensorName(sensor) {
    if (!sensor.name) {
      return /*#__PURE__*/React.createElement("span", null, t('No Name'));
    }
    return /*#__PURE__*/React.createElement(Tooltip, {
      title: sensor.name
    }, /*#__PURE__*/React.createElement("span", null, sensor.name));
  }
  function renderPressure(sensor) {
    var status = sensor.status;
    if (!status || status.waterPressure === undefined || status.waterPressure === null) return null;
    var units = (status === null || status === void 0 ? void 0 : status.units) || {
      waterPressure: 'pounds_per_square_inch'
    };
    if (units.waterPressure === 'psi') {
      units = _objectSpread2(_objectSpread2({}, units), {}, {
        waterPressure: 'pounds_per_square_inch'
      });
    }
    var convertedUnits = getUserUnits(status.waterPressure, units.waterPressure, 'pressure', {
      decimalPlaces: 4
    });
    return /*#__PURE__*/React.createElement("div", null, "".concat(convertedUnits.value, " ").concat(convertedUnits.label));
  }
  function renderSensorConnectivity(sensor) {
    if (!sensor.status) return null;
    return /*#__PURE__*/React.createElement(BooleanTag, {
      value: sensor.status.online,
      labels: [t('online'), t('offline')]
    });
  }
  function renderLatestDate(sensor) {
    if (!sensor.status || !sensor.status.latestDate) return null;
    var date = sensor.status.latestDate;
    return /*#__PURE__*/React.createElement(Tooltip, {
      title: /*#__PURE__*/React.createElement(Moment, {
        format: "YYYY-MM-DD h:mm:ss A",
        local: true
      }, date),
      placement: "bottom"
    }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Moment, {
      fromNow: true
    }, date)));
  }
  function renderSensorAlarms(sensor) {
    return /*#__PURE__*/React.createElement(SensorAlarmButton, {
      type: sensor.type,
      identifier: sensor.identifier,
      alarmCount: sensor.status && sensor.status.alarmCount
    });
  }
  function renderFlow(sensor) {
    var status = sensor.status;
    if (!status || status.flowRate === undefined || status.flowRate === null) {
      return null;
    }
    return /*#__PURE__*/React.createElement("div", null, "".concat(status.flowRate.toFixed(1), " GPM"));
  }
  function widthCalc(columns) {
    var maxWidth = 100;
    var result = columns().map(function (column) {
      if (column.key !== 'alarms') {
        return _objectSpread2(_objectSpread2({}, column), {}, {
          width: "".concat((maxWidth - 10) / (columns().length - 1), "%")
        });
      }
      return column;
    });
    return result;
  }
  var pressureColumns = function pressureColumns() {
    return [{
      title: t('Name'),
      key: 'name',
      className: styles$5['schedule-item-header'],
      render: function render(sensor) {
        return renderSensorName(sensor);
      }
    }, {
      title: t('Connectivity'),
      key: 'connectivity',
      className: styles$5.connect,
      render: function render(sensor) {
        return renderSensorConnectivity(sensor);
      }
    }, {
      title: t('Pressure'),
      key: 'pressure',
      className: styles$5['state-header'],
      render: function render(sensor) {
        return renderPressure(sensor);
      }
    }, {
      title: t('Last Data'),
      key: 'lastData',
      className: styles$5['last-data'],
      render: function render(sensor) {
        return renderLatestDate(sensor);
      }
    }, {
      title: t('Alarms'),
      key: 'alarms',
      className: styles$5['alarms-header'],
      width: 100,
      render: function render(sensor) {
        return renderSensorAlarms(sensor);
      }
    }];
  };
  var flowMeterColumns = function flowMeterColumns() {
    return [{
      title: t('Name'),
      key: 'name',
      className: styles$5['schedule-item-header'],
      render: function render(sensor) {
        return renderSensorName(sensor);
      }
    }, {
      title: t('Connectivity'),
      key: 'connectivity',
      className: styles$5.connect,
      render: function render(sensor) {
        return renderSensorConnectivity(sensor);
      }
    }, {
      title: t('Flow'),
      key: 'flow',
      className: styles$5['state-header'],
      render: function render(sensor) {
        return renderFlow(sensor);
      }
    }, {
      title: t('Last Data'),
      key: 'lastData',
      className: styles$5['last-data'],
      render: function render(sensor) {
        return renderLatestDate(sensor);
      }
    }, {
      title: t('Alarms'),
      key: 'alarms',
      className: styles$5['alarms-header'],
      width: 100,
      render: function render(sensor) {
        return renderSensorAlarms(sensor);
      }
    }];
  };
  var pumpControllerColumns = function pumpControllerColumns() {
    return [{
      title: t('Name'),
      key: 'name',
      className: styles$5['schedule-item-header'],
      render: function render(sensor) {
        return renderSensorName(sensor);
      }
    }, {
      title: t('Connectivity'),
      key: 'connectivity',
      className: styles$5.connect,
      render: function render(sensor) {
        return renderSensorConnectivity(sensor);
      }
    }, {
      title: t('State'),
      className: styles$5['state-header'],
      key: 'state',
      render: function render(sensor) {
        return /*#__PURE__*/React.createElement(PumpStateTag, {
          state: sensor.status && sensor.status.controlStatus && sensor.status.controlStatus.status,
          loading: sensor.status && sensor.status.loading,
          online: sensor.status && sensor.status.online
        });
      }
    }, {
      title: t('Last Data'),
      key: 'lastData',
      className: styles$5['last-data'],
      render: function render(sensor) {
        return renderLatestDate(sensor);
      }
    }, {
      title: t('Alarms'),
      key: 'alarms',
      className: styles$5['alarms-header'],
      width: 100,
      render: function render(sensor) {
        return renderSensorAlarms(sensor);
      }
    }];
  };
  var valveControllerColumns = function valveControllerColumns() {
    return [{
      title: t('Name'),
      key: 'name',
      className: styles$5['schedule-item-header'],
      render: function render(sensor) {
        return renderSensorName(sensor);
      }
    }, {
      title: t('Connectivity'),
      key: 'connectivity',
      className: styles$5.connect,
      render: function render(sensor) {
        return renderSensorConnectivity(sensor);
      }
    }, {
      title: t('State'),
      className: styles$5['state-header'],
      key: 'state',
      render: function render(sensor) {
        return getCurrentState(sensor.status && sensor.status.controlStatus && sensor.status.controlStatus.state, sensor.status && sensor.status.loading);
      }
    }, {
      title: t('Last Data'),
      key: 'lastData',
      className: styles$5['last-data'],
      render: function render(sensor) {
        return renderLatestDate(sensor);
      }
    }, {
      title: t('Alarms'),
      key: 'alarms',
      className: styles$5['alarms-header'],
      width: 100,
      render: function render(sensor) {
        return renderSensorAlarms(sensor);
      }
    }];
  };
  var blockList = function blockList() {
    return [{
      title: t('Name'),
      key: 'blockName',
      className: styles$5['schedule-item-header'],
      render: function render(d) {
        return d.blockName;
      }
    }, {
      title: t('Connectivity'),
      key: 'connectivity',
      className: styles$5['hidden-column'],
      render: null
    }, {
      title: t('Irrigation State'),
      className: styles$5['state-header'],
      render: function render(d) {
        var waterPressureState = pressureSensorsObj[d.blockId] && pressureSensorsObj[d.blockId].waterPressureState;
        var statusDetails = getBlockIrrigationStateByWaterPressureState(waterPressureState);
        return /*#__PURE__*/React.createElement(Tag, {
          color: statusDetails.color,
          className: waterPressureState > 1 ? [styles$5['tag-icon-irrigation-state'], styles$5['tag-icon-irrigating']] : styles$5['tag-icon-irrigation-state']
        }, statusDetails.irrigationState && t(statusDetails.irrigationState).toUpperCase());
      }
    }, {
      title: t('Last Data'),
      className: styles$5['hidden-column'],
      render: null
    }, {
      title: t('Alarms'),
      key: 'alarms',
      className: styles$5['alarms-header'],
      render: function render(d) {
        return renderSensorAlarms(d);
      }
    }];
  };
  var pumpControllers = pumpControllerIdentifier ? [pumpController] : null;
  return /*#__PURE__*/React.createElement("div", null, pumpControllers && [/*#__PURE__*/React.createElement("span", {
    className: styles$5['sub-header'],
    key: "header"
  }, t('Pump Control')), /*#__PURE__*/React.createElement(Table, {
    key: "table",
    dataSource: pumpControllers,
    columns: widthCalc(pumpControllerColumns),
    rowKey: function rowKey(record) {
      return record.identifier;
    },
    size: "small",
    className: styles$5['inner-table'],
    pagination: false
  })], valveController && [/*#__PURE__*/React.createElement("span", {
    className: styles$5['sub-header'],
    key: "header"
  }, showBlockList ? t('Blocks') : t('Valve Control')), /*#__PURE__*/React.createElement(Table, {
    key: "table",
    dataSource: showBlockList ? blockArr : valveControllers,
    columns: widthCalc(showBlockList ? blockList : valveControllerColumns),
    rowKey: function rowKey(record) {
      return record.identifier;
    },
    size: "small",
    className: styles$5['inner-table'],
    pagination: false
  })], flowMeter && [/*#__PURE__*/React.createElement("span", {
    className: styles$5['sub-header'],
    key: "header"
  }, t('Flow Meter')), /*#__PURE__*/React.createElement(Table, {
    key: "table",
    dataSource: [flowMeter],
    columns: widthCalc(flowMeterColumns),
    rowKey: function rowKey(record) {
      return record.identifier;
    },
    size: "small",
    className: styles$5['inner-table'],
    pagination: false,
    locale: {
      emptyText: t('No Data')
    }
  })], /*#__PURE__*/React.createElement("span", {
    className: styles$5['sub-header']
  }, t('Pressure Sensors')), /*#__PURE__*/React.createElement(Table, {
    dataSource: pressureSensors,
    columns: widthCalc(pressureColumns),
    rowKey: function rowKey(record) {
      return record.identifier;
    },
    size: "small",
    className: styles$5['inner-table'],
    pagination: false,
    locale: {
      emptyText: t('No Data')
    }
  }));
}
BlockControlSensorList.propTypes = {
  controlStatus: PropTypes.shape().isRequired,
  valves: PropTypes.arrayOf(PropTypes.any),
  showBlockList: PropTypes.bool
};
BlockControlSensorList.defaultProps = {
  valves: [],
  showBlockList: false
};

var Panel$2 = Collapse.Panel;
var Text$3 = Typography.Text;

// TODO: This needs to be replaced with selectNewBlockSensorStatus once block details are added
var selectBlockSensorStatus$1 = selectors.selectBlockSensorStatus;
var loadSensorStatus$1 = actions.loadSensorStatus;
function BlockControlList(_ref) {
  var blocks = _ref.blocks,
    valves = _ref.valves,
    onClickCalendar = _ref.onClickCalendar,
    blockLoading = _ref.blockLoading;
  var dispatch = useDispatch();
  var filteredBlocks = blocks ? blocks.filter(function (d) {
    return d.valve;
  }) : null;
  var blocksUnsorted = useSelector(function (state) {
    return selectBlockSensorStatus$1(state, filteredBlocks);
  });
  var blockDataSorted = blocksUnsorted.sort(function (a, b) {
    return a.blockName.localeCompare(b.blockName);
  });
  var spinner = blockDataSorted.reduce(function (a, p) {
    return !p || a || p.valveLoading;
  }, false);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var blockIds = filteredBlocks && filteredBlocks.map(function (d) {
    return d && d.id;
  });
  var pressureSensorsObj = useSelector(function (state) {
    return getPressureDetailsForBlockIds(state, blockIds);
  });
  var sensorIdentifierArr = [];
  Object.values(pressureSensorsObj).forEach(function (pressureSensors) {
    var pressureSensorIdentifiers = pressureSensors.pressureSensorIdentifiers;
    JSON.parse(pressureSensorIdentifiers).forEach(function (identifier) {
      sensorIdentifierArr.push({
        type: 'water_pressure',
        identifier: identifier
      });
    });
  });
  var sensorIdentifiers = JSON.stringify(sensorIdentifierArr);
  useEffect(function () {
    JSON.parse(sensorIdentifiers).forEach(function (sensorParams) {
      dispatch(loadSensorStatus$1(sensorParams));
    });
  }, [dispatch, sensorIdentifiers]);
  var valveObj = blocks.reduce(function (acc, obj) {
    acc[obj.id] = {
      valveIds: obj.valves
    };
    return acc;
  }, {});
  var vfds = blocks.reduce(function (acc, obj) {
    acc[obj.id] = obj.vfds;
    return acc;
  }, {});
  var blockData = blockDataSorted.map(function (d) {
    var obj = d;
    obj.valves = valveObj[obj.blockId];
    obj.vfds = vfds[obj.blockId];
    return obj;
  });
  var getMessageClassName = function getMessageClassName(state, online) {
    var styleStr = "".concat(styles$5['red-message'], " ");
    var styleStrNot = "".concat(styles$5['normal-message'], " ");
    if (state === 'unknown' || !online && state === 'closed') {
      return styleStr;
    }
    if (!state) return styleStr;
    return styleStrNot;
  };
  var getSchedule = function getSchedule(block, text) {
    return /*#__PURE__*/React.createElement("div", {
      className: styles$5['icon-container'],
      onClick: function onClick() {
        return onClickCalendar({
          id: block.blockId
        });
      },
      role: "presentation"
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$5.icon
    }, /*#__PURE__*/React.createElement(FaCalendarAlt, null)), /*#__PURE__*/React.createElement("div", {
      className: getMessageClassName(block.valveCurrentState, block.valveOnline)
    }, /*#__PURE__*/React.createElement("span", {
      className: styles$5['schedule-content']
    }, text)));
  };
  var getIndClass = function getIndClass(blockStatus) {
    var waterPressureState = pressureSensorsObj[blockStatus.blockId] && pressureSensorsObj[blockStatus.blockId].waterPressureState;
    var styleStr = "".concat(styles$5.indicator, " ");
    if (!blockStatus.valveLoading) {
      if (blockStatus.valveControlEnabled) {
        if (!blockStatus.valveOnline) return styleStr + styles$5.red;
        if (blockStatus.valveOnline && waterPressureState === 1 && blockStatus.valveCurrentState === 'closed') return styleStr + styles$5['light-grey'];
        if (blockStatus.valveOnline && waterPressureState === 4 && (blockStatus.valveCurrentState === 'open' || blockStatus.pumpCurrentState === 'on')) return styleStr + styles$5.blue;
      }
    }
    return styleStr + styles$5['light-grey'];
  };
  var getRowClassName = function getRowClassName(record) {
    if (record.valveCurrentState) {
      if (!record.valveControlEnabled || record.valveCurrentState === 'unknown') {
        return styles$5['red-border-text'];
      }
      if (record.valveControlEnabled && !record.valveOnline && (record.valveCurrentState === 'closed' || !record.valveCurrentState)) {
        return styles$5['red-border-text'];
      }
    }
    if (!record.valveLoading && (!record.valveControlEnabled || !record.valveCurrentState)) {
      return styles$5['red-border-text'];
    }
    var className = getIndClass(record);
    return className;
  };
  function widthCalc(columns) {
    var maxwid = 100;
    var result = columns().map(function (element) {
      var values = element;
      if (element.title === 'Alarm') {
        values.width = 100;
      }
      if (element.title === 'Override') {
        values.width = 100;
      }
      if (element.title !== 'Override' && element.title !== 'Alarm') {
        values.width = "".concat((maxwid - 10) / (columns().length - 2), "%");
      }
      return values;
    });
    return result;
  }
  function getAlarmListUrl(block) {
    var params = {
      blockId: block.blockId,
      logLevel: 'error',
      active: true
    };
    var paramStr = new URLSearchParams(params).toString();
    return "/events?".concat(paramStr);
  }
  var columns = function columns() {
    return [{
      title: t('Block'),
      className: styles$5['schedule-item-header'],
      render: function render(block) {
        if (block.blockName) {
          return /*#__PURE__*/React.createElement(Tooltip, {
            title: block.blockName
          }, /*#__PURE__*/React.createElement("span", null, block.blockName));
        }
        return /*#__PURE__*/React.createElement("span", {
          style: {
            color: 'lightgray'
          }
        }, t('No Name'));
      }
    }, {
      title: t('Schedule'),
      className: styles$5['schedule-header'],
      render: function render(block) {
        if (block.valveControlEnabled) {
          return getSchedule(block, getValveScheduleMessage(t, block.valveOnline, block.valveCurrentState, block.valveScheduledOpen, block.valveScheduledClose, block.valveOverrideStatus && block.valveOverrideStatus.state));
        }
        return t('Control not enabled');
      }
    }, {
      title: t('Override'),
      className: styles$5['hidden-column'],
      render: null
    }, {
      title: t('Irrigation State'),
      className: styles$5['state-header'],
      render: function render(block) {
        var waterPressureState = pressureSensorsObj[block.blockId] && pressureSensorsObj[block.blockId].waterPressureState;
        var statusDetails = getBlockIrrigationStateByWaterPressureState(waterPressureState);
        return /*#__PURE__*/React.createElement(Tag, {
          key: block.valveCurrentState,
          color: statusDetails.color,
          className: waterPressureState > 1 ? [styles$5['tag-icon-irrigation-state'], styles$5['tag-icon-irrigating']] : styles$5['tag-icon-irrigation-state']
        }, statusDetails.irrigationState && t(statusDetails.irrigationState.toUpperCase()));
      }
    }, {
      title: t('Alarms'),
      className: styles$5['alarms-header'],
      render: function render(block) {
        return /*#__PURE__*/React.createElement(Link, {
          to: getAlarmListUrl(block)
        }, /*#__PURE__*/React.createElement(Badge, {
          count: block.blockAlarmCount
        }, /*#__PURE__*/React.createElement(Button, {
          className: styles$5['bell-icon-button'],
          icon: /*#__PURE__*/React.createElement(BellFilled, {
            className: styles$5['bell-icon-size']
          })
        })));
      }
    }];
  };
  function renderBlockDetail(blockControlStatus) {
    return /*#__PURE__*/React.createElement(BlockControlSensorList, {
      controlStatus: blockControlStatus,
      valves: valves
    });
  }
  return /*#__PURE__*/React.createElement("div", {
    className: styles$5['list-container']
  }, /*#__PURE__*/React.createElement(Collapse, {
    expandIconPosition: "right",
    defaultActiveKey: ['1']
  }, /*#__PURE__*/React.createElement(Panel$2, {
    header: /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Text$3, {
      style: {
        fontSize: '16px'
      }
    }, t('Blocks')), blockLoading || spinner ? /*#__PURE__*/React.createElement(LoadingOutlined, {
      style: {
        marginLeft: '10px',
        fontSize: '16px'
      }
    }) : ''),
    key: "1",
    className: styles$5['collapse-header']
  }, blockData.length ? /*#__PURE__*/React.createElement(Table, {
    className: styles$5['custom-table'],
    rowClassName: getRowClassName,
    dataSource: blockData,
    columns: widthCalc(columns),
    pagination: false,
    rowKey: function rowKey(record) {
      return String(record.blockId);
    },
    expandable: {
      expandRowByClick: true,
      rowExpandable: function rowExpandable() {
        return true;
      },
      expandedRowRender: function expandedRowRender(block) {
        return renderBlockDetail(block);
      }
    },
    locale: {
      emptyText: t('No Data')
    }
  }) : /*#__PURE__*/React.createElement("section", {
    className: styles$5['configuration-message']
  }, t('No Blocks Configured')))));
}
BlockControlList.propTypes = {
  blocks: PropTypes.arrayOf(PropTypes.object),
  valves: PropTypes.arrayOf(PropTypes.object),
  onClickCalendar: PropTypes.func,
  blockLoading: PropTypes.bool
};
BlockControlList.defaultProps = {
  blocks: [],
  valves: [],
  onClickCalendar: null,
  blockLoading: null
};

var selectControlGatewaysForRanchId = selectors.selectControlGatewaysForRanchId,
  populateSensorStatus = selectors.populateSensorStatus;
var loadSensorStatus = actions.loadSensorStatus;
function sortByName(a, b) {
  if (!a.name) return -1;
  if (!b.name) return 1;
  return a.name.localeCompare(b.name);
}
function ControlSystemStatus(_ref) {
  var ranchId = _ref.ranchId;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var dispatch = useDispatch();
  var refreshId = useContext(RefreshContext);
  var gateways = useSelector(function (state) {
    return selectControlGatewaysForRanchId(state, ranchId);
  });
  var gatewaysWithStatus = useSelector(function (state) {
    return populateSensorStatus(state, gateways);
  });
  var gatewaysSorted = gatewaysWithStatus.sort(sortByName);
  var gatewayIdentifiers = JSON.stringify(gatewaysSorted.map(function (gateway) {
    return gateway.identifier;
  }));
  var statusLabels = [t('operational'), t('Degraded'), t('offline')];
  useEffect(function () {
    if (refreshId) {
      JSON.parse(gatewayIdentifiers).forEach(function (identifier) {
        return dispatch(loadSensorStatus({
          identifier: identifier,
          type: 'gateway'
        }));
      });
    }
  }, [dispatch, gatewayIdentifiers, refreshId]);
  function getOverallStatus(sensors) {
    var numInternetOffline = 0;
    var numControlOffline = 0;
    var numDegraded = 0;
    var numStatus = 0;
    sensors.forEach(function (sensor) {
      if (sensor.status && sensor.status.controlStatus) {
        numStatus += 1;
        if (sensor.status.online === false) numInternetOffline += 1;
        if (sensor.status.controlStatus.controlServerState === 'offline') numControlOffline += 1;
        if (sensor.status.controlStatus.controlServerState === 'degraded') numDegraded += 1;
      }
    });
    // if a single system is offline or down, show error state
    if (numControlOffline > 0 || numInternetOffline > 0 || numStatus === 0) return 'error';
    // if a single system is degraded, show warning state
    if (numDegraded > 0) return 'warning';
    return 'ok';
  }
  function getStoplightStateFromControlState(value) {
    if (value === 'offline') return 'error';
    if (value === 'online') return 'ok';
    if (value === 'degraded') return 'warning';
    return undefined;
  }
  function renderPanelHeader() {
    var overallStatus = getOverallStatus(gatewaysWithStatus);
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography.Text, {
      className: styles$5['space-after'],
      style: {
        fontSize: '16px'
      }
    }, t('Gateway System Status')), /*#__PURE__*/React.createElement(StoplightTag, {
      value: overallStatus,
      labels: statusLabels
    }));
  }
  function renderGatewayStatus(gateway) {
    var online = gateway.status && gateway.status.online;
    var controlStatusState = gateway.status && gateway.status.controlStatus && gateway.status.controlStatus.controlServerState;
    var controlStoplightState = getStoplightStateFromControlState(controlStatusState);
    return /*#__PURE__*/React.createElement("div", {
      key: gateway.id
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$5['gateway-header']
    }, /*#__PURE__*/React.createElement("strong", null, gateway.name)), /*#__PURE__*/React.createElement(Divider, {
      dashed: true
    }), /*#__PURE__*/React.createElement("div", {
      className: styles$5['space-between']
    }, /*#__PURE__*/React.createElement("div", null, t('Internet Connectivity')), /*#__PURE__*/React.createElement(BooleanTag, {
      value: online,
      labels: [statusLabels[0], statusLabels[2]]
    })), /*#__PURE__*/React.createElement(Divider, {
      dashed: true
    }), /*#__PURE__*/React.createElement("div", {
      className: styles$5['space-between']
    }, /*#__PURE__*/React.createElement("div", null, t('Gateway Control Software')), /*#__PURE__*/React.createElement(StoplightTag, {
      value: controlStoplightState,
      labels: statusLabels
    })), /*#__PURE__*/React.createElement(Divider, null));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: styles$5['list-container']
  }, /*#__PURE__*/React.createElement(Collapse, {
    expandIconPosition: "right"
  }, /*#__PURE__*/React.createElement(Collapse.Panel, {
    header: renderPanelHeader(),
    key: "systemStatus",
    className: styles$5['collapse-header']
  }, gatewaysSorted.map(function (gateway) {
    return renderGatewayStatus(gateway);
  }))));
}
ControlSystemStatus.propTypes = {
  ranchId: PropTypes.number.isRequired
};

var Panel$1 = Collapse.Panel;
var Text$2 = Typography.Text;

// TODO: This needs to be replaced with selectNewBlockSensorStatus once block details are added
var selectBlockSensorStatus = selectors.selectBlockSensorStatus,
  selectValveControllersForBlocks = selectors.selectValveControllersForBlocks;
var loadSensorStatusAction = actions.loadSensorStatus;
var REFRESH_INTERVAL = 1000 * 30;

/**
 * @param {*} blockNames - blockName object with blockId as key
 * @param {*} blockIds - array of blockIds
 * @returns - block name/ count of blocks based on blockIds length
 * Ex: If blockIds = [1], Result: 'BLOCK 1'
 *     If blockIds = [1, 2], Result: '2 blocks'
 */
function getBlockNameForValve(blockNames, blockIds) {
  var blockName = '';
  if (blockIds && blockIds.length) {
    if (blockIds.length === 1) {
      blockName = blockNames[blockIds[0]];
    } else {
      blockName = "".concat(blockIds.length, " blocks");
    }
  }
  return blockName;
}
function ValveControlList(_ref) {
  var _ref2, _valveData;
  var valves = _ref.valves,
    blocks = _ref.blocks,
    onClickCalendar = _ref.onClickCalendar,
    valveLoading = _ref.valveLoading;
  var dispatch = useDispatch();
  var interval = useRef(null);
  var filteredBlocks = blocks ? blocks.filter(function (d) {
    return d.valve || d.valves;
  }) : null;
  var blocksUnsorted = useSelector(function (state) {
    return selectBlockSensorStatus(state, filteredBlocks);
  });
  var blockData = blocksUnsorted.sort(function (a, b) {
    return a.blockName.localeCompare(b.blockName);
  });
  var spinner = blockData.reduce(function (a, p) {
    return !p || a || p.valveLoading;
  }, false);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var valveParams = JSON.stringify(valves.map(function (v) {
    return {
      identifier: v === null || v === void 0 ? void 0 : v.identifier,
      type: v === null || v === void 0 ? void 0 : v.type
    };
  }));
  var loadSensorsStatus = useCallback(function (sensorParams) {
    sensorParams.forEach(function (sensorParam) {
      dispatch(loadSensorStatusAction(sensorParam));
    });
  }, [dispatch]);
  useEffect(function () {
    var parsedSensorParams = JSON.parse(valveParams);
    loadSensorsStatus(parsedSensorParams);
    interval.current = setInterval(function () {
      loadSensorsStatus(parsedSensorParams);
    }, REFRESH_INTERVAL);
    return function () {
      if (interval.current) {
        clearInterval(interval.current);
      }
    };
  }, [loadSensorsStatus, valveParams]);
  var blockNames = filteredBlocks.reduce(function (acc, obj) {
    acc[obj.id] = obj.name;
    return acc;
  }, {});
  var blockDataObj = blockData.reduce(function (acc, b) {
    acc[b.blockId] = b;
    return acc;
  }, {});
  var blockIds = blocks.map(function (b) {
    return b.id;
  });
  var valveDataByBlock = useSelector(function (state) {
    return selectValveControllersForBlocks(state, blockIds);
  });
  var flattenedArray = (_ref2 = []).concat.apply(_ref2, _toConsumableArray(Object.values(valveDataByBlock)));
  var valveData = flattenedArray.length === 0 || flattenedArray.length === 1 && Object.keys(flattenedArray[0]).length === 0 ? [] : Array.from(new Set(flattenedArray));
  valveData = (_valveData = valveData) === null || _valveData === void 0 ? void 0 : _valveData.map(function (valveItem) {
    var _valveItem$status, _valveItem$status2, _valveItem$status3, _valveItem$status4, _valveItem$status5, _valveItem$irrigation, _blockDataObj$valveIt, _valveItem$irrigation2, _blockDataObj$valveIt2, _valveItem$irrigation3, _blockDataObj$valveIt3;
    return _objectSpread2(_objectSpread2({}, valveItem), {}, {
      valveOnline: valveItem === null || valveItem === void 0 || (_valveItem$status = valveItem.status) === null || _valveItem$status === void 0 ? void 0 : _valveItem$status.online,
      valveOverrideStatus: valveItem === null || valveItem === void 0 || (_valveItem$status2 = valveItem.status) === null || _valveItem$status2 === void 0 ? void 0 : _valveItem$status2.overrideStatus,
      valveAlarmCount: valveItem === null || valveItem === void 0 || (_valveItem$status3 = valveItem.status) === null || _valveItem$status3 === void 0 ? void 0 : _valveItem$status3.alarmCount,
      valveCurrentState: valveItem === null || valveItem === void 0 || (_valveItem$status4 = valveItem.status) === null || _valveItem$status4 === void 0 || (_valveItem$status4 = _valveItem$status4.controlStatus) === null || _valveItem$status4 === void 0 ? void 0 : _valveItem$status4.state,
      valveIdentifier: valveItem === null || valveItem === void 0 ? void 0 : valveItem.identifier,
      valveLoading: valveItem === null || valveItem === void 0 || (_valveItem$status5 = valveItem.status) === null || _valveItem$status5 === void 0 ? void 0 : _valveItem$status5.loading,
      valveScheduledOpen: (valveItem === null || valveItem === void 0 || (_valveItem$irrigation = valveItem.irrigation_blocks) === null || _valveItem$irrigation === void 0 ? void 0 : _valveItem$irrigation.length) && ((_blockDataObj$valveIt = blockDataObj[valveItem === null || valveItem === void 0 ? void 0 : valveItem.irrigation_blocks[0]]) === null || _blockDataObj$valveIt === void 0 ? void 0 : _blockDataObj$valveIt.valveScheduledOpen),
      valveScheduledClose: (valveItem === null || valveItem === void 0 || (_valveItem$irrigation2 = valveItem.irrigation_blocks) === null || _valveItem$irrigation2 === void 0 ? void 0 : _valveItem$irrigation2.length) && ((_blockDataObj$valveIt2 = blockDataObj[valveItem === null || valveItem === void 0 ? void 0 : valveItem.irrigation_blocks[0]]) === null || _blockDataObj$valveIt2 === void 0 ? void 0 : _blockDataObj$valveIt2.valveScheduledClose),
      valveControlEnabled: (valveItem === null || valveItem === void 0 || (_valveItem$irrigation3 = valveItem.irrigation_blocks) === null || _valveItem$irrigation3 === void 0 ? void 0 : _valveItem$irrigation3.length) && ((_blockDataObj$valveIt3 = blockDataObj[valveItem === null || valveItem === void 0 ? void 0 : valveItem.irrigation_blocks[0]]) === null || _blockDataObj$valveIt3 === void 0 ? void 0 : _blockDataObj$valveIt3.valveControlEnabled)
    });
  });
  valveData.sort(function (a, b) {
    var _a$name;
    return a === null || a === void 0 || (_a$name = a.name) === null || _a$name === void 0 ? void 0 : _a$name.localeCompare(b === null || b === void 0 ? void 0 : b.name);
  });
  var getMessageClassName = function getMessageClassName(state, online) {
    var styleStr = "".concat(styles$5['red-message'], " ");
    var styleStrNot = "".concat(styles$5['normal-message'], " ");
    if (state === 'unknown' || !online && state === 'closed') {
      return styleStr;
    }
    if (!state) return styleStr;
    return styleStrNot;
  };
  var getSchedule = function getSchedule(valve, text) {
    return /*#__PURE__*/React.createElement("div", {
      className: styles$5['icon-container'],
      onClick: function onClick() {
        return onClickCalendar({
          id: valve.blockId
        });
      },
      role: "presentation"
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$5.icon
    }, /*#__PURE__*/React.createElement(FaCalendarAlt, null)), /*#__PURE__*/React.createElement("div", {
      className: getMessageClassName(valve.valveCurrentState, valve.valveOnline)
    }, /*#__PURE__*/React.createElement("span", {
      className: styles$5['schedule-content']
    }, text)));
  };
  var getIndClass = function getIndClass(blockStatus) {
    var styleStr = "".concat(styles$5.indicator, " ");
    if (!blockStatus.valveLoading) {
      if (blockStatus.valveControlEnabled) {
        if (!blockStatus.valveOnline) return styleStr + styles$5.red;
        if (blockStatus.valveOnline && blockStatus.valveCurrentState === 'closed') return styleStr + styles$5['light-grey'];
        if (blockStatus.valveOnline && blockStatus.valveCurrentState === 'open') return styleStr + styles$5.blue;
      }
    }
    return styleStr + styles$5['light-grey'];
  };
  var getCurrentState = function getCurrentState(valve) {
    var color = valve.valveCurrentState === 'open' ? '#1890FF' : '#D40202';
    if (valve.valveCurrentState) {
      if (valve.valveCurrentState !== 'unknown') {
        if (valve.valveOnline && valve.valveCurrentState === 'closed') {
          return /*#__PURE__*/React.createElement(Tag, {
            color: "",
            key: valve.valveCurrentState,
            className: styles$5['tag-icon']
          }, t('Closed').toUpperCase());
        }
        var state = valve.valveCurrentState === 'open' ? t('Open_status').toUpperCase() : valve.valveCurrentState;
        return /*#__PURE__*/React.createElement(Tag, {
          color: color,
          key: valve.valveCurrentState,
          className: [styles$5['tag-icon'], styles$5['tag-icon-irrigating']]
        }, t(state.toUpperCase()));
      }
      return /*#__PURE__*/React.createElement(WarningFilled, {
        className: styles$5['warning-icon']
      });
    }
    if (!valve.valveCurrentState) {
      return /*#__PURE__*/React.createElement(WarningFilled, {
        className: styles$5['warning-icon']
      });
    }
    return '';
  };
  var getRowClassName = function getRowClassName(record) {
    if (record.valveCurrentState) {
      if (!record.valveControlEnabled || record.valveCurrentState === 'unknown') {
        return styles$5['red-border-text'];
      }
      if (record.valveControlEnabled && !record.valveOnline && (record.valveCurrentState === 'closed' || !record.valveCurrentState)) {
        return styles$5['red-border-text'];
      }
    }
    if (!record.valveLoading && (!record.valveControlEnabled || !record.valveCurrentState)) {
      return styles$5['red-border-text'];
    }
    var className = getIndClass(record);
    return className;
  };
  function widthCalc(columns) {
    var maxwid = 100;
    var result = columns().map(function (element) {
      var values = element;
      if (element.title === 'Alarm') {
        values.width = 100;
      }
      if (element.title === 'Override') {
        values.width = 100;
      }
      if (element.title !== 'Override' && element.title !== 'Alarm') {
        values.width = "".concat((maxwid - 10) / (columns().length - 2), "%");
      }
      return values;
    });
    return result;
  }
  function getAlarmListUrl(valve) {
    var params = {
      blockId: valve.blockId,
      logLevel: 'error',
      active: true
    };
    var paramStr = new URLSearchParams(params).toString();
    return "/events?".concat(paramStr);
  }
  var columns = function columns() {
    return [{
      title: t('Block(s)'),
      className: styles$5['schedule-item-header'],
      render: function render(valve) {
        var blockIds = valve.irrigation_blocks && valve.irrigation_blocks.length ? valve.irrigation_blocks : [valve.block];
        var blockName = getBlockNameForValve(blockNames, blockIds);
        if (blockName) {
          return /*#__PURE__*/React.createElement(Tooltip, {
            title: blockName
          }, /*#__PURE__*/React.createElement("span", null, blockName));
        }
        return /*#__PURE__*/React.createElement("span", {
          style: {
            color: 'lightgray'
          }
        }, t('No Name'));
      }
    }, {
      title: t('Valve'),
      className: styles$5['schedule-item-header'],
      render: function render(valve) {
        if (valve.name) {
          return /*#__PURE__*/React.createElement(Tooltip, {
            title: valve.name
          }, /*#__PURE__*/React.createElement("span", null, valve.name));
        }
        return /*#__PURE__*/React.createElement("span", {
          style: {
            color: 'lightgray'
          }
        }, t('No Name'));
      }
    }, {
      title: t('Schedule'),
      className: styles$5['schedule-header'],
      render: function render(valve) {
        if (valve.valveControlEnabled) {
          return getSchedule(valve, getValveScheduleMessage(t, valve.valveOnline, valve.valveCurrentState, valve.valveScheduledOpen, valve.valveScheduledClose, valve.valveOverrideStatus && valve.valveOverrideStatus.state));
        }
        return t('Control not enabled');
      }
    }, {
      title: t('Override'),
      className: styles$5['override-header'],
      render: function render(valve) {
        if (valve.valveControlEnabled) {
          return /*#__PURE__*/React.createElement(OverrideStatus, {
            type: VALVE_TYPE,
            overrideStatus: valve.valveOverrideStatus,
            valveIdentifier: valve.valveIdentifier,
            vfdIdentifier: valve.vfdIdentifier,
            currentState: valve.valveCurrentState,
            confirmDialogMessages: [getPumpScheduleMessageBasic(t, valve.pumpStartDate, valve.pumpStopDate), getValveScheduleMessage(t, valve.valveOnline, valve.valveCurrentState, valve.valveScheduledOpen, valve.valveScheduledClose)]
          });
        }
        return null;
      }
    }, {
      title: t('State'),
      className: styles$5['state-header'],
      render: function render(valve) {
        if (valve.valveControlEnabled) {
          return /*#__PURE__*/React.createElement("div", {
            className: styles$5.status
          }, getCurrentState(valve));
        }
        return null;
      }
    }, {
      title: t('Alarms'),
      className: styles$5['alarms-header'],
      render: function render(valve) {
        return /*#__PURE__*/React.createElement(Link, {
          to: getAlarmListUrl(valve)
        }, /*#__PURE__*/React.createElement(Badge, {
          count: valve.valveAlarmCount
        }, /*#__PURE__*/React.createElement(Button, {
          className: styles$5['bell-icon-button'],
          icon: /*#__PURE__*/React.createElement(BellFilled, {
            className: styles$5['bell-icon-size']
          })
        })));
      }
    }];
  };
  function renderValveDetail(valveControlStatus) {
    return /*#__PURE__*/React.createElement(BlockControlSensorList, {
      controlStatus: valveControlStatus,
      showBlockList: true
    });
  }
  return /*#__PURE__*/React.createElement("div", {
    className: styles$5['list-container']
  }, /*#__PURE__*/React.createElement(Collapse, {
    expandIconPosition: "right",
    defaultActiveKey: ['1']
  }, /*#__PURE__*/React.createElement(Panel$1, {
    header: /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Text$2, {
      style: {
        fontSize: '16px'
      }
    }, t('Valves')), valveLoading || spinner ? /*#__PURE__*/React.createElement(LoadingOutlined, {
      style: {
        marginLeft: '10px',
        fontSize: '16px'
      }
    }) : ''),
    key: "1",
    className: styles$5['collapse-header']
  }, valveData.length ? /*#__PURE__*/React.createElement(Table, {
    className: styles$5['custom-table'],
    rowClassName: getRowClassName,
    dataSource: valveData,
    columns: widthCalc(columns),
    pagination: false,
    rowKey: function rowKey(record) {
      return String(record.id);
    },
    expandable: {
      expandRowByClick: true,
      rowExpandable: function rowExpandable() {
        return true;
      },
      expandedRowRender: function expandedRowRender(valve) {
        return renderValveDetail(valve);
      }
    },
    locale: {
      emptyText: t('No Data')
    }
  }) : /*#__PURE__*/React.createElement("section", {
    className: styles$5['configuration-message']
  }, t('No Valves Configured')))));
}
ValveControlList.propTypes = {
  blocks: PropTypes.arrayOf(PropTypes.object),
  valves: PropTypes.arrayOf(PropTypes.object),
  onClickCalendar: PropTypes.func,
  valveLoading: PropTypes.bool
};
ValveControlList.defaultProps = {
  blocks: [],
  valves: [],
  onClickCalendar: null,
  valveLoading: null
};

var styles$4 = {"root":"CircularSlider_root__lSq6C","custom-label-div":"CircularSlider_custom-label-div__v-w3n","custom-label-div-default":"CircularSlider_custom-label-div-default__6RB23","water-value":"CircularSlider_water-value__KMjgd","outer-div":"CircularSlider_outer-div__QMUN0","inner-div":"CircularSlider_inner-div__KLPs0","time-background":"CircularSlider_time-background__r2I1Q","custom-input":"CircularSlider_custom-input__gGpQZ","time-div-style":"CircularSlider_time-div-style__5nC-k","water-value-div-style":"CircularSlider_water-value-div-style__4YGdL","span-text-value":"CircularSlider_span-text-value__dNdPp","span-text-unit":"CircularSlider_span-text-unit__-jNrd","container":"CircularSlider_container__aAv0y","card-style":"CircularSlider_card-style__CCcxz","card-div-style":"CircularSlider_card-div-style__DxkOs","back-icon":"CircularSlider_back-icon__0NNbb"};

function round(x, step) {
  return Math.ceil(x / step) * step;
}
var Slider = function Slider(props) {
  props.strokeDashArray;
    var sliderWidth = props.sliderWidth,
    trackSize = props.trackSize,
    hourMax = props.hourMax,
    hourStep = props.hourStep,
    minMax = props.minMax,
    minStep = props.minStep,
    value = props.value;
    props.defaultValue;
    var knobSize = props.knobSize,
    colors = props.colors,
    onChange = props.onChange,
    cutoffValues = props.cutoffValues,
    waterValue = props.waterValue,
    waterUnit = props.waterUnit;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;

  // const defaultMinutes = (defaultValue !== null) ? defaultValue : value || 0;
  var timeoutId = useRef(0);
  useEffect(function () {
    return function () {
      if (timeoutId.current) clearTimeout(timeoutId.current);
    };
  });
  function parseHours(minutes) {
    return Math.floor(minutes / 60);
  }
  function parseMinutes(minutes) {
    return minutes % 60;
  }
  var _useState = useState(parseHours(value)),
    _useState2 = _slicedToArray(_useState, 2),
    hrs = _useState2[0],
    setHrs = _useState2[1];
  var _useState3 = useState(parseMinutes(value)),
    _useState4 = _slicedToArray(_useState3, 2),
    mins = _useState4[0],
    setMins = _useState4[1];
  useEffect(function () {
    if (mins !== parseMinutes(value)) setMins(parseMinutes(value));
  }, [value, mins]);
  var totalMinutes = value; // 60 * hrs + mins;

  var maxTotalMinutes = 60 * hourMax;
  function getSliderValues() {
    var allValues = [];
    for (var i = minStep; i <= maxTotalMinutes; i += minStep) {
      allValues.push(i);
    }
    return allValues;
  }
  var timeArr = getSliderValues();
  var currIndex = timeArr.indexOf(round(totalMinutes, minStep));
  var sliderIndex = currIndex >= 0 ? currIndex : 0;
  var onSliderChange = function onSliderChange(newValue) {
    // handle values over slider max
    if (newValue === maxTotalMinutes && totalMinutes > maxTotalMinutes) {
      return;
    }
    setHrs(parseHours(newValue));
    setMins(parseMinutes(newValue));
    onChange(newValue);
  };
  function onHoursInputChange(newHours) {
    setHrs(newHours);
    onChange(Number(newHours * 60 + mins));
  }
  function onMinutesInputChange(newMinutes) {
    var extraHours = Math.floor(newMinutes / 60);
    var minutes = newMinutes % 60;
    setMins(minutes);
    setHrs(hrs + extraHours);
    onChange(Number(newMinutes + 60 * hrs));
  }
  function appendAttributesToElement() {
    var circles = document.getElementsByTagName('circle');
    var svgElem = document.getElementsByTagName('svg');
    var divElem = document.querySelectorAll('.innerDiv div');
    if (svgElem.length && svgElem.length >= 3) {
      svgElem[0].setAttribute('id', 'sliderCircle');
      svgElem[1].setAttribute('id', 'knob');
      svgElem[0].setAttribute('shape-rendering', 'geometricPrecision');
      svgElem[1].setAttribute('shape-rendering', 'geometricPrecision');
      svgElem[2].childNodes.forEach(function (d) {
        return d.setAttribute('fill', 'none');
      });
    }
    if (divElem.length && divElem.length >= 1) {
      divElem[1].setAttribute('id', 'knobDiv');
    }
    return circles;
  }
  var filteredCutOffPoints = [];
  var filteredColor = [];
  var arrIndex;
  for (arrIndex = 0; arrIndex < cutoffValues.length; arrIndex += 1) {
    var cutoffValue = cutoffValues[arrIndex];
    if (cutoffValue && cutoffValue > 0 && cutoffValue <= hourMax) {
      filteredColor.push(colors[arrIndex]);
      filteredCutOffPoints.push(cutoffValues[arrIndex]);
    }
  }
  filteredColor.push(colors[arrIndex]);
  var mobileScreen = window.innerWidth < 600;
  var outerCircleWidth = sliderWidth;
  var cutOffValArray = filteredCutOffPoints;
  var x = sliderWidth / 2;
  var y = sliderWidth / 2;
  var r = x - 8;
  var maxValue = hourMax;
  var sin = Math.sin;
  var cos = Math.cos;
  var svg = document.getElementById('svgStrokeCircle');

  // Change below values to adjust gap between circle and size of circle
  var radius = 7.5;
  var gap = 12;
  function getProportionateAngle(num) {
    return 2 * Math.PI * num / maxValue;
  }
  function getPointForAngle(ra, angle) {
    return [x + ra * sin(angle - Math.PI), y + ra * cos(angle - Math.PI)];
  }
  function plotCirclesOnArc(start, end, color) {
    var circle = document.getElementById('innerCircle');
    var angleUnit = Math.PI / 180;
    var angleBetweenCircles = gap * angleUnit;
    var currentAngle = start + angleBetweenCircles;
    var cutOffPointsArr = [].concat(cutOffValArray, [end]);
    for (var i = 0; i < cutOffPointsArr.length; i += 1) {
      var cutOffAngle = getProportionateAngle(cutOffPointsArr[i]);
      while (currentAngle <= cutOffAngle) {
        var point = getPointForAngle(r, currentAngle);
        var circleClone = circle.cloneNode(true);
        circleClone.setAttribute('id', 'arc-cir');
        circleClone.setAttribute('r', radius);
        circleClone.setAttribute('cx', point[0]);
        circleClone.setAttribute('cy', point[1]);
        circleClone.setAttribute('fill', color || filteredColor[i]);
        circleClone.setAttribute('stroke-width', 1);
        circleClone.setAttribute('shape-rendering', 'geometricPrecision');
        circleClone.setAttribute('stroke-linejoin', 'round');
        svg.appendChild(circleClone);
        currentAngle += angleBetweenCircles;
      }
    }
  }
  function removeCircles() {
    var dialCircles = document.querySelectorAll('#arc-cir');
    if (dialCircles !== null && dialCircles !== void 0 && dialCircles.length) {
      dialCircles.forEach(function (d) {
        return d.remove();
      });
    }
  }
  useEffect(function () {
    var circle = appendAttributesToElement();
    if (circle.length && circle.length >= 2) {
      circle[0].setAttribute('id', 'circle');
      circle[0].setAttribute('r', "".concat(mobileScreen ? x - 20 : x - 30));
      circle[0].setAttribute('fill', '#e3e3e3');
      circle[1].setAttribute('fill', 'white');
      circle[1].setAttribute('fill-opacity', '0.8');
    }
    if (!document.getElementById('svgStrokeCircle')) {
      var newHtml = "<svg id=\"svgStrokeCircle\" class=\"outercircle\"\n        viewBox=\"0 0 ".concat(outerCircleWidth, " ").concat(outerCircleWidth, "\"\n        width=\"").concat(outerCircleWidth, "\" height=\"").concat(outerCircleWidth, "\">\n        <circle id='innerCircle' cx=\"").concat(x, "\" cy=\"").concat(y, "\" r=\"").concat(r, "\" fill=\"none\"\n        stroke-width=\"1\" shape-rendering=\"geometricPrecision stroke-linejoin=\"round\" />\n        </svg>");
      var newSvg = document.getElementById('strokeCircle');
      if (newSvg) {
        newSvg.innerHTML += newHtml;
      }
    }
    try {
      if (cutOffValArray && cutOffValArray.length) {
        removeCircles();
        plotCirclesOnArc(0, maxValue);
      } else {
        removeCircles();
        plotCirclesOnArc(0, maxValue, filteredColor[0] ? filteredColor[0] : 'orange');
      }
    } catch (_unused) {
      // navigated away from page
    }
  });
  var handleOnlyNumericInput = function handleOnlyNumericInput(e) {
    // Block non-numeric keys
    var isNumberKey = /^[0-9]$/.test(e.key);
    var allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab', 'Delete'];
    if (!isNumberKey && !allowedKeys.includes(e.key)) {
      e.preventDefault();
    }
  };
  var validateNumericInput = function validateNumericInput(e) {
    var inputChar = e.data;
    if (!/^\d$/.test(inputChar)) {
      e.preventDefault();
    }
  };
  function renderInputs() {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "".concat(styles$4['custom-label-div'], " \n          ").concat(!waterValue || !waterUnit ? styles$4['custom-label-div-default'] : '')
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$4['time-div-style']
    }, /*#__PURE__*/React.createElement(InputNumber, {
      className: styles$4['custom-input'],
      min: 0,
      step: hourStep,
      max: hourMax,
      defaultValue: 3,
      value: hrs,
      onChange: onHoursInputChange,
      controls: false // Whether to show +- controls: 4.17.0
      ,
      size: "large",
      "data-testid": "input-hrs",
      onKeyDown: handleOnlyNumericInput,
      onBeforeInput: validateNumericInput
    }), /*#__PURE__*/React.createElement("span", {
      className: styles$4['span-text']
    }, t('hrs'))), /*#__PURE__*/React.createElement("div", {
      className: styles$4['time-div-style']
    }, /*#__PURE__*/React.createElement(InputNumber, {
      className: styles$4['custom-input'],
      min: 0,
      step: minStep,
      max: minMax,
      defaultValue: 0,
      value: mins,
      onChange: onMinutesInputChange,
      controls: false,
      size: "large",
      "data-testid": "input-mins",
      onKeyDown: handleOnlyNumericInput,
      onBeforeInput: validateNumericInput
    }), /*#__PURE__*/React.createElement("span", {
      className: styles$4['span-text']
    }, t('mins')))), waterValue && waterUnit ? /*#__PURE__*/React.createElement("div", {
      className: "".concat(styles$4['custom-label-div'], " ").concat(styles$4['water-value'])
    }, /*#__PURE__*/React.createElement("span", {
      className: styles$4['span-text-value']
    }, waterValue), /*#__PURE__*/React.createElement("span", {
      className: styles$4['span-text-unit']
    }, waterUnit)) : null);
  }
  return /*#__PURE__*/React.createElement("div", {
    className: styles$4['outer-div']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$4['inner-div'],
    id: "innerdiv"
  }, /*#__PURE__*/React.createElement(CircularSlider, {
    width: sliderWidth,
    renderLabelValue: renderInputs(),
    knobSize: knobSize || 40,
    labelFontSize: "1rem",
    valueFontSize: "2rem",
    knobPosition: "top",
    direction: -1,
    progressLineCap: "round",
    knobColor: "#1890ff",
    progressColorFrom: "#1890ff",
    progressColorTo: "#1890ff",
    progressSize: trackSize,
    trackColor: "transparent",
    trackSize: trackSize,
    data: timeArr,
    dataIndex: sliderIndex,
    onChange: onSliderChange
  })), /*#__PURE__*/React.createElement("div", {
    id: "strokeCircle",
    className: styles$4['inner-div']
  }));
};
Slider.propTypes = {
  strokeDashArray: PropTypes.string,
  sliderWidth: PropTypes.number,
  trackSize: PropTypes.number,
  hourMax: PropTypes.number,
  hourStep: PropTypes.number,
  minMax: PropTypes.number,
  minStep: PropTypes.number,
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func,
  defaultValue: PropTypes.number,
  knobSize: PropTypes.number,
  colors: PropTypes.arrayOf(PropTypes.string),
  cutoffValues: PropTypes.arrayOf(PropTypes.any),
  waterValue: PropTypes.number,
  waterUnit: PropTypes.string
};
Slider.defaultProps = {
  strokeDashArray: '0,18.5',
  sliderWidth: 150,
  trackSize: 14,
  hourMax: 72,
  hourStep: 1,
  minMax: 60,
  minStep: 5,
  defaultValue: null,
  onChange: function onChange() {},
  knobSize: 30,
  colors: ['green', 'orange', 'blue'],
  cutoffValues: [],
  waterValue: null,
  waterUnit: null
};

var img$5 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEwAACxMBAJqcGAAABXVJREFUSImd1nts1eUdx/H39/mdS0tpSlvac3qDtgItLaUUKXaBjYhijGPIXCBmuES3BGWJS5YRFl2yW8YWt0ScYuamf5hdTNRkjswLjgFzU2kpPbSrBWRHwNorR3o/PT2X5/nuD2BIWifb99/nl8/r+/s+z5PfT7hSdXV184M53mqFKpA8o2qdMiw+13Oyred9wPF/lAA0rm3cY1QfM6Dzg06Lc0RyA8rYDG5gUsSIJsWYF6cz9ucn23pO/y+ABxAKh75qhOb5AaRlscqH4yKjCZFbq9U8uNpJfbH6rbJqYNzsWrw4XFtQED48PDw8c8NAdWXRg0akZu0iR9eg8JM7LMuKlNfOeBw5b1gZVjZWOj5XrtI/KSumrO5cWFp8cKj/4vANAcuqQt9ZVGhKlxY6SubD8x2Gr6xQtjU4UHim3UOBlSGlpcxJxkn2uRH5eigUen1w8OLgfwMMgBhjmkoNh8563H+zZf1i5ZGDHuMJ4e56x+NftBzrM/y6wyPjhC01li01GgwG9O9r1tRXfOYbLKoovntdlVl6YVTxDGxvcAR9sChfyfLBgmzYUO34S9SjfcDQEDI4Z7gwIYGkk2/ULilZt6A4VBkqLxke6h8amQUUFIdqQ7lsuLfJ48m3YdMSZUX4cvjVCnhQX2j48/uGNz6A6JjQUmW4qUCCzeUsm0yycTTuHg6XldxesKDw5VgslvrPiBB593ivs1+oNjSVGZ5u9VC9Fp6xwpnBAE+1GYxR7lvtceABjx2Njumk4/cRpSTXyeZaFZ/Rddm53lGuXAEBaGlpyVamxp+/N+AP5Qrbf5fmy3WOrXWWlBU6P/LzdLvSWGb4wSYPdWkOnrbsP+axvtJxX5NlQdblZkYSsOsVX2oqyfbOju4DHkBfX1+moryofGxGVn+p3khTmeFnR5SqfBiZDLCvVdlcZ3j0NsNEPMn+Y/BSl8fuz2fYWu+uG2W2H9TifTguN13ovfisubqQwPfjI2etjfQpDSXCE1t9GPXzXMRx+zLDw+uFi2Mz7D0qtPcK+zanWVP+iTleKVVYXqTMpGXltT0Aulq7+h2y57uvpu2laWVpPpzoU4IB2H2rITaR5KdHDQMTwi/usoRzZx/JRBpG4pDjV1JOA9cBAB3Hu5+Ip/T1h17OuEivcvi88r3bfEzGUzz1jqF/XNh7R4a8rNmdO4W9f/Pxp1Meowkh2+8SswBAY7GZbUPjHP7hEatLFgpLCh0H3lNaew0/2pQhNzi7c4BXThk+GhM2VlpOfywEPInMBRCNRpNeIP8uq4w0lQs9A2mePeGxZ4OlKGfu8PY+wwsnPXbdnCHLB0fPGTeWMPvnBABisZhJWfLvWSE8+a5wZ41jZdgxMi1cmpbrnj01LDz2lscDqyxV+co/eg2TaUaN+v/4qYA3z6sKGOgZtPSOCTsaLcNTwu43PN6+cA3oGhS+f9jH9npLc5kjFocX3zMukZb7Ozo60gC+uQCjZmFu0OkfOuGeekc8BY++6bGmTNmy/PKH7dC/DM8c99jRYFlX4Yin4ZdtPueJ/DbS/s9Xr2bNCfhQSVvlbMzwzVscj7zpo6lUeegWSzwNvznucaJf+NbaDLULlYkk7Gv16URK3plJ+Xd+MkvmAhqbG+sD4rqXh5HYlNAYduxca/lr1PBCl6E6X/lagyMvS+mJCc9FPGetvjYUm9kWjUaTnwm0tLRkJ+309Dw/1BQpFXnKW+eFvCBsrXU0FClnLsGhc56e/ph0Rvl2pK37V8CsCzInALCqucEKYgI+1dA8pCwPcnzKcBz3wYioKom0Y38m5T3e2dkZ+7ScOfcAwCp1RlxjMmOqBya1dGhSslNOLonKeVHXHol0d3IDvzL/BqKJYHNesN/1AAAAAElFTkSuQmCC";

var img$4 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEwAACxMBAJqcGAAABMlJREFUSImdVF1sk1UYfs7P97VdW1jd2NgGgvth0MUWtpXxE1hQ0Rg1Agn+xGDQhKAXkBgkGgkxmVwQLjRg9EoIhgsIFyRICDGB4IhsY3Pd2MjY6IZDYHUbpWPt+vXr951zvNARMltEnqv3JOd5nvOc876H4H8iFPLPFZwcUTZ7VUFt7e7o/fFx+8mTiPr9fp1zrvl8PjNhxroLq1SVZSQnJ+54U11t1xY8jssfXQQCATfnqhwgeUqxP7u6uv6oDQVeU8AZAJhMxQEKEdwwlR65NeKZOL6k8J9DqlwGdLoI1j9/iDkwqRhpEUyektyKBEOBYUnIdm+ZNNftMuApFqJyjWAZO3HVSupOAFi2zF/xuAQPr6i2tqbC5kz2tPcMA1B+v1/XPNp6KPkdJWT+C5+m6WgfR+SCC5YplLvAIsl7DApSUIqjxHZ83NnZac00YNNFNDoeH707OjG9Hh8fl2WlJW9Q6VpLwd23fgMSQ4WkRjShyNhIUpkJ8JLfsaBxmMZuFNQKIm6PjoyFcxrMRDAUfG+2XvZNDfncl2cuJhOqm7xYvg+ls2uRGnPDIUtx1/gF9yKzABDFlTNeUjL3bDQalVnfYCY4HJsq895x+chSFImXAaLLzhvn0NvfBgkD/XoTFunbsMI4jbr0UeKU894SoAdm6uQ0kLDCg+NnjWQiiTF+AUoZdJJ0I6LtR5fzI+jUhVcat4BCh0MVocLe4SKwt8/U5NnE/X6/DiUGEyxy84q2qYZAw0vzDmEqshCAxDXHbtgyqTrO3H/YJBQOgMJVG2pos7nxek9rz1jWBMFgMN/p9vQ41JzDLpQvJOAZonSzfF7wodR8awsMMkLu0/bptLjDj2OOWIs5mdVLdct1ImcCyumeUsfq55Y/s0cfvWlinF3EkHZQXb049vcpAUiSgZIk06/t07jmJpJY8IgKVFt7IWFpY+T8uupV1d6BloHEvxIw4lhRQOr1ZMwGAOTLekhikutsr/WA9SDGfsWg9rXyUT+vznxBvKoaTLmwJPMVuPJAwoCSED7ps4EsbVpcUlxlmslQfqqRAwQx1ow46ZxMI67HeQudYO1KEYGtq0/SB0OFKBSNuMtPgUEHAcUgP2hIOnmsvb39FJDls6teVe11m/mXNOJcRJVXZUgUglj6h8vPaoOXGeKyF/2OJjSkT0ApCgWJdse7tk0SAoQIqviRdCq1q6+vL5PVAAA2b97MBocH1iupfE6NXjKFuh0yjxFNFgKQ6HS+D7eqQoG9BjF2WcVJOOL1uGqam5vtmVpP9F3X1Te05qvAimetD5DGCCKOA/CJBqTJKDIqLkw2fri7o3t7Nm7WOXgUgZWBImGaQcUsXNV3ghCGMmsT5ttbAABj/DwbIt8vz8XPOcnTILZ600Mr5YbgIaxMn4ZP1EGQKQAKChIxtFqKiNZc/P9MQCWlAMVAWwIAsNDahl7HbsRYCxQkBKa4gHHu6RMo9tMUIjTOrgBQ4PAgT5bBLctRaX2CMvttohPvjqdOEA6Ho4FQ7cbrfN9JyjVd0YzTKxdjsfklKBxI8ygIlPupEwBAT0f451meWLFiqXVKyf2GvGdMsl7EWAtu0WOGrTLf5uI+UZvO5NSF6j6TYDsJiA2YTeGO7h9ybf4LTbIQGn99a2UAAAAASUVORK5CYII=";

var img$3 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4QUdBTASUWvn5QAAA6BJREFUSMfdld1PW2Ucxz+n5/S9h7ZAgY5JCxZKnFsHGxIw29zmdrNNzSLZFl9uTNQbjXcm3rh45413xr9Ao9HgTEymLltYzByMbDDA2QGVl7UU6OtoS1vOOa0XGh0ZjLKYmPi9e54nTz6/X76/F/ivZbeaqKmyPPZ/YbOHKouJl59tw7/DSQnI5deYmI9z8eYMRUWtGCBudOmtd3D+XC8dzS5S2QI1NiNFRaPWbuVIwEMwnCSTX3s8wJNuJ+fP9hJaTHEtGCXgdfH9zVlGZ+LYTHoC3lr0epFboaWKALoHD7LFyLun9qEXBcbmEshmAxeGQ4QW07x6qB1/o4PFVI6eNjeNtVXbB7zY7cMlm/gtnOTcAT/L6VXG5+L09bby3Y0QyWwRRSuRySsc2+vZHsBhM9Hd6uazH24DAv2D0wxPL/HR2R5S2SJraonmuir6h0JcGZ+ns6UOSdRVDgh46xAEgeZ6O8FIiut3o3x4ppvRmRhqqcxrz7VzfTJKrqCw1+tCJwi47JbKATtrZaxGkS5fPSO/L/PW8d0EIym+vDaJxShxP1ekwWHhjed34ZRNFJUSBkmqHOC0mbCZDPQPhvC4ZNrcDgqKynsnO2istpLMFjHqRfJFFYEyggDJTL5yQJXZwFQ0RbagcGRPE/cSWZ7aWc3ARJgfR+epkU0ICEiiwJpapv/6FJl8cUvA3zlKosBsLEOXr55wfIX7eYWWv/w4ud+LqpXQSzriKwUmwklGZ5a212guu4Xe9kZEHeQVDdmkRzbr6fE3YDXpKQN2i5E74RSXRmbJrG4cvSSKVNttrBbW1gPmYhl62nfQ5JLRiwIWo4Sqlv5sQLMBrQQ3ppe5OnGPWDq7acQfvH6KEz0BBkaCqJr2D0BRNYYmo1hNBjwuO3aLAdlswGrWE07k+PqXKa6MzZHOrjf2pQOdnDnazUIizcGAH/8TbnQ6HVdHgxQVdeNp2tZYQ0dLHQ1OK2OzMQbvLpAvKg+PYkHgzRcOsxBPcWz/LpKZHL/ORCiXy3wzMLze5Ac1GUkwGUlsaWDv0z7cNQ60ksZyeoXPLw3yzumjfPrt5YerqFI5ZSsdbR4cNit2m5mlZJrF5AoXh8bpO9SFJOqIJtKP3geP0h5fEx+/3YfLIROOJbkzG8VmNnL64D46W5v45KufiMRSW2+0Tetap6PvcBcBXxOaptHucWO3mPni8hAXfr5FKpP7d3a1JImAwPFndvP+Kyf4/+oPyW1YqDyBO5MAAAAASUVORK5CYII=";

var img$2 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEwAACxMBAJqcGAAABO9JREFUSImdlmlsVFUYht9z7r0znaUtLV2YUpYBxgmVdqZNoVRQBMNiJAEjARMxxOAPggnRRNQIIfhDoyEhwUhA/lkQjcQgSqFaa4BObYsdCt2QskjblJkOdKbLLHc9xx/Q2mVKGt/kJPee837fc893br57Caah5cuXW2J6bC4BkSQuBf1+/6PpxAEAmWqhoKDAnpJq2pmZZtkTHow7RUGApusEACiTZvj9/sH/DShZ6nnVbDZVLMjPtW7buJqWFbmRlW7FD1W1OHrq/IN4Qj7EQCyUoHXhfPfFM2fOGNMGlK8o/oQQYf++3W/QDSs84FocnMkAB158+zOmGToWus2yJZUId9plJif4NUMxrfb7/VoygDj2prTc844kmvaf+PQ96spLA5PDo2udXX1QdJ3sPZhJsvNMVgBQZI5D+0IlEVV7DcD3yQB05KKwtNANTo4c/ngXXTTLCqbFxxlPVdXpSzxmMjNXGp0zpxB4yqwWQvnSqUo0CshKsx7ZsuEFwbsoB9xQx5kGhhOo/rNdKF9lARXGV1VVDMPgRH4qwOv1Zkfj6tq3Nq0B1xOTTKcvNvA5cwU4nzGPm9dVjpstmkE5yygt89SULPPsnRgrAgAR2Use9wI+M5WCT3gfYgkV3/9ax7a8aRNEEwFnHPFBhubGBJoaZR7pN0xzHDN39AQjVkmg8wEcmgQAIYUFLqcwsTQAUHG+jmfmUFrgSUE4oOJKTRxN9SpPtZr1retWSc/vdsM5O8v67S+1qLhwtSfpDuw2iyM91TopeXgohtMX6/jmrVZadXYYDT6Fu+ZlaV/sWW8qW+KUCPnvPCKDUWi6nhygKHIkFotNAhw+WakpKpPOn4vxvIwZ2lcfvm7yuueaJvqYrqHjfpAPx+X6pABNY+1tt++rwMrR4Au+FvxW/7cEAB9s30Q2PFdoAmPQFRmcsccmQiEIFA8CIVy/3QtiiJVJAQKMan/HfSE8FENmmg0AcPD4TwCA6uPvwypR9AeD8F2/i7buAPqHogCATLsNCxxZuNnVh3S7ueH3hsauiYDRIq5dW167othdvm/nRgEAonEFNosJamwY5y4149i5OmQ5KPJdDPZ0gHMgHuUI9VD806kBlPcyhR9wzlv8zdjeNArwlnldEuEdB3a+LK5bWQJKKXQ5ge+q6lBR04htuwXkL0zefA0d6Gw1UP2jFh8Ko1uPG+v9/o7ux9V5omBvMJyTm9Piu3Fvq5kYxOWYgUhkAB+dqMT2d8UpkwMApUC2g2LZalFSEzyjr5fsyM3O/zoQCCjCWGMwELqV68i+1NHVt/mPps6UntAA6Vf7sWazCEKnSj+m3gRwLhbonTZYBgfUoUBvyDcprPmv1isUD/PuBsK7Lt+499BiA3RtGtkBcAZoCQGz8imhAnEBE9r1iC5f7pKBrhPe0iW3tAekRldTBHABoomBCHx8Ug4wg8DQCbhGISeANr9q6CqpBMZ002RyORf7OCcPr9VqMHQCJS5AiYpQYk9G9PHQEgKYRvGoj+Hkl3HGdfzc3NRyFnjKN3lEJSWFhaINjcXlJsuyVSLSMsY/k6JwdN9maGvS+J12TQchB6/6Wj8HwKYFAIDS0mfnpKSLRxMx/orFyrk9nRKA89gwR2yICBY7gpqM4zLHsZb6ltDY2GkBRlRUVGSTJBQzgtkAwMGCAje3P+035l9nKC7r2a4SUQAAAABJRU5ErkJggg==";

var img$1 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAEXElEQVRIicWVaWxUVRiGn3tnn+ntnaGdtmOBttAtFOgSx0IrKlRIEMIWKhA1UUk0Rkk0IVH/iGBigv4xcUs0+s8FMFVjAhiWVInQWlsKZekCnS4zlE47SzvrndUfUkMmNgzGxDc5P86Xk/c570m+78D/qPXASdmk9+XlGj3AaeBlwHI/JsI89YO5Rv1bO5srqXrAQgoIRWJcGZvmRLfDr8QT7wPvZgNQ/UPtk9JC8/639zRRX2bFF4ySl6NDiSfJl02sqy3R9zu9LYFIzAlcvBdAzNgfXmqzvHRwTxNjUzMcOz9EgWzkeM8ox3tGcfvDlFklnrAvAfhwngvOm2CdZNR99mbrKiS9mtOXx8nPNdDjcDN8e4bnW2owm7QEIjEqbBa6h92aQFgZu1eKuxN8sbWxHKuk57rTy541Vbj9YfpGp2ltquDH32/iDSrEkykCkTjr60oA9mX7RM3mHH1pY4WNT09eAgTaOm7QdWOSQ7tX4wsqxBIpygpyaeu8ydm+MRqWFKBWibWALRvAjtrSAgRBoKxQpt/l48LABAd2NdLrmCKRSvPMY9VcGJwgFI1TV2pFFASsshGgOhtAw8J8CZNOhb28kIvDbl7csIJ+l49vfxvEqFMzE1IoMhvZ+3gNFkmPEk+hVasBNNkAllpy9OTotbR13KTEKlFpMxONJ3h1cz3FC0x4gwo6jYqIkkAgjSCANxABGMsGIOUatAxN+AhG46xbuZhxT5BlCxfQfsXJz71j5El6BATUKoFYIk3bhSECEcUNDGQDmFWrBEamAtjLC3FOz3JpdJrJmQj9Lh8VNplEMoVGLeIJKLRfc9HrmAR4D0hneNYB2+Y2c32w0SoblzZVF6MSIRJPIuk1SAYNq6uKMOk1pAHZqOOa08epiyMEwsoosCvDfKNapTq3QM7ZHY7GpoGuuQRfnuh2EIjEKCuUKbVKFFmMpFJpYvEkJp0GURA5d32C9r5xZkORKLAKaAZGgKvAEeD4G09v4sCzWzHotPvvTnA1nkhaOgcnVpn0WkqsMrJRi2TQYjJocHpCHDs/xNnLo/iDkQHgYWAc6Nq2pqF4V0uj9ZbHX/NIbRVVi2yIosgvvf25SjxxKHOa2oEPKovzmuqXFFBkMXF5ZIqOgVtElLgT+Ag4PHdYEISpF7aszb817WP9gzV4AyGuOlyk02m+a+/6A7CrMwBdQPOgy/PkoMvTDGgBF9ALnAQSwGbgOWB50/LyfFuemWQqids/y1enOti3o4WPvz8Dd8Z5JmBOR++sTLVaJNPR+soSzDkm5BwDk14/t72znOjso/VRO2qVyITHD3f6I3Nc30uVFYuKeGfvdrY016ESBfqGXahFkVe2t7BmZQWf//Qr4WisG+iH+X+0+ZSnEkVH61q7VFu+mGQySXWJDdlo4OsznfxwrgdfIDQANAIz9+n9t+qBsFqtSoOQ3vDQivTrT21K81fD7fy3pplaCDQAy4BvgEngtf/K/L70J3jGnmeAXu1JAAAAAElFTkSuQmCC";

var Panel = Collapse.Panel;
var Text$1 = Typography.Text;
var EntityList = function EntityList(_ref) {
  var onChange = _ref.onChange,
    selected = _ref.selected,
    data = _ref.data,
    activeSelections = _ref.activeSelections;
  // sort data in alphabetical order
  if (data.length) {
    data.map(function (d) {
      var obj = d;
      obj.ranches.sort(function (a, b) {
        return a && a.name.toLowerCase().localeCompare(b && b.name.toLowerCase());
      });
      obj.ranches.map(function (r) {
        var robj = r;
        robj.blocks.sort(function (a, b) {
          return a && a.name.toLowerCase().localeCompare(b && b.name.toLowerCase());
        });
        return robj;
      });
      return obj;
    });
    data.sort(function (a, b) {
      return a && a.name.toLowerCase().localeCompare(b && b.name.toLowerCase());
    });
  }
  function getImage(type) {
    switch (type.toLowerCase()) {
      case 'almonds':
      case 'almond':
        return img$5;
      case 'grapes':
      case 'grape':
        return img$4;
      case 'pistachios':
      case 'pistachio':
        return img$2;
      case 'walnuts':
      case 'walnut':
        return img$1;
      default:
        return img$3;
    }
  }
  useEffect(function () {
    if (selected.ranch.length && !selected.block.length) {
      var elmnt = document.getElementById(String(selected.ranch[0]));
      if (elmnt) elmnt.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    } else if (selected.block.length) {
      var _elmnt = document.getElementById(String(selected.block[0]));
      if (_elmnt) _elmnt.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
  });
  return data.map(function (en, i) {
    if (en && en.id) {
      return /*#__PURE__*/React.createElement(Collapse, {
        expandIconPosition: "right",
        key: "".concat(String(en.id), "_").concat(String(i)),
        collapsible: "header",
        defaultActiveKey: en.id
      }, /*#__PURE__*/React.createElement(Panel, {
        header: en.name,
        key: String(en.id),
        className: styles$8['collapse-content']
      }, en.ranches.length ? en.ranches.map(function (ra, j) {
        return /*#__PURE__*/React.createElement(Collapse, {
          className: selected.ranch && selected.ranch.includes(ra.id) && selected.block && !selected.block.length ? styles$8['collapsible-list-selected'] : styles$8['collapsible-list'],
          expandIcon: function expandIcon(_ref2) {
            var isActive = _ref2.isActive;
            return /*#__PURE__*/React.createElement(CaretRightOutlined, {
              rotate: isActive ? 90 : 0
            });
          },
          key: "".concat(String(ra.id), "_").concat(String(j)),
          activeKey: activeSelections,
          onChange: onChange
        }, /*#__PURE__*/React.createElement(Panel, {
          header: selected.ranch && selected.ranch.includes(ra.id) && selected.block && !selected.block.length ? /*#__PURE__*/React.createElement(Tooltip, {
            title: ra.name
          }, /*#__PURE__*/React.createElement(Text$1, {
            id: String(ra.id),
            onClick: function onClick(d) {
              return onChange({
                ranch: d.target.id
              });
            },
            className: styles$8['selected-ranch-header']
          }, ra.name)) : /*#__PURE__*/React.createElement(Tooltip, {
            title: ra.name
          }, /*#__PURE__*/React.createElement(Text$1, {
            id: String(ra.id),
            onClick: function onClick(d) {
              return onChange({
                ranch: d.target.id
              });
            }
          }, ra.name)),
          key: String(ra.id)
        }, ra.blocks.length ? ra.blocks.map(function (bl, k) {
          return /*#__PURE__*/React.createElement("div", {
            key: "".concat(bl.name, "_").concat(String(k)),
            className: styles$8['list-content']
          }, /*#__PURE__*/React.createElement(List.Item, {
            key: bl.id,
            onClick: function onClick(d) {
              return onChange({
                block: d.target.id
              });
            },
            id: bl.id,
            className: selected.ranch && selected.ranch.length && selected.block && selected.block.includes(bl.id) ? styles$8['selected-block'] : styles$8['extra-list'],
            extra: [/*#__PURE__*/React.createElement("div", {
              id: bl.id,
              key: "".concat(bl.id, "_").concat(bl.name),
              className: styles$8['extra-list-items']
            }, /*#__PURE__*/React.createElement("img", {
              id: bl.id,
              alt: bl.crop,
              src: getImage(bl.crop)
            }))]
          }, /*#__PURE__*/React.createElement(Tooltip, {
            title: bl.name
          }, /*#__PURE__*/React.createElement(Text$1, {
            id: bl.id,
            className: selected.ranch && selected.ranch.length && selected.block && selected.block.includes(bl.id) ? styles$8['selected-block-text'] : styles$8['list-name']
          }, bl.name))), /*#__PURE__*/React.createElement("div", {
            className: styles$8['status-box']
          }));
        }) : /*#__PURE__*/React.createElement("div", null, !ra.isLoading ? /*#__PURE__*/React.createElement(Text$1, {
          className: styles$8['loading-icon']
        }, "No Block") : /*#__PURE__*/React.createElement(LoadingOutlined, {
          className: styles$8['loading-icon']
        }))), /*#__PURE__*/React.createElement("div", {
          className: styles$8['panel-statusbox']
        }));
      }) : /*#__PURE__*/React.createElement("div", null, !en.isLoading ? /*#__PURE__*/React.createElement(Text$1, {
        className: styles$8['loading-icon']
      }, "No Ranch") : /*#__PURE__*/React.createElement(LoadingOutlined, {
        className: styles$8['loading-icon']
      }))));
    }
    return null;
  });
};
EntityList.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  onChange: PropTypes.func,
  selected: PropTypes.shape({
    ranch: PropTypes.arrayOf(PropTypes.any),
    block: PropTypes.arrayOf(PropTypes.any)
  }),
  activeSelections: PropTypes.arrayOf(PropTypes.any)
};
EntityList.defaultProps = {
  data: [],
  onChange: null,
  selected: null,
  activeSelections: []
};

var styles$3 = {"gantt":"HighchartsSchedule_gantt__u8z1K","chart-div":"HighchartsSchedule_chart-div__bOQJq","loader":"HighchartsSchedule_loader__kwhDJ","capitalize":"HighchartsSchedule_capitalize__Orm6t","bell-icon-size":"HighchartsSchedule_bell-icon-size__nrj5I","bell-icon-button":"HighchartsSchedule_bell-icon-button__MWK-b","block-buttons":"HighchartsSchedule_block-buttons__lfMAY","override-alert":"HighchartsSchedule_override-alert__j1yJP","chart-container-div-style":"HighchartsSchedule_chart-container-div-style__oITXk","loading-block":"HighchartsSchedule_loading-block__JVj8h","loading-data":"HighchartsSchedule_loading-data__D49oX"};

NoDataToDisplay(Highcharts);
var defaultOptions$1 = function defaultOptions(t) {
  return {
    title: null,
    xAxis: {
      gridLineWidth: 1
    },
    yAxis: {
      gridLineWidth: 1
    },
    series: [],
    credits: {
      enabled: false
    },
    noData: {
      style: {
        fontWeight: 'bold',
        fontSize: '15px',
        color: '#303030'
      }
    },
    time: {
      useUTC: false
    }
  };
};
var ChartComponent = /*#__PURE__*/function (_React$Component) {
  function ChartComponent(props) {
    var _this;
    _classCallCheck(this, ChartComponent);
    _this = _callSuper(this, ChartComponent, [props]);
    _this.componentDidUpdate = function () {
      // NOTE: this is overkill and should be cleaned up
      // Force reflow to fix issue where graph does match parent size on load
      // need to call this.highchartsComponent.current.chart.reflow() on parent resize
      _this.forceReflow();
    };
    _this.forceReflow = function () {
      if (_this.highchartsComponent && _this.highchartsComponent.current) {
        _this.highchartsComponent.current.chart.reflow();
      }
    };
    _this.customCallback = function (param) {
      var callback = _this.props.callback;
      callback(param);
    };
    _this.highchartsComponent = /*#__PURE__*/React.createRef();
    return _this;
  }
  _inherits(ChartComponent, _React$Component);
  return _createClass(ChartComponent, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        options = _this$props.options,
        constructorType = _this$props.constructorType,
        chartRef = _this$props.chartRef,
        loading = _this$props.loading,
        t = _this$props.t;
      if (chartRef && this.highchartsComponent) {
        chartRef.current = this.highchartsComponent.current;
      }
      return /*#__PURE__*/React.createElement(HighchartsReact, {
        constructorType: constructorType || 'chart',
        containerProps: {
          className: styles$3['chart-container-div-style']
        },
        highcharts: constructorType === 'ganttChart' ? HighchartsGantt : Highcharts,
        options: _objectSpread2(_objectSpread2(_objectSpread2({}, defaultOptions$1()), options), {}, {
          lang: {
            noData: loading ? '' : t('No Data'),
            // ensures loading and "No data" don't overlap.
            loading: t('Loading...')
          }
        }),
        ref: this.highchartsComponent,
        callback: this.customCallback
      });
    }
  }]);
}(React.Component);
ChartComponent.propTypes = {
  options: PropTypes.shape({}),
  constructorType: PropTypes.string,
  chartRef: PropTypes.shape({
    current: PropTypes.any
  }),
  callback: PropTypes.func,
  loading: PropTypes.bool
};
ChartComponent.defaultProps = {
  options: null,
  constructorType: null,
  chartRef: null,
  callback: function callback() {},
  loading: false
};

var img = "data:image/gif;base64,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";

var selectEntitySidebarCollapseState = selectors.selectEntitySidebarCollapseState;
var HighchartsSchedule = function HighchartsSchedule(_ref) {
  var chartData = _ref.chartData,
    onClickChart = _ref.onClickChart,
    dates = _ref.dates,
    configChange = _ref.configChange;
  var chartRef = useRef(null);
  var renderTrigger = useRef(true); // To trigger the render and build config
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    options = _useState2[0],
    setOptions = _useState2[1];
  // variable to hold the processed chart data
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    series = _useState4[0],
    setSeries = _useState4[1];
  var sidebarCollapsed = useSelector(function (state) {
    return selectEntitySidebarCollapseState(state);
  }).payload;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var colors = {
    recommended: 'rgb(193, 218, 214)',
    past: 'rgb(232, 208, 169)',
    scheduled: 'lightblue'
  };
  var jsonKeys = {
    recommended_events: 'recommended',
    past_events: 'past',
    scheduled_events: 'scheduled'
  };

  // This will be removed in future after confirmation
  // const abbrFlow = (data) => {
  //   if (data) return `, ${data / 1000}k gal`;
  //   return '';
  // };

  // Currently used for comparing the dates in the series with props dates
  var equals = function equals(x, y) {
    return x.map(function (d, i) {
      return moment(d).isSame(moment(y[i]));
    }).reduce(function (a, p) {
      return a && p;
    }, true);
  };
  var divElement = document.querySelector('.schedule-chart-inner');
  var divHeight = divElement ? divElement.offsetHeight : null;
  // issue: ganttchart y-axis labels are overlapping in mobile screen
  // when there are more than 7 blocks are selected
  // Below height calculation will use to fix the issue.
  var height;
  if (divHeight && chartData && chartData[0] && chartData[0].selectedIrrigationTypes) {
    if (chartData[0].selectedIrrigationTypes.length) {
      var heightVal = chartData.length * chartData[0].selectedIrrigationTypes.length * 50;
      height = heightVal > divHeight ? heightVal : divHeight;
    } else height = divHeight;
  } else height = window.innerHeight / 1.6; // To handle the chart height issue

  /**
   * Function to build the config for the chart
   * It takes chartData and other required values to build config
   * @returns config object.
   */
  var buildChartConfig = useCallback(function () {
    function getAlarmListUrl(blockId) {
      var params = {
        blockId: blockId,
        logLevel: 'error',
        active: true
      };
      var paramStr = new URLSearchParams(params).toString();
      return "/events?".concat(paramStr);
    }
    function getControlPageUrl(blockId) {
      var params = {
        blockId: blockId
      };
      var paramStr = new URLSearchParams(params).toString();
      return "/control?".concat(paramStr);
    }
    function renderAlarmButton(block) {
      return /*#__PURE__*/React.createElement("a", {
        href: getAlarmListUrl(block.blockId)
      }, /*#__PURE__*/React.createElement(Badge, {
        count: block.blockAlarmCount
      }, /*#__PURE__*/React.createElement(Button, {
        className: styles$3['bell-icon-button'],
        icon: /*#__PURE__*/React.createElement(BellFilled, {
          className: styles$3['bell-icon-size']
        })
      })));
    }
    function renderOverrideNotice(block) {
      if (!block.overrideActive) return null;
      return /*#__PURE__*/React.createElement("a", {
        className: styles$3['override-alert'],
        href: getControlPageUrl(block.blockId)
      }, t('Override Active'));
    }
    function renderCategory(seriesObj) {
      if (seriesObj.name.includes('<img')) {
        return seriesObj.name;
      }
      var links = ReactDOMServer.renderToStaticMarkup(renderOverrideNotice(seriesObj.current));
      var buttons = ReactDOMServer.renderToStaticMarkup(/*#__PURE__*/React.createElement("div", {
        className: styles$3['block-buttons']
      }, renderAlarmButton(seriesObj.current)));
      return "".concat(seriesObj.name, "<br><span class=").concat(styles$3.capitalize, ">(").concat(seriesObj.current.irrigationType, ")</span><br>") + "".concat(links).concat(buttons);
    }
    var abbrDuration = function abbrDuration(duration) {
      var durationHr = duration.asHours();
      if (durationHr % 1 !== 0) return "".concat(durationHr.toFixed(1), " hrs");
      return "".concat(durationHr.toFixed(), " hrs");
    };
    var abbrPeriod = function abbrPeriod(data) {
      var duration = moment.duration(moment(data[1]).diff(moment(data[0])));
      return abbrDuration(duration);
    };

    /**
     * This will be called after chartData get processed
     * @param seriesData - Processed chartData
     * @returns the chartConfig as a result
     */
    function configBuild(seriesData) {
      var chartConfig;

      /**
       * condition to check the seriesData is valid by checking the length
       * Ex: blocks: [1] and selectedIrrigationTypes: ['scheduled', 'past']
       * Then the result data length will be 2
       */
      if (chartData.length * chartData[0].selectedIrrigationTypes.length === seriesData.length) {
        var xaxisDateFormat;
        var dateDiff;
        if (dates) {
          dateDiff = dates[1].diff(dates[0], 'days');
          if (dateDiff > 1 && dateDiff < 7) xaxisDateFormat = '%e %b %Y';else if (dateDiff > 7 && dateDiff <= 14) xaxisDateFormat = '%e %b';else if (dateDiff > 14) xaxisDateFormat = '%e';else if (!dateDiff) xaxisDateFormat = '%H:%M';else xaxisDateFormat = '%e %b %Y';
        }
        var xaxisOption;
        if (dates) {
          xaxisOption = [{
            tickInterval: dateDiff ? 1000 * 60 * 60 * 24 : 3600 * 1000,
            type: 'datetime',
            min: dates[0].valueOf(),
            max: dates[1].valueOf(),
            currentDateIndicator: true,
            dateTimeLabelFormats: {
              day: xaxisDateFormat
            }
          }, {
            startOfWeek: 0
          }];
        } else {
          xaxisOption = [{
            currentDateIndicator: true,
            grid: {
              cellHeight: 60
            }
          }, {
            startOfWeek: 0
          }];
        }
        var numSeries = seriesData.length;
        var minHeight = numSeries * 100 + 120; // extra 120 is header height
        var chartHeight = minHeight > height ? minHeight : height;
        chartConfig = {
          series: seriesData,
          chart: {
            marginLeft: 130,
            animation: false,
            height: height ? "".concat(chartHeight, "px") : 'calc(100vh - 100%)',
            reflow: true,
            events: {
              click: function click(e) {
                if (global.chartYaxisCategories.length > 0) {
                  var clickObj = global.chartYaxisCategories[Math.abs(Math.round(e.yAxis[0].value))];
                  if (clickObj) {
                    clickObj.startDate = moment(e.xAxis[0].value);
                    clickObj.irrigationType = global.chartYaxisCategoryTypes[Math.abs(Math.round(e.yAxis[0].value))];
                    onClickChart(clickObj);
                  }
                }
              }
            }
          },
          plotOptions: {
            series: {
              /**
               * Link: https://api.highcharts.com/gantt/plotOptions.series.animation
               * To handle the label flickering
               */
              animation: {
                defer: 0,
                duration: 0
              },
              dataLabels: {
                enabled: true,
                format: '{point.runtime}',
                style: {
                  cursor: 'default',
                  pointerEvents: 'none',
                  color: 'black'
                }
              },
              states: {
                select: {
                  color: '',
                  borderColor: 'none'
                }
              },
              allowPointSelect: true,
              point: {
                events: {
                  click: function click(e) {
                    onClickChart({
                      scheduleId: e.point.options.schId,
                      blockId: e.point.options.blkId
                    });
                    if (chartRef.current) {
                      var chart = chartRef.current.chart;
                      if (chart) chart.tooltip.hide();
                    }
                  }
                }
              }
            }
          },
          tooltip: {
            pointFormat: '<span>Run Time: {point.runtime}</span><br/>'
            // + '<span>Acre in: {point.acrein}</span><br/>'
            + '<span>From: {point.start:%Y-%m-%d %H:%M:%S}</span><br/>' + '<span>To: {point.end:%Y-%m-%d %H:%M:%S}</span><br/>' + '<span>Total runtime (in view): {point.totalRuntime}</span><br/>'
            // + '<span>Season Acre in: {point.seasonAcrein}</span>',
          },
          xAxis: xaxisOption,
          yAxis: {
            type: 'category',
            labels: {
              useHTML: true,
              style: {
                width: '90px',
                minWidth: '90px',
                textAlign: 'center',
                paddingTop: '10px',
                paddingBottom: '10px'
              }
            },
            grid: {
              columns: [{
                title: {
                  text: t('Blocks')
                },
                categories: seriesData.map(function (s) {
                  return renderCategory(s);
                })
              }]
            }
          }
        };
      }
      return chartConfig;
    }
    var defaultOption;
    if (renderTrigger.current) {
      var seriesData = [];
      var count = 0;
      var yHeight = 0;
      global.chartYaxisCategories = [];
      global.chartYaxisCategoryTypes = [];
      // for each object in chartData, i
      chartData.forEach(function (block, i) {
        // for each IrrigationType, j
        Object.keys(jsonKeys).forEach(function (irrgType, j) {
          // get events array
          var irrgEventArr = block[irrgType];
          var obj = {};
          // set date
          obj.selectedDates = dates;
          // set name
          obj.name = block.name ? block.name : "<img id=".concat(styles$3['loading-block'], " src=").concat(img, " alt=\"Loading...\" />");
          // push name to categories
          if (block.selectedIrrigationTypes && block.selectedIrrigationTypes.includes(jsonKeys[irrgType])) {
            global.chartYaxisCategories.push({
              name: block.name,
              id: block.id,
              startDate: null
            });
            global.chartYaxisCategoryTypes.push(jsonKeys[irrgType]);
          }
          var pumpOverride = block.blockControlStatus && block.blockControlStatus.vfdStatus && block.blockControlStatus.vfdStatus.overrideStatus;
          var valveOverride = block.blockControlStatus && block.blockControlStatus.valveStatus && block.blockControlStatus.valveStatus.overrideStatus;
          var overrideActive = !!(valveOverride || pumpOverride);

          // set current object with values
          obj.current = {
            name: block.name,
            irrigationType: jsonKeys[irrgType],
            blockId: block.id,
            blockAlarmCount: block.blockControlStatus && block.blockControlStatus.valveStatus && block.blockControlStatus.valveStatus.blockAlarmCount,
            overrideActive: overrideActive
          };
          obj.current.irrigationType = jsonKeys[irrgType];
          if (irrgType === 'recommended_events') {
            obj.current.totalRuntime = block.totalRuntimeRecommended;
          } else if (irrgType === 'scheduled_events') {
            obj.current.totalRuntime = block.totalRuntimeScheduled;
          } else if (irrgType === 'past_events') {
            obj.current.totalRuntime = block.totalRuntimePast;
          }
          obj.data = [];
          if (!irrgEventArr || !irrgEventArr.length) {
            // set data with array of object with values
            if (block.selectedIrrigationTypes && block.selectedIrrigationTypes.includes(jsonKeys[irrgType])) {
              obj.data.push({
                id: "block-".concat(count),
                y: yHeight
              });
              count += 1;
              seriesData.push(obj);
              yHeight += 1;
            }
          }
          if (irrgEventArr) {
            if (irrgEventArr.length > 0) {
              // set data with array of object with values
              irrgEventArr.forEach(function (event) {
                obj.data.push({
                  id: "block-".concat(count),
                  schId: event.id,
                  blkId: block.id,
                  runtime: abbrPeriod([event.start_date, event.stop_date]),
                  // totalRuntime: abbrDuration(obj.current.totalRuntime),
                  flow: event.flow,
                  start: Date.parse(event.start_date),
                  end: Date.parse(event.stop_date),
                  y: yHeight,
                  color: colors[jsonKeys[irrgType]]
                });
                count += 1;
              });
              seriesData.push(obj);
              yHeight += 1;
            }
          }
          // Condition to set the processed data to state once it done
          if (chartData.length === i + 1 && Object.keys(jsonKeys).length === j + 1) {
            setSeries(seriesData);
            defaultOption = configBuild(seriesData);
          }
        });
      });
    }
    return defaultOption;
  }, [chartData, t, jsonKeys, colors, dates, height, onClickChart]);

  // To trigger the buildChartConfig when the chartData/dates get changed
  useEffect(function () {
    if (!renderTrigger.current && (chartData.length * (chartData[0] && chartData[0].selectedIrrigationTypes || []).length !== series.length || series.length && !equals(series[0].selectedDates, dates))) {
      renderTrigger.current = true;
    }
  }, [chartData, dates, series]);

  /**
   * Calls the buildChartConfig() function to set options to state
   * Also sets the 'false' to renderTrigger to avoid repeated calls
   */
  useEffect(function () {
    if (renderTrigger.current && !configChange) {
      var config = buildChartConfig();
      if (config) {
        renderTrigger.current = false;
        setOptions(config);
      }
    }
  }, [buildChartConfig, configChange]);
  useEffect(function () {
    if (chartRef.current && divHeight && window.innerWidth > 599) {
      // 20 -> element padding, 320 -> entitySideBar width
      var width = window.innerWidth - 20;
      if (!sidebarCollapsed) {
        chartRef.current.chart.setSize(width - 320, divHeight, false);
      } else {
        chartRef.current.chart.setSize(width, divHeight, false);
      }
    }
  }, [divHeight, sidebarCollapsed]);
  useEffect(function () {
    var interval = setInterval(function () {
      if (chartRef.current && chartRef.current.chart) chartRef.current.chart.redraw();
    }, 60000);
    return function () {
      clearInterval(interval);
    };
  }, []);

  // Below code will be removed in future after confirmation
  // if (chartRef.current) {
  //   const { chart } = chartRef.current;
  //   // highcharts API for loading: https://api.highcharts.com/highcharts/loading
  //   // default: Loading
  //   // Spinner instead of Loading texs: https://stackoverflow.com/questions/12148276/highcharts-how-to-show-loading-animation-at-set-data
  //   chart.showLoading(`<img id=${styles.loadingData} src=${image} alt="Loading..." />`);
  //   setTimeout(() => chart.hideLoading(), 1500);
  // }

  window.onresize = function onresize() {
    var chartContainer = document.querySelector('.schedule-chart-outer');
    if (chartContainer) {
      var width = chartContainer.clientWidth;
      var boxheight = chartContainer.clientHeight;
      if (chartRef.current) {
        var chart = chartRef.current.chart;
        // - The third args is an animation set to true.
        if (boxheight > 400) {
          if (boxheight > height) chart.setSize(width, boxheight, false);else chart.setSize(width, height, false);
        }
      }
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: styles$3['chart-div']
  }, options ? /*#__PURE__*/React.createElement(ChartComponent, {
    constructorType: "ganttChart",
    options: options,
    chartRef: chartRef,
    t: t
  }) : null, renderTrigger.current ? /*#__PURE__*/React.createElement(LoadingOutlined, {
    className: styles$3.loader
  }) : null);
};
HighchartsSchedule.propTypes = {
  chartData: PropTypes.arrayOf(PropTypes.any),
  dates: PropTypes.arrayOf(PropTypes.object),
  onClickChart: PropTypes.func,
  configChange: PropTypes.bool
};
HighchartsSchedule.defaultProps = {
  chartData: null,
  dates: null,
  onClickChart: function onClickChart() {
    return null;
  },
  configChange: null
};

var styles$2 = {"container":"InputStyles_container__JsrAJ","left-half":"InputStyles_left-half__EEIQ7","right-half":"InputStyles_right-half__wxCV1","form-container":"InputStyles_form-container__fXYvi","ant-btn":"InputStyles_ant-btn__-igY4","update-form-buttons":"InputStyles_update-form-buttons__Sf9xO","error-text":"InputStyles_error-text__xlXVw"};

function InputNumberUnits(props) {
  var disabled = props.disabled,
    initialValue = props.initialValue,
    onChange = props.onChange,
    unitOptions = props.unitOptions;
  var _useState = useState(unitOptions && unitOptions[0] && unitOptions[0].key || ''),
    _useState2 = _slicedToArray(_useState, 2),
    units = _useState2[0],
    setUnits = _useState2[1];
  var _useState3 = useState(initialValue || 0),
    _useState4 = _slicedToArray(_useState3, 2),
    value = _useState4[0],
    setValue = _useState4[1];
  function onUnitsChange(newUnits) {
    setUnits(newUnits);
    if (onChange) {
      onChange({
        value: value,
        units: newUnits
      });
    }
  }
  function onValueChange(newValue) {
    setValue(newValue);
    if (onChange) {
      onChange({
        value: newValue,
        units: units
      });
    }
  }
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("section", {
    className: styles$2.container
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$2['left-half']
  }, /*#__PURE__*/React.createElement(InputNumber, {
    value: value,
    onChange: onValueChange,
    disabled: disabled,
    style: {
      width: '100%'
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: styles$2['right-half']
  }, /*#__PURE__*/React.createElement(Select, {
    value: units,
    onChange: onUnitsChange,
    disabled: disabled
  }, unitOptions.map(function (option) {
    return /*#__PURE__*/React.createElement(Select.Option, {
      key: option.key,
      value: option.key
    }, option.name);
  })))));
}
InputNumberUnits.propTypes = {
  unitOptions: PropTypes.arrayOf(PropTypes.object).isRequired,
  disabled: PropTypes.bool,
  initialValue: PropTypes.number,
  onChange: PropTypes.func
};
InputNumberUnits.defaultProps = {
  disabled: false,
  initialValue: 0,
  onChange: null
};

var timeUnits = [{
  key: 'minutes',
  name: 'Minutes'
}, {
  key: 'hours',
  name: 'Hours'
}];
function InputTime(props) {
  var disabled = props.disabled,
    initialValue = props.initialValue,
    onChange = props.onChange;
  return /*#__PURE__*/React.createElement(InputNumberUnits, {
    unitOptions: timeUnits,
    onChange: onChange,
    disabled: disabled,
    initialValue: initialValue
  });
}
InputTime.propTypes = {
  disabled: PropTypes.bool,
  initialValue: PropTypes.number,
  onChange: PropTypes.func
};
InputTime.defaultProps = {
  onChange: null,
  disabled: false,
  initialValue: 0
};

var volumeUnits = [{
  key: 'acrein',
  name: 'acre inches'
}, {
  key: 'cuft',
  name: 'cubic feet'
}];
function InputVolume(props) {
  var disabled = props.disabled,
    initialValue = props.initialValue,
    onChange = props.onChange;
  return /*#__PURE__*/React.createElement(InputNumberUnits, {
    unitOptions: volumeUnits,
    onChange: onChange,
    disabled: disabled,
    initialValue: initialValue
  });
}
InputVolume.propTypes = {
  disabled: PropTypes.bool,
  initialValue: PropTypes.number,
  onChange: PropTypes.func
};
InputVolume.defaultProps = {
  disabled: false,
  initialValue: 0,
  onChange: null
};

function MapSettingsMenu(_ref) {
  var renderItemShowLabels = _ref.renderItemShowLabels,
    renderItemPresentationMode = _ref.renderItemPresentationMode,
    onChangePresentationMode = _ref.onChangePresentationMode,
    showLabels = _ref.showLabels,
    toggleShowLabels = _ref.toggleShowLabels;
  return /*#__PURE__*/React.createElement(Menu, {
    className: "settings-menu",
    selectable: false
  }, renderItemPresentationMode && /*#__PURE__*/React.createElement(Menu.Item, {
    key: "1"
  }, /*#__PURE__*/React.createElement(Select, {
    defaultValue: "connectivity",
    style: {
      width: 140
      // position: 'absolute',
      // zIndex: 1,
      // top: 10,
      // left: 10,
    },
    onChange: onChangePresentationMode,
    "data-test-id": "presentationmode-select"
  }, /*#__PURE__*/React.createElement(Select.Option, {
    value: "connectivity",
    className: "presentationmode-option-connectivity"
  }, "Connectivity"), /*#__PURE__*/React.createElement(Select.Option, {
    value: "waterpressure",
    className: "presentationmode-option-waterpressure"
  }, "Water Pressure"), /*#__PURE__*/React.createElement(Select.Option, {
    value: "provision",
    className: "presentationmode-option-provision"
  }, "Provision"))), renderItemShowLabels && /*#__PURE__*/React.createElement(Menu.Item, {
    key: "2"
  }, /*#__PURE__*/React.createElement("span", null, "Show Labels:"), /*#__PURE__*/React.createElement(Switch, {
    checked: showLabels,
    onChange: toggleShowLabels,
    className: "switch-toggle-labels"
  })));
}
MapSettingsMenu.propTypes = {
  renderItemShowLabels: PropTypes.bool.isRequired,
  renderItemPresentationMode: PropTypes.bool.isRequired,
  onChangePresentationMode: PropTypes.func.isRequired,
  showLabels: PropTypes.bool.isRequired,
  toggleShowLabels: PropTypes.func.isRequired
};

/* eslint-disable */
/*
 * Modified version of Leaflet.markercluster
 * Source for the original can be found here https://github.com/Leaflet/Leaflet.markercluster
 * Leaflet.markercluster 1.4.1+master.94f9815,
 * Provides Beautiful Animated Marker Clustering functionality for Leaflet, a JS library for interactive maps.
 * (c) 2012-2017, Dave Leaver, smartrak
 */

/*global L*/

function leafletMarkerClusterGroup(L) {
  if (L.MarkerClusterGroup) {
    return;
  }
  /*
   * L.MarkerClusterGroup extends L.FeatureGroup by clustering the markers contained within
   */

  L.MarkerClusterGroup = L.FeatureGroup.extend({
    options: {
      maxClusterRadius: 80,
      //A cluster will cover at most this many pixels from its center
      iconCreateFunction: null,
      clusterPane: L.Marker.prototype.options.pane,
      spiderfyOnMaxZoom: true,
      showCoverageOnHover: true,
      zoomToBoundsOnClick: true,
      singleMarkerMode: false,
      // callback to determine if should spiderfy vs cluster
      shouldSpiderfy: null,
      unspiderfyOnMapClick: true,
      disableClusteringAtZoom: null,
      // Setting this to false prevents the removal of any clusters outside of the viewpoint, which
      // is the default behaviour for performance reasons.
      removeOutsideVisibleBounds: true,
      // Set to false to disable all animations (zoom and spiderfy).
      // If false, option animateAddingMarkers below has no effect.
      // If L.DomUtil.TRANSITION is falsy, this option has no effect.
      animate: true,
      //Whether to animate adding markers after adding the MarkerClusterGroup to the map
      // If you are adding individual markers set to true, if adding bulk markers leave false for massive performance gains.
      animateAddingMarkers: false,
      //Increase to increase the distance away that spiderfied markers appear from the center
      spiderfyDistanceMultiplier: 1,
      // Make it possible to specify a polyline options on a spider leg
      spiderLegPolylineOptions: {
        weight: 1.5,
        color: '#222',
        opacity: 0.5
      },
      // When bulk adding layers, adds markers in chunks. Means addLayers may not add all the layers in the call, others will be loaded during setTimeouts
      chunkedLoading: false,
      chunkInterval: 200,
      // process markers for a maximum of ~ n milliseconds (then trigger the chunkProgress callback)
      chunkDelay: 50,
      // at the end of each interval, give n milliseconds back to system/browser
      chunkProgress: null,
      // progress callback: function(processed, total, elapsed) (e.g. for a progress indicator)

      //Options to pass to the L.Polygon constructor
      polygonOptions: {}
    },
    initialize: function initialize(options) {
      L.Util.setOptions(this, options);
      if (!this.options.iconCreateFunction) {
        this.options.iconCreateFunction = this._defaultIconCreateFunction;
      }
      this._featureGroup = L.featureGroup();
      this._featureGroup.addEventParent(this);
      this._nonPointGroup = L.featureGroup();
      this._nonPointGroup.addEventParent(this);
      this._inZoomAnimation = 0;
      this._needsClustering = [];
      this._needsRemoving = []; //Markers removed while we aren't on the map need to be kept track of
      //The bounds of the currently shown area (from _getExpandedVisibleBounds) Updated on zoom/move
      this._currentShownBounds = null;
      this._queue = [];
      this._childMarkerEventHandlers = {
        'dragstart': this._childMarkerDragStart,
        'move': this._childMarkerMoved,
        'dragend': this._childMarkerDragEnd
      };

      // Hook the appropriate animation methods.
      var animate = L.DomUtil.TRANSITION && this.options.animate;
      L.extend(this, animate ? this._withAnimation : this._noAnimation);
      // Remember which MarkerCluster class to instantiate (animated or not).
      this._markerCluster = animate ? L.MarkerCluster : L.MarkerClusterNonAnimated;
    },
    refresh: function refresh() {
      this._topClusterLevel._recursivelySpiderfy(this._map._zoom, this._currentShownBounds, this.options.shouldSpiderfy);
      this._topClusterLevel._recursivelyRemoveChildrenFromMap(this._currentShownBounds, this._zoom, this._currentShownBounds);
      this._topClusterLevel._recursivelyAddChildrenToMap(null, this._map._zoom, this._currentShownBounds);
    },
    addLayer: function addLayer(layer) {
      if (layer instanceof L.LayerGroup) {
        return this.addLayers([layer]);
      }

      //Don't cluster non point data
      if (!layer.getLatLng) {
        this._nonPointGroup.addLayer(layer);
        this.fire('layeradd', {
          layer: layer
        });
        return this;
      }
      if (!this._map) {
        this._needsClustering.push(layer);
        this.fire('layeradd', {
          layer: layer
        });
        return this;
      }
      if (this.hasLayer(layer)) {
        return this;
      }

      //If we have already clustered we'll need to add this one to a cluster

      if (this._unspiderfy) {
        this._unspiderfy();
      }
      this._addLayer(layer, this._maxZoom);
      this.fire('layeradd', {
        layer: layer
      });

      // Refresh bounds and weighted positions.
      this._topClusterLevel._recalculateBounds();
      this._refreshClustersIcons();

      //Work out what is visible
      var visibleLayer = layer,
        currentZoom = this._zoom;
      if (layer.__parent) {
        while (visibleLayer.__parent._zoom >= currentZoom) {
          visibleLayer = visibleLayer.__parent;
        }
      }
      if (this._currentShownBounds.contains(visibleLayer.getLatLng())) {
        if (this.options.animateAddingMarkers) {
          this._animationAddLayer(layer, visibleLayer);
        } else {
          this._animationAddLayerNonAnimated(layer, visibleLayer);
        }
      }
      return this;
    },
    removeLayer: function removeLayer(layer) {
      if (layer instanceof L.LayerGroup) {
        return this.removeLayers([layer]);
      }

      //Non point layers
      if (!layer.getLatLng) {
        this._nonPointGroup.removeLayer(layer);
        this.fire('layerremove', {
          layer: layer
        });
        return this;
      }
      if (!this._map) {
        if (!this._arraySplice(this._needsClustering, layer) && this.hasLayer(layer)) {
          this._needsRemoving.push({
            layer: layer,
            latlng: layer._latlng
          });
        }
        this.fire('layerremove', {
          layer: layer
        });
        return this;
      }
      if (!layer.__parent) {
        return this;
      }
      if (this._unspiderfy) {
        this._unspiderfy();
        this._unspiderfyLayer(layer);
      }

      //Remove the marker from clusters
      this._removeLayer(layer, true);
      this.fire('layerremove', {
        layer: layer
      });

      // Refresh bounds and weighted positions.
      this._topClusterLevel._recalculateBounds();
      this._refreshClustersIcons();
      layer.off(this._childMarkerEventHandlers, this);
      if (this._featureGroup.hasLayer(layer)) {
        this._featureGroup.removeLayer(layer);
        if (layer.clusterShow) {
          layer.clusterShow();
        }
      }
      return this;
    },
    //Takes an array of markers and adds them in bulk
    addLayers: function addLayers(layersArray, skipLayerAddEvent) {
      if (!L.Util.isArray(layersArray)) {
        return this.addLayer(layersArray);
      }
      var fg = this._featureGroup,
        npg = this._nonPointGroup,
        chunked = this.options.chunkedLoading,
        chunkInterval = this.options.chunkInterval,
        chunkProgress = this.options.chunkProgress,
        l = layersArray.length,
        offset = 0,
        originalArray = true,
        m;
      if (this._map) {
        var started = new Date().getTime();
        var process = L.bind(function () {
          var start = new Date().getTime();
          for (; offset < l; offset++) {
            if (chunked && offset % 200 === 0) {
              // every couple hundred markers, instrument the time elapsed since processing started:
              var elapsed = new Date().getTime() - start;
              if (elapsed > chunkInterval) {
                break; // been working too hard, time to take a break :-)
              }
            }
            m = layersArray[offset];

            // Group of layers, append children to layersArray and skip.
            // Side effects:
            // - Total increases, so chunkProgress ratio jumps backward.
            // - Groups are not included in this group, only their non-group child layers (hasLayer).
            // Changing array length while looping does not affect performance in current browsers:
            // http://jsperf.com/for-loop-changing-length/6
            if (m instanceof L.LayerGroup) {
              if (originalArray) {
                layersArray = layersArray.slice();
                originalArray = false;
              }
              this._extractNonGroupLayers(m, layersArray);
              l = layersArray.length;
              continue;
            }

            //Not point data, can't be clustered
            if (!m.getLatLng) {
              npg.addLayer(m);
              if (!skipLayerAddEvent) {
                this.fire('layeradd', {
                  layer: m
                });
              }
              continue;
            }
            if (this.hasLayer(m)) {
              continue;
            }
            this._addLayer(m, this._maxZoom);
            if (!skipLayerAddEvent) {
              this.fire('layeradd', {
                layer: m
              });
            }

            //If we just made a cluster of size 2 then we need to remove the other marker from the map (if it is) or we never will
            if (m.__parent) {
              if (m.__parent.getChildCount() === 2) {
                var markers = m.__parent.getAllChildMarkers(),
                  otherMarker = markers[0] === m ? markers[1] : markers[0];
                fg.removeLayer(otherMarker);
              }
            }
          }
          if (chunkProgress) {
            // report progress and time elapsed:
            chunkProgress(offset, l, new Date().getTime() - started);
          }

          // Completed processing all markers.
          if (offset === l) {
            // Refresh bounds and weighted positions.
            this._topClusterLevel._recalculateBounds();
            this._refreshClustersIcons();
            this._topClusterLevel._recursivelyAddChildrenToMap(null, this._zoom, this._currentShownBounds);
          } else {
            setTimeout(process, this.options.chunkDelay);
          }
        }, this);
        process();
      } else {
        var needsClustering = this._needsClustering;
        for (; offset < l; offset++) {
          m = layersArray[offset];

          // Group of layers, append children to layersArray and skip.
          if (m instanceof L.LayerGroup) {
            if (originalArray) {
              layersArray = layersArray.slice();
              originalArray = false;
            }
            this._extractNonGroupLayers(m, layersArray);
            l = layersArray.length;
            continue;
          }

          //Not point data, can't be clustered
          if (!m.getLatLng) {
            npg.addLayer(m);
            continue;
          }
          if (this.hasLayer(m)) {
            continue;
          }
          needsClustering.push(m);
        }
      }
      return this;
    },
    //Takes an array of markers and removes them in bulk
    removeLayers: function removeLayers(layersArray) {
      var i,
        m,
        l = layersArray.length,
        fg = this._featureGroup,
        npg = this._nonPointGroup,
        originalArray = true;
      if (!this._map) {
        for (i = 0; i < l; i++) {
          m = layersArray[i];

          // Group of layers, append children to layersArray and skip.
          if (m instanceof L.LayerGroup) {
            if (originalArray) {
              layersArray = layersArray.slice();
              originalArray = false;
            }
            this._extractNonGroupLayers(m, layersArray);
            l = layersArray.length;
            continue;
          }
          this._arraySplice(this._needsClustering, m);
          npg.removeLayer(m);
          if (this.hasLayer(m)) {
            this._needsRemoving.push({
              layer: m,
              latlng: m._latlng
            });
          }
          this.fire('layerremove', {
            layer: m
          });
        }
        return this;
      }
      if (this._unspiderfy) {
        this._unspiderfy();

        // Work on a copy of the array, so that next loop is not affected.
        var layersArray2 = layersArray.slice(),
          l2 = l;
        for (i = 0; i < l2; i++) {
          m = layersArray2[i];

          // Group of layers, append children to layersArray and skip.
          if (m instanceof L.LayerGroup) {
            this._extractNonGroupLayers(m, layersArray2);
            l2 = layersArray2.length;
            continue;
          }
          this._unspiderfyLayer(m);
        }
      }
      for (i = 0; i < l; i++) {
        m = layersArray[i];

        // Group of layers, append children to layersArray and skip.
        if (m instanceof L.LayerGroup) {
          if (originalArray) {
            layersArray = layersArray.slice();
            originalArray = false;
          }
          this._extractNonGroupLayers(m, layersArray);
          l = layersArray.length;
          continue;
        }
        if (!m.__parent) {
          npg.removeLayer(m);
          this.fire('layerremove', {
            layer: m
          });
          continue;
        }
        this._removeLayer(m, true, true);
        this.fire('layerremove', {
          layer: m
        });
        if (fg.hasLayer(m)) {
          fg.removeLayer(m);
          if (m.clusterShow) {
            m.clusterShow();
          }
        }
      }

      // Refresh bounds and weighted positions.
      this._topClusterLevel._recalculateBounds();
      this._refreshClustersIcons();

      //Fix up the clusters and markers on the map
      this._topClusterLevel._recursivelyAddChildrenToMap(null, this._zoom, this._currentShownBounds);
      return this;
    },
    //Removes all layers from the MarkerClusterGroup
    clearLayers: function clearLayers() {
      //Need our own special implementation as the LayerGroup one doesn't work for us

      //If we aren't on the map (yet), blow away the markers we know of
      if (!this._map) {
        this._needsClustering = [];
        this._needsRemoving = [];
        delete this._gridClusters;
        delete this._gridUnclustered;
      }
      if (this._noanimationUnspiderfy) {
        this._noanimationUnspiderfy();
      }

      //Remove all the visible layers
      this._featureGroup.clearLayers();
      this._nonPointGroup.clearLayers();
      this.eachLayer(function (marker) {
        marker.off(this._childMarkerEventHandlers, this);
        delete marker.__parent;
      }, this);
      if (this._map) {
        //Reset _topClusterLevel and the DistanceGrids
        this._generateInitialClusters();
      }
      return this;
    },
    //Override FeatureGroup.getBounds as it doesn't work
    getBounds: function getBounds() {
      var bounds = new L.LatLngBounds();
      if (this._topClusterLevel) {
        bounds.extend(this._topClusterLevel._bounds);
      }
      for (var i = this._needsClustering.length - 1; i >= 0; i--) {
        bounds.extend(this._needsClustering[i].getLatLng());
      }
      bounds.extend(this._nonPointGroup.getBounds());
      return bounds;
    },
    //Overrides LayerGroup.eachLayer
    eachLayer: function eachLayer(method, context) {
      var markers = this._needsClustering.slice(),
        needsRemoving = this._needsRemoving,
        thisNeedsRemoving,
        i,
        j;
      if (this._topClusterLevel) {
        this._topClusterLevel.getAllChildMarkers(markers);
      }
      for (i = markers.length - 1; i >= 0; i--) {
        thisNeedsRemoving = true;
        for (j = needsRemoving.length - 1; j >= 0; j--) {
          if (needsRemoving[j].layer === markers[i]) {
            thisNeedsRemoving = false;
            break;
          }
        }
        if (thisNeedsRemoving) {
          method.call(context, markers[i]);
        }
      }
      this._nonPointGroup.eachLayer(method, context);
    },
    //Overrides LayerGroup.getLayers
    getLayers: function getLayers() {
      var layers = [];
      this.eachLayer(function (l) {
        layers.push(l);
      });
      return layers;
    },
    //Overrides LayerGroup.getLayer, WARNING: Really bad performance
    getLayer: function getLayer(id) {
      var result = null;
      id = parseInt(id, 10);
      this.eachLayer(function (l) {
        if (L.stamp(l) === id) {
          result = l;
        }
      });
      return result;
    },
    //Returns true if the given layer is in this MarkerClusterGroup
    hasLayer: function hasLayer(layer) {
      if (!layer) {
        return false;
      }
      var i,
        anArray = this._needsClustering;
      for (i = anArray.length - 1; i >= 0; i--) {
        if (anArray[i] === layer) {
          return true;
        }
      }
      anArray = this._needsRemoving;
      for (i = anArray.length - 1; i >= 0; i--) {
        if (anArray[i].layer === layer) {
          return false;
        }
      }
      return !!(layer.__parent && layer.__parent._group === this) || this._nonPointGroup.hasLayer(layer);
    },
    //Zoom down to show the given layer (spiderfying if necessary) then calls the callback
    zoomToShowLayer: function zoomToShowLayer(layer, callback) {
      if (typeof callback !== 'function') {
        callback = function callback() {};
      }
      var _showMarker = function showMarker() {
        if ((layer._icon || layer.__parent._icon) && !this._inZoomAnimation) {
          this._map.off('moveend', _showMarker, this);
          this.off('animationend', _showMarker, this);
          if (layer._icon) {
            callback();
          } else if (layer.__parent._icon) {
            this.once('spiderfied', callback, this);
            layer.__parent.spiderfy();
          }
        }
      };
      if (layer._icon && this._map.getBounds().contains(layer.getLatLng())) {
        //Layer is visible ond on screen, immediate return
        callback();
      } else if (layer.__parent._zoom < this._map._zoom) {
        //Layer should be visible at this zoom level. It must not be on screen so just pan over to it
        this._map.on('moveend', _showMarker, this);
        this._map.panTo(layer.getLatLng());
      } else {
        this._map.on('moveend', _showMarker, this);
        this.on('animationend', _showMarker, this);
        layer.__parent.zoomToBounds();
      }
    },
    //Overrides FeatureGroup.onAdd
    onAdd: function onAdd(map) {
      this._map = map;
      var i, l, layer;
      if (!isFinite(this._map.getMaxZoom())) {
        throw "Map has no maxZoom specified";
      }
      this._featureGroup.addTo(map);
      this._nonPointGroup.addTo(map);
      if (!this._gridClusters) {
        this._generateInitialClusters();
      }
      this._maxLat = map.options.crs.projection.MAX_LATITUDE;

      //Restore all the positions as they are in the MCG before removing them
      for (i = 0, l = this._needsRemoving.length; i < l; i++) {
        layer = this._needsRemoving[i];
        layer.newlatlng = layer.layer._latlng;
        layer.layer._latlng = layer.latlng;
      }
      //Remove them, then restore their new positions
      for (i = 0, l = this._needsRemoving.length; i < l; i++) {
        layer = this._needsRemoving[i];
        this._removeLayer(layer.layer, true);
        layer.layer._latlng = layer.newlatlng;
      }
      this._needsRemoving = [];

      //Remember the current zoom level and bounds
      this._zoom = this._map._zoom;
      this._currentShownBounds = this._getExpandedVisibleBounds();
      this._map.on('zoomend', this._zoomEnd, this);
      this._map.on('moveend', this._moveEnd, this);
      if (this._spiderfierOnAdd) {
        //TODO FIXME: Not sure how to have spiderfier add something on here nicely
        this._spiderfierOnAdd();
      }
      this._bindEvents();

      //Actually add our markers to the map:
      l = this._needsClustering;
      this._needsClustering = [];
      this.addLayers(l, true);
      this._topClusterLevel._recursivelySpiderfy(this._map._zoom, this._currentShownBounds, this.options.shouldSpiderfy);
    },
    //Overrides FeatureGroup.onRemove
    onRemove: function onRemove(map) {
      map.off('zoomend', this._zoomEnd, this);
      map.off('moveend', this._moveEnd, this);
      this._unbindEvents();

      //In case we are in a cluster animation
      this._map._mapPane.className = this._map._mapPane.className.replace(' leaflet-cluster-anim', '');
      if (this._spiderfierOnRemove) {
        //TODO FIXME: Not sure how to have spiderfier add something on here nicely
        this._spiderfierOnRemove();
      }
      delete this._maxLat;

      //Clean up all the layers we added to the map
      this._hideCoverage();
      this._featureGroup.remove();
      this._nonPointGroup.remove();
      this._featureGroup.clearLayers();
      this._map = null;
    },
    getVisibleParent: function getVisibleParent(marker) {
      var vMarker = marker;
      while (vMarker && !vMarker._icon) {
        vMarker = vMarker.__parent;
      }
      return vMarker || null;
    },
    //Remove the given object from the given array
    _arraySplice: function _arraySplice(anArray, obj) {
      for (var i = anArray.length - 1; i >= 0; i--) {
        if (anArray[i] === obj) {
          anArray.splice(i, 1);
          return true;
        }
      }
    },
    /**
     * Removes a marker from all _gridUnclustered zoom levels, starting at the supplied zoom.
     * @param marker to be removed from _gridUnclustered.
     * @param z integer bottom start zoom level (included)
     * @private
     */
    _removeFromGridUnclustered: function _removeFromGridUnclustered(marker, z) {
      var map = this._map,
        gridUnclustered = this._gridUnclustered,
        minZoom = Math.floor(this._map.getMinZoom());
      for (; z >= minZoom; z--) {
        if (!gridUnclustered[z].removeObject(marker, map.project(marker.getLatLng(), z))) {
          break;
        }
      }
    },
    _childMarkerDragStart: function _childMarkerDragStart(e) {
      e.target.__dragStart = e.target._latlng;
    },
    _childMarkerMoved: function _childMarkerMoved(e) {
      if (!this._ignoreMove && !e.target.__dragStart) {
        var isPopupOpen = e.target._popup && e.target._popup.isOpen();
        this._moveChild(e.target, e.oldLatLng, e.latlng);
        if (isPopupOpen) {
          e.target.openPopup();
        }
      }
    },
    _moveChild: function _moveChild(layer, from, to) {
      layer._latlng = from;
      this.removeLayer(layer);
      layer._latlng = to;
      this.addLayer(layer);
    },
    _childMarkerDragEnd: function _childMarkerDragEnd(e) {
      var dragStart = e.target.__dragStart;
      delete e.target.__dragStart;
      if (dragStart) {
        this._moveChild(e.target, dragStart, e.target._latlng);
      }
    },
    //Internal function for removing a marker from everything.
    //dontUpdateMap: set to true if you will handle updating the map manually (for bulk functions)
    _removeLayer: function _removeLayer(marker, removeFromDistanceGrid, dontUpdateMap) {
      var gridClusters = this._gridClusters,
        gridUnclustered = this._gridUnclustered,
        fg = this._featureGroup,
        map = this._map,
        minZoom = Math.floor(this._map.getMinZoom());

      //Remove the marker from distance clusters it might be in
      if (removeFromDistanceGrid) {
        this._removeFromGridUnclustered(marker, this._maxZoom);
      }

      //Work our way up the clusters removing them as we go if required
      var cluster = marker.__parent,
        markers = cluster._markers,
        otherMarker;

      //Remove the marker from the immediate parents marker list
      this._arraySplice(markers, marker);
      while (cluster) {
        cluster._childCount--;
        cluster._boundsNeedUpdate = true;
        if (cluster._zoom < minZoom) {
          //Top level, do nothing
          break;
        } else if (removeFromDistanceGrid && cluster._childCount <= 1) {
          //Cluster no longer required
          //We need to push the other marker up to the parent
          otherMarker = cluster._markers[0] === marker ? cluster._markers[1] : cluster._markers[0];

          //Update distance grid
          gridClusters[cluster._zoom].removeObject(cluster, map.project(cluster._cLatLng, cluster._zoom));
          gridUnclustered[cluster._zoom].addObject(otherMarker, map.project(otherMarker.getLatLng(), cluster._zoom));

          //Move otherMarker up to parent
          this._arraySplice(cluster.__parent._childClusters, cluster);
          cluster.__parent._markers.push(otherMarker);
          otherMarker.__parent = cluster.__parent;
          if (cluster._icon) {
            //Cluster is currently on the map, need to put the marker on the map instead
            fg.removeLayer(cluster);
            if (!dontUpdateMap) {
              fg.addLayer(otherMarker);
            }
          }
        } else {
          cluster._iconNeedsUpdate = true;
        }
        cluster = cluster.__parent;
      }
      delete marker.__parent;
    },
    _isOrIsParent: function _isOrIsParent(el, oel) {
      while (oel) {
        if (el === oel) {
          return true;
        }
        oel = oel.parentNode;
      }
      return false;
    },
    //Override L.Evented.fire
    fire: function fire(type, data, propagate) {
      if (data && data.layer instanceof L.MarkerCluster) {
        //Prevent multiple clustermouseover/off events if the icon is made up of stacked divs (Doesn't work in ie <= 8, no relatedTarget)
        if (data.originalEvent && this._isOrIsParent(data.layer._icon, data.originalEvent.relatedTarget)) {
          return;
        }
        type = 'cluster' + type;
      }
      L.FeatureGroup.prototype.fire.call(this, type, data, propagate);
    },
    //Override L.Evented.listens
    listens: function listens(type, propagate) {
      return L.FeatureGroup.prototype.listens.call(this, type, propagate) || L.FeatureGroup.prototype.listens.call(this, 'cluster' + type, propagate);
    },
    //Default functionality
    _defaultIconCreateFunction: function _defaultIconCreateFunction(cluster) {
      var childCount = cluster.getChildCount();
      var c = ' marker-cluster-';
      if (childCount < 10) {
        c += 'small';
      } else if (childCount < 100) {
        c += 'medium';
      } else {
        c += 'large';
      }
      return new L.DivIcon({
        html: '<div><span>' + childCount + '</span></div>',
        className: 'marker-cluster' + c,
        iconSize: new L.Point(40, 40)
      });
    },
    _bindEvents: function _bindEvents() {
      var map = this._map,
        spiderfyOnMaxZoom = this.options.spiderfyOnMaxZoom,
        showCoverageOnHover = this.options.showCoverageOnHover,
        zoomToBoundsOnClick = this.options.zoomToBoundsOnClick;

      //Zoom on cluster click or spiderfy if we are at the lowest level
      if (spiderfyOnMaxZoom || zoomToBoundsOnClick) {
        this.on('clusterclick', this._zoomOrSpiderfy, this);
      }

      //Show convex hull (boundary) polygon on mouse over
      if (showCoverageOnHover) {
        this.on('clustermouseover', this._showCoverage, this);
        this.on('clustermouseout', this._hideCoverage, this);
        map.on('zoomend', this._hideCoverage, this);
      }
    },
    _zoomOrSpiderfy: function _zoomOrSpiderfy(e) {
      var cluster = e.layer,
        bottomCluster = cluster;
      while (bottomCluster._childClusters.length === 1) {
        bottomCluster = bottomCluster._childClusters[0];
      }
      if (bottomCluster._zoom === this._maxZoom && bottomCluster._childCount === cluster._childCount && this.options.spiderfyOnMaxZoom) {
        // All child markers are contained in a single cluster from this._maxZoom to this cluster.
        cluster.spiderfy();
      } else if (this.options.zoomToBoundsOnClick) {
        cluster.zoomToBounds();
      }

      // Focus the map again for keyboard users.
      if (e.originalEvent && e.originalEvent.keyCode === 13) {
        this._map._container.focus();
      }
    },
    _showCoverage: function _showCoverage(e) {
      var map = this._map;
      if (this._inZoomAnimation) {
        return;
      }
      if (this._shownPolygon) {
        map.removeLayer(this._shownPolygon);
      }
      if (e.layer.getChildCount() > 2 && e.layer !== this._spiderfied) {
        this._shownPolygon = new L.Polygon(e.layer.getConvexHull(), this.options.polygonOptions);
        map.addLayer(this._shownPolygon);
      }
    },
    _hideCoverage: function _hideCoverage() {
      if (this._shownPolygon) {
        this._map.removeLayer(this._shownPolygon);
        this._shownPolygon = null;
      }
    },
    _unbindEvents: function _unbindEvents() {
      var spiderfyOnMaxZoom = this.options.spiderfyOnMaxZoom,
        showCoverageOnHover = this.options.showCoverageOnHover,
        zoomToBoundsOnClick = this.options.zoomToBoundsOnClick,
        map = this._map;
      if (spiderfyOnMaxZoom || zoomToBoundsOnClick) {
        this.off('clusterclick', this._zoomOrSpiderfy, this);
      }
      if (showCoverageOnHover) {
        this.off('clustermouseover', this._showCoverage, this);
        this.off('clustermouseout', this._hideCoverage, this);
        map.off('zoomend', this._hideCoverage, this);
      }
    },
    _zoomEnd: function _zoomEnd() {
      if (!this._map) {
        //May have been removed from the map by a zoomEnd handler
        return;
      }
      this._mergeSplitClusters();
      this._zoom = this._map._zoom;
      this._currentShownBounds = this._getExpandedVisibleBounds();
      this._topClusterLevel._recursivelySpiderfy(this._map._zoom, this._currentShownBounds, this.options.shouldSpiderfy);
      this._topClusterLevel._recursivelyRemoveChildrenFromMap(this._currentShownBounds, this._zoom, this._currentShownBounds);
      this._topClusterLevel._recursivelyAddChildrenToMap(null, this._map._zoom, this._currentShownBounds);
    },
    _moveEnd: function _moveEnd() {
      if (this._inZoomAnimation) {
        return;
      }
      var newBounds = this._getExpandedVisibleBounds();
      this._topClusterLevel._recursivelyRemoveChildrenFromMap(this._currentShownBounds, Math.floor(this._map.getMinZoom()), this._zoom, newBounds);
      this._topClusterLevel._recursivelyAddChildrenToMap(null, this._map._zoom, newBounds);
      this._currentShownBounds = newBounds;
      return;
    },
    _generateInitialClusters: function _generateInitialClusters() {
      var maxZoom = this._map.getMaxZoom(),
        minZoom = this._map.getMinZoom(),
        radius = this.options.maxClusterRadius,
        radiusFn = radius;

      //If we just set maxClusterRadius to a single number, we need to create
      //a simple function to return that number. Otherwise, we just have to
      //use the function we've passed in.
      if (typeof radius !== "function") {
        radiusFn = function radiusFn() {
          return radius;
        };
      }
      if (this.options.disableClusteringAtZoom !== null) {
        maxZoom = this.options.disableClusteringAtZoom - 1;
      }
      this._maxZoom = maxZoom;
      this._gridClusters = {};
      this._gridUnclustered = {};

      //Set up DistanceGrids for each zoom
      for (var zoom = maxZoom; zoom >= minZoom; zoom--) {
        this._gridClusters[zoom] = new L.DistanceGrid(radiusFn(zoom));
        this._gridUnclustered[zoom] = new L.DistanceGrid(radiusFn(zoom));
      }

      // Instantiate the appropriate L.MarkerCluster class (animated or not).
      this._topClusterLevel = new this._markerCluster(this, minZoom - 1);
    },
    //Zoom: Zoom to start adding at (Pass this._maxZoom to start at the bottom)
    _addLayer: function _addLayer(layer, zoom) {
      var gridClusters = this._gridClusters,
        gridUnclustered = this._gridUnclustered,
        minZoom = Math.floor(this._map.getMinZoom()),
        markerPoint,
        z;
      if (this.options.singleMarkerMode) {
        this._overrideMarkerIcon(layer);
      }
      layer.on(this._childMarkerEventHandlers, this);

      //Find the lowest zoom level to slot this one in
      for (; zoom >= minZoom; zoom--) {
        markerPoint = this._map.project(layer.getLatLng(), zoom); // calculate pixel position

        //Try find a cluster close by
        var closest = gridClusters[zoom].getNearObject(markerPoint);
        if (closest) {
          closest._addChild(layer);
          layer.__parent = closest;
          return;
        }

        //Try find a marker close by to form a new cluster with
        closest = gridUnclustered[zoom].getNearObject(markerPoint);
        if (closest) {
          var parent = closest.__parent;
          if (parent) {
            this._removeLayer(closest, false);
          }

          //Create new cluster with these 2 in it

          var newCluster = new this._markerCluster(this, zoom, closest, layer);
          gridClusters[zoom].addObject(newCluster, this._map.project(newCluster._cLatLng, zoom));
          closest.__parent = newCluster;
          layer.__parent = newCluster;

          //First create any new intermediate parent clusters that don't exist
          var lastParent = newCluster;
          for (z = zoom - 1; z > parent._zoom; z--) {
            lastParent = new this._markerCluster(this, z, lastParent);
            gridClusters[z].addObject(lastParent, this._map.project(closest.getLatLng(), z));
          }
          parent._addChild(lastParent);

          //Remove closest from this zoom level and any above that it is in, replace with newCluster
          this._removeFromGridUnclustered(closest, zoom);
          return;
        }

        //Didn't manage to cluster in at this zoom, record us as a marker here and continue upwards
        gridUnclustered[zoom].addObject(layer, markerPoint);
      }

      //Didn't get in anything, add us to the top
      this._topClusterLevel._addChild(layer);
      layer.__parent = this._topClusterLevel;
      return;
    },
    /**
     * Refreshes the icon of all "dirty" visible clusters.
     * Non-visible "dirty" clusters will be updated when they are added to the map.
     * @private
     */
    _refreshClustersIcons: function _refreshClustersIcons() {
      this._featureGroup.eachLayer(function (c) {
        if (c instanceof L.MarkerCluster && c._iconNeedsUpdate) {
          c._updateIcon();
        }
      });
    },
    //Enqueue code to fire after the marker expand/contract has happened
    _enqueue: function _enqueue(fn) {
      this._queue.push(fn);
      if (!this._queueTimeout) {
        this._queueTimeout = setTimeout(L.bind(this._processQueue, this), 300);
      }
    },
    _processQueue: function _processQueue() {
      for (var i = 0; i < this._queue.length; i++) {
        this._queue[i].call(this);
      }
      this._queue.length = 0;
      clearTimeout(this._queueTimeout);
      this._queueTimeout = null;
    },
    //Merge and split any existing clusters that are too big or small
    _mergeSplitClusters: function _mergeSplitClusters() {
      var mapZoom = this._map._zoom;

      //In case we are starting to split before the animation finished
      this._processQueue();
      if (this._zoom < mapZoom && this._currentShownBounds.intersects(this._getExpandedVisibleBounds())) {
        //Zoom in, split
        this._animationStart();
        //Remove clusters now off screen
        this._topClusterLevel._recursivelyRemoveChildrenFromMap(this._currentShownBounds, this._map.getMinZoom(), this._zoom, this._getExpandedVisibleBounds());
        this._animationZoomIn(this._zoom, mapZoom);
      } else if (this._zoom > mapZoom) {
        //Zoom out, merge
        this._animationStart();
        this._animationZoomOut(this._zoom, mapZoom);
      } else {
        this._moveEnd();
      }
    },
    //Gets the maps visible bounds expanded in each direction by the size of the screen (so the user cannot see an area we do not cover in one pan)
    _getExpandedVisibleBounds: function _getExpandedVisibleBounds() {
      if (!this.options.removeOutsideVisibleBounds) {
        return this._mapBoundsInfinite;
      } else if (L.Browser.mobile) {
        return this._checkBoundsMaxLat(this._map.getBounds());
      }
      return this._checkBoundsMaxLat(this._map.getBounds().pad(1)); // Padding expands the bounds by its own dimensions but scaled with the given factor.
    },
    /**
     * Expands the latitude to Infinity (or -Infinity) if the input bounds reach the map projection maximum defined latitude
     * (in the case of Web/Spherical Mercator, it is 85.0511287798 / see https://en.wikipedia.org/wiki/Web_Mercator#Formulas).
     * Otherwise, the removeOutsideVisibleBounds option will remove markers beyond that limit, whereas the same markers without
     * this option (or outside MCG) will have their position floored (ceiled) by the projection and rendered at that limit,
     * making the user think that MCG "eats" them and never displays them again.
     * @param bounds L.LatLngBounds
     * @returns {L.LatLngBounds}
     * @private
     */
    _checkBoundsMaxLat: function _checkBoundsMaxLat(bounds) {
      var maxLat = this._maxLat;
      if (maxLat !== undefined) {
        if (bounds.getNorth() >= maxLat) {
          bounds._northEast.lat = Infinity;
        }
        if (bounds.getSouth() <= -maxLat) {
          bounds._southWest.lat = -Infinity;
        }
      }
      return bounds;
    },
    //Shared animation code
    _animationAddLayerNonAnimated: function _animationAddLayerNonAnimated(layer, newCluster) {
      if (newCluster === layer) {
        this._featureGroup.addLayer(layer);
      } else if (newCluster._childCount === 2) {
        newCluster._addToMap();
        var markers = newCluster.getAllChildMarkers();
        this._featureGroup.removeLayer(markers[0]);
        this._featureGroup.removeLayer(markers[1]);
      } else {
        newCluster._updateIcon();
      }
    },
    /**
     * Extracts individual (i.e. non-group) layers from a Layer Group.
     * @param group to extract layers from.
     * @param output {Array} in which to store the extracted layers.
     * @returns {*|Array}
     * @private
     */
    _extractNonGroupLayers: function _extractNonGroupLayers(group, output) {
      var layers = group.getLayers(),
        i = 0,
        layer;
      output = output || [];
      for (; i < layers.length; i++) {
        layer = layers[i];
        if (layer instanceof L.LayerGroup) {
          this._extractNonGroupLayers(layer, output);
          continue;
        }
        output.push(layer);
      }
      return output;
    },
    /**
     * Implements the singleMarkerMode option.
     * @param layer Marker to re-style using the Clusters iconCreateFunction.
     * @returns {L.Icon} The newly created icon.
     * @private
     */
    _overrideMarkerIcon: function _overrideMarkerIcon(layer) {
      var icon = layer.options.icon = this.options.iconCreateFunction({
        getChildCount: function getChildCount() {
          return 1;
        },
        getAllChildMarkers: function getAllChildMarkers() {
          return [layer];
        }
      });
      return icon;
    }
  });

  // Constant bounds used in case option "removeOutsideVisibleBounds" is set to false.
  L.MarkerClusterGroup.include({
    _mapBoundsInfinite: new L.LatLngBounds(new L.LatLng(-Infinity, -Infinity), new L.LatLng(Infinity, Infinity))
  });
  L.MarkerClusterGroup.include({
    _noAnimation: {
      //Non Animated versions of everything
      _animationStart: function _animationStart() {
        //Do nothing...
      },
      _animationZoomIn: function _animationZoomIn(previousZoomLevel, newZoomLevel) {
        this._topClusterLevel._recursivelyRemoveChildrenFromMap(this._currentShownBounds, this._map.getMinZoom(), previousZoomLevel);
        this._topClusterLevel._recursivelyAddChildrenToMap(null, newZoomLevel, this._getExpandedVisibleBounds());

        //We didn't actually animate, but we use this event to mean "clustering animations have finished"
        this.fire('animationend');
      },
      _animationZoomOut: function _animationZoomOut(previousZoomLevel, newZoomLevel) {
        this._topClusterLevel._recursivelyRemoveChildrenFromMap(this._currentShownBounds, this._map.getMinZoom(), previousZoomLevel);
        this._topClusterLevel._recursivelyAddChildrenToMap(null, newZoomLevel, this._getExpandedVisibleBounds());

        //We didn't actually animate, but we use this event to mean "clustering animations have finished"
        this.fire('animationend');
      },
      _animationAddLayer: function _animationAddLayer(layer, newCluster) {
        this._animationAddLayerNonAnimated(layer, newCluster);
      }
    },
    _withAnimation: {
      //Animated versions here
      _animationStart: function _animationStart() {
        this._map._mapPane.className += ' leaflet-cluster-anim';
        this._inZoomAnimation++;
      },
      _animationZoomIn: function _animationZoomIn(previousZoomLevel, newZoomLevel) {
        var bounds = this._getExpandedVisibleBounds(),
          fg = this._featureGroup,
          minZoom = this._map.getMinZoom(),
          i;
        this._ignoreMove = true;

        //Add all children of current clusters to map and remove those clusters from map
        this._topClusterLevel._recursively(bounds, previousZoomLevel, minZoom, function (c) {
          var startPos = c._latlng,
            markers = c._markers,
            m;
          if (!bounds.contains(startPos)) {
            startPos = null;
          }
          if (c._isSingleParent() && previousZoomLevel + 1 === newZoomLevel) {
            //Immediately add the new child and remove us
            fg.removeLayer(c);
            c._recursivelyAddChildrenToMap(null, newZoomLevel, bounds);
          } else {
            //Fade out old cluster
            c.clusterHide();
            c._recursivelyAddChildrenToMap(startPos, newZoomLevel, bounds);
          }

          //Remove all markers that aren't visible any more
          //TODO: Do we actually need to do this on the higher levels too?
          for (i = markers.length - 1; i >= 0; i--) {
            m = markers[i];
            if (!bounds.contains(m._latlng)) {
              fg.removeLayer(m);
            }
          }
        });
        this._forceLayout();

        //Update opacities
        this._topClusterLevel._recursivelyBecomeVisible(bounds, newZoomLevel);
        //TODO Maybe? Update markers in _recursivelyBecomeVisible
        fg.eachLayer(function (n) {
          if (!(n instanceof L.MarkerCluster) && n._icon) {
            n.clusterShow();
          }
        });

        //update the positions of the just added clusters/markers
        this._topClusterLevel._recursively(bounds, previousZoomLevel, newZoomLevel, function (c) {
          c._recursivelyRestoreChildPositions(newZoomLevel);
        });
        this._ignoreMove = false;

        //Remove the old clusters and close the zoom animation
        this._enqueue(function () {
          //update the positions of the just added clusters/markers
          this._topClusterLevel._recursively(bounds, previousZoomLevel, minZoom, function (c) {
            fg.removeLayer(c);
            c.clusterShow();
          });
          this._animationEnd();
        });
      },
      _animationZoomOut: function _animationZoomOut(previousZoomLevel, newZoomLevel) {
        this._animationZoomOutSingle(this._topClusterLevel, previousZoomLevel - 1, newZoomLevel);

        //Need to add markers for those that weren't on the map before but are now
        this._topClusterLevel._recursivelyAddChildrenToMap(null, newZoomLevel, this._getExpandedVisibleBounds());
        //Remove markers that were on the map before but won't be now
        this._topClusterLevel._recursivelyRemoveChildrenFromMap(this._currentShownBounds, this._map.getMinZoom(), previousZoomLevel, this._getExpandedVisibleBounds());
      },
      _animationAddLayer: function _animationAddLayer(layer, newCluster) {
        var me = this,
          fg = this._featureGroup;
        fg.addLayer(layer);
        if (newCluster !== layer) {
          if (newCluster._childCount > 2) {
            //Was already a cluster

            newCluster._updateIcon();
            this._forceLayout();
            this._animationStart();
            layer._setPos(this._map.latLngToLayerPoint(newCluster.getLatLng()));
            layer.clusterHide();
            this._enqueue(function () {
              fg.removeLayer(layer);
              layer.clusterShow();
              me._animationEnd();
            });
          } else {
            //Just became a cluster
            this._forceLayout();
            me._animationStart();
            me._animationZoomOutSingle(newCluster, this._map.getMaxZoom(), this._zoom);
          }
        }
      }
    },
    // Private methods for animated versions.
    _animationZoomOutSingle: function _animationZoomOutSingle(cluster, previousZoomLevel, newZoomLevel) {
      var bounds = this._getExpandedVisibleBounds(),
        minZoom = this._map.getMinZoom();

      //Animate all of the markers in the clusters to move to their cluster center point
      cluster._recursivelyAnimateChildrenInAndAddSelfToMap(bounds, minZoom, previousZoomLevel + 1, newZoomLevel);
      var me = this;

      //Update the opacity (If we immediately set it they won't animate)
      this._forceLayout();
      cluster._recursivelyBecomeVisible(bounds, newZoomLevel);

      //TODO: Maybe use the transition timing stuff to make this more reliable
      //When the animations are done, tidy up
      this._enqueue(function () {
        //This cluster stopped being a cluster before the timeout fired
        if (cluster._childCount === 1) {
          var m = cluster._markers[0];
          //If we were in a cluster animation at the time then the opacity and position of our child could be wrong now, so fix it
          this._ignoreMove = true;
          m.setLatLng(m.getLatLng());
          this._ignoreMove = false;
          if (m.clusterShow) {
            m.clusterShow();
          }
        } else {
          cluster._recursively(bounds, newZoomLevel, minZoom, function (c) {
            c._recursivelyRemoveChildrenFromMap(bounds, minZoom, previousZoomLevel + 1);
          });
        }
        me._animationEnd();
      });
    },
    _animationEnd: function _animationEnd() {
      if (this._map) {
        this._map._mapPane.className = this._map._mapPane.className.replace(' leaflet-cluster-anim', '');
      }
      this._inZoomAnimation--;
      this.fire('animationend');
    },
    //Force a browser layout of stuff in the map
    // Should apply the current opacity and location to all elements so we can update them again for an animation
    _forceLayout: function _forceLayout() {
      //In my testing this works, infact offsetWidth of any element seems to work.
      //Could loop all this._layers and do this for each _icon if it stops working

      L.Util.falseFn(document.body.offsetWidth);
    }
  });
  L.markerClusterGroup = function (options) {
    return new L.MarkerClusterGroup(options);
  };
  L.MarkerCluster = L.Marker.extend({
    options: L.Icon.prototype.options,
    initialize: function initialize(group, zoom, a, b) {
      L.Marker.prototype.initialize.call(this, a ? a._cLatLng || a.getLatLng() : new L.LatLng(0, 0), {
        icon: this,
        pane: group.options.clusterPane
      });
      this._group = group;
      this._zoom = zoom;
      this._markers = [];
      this._childClusters = [];
      this._childCount = 0;
      this._iconNeedsUpdate = true;
      this._boundsNeedUpdate = true;
      this._bounds = new L.LatLngBounds();
      if (a) {
        this._addChild(a);
      }
      if (b) {
        this._addChild(b);
      }
    },
    //Recursively retrieve all child markers of this cluster
    getAllChildMarkers: function getAllChildMarkers(storageArray, ignoreDraggedMarker) {
      storageArray = storageArray || [];
      for (var i = this._childClusters.length - 1; i >= 0; i--) {
        this._childClusters[i].getAllChildMarkers(storageArray);
      }
      for (var j = this._markers.length - 1; j >= 0; j--) {
        if (ignoreDraggedMarker && this._markers[j].__dragStart) {
          continue;
        }
        storageArray.push(this._markers[j]);
      }
      return storageArray;
    },
    //Returns the count of how many child markers we have
    getChildCount: function getChildCount() {
      return this._childCount;
    },
    //Zoom to the minimum of showing all of the child markers, or the extents of this cluster
    zoomToBounds: function zoomToBounds(fitBoundsOptions) {
      var childClusters = this._childClusters.slice(),
        map = this._group._map,
        boundsZoom = map.getBoundsZoom(this._bounds),
        zoom = this._zoom + 1,
        mapZoom = map.getZoom(),
        i;

      //calculate how far we need to zoom down to see all of the markers
      while (childClusters.length > 0 && boundsZoom > zoom) {
        zoom++;
        var newClusters = [];
        for (i = 0; i < childClusters.length; i++) {
          newClusters = newClusters.concat(childClusters[i]._childClusters);
        }
        childClusters = newClusters;
      }
      if (boundsZoom > zoom) {
        this._group._map.setView(this._latlng, zoom);
      } else if (boundsZoom <= mapZoom) {
        //If fitBounds wouldn't zoom us down, zoom us down instead
        this._group._map.setView(this._latlng, mapZoom + 1);
      } else {
        this._group._map.fitBounds(this._bounds, fitBoundsOptions);
      }
    },
    getBounds: function getBounds() {
      var bounds = new L.LatLngBounds();
      bounds.extend(this._bounds);
      return bounds;
    },
    _updateIcon: function _updateIcon() {
      this._iconNeedsUpdate = true;
      if (this._icon) {
        this.setIcon(this);
      }
    },
    //Cludge for Icon, we pretend to be an icon for performance
    createIcon: function createIcon() {
      if (this._iconNeedsUpdate) {
        this._iconObj = this._group.options.iconCreateFunction(this);
        this._iconNeedsUpdate = false;
      }
      return this._iconObj.createIcon();
    },
    createShadow: function createShadow() {
      return this._iconObj.createShadow();
    },
    _addChild: function _addChild(new1, isNotificationFromChild) {
      this._iconNeedsUpdate = true;
      this._boundsNeedUpdate = true;
      this._setClusterCenter(new1);
      if (new1 instanceof L.MarkerCluster) {
        if (!isNotificationFromChild) {
          this._childClusters.push(new1);
          new1.__parent = this;
        }
        this._childCount += new1._childCount;
      } else {
        if (!isNotificationFromChild) {
          this._markers.push(new1);
        }
        this._childCount++;
      }
      if (this.__parent) {
        this.__parent._addChild(new1, true);
      }
    },
    /**
     * Makes sure the cluster center is set. If not, uses the child center if it is a cluster, or the marker position.
     * @param child L.MarkerCluster|L.Marker that will be used as cluster center if not defined yet.
     * @private
     */
    _setClusterCenter: function _setClusterCenter(child) {
      if (!this._cLatLng) {
        // when clustering, take position of the first point as the cluster center
        this._cLatLng = child._cLatLng || child._latlng;
      }
    },
    /**
     * Assigns impossible bounding values so that the next extend entirely determines the new bounds.
     * This method avoids having to trash the previous L.LatLngBounds object and to create a new one, which is much slower for this class.
     * As long as the bounds are not extended, most other methods would probably fail, as they would with bounds initialized but not extended.
     * @private
     */
    _resetBounds: function _resetBounds() {
      var bounds = this._bounds;
      if (bounds._southWest) {
        bounds._southWest.lat = Infinity;
        bounds._southWest.lng = Infinity;
      }
      if (bounds._northEast) {
        bounds._northEast.lat = -Infinity;
        bounds._northEast.lng = -Infinity;
      }
    },
    _recalculateBounds: function _recalculateBounds() {
      var markers = this._markers,
        childClusters = this._childClusters,
        latSum = 0,
        lngSum = 0,
        totalCount = this._childCount,
        i,
        child,
        childLatLng,
        childCount;

      // Case where all markers are removed from the map and we are left with just an empty _topClusterLevel.
      if (totalCount === 0) {
        return;
      }

      // Reset rather than creating a new object, for performance.
      this._resetBounds();

      // Child markers.
      for (i = 0; i < markers.length; i++) {
        childLatLng = markers[i]._latlng;
        this._bounds.extend(childLatLng);
        latSum += childLatLng.lat;
        lngSum += childLatLng.lng;
      }

      // Child clusters.
      for (i = 0; i < childClusters.length; i++) {
        child = childClusters[i];

        // Re-compute child bounds and weighted position first if necessary.
        if (child._boundsNeedUpdate) {
          child._recalculateBounds();
        }
        this._bounds.extend(child._bounds);
        childLatLng = child._wLatLng;
        childCount = child._childCount;
        latSum += childLatLng.lat * childCount;
        lngSum += childLatLng.lng * childCount;
      }
      this._latlng = this._wLatLng = new L.LatLng(latSum / totalCount, lngSum / totalCount);

      // Reset dirty flag.
      this._boundsNeedUpdate = false;
    },
    //Set our markers position as given and add it to the map
    _addToMap: function _addToMap(startPos) {
      if (startPos) {
        this._backupLatlng = this._latlng;
        this.setLatLng(startPos);
      }
      this._group._featureGroup.addLayer(this);
    },
    _recursivelyAnimateChildrenIn: function _recursivelyAnimateChildrenIn(bounds, center, maxZoom) {
      this._recursively(bounds, this._group._map.getMinZoom(), maxZoom - 1, function (c) {
        var markers = c._markers,
          i,
          m;
        for (i = markers.length - 1; i >= 0; i--) {
          m = markers[i];

          //Only do it if the icon is still on the map
          if (m._icon) {
            m._setPos(center);
            m.clusterHide();
          }
        }
      }, function (c) {
        var childClusters = c._childClusters,
          j,
          cm;
        for (j = childClusters.length - 1; j >= 0; j--) {
          cm = childClusters[j];
          if (cm._icon) {
            cm._setPos(center);
            cm.clusterHide();
          }
        }
      });
    },
    _recursivelyAnimateChildrenInAndAddSelfToMap: function _recursivelyAnimateChildrenInAndAddSelfToMap(bounds, mapMinZoom, previousZoomLevel, newZoomLevel) {
      this._recursively(bounds, newZoomLevel, mapMinZoom, function (c) {
        c._recursivelyAnimateChildrenIn(bounds, c._group._map.latLngToLayerPoint(c.getLatLng()).round(), previousZoomLevel);

        //TODO: depthToAnimateIn affects _isSingleParent, if there is a multizoom we may/may not be.
        //As a hack we only do a animation free zoom on a single level zoom, if someone does multiple levels then we always animate
        if (c._isSingleParent() && previousZoomLevel - 1 === newZoomLevel) {
          c.clusterShow();
          c._recursivelyRemoveChildrenFromMap(bounds, mapMinZoom, previousZoomLevel); //Immediately remove our children as we are replacing them. TODO previousBounds not bounds
        } else {
          c.clusterHide();
        }
        c._addToMap();
      });
    },
    _recursivelyBecomeVisible: function _recursivelyBecomeVisible(bounds, zoomLevel) {
      this._recursively(bounds, this._group._map.getMinZoom(), zoomLevel, null, function (c) {
        c.clusterShow();
      });
    },
    _recursivelyAddChildrenToMap: function _recursivelyAddChildrenToMap(startPos, zoomLevel, bounds) {
      this._recursively(bounds, this._group._map.getMinZoom() - 1, zoomLevel, function (c) {
        if (zoomLevel === c._zoom) {
          return;
        }

        //Add our child markers at startPos (so they can be animated out)
        for (var i = c._markers.length - 1; i >= 0; i--) {
          var nm = c._markers[i];
          if (!bounds.contains(nm._latlng)) {
            continue;
          }
          if (startPos) {
            nm._backupLatlng = nm.getLatLng();
            nm.setLatLng(startPos);
            if (nm.clusterHide) {
              nm.clusterHide();
            }
          }
          c._group._featureGroup.addLayer(nm);
        }
      }, function (c) {
        c._addToMap(startPos);
      });
    },
    _recursivelySpiderfy: function _recursivelySpiderfy(zoomLevel, bounds, shouldSpiderfy) {
      this._recursively(bounds, -1, zoomLevel, function (c) {
        c._noanimationUnspiderfy();
      }, function (c) {
        if (shouldSpiderfy && shouldSpiderfy(c, zoomLevel)) {
          c.spiderfy();
        }
      });
    },
    _recursivelyRestoreChildPositions: function _recursivelyRestoreChildPositions(zoomLevel) {
      //Fix positions of child markers
      for (var i = this._markers.length - 1; i >= 0; i--) {
        var nm = this._markers[i];
        if (nm._backupLatlng) {
          nm.setLatLng(nm._backupLatlng);
          delete nm._backupLatlng;
        }
      }
      if (zoomLevel - 1 === this._zoom) {
        //Reposition child clusters
        for (var j = this._childClusters.length - 1; j >= 0; j--) {
          this._childClusters[j]._restorePosition();
        }
      } else {
        for (var k = this._childClusters.length - 1; k >= 0; k--) {
          this._childClusters[k]._recursivelyRestoreChildPositions(zoomLevel);
        }
      }
    },
    _restorePosition: function _restorePosition() {
      if (this._backupLatlng) {
        this.setLatLng(this._backupLatlng);
        delete this._backupLatlng;
      }
    },
    //exceptBounds: If set, don't remove any markers/clusters in it
    _recursivelyRemoveChildrenFromMap: function _recursivelyRemoveChildrenFromMap(previousBounds, mapMinZoom, zoomLevel, exceptBounds) {
      var m, i;
      this._recursively(previousBounds, mapMinZoom - 1, zoomLevel - 1, function (c) {
        //Remove markers at every level
        for (i = c._markers.length - 1; i >= 0; i--) {
          m = c._markers[i];
          if (!exceptBounds || !exceptBounds.contains(m._latlng)) {
            c._group._featureGroup.removeLayer(m);
            if (m.clusterShow) {
              m.clusterShow();
            }
          }
        }
      }, function (c) {
        //Remove child clusters at just the bottom level
        for (i = c._childClusters.length - 1; i >= 0; i--) {
          m = c._childClusters[i];
          if (!exceptBounds || !exceptBounds.contains(m._latlng)) {
            c._group._featureGroup.removeLayer(m);
            if (m.clusterShow) {
              m.clusterShow();
            }
          }
        }
      });
    },
    //Run the given functions recursively to this and child clusters
    // boundsToApplyTo: a L.LatLngBounds representing the bounds of what clusters to recurse in to
    // zoomLevelToStart: zoom level to start running functions (inclusive)
    // zoomLevelToStop: zoom level to stop running functions (inclusive)
    // runAtEveryLevel: function that takes an L.MarkerCluster as an argument that should be applied on every level
    // runAtBottomLevel: function that takes an L.MarkerCluster as an argument that should be applied at only the bottom level
    _recursively: function _recursively(boundsToApplyTo, zoomLevelToStart, zoomLevelToStop, runAtEveryLevel, runAtBottomLevel) {
      var childClusters = this._childClusters,
        zoom = this._zoom,
        i,
        c;
      if (zoomLevelToStart <= zoom) {
        if (runAtEveryLevel) {
          runAtEveryLevel(this);
        }
        if (runAtBottomLevel && zoom === zoomLevelToStop) {
          runAtBottomLevel(this);
        }
      }
      if (zoom < zoomLevelToStart || zoom < zoomLevelToStop) {
        for (i = childClusters.length - 1; i >= 0; i--) {
          c = childClusters[i];
          if (c._boundsNeedUpdate) {
            c._recalculateBounds();
          }
          if (boundsToApplyTo.intersects(c._bounds)) {
            c._recursively(boundsToApplyTo, zoomLevelToStart, zoomLevelToStop, runAtEveryLevel, runAtBottomLevel);
          }
        }
      }
    },
    //Returns true if we are the parent of only one cluster and that cluster is the same as us
    _isSingleParent: function _isSingleParent() {
      //Don't need to check this._markers as the rest won't work if there are any
      return this._childClusters.length > 0 && this._childClusters[0]._childCount === this._childCount;
    }
  });

  /*
  * Extends L.Marker to include two extra methods: clusterHide and clusterShow.
  * 
  * They work as setOpacity(0) and setOpacity(1) respectively, but
  * don't overwrite the options.opacity
  * 
  */

  L.Marker.include({
    clusterHide: function clusterHide() {
      var backup = this.options.opacity;
      this.setOpacity(0);
      this.options.opacity = backup;
      return this;
    },
    clusterShow: function clusterShow() {
      return this.setOpacity(this.options.opacity);
    }
  });
  L.DistanceGrid = function (cellSize) {
    this._cellSize = cellSize;
    this._sqCellSize = cellSize * cellSize;
    this._grid = {};
    this._objectPoint = {};
  };
  L.DistanceGrid.prototype = {
    addObject: function addObject(obj, point) {
      var x = this._getCoord(point.x),
        y = this._getCoord(point.y),
        grid = this._grid,
        row = grid[y] = grid[y] || {},
        cell = row[x] = row[x] || [],
        stamp = L.Util.stamp(obj);
      this._objectPoint[stamp] = point;
      cell.push(obj);
    },
    updateObject: function updateObject(obj, point) {
      this.removeObject(obj);
      this.addObject(obj, point);
    },
    //Returns true if the object was found
    removeObject: function removeObject(obj, point) {
      var x = this._getCoord(point.x),
        y = this._getCoord(point.y),
        grid = this._grid,
        row = grid[y] = grid[y] || {},
        cell = row[x] = row[x] || [],
        i,
        len;
      delete this._objectPoint[L.Util.stamp(obj)];
      for (i = 0, len = cell.length; i < len; i++) {
        if (cell[i] === obj) {
          cell.splice(i, 1);
          if (len === 1) {
            delete row[x];
          }
          return true;
        }
      }
    },
    eachObject: function eachObject(fn, context) {
      var i,
        j,
        k,
        len,
        row,
        cell,
        removed,
        grid = this._grid;
      for (i in grid) {
        row = grid[i];
        for (j in row) {
          cell = row[j];
          for (k = 0, len = cell.length; k < len; k++) {
            removed = fn.call(context, cell[k]);
            if (removed) {
              k--;
              len--;
            }
          }
        }
      }
    },
    getNearObject: function getNearObject(point) {
      var x = this._getCoord(point.x),
        y = this._getCoord(point.y),
        i,
        j,
        k,
        row,
        cell,
        len,
        obj,
        dist,
        objectPoint = this._objectPoint,
        closestDistSq = this._sqCellSize,
        closest = null;
      for (i = y - 1; i <= y + 1; i++) {
        row = this._grid[i];
        if (row) {
          for (j = x - 1; j <= x + 1; j++) {
            cell = row[j];
            if (cell) {
              for (k = 0, len = cell.length; k < len; k++) {
                obj = cell[k];
                dist = this._sqDist(objectPoint[L.Util.stamp(obj)], point);
                if (dist < closestDistSq || dist <= closestDistSq && closest === null) {
                  closestDistSq = dist;
                  closest = obj;
                }
              }
            }
          }
        }
      }
      return closest;
    },
    _getCoord: function _getCoord(x) {
      var coord = Math.floor(x / this._cellSize);
      return isFinite(coord) ? coord : x;
    },
    _sqDist: function _sqDist(p, p2) {
      var dx = p2.x - p.x,
        dy = p2.y - p.y;
      return dx * dx + dy * dy;
    }
  };

  /* Copyright (c) 2012 the authors listed at the following URL, and/or
  the authors of referenced articles or incorporated external code:
  http://en.literateprograms.org/Quickhull_(Javascript)?action=history&offset=20120410175256
  
  Permission is hereby granted, free of charge, to any person obtaining
  a copy of this software and associated documentation files (the
  "Software"), to deal in the Software without restriction, including
  without limitation the rights to use, copy, modify, merge, publish,
  distribute, sublicense, and/or sell copies of the Software, and to
  permit persons to whom the Software is furnished to do so, subject to
  the following conditions:
  
  The above copyright notice and this permission notice shall be
  included in all copies or substantial portions of the Software.
  
  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
  EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
  MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
  IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
  CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
  TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
  SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
  
  Retrieved from: http://en.literateprograms.org/Quickhull_(Javascript)?oldid=18434
  */

  (function () {
    L.QuickHull = {
      /*
       * @param {Object} cpt a point to be measured from the baseline
       * @param {Array} bl the baseline, as represented by a two-element
       *   array of latlng objects.
       * @returns {Number} an approximate distance measure
       */
      getDistant: function getDistant(cpt, bl) {
        var vY = bl[1].lat - bl[0].lat,
          vX = bl[0].lng - bl[1].lng;
        return vX * (cpt.lat - bl[0].lat) + vY * (cpt.lng - bl[0].lng);
      },
      /*
       * @param {Array} baseLine a two-element array of latlng objects
       *   representing the baseline to project from
       * @param {Array} latLngs an array of latlng objects
       * @returns {Object} the maximum point and all new points to stay
       *   in consideration for the hull.
       */
      findMostDistantPointFromBaseLine: function findMostDistantPointFromBaseLine(baseLine, latLngs) {
        var maxD = 0,
          maxPt = null,
          newPoints = [],
          i,
          pt,
          d;
        for (i = latLngs.length - 1; i >= 0; i--) {
          pt = latLngs[i];
          d = this.getDistant(pt, baseLine);
          if (d > 0) {
            newPoints.push(pt);
          } else {
            continue;
          }
          if (d > maxD) {
            maxD = d;
            maxPt = pt;
          }
        }
        return {
          maxPoint: maxPt,
          newPoints: newPoints
        };
      },
      /*
       * Given a baseline, compute the convex hull of latLngs as an array
       * of latLngs.
       *
       * @param {Array} latLngs
       * @returns {Array}
       */
      buildConvexHull: function buildConvexHull(baseLine, latLngs) {
        var convexHullBaseLines = [],
          t = this.findMostDistantPointFromBaseLine(baseLine, latLngs);
        if (t.maxPoint) {
          // if there is still a point "outside" the base line
          convexHullBaseLines = convexHullBaseLines.concat(this.buildConvexHull([baseLine[0], t.maxPoint], t.newPoints));
          convexHullBaseLines = convexHullBaseLines.concat(this.buildConvexHull([t.maxPoint, baseLine[1]], t.newPoints));
          return convexHullBaseLines;
        } else {
          // if there is no more point "outside" the base line, the current base line is part of the convex hull
          return [baseLine[0]];
        }
      },
      /*
       * Given an array of latlngs, compute a convex hull as an array
       * of latlngs
       *
       * @param {Array} latLngs
       * @returns {Array}
       */
      getConvexHull: function getConvexHull(latLngs) {
        // find first baseline
        var maxLat = false,
          minLat = false,
          maxLng = false,
          minLng = false,
          maxLatPt = null,
          minLatPt = null,
          maxLngPt = null,
          minLngPt = null,
          maxPt = null,
          minPt = null,
          i;
        for (i = latLngs.length - 1; i >= 0; i--) {
          var pt = latLngs[i];
          if (maxLat === false || pt.lat > maxLat) {
            maxLatPt = pt;
            maxLat = pt.lat;
          }
          if (minLat === false || pt.lat < minLat) {
            minLatPt = pt;
            minLat = pt.lat;
          }
          if (maxLng === false || pt.lng > maxLng) {
            maxLngPt = pt;
            maxLng = pt.lng;
          }
          if (minLng === false || pt.lng < minLng) {
            minLngPt = pt;
            minLng = pt.lng;
          }
        }
        if (minLat !== maxLat) {
          minPt = minLatPt;
          maxPt = maxLatPt;
        } else {
          minPt = minLngPt;
          maxPt = maxLngPt;
        }
        var ch = [].concat(this.buildConvexHull([minPt, maxPt], latLngs), this.buildConvexHull([maxPt, minPt], latLngs));
        return ch;
      }
    };
  })();
  L.MarkerCluster.include({
    getConvexHull: function getConvexHull() {
      var childMarkers = this.getAllChildMarkers(),
        points = [],
        p,
        i;
      for (i = childMarkers.length - 1; i >= 0; i--) {
        p = childMarkers[i].getLatLng();
        points.push(p);
      }
      return L.QuickHull.getConvexHull(points);
    }
  });

  //This code is 100% based on https://github.com/jawj/OverlappingMarkerSpiderfier-Leaflet
  //Huge thanks to jawj for implementing it first to make my job easy :-)

  L.MarkerCluster.include({
    _2PI: Math.PI * 2,
    _circleFootSeparation: 25,
    //related to circumference of circle
    // _circleStartAngle: 0,
    _circleStartAngle: Math.PI / 6,
    _spiralFootSeparation: 28,
    //related to size of spiral (experiment!)
    _spiralLengthStart: 11,
    _spiralLengthFactor: 5,
    _circleSpiralSwitchover: 9,
    //show spiral instead of circle from this marker count upwards.
    // 0 -> always spiral; Infinity -> always circle

    spiderfy: function spiderfy() {
      if (this._group._isSpiderfied(this)) {
        // || this._group._inZoomAnimation) {
        return;
      }
      var childMarkers = this.getAllChildMarkers(null, true),
        group = this._group,
        map = group._map,
        center = map.latLngToLayerPoint(this._latlng),
        positions;
      this._group._addSpiderfied(this);

      //TODO Maybe: childMarkers order by distance to center

      if (childMarkers.length >= this._circleSpiralSwitchover) {
        positions = this._generatePointsSpiral(childMarkers.length, center);
      } else {
        center.y += 10; // Otherwise circles look wrong => hack for standard blue icon, renders differently for other icons.
        positions = this._generatePointsCircle(childMarkers.length, center);
      }
      this._animationSpiderfy(childMarkers, positions);
    },
    unspiderfy: function unspiderfy(zoomDetails) {
      /// <param Name="zoomDetails">Argument from zoomanim if being called in a zoom animation or null otherwise</param>

      this._animationUnspiderfy(zoomDetails);
      this._group._removeSpiderfied(this);
    },
    _generatePointsCircle: function _generatePointsCircle(count, centerPt) {
      var circumference = this._group.options.spiderfyDistanceMultiplier * this._circleFootSeparation * (2 + count),
        legLength = circumference / this._2PI,
        //radius from circumference
        angleStep = this._2PI / count,
        res = [],
        i,
        angle;
      res.length = count;
      for (i = 0; i < count; i++) {
        // Clockwise, like spiral.
        angle = this._circleStartAngle + i * angleStep;
        res[i] = new L.Point(centerPt.x + legLength * Math.cos(angle), centerPt.y + legLength * Math.sin(angle))._round();
      }
      return res;
    },
    _generatePointsSpiral: function _generatePointsSpiral(count, centerPt) {
      var spiderfyDistanceMultiplier = this._group.options.spiderfyDistanceMultiplier,
        legLength = spiderfyDistanceMultiplier * this._spiralLengthStart,
        separation = spiderfyDistanceMultiplier * this._spiralFootSeparation,
        lengthFactor = spiderfyDistanceMultiplier * this._spiralLengthFactor * this._2PI,
        angle = 0,
        res = [],
        i;
      res.length = count;

      // Higher index, closer position to cluster center.
      for (i = count; i >= 0; i--) {
        // Skip the first position, so that we are already farther from center and we avoid
        // being under the default cluster icon (especially important for Circle Markers).
        if (i < count) {
          res[i] = new L.Point(centerPt.x + legLength * Math.cos(angle), centerPt.y + legLength * Math.sin(angle))._round();
        }
        angle += separation / legLength + i * 0.0005;
        legLength += lengthFactor / angle;
      }
      return res;
    },
    _noanimationUnspiderfy: function _noanimationUnspiderfy() {
      var group = this._group,
        map = group._map,
        fg = group._featureGroup,
        childMarkers = this.getAllChildMarkers(null, true),
        m,
        i;
      group._ignoreMove = true;
      this.setOpacity(1);
      for (i = childMarkers.length - 1; i >= 0; i--) {
        m = childMarkers[i];
        fg.removeLayer(m);
        if (m._preSpiderfyLatlng) {
          m.setLatLng(m._preSpiderfyLatlng);
          delete m._preSpiderfyLatlng;
        }
        if (m.setZIndexOffset) {
          m.setZIndexOffset(0);
        }
        if (m._spiderLeg) {
          map.removeLayer(m._spiderLeg);
          delete m._spiderLeg;
        }
      }
      group.fire('unspiderfied', {
        cluster: this,
        markers: childMarkers
      });
      group._removeSpiderfied(this);
      // group._ignoreMove = false;
      // group._spiderfied = null;
    }
  });

  //Non Animated versions of everything
  L.MarkerClusterNonAnimated = L.MarkerCluster.extend({
    _animationSpiderfy: function _animationSpiderfy(childMarkers, positions) {
      var group = this._group,
        map = group._map,
        fg = group._featureGroup,
        legOptions = this._group.options.spiderLegPolylineOptions,
        i,
        m,
        leg,
        newPos;

      // Traverse in ascending order to make sure that inner circleMarkers are on top of further legs. Normal markers are re-ordered by newPosition.
      // The reverse order trick no longer improves performance on modern browsers.
      for (i = 0; i < childMarkers.length; i++) {
        newPos = map.layerPointToLatLng(positions[i]);
        m = childMarkers[i];

        // Add the leg before the marker, so that in case the latter is a circleMarker, the leg is behind it.
        leg = new L.Polyline([this._latlng, newPos], legOptions);
        map.addLayer(leg);
        m._spiderLeg = leg;

        // Now add the marker.
        m._preSpiderfyLatlng = m._latlng;
        m.setLatLng(newPos);
        if (m.setZIndexOffset) {
          m.setZIndexOffset(1000000); //Make these appear on top of EVERYTHING
        }
        fg.addLayer(m);
      }
      this.setOpacity(0.3);
      group.fire('spiderfied', {
        cluster: this,
        markers: childMarkers
      });
    },
    _animationSpiderfyOld: function _animationSpiderfyOld(childMarkers, positions) {
      var group = this._group,
        map = group._map,
        fg = group._featureGroup,
        legOptions = this._group.options.spiderLegPolylineOptions,
        i,
        m,
        leg,
        newPos;
      group._ignoreMove = true;

      // Traverse in ascending order to make sure that inner circleMarkers are on top of further legs. Normal markers are re-ordered by newPosition.
      // The reverse order trick no longer improves performance on modern browsers.
      for (i = 0; i < childMarkers.length; i++) {
        newPos = map.layerPointToLatLng(positions[i]);
        m = childMarkers[i];

        // Add the leg before the marker, so that in case the latter is a circleMarker, the leg is behind it.
        leg = new L.Polyline([this._latlng, newPos], legOptions);
        map.addLayer(leg);
        m._spiderLeg = leg;

        // Now add the marker.
        m._preSpiderfyLatlng = m._latlng;
        m.setLatLng(newPos);
        if (m.setZIndexOffset) {
          m.setZIndexOffset(1000000); //Make these appear on top of EVERYTHING
        }
        fg.addLayer(m);
      }
      this.setOpacity(0.3);
      group._ignoreMove = false;
      group.fire('spiderfied', {
        cluster: this,
        markers: childMarkers
      });
    },
    _animationUnspiderfy: function _animationUnspiderfy() {
      this._noanimationUnspiderfy();
    }
  });

  //Animated versions here
  L.MarkerCluster.include({
    _animationSpiderfy: function _animationSpiderfy(childMarkers, positions) {
      var me = this,
        group = this._group,
        map = group._map,
        fg = group._featureGroup,
        thisLayerLatLng = this._latlng,
        thisLayerPos = map.latLngToLayerPoint(thisLayerLatLng),
        svg = L.Path.SVG,
        legOptions = L.extend({}, this._group.options.spiderLegPolylineOptions),
        // Copy the options so that we can modify them for animation.
        finalLegOpacity = legOptions.opacity,
        i,
        m,
        leg,
        legPath,
        legLength,
        newPos;
      if (finalLegOpacity === undefined) {
        finalLegOpacity = L.MarkerClusterGroup.prototype.options.spiderLegPolylineOptions.opacity;
      }
      if (svg) {
        // If the initial opacity of the spider leg is not 0 then it appears before the animation starts.
        legOptions.opacity = 0;

        // Add the class for CSS transitions.
        legOptions.className = (legOptions.className || '') + ' leaflet-cluster-spider-leg';
      } else {
        // Make sure we have a defined opacity.
        legOptions.opacity = finalLegOpacity;
      }
      group._ignoreMove = true;

      // Add markers and spider legs to map, hidden at our center point.
      // Traverse in ascending order to make sure that inner circleMarkers are on top of further legs. Normal markers are re-ordered by newPosition.
      // The reverse order trick no longer improves performance on modern browsers.
      for (i = 0; i < childMarkers.length; i++) {
        m = childMarkers[i];
        newPos = map.layerPointToLatLng(positions[i]);

        // Add the leg before the marker, so that in case the latter is a circleMarker, the leg is behind it.
        leg = new L.Polyline([thisLayerLatLng, newPos], legOptions);
        map.addLayer(leg);
        m._spiderLeg = leg;

        // Explanations: https://jakearchibald.com/2013/animated-line-drawing-svg/
        // In our case the transition property is declared in the CSS file.
        if (svg) {
          legPath = leg._path;
          legLength = legPath.getTotalLength() + 0.1; // Need a small extra length to avoid remaining dot in Firefox.
          legPath.style.strokeDasharray = legLength; // Just 1 length is enough, it will be duplicated.
          legPath.style.strokeDashoffset = legLength;
        }

        // If it is a marker, add it now and we'll animate it out
        if (m.setZIndexOffset) {
          m.setZIndexOffset(1000000); // Make normal markers appear on top of EVERYTHING
        }
        if (m.clusterHide) {
          m.clusterHide();
        }

        // Vectors just get immediately added
        fg.addLayer(m);
        if (m._setPos) {
          m._setPos(thisLayerPos);
        }
      }
      group._forceLayout();
      group._animationStart();

      // Reveal markers and spider legs.
      for (i = childMarkers.length - 1; i >= 0; i--) {
        newPos = map.layerPointToLatLng(positions[i]);
        m = childMarkers[i];

        //Move marker to new position
        m._preSpiderfyLatlng = m._latlng;
        m.setLatLng(newPos);
        if (m.clusterShow) {
          m.clusterShow();
        }

        // Animate leg (animation is actually delegated to CSS transition).
        if (svg) {
          leg = m._spiderLeg;
          legPath = leg._path;
          legPath.style.strokeDashoffset = 0;
          //legPath.style.strokeOpacity = finalLegOpacity;
          leg.setStyle({
            opacity: finalLegOpacity
          });
        }
      }
      this.setOpacity(0.3);
      group._ignoreMove = false;
      setTimeout(function () {
        group._animationEnd();
        group.fire('spiderfied', {
          cluster: me,
          markers: childMarkers
        });
      }, 200);
    },
    _animationUnspiderfy: function _animationUnspiderfy(zoomDetails) {
      var me = this,
        group = this._group,
        map = group._map,
        fg = group._featureGroup,
        thisLayerPos = zoomDetails ? map._latLngToNewLayerPoint(this._latlng, zoomDetails.zoom, zoomDetails.center) : map.latLngToLayerPoint(this._latlng),
        childMarkers = this.getAllChildMarkers(null, true),
        svg = L.Path.SVG,
        m,
        i,
        leg,
        legPath,
        legLength,
        nonAnimatable;
      group._ignoreMove = true;
      group._animationStart();

      //Make us visible and bring the child markers back in
      this.setOpacity(1);
      for (i = childMarkers.length - 1; i >= 0; i--) {
        m = childMarkers[i];

        //Marker was added to us after we were spiderfied
        if (!m._preSpiderfyLatlng) {
          continue;
        }

        //Close any popup on the marker first, otherwise setting the location of the marker will make the map scroll
        m.closePopup();

        //Fix up the location to the real one
        m.setLatLng(m._preSpiderfyLatlng);
        delete m._preSpiderfyLatlng;

        //Hack override the location to be our center
        nonAnimatable = true;
        if (m._setPos) {
          m._setPos(thisLayerPos);
          nonAnimatable = false;
        }
        if (m.clusterHide) {
          m.clusterHide();
          nonAnimatable = false;
        }
        if (nonAnimatable) {
          fg.removeLayer(m);
        }

        // Animate the spider leg back in (animation is actually delegated to CSS transition).
        if (svg) {
          leg = m._spiderLeg;
          legPath = leg._path;
          legLength = legPath.getTotalLength() + 0.1;
          legPath.style.strokeDashoffset = legLength;
          leg.setStyle({
            opacity: 0
          });
        }
      }
      group._ignoreMove = false;
      setTimeout(function () {
        //If we have only <= one child left then that marker will be shown on the map so don't remove it!
        var stillThereChildCount = 0;
        for (i = childMarkers.length - 1; i >= 0; i--) {
          m = childMarkers[i];
          if (m._spiderLeg) {
            stillThereChildCount++;
          }
        }
        for (i = childMarkers.length - 1; i >= 0; i--) {
          m = childMarkers[i];
          if (!m._spiderLeg) {
            //Has already been unspiderfied
            continue;
          }
          if (m.clusterShow) {
            m.clusterShow();
          }
          if (m.setZIndexOffset) {
            m.setZIndexOffset(0);
          }
          if (stillThereChildCount > 1) {
            fg.removeLayer(m);
          }
          map.removeLayer(m._spiderLeg);
          delete m._spiderLeg;
        }
        group._animationEnd();
        group.fire('unspiderfied', {
          cluster: me,
          markers: childMarkers
        });
      }, 200);
    }
  });
  L.MarkerClusterGroup.include({
    // The MarkerCluster(s) currently spiderfied
    _spiderfied: {},
    _isSpiderfied: function _isSpiderfied(marker) {
      return this._spiderfied[marker._leaflet_id];
    },
    _addSpiderfied: function _addSpiderfied(marker) {
      this._spiderfied[marker._leaflet_id] = marker;
    },
    _removeSpiderfied: function _removeSpiderfied(marker) {
      delete this._spiderfied[marker._leaflet_id];
    },
    _spiderfierOnAdd: function _spiderfierOnAdd() {
      if (this.options.unspiderfyOnMapClick) {
        this._map.on('click', this._unspiderfyWrapper, this);
      }

      // if (this._map.options.zoomAnimation) {
      // 	this._map.on('zoomstart', this._unspiderfyZoomStart, this);
      // }
      // // Browsers without zoomAnimation or a big zoom don't fire zoomstart
      // this._map.on('zoomend', this._noanimationUnspiderfy, this);
    },
    _spiderfierOnRemove: function _spiderfierOnRemove() {
      this._map.off('click', this._unspiderfyWrapper, this);
      this._map.off('zoomstart', this._unspiderfyZoomStart, this);
      this._map.off('zoomanim', this._unspiderfyZoomAnim, this);
      this._map.off('zoomend', this._noanimationUnspiderfy, this);

      //Ensure that markers are back where they should be
      // Use no animation to avoid a sticky leaflet-cluster-anim class on mapPane
      this._noanimationUnspiderfy();
    },
    //On zoom start we add a zoomanim handler so that we are guaranteed to be last (after markers are animated)
    //This means we can define the animation they do rather than Markers doing an animation to their actual location
    _unspiderfyZoomStart: function _unspiderfyZoomStart() {
      if (!this._map) {
        //May have been removed from the map by a zoomEnd handler
        return;
      }
      this._map.on('zoomanim', this._unspiderfyZoomAnim, this);
    },
    _unspiderfyZoomAnim: function _unspiderfyZoomAnim() {
      //Wait until the first zoomanim after the user has finished touch-zooming before running the animation
      if (L.DomUtil.hasClass(this._map._mapPane, 'leaflet-touching')) {
        return;
      }
      this._map.off('zoomanim', this._unspiderfyZoomAnim, this);
    },
    _unspiderfyWrapper: function _unspiderfyWrapper() {
      /// <summary>_unspiderfy but passes no arguments</summary>
      this._unspiderfy();
    },
    _unspiderfy: function _unspiderfy(zoomDetails) {
      for (var mKey in this._spiderfied) {
        if (this._spiderfied.hasOwnProperty(mKey)) {
          this._spiderfied[mKey].unspiderfy(zoomDetails);
        }
      }
    },
    _noanimationUnspiderfy: function _noanimationUnspiderfy() {
      for (var mKey in this._spiderfied) {
        if (this._spiderfied.hasOwnProperty(mKey)) {
          this._spiderfied[mKey]._noanimationUnspiderfy();
        }
      }
    },
    //If the given layer is currently being spiderfied then we unspiderfy it so it isn't on the map anymore etc
    _unspiderfyLayer: function _unspiderfyLayer(layer) {
      if (layer._spiderLeg) {
        this._featureGroup.removeLayer(layer);
        if (layer.clusterShow) {
          layer.clusterShow();
        }
        //Position will be fixed up immediately in _animationUnspiderfy
        if (layer.setZIndexOffset) {
          layer.setZIndexOffset(0);
        }
        this._map.removeLayer(layer._spiderLeg);
        delete layer._spiderLeg;
      }
    }
  });

  /**
   * Adds 1 public method to MCG and 1 to L.Marker to facilitate changing
   * markers' icon options and refreshing their icon and their parent clusters
   * accordingly (case where their iconCreateFunction uses data of childMarkers
   * to make up the cluster icon).
   */

  L.MarkerClusterGroup.include({
    /**
     * Updates the icon of all clusters which are parents of the given marker(s).
     * In singleMarkerMode, also updates the given marker(s) icon.
     * @param layers L.MarkerClusterGroup|L.LayerGroup|Array(L.Marker)|Map(L.Marker)|
     * L.MarkerCluster|L.Marker (optional) list of markers (or single marker) whose parent
     * clusters need to be updated. If not provided, retrieves all child markers of this.
     * @returns {L.MarkerClusterGroup}
     */
    refreshClusters: function refreshClusters(layers) {
      if (!layers) {
        layers = this._topClusterLevel.getAllChildMarkers();
      } else if (layers instanceof L.MarkerClusterGroup) {
        layers = layers._topClusterLevel.getAllChildMarkers();
      } else if (layers instanceof L.LayerGroup) {
        layers = layers._layers;
      } else if (layers instanceof L.MarkerCluster) {
        layers = layers.getAllChildMarkers();
      } else if (layers instanceof L.Marker) {
        layers = [layers];
      } // else: must be an Array(L.Marker)|Map(L.Marker)
      this._flagParentsIconsNeedUpdate(layers);
      this._refreshClustersIcons();

      // In case of singleMarkerMode, also re-draw the markers.
      if (this.options.singleMarkerMode) {
        this._refreshSingleMarkerModeMarkers(layers);
      }
      return this;
    },
    /**
     * Simply flags all parent clusters of the given markers as having a "dirty" icon.
     * @param layers Array(L.Marker)|Map(L.Marker) list of markers.
     * @private
     */
    _flagParentsIconsNeedUpdate: function _flagParentsIconsNeedUpdate(layers) {
      var id, parent;

      // Assumes layers is an Array or an Object whose prototype is non-enumerable.
      for (id in layers) {
        // Flag parent clusters' icon as "dirty", all the way up.
        // Dumb process that flags multiple times upper parents, but still
        // much more efficient than trying to be smart and make short lists,
        // at least in the case of a hierarchy following a power law:
        // http://jsperf.com/flag-nodes-in-power-hierarchy/2
        parent = layers[id].__parent;
        while (parent) {
          parent._iconNeedsUpdate = true;
          parent = parent.__parent;
        }
      }
    },
    /**
     * Re-draws the icon of the supplied markers.
     * To be used in singleMarkerMode only.
     * @param layers Array(L.Marker)|Map(L.Marker) list of markers.
     * @private
     */
    _refreshSingleMarkerModeMarkers: function _refreshSingleMarkerModeMarkers(layers) {
      var id, layer;
      for (id in layers) {
        layer = layers[id];

        // Make sure we do not override markers that do not belong to THIS group.
        if (this.hasLayer(layer)) {
          // Need to re-create the icon first, then re-draw the marker.
          layer.setIcon(this._overrideMarkerIcon(layer));
        }
      }
    }
  });
  L.Marker.include({
    /**
     * Updates the given options in the marker's icon and refreshes the marker.
     * @param options map object of icon options.
     * @param directlyRefreshClusters boolean (optional) true to trigger
     * MCG.refreshClustersOf() right away with this single marker.
     * @returns {L.Marker}
     */
    refreshIconOptions: function refreshIconOptions(options, directlyRefreshClusters) {
      var icon = this.options.icon;
      L.setOptions(icon, options);
      this.setIcon(icon);

      // Shortcut to refresh the associated MCG clusters right away.
      // To be used when refreshing a single marker.
      // Otherwise, better use MCG.refreshClusters() once at the end with
      // the list of modified markers.
      if (directlyRefreshClusters && this.__parent) {
        this.__parent._group.refreshClusters(this);
      }
      return this;
    }
  });
}

/**
 * connectivity status
 * green - reported in last 30 min
 * yellow - reported in last 2 hours
 * red - hasn't reported in last 2 hours
 * grey - hasn't reported ever
 */
function getColorsByLastPostedInMinutes(feature) {
  var _feature$properties;
  var minutes = feature === null || feature === void 0 || (_feature$properties = feature.properties) === null || _feature$properties === void 0 ? void 0 : _feature$properties.lastPostedInMinutes;
  if (minutes === undefined) {
    return stateColorCode[0];
  }
  if (minutes <= 30) {
    return stateColorCode[5];
  }
  if (minutes > 30 && minutes <= 120) {
    return stateColorCode[3];
  }
  if (minutes > 120) {
    return stateColorCode[2];
  }
  if (minutes === -1) {
    return stateColorCode[1];
  }
  return stateColorCode[1];
}
function prepareGlMarker(markerIcon, feature, latlng, mapVar, onClick, addMarker) {
  if (feature) {
    var _feature$geometry;
    var _ref = markerIcon || {},
      markerColor = _ref.markerColor,
      iconColor = _ref.iconColor,
      selectedClass = _ref.selectedClass,
      dataTestId = _ref.dataTestId,
      extraClassesSvg = _ref.extraClassesSvg,
      markerBorderColor = _ref.markerBorderColor,
      icon = _ref.icon,
      data = _ref.data;
    var _ref2 = data || {},
      value = _ref2.value,
      valueColor = _ref2.valueColor;
    var x = 10;
    if (markerIcon !== null && markerIcon !== void 0 && markerIcon.data && typeof (markerIcon === null || markerIcon === void 0 ? void 0 : markerIcon.data.value) !== 'undefined') {
      if (Number(value) === 0) {
        x = 14;
      } else if (Number(value) >= 100) {
        x = 7;
      } else if (Number(value) >= 10) {
        x = 11;
      } else if (String(value).split('').length === 1) {
        x = 14;
      } else {
        x = 10;
      }
    }
    var divElem = document.createElement('div');
    var borderColor = markerBorderColor || markerColor;
    var iconElem = "<div data-test-id=\"".concat(dataTestId, "\" class=\"vector-markericon vector-marker leaflet-zoom-animated ").concat(selectedClass, " leaflet-interactive\" tabindex=\"0\" role=\"button\">\n            <svg width=\"35px\" height=\"40px\" class=\"").concat(extraClassesSvg, "\" viewBox=\"0 0 35 40\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n              <path class=\"pin-outer marker-pin-outer-").concat(dataTestId, "\" d=\"M6.19,28.81a16,16,0,1,1,22.63,0L17.5,40.13Z\" fill=\"").concat(borderColor, "\"></path>\n              <path class=\"pin-inner marker-pin-inner-").concat(dataTestId, "\" d=\"M7.9,27.1a13.58,13.58,0,1,1,19.21,0l-9.6,9.6Z\" fill=\"").concat(markerColor, "\"></path>\n              ").concat(markerIcon !== null && markerIcon !== void 0 && markerIcon.data ? "<text x=\"".concat(x, "\" y=\"22\" fill=\"").concat(valueColor, "\" font-weight=\"bold\">").concat(value, "</text>") : '', "\n            </svg>\n            ").concat(!(markerIcon !== null && markerIcon !== void 0 && markerIcon.data) ? "<i class=\" icon  ".concat(icon, "  icon-").concat(iconColor, "\"></i>") : '', "\n          </div>");
    divElem.innerHTML = iconElem;
    divElem.className = 'marker';
    divElem.addEventListener('click', function (e) {
      onClick(feature);
      e.stopPropagation();
    }, false);
    if (addMarker) {
      // add marker to map
      new maplibregl$1.Marker({
        element: divElem
      }).setLngLat(latlng).addTo(mapVar);
    }

    // return divElem;
    var newLatlng = [latlng === null || latlng === void 0 ? void 0 : latlng.lng, latlng === null || latlng === void 0 ? void 0 : latlng.lat];
    return _defineProperty({}, newLatlng, [{
      id: feature === null || feature === void 0 ? void 0 : feature.id,
      type: divElem,
      color: iconColor,
      center: feature === null || feature === void 0 || (_feature$geometry = feature.geometry) === null || _feature$geometry === void 0 ? void 0 : _feature$geometry.coordinates,
      feature: feature
    }]);
  }
  return null;
}
function prepareMarker(feature, latlng, presentationMode, isSelected, mapVar, onClick, getUserUnits) {
  var _feature$properties16, _feature$properties17, _feature$properties18, _feature$id;
  var addMarker = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : true;
  var marker;
  var opts = {};
  opts.markerColor = '#fff';
  opts.iconColor = '#000';
  opts.selected = false;
  switch (presentationMode) {
    case 'initial':
      {
        opts.markerColor = 'gray';
        opts.iconColor = 'white';
        break;
      }
    case 'soilstatus':
      {
        var _feature$properties2, _feature$properties3;
        // if soil sensors
        if (['aquacheck_soil', 'pixl_soil'].includes(feature === null || feature === void 0 || (_feature$properties2 = feature.properties) === null || _feature$properties2 === void 0 ? void 0 : _feature$properties2.type) && feature !== null && feature !== void 0 && (_feature$properties3 = feature.properties) !== null && _feature$properties3 !== void 0 && _feature$properties3.block) {
          var _feature$properties4 = feature === null || feature === void 0 ? void 0 : feature.properties,
            soilState = _feature$properties4.soil_state;
          if (!soilState) {
            opts.markerColor = 'gray';
            opts.iconColor = 'white';
            break;
          }
          opts.markerColor = getColorCodeForSoilState(soilState);
          opts.iconColor = 'white';
          break;
        }
        opts.markerColor = 'white';
        opts.iconColor = 'black';
        break;
      }
    case 'connectivity':
      {
        var color = getColorsByLastPostedInMinutes(feature);
        opts.markerColor = color.markerColor;
        opts.iconColor = 'white';
        break;
      }
    case 'waterpressure':
      {
        var _feature$properties5;
        opts.markerColor = 'gray';
        opts.iconColor = 'black';
        if ((feature === null || feature === void 0 || (_feature$properties5 = feature.properties) === null || _feature$properties5 === void 0 ? void 0 : _feature$properties5.water_pressure) !== undefined) {
          var _feature$properties6, _feature$properties7, _feature$properties8;
          opts.data = {};
          var convertedWaterPressure = getUserUnits(feature === null || feature === void 0 || (_feature$properties6 = feature.properties) === null || _feature$properties6 === void 0 ? void 0 : _feature$properties6.water_pressure, 'pounds_per_square_inch', 'pressure', {
            decimalPlaces: 2
          });
          opts.data.value = convertedWaterPressure.value;
          opts.data.valueColor = (feature === null || feature === void 0 || (_feature$properties7 = feature.properties) === null || _feature$properties7 === void 0 ? void 0 : _feature$properties7.waterPressureRatio) < 0.5 ? 'black' : 'white';
          if (feature !== null && feature !== void 0 && (_feature$properties8 = feature.properties) !== null && _feature$properties8 !== void 0 && _feature$properties8.waterPressureColor) {
            opts.markerColor = feature.properties.waterPressureColor;
          }
        }
        break;
      }
    case 'control':
      {
        var _feature$properties9, _feature$properties10, _feature$properties13;
        if (feature !== null && feature !== void 0 && (_feature$properties9 = feature.properties) !== null && _feature$properties9 !== void 0 && _feature$properties9.online) {
          opts.markerColor = 'white';
          opts.iconColor = 'black';
        } else {
          opts.markerColor = 'gray';
          opts.iconColor = 'black';
        }
        if ((feature === null || feature === void 0 || (_feature$properties10 = feature.properties) === null || _feature$properties10 === void 0 ? void 0 : _feature$properties10.type) === 'water_pressure') {
          var _feature$properties11;
          if ((feature === null || feature === void 0 || (_feature$properties11 = feature.properties) === null || _feature$properties11 === void 0 ? void 0 : _feature$properties11.water_pressure) !== undefined) {
            var _feature$properties12;
            opts.data = {};
            var _convertedWaterPressure = getUserUnits(feature.properties.water_pressure, 'pounds_per_square_inch', 'pressure', {
              decimalPlaces: 2
            });
            opts.data.value = _convertedWaterPressure.value;
            opts.data.valueColor = feature.properties.waterPressureRatio < 0.5 ? 'black' : 'white';
            if (feature !== null && feature !== void 0 && (_feature$properties12 = feature.properties) !== null && _feature$properties12 !== void 0 && _feature$properties12.waterPressureColor) {
              opts.markerColor = feature.properties.waterPressureColor;
            }
          }
        } else if (feature !== null && feature !== void 0 && (_feature$properties13 = feature.properties) !== null && _feature$properties13 !== void 0 && _feature$properties13.controlSateON) {
          opts.markerColor = '#3C61B4';
          opts.iconColor = 'white';
        }
        break;
      }
    case 'provision':
      {
        var _feature$properties14;
        opts.iconColor = 'white';
        opts.markerColor = '#e23549';
        if (feature !== null && feature !== void 0 && (_feature$properties14 = feature.properties) !== null && _feature$properties14 !== void 0 && _feature$properties14.provisioned) {
          opts.markerColor = '#3dc873';
        }
        break;
      }
    case 'anomaly':
      {
        var _feature$properties15;
        opts.markerColor = getAnomalyIconColorBySeverity(feature === null || feature === void 0 || (_feature$properties15 = feature.properties) === null || _feature$properties15 === void 0 ? void 0 : _feature$properties15.anomaly_severity);
        opts.iconColor = 'white';
        break;
      }
    case 'cropHealth':
      {
        var _ref4 = feature !== null && feature !== void 0 && feature.properties ? feature === null || feature === void 0 ? void 0 : feature.properties : {},
          cropStress = _ref4.crop_stress;
        var cropState = getCropStateByStress(new Set([cropStress]));
        var cropHealthColor = stateColorCode[cropState] || {};
        opts.iconColor = cropHealthColor.iconColor;
        opts.markerColor = cropHealthColor.markerColor;
        break;
      }
    default:
      {
        opts.markerColor = '#fff';
        opts.iconColor = '#000';
        opts.selected = false;
      }
  }
  if (feature !== null && feature !== void 0 && (_feature$properties16 = feature.properties) !== null && _feature$properties16 !== void 0 && _feature$properties16.alarm_count) {
    opts.markerBorderColor = 'red';
  }
  var markerIcon = L$1.VectorMarkers.icon({
    icon: presentationMode === 'anomaly' ? getAnomalyIcon(feature === null || feature === void 0 || (_feature$properties17 = feature.properties) === null || _feature$properties17 === void 0 ? void 0 : _feature$properties17.anomaly_type) : (icons === null || icons === void 0 ? void 0 : icons[feature === null || feature === void 0 || (_feature$properties18 = feature.properties) === null || _feature$properties18 === void 0 ? void 0 : _feature$properties18.type]) || 'icon-radio-waves',
    prefix: 'icon',
    markerColor: opts === null || opts === void 0 ? void 0 : opts.markerColor,
    iconColor: opts === null || opts === void 0 ? void 0 : opts.iconColor,
    dataTestId: feature === null || feature === void 0 || (_feature$id = feature.id) === null || _feature$id === void 0 || (_feature$id = _feature$id.split('/')) === null || _feature$id === void 0 ? void 0 : _feature$id.join('-'),
    selected: opts === null || opts === void 0 ? void 0 : opts.selected,
    selectedClass: isSelected ? 'marker-is-selected' : '',
    data: opts === null || opts === void 0 ? void 0 : opts.data,
    markerBorderColor: opts === null || opts === void 0 ? void 0 : opts.markerBorderColor
  });

  // Maintain consistent order of icon elements rendering across browsers
  var divElem = document.createElement('div');
  var borderColor = markerIcon.options.markerBorderColor || markerIcon.options.markerColor;
  var iconElem = "<div data-test-id=\"".concat(markerIcon.options.dataTestId, "\" class=\"vector-markericon vector-marker leaflet-zoom-animated ").concat(markerIcon.options.selectedClass, " leaflet-interactive\"  style=\"top: 11px;\"tabindex=\"0\" role=\"button\">\n            <svg width=\"35px\" height=\"40px\" class=\"").concat(markerIcon.options.extraClassesSvg, "\" viewBox=\"0 0 35 40\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n              <path class=\"pin-outer marker-pin-outer-").concat(markerIcon.options.dataTestId, "\" d=\"M6.19,28.81a16,16,0,1,1,22.63,0L17.5,40.13Z\" fill=\"").concat(borderColor, "\"></path>\n              <path class=\"pin-inner marker-pin-inner-").concat(markerIcon.options.dataTestId, "\" d=\"M7.9,27.1a13.58,13.58,0,1,1,19.21,0l-9.6,9.6Z\" fill=\"").concat(markerIcon.options.markerColor, "\"></path>\n                    ").concat(markerIcon.options.data ? "<text x=\"14\" y=\"22\" fill=\"".concat(markerIcon.options.iconColor, "\" font-weight=\"bold\">").concat(markerIcon.options.data, "</text>") : '', "\n            </svg>\n            ").concat(!markerIcon.options.data ? "<i class=\" icon ".concat(markerIcon.options.icon, " icon-").concat(markerIcon.options.iconColor, " \"></i>") : '', "\n          </div>");
  divElem.innerHTML = iconElem;
  divElem.className = 'marker';
  if (mapVar && !(mapVar !== null && mapVar !== void 0 && mapVar.leafletElement)) {
    marker = prepareGlMarker(markerIcon === null || markerIcon === void 0 ? void 0 : markerIcon.options, feature, latlng, mapVar, onClick, addMarker);
  } else {
    // eslint-disable-next-line new-cap
    marker = new L$1.marker(latlng, {
      icon: markerIcon
    });
    marker.setIcon(L$1.divIcon({
      html: divElem.innerHTML,
      className: ''
    }));
  }
  return marker;
}
function prepareSingleMarkerIcon() {
  var opts = {};
  opts.markerColor = '#fff';
  opts.iconColor = '#000';
  opts.selected = false;
  return L$1.VectorMarkers.icon({
    icon: 'icon-radio-waves',
    prefix: 'icon',
    markerColor: opts.markerColor,
    iconColor: opts.iconColor,
    dataTestId: 'single-marker',
    selected: opts.selected
  });
}

var createDivIcon = function createDivIcon(markersLength, c) {
  return new L$1.DivIcon({
    html: "<div><span>".concat(markersLength, "</span></div>"),
    className: "marker-cluster ".concat(c),
    iconSize: new L$1.Point(40, 40)
  });
};
function getColorForClassName(className) {
  switch (className) {
    case 'marker-cluster-critical':
      return {
        color: '#e8101e',
        bgColor: 'rgba(226, 53, 73, 0.6)'
      };
    case 'marker-cluster-bad':
      return {
        color: '#fa8c16',
        bgColor: 'rgba(226, 53, 73, 0.6)'
      };
    case 'marker-cluster-warning':
      return {
        color: '#fadb14',
        bgColor: 'rgba(255, 204, 0, 0.6)'
      };
    case 'marker-cluster-over':
      return {
        color: '#1890FF',
        bgColor: 'rgba(66, 154, 255, 0.6)'
      };
    case 'marker-cluster-good':
      return {
        color: 'green',
        bgColor: 'rgba(61, 200, 115, 0.6)'
      };
    default:
      return {
        color: 'white',
        bgColor: 'rgba(255, 255, 255, 0.6)'
      };
  }
}
function prepareMarkerClusterIconColor(presentationMode, childCount, markers) {
  var c = 'rgba(253, 156, 115, 0.6)';
  if (childCount < 10) {
    c += 'rgba(181, 226, 140, 0.6)';
  } else if (childCount < 100) {
    c += 'rgba(241, 211, 87, 0.6)';
  } else {
    c += 'rgba(253, 156, 115, 0.6)';
  }
  var _calculateGroupStateF = calculateGroupStateForPresentationModes(markers),
    connectivityState = _calculateGroupStateF.connectivityState,
    waterPressureState = _calculateGroupStateF.waterPressureState,
    provisionState = _calculateGroupStateF.provisionState,
    soilState = _calculateGroupStateF.soilState,
    controlState = _calculateGroupStateF.controlState;
  if (presentationMode === 'initial') {
    c = 'rgba(255, 255, 255, 0.6)';
    return c;
  }
  if (presentationMode === 'soilstatus') {
    switch (soilState) {
      case 1:
        c = getColorForClassName('marker-cluster-critical');
        break;
      case 2:
        c = getColorForClassName('marker-cluster-bad');
        break;
      case 3:
        c = getColorForClassName('marker-cluster-warning');
        break;
      case 4:
        c = getColorForClassName('marker-cluster-over');
        break;
      case 5:
        c = getColorForClassName('marker-cluster-good');
        break;
      default:
        c = getColorForClassName('marker-cluster-unknown');
    }
    return c;
  }
  if (presentationMode === 'connectivity') {
    switch (connectivityState) {
      case 0:
        c = getColorForClassName('marker-cluster-unknown');
        break;
      case -1:
        c = getColorForClassName('marker-cluster-offline');
        break;
      case 2:
        c = getColorForClassName('marker-cluster-critical');
        break;
      case 3:
        c = getColorForClassName('marker-cluster-warning');
        break;
      case 5:
        c = getColorForClassName('marker-cluster-good');
        break;
      default:
        c = getColorForClassName('marker-cluster-unknown');
    }
    return c;
  }
  if (presentationMode === 'waterpressure') {
    switch (waterPressureState) {
      case 0:
        c = getColorForClassName('marker-cluster-unknown');
        break;
      case 4:
        c = getColorForClassName('marker-cluster-over');
        break;
      default:
        c = getColorForClassName('marker-cluster-unknown');
    }
    return c;
  }
  if (presentationMode === 'control') {
    switch (controlState) {
      case 0:
        c = getColorForClassName('marker-cluster-unknown');
        break;
      case 4:
        c = getColorForClassName('marker-cluster-over');
        break;
      default:
        c = getColorForClassName('marker-cluster-unknown');
    }
    return c;
  }
  if (presentationMode === 'provision') {
    switch (provisionState) {
      case 2:
        c = getColorForClassName('marker-cluster-critical');
        break;
      case 5:
        c = getColorForClassName('marker-cluster-good');
        break;
      default:
        c = getColorForClassName('marker-cluster-unknown');
    }
    return c;
  }

  // Default cluster icon color at All ranches level
  // for Irrigation Recommendation, Crop Health, Plants map settings
  return getColorForClassName(c);
}
var prepareMarkerClusterIcon = function prepareMarkerClusterIcon(presentationMode) {
  return function (cluster) {
    var childCount = cluster.getChildCount();
    var c = 'marker-cluster-';
    if (childCount < 10) {
      c += 'small';
    } else if (childCount < 100) {
      c += 'medium';
    } else {
      c += 'large';
    }
    var markers = cluster.getAllChildMarkers();
    var markersLength = markers.length;
    var _calculateGroupStateF2 = calculateGroupStateForPresentationModes(markers, true),
      connectivityState = _calculateGroupStateF2.connectivityState,
      waterPressureState = _calculateGroupStateF2.waterPressureState,
      provisionState = _calculateGroupStateF2.provisionState,
      soilState = _calculateGroupStateF2.soilState,
      controlState = _calculateGroupStateF2.controlState;
    if (presentationMode === 'initial') {
      c = 'marker-cluster-unknown';
      return createDivIcon(markersLength, c);
    }
    if (presentationMode === 'soilstatus') {
      switch (soilState) {
        case 1:
          c = 'marker-cluster-critical';
          break;
        case 2:
          c = 'marker-cluster-bad';
          break;
        case 3:
          c = 'marker-cluster-warning';
          break;
        case 4:
          c = 'marker-cluster-over';
          break;
        case 5:
          c = 'marker-cluster-good';
          break;
        default:
          c = 'marker-cluster-unknown';
      }
      return createDivIcon(markersLength, c);
    }
    if (presentationMode === 'connectivity') {
      switch (connectivityState) {
        case 0:
          c = 'marker-cluster-unknown';
          break;
        case -1:
          c = 'marker-cluster-offline';
          break;
        case 2:
          c = 'marker-cluster-critical';
          break;
        case 3:
          c = 'marker-cluster-warning';
          break;
        case 5:
          c = 'marker-cluster-good';
          break;
        default:
          c = 'marker-cluster-unknown';
      }
      return createDivIcon(markersLength, c);
    }
    if (presentationMode === 'waterpressure') {
      switch (waterPressureState) {
        case 0:
          c = 'marker-cluster-unknown';
          break;
        case 4:
          c = 'marker-cluster-over';
          break;
        default:
          c = 'marker-cluster-unknown';
      }
      return createDivIcon(markersLength, c);
    }
    if (presentationMode === 'control') {
      switch (controlState) {
        case 0:
          c = 'marker-cluster-unknown';
          break;
        case 4:
          c = 'marker-cluster-over';
          break;
        default:
          c = 'marker-cluster-unknown';
      }
      return createDivIcon(markersLength, c);
    }
    if (presentationMode === 'provision') {
      switch (provisionState) {
        case 2:
          c = 'marker-cluster-critical';
          break;
        case 5:
          c = 'marker-cluster-good';
          break;
        default:
          c = 'marker-cluster-unknown';
      }
      return createDivIcon(markersLength, c);
    }
    return createDivIcon(markersLength, c);
  };
};

leafletMarkerClusterGroup(L$1);
var shouldSpiderfy = function shouldSpiderfy(c) {
  return c.getChildCount() < 7;
};
function MarkerCluster(_ref) {
  var sensorsGeoJSON = _ref.sensorsGeoJSON,
    showAllSensorLabels = _ref.showAllSensorLabels,
    activePopUp = _ref.activePopUp,
    selectSensor = _ref.selectSensor,
    showPopUpOnMarkerClick = _ref.showPopUpOnMarkerClick,
    presentationMode = _ref.presentationMode,
    selectedSensor = _ref.selectedSensor,
    refreshMap = _ref.refreshMap;
  var marketClusterGroup = L$1.markerClusterGroup({
    maxClusterRadius: 35,
    unspiderfyOnMapClick: false,
    shouldSpiderfy: shouldSpiderfy,
    animate: false,
    iconCreateFunction: prepareMarkerClusterIcon(presentationMode),
    spiderLegPolylineOptions: {
      weight: 1.5,
      color: '#eee',
      opacity: 0.8
    },
    polygonOptions: {
      stroke: false,
      fill: false
    }
  });
  var _useLeaflet = useLeaflet(),
    map = _useLeaflet.map;
  var prevsensorsGeoJSON = useRef(JSON.stringify({}));
  var markers = useRef([]);
  var onMarkerPopupOpen = function onMarkerPopupOpen(_ref2) {
    var _ref2$target$feature$ = _ref2.target.feature.properties,
      type = _ref2$target$feature$.type,
      identifier = _ref2$target$feature$.identifier;
    selectSensor(type, identifier);
  };
  useEffect(function () {
    var destroy = function destroy() {
      markers.current.forEach(function (marker) {
        marker.off('popupopen', onMarkerPopupOpen);
      });
      marketClusterGroup.clearLayers();
    };
    return destroy;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(function () {
    markers.current.forEach(function (marker) {
      if (marker.unbindTooltip) {
        marker.unbindTooltip();
      }
    });
    if (showAllSensorLabels) {
      markers.current.forEach(function (marker) {
        marker.bindTooltip(getMarkerTooltipByPresentationMode(marker.feature, presentationMode), {
          direction: 'auto',
          permanent: true,
          className: "".concat(marker.feature.properties.type, "-").concat(marker.feature.properties.identifier)
        });
      });
    }
  }, [showAllSensorLabels]);
  useEffect(function () {
    if (typeof sensorsGeoJSON === 'undefined') {
      marketClusterGroup.clearLayers();
      markers.current = [];
      return;
    }
    var sensorsGeoJSONString = JSON.stringify(sensorsGeoJSON);
    if (prevsensorsGeoJSON.current !== sensorsGeoJSONString) {
      marketClusterGroup.clearLayers();
      markers.current = [];

      // eslint-disable-next-line no-param-reassign
      sensorsGeoJSON.features = sensorsGeoJSON.features.filter(function (feature) {
        return feature.geometry.coordinates[0] && feature.geometry.coordinates[1];
      });
      if (!sensorsGeoJSON.features.length) {
        return;
      }
      var geojson = L$1.geoJSON(sensorsGeoJSON, {
        pointToLayer: function pointToLayer(feature, latlng) {
          var marker = prepareMarker(feature, latlng, presentationMode);
          markers.current.push(marker);
          if (showPopUpOnMarkerClick) {
            var popupContent = "<div class=\"popup-inner\" data-test-id=\"popup-".concat(feature.id, "\">\n              <div class=\"popup-title\">").concat(feature.properties.type, "</div>\n              <div>").concat(feature.properties.identifier, "</div>\n              <div class=\"popup-location\">").concat(feature.geometry.coordinates[1], ", ").concat(feature.geometry.coordinates[0], "</div>\n              </div>");
            marker.bindPopup(popupContent, {
              autoPan: false
            });
          }
          if (showAllSensorLabels) {
            marker.bindTooltip(getMarkerTooltipByPresentationMode(feature, presentationMode), {
              direction: 'auto',
              permanent: true,
              className: "".concat(feature.properties.type, "-").concat(feature.properties.identifier)
            });
          } else if (presentationMode === 'connectivity') {
            marker.bindTooltip(feature.properties.name || 'NO NAME', {
              direction: 'auto',
              permanent: false,
              className: "".concat(feature.properties.type, "-").concat(feature.properties.identifier)
            });
          }
          marker.on('click', onMarkerPopupOpen);
          return marker;
        }
      });
      marketClusterGroup.addLayer(geojson);
      map.addLayer(marketClusterGroup);
      map.setZoom(Math.round(map.getZoom()));
      prevsensorsGeoJSON.current = sensorsGeoJSONString;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sensorsGeoJSON]);
  useEffect(function () {
    if (activePopUp === Object(activePopUp) && activePopUp.identifier) {
      var identifier = activePopUp.identifier;
      var markersLength = markers.current.length;
      for (var i = 0; i < markersLength; i += 1) {
        var marker = markers.current[i];
        if (marker.feature.properties.identifier === identifier) {
          marker.openPopup();
          break;
        }
      }
    }
  }, [activePopUp, map]);
  useEffect(function () {
    markers.current.forEach(function (marker) {
      var iconOpts = marker.getIcon().options;
      if (selectedSensor && marker.feature.properties.identifier === selectedSensor.properties.identifier && marker.feature.properties.type === selectedSensor.properties.type) {
        marker.setIcon(L$1.VectorMarkers.icon(_objectSpread2(_objectSpread2({}, iconOpts), {}, {
          selected: true
        })));
      } else if (iconOpts.selected) {
        marker.setIcon(L$1.VectorMarkers.icon(_objectSpread2(_objectSpread2({}, iconOpts), {}, {
          selected: false
        })));
      }
    });
  }, [selectedSensor]);
  refreshMap();
  return null;
}
MarkerCluster.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  activePopUp: PropTypes.object,
  selectSensor: PropTypes.func,
  showAllSensorLabels: PropTypes.bool,
  sensorsGeoJSON: PropTypes.shape({
    type: PropTypes.string,
    features: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      type: PropTypes.string,
      geometry: PropTypes.shape({
        coordinates: PropTypes.arrayOf(PropTypes.number),
        type: PropTypes.string
      }),
      properties: PropTypes.object
    }))
  }),
  showPopUpOnMarkerClick: PropTypes.bool,
  presentationMode: PropTypes.string,
  refreshMap: PropTypes.func.isRequired,
  selectedSensor: PropTypes.any
};
MarkerCluster.defaultProps = {
  activePopUp: undefined,
  selectSensor: undefined,
  showAllSensorLabels: undefined,
  sensorsGeoJSON: undefined,
  showPopUpOnMarkerClick: true,
  presentationMode: undefined,
  selectedSensor: undefined
};

/* eslint-disable */

/**
 * Source for the original can be found here https://github.com/mutsuyuki/Leaflet.SmoothWheelZoom
 * This is modified version from the Farmx angular application
 */
function leafletVectorMarkers(L) {
  if (L.VectorMarkers) {
    return;
  }
  L.VectorMarkers = {};
  L.VectorMarkers.version = "1.0.0";
  L.VectorMarkers.MAP_PIN = 'M6.19,28.81a16,16,0,1,1,22.63,0L17.5,40.13Z';
  L.VectorMarkers.PIN_INNER = 'M7.9,27.1a13.58,13.58,0,1,1,19.21,0l-9.6,9.6Z';
  L.VectorMarkers.Icon = L.Icon.extend({
    options: {
      iconSize: [32, 40],
      iconAnchor: [16, 40],
      popupAnchor: [2, -40],
      shadowAnchor: [24, 24],
      shadowSize: [32, 40],
      className: "vector-marker",
      prefix: "fa",
      spinClass: "fa-spin",
      extraClasses: "",
      extraClassesSvg: "",
      icon: "home",
      markerColor: "blue",
      iconColor: "white",
      selected: false,
      selectedClass: '',
      data: undefined
    },
    initialize: function initialize(options) {
      return options = L.Util.setOptions(this, options);
    },
    createIcon: function createIcon(oldIcon) {
      var div, icon, options, pin_path, pin_inner;
      div = oldIcon && oldIcon.tagName === "DIV" ? oldIcon : document.createElement("div");
      options = this.options;
      div.setAttribute('data-test-id', "marker-".concat(options.dataTestId));
      if (options.data && typeof options.data.value !== 'undefiend') {
        var x = 10;
        if (Number(options.data.value) === 0) {
          x = 14;
        } else if (Number(options.data.value) >= 100) {
          x = 7;
        } else if (Number(options.data.value) >= 10) {
          x = 11;
        } else if (String(options.data.value).split('').length === 1) {
          x = 14;
        } else {
          x = 10;
        }
        icon = "<text x=\"".concat(x, "\" y=\"22\" fill=\"").concat(options.data.valueColor, "\" font-weight=\"bold\">").concat(options.data.value, "</text>");
      } else if (options.icon) {
        icon = this._createInner();
      }
      pin_path = L.VectorMarkers.MAP_PIN;
      pin_inner = L.VectorMarkers.PIN_INNER;
      var borderColor = options.markerBorderColor || options.markerColor;
      if (icon) {
        div.innerHTML = '<svg width="35px" height="40px" ' + "class=\"".concat(options.extraClassesSvg, "\"") + ' viewBox="0 0 35 40" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">' + '<path class="pin-outer ' + "marker-pin-outer-".concat(options.dataTestId) + '" d="' + pin_path + '" fill="' + borderColor + '"></path>' + '<path class="pin-inner ' + "marker-pin-inner-".concat(options.dataTestId) + '" d="' + pin_inner + '" fill="' + options.markerColor + '"></path>' + icon + '</svg>';
      } else {
        div.innerHTML = '<svg width="35px" height="40px" ' + "class=\"".concat(options.extraClassesSvg, "\"") + ' viewBox="0 0 35 40" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">' + '<path class="pin-outer ' + "marker-pin-outer-".concat(options.dataTestId) + '" d="' + pin_path + '" fill="gray"></path>' + '<path class="pin-inner ' + "marker-pin-inner-".concat(options.dataTestId) + '" d="' + pin_inner + '" fill="gray"></path>' + '<text x="7" y="22" fill="white" font-weight="bold">N/A</text>' + '</svg>';
      }
      this._setIconStyles(div, "icon");
      if (options.selected) {
        this._setIconStyles(div, " selected-icon");
      }
      return div;
    },
    _createInner: function _createInner() {
      var iconClass, iconColorClass, iconColorStyle, iconSpinClass, options;
      iconClass = void 0;
      iconSpinClass = "";
      iconColorClass = "";
      iconColorStyle = "";
      var options = this.options;
      if (options.data) {
        return;
      }
      if (options.icon.slice(0, options.prefix.length + 1) === options.prefix + "-") {
        iconClass = options.icon;
      } else {
        iconClass = options.prefix + "-" + options.icon;
      }
      if (options.spin && typeof options.spinClass === "string") {
        iconSpinClass = options.spinClass;
      }
      if (options.iconColor) {
        if (options.iconColor === "white" || options.iconColor === "black") {
          iconColorClass = "icon-" + options.iconColor;
        } else {
          iconColorStyle = "style='color: " + options.iconColor + "' ";
        }
      }
      return "<i " + iconColorStyle + "class='" + options.extraClasses + " " + options.prefix + " " + iconClass + " " + iconSpinClass + " " + iconColorClass + "'></i>";
    },
    _setIconStyles: function _setIconStyles(img, name) {
      var anchor, options, size;
      options = this.options;
      size = L.point(options[name === "shadow" ? "shadowSize" : "iconSize"]);
      anchor = void 0;
      if (name === "shadow") {
        anchor = L.point(options.shadowAnchor || options.iconAnchor);
      } else {
        anchor = L.point(options.iconAnchor);
      }
      if (!anchor && size) {
        anchor = size.divideBy(2, true);
      }
      img.className = "vector-marker" + name + " " + options.className;
      if (options.selectedClass) {
        img.classList.add(options.selectedClass);
      }
      if (anchor) {
        img.style.marginLeft = -anchor.x + "px";
        img.style.marginTop = -anchor.y + "px";
      }
      if (size) {
        img.style.width = size.x + "px";
        return img.style.height = size.y + "px";
      }
    },
    createShadow: function createShadow() {
      var div;
      div = document.createElement("div");
      this._setIconStyles(div, "shadow");
      return div;
    }
  });
  L.VectorMarkers.icon = function (options) {
    return new L.VectorMarkers.Icon(options);
  };
}

/* 
 * Workaround for 1px lines appearing in some browsers due to fractional transforms
 * and resulting anti-aliasing.
 * https://github.com/Leaflet/Leaflet/issues/3575
 */
(function () {
  var originalInitTile = L.GridLayer.prototype._initTile;
  L.GridLayer.include({
    _initTile: function _initTile(tile) {
      originalInitTile.call(this, tile);
      var tileSize = this.getTileSize();
      tile.style.width = tileSize.x + 1 + 'px';
      tile.style.height = tileSize.y + 1 + 'px';
    }
  });
})();

function AnomalyLayer(props) {
  var anomalyGeoJSON = props.anomalyGeoJSON,
    presentationMode = props.presentationMode,
    isShowingImagery = props.isShowingImagery,
    zoomShowSensorsState = props.zoomShowSensorsState,
    onClickBlock = props.onClickBlock,
    setState = props.setState,
    mapState = props.mapState,
    mapRef = props.mapRef,
    previousZoom = props.previousZoom,
    deleteAnomaly = props.deleteAnomaly,
    onSelectAnomaly = props.onSelectAnomaly,
    createAnomaly = props.createAnomaly,
    onDrawAnomaly = props.onDrawAnomaly,
    userAreaUnit = props.userAreaUnit;
  var selectedPolygons = useRef([]);
  var isDelete = useRef(false);
  var polygonDrawer = useRef(false);
  var _ref = anomalyGeoJSON || {},
    anomalyArea = _ref.anomaly_area,
    coords = _ref.coords,
    properties = _ref.properties;
  var _ref2 = properties || {},
    anomlayAreaList = _ref2.anomaly_aoi_list;
  var isAnomalyArea = anomalyArea || coords;
  var feature = anomalyGeoJSON;
  function getAnomalyPolygonStyle(anomalySeverity) {
    var style = {
      color: anomalySeverity ? getAnomalyIconColorBySeverity(anomalySeverity) : '#3388ff',
      dashArray: '0',
      weight: 3,
      opacity: 1.0,
      fillColor: !anomalyArea ? '#000000' : getAnomalyIconColorBySeverity(anomalySeverity),
      fillOpacity: !anomalyArea ? 0.0 : 0.5,
      editing: {
        dashArray: '10, 10',
        fill: true,
        fillColor: '#fe57a1',
        fillOpacity: 0.1,
        maintainColor: false
      }
    };
    return style;
  }
  var selected = false;
  // To fix the block boundary visible on anomaly detail page
  var dataToRender = [];
  if ((feature === null || feature === void 0 ? void 0 : feature.type) === 'FeatureCollection' && !anomalyArea) {
    dataToRender = feature.features.filter(function (d) {
      return d && d.properties.anomaly_type;
    });
  } else if (anomalyArea) dataToRender = anomlayAreaList || anomalyArea;else dataToRender = feature ? [feature] : [];
  function setElementStyle(elem, styleObj) {
    elem.setAttribute('stroke', styleObj.stroke);
    elem.setAttribute('fill', styleObj.fill);
    elem.setAttribute('fill-opacity', styleObj.opacity);
  }
  function onClickAnomaly(d) {
    if (d && isDelete.current) {
      var _ids;
      var ids = [];
      if (selectedPolygons.current.length) {
        ids = selectedPolygons.current.map(function (e) {
          return e._leaflet_id;
        });
      }
      if (!((_ids = ids) !== null && _ids !== void 0 && _ids.includes(d._leaflet_id))) {
        selectedPolygons.current.push(d);
        var elem = d._path;
        setElementStyle(elem, {
          stroke: '#fe57a1',
          fill: '#fe57a1',
          opacity: 0.5
        });
        if (selectedPolygons.current.length && onSelectAnomaly) {
          onSelectAnomaly({
            enable: false
          });
        }
      } else {
        var _d$feature;
        var _elem = d._path;
        // eslint-disable-next-line camelcase
        var polygonColor = getAnomalyPolygonStyle(d === null || d === void 0 || (_d$feature = d.feature) === null || _d$feature === void 0 || (_d$feature = _d$feature.properties) === null || _d$feature === void 0 ? void 0 : _d$feature.anomaly_severity);
        setElementStyle(_elem, {
          stroke: (polygonColor === null || polygonColor === void 0 ? void 0 : polygonColor.color) || '#3388ff',
          fill: (polygonColor === null || polygonColor === void 0 ? void 0 : polygonColor.color) || '#000000',
          opacity: (polygonColor === null || polygonColor === void 0 ? void 0 : polygonColor.fillOpacity) || 0
        });
        selectedPolygons.current = selectedPolygons.current.filter(function (e) {
          return e._leaflet_id !== d._leaflet_id;
        });
        if (!selectedPolygons.current.length && onSelectAnomaly) {
          onSelectAnomaly({
            enable: true
          });
        }
      }
    }
  }
  function whenClicked(e) {
    onClickAnomaly(e === null || e === void 0 ? void 0 : e.target);
  }
  function _onEachFeature(fe, layer) {
    layer.on({
      click: whenClicked
    });
  }
  function clearTooltip() {
    var element = document.querySelector('.leaflet-draw-tooltip');
    if (element) {
      element.style.display = 'none';
    }
  }
  useEffect(function () {
    // Zoom out the map when clear anomalyGeoJSON
    if (!anomalyGeoJSON && previousZoom.current) {
      setState(_objectSpread2(_objectSpread2({}, mapState), {}, {
        viewBox: previousZoom.current
      }));
      clearTooltip();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [anomalyGeoJSON]);
  useEffect(function () {
    isDelete.current = deleteAnomaly === null || deleteAnomaly === void 0 ? void 0 : deleteAnomaly["delete"];
  }, [deleteAnomaly, isDelete]);
  function updateTooltipText(element) {
    var childElementText = element.firstChild.innerHTML;
    var changedText = childElementText.split(' ')[0].split('<br>')[1];
    if (changedText) {
      var defaultUnit = childElementText.split(' ')[1];
      var defaultText = document.querySelector('.leaflet-draw-tooltip').firstChild.innerHTML;
      var tooltipText = defaultText.replace(defaultUnit, userAreaUnit);
      document.querySelector('.leaflet-draw-tooltip-subtext').innerHTML = tooltipText;
    }
  }
  function customTooltip() {
    var element = document.querySelector('.leaflet-draw-tooltip');
    if (element) {
      updateTooltipText(element);
    }
  }

  // To draw the polygon on the map on create and edit anomaly
  useEffect(function () {
    if (createAnomaly !== null && createAnomaly !== void 0 && createAnomaly.visible) {
      if ((createAnomaly === null || createAnomaly === void 0 ? void 0 : createAnomaly.type) === 'create') {
        polygonDrawer.current = new L$1.Draw.Polygon(mapRef.current, {
          showArea: true,
          allowIntersection: false,
          color: '#3388ff',
          dashArray: '8 8',
          weight: 3,
          opacity: 1.0,
          fillColor: '#000000',
          fillOpacity: 0.0,
          shapeOptions: {
            stroke: true,
            color: '#3388ff',
            weight: 3,
            opacity: 1.0,
            fillColor: '#000000',
            fillOpacity: 0.0,
            dashArray: '8 8',
            fill: false,
            clickable: false,
            editing: {
              dashArray: '10, 10',
              fill: true,
              fillColor: '#fe57a1',
              fillOpacity: 0.1,
              maintainColor: false
            }
          }
        });
        polygonDrawer.current.enable();
        L$1.DomUtil.addClass(mapRef.current._container, 'crosshair-cursor-enabled');
      }
      if ((createAnomaly === null || createAnomaly === void 0 ? void 0 : createAnomaly.type) === 'edit') {
        // To filter the anomaly boundary by anomaly id from map layers to edit
        var editableLayer;
        mapRef.current.eachLayer(function (layer) {
          var _layer$options, _layer$options2, _anomalyGeoJSON$prope;
          if (layer !== null && layer !== void 0 && (_layer$options = layer.options) !== null && _layer$options !== void 0 && _layer$options.data && (layer === null || layer === void 0 || (_layer$options2 = layer.options) === null || _layer$options2 === void 0 || (_layer$options2 = _layer$options2.data[0]) === null || _layer$options2 === void 0 || (_layer$options2 = _layer$options2.properties) === null || _layer$options2 === void 0 ? void 0 : _layer$options2.id) === (anomalyGeoJSON === null || anomalyGeoJSON === void 0 || (_anomalyGeoJSON$prope = anomalyGeoJSON.properties) === null || _anomalyGeoJSON$prope === void 0 ? void 0 : _anomalyGeoJSON$prope.id)) {
            editableLayer = layer;
          }
        });
        if (editableLayer) {
          polygonDrawer.current = new L$1.EditToolbar.Edit(mapRef.current, {
            featureGroup: editableLayer,
            dashArray: '10, 10',
            fill: true,
            fillColor: '#fe57a1',
            fillOpacity: 0.1,
            maintainColor: false,
            selectedPathOptions: {
              dashArray: '10, 10',
              fill: true,
              fillColor: '#fe57a1',
              fillOpacity: 0.1,
              maintainColor: false
            },
            shapeOptions: {
              stroke: true,
              color: '#3388ff',
              weight: 3,
              opacity: 1.0,
              fillColor: '#000000',
              fillOpacity: 0.0,
              dashArray: '8 8',
              fill: false,
              clickable: false
            }
          });
          polygonDrawer.current.enable();
        } else if (onDrawAnomaly) onDrawAnomaly({
          type: 'close',
          visible: false
        });
      }
      if ((createAnomaly === null || createAnomaly === void 0 ? void 0 : createAnomaly.type) === 'undo') {
        // To avoid tooltip unit flashing behavior called customTooltip() multiple times
        customTooltip();
        polygonDrawer.current.deleteLastVertex();
        customTooltip();
        if (polygonDrawer.current._poly._latlngs.length < 2) {
          if (onDrawAnomaly) onDrawAnomaly({
            type: 'hide-undo'
          });
          L$1.DomUtil.removeClass(mapRef.current._container, 'crosshair-cursor-enabled');
        }
      }
    } else if (!(createAnomaly !== null && createAnomaly !== void 0 && createAnomaly.visible) && polygonDrawer.current) {
      if ((createAnomaly === null || createAnomaly === void 0 ? void 0 : createAnomaly.type) === 'save') {
        if (createAnomaly !== null && createAnomaly !== void 0 && createAnomaly.isAnomalyCreate) {
          if (onDrawAnomaly) onDrawAnomaly({
            type: 'create'
          });
          mapRef.current.eachLayer(function (e) {
            var _e$_path;
            if (e !== null && e !== void 0 && (_e$_path = e._path) !== null && _e$_path !== void 0 && (_e$_path = _e$_path.outerHTML) !== null && _e$_path !== void 0 && _e$_path.includes('class="leaflet-interactive"')) {
              mapRef.current.removeLayer(e);
            }
          });
        } else {
          polygonDrawer.current.save();
          polygonDrawer.current.disable();
        }
      }
      if ((createAnomaly === null || createAnomaly === void 0 ? void 0 : createAnomaly.type) === 'cancel') {
        mapRef.current.eachLayer(function (e) {
          var _e$_path2;
          if (e !== null && e !== void 0 && (_e$_path2 = e._path) !== null && _e$_path2 !== void 0 && (_e$_path2 = _e$_path2.outerHTML) !== null && _e$_path2 !== void 0 && _e$_path2.includes('class="leaflet-interactive"')) {
            mapRef.current.removeLayer(e);
            if (onDrawAnomaly) onDrawAnomaly();
            L$1.DomUtil.removeClass(mapRef.current._container, 'crosshair-cursor-enabled');
          }
        });
        if (polygonDrawer.current.revertLayers) polygonDrawer.current.revertLayers();
        polygonDrawer.current.disable();
        L$1.DomUtil.removeClass(mapRef.current._container, 'crosshair-cursor-enabled');
        clearTooltip();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [createAnomaly, anomalyGeoJSON]);
  if (document.querySelector('div.map-desktop-container')) {
    document.addEventListener('mousemove', function () {
      customTooltip();
    });
    document.addEventListener('mousedown', function () {
      customTooltip();
    });
  }
  if (document.querySelector('div.map-mobile-container')) {
    document.addEventListener('touchstart', function () {
      customTooltip();
    });
    document.addEventListener('touchmove', function () {
      customTooltip();
    });
    document.addEventListener('touchend', function () {
      customTooltip();
    });
    document.addEventListener('click', function () {
      customTooltip();
    });
  }
  useEffect(function () {
    var _selectedPolygons$cur;
    if (deleteAnomaly !== null && deleteAnomaly !== void 0 && deleteAnomaly.save) {
      if (onSelectAnomaly) onSelectAnomaly({
        enable: true,
        data: selectedPolygons.current
      });
      selectedPolygons.current.forEach(function (d) {
        mapRef.current.removeLayer(d);
      });
      selectedPolygons.current = [];
    } else if (!(deleteAnomaly !== null && deleteAnomaly !== void 0 && deleteAnomaly["delete"]) && !(deleteAnomaly !== null && deleteAnomaly !== void 0 && deleteAnomaly.save) && (_selectedPolygons$cur = selectedPolygons.current) !== null && _selectedPolygons$cur !== void 0 && _selectedPolygons$cur.length) {
      selectedPolygons.current.forEach(function (d) {
        var _d$feature2;
        var anomalyLevel = d === null || d === void 0 || (_d$feature2 = d.feature) === null || _d$feature2 === void 0 || (_d$feature2 = _d$feature2.properties) === null || _d$feature2 === void 0 ? void 0 : _d$feature2.anomaly_severity;
        var selector = ".map-ranch-block-anomaly-boundary-".concat(anomalyLevel);
        var polygonElems = document.querySelectorAll(selector);
        if (polygonElems !== null && polygonElems !== void 0 && polygonElems.length) {
          polygonElems.forEach(function (elem) {
            var _d$feature3;
            var polygonColor = getAnomalyPolygonStyle(d === null || d === void 0 || (_d$feature3 = d.feature) === null || _d$feature3 === void 0 || (_d$feature3 = _d$feature3.properties) === null || _d$feature3 === void 0 ? void 0 : _d$feature3.anomaly_severity);
            setElementStyle(elem, {
              stroke: (polygonColor === null || polygonColor === void 0 ? void 0 : polygonColor.color) || '#3388ff',
              fill: (polygonColor === null || polygonColor === void 0 ? void 0 : polygonColor.color) || '#000000',
              opacity: (polygonColor === null || polygonColor === void 0 ? void 0 : polygonColor.fillOpacity) || 0
            });
          });
        }
      });
      selectedPolygons.current = [];
      if (onSelectAnomaly) onSelectAnomaly({
        enable: true
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteAnomaly]);

  // to handle the polygon color fill on zoom event
  useEffect(function () {
    if (!mapRef.current) return;
    mapRef.current.on('zoomend', function () {
      var _selectedPolygons$cur2;
      if ((_selectedPolygons$cur2 = selectedPolygons.current) !== null && _selectedPolygons$cur2 !== void 0 && _selectedPolygons$cur2.length && deleteAnomaly !== null && deleteAnomaly !== void 0 && deleteAnomaly["delete"]) {
        if (previousZoom !== null) {
          selectedPolygons.current.forEach(function (d) {
            var _d$feature4;
            var anomalyLevel = d === null || d === void 0 || (_d$feature4 = d.feature) === null || _d$feature4 === void 0 || (_d$feature4 = _d$feature4.properties) === null || _d$feature4 === void 0 ? void 0 : _d$feature4.anomaly_severity;
            var selector = ".map-ranch-block-anomaly-boundary-".concat(anomalyLevel);
            var polygonElems = document.querySelectorAll(selector);
            if (polygonElems !== null && polygonElems !== void 0 && polygonElems.length) {
              polygonElems.forEach(function (elem) {
                setElementStyle(elem, {
                  stroke: '#fe57a1',
                  fill: '#fe57a1',
                  opacity: 0.5
                });
              });
            }
          });
        }
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mapRef, deleteAnomaly === null || deleteAnomaly === void 0 ? void 0 : deleteAnomaly["delete"]]);
  useEffect(function () {
    if (!mapRef.current) return;

    // Calls when polygon create points, then undo last point on the map
    mapRef.current.on('draw:drawvertex', function (e) {
      var layers = e.layers;
      if (Object.values(layers._layers).length > 1) {
        if (onDrawAnomaly) onDrawAnomaly({
          type: 'show-undo'
        });
      } else if (Object.values(layers._layers).length) {
        if (onDrawAnomaly) onDrawAnomaly({
          type: 'show-cancel'
        });
      }
    });

    // Calls when polygon created on the map
    mapRef.current.on('draw:created', function (e) {
      var layer = e.layer;
      layer.addTo(mapRef.current);
      if (onDrawAnomaly) onDrawAnomaly({
        type: 'stop-draw',
        layer: layer
      });
      L$1.DomUtil.removeClass(mapRef.current._container, 'crosshair-cursor-enabled');
    });

    // Calls when polygon edited on the map
    mapRef.current.on('draw:edited', function (e) {
      var layers = e.layers;
      layers.eachLayer(function (layer) {
        var _layer$toGeoJSON;
        var newObj = _objectSpread2({}, (_layer$toGeoJSON = layer.toGeoJSON()) === null || _layer$toGeoJSON === void 0 ? void 0 : _layer$toGeoJSON.properties);
        var coordinates = layer.toGeoJSON().geometry.coordinates;
        var editedCoordinates = coordinates[0];
        newObj.bounds.coordinates[0] = editedCoordinates;
        newObj.center.coordinates[0] = layer.getBounds().getCenter().lng;
        newObj.center.coordinates[1] = layer.getBounds().getCenter().lat;
        if (onDrawAnomaly) onDrawAnomaly({
          type: 'edit',
          layer: newObj
        });
        mapRef.current.removeLayer(layer);
      });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return dataToRender.map(function (d) {
    var _d$geometry;
    var className = "map-ranch-block-anomaly-boundary-".concat(!isAnomalyArea ? feature.name : d.anomaly_severity);
    var style = !isAnomalyArea ? getAnomalyPolygonStyle((feature === null || feature === void 0 ? void 0 : feature.properties) && feature.properties.anomaly_severity) : getAnomalyPolygonStyle(d.anomaly_severity);
    var data = !isAnomalyArea ? [_objectSpread2(_objectSpread2({}, d), {}, {
      geometry: {
        type: 'Polygon',
        coordinates: d === null || d === void 0 || (_d$geometry = d.geometry) === null || _d$geometry === void 0 ? void 0 : _d$geometry.coordinates
      }
    })] : [{
      type: 'Feature',
      geometry: d.multi_bounds,
      properties: _objectSpread2({}, d)
    }];
    return /*#__PURE__*/React.createElement(GeoJSON, {
      className: className,
      style: style,
      key: "".concat(presentationMode).concat(JSON.stringify(!isAnomalyArea ? feature.properties : d), "\n       ").concat(selected).concat(isShowingImagery.visible).concat(zoomShowSensorsState),
      data: data,
      onEachFeature: function onEachFeature(fe, la) {
        return _onEachFeature(fe, la);
      },
      onClick: function onClick() {
        if (onClickBlock) {
          onClickBlock(feature.properties.id);
        }
      }
    });
  });
}

/**
 * Below plugin code copied from stackExchange
 * URL: https://gis.stackexchange.com/questions/451897/imageoverlay-is-not-working-with-leaflet-side-by-side/452123#452123
 * Issue: ImageOverlay not working on the leaflet-side-by-side npm v.1.9.x.
 *        So it rendered the imageOverlay as one above another.
 *        and when dragging the draggable line doesn't worked as expected.
 * Action: when asked the solution on the stackExchange forum (above URL) and
 *        got the edited plugin for the leaflet-side-by-side npm v.1.9.x
 * Result: The imageOverly is working as expected with this plugin by loading directly in component.
 */

(function () {
  function r(e, n, t) {
    function o(i, f) {
      if (!n[i]) {
        if (!e[i]) {
          var c = "function" == typeof require && require;
          if (!f && c) return c(i, !0);
          if (u) return u(i, !0);
          var a = new Error("Cannot find module '" + i + "'");
          throw a.code = "MODULE_NOT_FOUND", a;
        }
        var p = n[i] = {
          exports: {}
        };
        e[i][0].call(p.exports, function (r) {
          var n = e[i][1][r];
          return o(n || r);
        }, p, p.exports, r, e, n, t);
      }
      return n[i].exports;
    }
    for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) o(t[i]);
    return o;
  }
  return r;
})()({
  1: [function (require, module, exports) {
    (function (global) {
      var L = typeof window !== "undefined" ? window["L"] : typeof global !== "undefined" ? global["L"] : null;
      require("./layout.css");
      require("./range.css");
      var mapWasDragEnabled;
      var mapWasTapEnabled;

      // Leaflet v0.7 backwards compatibility
      function on(el, types, fn, context) {
        types.split(" ").forEach(function (type) {
          L.DomEvent.on(el, type, fn, context);
        });
      }

      // Leaflet v0.7 backwards compatibility
      function off(el, types, fn, context) {
        types.split(" ").forEach(function (type) {
          L.DomEvent.off(el, type, fn, context);
        });
      }
      function getRangeEvent(rangeInput) {
        return "oninput" in rangeInput ? "input" : "change";
      }
      function cancelMapDrag() {
        mapWasDragEnabled = this._map.dragging.enabled();
        mapWasTapEnabled = this._map.tap && this._map.tap.enabled();
        this._map.dragging.disable();
        this._map.tap && this._map.tap.disable();
      }
      function uncancelMapDrag(e) {
        this._refocusOnMap(e);
        if (mapWasDragEnabled) {
          this._map.dragging.enable();
        }
        if (mapWasTapEnabled) {
          this._map.tap.enable();
        }
      }

      // convert arg to an array - returns empty array if arg is undefined
      function asArray(arg) {
        return arg === "undefined" ? [] : Array.isArray(arg) ? arg : [arg];
      }
      function noop() {}

      // start fix for Leaflet 1.9 -----------------------
      function isTouch() {
        return "ontouchstart" in window || navigator.MaxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
      }
      // end fix for Leaflet 1.9 -----------------------

      L.Control.SideBySide = L.Control.extend({
        options: {
          thumbSize: 42,
          padding: 0
        },
        initialize: function initialize(leftLayers, rightLayers, options) {
          this.setLeftLayers(leftLayers);
          this.setRightLayers(rightLayers);
          L.setOptions(this, options);
        },
        getPosition: function getPosition() {
          var rangeValue = this._range.value;
          var offset = (0.5 - rangeValue) * (2 * this.options.padding + this.options.thumbSize);
          return this._map.getSize().x * rangeValue + offset;
        },
        setPosition: noop,
        includes: L.Evented.prototype || L.Mixin.Events,
        addTo: function addTo(map) {
          this.remove();
          this._map = map;
          var container = this._container = L.DomUtil.create("div", "leaflet-sbs", map._controlContainer);
          this._divider = L.DomUtil.create("div", "leaflet-sbs-divider", container);
          var range = this._range = L.DomUtil.create("input", "leaflet-sbs-range", container);
          range.type = "range";
          range.min = 0;
          range.max = 1;
          range.step = "any";
          range.value = 0.5;
          range.style.paddingLeft = range.style.paddingRight = this.options.padding + "px";
          this._addEvents();
          this._updateLayers();
          return this;
        },
        remove: function remove() {
          if (!this._map) {
            return this;
          }
          if (this._leftLayer) {
            // start fix for Leaflet 1.9 -----------------------
            //      this._leftLayer.getContainer().style.clip = ''
            this._leftLayer.getPane().style.clip = "";
            // end fix for Leaflet 1.9 -----------------------
          }
          if (this._rightLayer) {
            // start fix for Leaflet 1.9 -----------------------
            //      this._rightLayer.getContainer().style.clip = ''
            this._rightLayer.getPane().style.clip = "";
            // end fix for Leaflet 1.9 -----------------------
          }
          this._removeEvents();
          L.DomUtil.remove(this._container);
          this._map = null;
          return this;
        },
        setLeftLayers: function setLeftLayers(leftLayers) {
          this._leftLayers = asArray(leftLayers);
          this._updateLayers();
          return this;
        },
        setRightLayers: function setRightLayers(rightLayers) {
          this._rightLayers = asArray(rightLayers);
          this._updateLayers();
          return this;
        },
        _updateClip: function _updateClip() {
          var map = this._map;
          var nw = map.containerPointToLayerPoint([0, 0]);
          var se = map.containerPointToLayerPoint(map.getSize());
          var clipX = nw.x + this.getPosition();
          var dividerX = this.getPosition();
          this._divider.style.left = dividerX + "px";
          this.fire("dividermove", {
            x: dividerX
          });
          var clipLeft = "rect(" + [nw.y, clipX, se.y, nw.x].join("px,") + "px)";
          var clipRight = "rect(" + [nw.y, se.x, se.y, clipX].join("px,") + "px)";
          if (this._leftLayer) {
            // start fix for Leaflet 1.9 -----------------------
            //      this._leftLayer.getContainer().style.clip = clipLeft
            this._leftLayer.getPane().style.clip = clipLeft;
          }
          if (this._rightLayer) {
            // start fix for Leaflet 1.9 -----------------------
            //      this._rightLayer.getContainer().style.clip = clipRight
            this._rightLayer.getPane().style.clip = clipRight;
            // end fix for Leaflet 1.9 -----------------------
          }
        },
        _updateLayers: function _updateLayers() {
          if (!this._map) {
            return this;
          }
          var prevLeft = this._leftLayer;
          var prevRight = this._rightLayer;
          this._leftLayer = this._rightLayer = null;
          this._leftLayers.forEach(function (layer) {
            if (this._map.hasLayer(layer)) {
              this._leftLayer = layer;
            }
          }, this);
          this._rightLayers.forEach(function (layer) {
            if (this._map.hasLayer(layer)) {
              this._rightLayer = layer;
            }
          }, this);
          if (prevLeft !== this._leftLayer) {
            prevLeft && this.fire("leftlayerremove", {
              layer: prevLeft
            });
            this._leftLayer && this.fire("leftlayeradd", {
              layer: this._leftLayer
            });
          }
          if (prevRight !== this._rightLayer) {
            prevRight && this.fire("rightlayerremove", {
              layer: prevRight
            });
            this._rightLayer && this.fire("rightlayeradd", {
              layer: this._rightLayer
            });
          }
          this._updateClip();
        },
        _addEvents: function _addEvents() {
          var range = this._range;
          var map = this._map;
          if (!map || !range) return;
          map.on("move", this._updateClip, this);
          map.on("layeradd layerremove", this._updateLayers, this);
          on(range, getRangeEvent(range), this._updateClip, this);
          // start fix for Leaflet 1.9 -----------------------
          //    on(range, L.Browser.touch ? 'touchstart' : 'mousedown', cancelMapDrag, this)
          //    on(range, L.Browser.touch ? 'touchend' : 'mouseup', uncancelMapDrag, this)
          on(range, isTouch() ? "touchstart" : "mousedown", cancelMapDrag, this);
          on(range, isTouch() ? "touchend" : "mouseup", uncancelMapDrag, this);
          // end fix for Leaflet 1.9 -----------------------
        },
        _removeEvents: function _removeEvents() {
          var range = this._range;
          var map = this._map;
          if (range) {
            off(range, getRangeEvent(range), this._updateClip, this);
            off(range, L.Browser.touch ? "touchstart" : "mousedown", cancelMapDrag, this);
            off(range, L.Browser.touch ? "touchend" : "mouseup", uncancelMapDrag, this);
          }
          if (map) {
            map.off("layeradd layerremove", this._updateLayers, this);
            map.off("move", this._updateClip, this);
          }
        }
      });
      L.control.sideBySide = function (leftLayers, rightLayers, options) {
        return new L.Control.SideBySide(leftLayers, rightLayers, options);
      };
      module.exports = L.Control.SideBySide;
    }).call(this, typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
  }, {
    "./layout.css": 2,
    "./range.css": 4
  }],
  2: [function (require, module, exports) {
    var inject = require("./node_modules/cssify");
    var css = ".leaflet-sbs-range {\r\n    position: absolute;\r\n    top: 50%;\r\n    width: 100%;\r\n    z-index: 999;\r\n}\r\n.leaflet-sbs-divider {\r\n    position: absolute;\r\n    top: 0;\r\n    bottom: 0;\r\n    left: 50%;\r\n    margin-left: -2px;\r\n    width: 4px;\r\n    background-color: #fff;\r\n    pointer-events: none;\r\n    z-index: 999;\r\n}\r\n";
    inject(css, undefined, "_i6aomd");
    module.exports = css;
  }, {
    "./node_modules/cssify": 3
  }],
  3: [function (require, module, exports) {

    function injectStyleTag(document, fileName, cb) {
      var style = document.getElementById(fileName);
      if (style) {
        cb(style);
      } else {
        var head = document.getElementsByTagName("head")[0];
        style = document.createElement("style");
        if (fileName != null) style.id = fileName;
        cb(style);
        head.appendChild(style);
      }
      return style;
    }
    module.exports = function (css, customDocument, fileName) {
      var doc = customDocument || document;
      /* istanbul ignore if: not supported by Electron */
      if (doc.createStyleSheet) {
        var sheet = doc.createStyleSheet();
        sheet.cssText = css;
        return sheet.ownerNode;
      } else {
        return injectStyleTag(doc, fileName, function (style) {
          /* istanbul ignore if: not supported by Electron */
          if (style.styleSheet) {
            style.styleSheet.cssText = css;
          } else {
            style.innerHTML = css;
          }
        });
      }
    };
    module.exports.byUrl = function (url) {
      /* istanbul ignore if: not supported by Electron */
      if (document.createStyleSheet) {
        return document.createStyleSheet(url).ownerNode;
      } else {
        var head = document.getElementsByTagName("head")[0];
        var link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = url;
        head.appendChild(link);
        return link;
      }
    };
  }, {}],
  4: [function (require, module, exports) {
    var inject = require("./node_modules/cssify");
    var css = '.leaflet-sbs-range {\r\n    -webkit-appearance: none;\r\n    display: inline-block!important;\r\n    vertical-align: middle;\r\n    height: 0;\r\n    padding: 0;\r\n    margin: 0;\r\n    border: 0;\r\n    background: rgba(0, 0, 0, 0.25);\r\n    min-width: 100px;\r\n    cursor: pointer;\r\n    pointer-events: none;\r\n    z-index: 999;\r\n}\r\n.leaflet-sbs-range::-ms-fill-upper {\r\n    background: transparent;\r\n}\r\n.leaflet-sbs-range::-ms-fill-lower {\r\n    background: rgba(255, 255, 255, 0.25);\r\n}\r\n/* Browser thingies */\r\n\r\n.leaflet-sbs-range::-moz-range-track {\r\n    opacity: 0;\r\n}\r\n.leaflet-sbs-range::-ms-track {\r\n    opacity: 0;\r\n}\r\n.leaflet-sbs-range::-ms-tooltip {\r\n    display: none;\r\n}\r\n/* For whatever reason, these need to be defined\r\n * on their own so dont group them */\r\n\r\n.leaflet-sbs-range::-webkit-slider-thumb {\r\n    -webkit-appearance: none;\r\n    margin: 0;\r\n    padding: 0;\r\n    background: #fff;\r\n    height: 40px;\r\n    width: 40px;\r\n    border-radius: 20px;\r\n    cursor: ew-resize;\r\n    pointer-events: auto;\r\n    border: 1px solid #ddd;\r\n    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQCAMAAAC5zwKfAAAABlBMVEV9fX3///+Kct39AAAAAnRSTlP/AOW3MEoAAAA9SURBVFjD7dehDQAwDANBZ/+l2wmKoiqR7pHRcaeaCxAIBAL/g7k9JxAIBAKBQCAQCAQC14H+MhAIBE4CD3fOFvGVBzhZAAAAAElFTkSuQmCC");\r\n    background-position: 50% 50%;\r\n    background-repeat: no-repeat;\r\n    background-size: 40px 40px;\r\n}\r\n.leaflet-sbs-range::-ms-thumb {\r\n    margin: 0;\r\n    padding: 0;\r\n    background: #fff;\r\n    height: 40px;\r\n    width: 40px;\r\n    border-radius: 20px;\r\n    cursor: ew-resize;\r\n    pointer-events: auto;\r\n    border: 1px solid #ddd;\r\n    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQCAMAAAC5zwKfAAAABlBMVEV9fX3///+Kct39AAAAAnRSTlP/AOW3MEoAAAA9SURBVFjD7dehDQAwDANBZ/+l2wmKoiqR7pHRcaeaCxAIBAL/g7k9JxAIBAKBQCAQCAQC14H+MhAIBE4CD3fOFvGVBzhZAAAAAElFTkSuQmCC");\r\n    background-position: 50% 50%;\r\n    background-repeat: no-repeat;\r\n    background-size: 40px 40px;\r\n}\r\n.leaflet-sbs-range::-moz-range-thumb {\r\n    padding: 0;\r\n    right: 0    ;\r\n    background: #fff;\r\n    height: 40px;\r\n    width: 40px;\r\n    border-radius: 20px;\r\n    cursor: ew-resize;\r\n    pointer-events: auto;\r\n    border: 1px solid #ddd;\r\n    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQCAMAAAC5zwKfAAAABlBMVEV9fX3///+Kct39AAAAAnRSTlP/AOW3MEoAAAA9SURBVFjD7dehDQAwDANBZ/+l2wmKoiqR7pHRcaeaCxAIBAL/g7k9JxAIBAKBQCAQCAQC14H+MhAIBE4CD3fOFvGVBzhZAAAAAElFTkSuQmCC");\r\n    background-position: 50% 50%;\r\n    background-repeat: no-repeat;\r\n    background-size: 40px 40px;\r\n}\r\n.leaflet-sbs-range:disabled::-moz-range-thumb {\r\n    cursor: default;\r\n}\r\n.leaflet-sbs-range:disabled::-ms-thumb {\r\n    cursor: default;\r\n}\r\n.leaflet-sbs-range:disabled::-webkit-slider-thumb {\r\n    cursor: default;\r\n}\r\n.leaflet-sbs-range:disabled {\r\n    cursor: default;\r\n}\r\n.leaflet-sbs-range:focus {\r\n    outline: none!important;\r\n}\r\n.leaflet-sbs-range::-moz-focus-outer {\r\n    border: 0;\r\n}\r\n\r\n';
    inject(css, undefined, "_1tlt668");
    module.exports = css;
  }, {
    "./node_modules/cssify": 3
  }]
}, {}, [1]);

/* eslint-disable */

/**
 * Source code: maplibre-gl-compare.js
 * Link: https://github.com/maplibre/maplibre-gl-compare/blob/main/dist/maplibre-gl-compare.js
 * Version: 0.5.0
 * Reason for edit: maplibre-gl-compare view throws an
 *                  error "_maplibreGl.default.Compare is not a constructor"
 * Solution: import 'maplibre-gl' package and assign to variable called 'maplibregl'
 * Edited By: Piruthiviraj K (dAlchemy)
 * Asked for solution URL: https://stackoverflow.com/questions/76882081/maplibregl-default-compare-is-not-a-constructor
 */

window.maplibregl = require('maplibre-gl');
!function o(i, r, s) {
  function h(t, e) {
    if (!r[t]) {
      if (!i[t]) {
        var n = "function" == typeof require && require;
        if (!e && n) return n(t, !0);
        if (u) return u(t, !0);
        throw (n = new Error("Cannot find module '" + t + "'")).code = "MODULE_NOT_FOUND", n;
      }
      n = r[t] = {
        exports: {}
      }, i[t][0].call(n.exports, function (e) {
        return h(i[t][1][e] || e);
      }, n, n.exports, o, i, r, s);
    }
    return r[t].exports;
  }
  for (var u = "function" == typeof require && require, e = 0; e < s.length; e++) h(s[e]);
  return h;
}({
  1: [function (e, t, n) {

    var i = e("@mapbox/mapbox-gl-sync-move"),
      r = e("events").EventEmitter;
    function o(e, t, n, o) {
      if (this.options = o || {}, this._mapA = e, this._mapB = t, this._horizontal = "horizontal" === this.options.orientation, this._onDown = this._onDown.bind(this), this._onMove = this._onMove.bind(this), this._onMouseUp = this._onMouseUp.bind(this), this._onTouchEnd = this._onTouchEnd.bind(this), this._ev = new r(), this._swiper = document.createElement("div"), this._swiper.className = this._horizontal ? "compare-swiper-horizontal" : "compare-swiper-vertical", this._controlContainer = document.createElement("div"), this._controlContainer.className = this._horizontal ? "maplibregl-compare maplibregl-compare-horizontal" : "maplibregl-compare", this._controlContainer.className = this._controlContainer.className, this._controlContainer.appendChild(this._swiper), "string" == typeof n && document.body.querySelectorAll) {
        o = document.body.querySelectorAll(n)[0];
        if (!o) throw new Error("Cannot find element with specified container selector.");
        o.appendChild(this._controlContainer);
      } else {
        if (!(n instanceof Element && n.appendChild)) throw new Error("Invalid container specified. Must be CSS selector or HTML element.");
        n.appendChild(this._controlContainer);
      }
      this._bounds = t.getContainer().getBoundingClientRect();
      n = (this._horizontal ? this._bounds.height : this._bounds.width) / 2;
      this._setPosition(n), this._clearSync = i(e, t), this._onResize = function () {
        this._bounds = t.getContainer().getBoundingClientRect(), this.currentPosition && this._setPosition(this.currentPosition);
      }.bind(this), t.on("resize", this._onResize), this.options && this.options.mousemove && (e.getContainer().addEventListener("mousemove", this._onMove), t.getContainer().addEventListener("mousemove", this._onMove)), this._swiper.addEventListener("mousedown", this._onDown), this._swiper.addEventListener("touchstart", this._onDown);
    }
    o.prototype = {
      _setPointerEvents: function _setPointerEvents(e) {
        this._controlContainer.style.pointerEvents = e, this._swiper.style.pointerEvents = e;
      },
      _onDown: function _onDown(e) {
        e.touches ? (document.addEventListener("touchmove", this._onMove), document.addEventListener("touchend", this._onTouchEnd)) : (document.addEventListener("mousemove", this._onMove), document.addEventListener("mouseup", this._onMouseUp));
      },
      _setPosition: function _setPosition(e) {
        e = Math.min(e, this._horizontal ? this._bounds.height : this._bounds.width);
        var t = this._horizontal ? "translate(0, " + e + "px)" : "translate(" + e + "px, 0)";
        this._controlContainer.style.transform = t, this._controlContainer.style.WebkitTransform = t;
        var n = this._horizontal ? "rect(0, 999em, " + e + "px, 0)" : "rect(0, " + e + "px, " + this._bounds.height + "px, 0)",
          t = this._horizontal ? "rect(" + e + "px, 999em, " + this._bounds.height + "px,0)" : "rect(0, 999em, " + this._bounds.height + "px," + e + "px)";
        this._mapA.getContainer().style.clip = n, this._mapB.getContainer().style.clip = t, this.currentPosition = e;
      },
      _onMove: function _onMove(e) {
        this.options && this.options.mousemove && this._setPointerEvents(e.touches ? "auto" : "none"), this._horizontal ? this._setPosition(this._getY(e)) : this._setPosition(this._getX(e));
      },
      _onMouseUp: function _onMouseUp() {
        document.removeEventListener("mousemove", this._onMove), document.removeEventListener("mouseup", this._onMouseUp), this.fire("slideend", {
          currentPosition: this.currentPosition
        });
      },
      _onTouchEnd: function _onTouchEnd() {
        document.removeEventListener("touchmove", this._onMove), document.removeEventListener("touchend", this._onTouchEnd), this.fire("slideend", {
          currentPosition: this.currentPosition
        });
      },
      _getX: function _getX(e) {
        e = (e = e.touches ? e.touches[0] : e).clientX - this._bounds.left;
        return e = (e = e < 0 ? 0 : e) > this._bounds.width ? this._bounds.width : e;
      },
      _getY: function _getY(e) {
        e = (e = e.touches ? e.touches[0] : e).clientY - this._bounds.top;
        return e = (e = e < 0 ? 0 : e) > this._bounds.height ? this._bounds.height : e;
      },
      setSlider: function setSlider(e) {
        this._setPosition(e);
      },
      on: function on(e, t) {
        return this._ev.on(e, t), this;
      },
      fire: function fire(e, t) {
        return this._ev.emit(e, t), this;
      },
      off: function off(e, t) {
        return this._ev.removeListener(e, t), this;
      },
      remove: function remove() {
        this._clearSync(), this._mapB.off("resize", this._onResize);
        var e = this._mapA.getContainer();
        e && (e.style.clip = null, e.removeEventListener("mousemove", this._onMove));
        e = this._mapB.getContainer();
        e && (e.style.clip = null, e.removeEventListener("mousemove", this._onMove)), this._swiper.removeEventListener("mousedown", this._onDown), this._swiper.removeEventListener("touchstart", this._onDown), this._controlContainer.remove();
      }
    }, window.maplibregl ? maplibregl.Compare = o : void 0 !== t && (t.exports = o);
  }, {
    "@mapbox/mapbox-gl-sync-move": 2,
    events: 3
  }],
  2: [function (e, t, n) {
    t.exports = function () {
      var e = arguments.length;
      if (1 === e) t = arguments[0];else for (var t = [], n = 0; n < e; n++) t.push(arguments[n]);
      var o = [];
      function i() {
        t.forEach(function (e, t) {
          e.on("move", o[t]);
        });
      }
      function r() {
        t.forEach(function (e, t) {
          e.off("move", o[t]);
        });
      }
      return t.forEach(function (e, n) {
        o[n] = function (e, t) {
          r(), function (e, t) {
            var n = e.getCenter(),
              o = e.getZoom(),
              i = e.getBearing(),
              r = e.getPitch();
            t.forEach(function (e) {
              e.jumpTo({
                center: n,
                zoom: o,
                bearing: i,
                pitch: r
              });
            });
          }(e, t), i();
        }.bind(null, e, t.filter(function (e, t) {
          return t !== n;
        }));
      }), i(), function () {
        r(), o = [];
      };
    };
  }, {}],
  3: [function (e, t, n) {

    var o = "object" == (typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) ? Reflect : null,
      u = o && "function" == typeof o.apply ? o.apply : function (e, t, n) {
        return Function.prototype.apply.call(e, t, n);
      };
    var i = o && "function" == typeof o.ownKeys ? o.ownKeys : Object.getOwnPropertySymbols ? function (e) {
        return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e));
      } : function (e) {
        return Object.getOwnPropertyNames(e);
      },
      r = Number.isNaN || function (e) {
        return e != e;
      };
    function s() {
      s.init.call(this);
    }
    t.exports = s, t.exports.once = function (h, u) {
      return new Promise(function (e, t) {
        function n(e) {
          h.removeListener(u, o), t(e);
        }
        function o() {
          "function" == typeof h.removeListener && h.removeListener("error", n), e([].slice.call(arguments));
        }
        var i, r, s;
        d(h, u, o, {
          once: !0
        }), "error" !== u && (r = n, s = {
          once: !0
        }, "function" == typeof (i = h).on && d(i, "error", r, s));
      });
    }, (s.EventEmitter = s).prototype._events = void 0, s.prototype._eventsCount = 0, s.prototype._maxListeners = void 0;
    var h = 10;
    function c(e) {
      if ("function" != typeof e) throw new TypeError('The "listener" argument must be of type Function. Received type ' + _typeof(e));
    }
    function a(e) {
      return void 0 === e._maxListeners ? s.defaultMaxListeners : e._maxListeners;
    }
    function f(e, t, n, o) {
      var i, r;
      return c(n), void 0 === (i = e._events) ? (i = e._events = Object.create(null), e._eventsCount = 0) : (void 0 !== i.newListener && (e.emit("newListener", t, n.listener || n), i = e._events), r = i[t]), void 0 === r ? (r = i[t] = n, ++e._eventsCount) : ("function" == typeof r ? r = i[t] = o ? [n, r] : [r, n] : o ? r.unshift(n) : r.push(n), 0 < (n = a(e)) && r.length > n && !r.warned && (r.warned = !0, (n = new Error("Possible EventEmitter memory leak detected. " + r.length + " " + String(t) + " listeners added. Use emitter.setMaxListeners() to increase limit")).name = "MaxListenersExceededWarning", n.emitter = e, n.type = t, n.count = r.length, n = n, console && console.warn && console.warn(n))), e;
    }
    function l(e, t, n) {
      e = {
        fired: !1,
        wrapFn: void 0,
        target: e,
        type: t,
        listener: n
      }, t = function () {
        if (!this.fired) return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, 0 === arguments.length ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
      }.bind(e);
      return t.listener = n, e.wrapFn = t;
    }
    function p(e, t, n) {
      e = e._events;
      if (void 0 === e) return [];
      t = e[t];
      return void 0 === t ? [] : "function" == typeof t ? n ? [t.listener || t] : [t] : n ? function (e) {
        for (var t = new Array(e.length), n = 0; n < t.length; ++n) t[n] = e[n].listener || e[n];
        return t;
      }(t) : m(t, t.length);
    }
    function v(e) {
      var t = this._events;
      if (void 0 !== t) {
        e = t[e];
        if ("function" == typeof e) return 1;
        if (void 0 !== e) return e.length;
      }
      return 0;
    }
    function m(e, t) {
      for (var n = new Array(t), o = 0; o < t; ++o) n[o] = e[o];
      return n;
    }
    function d(n, o, i, r) {
      if ("function" == typeof n.on) r.once ? n.once(o, i) : n.on(o, i);else {
        if ("function" != typeof n.addEventListener) throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + _typeof(n));
        n.addEventListener(o, function e(t) {
          r.once && n.removeEventListener(o, e), i(t);
        });
      }
    }
    Object.defineProperty(s, "defaultMaxListeners", {
      enumerable: !0,
      get: function get() {
        return h;
      },
      set: function set(e) {
        if ("number" != typeof e || e < 0 || r(e)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + e + ".");
        h = e;
      }
    }), s.init = function () {
      void 0 !== this._events && this._events !== Object.getPrototypeOf(this)._events || (this._events = Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
    }, s.prototype.setMaxListeners = function (e) {
      if ("number" != typeof e || e < 0 || r(e)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + e + ".");
      return this._maxListeners = e, this;
    }, s.prototype.getMaxListeners = function () {
      return a(this);
    }, s.prototype.emit = function (e) {
      for (var t = [], n = 1; n < arguments.length; n++) t.push(arguments[n]);
      var o,
        i = "error" === e,
        r = this._events;
      if (void 0 !== r) i = i && void 0 === r.error;else if (!i) return !1;
      if (i) {
        if ((o = 0 < t.length ? t[0] : o) instanceof Error) throw o;
        i = new Error("Unhandled error." + (o ? " (" + o.message + ")" : ""));
        throw i.context = o, i;
      }
      e = r[e];
      if (void 0 === e) return !1;
      if ("function" == typeof e) u(e, this, t);else for (var s = e.length, h = m(e, s), n = 0; n < s; ++n) u(h[n], this, t);
      return !0;
    }, s.prototype.addListener = function (e, t) {
      return f(this, e, t, !1);
    }, s.prototype.on = s.prototype.addListener, s.prototype.prependListener = function (e, t) {
      return f(this, e, t, !0);
    }, s.prototype.once = function (e, t) {
      return c(t), this.on(e, l(this, e, t)), this;
    }, s.prototype.prependOnceListener = function (e, t) {
      return c(t), this.prependListener(e, l(this, e, t)), this;
    }, s.prototype.removeListener = function (e, t) {
      var n, o, i, r, s;
      if (c(t), void 0 === (o = this._events)) return this;
      if (void 0 === (n = o[e])) return this;
      if (n === t || n.listener === t) 0 == --this._eventsCount ? this._events = Object.create(null) : (delete o[e], o.removeListener && this.emit("removeListener", e, n.listener || t));else if ("function" != typeof n) {
        for (i = -1, r = n.length - 1; 0 <= r; r--) if (n[r] === t || n[r].listener === t) {
          s = n[r].listener, i = r;
          break;
        }
        if (i < 0) return this;
        0 === i ? n.shift() : function (e, t) {
          for (; t + 1 < e.length; t++) e[t] = e[t + 1];
          e.pop();
        }(n, i), 1 === n.length && (o[e] = n[0]), void 0 !== o.removeListener && this.emit("removeListener", e, s || t);
      }
      return this;
    }, s.prototype.off = s.prototype.removeListener, s.prototype.removeAllListeners = function (e) {
      var t,
        n = this._events;
      if (void 0 === n) return this;
      if (void 0 === n.removeListener) return 0 === arguments.length ? (this._events = Object.create(null), this._eventsCount = 0) : void 0 !== n[e] && (0 == --this._eventsCount ? this._events = Object.create(null) : delete n[e]), this;
      if (0 === arguments.length) {
        for (var o, i = Object.keys(n), r = 0; r < i.length; ++r) "removeListener" !== (o = i[r]) && this.removeAllListeners(o);
        return this.removeAllListeners("removeListener"), this._events = Object.create(null), this._eventsCount = 0, this;
      }
      if ("function" == typeof (t = n[e])) this.removeListener(e, t);else if (void 0 !== t) for (r = t.length - 1; 0 <= r; r--) this.removeListener(e, t[r]);
      return this;
    }, s.prototype.listeners = function (e) {
      return p(this, e, !0);
    }, s.prototype.rawListeners = function (e) {
      return p(this, e, !1);
    }, s.listenerCount = function (e, t) {
      return "function" == typeof e.listenerCount ? e.listenerCount(t) : v.call(e, t);
    }, s.prototype.listenerCount = v, s.prototype.eventNames = function () {
      return 0 < this._eventsCount ? i(this._events) : [];
    };
  }, {}]
}, {}, [1]);

// 500 will be min width and height to avoid the map page breaking when browser size changed.
var MIN_WIDTH = 500;
var MIN_HEIGHT = 500;
var dataTypeLabel = {
  NDSM: 'Canopy Height',
  DSM: 'Canopy Height'
};

// To store the attached events details to detach
var eventRef$1 = {};
var eventRefRight$1 = {};
var circleWidth = 2; // For the selected plants

// Circle layer Ids
var defaultCircleLayerId = 'points-fill';
var rightSideCircleLayerId = 'points-fill-1';

// Function to return circle width based on zoom level
function getWidthByZoom(zoom) {
  var width = 0;
  //  Adjust condition to display circle width on zoom in and out
  if (zoom >= 17) width = 1;
  return width;
}

// Function to calculate distance between two coordinates
function calculateDistance(coord1, coord2) {
  var dx = coord1[0] - coord2[0];
  var dy = coord1[1] - coord2[1];
  return Math.sqrt(dx * dx + dy * dy);
}

// Function to calculate average spacing
function calculateAverageSpacing(features) {
  var totalDistance = 0;
  var count = 0;
  for (var i = 0; i < features.length; i += 1) {
    for (var j = i + 1; j < features.length; j += 1) {
      var distance = calculateDistance(features[i].geometry.coordinates, features[j].geometry.coordinates);
      totalDistance += distance;
      count += 1;
    }
  }
  if (count === 0) {
    return 0; // Avoid division by zero
  }
  return totalDistance / count;
}

// Get the rendered features of the circle layer
function getRenderedCircles(mapVar, layerId) {
  if (mapVar !== null && mapVar !== void 0 && mapVar.getLayer(layerId)) {
    // Get the source data associated with the layer
    var source = mapVar === null || mapVar === void 0 ? void 0 : mapVar.getSource('point');
    if (source && (source === null || source === void 0 ? void 0 : source.type) === 'geojson') {
      var sourceData = source === null || source === void 0 ? void 0 : source._data; // Access the GeoJSON data
      // Filter out the features that belong to the specified layer
      return (sourceData === null || sourceData === void 0 ? void 0 : sourceData.features) || [];
    }
    return [];
  }
  return [];
}
function getBaseRadiusByAvgPlantSpacing(averageSpacing) {
  // Use the average spacing to determine the base radius
  // The majority averageSpacing values are between 0 to 1.
  // The baseRadius should be vary at different range to make circles to visible size
  // NOTE:
  //     - When the averageSpacing value increases the base radius should be small
  //     - Similarly the averageSpacing value decreases the base radius should be high
  var baseRadius = 3; // default
  if (averageSpacing <= 0.0002) baseRadius = 20; // for small block area with minimum plants
  else if (averageSpacing > 0.0002 && averageSpacing <= 0.00038) baseRadius = 10;else if (averageSpacing > 0.00038 && averageSpacing <= 0.0006) baseRadius = 6;else if (averageSpacing > 0.0006 && averageSpacing <= 0.001) baseRadius = 5;else if (averageSpacing > 0.001 && averageSpacing <= 0.0013) baseRadius = 4;else if (averageSpacing > 0.002 && averageSpacing < 0.01) baseRadius = 4;else if (averageSpacing > 0.01) baseRadius = 6;
  return baseRadius;
}

// Function to calculate circle base radius based on the plant average spacing
function calculateCircleBaseRadius(averageSpacing, plantObj) {
  var rowSpacing = parseFloat(plantObj === null || plantObj === void 0 ? void 0 : plantObj.rowSpacing) || 0;
  var plantSpacing = parseFloat(plantObj === null || plantObj === void 0 ? void 0 : plantObj.plantSpacing) || 0;
  // To convert the averageSpacing range between 0 to 1
  var avgSpacing = rowSpacing * plantSpacing / 1000;
  var baseRadius = 3; // default
  if (rowSpacing && plantSpacing) {
    // Use calculated averageSpacing value from the API response
    baseRadius = getBaseRadiusByAvgPlantSpacing(avgSpacing);
  } else {
    // Use averageSpacing value from distance calculation logic between the plant points
    baseRadius = getBaseRadiusByAvgPlantSpacing(averageSpacing);
  }
  return baseRadius;
}
var plantObj = {};
var latLng; // From the map center
var currZoom; // Map's current zoom value
var baseZoom = 15; // Base zoom level for gap calculation
var baseRadius = 3; // Base circle radius at baseZoom
var averageSpacing = 0; // Default spacing between circles
var renderedCircles = [];
var defaultSizePercent = 100; // Change this value between 1 - 100 to render circle size on screen
var prevVal = 0;

// Function to return circle radius based on zoom level
function getRadiusByZoom(mapVar, isUpdate, circleSize) {
  var _renderedCircles, _renderedCircles2, _latLng, _renderedCircles3;
  var sizePercent = circleSize && circleSize <= 100 ? circleSize : defaultSizePercent;

  // Render the circles data for the space calculation
  if (!((_renderedCircles = renderedCircles) !== null && _renderedCircles !== void 0 && _renderedCircles.length) && mapVar !== null && mapVar !== void 0 && mapVar.getSource('point')) {
    renderedCircles = getRenderedCircles(mapVar, defaultCircleLayerId);
  }

  // Calculate the average space between the plant circles
  if ((_renderedCircles2 = renderedCircles) !== null && _renderedCircles2 !== void 0 && _renderedCircles2.length && !averageSpacing) {
    averageSpacing = calculateAverageSpacing(renderedCircles);
    baseRadius = calculateCircleBaseRadius(averageSpacing, plantObj);
  }
  // This factor determines how much the circle's size changes with each zoom level.
  // A higher value will make the circle grow or shrink more rapidly as you zoom in or out
  var zoomScaleFactor = 0.75;

  // This factor controls how much the circle's size is affected by changes in pitch.
  var pitchScaleFactor = averageSpacing;

  // Calculate the effective radius based on zoom and pitch
  // eslint-disable-next-line no-restricted-properties
  var effectiveRadius = baseRadius * Math.pow(2, currZoom - baseZoom) * zoomScaleFactor * Math.cos(((_latLng = latLng) === null || _latLng === void 0 ? void 0 : _latLng.lat) / 180 * Math.PI) * pitchScaleFactor * sizePercent;

  // Decide radius by zoom value to render circle with minimum size
  var radius = currZoom > 16.5 ? effectiveRadius : 0.6;

  // Update the circle layer's paint properties to default/left map
  if (mapVar !== null && mapVar !== void 0 && mapVar.getLayer(defaultCircleLayerId) && isUpdate && effectiveRadius && prevVal !== effectiveRadius) {
    mapVar.setPaintProperty(defaultCircleLayerId, 'circle-radius', radius);
    // To maintain the circle stroke
    var newWidth = getWidthByZoom(currZoom);
    var prevWidthArr = mapVar.getPaintProperty(defaultCircleLayerId, 'circle-stroke-width');
    var prevWidth = prevWidthArr[prevWidthArr.length - 1];
    prevVal = effectiveRadius;
    if (!prevWidth) mapVar.setPaintProperty(defaultCircleLayerId, 'circle-stroke-width', newWidth);
  }
  // Update the circle layer's paint properties for the right side map
  if (mapVar !== null && mapVar !== void 0 && mapVar.getLayer(rightSideCircleLayerId) && effectiveRadius && isUpdate) {
    mapVar.setPaintProperty(rightSideCircleLayerId, 'circle-radius', radius);
    var _newWidth = getWidthByZoom(currZoom);
    var _prevWidthArr = mapVar.getPaintProperty(rightSideCircleLayerId, 'circle-stroke-width');
    var _prevWidth = _prevWidthArr[_prevWidthArr.length - 1];
    if (!_prevWidth) mapVar.setPaintProperty(rightSideCircleLayerId, 'circle-stroke-width', _newWidth);
  }

  // Reset the values when changing block
  if (!(mapVar !== null && mapVar !== void 0 && mapVar.getSource('point')) && !(mapVar !== null && mapVar !== void 0 && mapVar.getSource('point1')) && (_renderedCircles3 = renderedCircles) !== null && _renderedCircles3 !== void 0 && _renderedCircles3.length) {
    averageSpacing = 0;
    baseRadius = 3;
    renderedCircles = [];
  }
  return radius;
}
function mouseEnter(mapVar) {
  mapVar.getCanvas().style.cursor = 'pointer';
}
function mouseLeave(mapVar) {
  mapVar.getCanvas().style.cursor = '';
}
function onZoom$1(mapVar) {
  currZoom = mapVar === null || mapVar === void 0 ? void 0 : mapVar.getZoom();
  latLng = mapVar === null || mapVar === void 0 ? void 0 : mapVar.getCenter();
  getRadiusByZoom(mapVar, true);
}
function detachEventsWithLayerId(mapVar, eventObj) {
  Object.keys(eventObj).forEach(function (eventName) {
    if (eventObj[eventName] && mapVar) {
      var _eventObj$eventName, _eventObj$eventName3;
      if (!((_eventObj$eventName = eventObj[eventName]) !== null && _eventObj$eventName !== void 0 && _eventObj$eventName.layerId)) {
        var _eventObj$eventName2;
        mapVar.off(eventName, (_eventObj$eventName2 = eventObj[eventName]) === null || _eventObj$eventName2 === void 0 ? void 0 : _eventObj$eventName2.event);
      }
      if ((_eventObj$eventName3 = eventObj[eventName]) !== null && _eventObj$eventName3 !== void 0 && _eventObj$eventName3.layerId) {
        var _eventObj$eventName4, _eventObj$eventName5;
        mapVar.off(eventName, (_eventObj$eventName4 = eventObj[eventName]) === null || _eventObj$eventName4 === void 0 ? void 0 : _eventObj$eventName4.layerId, (_eventObj$eventName5 = eventObj[eventName]) === null || _eventObj$eventName5 === void 0 ? void 0 : _eventObj$eventName5.event);
      }
    }
  });
}
function clearGlLayers(mapVar, layerNumber, sourceStr, layerStr, layerIdNumArr) {
  var layerId = layerNumber ? layerNumber * 100 : 100;
  if (layerIdNumArr !== null && layerIdNumArr !== void 0 && layerIdNumArr.length) {
    for (var i = 0; i < layerIdNumArr.length; i += 1) {
      var layerIdNum = layerIdNumArr[i];
      for (var j = 0; j < 100; j += 1) {
        if (mapVar !== null && mapVar !== void 0 && mapVar.getLayer("".concat(layerStr).concat(j + 1 + layerId * layerIdNum))) {
          mapVar.removeLayer("".concat(layerStr).concat(j + 1 + layerId * layerIdNum));
        }
        if (mapVar !== null && mapVar !== void 0 && mapVar.getSource("".concat(sourceStr).concat(j + 1 + layerId * layerIdNum))) {
          mapVar.removeSource("".concat(sourceStr).concat(j + 1 + layerId * layerIdNum));
        }
      }
    }
  } else {
    if (mapVar !== null && mapVar !== void 0 && mapVar.getLayer(layerStr)) mapVar.removeLayer(layerStr);
    if (mapVar !== null && mapVar !== void 0 && mapVar.getSource(sourceStr)) mapVar.removeSource(sourceStr);
  }
}
var selectedId;
// Below function to change plant circle radius and width when zooming in and out
function applyPointsStyles(mapVar, zoom, highlightPlant) {
  getRadiusByZoom(mapVar, true);
  var newWidth = getWidthByZoom(zoom);
  if (mapVar !== null && mapVar !== void 0 && mapVar.getLayer('points-fill')) {
    mapVar.setPaintProperty('points-fill', 'circle-stroke-width', newWidth);
  }
  if (mapVar !== null && mapVar !== void 0 && mapVar.getLayer('points-fill-1')) {
    mapVar.setPaintProperty('points-fill-1', 'circle-stroke-width', newWidth);
  }
  if (selectedId) {
    if (mapVar !== null && mapVar !== void 0 && mapVar.getLayer('points-fill')) {
      mapVar.setPaintProperty('points-fill', 'circle-stroke-width', ['match', ['get', 'id'], selectedId, circleWidth, newWidth]);
      mapVar.setPaintProperty('points-fill', 'circle-stroke-color', ['match', ['get', 'id'], selectedId, '#fff', '#000']);
      if (highlightPlant) {
        mapVar.setPaintProperty('points-fill', 'circle-stroke-width', ['match', ['get', 'selected'], 'true', circleWidth, newWidth]);
        mapVar.setPaintProperty('points-fill', 'circle-stroke-color', ['match', ['get', 'selected'], 'true', '#fff', '#000']);
      }
    }
    if (mapVar !== null && mapVar !== void 0 && mapVar.getLayer('points-fill-1')) {
      mapVar.setPaintProperty('points-fill-1', 'circle-stroke-width', ['match', ['get', 'id'], selectedId, circleWidth, newWidth]);
      mapVar.setPaintProperty('points-fill-1', 'circle-stroke-color', ['match', ['get', 'id'], selectedId, '#fff', '#000']);
    }
  } else if (mapVar !== null && mapVar !== void 0 && mapVar.getLayer('points-fill')) {
    mapVar.setPaintProperty('points-fill', 'circle-stroke-width', ['match', ['get', 'selected'], 'true', circleWidth, newWidth]);
    mapVar.setPaintProperty('points-fill', 'circle-stroke-color', ['match', ['get', 'selected'], 'true', '#fff', '#000']);
  } else if (mapVar !== null && mapVar !== void 0 && mapVar.getLayer('points-fill-1')) {
    mapVar.setPaintProperty('points-fill-1', 'circle-stroke-width', ['match', ['get', 'selected'], 'true', circleWidth, newWidth]);
    mapVar.setPaintProperty('points-fill-1', 'circle-stroke-color', ['match', ['get', 'selected'], 'true', '#fff', '#000']);
  }
}
function onPlantClick(d, mapVar, layerId, isPlants, highlightPlant, onClickBlock) {
  var _d$features2, _d$features3, _d$features4;
  var isBlock = (d === null || d === void 0 || (_d$features2 = d.features) === null || _d$features2 === void 0 || (_d$features2 = _d$features2[0]) === null || _d$features2 === void 0 || (_d$features2 = _d$features2.layer) === null || _d$features2 === void 0 || (_d$features2 = _d$features2.id) === null || _d$features2 === void 0 ? void 0 : _d$features2.indexOf('block')) >= 0;
  if (isPlants && !isBlock && ((d === null || d === void 0 || (_d$features3 = d.features) === null || _d$features3 === void 0 || (_d$features3 = _d$features3[0]) === null || _d$features3 === void 0 ? void 0 : _d$features3.source) === 'point' || (d === null || d === void 0 || (_d$features4 = d.features) === null || _d$features4 === void 0 || (_d$features4 = _d$features4[0]) === null || _d$features4 === void 0 ? void 0 : _d$features4.source) === 'point1')) {
    var _d$features5;
    var changeId = d === null || d === void 0 || (_d$features5 = d.features) === null || _d$features5 === void 0 || (_d$features5 = _d$features5[0]) === null || _d$features5 === void 0 || (_d$features5 = _d$features5.properties) === null || _d$features5 === void 0 ? void 0 : _d$features5.id;
    selectedId = changeId;
    mapVar.setPaintProperty(layerId, 'circle-radius', ['match', ['get', 'id'], changeId, getRadiusByZoom(mapVar), getRadiusByZoom(mapVar)]);
    mapVar.setPaintProperty(layerId, 'circle-stroke-color', ['match', ['get', 'id'], changeId, '#fff', '#000']);
    mapVar.setPaintProperty(layerId, 'circle-stroke-width', ['match', ['get', 'id'], changeId, 3, getWidthByZoom(currZoom)]);
    if (highlightPlant) {
      mapVar.setPaintProperty('points-fill', 'circle-stroke-width', ['match', ['get', 'selected'], 'true', circleWidth, getWidthByZoom(currZoom)]);
      mapVar.setPaintProperty('points-fill', 'circle-stroke-color', ['match', ['get', 'selected'], 'true', '#fff', '#000']);
    }
    if (onClickBlock) {
      var _d$features6;
      onClickBlock({
        type: 'point',
        data: d === null || d === void 0 || (_d$features6 = d.features) === null || _d$features6 === void 0 || (_d$features6 = _d$features6[0]) === null || _d$features6 === void 0 ? void 0 : _d$features6.properties,
        latLng: JSON.parse(JSON.stringify(d.lngLat))
      });
    }
  }
}
var onClickFunc;
var isPlantMode;
function addNewLayer(mapVar, sourceId, layerId, plantOption, showPlants, highlightPlant) {
  var _mapVar$style2;
  var zoom = mapVar === null || mapVar === void 0 ? void 0 : mapVar.getZoom();
  if (!(mapVar !== null && mapVar !== void 0 && mapVar.getLayer(layerId)) && mapVar !== null && mapVar !== void 0 && (_mapVar$style2 = mapVar.style) !== null && _mapVar$style2 !== void 0 && _mapVar$style2._loaded) {
    mapVar.addLayer({
      id: layerId,
      type: 'circle',
      source: sourceId,
      paint: {
        'circle-radius': getRadiusByZoom(mapVar),
        'circle-stroke-width': ['match', ['get', 'selected'], 'true', circleWidth, getWidthByZoom(zoom)],
        'circle-stroke-color': ['match', ['get', 'selected'], 'true', '#fff', '#000'],
        'circle-color': plantOption === 'count' ? ['match', ['get', 'healthClassification'], 'missing', 'white', 'dead', 'red', 'undeveloped', 'yellow', 'normal', '#3887be', '#000'] : ['get', "".concat(plantOption, "_color")] || '#000'
      },
      layout: {
        visibility: showPlants ? 'visible' : 'none'
      }
    });
    applyPointsStyles(mapVar, zoom, highlightPlant);
    if (!showPlants) {
      selectedId = null;
    }
    detachEventsWithLayerId(mapVar, eventRef$1);
    detachEventsWithLayerId(mapVar, eventRefRight$1);
    var layerOnClick = function layerOnClick(d) {
      onPlantClick(d, mapVar, layerId, isPlantMode, highlightPlant, onClickFunc);
    };
    var attachMouseEnter = function attachMouseEnter() {
      return mouseEnter(mapVar);
    };
    var attachMouseLeave = function attachMouseLeave() {
      return mouseLeave(mapVar);
    };
    var attachOnZoom = function attachOnZoom() {
      return onZoom$1(mapVar);
    };
    var isLeftMap = sourceId === 'point';
    (isLeftMap ? eventRef$1 : eventRefRight$1).mouseenter = {
      event: attachMouseEnter,
      layerId: layerId
    };
    (isLeftMap ? eventRef$1 : eventRefRight$1).mouseleave = {
      event: attachMouseLeave,
      layerId: layerId
    };
    (isLeftMap ? eventRef$1 : eventRefRight$1).zoom = {
      event: attachOnZoom
    };
    (isLeftMap ? eventRef$1 : eventRefRight$1).click = {
      event: layerOnClick,
      layerId: layerId
    };

    // Attach the events to the map ref
    mapVar.on('mouseenter', layerId, attachMouseEnter);
    mapVar.on('mouseleave', layerId, attachMouseLeave);
    mapVar.on('zoom', attachOnZoom);
    mapVar.on('click', layerId, layerOnClick);
  }
}
var prevBlockId;
function onMapClick(d, isPlants, mapVar, layerId, highlightPlant, showSideBySideMap, showPlants, plantOption, glMapRef, glRightMapRef, onClickBlock) {
  var _d$features7, _d$features8, _d$features9;
  onPlantClick(d, mapVar, layerId, isPlants, highlightPlant, onClickBlock);
  var isBlock = (d === null || d === void 0 || (_d$features7 = d.features) === null || _d$features7 === void 0 || (_d$features7 = _d$features7[0]) === null || _d$features7 === void 0 || (_d$features7 = _d$features7.layer) === null || _d$features7 === void 0 || (_d$features7 = _d$features7.id) === null || _d$features7 === void 0 ? void 0 : _d$features7.indexOf('block')) >= 0;
  if (isPlants && !isBlock && ((d === null || d === void 0 || (_d$features8 = d.features) === null || _d$features8 === void 0 || (_d$features8 = _d$features8[0]) === null || _d$features8 === void 0 ? void 0 : _d$features8.source) === 'point' || (d === null || d === void 0 || (_d$features9 = d.features) === null || _d$features9 === void 0 || (_d$features9 = _d$features9[0]) === null || _d$features9 === void 0 ? void 0 : _d$features9.source) === 'point1')) {
    var _d$target, _d$target2;
    if ((d === null || d === void 0 || (_d$target = d.target) === null || _d$target === void 0 ? void 0 : _d$target._container.id) === 'after' && showSideBySideMap) {
      if (glMapRef.current.getLayer('points-fill')) glMapRef.current.removeLayer('points-fill');
      addNewLayer(glMapRef.current, 'point', 'points-fill', plantOption, showPlants, highlightPlant);
    }
    if ((d === null || d === void 0 || (_d$target2 = d.target) === null || _d$target2 === void 0 ? void 0 : _d$target2._container.id) === 'before' && showSideBySideMap) {
      if (glRightMapRef.current.getLayer('points-fill-1')) {
        glRightMapRef.current.removeLayer('points-fill-1');
      }
      addNewLayer(glRightMapRef.current, 'point1', 'points-fill-1', plantOption, showPlants, highlightPlant);
    }
  }
}
// Below codes will be abstracted in future
function loadDataSource(mapVar, sourceId, layerId, plantOption, data, style, isBoundary, isRanch, isLabel, addLayerOnly, isPlants, onClickBlock, showSideBySideMap, showPlants, glMapRef, glRightMapRef, highlightPlant) {
  var _data$features, _data$features2, _mapVar$style3, _mapVar$style4;
  if (!(data !== null && data !== void 0 && data.type)) return;
  if (!showPlants) {
    selectedId = null;
  }

  // To store previous block id to recalculate plant circle
  if (isPlants && data !== null && data !== void 0 && (_data$features = data.features) !== null && _data$features !== void 0 && _data$features.length && !prevBlockId) {
    prevBlockId = data === null || data === void 0 ? void 0 : data.blockId;
    plantObj = data === null || data === void 0 ? void 0 : data.plantObj;
  }

  // Reset to default for plant circle calculation
  if (data !== null && data !== void 0 && (_data$features2 = data.features) !== null && _data$features2 !== void 0 && _data$features2.length && prevBlockId && prevBlockId !== (data === null || data === void 0 ? void 0 : data.blockId) && isPlants) {
    averageSpacing = 0;
    baseRadius = 3;
    renderedCircles = [];
    prevBlockId = data === null || data === void 0 ? void 0 : data.blockId;
    plantObj = data === null || data === void 0 ? void 0 : data.plantObj;
  }
  latLng = mapVar === null || mapVar === void 0 ? void 0 : mapVar.getCenter();
  onClickFunc = onClickBlock;
  isPlantMode = isPlants;
  var attachOnZoom = function attachOnZoom() {
    return onZoom$1(mapVar);
  };
  var attachMouseEnter = function attachMouseEnter() {
    return mouseEnter(mapVar);
  };
  var attachMouseLeave = function attachMouseLeave() {
    return mouseLeave(mapVar);
  };
  var attachOnClick = function attachOnClick(d) {
    if (!isPlants && onClickBlock) {
      var features = mapVar === null || mapVar === void 0 ? void 0 : mapVar.queryRenderedFeatures(d.point);
      features.forEach(function (feature) {
        var clickedLayerId = feature.layer.id;
        if ((clickedLayerId === null || clickedLayerId === void 0 ? void 0 : clickedLayerId.indexOf('block')) >= 0) {
          onClickBlock({
            type: 'block',
            data: feature === null || feature === void 0 ? void 0 : feature.properties,
            latLng: JSON.parse(JSON.stringify(d.lngLat))
          });
        }
      });
    }
    onMapClick(d, isPlants, mapVar, layerId, highlightPlant, showSideBySideMap, showPlants, plantOption, glMapRef, glRightMapRef, onClickBlock);
  };

  // Detach the previously attached events
  detachEventsWithLayerId(mapVar, eventRef$1);
  detachEventsWithLayerId(mapVar, eventRefRight$1);
  if (!addLayerOnly && !mapVar.getSource(sourceId) && mapVar !== null && mapVar !== void 0 && (_mapVar$style3 = mapVar.style) !== null && _mapVar$style3 !== void 0 && _mapVar$style3._loaded) {
    mapVar.addSource(sourceId, {
      type: 'geojson',
      data: data,
      generateId: true
    });
  }
  var layerPaint = style;
  var layerType = 'fill';
  if (isBoundary && isRanch) {
    layerType = 'line';
    layerPaint = style;
  }
  if (!isBoundary && !isRanch) {
    // Reset the zoom level when adding layer
    if (currZoom > (mapVar === null || mapVar === void 0 ? void 0 : mapVar.getZoom())) {
      currZoom = mapVar === null || mapVar === void 0 ? void 0 : mapVar.getZoom();
    }
    layerType = 'circle';
    layerPaint = {
      'circle-radius': getRadiusByZoom(mapVar),
      'circle-stroke-width': ['match', ['get', 'selected'], 'true', circleWidth, getWidthByZoom(currZoom)],
      'circle-stroke-color': ['match', ['get', 'selected'], 'true', '#fff', '#000'],
      'circle-color': plantOption === 'count' ? ['match', ['get', 'healthClassification'], 'missing', 'white', 'dead', 'red', 'undeveloped', 'yellow', 'normal', '#3887be', '#000'] : ['get', "".concat(plantOption, "_color")] || '#000'
    };
  }
  if (isLabel) {
    layerType = 'symbol';
    layerPaint = {
      'text-color': '#ffffff'
    };
  }
  if (!(mapVar !== null && mapVar !== void 0 && mapVar.getLayer(layerId)) && layerPaint && mapVar !== null && mapVar !== void 0 && (_mapVar$style4 = mapVar.style) !== null && _mapVar$style4 !== void 0 && _mapVar$style4._loaded) {
    mapVar.addLayer({
      id: layerId,
      type: layerType,
      source: sourceId,
      paint: layerPaint,
      layout: isLabel ? {
        'text-field': ['get', 'name'],
        'text-font': ['Open Sans Semibold', 'Arial Unicode MS Bold'],
        'text-size': 14,
        'text-offset': [0, 0],
        'text-anchor': 'top'
      } : {
        visibility: showPlants ? 'visible' : 'none'
      }
    });

    // To solve the plant circle are small size issue on the initial load
    if (!isBoundary && !isRanch && isPlants) {
      renderedCircles = (data === null || data === void 0 ? void 0 : data.features) || [];
      averageSpacing = 0;
      baseRadius = 3;
    }
    var isLeftMap = sourceId === 'point';
    // Store the event details
    (isLeftMap ? eventRef$1 : eventRefRight$1).zoom = {
      event: attachOnZoom
    };
    (isLeftMap ? eventRef$1 : eventRefRight$1).mouseenter = {
      event: attachMouseEnter,
      layerId: layerId
    };
    (isLeftMap ? eventRef$1 : eventRefRight$1).mouseleave = {
      event: attachMouseLeave,
      layerId: layerId
    };
    if (!isPlants) {
      (isLeftMap ? eventRef$1 : eventRefRight$1).click = {
        event: attachOnClick
      };
    } else {
      (isLeftMap ? eventRef$1 : eventRefRight$1).click = {
        event: attachOnClick,
        layerId: layerId
      };
    }

    // Attach the events to the map ref
    mapVar.on('zoom', attachOnZoom);
    mapVar.on('mouseenter', layerId, attachMouseEnter);
    mapVar.on('mouseleave', layerId, attachMouseLeave);
    if (!isPlants) {
      // attach click event for the block polygon
      mapVar.on('click', attachOnClick);
    } else {
      // attach click event for the plant points
      mapVar.on('click', layerId, attachOnClick);
    }
  }
}

// Below codes will be abstracted in future
function getStyleForRanch(mapVar, geoJSONData, layerNumber, expandedGeoJSON, colors, presentationMode, isPlants, onClickBlock, showSideBySideMap, glMapRef, glRightMapRef, highlightPlant) {
  var layerId = layerNumber ? layerNumber * 100 : 100;
  if (Boolean(geoJSONData) && Boolean(geoJSONData.features.length) && geoJSONData.features[0]) {
    clearGlLayers(mapVar, layerNumber, 'ranch', 'ranch-fill-', [1]);
    geoJSONData.features.forEach(function (feature, i) {
      var featureRanch = cloneDeep(feature);
      featureRanch.geometry.type = 'MultiLineString';
      var style = {
        color: 'white',
        weight: 2
      };
      try {
        // space for any conditional style rendering based on properties
        if (expandedGeoJSON !== null && expandedGeoJSON !== void 0 && expandedGeoJSON.features && expandedGeoJSON.features.length === 1 && expandedGeoJSON.features[0].properties.id === feature.properties.id) {
          delete style.dashArray;
          style.weight = 4;
          style.dashArray = [10, 10];
        }
        if (presentationMode) {
          switch (presentationMode) {
            case 'soilstatus':
              {
                if (feature.properties.state && feature.properties.state.state) {
                  style.color = (colors || stateColorCode)[feature.properties.state.state].markerColor;
                }
                break;
              }
            case 'connectivity':
              {
                if (feature.properties.connectivityState) {
                  style.color = (colors || stateColorCode)[feature.properties.connectivityState].markerColor;
                }
                break;
              }
            case 'waterpressure':
              {
                if (feature.properties.waterPressureState) {
                  style.color = (colors || stateColorCode)[feature.properties.waterPressureState].markerColor;
                }
                break;
              }
            case 'control':
              {
                if (feature.properties.controlState) {
                  style.color = (colors || stateColorCode)[feature.properties.controlState].markerColor;
                }
                break;
              }
            case 'provision':
              {
                if (feature.properties.provisionState) {
                  style.color = (colors || stateColorCode)[feature.properties.provisionState].markerColor;
                }
                break;
              }
            case 'cropHealth':
              {
                if (feature.properties.cropState) {
                  style.color = (colors || stateColorCode)[feature.properties.cropState].markerColor;
                }
                break;
              }
            default:
              style.color = 'white';
          }
        }
      } catch (error) {
        console.log('ERROR in Map.jsx ranch data anomaly', error);
      }
      loadDataSource(mapVar, "ranch".concat(i + 1 + layerId), "ranch-fill-".concat(i + 1 + layerId), undefined, feature, {
        'line-color': style.color,
        'line-width': 2
      }, true, true, false, false, isPlants, onClickBlock, showSideBySideMap, true, glMapRef, glRightMapRef, highlightPlant);
    });
  }
}

// Below codes will be abstracted in future
function getStyleForBlock(mapVar, geoJSONData, layerNumber, expandedGeoJSON, colors, presentationMode, CONDITION_CHECK, isPlants, onClickBlock, showSideBySideMap, glMapRef, glRightMapRef, highlightPlant) {
  var layerId = layerNumber ? layerNumber * 100 : 100;
  if (Boolean(geoJSONData) && Boolean(geoJSONData.features.length) && geoJSONData.features[0]) {
    clearGlLayers(mapVar, layerNumber, 'block', 'block-fill-', [1, 10, 20]);
    geoJSONData.features.forEach(function (feature, i) {
      var _bbox = bbox(feature),
        _bbox2 = _slicedToArray(_bbox, 4),
        minLng = _bbox2[0],
        minLat = _bbox2[1],
        maxLng = _bbox2[2],
        maxLat = _bbox2[3];
      var position = [(minLat + maxLat) / 2, (minLng + maxLng) / 2];
      var style = {
        color: 'white',
        weight: 2,
        fillOpacity: CONDITION_CHECK && !isPlants ? 0.5 : 0
      };
      var geometry = {
        type: 'Point',
        coordinates: [position[1], position[0]]
      };
      var changedFeature = _objectSpread2(_objectSpread2({}, feature), {}, {
        geometry: geometry
      });
      try {
        if (expandedGeoJSON !== null && expandedGeoJSON !== void 0 && expandedGeoJSON.features && expandedGeoJSON.features.length === 1 && expandedGeoJSON.features[0].properties.id === feature.properties.id) {
          style.weight = 4;
          style.fillOpacity = 0;
          style.dashArray = [10, 10];
        }
        if (presentationMode) {
          switch (presentationMode) {
            case 'soilstatus':
              {
                var soilStateStringOfBlock = feature.properties.soilStateStringOfBlock;
                var color = getColorCodeForSoilState(soilStateStringOfBlock);
                style.color = color;
                if (CONDITION_CHECK) {
                  style.fillColor = color;
                  style.fillOpacity = 0.5;
                }
                break;
              }
            case 'connectivity':
              {
                if (feature.properties.connectivityState) {
                  style.color = (colors || stateColorCode)[feature.properties.connectivityState].markerColor;
                  if (CONDITION_CHECK) {
                    style.fillColor = (colors || stateColorCode)[feature.properties.connectivityState].markerColor;
                    style.fillOpacity = 0.5;
                  }
                }
                break;
              }
            case 'waterpressure':
              {
                if (typeof feature.properties.waterPressureState !== 'undefined') {
                  style.color = (colors || stateColorCode)[feature.properties.waterPressureState].markerColor;
                  if (CONDITION_CHECK) {
                    style.fillColor = (colors || stateColorCode)[feature.properties.waterPressureState].markerColor;
                    style.fillOpacity = 0.5;
                  }
                }
                break;
              }
            case 'control':
              {
                if (typeof feature.properties.controlState !== 'undefined') {
                  style.color = (colors || stateColorCode)[feature.properties.waterPressureState].markerColor;
                  if (CONDITION_CHECK) {
                    style.fillColor = (colors || stateColorCode)[feature.properties.waterPressureState].markerColor;
                    style.fillOpacity = 0.5;
                  }
                }
                break;
              }
            case 'provision':
              {
                if (feature.properties.provisionState) {
                  style.color = (colors || stateColorCode)[feature.properties.provisionState].markerColor;
                  if (CONDITION_CHECK) {
                    style.fillColor = (colors || stateColorCode)[feature.properties.provisionState].markerColor;
                    style.fillOpacity = 0.5;
                  }
                }
                break;
              }
            case 'irrigationRecommendation':
              {
                if (feature.properties.recommendationInfo && feature.properties.recommendationInfo.state) {
                  var _color = getColorCodeForIrrigationState(feature.properties.recommendationInfo.state);
                  style.color = _color;
                  if (CONDITION_CHECK) {
                    style.fillColor = _color;
                    style.fillOpacity = 0.5;
                  }
                } else {
                  var _color2 = getColorCodeForIrrigationState();
                  style.color = getColorCodeForIrrigationState();
                  if (CONDITION_CHECK) {
                    style.fillColor = _color2;
                    style.fillOpacity = 0.5;
                  }
                }
                break;
              }
            case 'cropHealth':
              {
                if (typeof feature.properties.cropState !== 'undefined') {
                  style.color = (colors || stateColorCode)[feature.properties.cropState].markerColor;
                  if (CONDITION_CHECK) {
                    style.fillColor = (colors || stateColorCode)[feature.properties.cropState].markerColor;
                    style.fillOpacity = 0.5;
                  }
                }
                break;
              }
            default:
              style.color = 'white';
          }
        }
      } catch (error) {
        console.log('ERROR in Map.jsx block data anomaly', error);
      }
      loadDataSource(mapVar, "block".concat(i + 1 + layerId), "block-fill-".concat(i + 1 + layerId), undefined, feature, {
        'fill-color': style.color,
        'fill-opacity': style.fillOpacity
      }, true, false, false, false, isPlants, onClickBlock, showSideBySideMap, true, glMapRef, glRightMapRef, highlightPlant);
      loadDataSource(mapVar, "block".concat(i + 1 + layerId * 10), "block-fill-".concat(i + 1 + layerId * 10), undefined, feature, {
        'line-color': style.color,
        'line-width': 2
      }, true, true, false, false, isPlants, onClickBlock, showSideBySideMap, true, glMapRef, glRightMapRef, highlightPlant);
      // for label
      if ((mapVar === null || mapVar === void 0 ? void 0 : mapVar.getZoom()) > 13 && !showSideBySideMap) {
        loadDataSource(mapVar, "block".concat(i + 1 + layerId * 20), "block-fill-".concat(i + 1 + layerId * 20), undefined, changedFeature, undefined, true, undefined, true, false, isPlants, onClickBlock, showSideBySideMap, true, glMapRef, glRightMapRef, highlightPlant);
      }
      if (showSideBySideMap) {
        loadDataSource(mapVar, "block".concat(i + 1 + layerId * 20), "block-fill-".concat(i + 1 + layerId * 20), undefined, changedFeature, undefined, true, undefined, true, false, isPlants, onClickBlock, showSideBySideMap, true, glMapRef, glRightMapRef, highlightPlant);
      }
    });
  }
}
function clearImageryLayers(mapVar, layerStr, sourceStr) {
  if (!mapVar) return;
  for (var i = 0; i < 50; i += 1) {
    if (mapVar !== null && mapVar !== void 0 && mapVar.getLayer("".concat(layerStr).concat(i))) mapVar.removeLayer("".concat(layerStr).concat(i));
    if (mapVar !== null && mapVar !== void 0 && mapVar.getSource("".concat(sourceStr).concat(i))) mapVar.removeSource("".concat(sourceStr).concat(i));
  }
}
function showErrorInfo(dsm, droneDataType, t) {
  notification.config({
    maxCount: 1
  });
  notification.error({
    message: "".concat(t('The drone imagery for the type'), " \"").concat(dataTypeLabel[droneDataType] || dataTypeLabel[dsm] || droneDataType, "\" ").concat(t('is not available'))
  });
}
function renderImageryLayer(mapVar, data, sourceId, layerId, droneDataType, image, t) {
  if (!mapVar) return;
  data.forEach(function (d, i) {
    if (!(d !== null && d !== void 0 && d.tiles)) {
      var _mapVar$style5;
      var imageUrl = "".concat(d.png_url, "&temp=").concat(Date.now() + i);
      // eslint-disable-next-line no-unused-vars
      var polygon = JSON.parse(d.bounds).coordinates[0];
      var minLng = Infinity;
      var minLat = Infinity;
      var maxLng = -Infinity;
      var maxLat = -Infinity;
      polygon.forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          lng = _ref2[0],
          lat = _ref2[1];
        minLng = Math.min(minLng, lng);
        minLat = Math.min(minLat, lat);
        maxLng = Math.max(maxLng, lng);
        maxLat = Math.max(maxLat, lat);
      });
      var imageCoordinates = [[minLng, maxLat],
      // top-left
      [maxLng, maxLat],
      // top-right
      [maxLng, minLat],
      // bottom-right
      [minLng, minLat] // bottom-left
      ];
      var stableCoordinates = imageCoordinates.map(function (c) {
        return _toConsumableArray(c);
      });
      if (mapVar !== null && mapVar !== void 0 && (_mapVar$style5 = mapVar.style) !== null && _mapVar$style5 !== void 0 && _mapVar$style5._loaded) {
        mapVar.addSource("".concat(sourceId).concat(i), {
          type: 'image',
          url: image || imageUrl,
          coordinates: stableCoordinates
        });
        mapVar.addLayer({
          id: "".concat(layerId).concat(i),
          type: 'raster',
          source: "".concat(sourceId).concat(i),
          paint: {
            'raster-opacity': 90 / 100,
            'raster-fade-duration': 0
          }
        });
        mapVar.moveLayer("".concat(layerId).concat(i), mapVar.getStyle().layers[1].id);
      }
    } else {
      var _mapVar$style6, _mapVar$style7;
      var _ref3 = d || {},
        tiles = _ref3.tiles,
        minZoom = _ref3.minZoom,
        maxZoom = _ref3.maxZoom;

      // There are two possible imagery tiles for the "Canopy Height". Ex: "NDSM" and "DSM"
      // To pick the tile data based on the availability
      var dsm = droneDataType === 'NDSM' ? 'DSM' : null;
      var selectedTileUrl = (tiles === null || tiles === void 0 ? void 0 : tiles[droneDataType]) || (tiles === null || tiles === void 0 ? void 0 : tiles[dsm]);
      if (!(mapVar !== null && mapVar !== void 0 && mapVar.getSource("".concat(sourceId).concat(i))) && selectedTileUrl && mapVar !== null && mapVar !== void 0 && (_mapVar$style6 = mapVar.style) !== null && _mapVar$style6 !== void 0 && _mapVar$style6._loaded) {
        mapVar.addSource("".concat(sourceId).concat(i), {
          type: 'raster',
          tiles: [selectedTileUrl],
          tileSize: 256
        });
      }
      if (selectedTileUrl && mapVar !== null && mapVar !== void 0 && (_mapVar$style7 = mapVar.style) !== null && _mapVar$style7 !== void 0 && _mapVar$style7._loaded) {
        mapVar.addLayer({
          id: "".concat(layerId).concat(i),
          type: 'raster',
          source: "".concat(sourceId).concat(i),
          minzoom: minZoom,
          maxzoom: Math.min(24, maxZoom),
          // MaxZoom Ref: https://maplibre.org/maplibre-style-spec/layers/#maxzoom
          paint: {
            'raster-opacity': 90 / 100,
            'raster-fade-duration': 0
          }
        });
        mapVar.moveLayer("".concat(layerId).concat(i), mapVar.getStyle().layers[1].id);
      } else if (t && !selectedTileUrl) {
        // Notification popup appears only once,
        // when the imagery tile is not available for the selected date.
        showErrorInfo(dsm, droneDataType, t);
      }
    }
  });
}
function renderBlockLayer(glMapRef, glRightMapRef, blocksGeoJSON, expandedGeoJSON, colors, presentationMode, CONDITION_CHECK, isPlants, onClickBlock, showSideBySideMap) {
  var _blocksGeoJSON$featur;
  if (blocksGeoJSON !== null && blocksGeoJSON !== void 0 && (_blocksGeoJSON$featur = blocksGeoJSON.features) !== null && _blocksGeoJSON$featur !== void 0 && _blocksGeoJSON$featur.length) {
    var _glRightMapRef$curren, _glRightMapRef$curren2;
    getStyleForBlock(glMapRef.current, blocksGeoJSON, 1, expandedGeoJSON, colors, presentationMode, CONDITION_CHECK, isPlants, onClickBlock, showSideBySideMap, glMapRef, glRightMapRef);
    if (glRightMapRef !== null && glRightMapRef !== void 0 && glRightMapRef.current || glRightMapRef !== null && glRightMapRef !== void 0 && (_glRightMapRef$curren = glRightMapRef.current) !== null && _glRightMapRef$curren !== void 0 && _glRightMapRef$curren.isStyleLoaded && glRightMapRef !== null && glRightMapRef !== void 0 && (_glRightMapRef$curren2 = glRightMapRef.current) !== null && _glRightMapRef$curren2 !== void 0 && _glRightMapRef$curren2.isStyleLoaded()) {
      getStyleForBlock(glRightMapRef.current, blocksGeoJSON, 3, expandedGeoJSON, colors, presentationMode, CONDITION_CHECK, isPlants, onClickBlock, showSideBySideMap, glMapRef, glRightMapRef);
    }
  }
}
function renderRanchLayer(glMapRef, glRightMapRef, ranchesGeoJSON, expandedGeoJSON, colors, presentationMode, isPlants, onClickBlock, showSideBySideMap) {
  var _ranchesGeoJSON$featu;
  if (ranchesGeoJSON !== null && ranchesGeoJSON !== void 0 && (_ranchesGeoJSON$featu = ranchesGeoJSON.features) !== null && _ranchesGeoJSON$featu !== void 0 && _ranchesGeoJSON$featu.length) {
    var _glRightMapRef$curren3, _glRightMapRef$curren4;
    getStyleForRanch(glMapRef.current, ranchesGeoJSON, 2, expandedGeoJSON, colors, presentationMode, isPlants, onClickBlock, showSideBySideMap, glMapRef, glRightMapRef);
    if (glRightMapRef !== null && glRightMapRef !== void 0 && glRightMapRef.current || glRightMapRef !== null && glRightMapRef !== void 0 && (_glRightMapRef$curren3 = glRightMapRef.current) !== null && _glRightMapRef$curren3 !== void 0 && _glRightMapRef$curren3.isStyleLoaded && glRightMapRef !== null && glRightMapRef !== void 0 && (_glRightMapRef$curren4 = glRightMapRef.current) !== null && _glRightMapRef$curren4 !== void 0 && _glRightMapRef$curren4.isStyleLoaded()) {
      getStyleForRanch(glRightMapRef.current, ranchesGeoJSON, 4, expandedGeoJSON, colors, presentationMode, isPlants, onClickBlock, showSideBySideMap, glMapRef, glRightMapRef);
    }
  }
}
function renderLeftImagery(glMapRef, droneDataType, data, isSatellite, renderImagery, highlightPlant, t) {
  var sourceLeft = isSatellite ? 'satellite-imagery-' : 'drone-imagery-';
  var layerLeft = isSatellite ? 'overlay' : 'drone-overlay-';
  var CONDITION_CHECK = highlightPlant && !renderImagery;
  if (!CONDITION_CHECK) {
    clearImageryLayers(glMapRef.current, 'drone-overlay-', 'drone-imagery-');
    clearImageryLayers(glMapRef.current, 'overlay', 'satellite-imagery-');
  }
  if (!renderImagery) {
    renderImageryLayer(glMapRef.current, data || [], sourceLeft, layerLeft, droneDataType, undefined, t);
  }
}
function renderRightImagery(glRightMapRef, droneDataType, data, isSatellite, renderImagery, t) {
  var sourceRight = isSatellite ? 'satellite-imagery-right-' : 'drone-imagery-right-';
  var layerRight = isSatellite ? 'overlay-right-' : 'drone-overlay-right-';
  clearImageryLayers(glRightMapRef.current, 'drone-overlay-right-', 'drone-imagery-right-');
  clearImageryLayers(glRightMapRef.current, 'overlay-right-', 'satellite-imagery-right-');
  if (!renderImagery) {
    renderImageryLayer(glRightMapRef.current, data || [], sourceRight, layerRight, droneDataType, undefined, t);
  }
}
function renderLayersOnLoad(glMapRef, glRightMapRef, showSideBySideMap, onClickBlock, isPlants, blocksGeoJSON, ranchesGeoJSON, presentationMode, expandedGeoJSON, colors, CONDITION_CHECK, isShowingImagery, highlightPlant, t) {
  var _isShowingImagery$oth;
  if (!highlightPlant) {
    renderBlockLayer(glMapRef, glRightMapRef, blocksGeoJSON, expandedGeoJSON, colors, presentationMode, CONDITION_CHECK, isPlants, onClickBlock, showSideBySideMap);
    renderRanchLayer(glMapRef, glRightMapRef, ranchesGeoJSON, expandedGeoJSON, colors, presentationMode, isPlants, onClickBlock, showSideBySideMap);
  }
  var isSatellite = isShowingImagery.isSatellite,
    data = isShowingImagery.data,
    otherSide = isShowingImagery.otherSide,
    isSatelliteRight = isShowingImagery.isSatelliteRight;
  if (isShowingImagery !== null && isShowingImagery !== void 0 && isShowingImagery.visible) {
    renderLeftImagery(glMapRef, isShowingImagery === null || isShowingImagery === void 0 ? void 0 : isShowingImagery.droneDataType, data, isSatellite, false, highlightPlant, t);
  } else {
    renderLeftImagery(glMapRef, isShowingImagery === null || isShowingImagery === void 0 ? void 0 : isShowingImagery.droneDataType, data, isSatellite, true, highlightPlant, t);
  }
  if (isShowingImagery !== null && isShowingImagery !== void 0 && (_isShowingImagery$oth = isShowingImagery.otherSide) !== null && _isShowingImagery$oth !== void 0 && _isShowingImagery$oth.visible) {
    var _isShowingImagery$oth2;
    renderRightImagery(glRightMapRef, isShowingImagery === null || isShowingImagery === void 0 || (_isShowingImagery$oth2 = isShowingImagery.otherSide) === null || _isShowingImagery$oth2 === void 0 ? void 0 : _isShowingImagery$oth2.droneDataType, otherSide === null || otherSide === void 0 ? void 0 : otherSide.data, isSatelliteRight, false, t);
  } else {
    var _isShowingImagery$oth3;
    renderRightImagery(glRightMapRef, isShowingImagery === null || isShowingImagery === void 0 || (_isShowingImagery$oth3 = isShowingImagery.otherSide) === null || _isShowingImagery$oth3 === void 0 ? void 0 : _isShowingImagery$oth3.droneDataType, otherSide === null || otherSide === void 0 ? void 0 : otherSide.data, isSatelliteRight, true, t);
  }
}
function bringLabelsToFront(mapVar) {
  var _layers$filter;
  if (!mapVar) return;
  var labelStr = 'block';
  var plantsLayerIdLeft = 'points-fill';
  var plantsLayerIdRight = 'points-fill-1';
  var soilLayerId = 'wms-soil-layer';
  var _mapVar$getStyle = mapVar === null || mapVar === void 0 ? void 0 : mapVar.getStyle(),
    layers = _mapVar$getStyle.layers;
  var plantsLayersLeft = layers.filter(function (d) {
    return (d === null || d === void 0 ? void 0 : d.id) === plantsLayerIdLeft;
  });
  var plantsLayersRight = layers.filter(function (d) {
    return (d === null || d === void 0 ? void 0 : d.id) === plantsLayerIdRight;
  });
  var ids = layers.filter(function (d) {
    var _d$id;
    return (d === null || d === void 0 || (_d$id = d.id) === null || _d$id === void 0 ? void 0 : _d$id.indexOf(labelStr)) !== -1 && (d === null || d === void 0 ? void 0 : d.type) === 'symbol';
  }).map(function (d) {
    return d === null || d === void 0 ? void 0 : d.id;
  });
  ids.forEach(function (id) {
    mapVar.moveLayer(id, layers[layers.length - 1].id);
  });

  // Get layer ids from map styles and filter by ranch and block
  var blockAndRanchLayerids = layers === null || layers === void 0 ? void 0 : layers.filter(function (d) {
    var _d$id2, _d$id3;
    return (d === null || d === void 0 || (_d$id2 = d.id) === null || _d$id2 === void 0 ? void 0 : _d$id2.indexOf('block')) !== -1 || (d === null || d === void 0 || (_d$id3 = d.id) === null || _d$id3 === void 0 ? void 0 : _d$id3.indexOf('ranch')) !== -1;
  }).map(function (d) {
    return d === null || d === void 0 ? void 0 : d.id;
  });
  var isSoilLayerAvailable = layers === null || layers === void 0 || (_layers$filter = layers.filter(function (d) {
    return (d === null || d === void 0 ? void 0 : d.id) === soilLayerId;
  })) === null || _layers$filter === void 0 ? void 0 : _layers$filter.length;

  // To move the soil layer behind the ranch, block boundary layer
  if (isSoilLayerAvailable) {
    mapVar.moveLayer(soilLayerId, layers[layers.length - ((blockAndRanchLayerids === null || blockAndRanchLayerids === void 0 ? void 0 : blockAndRanchLayerids.length) + 1)].id);
  }

  // To move plant layers to behind the label layer
  if (plantsLayersLeft !== null && plantsLayersLeft !== void 0 && plantsLayersLeft.length) {
    mapVar.moveLayer(plantsLayerIdLeft, layers[layers.length - ((ids === null || ids === void 0 ? void 0 : ids.length) + 1)].id);
  }
  if (plantsLayersRight !== null && plantsLayersRight !== void 0 && plantsLayersRight.length) {
    mapVar.moveLayer(plantsLayerIdRight, layers[layers.length - ((ids === null || ids === void 0 ? void 0 : ids.length) + 1)].id);
  }
}
function renderOrHideLabels(mapVar, hide) {
  if (!mapVar) return;
  var labelStr = 'block';
  var layers = [];
  if (mapVar !== null && mapVar !== void 0 && mapVar.isStyleLoaded && mapVar !== null && mapVar !== void 0 && mapVar.isStyleLoaded()) {
    var _mapVar$getStyle2;
    layers = (mapVar === null || mapVar === void 0 || (_mapVar$getStyle2 = mapVar.getStyle()) === null || _mapVar$getStyle2 === void 0 ? void 0 : _mapVar$getStyle2.layers) || [];
  }
  var layerIds = layers.filter(function (d) {
    var _d$id4;
    return (d === null || d === void 0 || (_d$id4 = d.id) === null || _d$id4 === void 0 ? void 0 : _d$id4.indexOf(labelStr)) !== -1 && (d === null || d === void 0 ? void 0 : d.type) === 'symbol';
  }).map(function (d) {
    return d === null || d === void 0 ? void 0 : d.id;
  });
  layerIds.forEach(function (layerId) {
    var prevVisibility = mapVar.getLayoutProperty(layerId, 'visibility');
    if (prevVisibility !== 'none' && hide) {
      mapVar.setLayoutProperty(layerId, 'visibility', 'none');
    }
    if (prevVisibility === 'none' && !hide) {
      mapVar.setLayoutProperty(layerId, 'visibility', 'visible');
    }
  });
}
function getDynamicZoomValue(recenterGeoJSON, mapBoxPadding, width, height, state) {
  var _recenterGeoJSON$feat, _recenterGeoJSON$feat2;
  var zoomValue = 0;
  if (recenterGeoJSON !== null && recenterGeoJSON !== void 0 && (_recenterGeoJSON$feat = recenterGeoJSON.features) !== null && _recenterGeoJSON$feat !== void 0 && _recenterGeoJSON$feat.length && recenterGeoJSON !== null && recenterGeoJSON !== void 0 && (_recenterGeoJSON$feat2 = recenterGeoJSON.features) !== null && _recenterGeoJSON$feat2 !== void 0 && _recenterGeoJSON$feat2[0] && width && height) {
    var adjustedWidth = Math.max(width, MIN_WIDTH) || MIN_WIDTH;
    var adjustedHeight = Math.max(height, MIN_HEIGHT) || MIN_HEIGHT;
    var _bbox3 = bbox(recenterGeoJSON),
      _bbox4 = _slicedToArray(_bbox3, 4),
      minLng = _bbox4[0],
      minLat = _bbox4[1],
      maxLng = _bbox4[2],
      maxLat = _bbox4[3];
    var webMercatorViewport = new WebMercatorViewport(_objectSpread2(_objectSpread2({}, state === null || state === void 0 ? void 0 : state.viewBox), {}, {
      width: adjustedWidth,
      height: adjustedHeight
    }));
    try {
      var _webMercatorViewport$ = webMercatorViewport.fitBounds([[minLng, minLat], [maxLng, maxLat]], {
          padding: {
            top: mapBoxPadding.top,
            bottom: mapBoxPadding.bottom,
            left: mapBoxPadding.left,
            right: mapBoxPadding.right
          }
        }),
        zoom = _webMercatorViewport$.zoom;
      zoomValue = Math.round(zoom);

      // console.log('zoom :: ', zoom, isOptimalScreenSize, recenterGeoJSON?.features?.length)
    } catch (error) {
      var _state$viewBox;
      console.error('Error in fitBounds:', error);
      zoomValue = Math.round.apply(Math, _toConsumableArray(state === null || state === void 0 || (_state$viewBox = state.viewBox) === null || _state$viewBox === void 0 ? void 0 : _state$viewBox.zoom));
    }
  }
  return zoomValue;
}
function renderSoilLayer(mapVar) {
  if (mapVar) {
    if (!(mapVar !== null && mapVar !== void 0 && mapVar.getSource('wms-soil-source'))) {
      mapVar.addSource('wms-soil-source', {
        type: 'raster',
        tiles: ['https://map.farmx.co/api/soil/wms/?x={x}&y={y}&z={z}'],
        tileSize: 256
      });
    }
    if (!(mapVar !== null && mapVar !== void 0 && mapVar.getLayer('wms-soil-layer'))) {
      var _layers$filter2;
      mapVar.addLayer({
        id: 'wms-soil-layer',
        type: 'raster',
        source: 'wms-soil-source',
        paint: {}
      });
      var soilLayerId = 'wms-soil-layer';
      // Get layer ids from map styles and filter by ranch and block
      var _ref4 = (mapVar === null || mapVar === void 0 ? void 0 : mapVar.getStyle()) || {},
        layers = _ref4.layers;
      var ids = layers === null || layers === void 0 ? void 0 : layers.filter(function (d) {
        var _d$id5, _d$id6;
        return (d === null || d === void 0 || (_d$id5 = d.id) === null || _d$id5 === void 0 ? void 0 : _d$id5.indexOf('block')) !== -1 || (d === null || d === void 0 || (_d$id6 = d.id) === null || _d$id6 === void 0 ? void 0 : _d$id6.indexOf('ranch')) !== -1;
      }).map(function (d) {
        return d === null || d === void 0 ? void 0 : d.id;
      });
      var isSoilLayerAvailable = layers === null || layers === void 0 || (_layers$filter2 = layers.filter(function (d) {
        return (d === null || d === void 0 ? void 0 : d.id) === soilLayerId;
      })) === null || _layers$filter2 === void 0 ? void 0 : _layers$filter2.length;

      // To move the soil layer behind the ranch, block boundary layer
      if (isSoilLayerAvailable) {
        mapVar.moveLayer(soilLayerId, layers[layers.length - ((ids === null || ids === void 0 ? void 0 : ids.length) + 1)].id);
      }
    }
  }
}

var isEqual$1 = require('react-fast-compare');
var glAccessToken = process.env.REACT_APP_MAPTILER_TOKEN;
var eventRef = {};
var eventRefRight = {};
var eventRefSoil = {};
var eventRefSoilRight = {};
var orthoPhotoList = ['RGB', 'NDVI', 'OSAVI', 'NDRE', 'EBI', 'Thermal'];
var dsmList = ['NDSM', 'DSM'];
var previousData = {
  orthoPhotoList: [],
  dsmList: []
};
function removeSideBySideLayerAndSlider(mapRef, showSideBySideMap) {
  mapRef.current.eachLayer(function (layer) {
    // To remove the added layer when toggle the view
    if (showSideBySideMap && (layer.options.attribution === 'satellite' || layer.options.attribution === 'Drone Imagery')) {
      mapRef.current.removeLayer(layer);
    }
  });

  // To remove the draggable line
  var mapElem = document.querySelectorAll('.leaflet-sbs');
  if (mapElem !== null && mapElem !== void 0 && mapElem.length) mapElem.forEach(function (d) {
    d.remove();
  });
  var leafletLayerElem = document.querySelectorAll('.leaflet-layer');
  if (leafletLayerElem !== null && leafletLayerElem !== void 0 && leafletLayerElem.length) {
    leafletLayerElem.forEach(function (d) {
      var _d$style;
      if (d !== null && d !== void 0 && (_d$style = d.style) !== null && _d$style !== void 0 && _d$style.clip) d.remove();
    });
  }
}
function removePanes(mapRef) {
  var lPane = mapRef.current.getPane('left');
  var rPane = mapRef.current.getPane('right');
  if (lPane) {
    L$1.DomUtil.remove(lPane);
  }
  if (rPane) {
    L$1.DomUtil.remove(rPane);
  }
}
var useMapSideBySideView = function useMapSideBySideView(mapRef, showSideBySideMap, layersControl, isShowingImagery, sideBySideView, isPlants) {
  function getTileLayer(type, name, side) {
    var tileLayerByType;
    if (type === 'soil') {
      tileLayerByType = L$1.tileLayer('https://map.farmx.co/api/soil/wms/?x={x}&y={y}&z={z}', {
        zIndex: 5,
        showOnSelector: false,
        minZoom: 0,
        maxZoom: 19,
        name: name,
        pane: side
      });
    }
    if (type === 'satellite') {
      tileLayerByType = L$1.tileLayer('', {
        tileSize: 512,
        zoomOffset: -1,
        attributionControl: false,
        name: name,
        pane: side,
        zIndex: 0
      });
    }
    return tileLayerByType;
  }
  useEffect(function () {
    var _layersControl$soil, _layersControl$soil2, _isShowingImagery$oth;
    if (isPlants) return;
    if (!mapRef.current) return;
    if (mapRef.current && !showSideBySideMap) {
      removePanes(mapRef);
      removeSideBySideLayerAndSlider(mapRef, showSideBySideMap);
      return;
    }
    if (sideBySideView.current && showSideBySideMap) {
      removePanes(mapRef);
      removeSideBySideLayerAndSlider(mapRef, showSideBySideMap);
    }
    mapRef.current.createPane('left');
    mapRef.current.createPane('right');
    var streetLayer = getTileLayer('satellite', 'leftLayer', 'left').addTo(mapRef.current);
    var satelliteLayer = getTileLayer('satellite', 'rightLayer', 'right').addTo(mapRef.current);
    var soilLayerLeft = L$1.featureGroup();
    var soilLayerRight = L$1.featureGroup();
    if (layersControl !== null && layersControl !== void 0 && (_layersControl$soil = layersControl.soil) !== null && _layersControl$soil !== void 0 && _layersControl$soil.left.visible) {
      soilLayerLeft = getTileLayer('soil', 'soil', 'left').addTo(mapRef.current);
    }
    if (layersControl !== null && layersControl !== void 0 && (_layersControl$soil2 = layersControl.soil) !== null && _layersControl$soil2 !== void 0 && (_layersControl$soil2 = _layersControl$soil2.right) !== null && _layersControl$soil2 !== void 0 && _layersControl$soil2.visible) {
      soilLayerRight = getTileLayer('soil', 'soil', 'right').addTo(mapRef.current);
    }
    var leftLayer = [];
    var rightLayer = [];
    if (isShowingImagery !== null && isShowingImagery !== void 0 && isShowingImagery.data || isShowingImagery !== null && isShowingImagery !== void 0 && (_isShowingImagery$oth = isShowingImagery.otherSide) !== null && _isShowingImagery$oth !== void 0 && _isShowingImagery$oth.data) {
      var _isShowingImagery$oth2, _isShowingImagery$oth3;
      if (isShowingImagery !== null && isShowingImagery !== void 0 && isShowingImagery.data && isShowingImagery !== null && isShowingImagery !== void 0 && isShowingImagery.visible) {
        isShowingImagery.data.forEach(function (d) {
          if (isShowingImagery !== null && isShowingImagery !== void 0 && isShowingImagery.isSatellite) {
            try {
              var boundsCoords = JSON.parse(d.bounds).coordinates;
              var latlng = L$1.GeoJSON.coordsToLatLngs(boundsCoords, 1);
              var bounds = new L$1.LatLngBounds(latlng);
              var imageUrl = d.png_url;
              var options = {
                opacity: 90 / 100,
                alt: 'satellite imagery',
                attribution: 'satellite',
                pane: 'left'
              };
              // eslint-disable-next-line no-undef
              var imageLayer = L$1.imageOverlay(imageUrl, bounds, options);
              imageLayer.addTo(mapRef.current).bringToBack();
              leftLayer.push(imageLayer);
            } catch (error) {
              console.log('Error adding image layer:', error);
            }
          }
          if (d !== null && d !== void 0 && d.tiles) {
            var tiles = d.tiles,
              minZoom = d.minZoom,
              maxZoom = d.maxZoom;
            var selectedTileUrl = tiles[isShowingImagery === null || isShowingImagery === void 0 ? void 0 : isShowingImagery.droneDataType];
            if (selectedTileUrl) {
              var _imageLayer = L$1.tileLayer(selectedTileUrl, {
                minZoom: minZoom,
                maxZoom: maxZoom,
                attribution: 'Drone Imagery',
                pane: 'left'
              });
              _imageLayer.addTo(mapRef.current).bringToBack();
              leftLayer.push(_imageLayer);
            }
          }
        });
      }
      if (isShowingImagery !== null && isShowingImagery !== void 0 && (_isShowingImagery$oth2 = isShowingImagery.otherSide) !== null && _isShowingImagery$oth2 !== void 0 && _isShowingImagery$oth2.data && isShowingImagery !== null && isShowingImagery !== void 0 && (_isShowingImagery$oth3 = isShowingImagery.otherSide) !== null && _isShowingImagery$oth3 !== void 0 && _isShowingImagery$oth3.visible) {
        // eslint-disable-next-line react/prop-types
        isShowingImagery.otherSide.data.forEach(function (d) {
          if (isShowingImagery !== null && isShowingImagery !== void 0 && isShowingImagery.isSatelliteRight) {
            try {
              var boundsCoords = JSON.parse(d.bounds).coordinates;
              var latlng = L$1.GeoJSON.coordsToLatLngs(boundsCoords, 1);
              var bounds = new L$1.LatLngBounds(latlng);
              var imageUrl = d.png_url;
              var options = {
                opacity: 90 / 100,
                alt: 'satellite imagery',
                attribution: 'satellite',
                pane: 'right'
              }; // eslint-disable-next-line new-cap
              var imageLayer = L$1.imageOverlay(imageUrl, bounds, options);
              imageLayer.addTo(mapRef.current).bringToBack();
              rightLayer.push(imageLayer);
            } catch (error) {
              console.log('Error adding image layer:', error);
            }
          }
          if (d !== null && d !== void 0 && d.tiles) {
            var _isShowingImagery$oth4;
            var tiles = d.tiles,
              minZoom = d.minZoom,
              maxZoom = d.maxZoom;
            var selectedTileUrl = tiles[isShowingImagery === null || isShowingImagery === void 0 || (_isShowingImagery$oth4 = isShowingImagery.otherSide) === null || _isShowingImagery$oth4 === void 0 ? void 0 : _isShowingImagery$oth4.droneDataType];
            if (selectedTileUrl) {
              var _imageLayer2 = L$1.tileLayer(selectedTileUrl, {
                minZoom: minZoom,
                maxZoom: maxZoom,
                attribution: 'Drone Imagery',
                pane: 'right'
              });
              _imageLayer2.addTo(mapRef.current).bringToBack();
              rightLayer.push(_imageLayer2);
            }
          }
        });
      }
    }
    // To show the sideBySide view with two different base maps
    sideBySideView.current = L$1.control.sideBySide([streetLayer, soilLayerLeft, leftLayer], [satelliteLayer, soilLayerRight, rightLayer]).addTo(mapRef.current);
  }, [isPlants, isShowingImagery, layersControl, mapRef, showSideBySideMap, sideBySideView]);
};
var useMapGeoJSONData = function useMapGeoJSONData(mapRef, mounted, exposeZoomChange, blocksGeoJSON, ranchesGeoJSON, recenterGeoJSON, expandedGeoJSON, dynamicBoundsGeoJSON, sensorsGeoJSON, singleMarkerGeoJSON, mapBoxPadding, width, height, state, anomalyGeoJSON, plantsGeoJSON, isPlants, maxZoom, setState, previousZoom, glMapRef, isAllRanch, initialState, zoomValue) {
  var _plantsGeoJSON$featur, _ranchesGeoJSON$featu;
  var coords = (plantsGeoJSON === null || plantsGeoJSON === void 0 || (_plantsGeoJSON$featur = plantsGeoJSON.features) === null || _plantsGeoJSON$featur === void 0 || (_plantsGeoJSON$featur = _plantsGeoJSON$featur[0]) === null || _plantsGeoJSON$featur === void 0 || (_plantsGeoJSON$featur = _plantsGeoJSON$featur.geometry) === null || _plantsGeoJSON$featur === void 0 ? void 0 : _plantsGeoJSON$featur.coordinates) || [0, 0];
  var center = [coords[1], coords[0]];
  var ranchId = ranchesGeoJSON === null || ranchesGeoJSON === void 0 || (_ranchesGeoJSON$featu = ranchesGeoJSON.features) === null || _ranchesGeoJSON$featu === void 0 || (_ranchesGeoJSON$featu = _ranchesGeoJSON$featu[0]) === null || _ranchesGeoJSON$featu === void 0 ? void 0 : _ranchesGeoJSON$featu.id;
  useEffect(function () {
    if (ranchId) {
      previousData = {
        orthoPhotoList: [],
        dsmList: []
      };
    }
  }, [ranchId]);
  useEffect(function () {
    var _anomalyGeoJSON$prope, _anomalyGeoJSON$featu;
    if (!mounted.current) {
      return;
    }
    if (typeof exposeZoomChange === 'function' && mapRef.current) {
      exposeZoomChange(!isAllRanch ? zoomValue : state.viewBox.zoom, mapRef.current);
    }
    var incomingState = {
      recenterGeoJSON: recenterGeoJSON,
      expandedGeoJSON: expandedGeoJSON,
      ranchesGeoJSON: ranchesGeoJSON,
      dynamicBoundsGeoJSON: dynamicBoundsGeoJSON,
      sensorsGeoJSON: sensorsGeoJSON,
      mapBoxPadding: mapBoxPadding,
      width: width,
      height: height,
      viewBox: state.viewBox
    };
    if (isEqual$1(incomingState, state) && !anomalyGeoJSON) {
      return;
    }
    if (recenterGeoJSON && recenterGeoJSON.features.length && recenterGeoJSON.features[0]) {
      try {
        var _blocksGeoJSON$featur;
        if (!width || !height) {
          return;
        }
        var blockGeoJSONLength = blocksGeoJSON === null || blocksGeoJSON === void 0 || (_blocksGeoJSON$featur = blocksGeoJSON.features) === null || _blocksGeoJSON$featur === void 0 ? void 0 : _blocksGeoJSON$featur.length;
        var geoJSONData = recenterGeoJSON;
        if (!isAllRanch && !blockGeoJSONLength) geoJSONData = ranchesGeoJSON;
        var _bbox = bbox(geoJSONData),
          _bbox2 = _slicedToArray(_bbox, 4),
          minLng = _bbox2[0],
          minLat = _bbox2[1],
          maxLng = _bbox2[2],
          maxLat = _bbox2[3];
        var webMercatorViewport = new WebMercatorViewport(_objectSpread2(_objectSpread2({}, state.viewBox), {}, {
          width: width,
          height: height
        }));
        var _webMercatorViewport$ = webMercatorViewport.fitBounds([[minLng, minLat], [maxLng, maxLat]], {
            padding: {
              top: mapBoxPadding.top,
              bottom: mapBoxPadding.bottom,
              left: mapBoxPadding.left,
              right: mapBoxPadding.right
            }
          }),
          longitude = _webMercatorViewport$.longitude,
          latitude = _webMercatorViewport$.latitude,
          zoom = _webMercatorViewport$.zoom;
        var finalZoom = zoom;
        if (!isAllRanch && zoom > maxZoom) finalZoom = maxZoom;else if (!isAllRanch && zoom < maxZoom && zoom < zoomValue) finalZoom = zoomValue;
        var newState = _objectSpread2(_objectSpread2({}, state), {}, {
          recenterGeoJSON: recenterGeoJSON,
          expandedGeoJSON: expandedGeoJSON,
          ranchesGeoJSON: ranchesGeoJSON,
          dynamicBoundsGeoJSON: dynamicBoundsGeoJSON,
          sensorsGeoJSON: sensorsGeoJSON,
          mapBoxPadding: mapBoxPadding,
          viewBox: {
            longitude: longitude,
            latitude: latitude,
            zoom: finalZoom
          },
          width: width,
          height: height
        });
        previousZoom.current = newState.viewBox;
        setState(newState);
        if (glMapRef.current) {
          glMapRef.current.setCenter([longitude, latitude]);
          if (zoom === finalZoom || isAllRanch) glMapRef.current.setZoom(finalZoom);
        }
      } catch (error) {
        console.log('WebMercatorViewport recenterGeoJSON', error);
      }
      if (!anomalyGeoJSON) {
        return;
      }
    }
    if (isPlants && center[0] && plantsGeoJSON) {
      try {
        if (!width || !height) {
          return;
        }
        var _bbox3 = bbox(plantsGeoJSON),
          _bbox4 = _slicedToArray(_bbox3, 4),
          _minLng = _bbox4[0],
          _minLat = _bbox4[1],
          _maxLng = _bbox4[2],
          _maxLat = _bbox4[3];
        var _webMercatorViewport = new WebMercatorViewport(_objectSpread2(_objectSpread2({}, state.viewBox), {}, {
          width: width,
          height: height
        }));
        var _webMercatorViewport$2 = _webMercatorViewport.fitBounds([[_minLng, _minLat], [_maxLng, _maxLat]], {
            padding: {
              top: mapBoxPadding.top,
              bottom: mapBoxPadding.bottom,
              left: mapBoxPadding.left,
              right: mapBoxPadding.right
            }
          }),
          _longitude = _webMercatorViewport$2.longitude,
          _latitude = _webMercatorViewport$2.latitude,
          _zoom = _webMercatorViewport$2.zoom;
        var _newState = _objectSpread2(_objectSpread2({}, state), {}, {
          viewBox: {
            longitude: _longitude,
            latitude: _latitude,
            zoom: _zoom > maxZoom ? maxZoom : zoomValue
          },
          width: width,
          height: height
        });
        previousZoom.current = _newState.viewBox;
        setState(_newState);
      } catch (error) {
        console.log('WebMercatorViewport plantsGeoJSON', error);
      }
      return;
    }

    // For anomaly area calculation at block level
    if (anomalyGeoJSON !== null && anomalyGeoJSON !== void 0 && anomalyGeoJSON.coords) {
      try {
        var _bbox5 = bbox(anomalyGeoJSON === null || anomalyGeoJSON === void 0 ? void 0 : anomalyGeoJSON.coords),
          _bbox6 = _slicedToArray(_bbox5, 4),
          _minLng2 = _bbox6[0],
          _minLat2 = _bbox6[1],
          _maxLng2 = _bbox6[2],
          _maxLat2 = _bbox6[3];
        var _webMercatorViewport2 = new WebMercatorViewport(_objectSpread2(_objectSpread2({}, state.viewBox), {}, {
          width: width,
          height: height
        }));
        var _webMercatorViewport3 = _webMercatorViewport2.fitBounds([[_minLng2, _minLat2], [_maxLng2, _maxLat2]], {
            padding: {
              top: mapBoxPadding.top,
              bottom: mapBoxPadding.bottom,
              left: mapBoxPadding.left,
              right: mapBoxPadding.right
            }
          }),
          _longitude2 = _webMercatorViewport3.longitude,
          _latitude2 = _webMercatorViewport3.latitude,
          _zoom2 = _webMercatorViewport3.zoom;
        var changedViewBox = {
          latitude: _latitude2,
          longitude: _longitude2,
          zoom: zoomValue + 0.75
        };
        setState(_objectSpread2(_objectSpread2({}, state), {}, {
          viewBox: changedViewBox
        }));
      } catch (error) {
        console.error('Error in fitBounds:', error);
      }
      return;
    }

    // To zoom the map when clicking on anomaly icon
    if (anomalyGeoJSON && (anomalyGeoJSON !== null && anomalyGeoJSON !== void 0 && (_anomalyGeoJSON$prope = anomalyGeoJSON.properties) !== null && _anomalyGeoJSON$prope !== void 0 && (_anomalyGeoJSON$prope = _anomalyGeoJSON$prope.center) !== null && _anomalyGeoJSON$prope !== void 0 && _anomalyGeoJSON$prope.coordinates || anomalyGeoJSON !== null && anomalyGeoJSON !== void 0 && (_anomalyGeoJSON$featu = anomalyGeoJSON.features) !== null && _anomalyGeoJSON$featu !== void 0 && (_anomalyGeoJSON$featu = _anomalyGeoJSON$featu[0]) !== null && _anomalyGeoJSON$featu !== void 0 && (_anomalyGeoJSON$featu = _anomalyGeoJSON$featu.properties) !== null && _anomalyGeoJSON$featu !== void 0 && (_anomalyGeoJSON$featu = _anomalyGeoJSON$featu.center) !== null && _anomalyGeoJSON$featu !== void 0 && _anomalyGeoJSON$featu.coordinates)) {
      try {
        var _anomalyGeoJSON$featu2;
        var _bbox7 = bbox(anomalyGeoJSON),
          _bbox8 = _slicedToArray(_bbox7, 4),
          _minLng3 = _bbox8[0],
          _minLat3 = _bbox8[1],
          _maxLng3 = _bbox8[2],
          _maxLat3 = _bbox8[3];
        var _webMercatorViewport4 = new WebMercatorViewport(_objectSpread2(_objectSpread2({}, state.viewBox), {}, {
          width: width,
          height: height
        }));
        if (!(anomalyGeoJSON !== null && anomalyGeoJSON !== void 0 && anomalyGeoJSON.features) || anomalyGeoJSON !== null && anomalyGeoJSON !== void 0 && (_anomalyGeoJSON$featu2 = anomalyGeoJSON.features) !== null && _anomalyGeoJSON$featu2 !== void 0 && _anomalyGeoJSON$featu2.length) {
          var _webMercatorViewport5 = _webMercatorViewport4.fitBounds([[_minLng3, _minLat3], [_maxLng3, _maxLat3]], {
              padding: {
                top: mapBoxPadding.top,
                bottom: mapBoxPadding.bottom,
                left: mapBoxPadding.left,
                right: mapBoxPadding.right
              }
            }),
            _longitude3 = _webMercatorViewport5.longitude,
            _latitude3 = _webMercatorViewport5.latitude,
            _zoom3 = _webMercatorViewport5.zoom;
          var customZoomSize = zoomValue;
          if (anomalyGeoJSON !== null && anomalyGeoJSON !== void 0 && anomalyGeoJSON.customZoom) customZoomSize = zoomValue + 0.6;
          var zoomChanged = _zoom3 > maxZoom ? maxZoom : customZoomSize;
          // Zoom out to fit the block boundary in map view on anomaly detail page
          if (anomalyGeoJSON !== null && anomalyGeoJSON !== void 0 && anomalyGeoJSON.features) {
            zoomChanged = _zoom3 > maxZoom ? maxZoom : zoomValue + 0.75;
          }
          var _changedViewBox = {
            latitude: _latitude3,
            longitude: _longitude3,
            zoom: zoomChanged
          };
          setState(_objectSpread2(_objectSpread2({}, state), {}, {
            viewBox: _changedViewBox
          }));
        }
      } catch (error) {
        console.error('Error in fitBounds:', error);
      }
      return;
    }
    if (expandedGeoJSON && expandedGeoJSON.features.length) {
      try {
        if (!width || !height) {
          return;
        }
        var _bbox9 = bbox(expandedGeoJSON),
          _bbox10 = _slicedToArray(_bbox9, 4),
          _minLng4 = _bbox10[0],
          _minLat4 = _bbox10[1],
          _maxLng4 = _bbox10[2],
          _maxLat4 = _bbox10[3];
        var _webMercatorViewport6 = new WebMercatorViewport(_objectSpread2(_objectSpread2({}, state.viewBox), {}, {
          width: width,
          height: height
        }));
        var _webMercatorViewport7 = _webMercatorViewport6.fitBounds([[_minLng4, _minLat4], [_maxLng4, _maxLat4]], {
            padding: {
              top: mapBoxPadding.top,
              bottom: mapBoxPadding.bottom,
              left: mapBoxPadding.left,
              right: mapBoxPadding.right
            }
          }),
          _longitude4 = _webMercatorViewport7.longitude,
          _latitude4 = _webMercatorViewport7.latitude,
          _zoom4 = _webMercatorViewport7.zoom;
        var _newState2 = _objectSpread2(_objectSpread2({}, state), {}, {
          recenterGeoJSON: recenterGeoJSON,
          expandedGeoJSON: expandedGeoJSON,
          ranchesGeoJSON: ranchesGeoJSON,
          dynamicBoundsGeoJSON: dynamicBoundsGeoJSON,
          sensorsGeoJSON: sensorsGeoJSON,
          mapBoxPadding: mapBoxPadding,
          viewBox: {
            longitude: _longitude4,
            latitude: _latitude4,
            zoom: _zoom4 > maxZoom ? maxZoom : zoomValue
          },
          width: width,
          height: height
        });
        setState(_newState2);
      } catch (error) {
        console.log('WebMercatorViewport expandedGeoJSON', error);
      }
      return;
    }
    if (!ranchesGeoJSON && !sensorsGeoJSON && singleMarkerGeoJSON) {
      try {
        if (!width || !height) {
          return;
        }
        var _newState3 = _objectSpread2(_objectSpread2({}, state), {}, {
          recenterGeoJSON: recenterGeoJSON,
          expandedGeoJSON: expandedGeoJSON,
          ranchesGeoJSON: ranchesGeoJSON,
          dynamicBoundsGeoJSON: dynamicBoundsGeoJSON,
          sensorsGeoJSON: sensorsGeoJSON,
          mapBoxPadding: mapBoxPadding,
          singleMarkerGeoJSON: singleMarkerGeoJSON,
          viewBox: {
            longitude: singleMarkerGeoJSON.geometry.coordinates[1],
            latitude: singleMarkerGeoJSON.geometry.coordinates[0],
            zoom: zoomValue
          },
          width: width,
          height: height
        });
        setState(_newState3);
        return;
      } catch (error) {
        console.log('WebMercatorViewport singleMarkerGeoJSON', error);
      }
    }
    if (dynamicBoundsGeoJSON && dynamicBoundsGeoJSON.features.length) {
      try {
        if (!width || !height) {
          return;
        }
        var _bbox11 = bbox(dynamicBoundsGeoJSON),
          _bbox12 = _slicedToArray(_bbox11, 4),
          _minLng5 = _bbox12[0],
          _minLat5 = _bbox12[1],
          _maxLng5 = _bbox12[2],
          _maxLat5 = _bbox12[3];
        var _webMercatorViewport8 = new WebMercatorViewport(_objectSpread2(_objectSpread2({}, state.viewBox), {}, {
          width: width,
          height: height
        }));
        var _webMercatorViewport9 = _webMercatorViewport8.fitBounds([[_minLng5, _minLat5], [_maxLng5, _maxLat5]], {
            padding: {
              top: mapBoxPadding.top,
              bottom: mapBoxPadding.bottom,
              left: mapBoxPadding.left,
              right: mapBoxPadding.right
            }
          }),
          _longitude5 = _webMercatorViewport9.longitude,
          _latitude5 = _webMercatorViewport9.latitude,
          _zoom5 = _webMercatorViewport9.zoom;
        var _newState4 = _objectSpread2(_objectSpread2({}, state), {}, {
          recenterGeoJSON: recenterGeoJSON,
          expandedGeoJSON: expandedGeoJSON,
          ranchesGeoJSON: ranchesGeoJSON,
          dynamicBoundsGeoJSON: dynamicBoundsGeoJSON,
          sensorsGeoJSON: sensorsGeoJSON,
          mapBoxPadding: mapBoxPadding,
          viewBox: {
            longitude: _longitude5,
            latitude: _latitude5,
            zoom: _zoom5 > maxZoom ? maxZoom : zoomValue
          },
          width: width,
          height: height
        });
        setState(_newState4);
      } catch (error) {
        console.log('WebMercatorViewport ranchesGeoJSON', error);
      }
      return;
    }
    if (ranchesGeoJSON && ranchesGeoJSON.features.length && ranchesGeoJSON.features[0]) {
      try {
        if (!width || !height) {
          return;
        }
        var _bbox13 = bbox(ranchesGeoJSON),
          _bbox14 = _slicedToArray(_bbox13, 4),
          _minLng6 = _bbox14[0],
          _minLat6 = _bbox14[1],
          _maxLng6 = _bbox14[2],
          _maxLat6 = _bbox14[3];
        var _webMercatorViewport10 = new WebMercatorViewport(_objectSpread2(_objectSpread2({}, state.viewBox), {}, {
          width: width,
          height: height
        }));
        var _webMercatorViewport11 = _webMercatorViewport10.fitBounds([[_minLng6, _minLat6], [_maxLng6, _maxLat6]], {
            padding: {
              top: mapBoxPadding.top,
              bottom: mapBoxPadding.bottom,
              left: mapBoxPadding.left,
              right: mapBoxPadding.right
            }
          }),
          _longitude6 = _webMercatorViewport11.longitude,
          _latitude6 = _webMercatorViewport11.latitude,
          _zoom6 = _webMercatorViewport11.zoom;
        var _newState5 = _objectSpread2(_objectSpread2({}, state), {}, {
          recenterGeoJSON: recenterGeoJSON,
          expandedGeoJSON: expandedGeoJSON,
          ranchesGeoJSON: ranchesGeoJSON,
          dynamicBoundsGeoJSON: dynamicBoundsGeoJSON,
          sensorsGeoJSON: sensorsGeoJSON,
          mapBoxPadding: mapBoxPadding,
          viewBox: {
            longitude: _longitude6,
            latitude: _latitude6,
            zoom: _zoom6 > maxZoom ? maxZoom : zoomValue
          },
          width: width,
          height: height
        });
        setState(_newState5);
      } catch (error) {
        console.log('WebMercatorViewport ranchesGeoJSON', error);
      }
      return;
    }
    if (!sensorsGeoJSON) {
      setState(_objectSpread2(_objectSpread2({}, state), {}, {
        recenterGeoJSON: recenterGeoJSON,
        expandedGeoJSON: expandedGeoJSON,
        ranchesGeoJSON: ranchesGeoJSON,
        dynamicBoundsGeoJSON: dynamicBoundsGeoJSON,
        sensorsGeoJSON: sensorsGeoJSON,
        mapBoxPadding: mapBoxPadding
      }));
      return;
    }
    sensorsGeoJSON.features = sensorsGeoJSON.features.filter(function (feature) {
      return feature.geometry.coordinates[0] && feature.geometry.coordinates[1];
    });
    if (!sensorsGeoJSON.features.length) {
      setState(_objectSpread2(_objectSpread2({}, state), {}, {
        recenterGeoJSON: recenterGeoJSON,
        expandedGeoJSON: expandedGeoJSON,
        ranchesGeoJSON: ranchesGeoJSON,
        dynamicBoundsGeoJSON: dynamicBoundsGeoJSON,
        sensorsGeoJSON: sensorsGeoJSON,
        mapBoxPadding: mapBoxPadding
      }));
      return;
    }
    try {
      if (!width || !height) {
        return;
      }
      var _bbox15 = bbox(sensorsGeoJSON),
        _bbox16 = _slicedToArray(_bbox15, 4),
        _minLng7 = _bbox16[0],
        _minLat7 = _bbox16[1],
        _maxLng7 = _bbox16[2],
        _maxLat7 = _bbox16[3];
      var _webMercatorViewport12 = new WebMercatorViewport(_objectSpread2(_objectSpread2({}, state.viewBox), {}, {
        width: width,
        height: height
      }));
      var _webMercatorViewport13 = _webMercatorViewport12.fitBounds([[_minLng7, _minLat7], [_maxLng7, _maxLat7]], {
          padding: {
            top: mapBoxPadding.top,
            bottom: mapBoxPadding.bottom,
            left: mapBoxPadding.left,
            right: mapBoxPadding.right
          }
        }),
        _longitude7 = _webMercatorViewport13.longitude,
        _latitude7 = _webMercatorViewport13.latitude,
        _zoom7 = _webMercatorViewport13.zoom;
      var _newState6 = _objectSpread2(_objectSpread2({}, state), {}, {
        recenterGeoJSON: recenterGeoJSON,
        expandedGeoJSON: expandedGeoJSON,
        ranchesGeoJSON: ranchesGeoJSON,
        dynamicBoundsGeoJSON: dynamicBoundsGeoJSON,
        sensorsGeoJSON: sensorsGeoJSON,
        mapBoxPadding: mapBoxPadding,
        viewBox: {
          longitude: _longitude7,
          latitude: _latitude7,
          zoom: _zoom7 > maxZoom ? maxZoom : zoomValue
        },
        width: width,
        height: height
      });
      setState(_newState6);
    } catch (error) {
      console.log('WebMercatorViewport sensorsGeoJSON', error);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [recenterGeoJSON, expandedGeoJSON, singleMarkerGeoJSON, ranchesGeoJSON, dynamicBoundsGeoJSON, sensorsGeoJSON, mapBoxPadding, width, height, anomalyGeoJSON, plantsGeoJSON, isPlants, isAllRanch, blocksGeoJSON]);
};
function getMapLibreGlMap(containerId, center, zoom) {
  var mapElem = new maplibregl$1.Map({
    container: containerId,
    style: "https://api.maptiler.com/maps/8651cd7e-d371-4b78-a7b7-7757e74d3a82/style.json?key=".concat(glAccessToken),
    center: center,
    zoom: zoom
  });
  return mapElem;
}
function removeMapReferencesWithComparisonView(leftMap, rightMap, comparisonMap) {
  if (leftMap) leftMap.remove();
  try {
    if (rightMap) rightMap.remove();
  } catch (error) {
    console.log(error);
  }
  if (comparisonMap) comparisonMap.remove();
}
var comparisonMap;
var useMapLibreGlMap = function useMapLibreGlMap(glMapRef, glRightMapRef, showSideBySideMap, coords, mapRefElem, isAnomaly, isAllRanch, zoomValue) {
  useEffect(function () {
    if (isAnomaly) {
      removeMapReferencesWithComparisonView(glMapRef.current, glRightMapRef.current);
      return;
    }
    var zoomLevel = zoomValue;
    removeMapReferencesWithComparisonView(glMapRef.current, glRightMapRef.current, comparisonMap);
    if (!showSideBySideMap) {
      try {
        var leftMap = getMapLibreGlMap('default-map', coords, zoomLevel);
        if (mapRefElem) mapRefElem({
          left: leftMap
        });
        if (leftMap) {
          leftMap.addControl(new maplibregl$1.NavigationControl(), 'top-right');
        }
      } catch (error) {
        console.log(error);
      }
    }
    if (showSideBySideMap) {
      var _leftMap = getMapLibreGlMap('left', coords, zoomLevel);
      var rightMap = getMapLibreGlMap('right', coords, zoomLevel);
      if (mapRefElem) mapRefElem({
        left: _leftMap,
        right: rightMap
      });
      if (window.maplibregl) {
        var container = '#comparison-container';
        comparisonMap = new maplibregl$1.Compare(_leftMap, rightMap, container);
        _leftMap.addControl(new maplibregl$1.NavigationControl(), 'top-right');
        rightMap.addControl(new maplibregl$1.NavigationControl(), 'top-right');
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showSideBySideMap, isAnomaly, isAllRanch]);
};
function onStyleDataForLayers(glMapRef, glRightMapRef, showSideBySideMap, onClickBlock, isPlants, blocksGeoJSON, ranchesGeoJSON, presentationMode, expandedGeoJSON, colors, CONDITION_CHECK, isShowingImagery, highlightPlant, t) {
  renderLayersOnLoad(glMapRef, glRightMapRef, showSideBySideMap, onClickBlock, isPlants, blocksGeoJSON, ranchesGeoJSON, presentationMode, expandedGeoJSON, colors, CONDITION_CHECK, isShowingImagery, highlightPlant, t);
}
function onStyleDataForLoadSource(mapVar, sourceId, layerId, plantOption, data, style, isBoundary, isRanch, isLabel, addLayerOnly, isPlants, onClickBlock, showSideBySideMap, showPlants, glMapRef, glRightMapRef, highlightPlant) {
  var _glRightMapRef$curren;
  clearGlLayers(glMapRef.current, 1, '', 'pointsLabels');
  clearGlLayers(glMapRef.current, 1, 'point', 'points-fill');
  clearGlLayers(glRightMapRef.current, 1, 'point1', 'points-fill-1');
  loadDataSource(mapVar, sourceId, layerId, plantOption, data, style, isBoundary, isRanch, isLabel, addLayerOnly, isPlants, onClickBlock, showSideBySideMap, showPlants, glMapRef, glRightMapRef, highlightPlant);
  if (glRightMapRef !== null && glRightMapRef !== void 0 && (_glRightMapRef$curren = glRightMapRef.current) !== null && _glRightMapRef$curren !== void 0 && (_glRightMapRef$curren = _glRightMapRef$curren.style) !== null && _glRightMapRef$curren !== void 0 && _glRightMapRef$curren._loaded) {
    loadDataSource(glRightMapRef.current, 'point1', 'points-fill-1', plantOption, data, style, isBoundary, isRanch, isLabel, addLayerOnly, isPlants, onClickBlock, showSideBySideMap, showPlants, glMapRef, glRightMapRef, highlightPlant);
  }
}
var useLoadDataSourceAndLayer = function useLoadDataSourceAndLayer(glMapRef, glRightMapRef, plantsGeoJSON, showSideBySideMap, onClickBlock, isPlants, blocksGeoJSON, ranchesGeoJSON, presentationMode, expandedGeoJSON, colors, CONDITION_CHECK, isShowingImagery, isAnomaly, selectedColorValue, showPlants, highlightPlant, isGroundMission, isAllRanch, t) {
  var isGroundMissionPage = isGroundMission ? isShowingImagery : null;
  useEffect(function () {
    if (!glMapRef.current || isAnomaly || isAllRanch) return;
    var attachOnStyleData = function attachOnStyleData() {
      return onStyleDataForLayers(glMapRef, glRightMapRef, showSideBySideMap, onClickBlock, isPlants, blocksGeoJSON, ranchesGeoJSON, presentationMode, expandedGeoJSON, colors, CONDITION_CHECK, isShowingImagery, highlightPlant, t);
    };
    detachEventsWithLayerId(glMapRef.current, eventRef);
    eventRef.styledata = {
      event: attachOnStyleData
    };
    glMapRef.current.once('styledata', attachOnStyleData);
    if (showSideBySideMap && glRightMapRef !== null && glRightMapRef !== void 0 && glRightMapRef.current) {
      var attachOnStyleDataRight = function attachOnStyleDataRight() {
        return onStyleDataForLayers(glMapRef, glRightMapRef, showSideBySideMap, onClickBlock, isPlants, blocksGeoJSON, ranchesGeoJSON, presentationMode, expandedGeoJSON, colors, CONDITION_CHECK, isShowingImagery, highlightPlant, t);
      };
      detachEventsWithLayerId(glRightMapRef.current, eventRefRight);
      eventRefRight.styledata = {
        event: attachOnStyleDataRight
      };
      glRightMapRef.current.once('styledata', attachOnStyleDataRight);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showSideBySideMap, ranchesGeoJSON, presentationMode, glMapRef, isPlants, glRightMapRef, blocksGeoJSON, CONDITION_CHECK, isAnomaly, isGroundMissionPage, isAllRanch]);
  var plantsData = JSON.stringify(plantsGeoJSON);
  useEffect(function () {
    if (!glMapRef.current || isAnomaly) return;
    var parsedPlantsData = JSON.parse(plantsData);
    var attachOnStyleData = function attachOnStyleData() {
      return onStyleDataForLoadSource(glMapRef.current, 'point', 'points-fill', selectedColorValue, parsedPlantsData, undefined, false, false, false, false, isPlants, onClickBlock, showSideBySideMap, showPlants, glMapRef, glRightMapRef, highlightPlant);
    };
    eventRef.styledata = {
      event: attachOnStyleData
    };
    glMapRef.current.once('styledata', attachOnStyleData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [plantsData, showSideBySideMap, isAnomaly, selectedColorValue]);
};
var useRedrawPlantsPoints = function useRedrawPlantsPoints(glMapRef, glRightMapRef, showSideBySideMap, isBottomSheetVisible, selectedColorValue, isPlants, onClickBlock, plantsGeoJSON, isAnomaly, showPlants, highlightPlant) {
  var plantsData = JSON.stringify(plantsGeoJSON);
  useEffect(function () {
    var _glMapRef$current, _glRightMapRef$curren2;
    if (!glMapRef.current || isAnomaly) return;
    if (showSideBySideMap && !glRightMapRef.current) return;
    var parsedPlantsData = JSON.parse(plantsData);
    if ((_glMapRef$current = glMapRef.current) !== null && _glMapRef$current !== void 0 && (_glMapRef$current = _glMapRef$current.style) !== null && _glMapRef$current !== void 0 && _glMapRef$current._loaded && parsedPlantsData !== null && parsedPlantsData !== void 0 && parsedPlantsData.features) {
      clearGlLayers(glMapRef.current, 1, '', 'points-fill');
      if (glMapRef.current.getSource('point')) addNewLayer(glMapRef.current, 'point', 'points-fill', selectedColorValue, showPlants);else {
        if (showSideBySideMap) clearGlLayers(glRightMapRef.current, 1, 'point1', 'points-fill-1');
        loadDataSource(glMapRef.current, 'point', 'points-fill', selectedColorValue, parsedPlantsData, undefined, false, false, false, false, isPlants, onClickBlock, showSideBySideMap, showPlants, glMapRef, glRightMapRef, highlightPlant);
      }
    }
    if (showSideBySideMap && glRightMapRef !== null && glRightMapRef !== void 0 && (_glRightMapRef$curren2 = glRightMapRef.current) !== null && _glRightMapRef$curren2 !== void 0 && (_glRightMapRef$curren2 = _glRightMapRef$curren2.style) !== null && _glRightMapRef$curren2 !== void 0 && _glRightMapRef$curren2._loaded) {
      clearGlLayers(glRightMapRef.current, 1, '', 'points-fill-1');
      if (glRightMapRef.current.getSource('point1')) addNewLayer(glRightMapRef.current, 'point1', 'points-fill-1', selectedColorValue, showPlants);else {
        loadDataSource(glRightMapRef.current, 'point1', 'points-fill-1', selectedColorValue, parsedPlantsData, undefined, false, false, false, false, isPlants, onClickBlock, showSideBySideMap, showPlants, glMapRef, glRightMapRef, highlightPlant);
      }
    }
  }, [showSideBySideMap, selectedColorValue, isBottomSheetVisible, glMapRef, glRightMapRef, plantsData, isPlants, onClickBlock, showPlants, isAnomaly, highlightPlant]);
};
function renderLabels(mapVar, currZoom) {
  if (currZoom < 13) renderOrHideLabels(mapVar, true);else renderOrHideLabels(mapVar);
}
function onZoom(mapVar, mapVarRight, exposeZoomChange) {
  if (mapVar !== null && mapVar !== void 0 && mapVar.getZoom) {
    if (typeof exposeZoomChange === 'function') {
      exposeZoomChange(mapVar.getZoom());
    }
    var currZoom = mapVar === null || mapVar === void 0 ? void 0 : mapVar.getZoom();
    renderLabels(mapVar, currZoom);
    if (mapVarRight) renderLabels(mapVarRight, currZoom);
  }
}
var useZoomChange = function useZoomChange(glMapRef, glRightMapRef, exposeZoomChange, isAnomaly) {
  useEffect(function () {
    if (!glMapRef.current || isAnomaly) return;
    var attachOnZoom = function attachOnZoom() {
      return onZoom(glMapRef.current, glRightMapRef === null || glRightMapRef === void 0 ? void 0 : glRightMapRef.current, exposeZoomChange);
    };
    delete eventRef.styledata;
    detachEventsWithLayerId(glMapRef.current, eventRef);
    eventRef.zoom = {
      event: attachOnZoom
    };
    glMapRef.current.on('zoom', attachOnZoom);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [exposeZoomChange, glMapRef, isAnomaly]);
};
var useClearGlLayersOnClose = function useClearGlLayersOnClose(glMapRef, glRightMapRef, isBottomSheetVisible, isPlants, showSideBySideMap, onClickBlock, plantsGeoJSON, isAnomaly, selectedColorValue, showPlants, highlightPlant) {
  var plantsData = JSON.stringify(plantsGeoJSON);
  useEffect(function () {
    var _glMapRef$current2, _glRightMapRef$curren3;
    if (!isPlants || isAnomaly) return;
    var parsedPlantsData = JSON.parse(plantsData);
    if (!isBottomSheetVisible && (_glMapRef$current2 = glMapRef.current) !== null && _glMapRef$current2 !== void 0 && (_glMapRef$current2 = _glMapRef$current2.style) !== null && _glMapRef$current2 !== void 0 && _glMapRef$current2._loaded && parsedPlantsData !== null && parsedPlantsData !== void 0 && parsedPlantsData.features) {
      clearGlLayers(glMapRef.current, 1, '', 'points-fill');
      if (glMapRef.current.getSource('point')) {
        loadDataSource(glMapRef.current, 'point', 'points-fill', selectedColorValue, parsedPlantsData, undefined, false, false, false, true, isPlants, onClickBlock, showSideBySideMap, showPlants, glMapRef, glRightMapRef, highlightPlant);
      }
    }
    if (!isBottomSheetVisible && showSideBySideMap && glRightMapRef !== null && glRightMapRef !== void 0 && (_glRightMapRef$curren3 = glRightMapRef.current) !== null && _glRightMapRef$curren3 !== void 0 && (_glRightMapRef$curren3 = _glRightMapRef$curren3.style) !== null && _glRightMapRef$curren3 !== void 0 && _glRightMapRef$curren3._loaded) {
      clearGlLayers(glRightMapRef.current, 1, '', 'points-fill-1');
      if (glRightMapRef.current.getSource('point1')) {
        loadDataSource(glRightMapRef.current, 'point1', 'points-fill-1', selectedColorValue, parsedPlantsData, undefined, false, false, false, true, isPlants, onClickBlock, showSideBySideMap, showPlants, glMapRef, glRightMapRef, highlightPlant);
      }
    }
  }, [glMapRef, glRightMapRef, isBottomSheetVisible, isPlants, onClickBlock, plantsData, showSideBySideMap, isAnomaly, selectedColorValue, showPlants, highlightPlant]);
};
var useRedrawBlockRanchBoundary = function useRedrawBlockRanchBoundary(glMapRef, glRightMapRef, blocksGeoJSON, ranchesGeoJSON, expandedGeoJSON, presentationMode, isPlants, CONDITION_CHECK, onClickBlock, showSideBySideMap, colors, isShowingImagery, isAnomaly, isAllRanch) {
  useEffect(function () {
    var _glMapRef$current3, _blocksGeoJSON$featur2, _ranchesGeoJSON$featu2;
    if (isAnomaly || !(glMapRef !== null && glMapRef !== void 0 && glMapRef.current) || isAllRanch) return;
    if (glMapRef !== null && glMapRef !== void 0 && (_glMapRef$current3 = glMapRef.current) !== null && _glMapRef$current3 !== void 0 && (_glMapRef$current3 = _glMapRef$current3.style) !== null && _glMapRef$current3 !== void 0 && _glMapRef$current3._loaded && (blocksGeoJSON !== null && blocksGeoJSON !== void 0 && (_blocksGeoJSON$featur2 = blocksGeoJSON.features) !== null && _blocksGeoJSON$featur2 !== void 0 && _blocksGeoJSON$featur2.length || ranchesGeoJSON !== null && ranchesGeoJSON !== void 0 && (_ranchesGeoJSON$featu2 = ranchesGeoJSON.features) !== null && _ranchesGeoJSON$featu2 !== void 0 && _ranchesGeoJSON$featu2.length)) {
      if (!isPlants) {
        clearGlLayers(glMapRef.current, 1, 'block', 'block-fill-', [1, 10, 20]);
        clearGlLayers(glMapRef.current, 1, 'point', 'points-fill');
      }
      renderBlockLayer(glMapRef, glRightMapRef, blocksGeoJSON, expandedGeoJSON, colors, presentationMode, CONDITION_CHECK, isPlants, onClickBlock, showSideBySideMap);
      renderRanchLayer(glMapRef, glRightMapRef, ranchesGeoJSON, expandedGeoJSON, colors, presentationMode, isPlants, onClickBlock, showSideBySideMap);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showSideBySideMap, isShowingImagery === null || isShowingImagery === void 0 ? void 0 : isShowingImagery.visible, blocksGeoJSON, ranchesGeoJSON, glMapRef, glRightMapRef, presentationMode, isAnomaly, isAllRanch]);
};
var handleImageryError = function handleImageryError(mapRef, droneDataType, data, t) {
  var _mapRef$current;
  if (!(mapRef !== null && mapRef !== void 0 && (_mapRef$current = mapRef.current) !== null && _mapRef$current !== void 0 && (_mapRef$current = _mapRef$current.style) !== null && _mapRef$current !== void 0 && _mapRef$current._loaded)) return;
  var dsm = droneDataType === 'NDSM' ? 'DSM' : null;
  var opList = data.orthoPhotoList,
    dsList = data.dsmList;
  var isDsm = dsmList.includes(droneDataType);
  var isOrtho = orthoPhotoList.includes(droneDataType);
  if (isDsm && !(dsList !== null && dsList !== void 0 && dsList.includes(droneDataType)) && dsList !== null && dsList !== void 0 && dsList.length || isOrtho && !(opList !== null && opList !== void 0 && opList.includes(droneDataType)) && opList !== null && opList !== void 0 && opList.length) {
    showErrorInfo(dsm, droneDataType, t);
  }
};
var useRedrawSatelliteImagery = function useRedrawSatelliteImagery(glMapRef, glRightMapRef, isShowingImagery, showSideBySideMap, isAnomaly, highlightPlant, t) {
  var _data$, _otherSide$data;
  var isSatellite = isShowingImagery.isSatellite,
    data = isShowingImagery.data,
    otherSide = isShowingImagery.otherSide,
    isSatelliteRight = isShowingImagery.isSatelliteRight,
    droneDataType = isShowingImagery.droneDataType;
  var _ref = isShowingImagery || {},
    leftDroneDataType = _ref.droneDataType,
    leftImageryVisible = _ref.visible;
  var _ref2 = (isShowingImagery === null || isShowingImagery === void 0 ? void 0 : isShowingImagery.otherSide) || {},
    rightDroneDataType = _ref2.droneDataType,
    rightImageryVisible = _ref2.visible;
  var isLeftDataAvailable = data === null || data === void 0 || (_data$ = data[0]) === null || _data$ === void 0 || (_data$ = _data$.tiles) === null || _data$ === void 0 ? void 0 : _data$[leftDroneDataType];
  var isRightDataAvailable = otherSide === null || otherSide === void 0 || (_otherSide$data = otherSide.data) === null || _otherSide$data === void 0 || (_otherSide$data = _otherSide$data[0]) === null || _otherSide$data === void 0 || (_otherSide$data = _otherSide$data.tiles) === null || _otherSide$data === void 0 ? void 0 : _otherSide$data[rightDroneDataType];
  var isDsm = dsmList.includes(leftDroneDataType);
  var isOrtho = orthoPhotoList.includes(leftDroneDataType);
  useEffect(function () {
    var _glMapRef$current4, _previousData, _previousData2;
    if (isAnomaly || !(glMapRef !== null && glMapRef !== void 0 && glMapRef.current) || !showSideBySideMap) return;
    if (isShowingImagery !== null && isShowingImagery !== void 0 && isShowingImagery.visible && glMapRef !== null && glMapRef !== void 0 && (_glMapRef$current4 = glMapRef.current) !== null && _glMapRef$current4 !== void 0 && (_glMapRef$current4 = _glMapRef$current4.style) !== null && _glMapRef$current4 !== void 0 && _glMapRef$current4._loaded && isLeftDataAvailable) {
      var _data$2;
      var dataKeys = Object.keys((data === null || data === void 0 || (_data$2 = data[0]) === null || _data$2 === void 0 ? void 0 : _data$2.tiles) || {});
      if (isOrtho) previousData.orthoPhotoList = dataKeys;
      if (isDsm) previousData.dsmList = dataKeys;
      renderLeftImagery(glMapRef, leftDroneDataType, data, isSatellite, false, highlightPlant, t);
    } else if ((_previousData = previousData) !== null && _previousData !== void 0 && (_previousData = _previousData.orthoPhotoList) !== null && _previousData !== void 0 && _previousData.length || (_previousData2 = previousData) !== null && _previousData2 !== void 0 && (_previousData2 = _previousData2.dsmList) !== null && _previousData2 !== void 0 && _previousData2.length) {
      handleImageryError(glMapRef, leftDroneDataType, previousData, t);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [leftImageryVisible, showSideBySideMap, isLeftDataAvailable, droneDataType]);
  useEffect(function () {
    var _isShowingImagery$oth5, _glRightMapRef$curren4, _previousData3, _previousData4;
    if (isAnomaly || !(glRightMapRef !== null && glRightMapRef !== void 0 && glRightMapRef.current) || !showSideBySideMap) return;
    if (isShowingImagery !== null && isShowingImagery !== void 0 && (_isShowingImagery$oth5 = isShowingImagery.otherSide) !== null && _isShowingImagery$oth5 !== void 0 && _isShowingImagery$oth5.visible && glRightMapRef !== null && glRightMapRef !== void 0 && (_glRightMapRef$curren4 = glRightMapRef.current) !== null && _glRightMapRef$curren4 !== void 0 && (_glRightMapRef$curren4 = _glRightMapRef$curren4.style) !== null && _glRightMapRef$curren4 !== void 0 && _glRightMapRef$curren4._loaded && isRightDataAvailable) {
      renderRightImagery(glRightMapRef, rightDroneDataType, otherSide === null || otherSide === void 0 ? void 0 : otherSide.data, isSatelliteRight, false, t);
    } else if ((_previousData3 = previousData) !== null && _previousData3 !== void 0 && (_previousData3 = _previousData3.orthoPhotoList) !== null && _previousData3 !== void 0 && _previousData3.length || (_previousData4 = previousData) !== null && _previousData4 !== void 0 && (_previousData4 = _previousData4.dsmList) !== null && _previousData4 !== void 0 && _previousData4.length) {
      handleImageryError(glRightMapRef, rightDroneDataType, previousData, t);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rightImageryVisible, showSideBySideMap, isRightDataAvailable, rightDroneDataType]);
};
var useRenderSatelliteImagery = function useRenderSatelliteImagery(glMapRef, glRightMapRef, isShowingImagery, showSideBySideMap, isPlants, isAnomaly, t) {
  var _leftImageryData$, _rightImageryData$;
  var leftSideData = [];
  var rightSideData = [];
  var rightDroneDataType;
  var _ref3 = isShowingImagery || {},
    leftImageryData = _ref3.data,
    leftDroneDataType = _ref3.droneDataType,
    leftImageryVisible = _ref3.visible;
  var _ref4 = (isShowingImagery === null || isShowingImagery === void 0 ? void 0 : isShowingImagery.otherSide) || {},
    rightImageryData = _ref4.data,
    rightDroneType = _ref4.droneDataType,
    rightImageryVisible = _ref4.visible;
  var isSatellite = isShowingImagery.isSatellite,
    isSatelliteRight = isShowingImagery.isSatelliteRight;

  // To update the data only if available
  var isLeftDataAvailable = leftImageryData === null || leftImageryData === void 0 || (_leftImageryData$ = leftImageryData[0]) === null || _leftImageryData$ === void 0 || (_leftImageryData$ = _leftImageryData$.tiles) === null || _leftImageryData$ === void 0 ? void 0 : _leftImageryData$[leftDroneDataType];
  if (leftImageryVisible && leftImageryData && isLeftDataAvailable || leftImageryVisible && leftImageryData && isSatellite) {
    leftSideData = leftImageryData;
  }
  // To update the data only if available
  var isRightDataAvailable = rightImageryData === null || rightImageryData === void 0 || (_rightImageryData$ = rightImageryData[0]) === null || _rightImageryData$ === void 0 || (_rightImageryData$ = _rightImageryData$.tiles) === null || _rightImageryData$ === void 0 ? void 0 : _rightImageryData$[rightDroneType];
  if (rightImageryData && rightImageryVisible && isRightDataAvailable || rightImageryVisible && rightImageryData && isSatelliteRight) {
    rightSideData = rightImageryData;
    rightDroneDataType = rightDroneType;
  }
  var leftSide = JSON.stringify(leftSideData);
  var rightSide = JSON.stringify(rightSideData);
  useEffect(function () {
    var _glMapRef$current5;
    if (!(glMapRef !== null && glMapRef !== void 0 && glMapRef.current) || !showSideBySideMap || isAnomaly || !(leftImageryData !== null && leftImageryData !== void 0 && leftImageryData.length)) return;
    if (glMapRef !== null && glMapRef !== void 0 && (_glMapRef$current5 = glMapRef.current) !== null && _glMapRef$current5 !== void 0 && (_glMapRef$current5 = _glMapRef$current5.style) !== null && _glMapRef$current5 !== void 0 && _glMapRef$current5._loaded) {
      renderLeftImagery(glMapRef, leftDroneDataType, JSON.parse(leftSide), isSatellite, false, false, t);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [glMapRef, leftSide, showSideBySideMap, isAnomaly, leftDroneDataType]);
  useEffect(function () {
    var _glRightMapRef$curren5;
    if (!glRightMapRef.current || !showSideBySideMap || isAnomaly || !(rightImageryData !== null && rightImageryData !== void 0 && rightImageryData.length)) return;
    if (glRightMapRef !== null && glRightMapRef !== void 0 && (_glRightMapRef$curren5 = glRightMapRef.current) !== null && _glRightMapRef$curren5 !== void 0 && (_glRightMapRef$curren5 = _glRightMapRef$curren5.style) !== null && _glRightMapRef$curren5 !== void 0 && _glRightMapRef$curren5._loaded) {
      renderRightImagery(glRightMapRef, rightDroneDataType, JSON.parse(rightSide), isSatelliteRight, false, t);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [glRightMapRef, rightSide, showSideBySideMap, isAnomaly, rightDroneDataType]);
};
var useRenderSoilLayer = function useRenderSoilLayer(selMapShowSoilType, showSideBySideMap, presentationMode, glMapRef, glRightMapRef) {
  useEffect(function () {
    if (!selMapShowSoilType) return;
    if (glMapRef !== null && glMapRef !== void 0 && glMapRef.current) {
      detachEventsWithLayerId(glMapRef.current, eventRefSoil);
      var attachOnStyleLoad = function attachOnStyleLoad() {
        return renderSoilLayer(glMapRef.current);
      };
      eventRefSoil.styledata = {
        event: attachOnStyleLoad
      };
      glMapRef.current.once('styledata', attachOnStyleLoad);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [glMapRef, selMapShowSoilType, showSideBySideMap, presentationMode]);
  useEffect(function () {
    if (!selMapShowSoilType) return;
    if (glRightMapRef !== null && glRightMapRef !== void 0 && glRightMapRef.current) {
      detachEventsWithLayerId(glRightMapRef.current, eventRefSoilRight);
      var attachOnStyleLoad = function attachOnStyleLoad() {
        return renderSoilLayer(glRightMapRef.current);
      };
      eventRefSoilRight.styledata = {
        event: attachOnStyleLoad
      };
      glRightMapRef.current.once('styledata', attachOnStyleLoad);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [glRightMapRef, selMapShowSoilType, showSideBySideMap, presentationMode]);
};

/* eslint-disable import/no-extraneous-dependencies */
function RanchLayer(props) {
  var ranchesGeoJSON = props.ranchesGeoJSON,
    presentationMode = props.presentationMode,
    expandedGeoJSON = props.expandedGeoJSON,
    colors = props.colors,
    onClickRanch = props.onClickRanch,
    zoomShowSensorsState = props.zoomShowSensorsState;
  return ranchesGeoJSON.features.map(function (feature) {
    var selected = false;
    var featureRanch = cloneDeep(feature);
    featureRanch.geometry.type = 'MultiLineString';
    var style = {
      color: 'white',
      weight: 2
    };
    try {
      // space for any conditional style rendering based on properties
      if (expandedGeoJSON !== null && expandedGeoJSON !== void 0 && expandedGeoJSON.features && expandedGeoJSON.features.length === 1 && expandedGeoJSON.features[0].properties.id === feature.properties.id) {
        delete style.dashArray;
        selected = true;
        style.weight = 4;
        style.dashArray = [10, 10];
      }
      if (presentationMode) {
        switch (presentationMode) {
          case 'soilstatus':
            {
              if (feature.properties.state && feature.properties.state.state) {
                style.color = (colors || stateColorCode)[feature.properties.state.state].markerColor;
              }
              break;
            }
          case 'connectivity':
            {
              if (feature.properties.connectivityState) {
                style.color = (colors || stateColorCode)[feature.properties.connectivityState].markerColor;
              }
              break;
            }
          case 'waterpressure':
            {
              if (feature.properties.waterPressureState) {
                style.color = (colors || stateColorCode)[feature.properties.waterPressureState].markerColor;
              }
              break;
            }
          case 'control':
            {
              if (feature.properties.controlState) {
                style.color = (colors || stateColorCode)[feature.properties.controlState].markerColor;
              }
              break;
            }
          case 'provision':
            {
              if (feature.properties.provisionState) {
                style.color = (colors || stateColorCode)[feature.properties.provisionState].markerColor;
              }
              break;
            }
          case 'cropHealth':
            {
              if (feature.properties.cropState) {
                style.color = (colors || stateColorCode)[feature.properties.cropState].markerColor;
              }
              break;
            }
          default:
            style.color = 'white';
        }
      }
    } catch (error) {
      console.log('ERROR in Map.jsx ranch data anomaly', error);
    }
    return /*#__PURE__*/React.createElement(GeoJSON, {
      className: "map-ranch-boundary-".concat(feature.id),
      style: style,
      key: "".concat(JSON.stringify(feature)).concat(selected).concat(presentationMode).concat(zoomShowSensorsState),
      data: [featureRanch],
      onClick: function onClick() {
        if (onClickRanch) {
          onClickRanch(feature.properties.id);
        }
      }
    });
  });
}

var LabelMarker = function LabelMarker(_ref) {
  var position = _ref.position,
    name = _ref.name,
    className = _ref.className,
    onClick = _ref.onClick;
  var icon = L$1.divIcon({
    className: 'custom-icon',
    html: ReactDOMServer.renderToString(/*#__PURE__*/React.createElement("div", {
      className: "".concat(className, " label-marker-text")
    }, name))
  });
  return /*#__PURE__*/React.createElement(Marker, {
    onClick: onClick,
    position: position,
    icon: icon
  });
};
LabelMarker.propTypes = {
  position: PropTypes.arrayOf(PropTypes.number).isRequired,
  name: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
  onClick: PropTypes.func
};
LabelMarker.defaultProps = {
  onClick: function onClick() {}
};

function BlocksLayer(props) {
  var _isShowingImagery$oth;
  var blocksGeoJSON = props.blocksGeoJSON,
    presentationMode = props.presentationMode,
    expandedGeoJSON = props.expandedGeoJSON,
    colors = props.colors,
    onClickBlock = props.onClickBlock,
    isShowingImagery = props.isShowingImagery,
    mapRef = props.mapRef,
    zoomShowSensorsState = props.zoomShowSensorsState;
  var CONDITION_CHECK = !isShowingImagery.visible && !(isShowingImagery !== null && isShowingImagery !== void 0 && (_isShowingImagery$oth = isShowingImagery.otherSide) !== null && _isShowingImagery$oth !== void 0 && _isShowingImagery$oth.visible);
  return blocksGeoJSON.features.map(function (feature) {
    var _bbox = bbox(feature),
      _bbox2 = _slicedToArray(_bbox, 4),
      minLng = _bbox2[0],
      minLat = _bbox2[1],
      maxLng = _bbox2[2],
      maxLat = _bbox2[3];
    var position = [(minLat + maxLat) / 2, (minLng + maxLng) / 2];
    var style = {
      color: 'white',
      weight: 2,
      fillOpacity: 0
    };
    var selected = false;
    try {
      if (expandedGeoJSON !== null && expandedGeoJSON !== void 0 && expandedGeoJSON.features && expandedGeoJSON.features.length === 1 && expandedGeoJSON.features[0].properties.id === feature.properties.id) {
        style.weight = 4;
        style.fillOpacity = 0;
        style.dashArray = [10, 10];
        selected = true;
      }
      if (presentationMode) {
        switch (presentationMode) {
          case 'soilstatus':
            {
              var soilStateStringOfBlock = feature.properties.soilStateStringOfBlock;
              var color = getColorCodeForSoilState(soilStateStringOfBlock);
              style.color = color;
              if (CONDITION_CHECK) {
                style.fillColor = color;
                style.fillOpacity = 0.5;
              }
              break;
            }
          case 'connectivity':
            {
              if (feature.properties.connectivityState) {
                style.color = (colors || stateColorCode)[feature.properties.connectivityState].markerColor;
                if (CONDITION_CHECK) {
                  style.fillColor = (colors || stateColorCode)[feature.properties.connectivityState].markerColor;
                  style.fillOpacity = 0.5;
                }
              }
              break;
            }
          case 'waterpressure':
            {
              if (typeof feature.properties.waterPressureState !== 'undefined') {
                style.color = (colors || stateColorCode)[feature.properties.waterPressureState].markerColor;
                if (CONDITION_CHECK) {
                  style.fillColor = (colors || stateColorCode)[feature.properties.waterPressureState].markerColor;
                  style.fillOpacity = 0.5;
                }
              }
              break;
            }
          case 'control':
            {
              if (typeof feature.properties.controlState !== 'undefined') {
                style.color = (colors || stateColorCode)[feature.properties.waterPressureState].markerColor;
                if (CONDITION_CHECK) {
                  style.fillColor = (colors || stateColorCode)[feature.properties.waterPressureState].markerColor;
                  style.fillOpacity = 0.5;
                }
              }
              break;
            }
          case 'provision':
            {
              if (feature.properties.provisionState) {
                style.color = (colors || stateColorCode)[feature.properties.provisionState].markerColor;
                if (CONDITION_CHECK) {
                  style.fillColor = (colors || stateColorCode)[feature.properties.provisionState].markerColor;
                  style.fillOpacity = 0.5;
                }
              }
              break;
            }
          case 'irrigationRecommendation':
            {
              if (feature.properties.recommendationInfo && feature.properties.recommendationInfo.state) {
                var _color = getColorCodeForIrrigationState(feature.properties.recommendationInfo.state);
                style.color = _color;
                if (CONDITION_CHECK) {
                  style.fillColor = _color;
                  style.fillOpacity = 0.5;
                }
              } else {
                var _color2 = getColorCodeForIrrigationState();
                style.color = getColorCodeForIrrigationState();
                if (CONDITION_CHECK) {
                  style.fillColor = _color2;
                  style.fillOpacity = 0.5;
                }
              }
              break;
            }
          case 'cropHealth':
            {
              if (typeof feature.properties.cropState !== 'undefined') {
                style.color = (colors || stateColorCode)[feature.properties.cropState].markerColor;
                if (CONDITION_CHECK) {
                  style.fillColor = (colors || stateColorCode)[feature.properties.cropState].markerColor;
                  style.fillOpacity = 0.5;
                }
              }
              break;
            }
          default:
            style.color = 'white';
        }
      }
    } catch (error) {
      console.log('ERROR in Map.jsx block data anomaly', error);
    }
    return /*#__PURE__*/React.createElement(GeoJSON, {
      className: "map-ranch-block-b-".concat(feature.properties.name),
      style: style,
      key: "".concat(presentationMode).concat(JSON.stringify(feature.properties)).concat(selected).concat(isShowingImagery.visible).concat(zoomShowSensorsState),
      data: [feature],
      onClick: function onClick() {
        if (onClickBlock) {
          onClickBlock(feature.properties.id);
        }
      }
    }, mapRef.current && mapRef.current.getZoom() > 13 && /*#__PURE__*/React.createElement(LabelMarker, {
      position: position,
      name: feature.properties.name,
      className: "map-ranch-block-i-".concat(feature.properties.name),
      onClick: function onClick() {
        if (onClickBlock) {
          onClickBlock(feature.properties.id);
        }
      }
    }));
  });
}

var antIcon = /*#__PURE__*/React.createElement(LoadingOutlined, {
  style: {
    fontSize: 24
  },
  spin: true
});
var isEqual = require('react-fast-compare');
leafletVectorMarkers(L$1);
var accessToken = process.env.REACT_APP_MAPBOX_TOKEN;
var optimalZoomLevel = 15; // To render the ranch boundary upto visible level

var initialState = {
  viewBox: {
    latitude: 37.646,
    longitude: -121.016,
    zoom: 6
  },
  sensorsGeoJSON: {
    features: []
  },
  ranchesGeoJSON: {
    features: []
  }
};
var padding = {
  top: 240,
  left: 240,
  bottom: 240,
  right: 240
};
function SingleMarker(singleMarkerGeoJSON) {
  return /*#__PURE__*/React.createElement(Marker, {
    position: [singleMarkerGeoJSON.geometry.coordinates[0], singleMarkerGeoJSON.geometry.coordinates[1]],
    icon: prepareSingleMarkerIcon()
  });
}
var bounds = [[-90, -180],
// Southwest coordinates
[90, 180] // Northeast coordinates
];
var SetBounds = function SetBounds(_ref) {
  var mapRef = _ref.mapRef;
  var map = mapRef.current;
  if (map) {
    map.setMaxBounds(bounds);
    map.on('drag', function () {
      map.panInsideBounds(bounds, {
        animate: false
      });
    });
    return null;
  }
  return null;
};
var maxZoom = 23;
function Map(_ref2) {
  var _dynamicBoundsGeoJSON, _plantsGeoJSON$featur, _glMapRef$current, _recenterGeoJSON$feat, _isShowingImagery$oth;
  var children = _ref2.children,
    sensorsGeoJSON = _ref2.sensorsGeoJSON,
    mapBoxPadding = _ref2.mapBoxPadding,
    width = _ref2.width,
    height = _ref2.height,
    activePopUp = _ref2.activePopUp,
    selectSensor = _ref2.selectSensor,
    showAllSensorLabels = _ref2.showAllSensorLabels,
    recenterGeoJSON = _ref2.recenterGeoJSON,
    expandedGeoJSON = _ref2.expandedGeoJSON,
    ranchesGeoJSON = _ref2.ranchesGeoJSON,
    blocksGeoJSON = _ref2.blocksGeoJSON,
    showPopUpOnMarkerClick = _ref2.showPopUpOnMarkerClick,
    presentationMode = _ref2.presentationMode,
    selectedSensor = _ref2.selectedSensor,
    isDataLoading = _ref2.isDataLoading,
    onClickRanch = _ref2.onClickRanch,
    onClickBlock = _ref2.onClickBlock,
    onClickMap = _ref2.onClickMap,
    singleMarkerGeoJSON = _ref2.singleMarkerGeoJSON,
    dynamicBoundsGeoJSON = _ref2.dynamicBoundsGeoJSON,
    onClickDynamicBounds = _ref2.onClickDynamicBounds,
    isShowingImagery = _ref2.isShowingImagery,
    exposeZoomChange = _ref2.exposeZoomChange,
    colors = _ref2.colors,
    anomalyGeoJSON = _ref2.anomalyGeoJSON,
    deleteAnomaly = _ref2.deleteAnomaly,
    onSelectAnomaly = _ref2.onSelectAnomaly,
    createAnomaly = _ref2.createAnomaly,
    onDrawAnomaly = _ref2.onDrawAnomaly,
    userAreaUnit = _ref2.userAreaUnit,
    showSideBySideMap = _ref2.showSideBySideMap,
    layersControl = _ref2.layersControl,
    plantsGeoJSON = _ref2.plantsGeoJSON,
    mapRefElem = _ref2.mapRefElem,
    isBottomSheetVisible = _ref2.isBottomSheetVisible,
    selectedColorValue = _ref2.selectedColorValue,
    clusterGeoJSON = _ref2.clusterGeoJSON,
    showPlants = _ref2.showPlants,
    highlightPlant = _ref2.highlightPlant,
    isGroundMissionPage = _ref2.isGroundMissionPage,
    isBlockType = _ref2.isBlockType,
    isAllRanch = _ref2.isAllRanch,
    isSpinnerForMap = _ref2.isSpinnerForMap,
    selMapShowSoilType = _ref2.selMapShowSoilType;
  if (dynamicBoundsGeoJSON && !((_dynamicBoundsGeoJSON = dynamicBoundsGeoJSON) !== null && _dynamicBoundsGeoJSON !== void 0 && _dynamicBoundsGeoJSON.features)) {
    var dynamicBoundsGeoJSONBuffer = {
      type: 'FeatureCollection',
      features: []
    };
    dynamicBoundsGeoJSONBuffer.features.push(cloneDeep(dynamicBoundsGeoJSON));
    dynamicBoundsGeoJSON = dynamicBoundsGeoJSONBuffer;
  }
  // To render the Leaflet map for admin-web
  // Used existing prop to display
  var isSensorGeoJSONAvailable = sensorsGeoJSON !== undefined;
  var isAnomaly = presentationMode === 'anomaly' || isSensorGeoJSONAvailable;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(initialState),
    _useState2 = _slicedToArray(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  var mounted = useRef(false);
  var mapRef = useRef(null);
  var glMapRef = useRef(null);
  var glRightMapRef = useRef(null);
  var sideBySideView = useRef(null);
  var previousZoom = useRef(state.viewBox);
  var showZoomControl = useRef(null);
  var zoomValue = useRef(optimalZoomLevel);
  // Refs to store the attached events to detach
  var eventRef = useRef({});
  var rightMapEventRef = useRef({});
  var isPlants = presentationMode === 'plants';
  var coords = isPlants ? (plantsGeoJSON === null || plantsGeoJSON === void 0 || (_plantsGeoJSON$featur = plantsGeoJSON.features) === null || _plantsGeoJSON$featur === void 0 || (_plantsGeoJSON$featur = _plantsGeoJSON$featur[0]) === null || _plantsGeoJSON$featur === void 0 || (_plantsGeoJSON$featur = _plantsGeoJSON$featur.geometry) === null || _plantsGeoJSON$featur === void 0 ? void 0 : _plantsGeoJSON$featur.coordinates) || [0, 0] : [state.viewBox.longitude, state.viewBox.latitude];
  var el = document;
  var event = document.createEvent('HTMLEvents');
  event.initEvent('resize', true, false);
  useEffect(function () {
    // eslint-disable-next-line no-underscore-dangle
    delete L$1.Icon.Default.prototype._getIconUrl;
    L$1.Icon.Default.mergeOptions({
      iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
      iconUrl: require('leaflet/dist/images/marker-icon.png'),
      shadowUrl: require('leaflet/dist/images/marker-shadow.png')
    });
    mounted.current = true;
    el.dispatchEvent(event);
    return function () {
      mounted.current = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  function updateRefElem(elem) {
    if (elem !== null && elem !== void 0 && elem.left) {
      glMapRef.current = elem === null || elem === void 0 ? void 0 : elem.left;
    }
    if (elem !== null && elem !== void 0 && elem.right) {
      glRightMapRef.current = elem === null || elem === void 0 ? void 0 : elem.right;
    } else glRightMapRef.current = null;
    if (mapRefElem) mapRefElem(elem);
  }
  var newZoomValue = (_glMapRef$current = glMapRef.current) === null || _glMapRef$current === void 0 ? void 0 : _glMapRef$current.getZoom();
  if (newZoomValue !== undefined) {
    // To maintain similar zoom level between Leaflet map and Maplibre map
    // Switching between "Anomaly" and other map settings
    var decimalPart = newZoomValue % 1;
    zoomValue.current = decimalPart >= 0.5 ? Math.ceil(newZoomValue) : Math.floor(newZoomValue);
  }

  // anomaly map padding for smaller screen devices less than 500px
  var anomalyMapPadding = window.innerWidth < 500 ? {
    top: 0,
    left: 0,
    bottom: 0,
    right: 0
  } : padding;
  var newMapBoxPadding = isAnomaly && !isGroundMissionPage ? anomalyMapPadding : mapBoxPadding;
  var blockIdLocal;
  var ranchId;
  if ((recenterGeoJSON === null || recenterGeoJSON === void 0 || (_recenterGeoJSON$feat = recenterGeoJSON.features) === null || _recenterGeoJSON$feat === void 0 ? void 0 : _recenterGeoJSON$feat.length) === 1) {
    var _recenterGeoJSON$feat2, _recenterGeoJSON$feat3, _recenterGeoJSON$feat4;
    if (recenterGeoJSON !== null && recenterGeoJSON !== void 0 && (_recenterGeoJSON$feat2 = recenterGeoJSON.features) !== null && _recenterGeoJSON$feat2 !== void 0 && (_recenterGeoJSON$feat2 = _recenterGeoJSON$feat2[0]) !== null && _recenterGeoJSON$feat2 !== void 0 && _recenterGeoJSON$feat2.blocks) ranchId = recenterGeoJSON === null || recenterGeoJSON === void 0 || (_recenterGeoJSON$feat3 = recenterGeoJSON.features) === null || _recenterGeoJSON$feat3 === void 0 || (_recenterGeoJSON$feat3 = _recenterGeoJSON$feat3[0]) === null || _recenterGeoJSON$feat3 === void 0 ? void 0 : _recenterGeoJSON$feat3.id;else blockIdLocal = recenterGeoJSON === null || recenterGeoJSON === void 0 || (_recenterGeoJSON$feat4 = recenterGeoJSON.features) === null || _recenterGeoJSON$feat4 === void 0 || (_recenterGeoJSON$feat4 = _recenterGeoJSON$feat4[0]) === null || _recenterGeoJSON$feat4 === void 0 ? void 0 : _recenterGeoJSON$feat4.id;
  }
  // To get the zoom value dynamically based on the data
  var dynamicZoomValue = getDynamicZoomValue(recenterGeoJSON, mapBoxPadding, width, height, state);
  function setMapZoom(mapVar) {
    if (dynamicZoomValue && !isAllRanch) {
      zoomValue.current = dynamicZoomValue;
      mapVar.setZoom(dynamicZoomValue);
    }
  }
  // To reset/update the zoom level only on block/ranch/allRanch selection
  useEffect(function () {
    if (!glMapRef.current) return;
    if (!isAnomaly && (blockIdLocal || ranchId)) {
      setMapZoom(glMapRef.current);
    }
    if (!isAnomaly && isAllRanch) glMapRef.current.setZoom(dynamicZoomValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [blockIdLocal, ranchId, dynamicZoomValue]);
  useEffect(function () {
    if (!mapRef.current) return;
    if (isAnomaly && (blockIdLocal || ranchId)) {
      setMapZoom(mapRef.current);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [blockIdLocal, ranchId, dynamicZoomValue]);
  useMapLibreGlMap(glMapRef, glRightMapRef, showSideBySideMap, coords, updateRefElem, isAnomaly, isAllRanch, isAllRanch ? dynamicZoomValue : zoomValue.current);
  var CONDITION_CHECK = !isShowingImagery.visible && !(isShowingImagery !== null && isShowingImagery !== void 0 && (_isShowingImagery$oth = isShowingImagery.otherSide) !== null && _isShowingImagery$oth !== void 0 && _isShowingImagery$oth.visible);
  var plantsGeoJSONForBlock = isBlockType ? plantsGeoJSON : 'none';
  useMapGeoJSONData(mapRef, mounted, exposeZoomChange, blocksGeoJSON, ranchesGeoJSON, recenterGeoJSON, expandedGeoJSON, dynamicBoundsGeoJSON, sensorsGeoJSON, singleMarkerGeoJSON, newMapBoxPadding, width, height, state, anomalyGeoJSON, plantsGeoJSON, isPlants, maxZoom, setState, previousZoom, glMapRef, isAllRanch, initialState, zoomValue.current);
  useMapSideBySideView(mapRef, showSideBySideMap, layersControl, isShowingImagery, sideBySideView, isPlants);
  useLoadDataSourceAndLayer(glMapRef, glRightMapRef, plantsGeoJSONForBlock, showSideBySideMap, onClickBlock, isPlants, blocksGeoJSON, ranchesGeoJSON, presentationMode, expandedGeoJSON, colors, CONDITION_CHECK, isShowingImagery, isAnomaly, selectedColorValue, showPlants, highlightPlant, isGroundMissionPage, isAllRanch, t);
  useRedrawPlantsPoints(glMapRef, glRightMapRef, showSideBySideMap, isBottomSheetVisible, selectedColorValue, isPlants, onClickBlock, plantsGeoJSON, isAnomaly, showPlants, highlightPlant);
  useZoomChange(glMapRef, glRightMapRef, exposeZoomChange, isAnomaly);
  useClearGlLayersOnClose(glMapRef, glRightMapRef, isBottomSheetVisible, isPlants, showSideBySideMap, onClickBlock, plantsGeoJSON, isAnomaly, selectedColorValue, showPlants, highlightPlant);
  useRedrawSatelliteImagery(glMapRef, glRightMapRef, isShowingImagery, showSideBySideMap, isAnomaly, highlightPlant, t);
  useRedrawBlockRanchBoundary(glMapRef, glRightMapRef, blocksGeoJSON, ranchesGeoJSON, expandedGeoJSON, presentationMode, isPlants, CONDITION_CHECK, onClickBlock, showSideBySideMap, colors, isShowingImagery, isAnomaly, isAllRanch);
  useRenderSatelliteImagery(glMapRef, glRightMapRef, isShowingImagery, showSideBySideMap, isPlants, isAnomaly, t);
  useRenderSoilLayer(selMapShowSoilType, showSideBySideMap, presentationMode, glMapRef, glRightMapRef);

  // To resize the map and make panning smoothly
  // But it will give delay when resizing
  useEffect(function () {
    if (!glMapRef.current) return;
    glMapRef.current.resize();
    if (!glRightMapRef.current) return;
    if (showSideBySideMap) {
      glRightMapRef.current.resize();
    }
  }, [showSideBySideMap, isBottomSheetVisible, width]);
  useEffect(function () {
    if (!glMapRef.current) return;
    if (glMapRef.current && isAnomaly) glMapRef.current = null;
  }, [isAnomaly]);
  var plantsData = JSON.stringify(plantsGeoJSON || clusterGeoJSON || {});
  useEffect(function () {
    if (!glMapRef.current) return;
    if (isPlants) {
      try {
        var _JSON$parse = JSON.parse(plantsData),
          blockId = _JSON$parse.blockId;
        if (blocksGeoJSON && blocksGeoJSON.features.length && blocksGeoJSON.features[0]) {
          var _glMapRef$current2, _blockData$features;
          var blockData = _objectSpread2({}, blocksGeoJSON);
          if (blockId) {
            blockData.features = blocksGeoJSON.features.filter(function (d) {
              return (d === null || d === void 0 ? void 0 : d.id) === blockId;
            });
          }
          // this will be removed in the future
          if (glMapRef !== null && glMapRef !== void 0 && (_glMapRef$current2 = glMapRef.current) !== null && _glMapRef$current2 !== void 0 && _glMapRef$current2.getLayer('points-fill') && !isGroundMissionPage) {
            glMapRef.current.removeLayer('points-fill');
            glMapRef.current.removeSource('point');
          }
          if (!(blockData !== null && blockData !== void 0 && (_blockData$features = blockData.features) !== null && _blockData$features !== void 0 && _blockData$features.length)) return;
          var _bbox = bbox(blockData),
            _bbox2 = _slicedToArray(_bbox, 4),
            minLng = _bbox2[0],
            minLat = _bbox2[1],
            maxLng = _bbox2[2],
            maxLat = _bbox2[3];
          var viewBox = state.viewBox;
          viewBox.zoom = glMapRef.current.getZoom();
          var webMercatorViewport = new WebMercatorViewport(_objectSpread2(_objectSpread2({}, viewBox), {}, {
            width: width,
            height: height
          }));
          var _webMercatorViewport$ = webMercatorViewport.fitBounds([[minLng, minLat], [maxLng, maxLat]], {
              padding: {
                top: mapBoxPadding.top,
                bottom: mapBoxPadding.bottom,
                left: mapBoxPadding.left,
                right: mapBoxPadding.right
              }
            }),
            longitude = _webMercatorViewport$.longitude,
            latitude = _webMercatorViewport$.latitude,
            zoom = _webMercatorViewport$.zoom;
          var mapCenter = glMapRef.current.getCenter();
          // set zoom level for ground mission recommendation page
          if (isGroundMissionPage) glMapRef.current.setZoom(zoom);
          var lat = mapCenter.lat,
            lng = mapCenter.lng;
          if ([lng, lat].join(',') !== [longitude, latitude].join(',')) {
            glMapRef.current.setCenter([longitude, latitude]);
          }
        } else if (isAllRanch) {
          glMapRef.current.setZoom(dynamicZoomValue);
          glMapRef.current.setCenter([initialState.viewBox.longitude, initialState.viewBox.latitude]);
        } else {
          glMapRef.current.setZoom(dynamicZoomValue);
          glMapRef.current.setCenter([state.viewBox.longitude, state.viewBox.latitude]);
        }
      } catch (error) {
        console.error('Error in fitBounds:', error);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPlants, blocksGeoJSON, showSideBySideMap, plantsData, isAllRanch]);
  useEffect(function () {
    if (!glMapRef.current) return;
    function onIdle() {
      var _previousZoom$current;
      if (((_previousZoom$current = previousZoom.current) === null || _previousZoom$current === void 0 ? void 0 : _previousZoom$current.zoom) !== glMapRef.current.getZoom()) {
        if (typeof exposeZoomChange === 'function' && !isPlants) {
          exposeZoomChange(glMapRef.current.getZoom());
        }
      }
    }
    detachEventsWithLayerId(glMapRef.current, eventRef.current);
    eventRef.current.idle = {
      event: onIdle
    };
    glMapRef.current.once('idle', onIdle);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPlants, isAllRanch]);

  // For zoom control
  useEffect(function () {
    if (!mapRef.current) return;
    if (!isMobile && isAnomaly && !isSensorGeoJSONAvailable) {
      showZoomControl.current = L$1.control.zoom({
        position: 'topright'
      }).addTo(mapRef.current);
    }
  }, [isAnomaly, isSensorGeoJSONAvailable]);

  // Hide the color keys in smaller devices
  useEffect(function () {
    var visibleClassName = 'bottom-sheet-visible';
    var hiddenClassName = 'bottom-sheet-hidden';
    if (isBottomSheetVisible) {
      document.body.classList.add(visibleClassName);
      document.body.classList.remove(hiddenClassName);
    } else {
      document.body.classList.remove(visibleClassName);
      document.body.classList.add(hiddenClassName);
    }
  }, [isBottomSheetVisible]);

  // To bring the block labels to front
  useEffect(function () {
    if (!glMapRef.current) return;
    function onStyleData() {
      var _glRightMapRef$curren;
      bringLabelsToFront(glMapRef.current);
      if (glRightMapRef.current && (_glRightMapRef$curren = glRightMapRef.current) !== null && _glRightMapRef$curren !== void 0 && (_glRightMapRef$curren = _glRightMapRef$curren.style) !== null && _glRightMapRef$curren !== void 0 && _glRightMapRef$curren._loaded) {
        bringLabelsToFront(glRightMapRef.current);
      }
    }
    detachEventsWithLayerId(glMapRef.current, eventRef.current);
    eventRef.current.styledata = {
      event: onStyleData
    };
    glMapRef.current.on('styledata', onStyleData);
    if (!(glRightMapRef !== null && glRightMapRef !== void 0 && glRightMapRef.current)) return;
    detachEventsWithLayerId(glRightMapRef.current, rightMapEventRef.current);
    rightMapEventRef.current.styledata = {
      event: onStyleData
    };
    glRightMapRef.current.on('styledata', onStyleData);
  });
  var _useState3 = useState(true),
    _useState4 = _slicedToArray(_useState3, 2),
    zoomShowSensorsState = _useState4[0],
    setZoomShowSensorsState = _useState4[1];
  function onViewPortChanged(viewport) {
    if (viewport && viewport.center) {
      if (viewport.center[0] !== state.viewBox.latitude || viewport.center[1] !== state.viewBox.longitude || state.viewBox.zoom !== viewport.zoom) {
        var zoom = viewport.zoom > maxZoom ? maxZoom : viewport.zoom;
        setState(_objectSpread2(_objectSpread2({}, state), {}, {
          viewBox: {
            latitude: viewport.center[0],
            longitude: viewport.center[1],
            zoom: zoom
          }
        }));
        zoomValue.current = zoom;
        var zoomShowSensors = zoom > 11;
        if (zoomShowSensors !== zoomShowSensorsState && !isPlants) {
          setZoomShowSensorsState(zoomShowSensors);
        }
        if (typeof exposeZoomChange === 'function' && !isPlants) {
          exposeZoomChange(zoom, mapRef.current);
        }
      }
    }
    try {
      el.dispatchEvent(event);
    } catch (error) {
      console.log('Error map viewport changed', error);
    }
  }
  return /*#__PURE__*/React.createElement(Fragment, null, isSpinnerForMap && /*#__PURE__*/React.createElement(React.Fragment, null, (isDataLoading || !isPlants && !clusterGeoJSON && isPlants && !plantsGeoJSON || showSideBySideMap && !isShowingImagery.data) && /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'absolute',
      zIndex: '9999'
    },
    className: "map-data-is-loading"
  }, /*#__PURE__*/React.createElement(Spin, {
    indicator: antIcon
  }))), isAnomaly ? /*#__PURE__*/React.createElement(Map$1, {
    maxZoom: maxZoom,
    ref: function ref(r) {
      if (r && r.leafletElement) {
        mapRef.current = r.leafletElement;
      } else {
        mapRef.current = null;
      }
    },
    doubleClickZoom: false,
    onClick: onClickMap,
    attributionControl: false,
    className: "map-leaflet anomaly-view",
    viewport: {
      center: [state.viewBox.latitude, state.viewBox.longitude],
      zoom: state.viewBox.zoom > maxZoom ? maxZoom : state.viewBox.zoom
    },
    onViewportChanged: function onViewportChanged(viewport) {
      return onViewPortChanged(viewport);
    },
    zoomControl: false,
    minZoom: 2 // To fix the map goes blank when zooming out on anomaly view
  }, /*#__PURE__*/React.createElement(SetBounds, {
    mapRef: mapRef
  }), /*#__PURE__*/React.createElement(TileLayer, {
    url: "https://api.mapbox.com/styles/v1/farmx/cinjdgdic0015adnjk1bl7775/tiles/{z}/{x}/{y}?access_token={accessToken}",
    accessToken: accessToken,
    id: "farmx.cinjdgdic0015adnjk1bl7775",
    tileSize: 512,
    zoomOffset: -1
  }), Boolean(singleMarkerGeoJSON) && !isPlants && SingleMarker(singleMarkerGeoJSON), Boolean(state.sensorsGeoJSON) && Boolean(state.sensorsGeoJSON.features.length) && !isPlants && /*#__PURE__*/React.createElement(MarkerCluster, {
    key: JSON.stringify({
      presentationMode: presentationMode,
      s: state.sensorsGeoJSON
    }),
    sensorsGeoJSON: state.sensorsGeoJSON,
    activePopUp: activePopUp || {},
    selectSensor: selectSensor,
    showAllSensorLabels: showAllSensorLabels || false,
    showPopUpOnMarkerClick: showPopUpOnMarkerClick,
    presentationMode: presentationMode,
    selectedSensor: selectedSensor,
    refreshMap: function refreshMap() {
      el.dispatchEvent(event);
    }
  }), Boolean(dynamicBoundsGeoJSON) && Boolean(dynamicBoundsGeoJSON.features.length) && !isPlants && dynamicBoundsGeoJSON.features.map(function (feature) {
    return /*#__PURE__*/React.createElement(GeoJSON, {
      className: "map-dynamic-boundary-".concat(feature.id),
      style: {
        // color: '#e23549',
        color: '#FF0000',
        weight: 4,
        fillOpacity: 0,
        fillColor: '#e23549',
        dashArray: [10, 10]
      },
      key: JSON.stringify(feature),
      data: [feature],
      onClick: onClickDynamicBounds
    });
  }), Boolean(ranchesGeoJSON) && !isPlants && Boolean(ranchesGeoJSON.features.length) && ranchesGeoJSON.features[0] && /*#__PURE__*/React.createElement(RanchLayer, {
    ranchesGeoJSON: ranchesGeoJSON,
    presentationMode: presentationMode,
    expandedGeoJSON: expandedGeoJSON,
    colors: colors,
    onClickRanch: onClickRanch,
    zoomShowSensorsState: zoomShowSensorsState
  }), Boolean(blocksGeoJSON) && !isPlants && Boolean(blocksGeoJSON.features.length) && blocksGeoJSON.features[0] && /*#__PURE__*/React.createElement(BlocksLayer, {
    blocksGeoJSON: blocksGeoJSON,
    presentationMode: presentationMode,
    expandedGeoJSON: expandedGeoJSON,
    colors: colors,
    onClickBlock: onClickBlock,
    isShowingImagery: isShowingImagery,
    mapRef: mapRef,
    zoomShowSensorsState: zoomShowSensorsState
  }), presentationMode === 'anomaly' && /*#__PURE__*/React.createElement(AnomalyLayer, {
    anomalyGeoJSON: anomalyGeoJSON,
    presentationMode: presentationMode,
    isShowingImagery: isShowingImagery,
    zoomShowSensorsState: zoomShowSensorsState,
    onClickBlock: onClickBlock,
    setState: setState,
    mapState: state,
    mapRef: mapRef,
    previousZoom: previousZoom,
    deleteAnomaly: deleteAnomaly,
    onSelectAnomaly: onSelectAnomaly,
    createAnomaly: createAnomaly,
    onDrawAnomaly: onDrawAnomaly,
    userAreaUnit: userAreaUnit
  }), children) : /*#__PURE__*/React.createElement("div", {
    id: "default-map",
    className: "map-leaflet"
  }, showSideBySideMap ? /*#__PURE__*/React.createElement("div", {
    id: "comparison-container"
  }, /*#__PURE__*/React.createElement("div", {
    id: "left",
    className: "map"
  }), /*#__PURE__*/React.createElement("div", {
    id: "right",
    className: "map"
  })) : null, children, /*#__PURE__*/React.createElement("div", {
    id: "tooltip",
    style: {
      display: 'none'
    }
  })));
}
Map.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  width: PropTypes.number,
  height: PropTypes.number,
  // eslint-disable-next-line react/forbid-prop-types
  activePopUp: PropTypes.object,
  selectSensor: PropTypes.func,
  showAllSensorLabels: PropTypes.bool,
  presentationMode: PropTypes.string,
  recenterGeoJSON: PropTypes.shape({
    type: PropTypes.string,
    features: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      type: PropTypes.string,
      geometry: PropTypes.shape({
        coordinates: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.number), PropTypes.array]),
        type: PropTypes.string
      }),
      properties: PropTypes.object
    }))
  }),
  expandedGeoJSON: PropTypes.shape({
    type: PropTypes.string,
    features: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      type: PropTypes.string,
      geometry: PropTypes.shape({
        coordinates: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.number), PropTypes.array]),
        type: PropTypes.string
      }),
      properties: PropTypes.object
    }))
  }),
  ranchesGeoJSON: PropTypes.shape({
    type: PropTypes.string,
    features: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      type: PropTypes.string,
      geometry: PropTypes.shape({
        coordinates: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.number), PropTypes.array]),
        type: PropTypes.string
      }),
      properties: PropTypes.object
    }))
  }),
  dynamicBoundsGeoJSON: PropTypes.shape({
    type: PropTypes.string,
    features: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      type: PropTypes.string,
      geometry: PropTypes.shape({
        coordinates: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.number), PropTypes.array]),
        type: PropTypes.string
      }),
      properties: PropTypes.object
    }))
  }),
  blocksGeoJSON: PropTypes.shape({
    type: PropTypes.string,
    features: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      type: PropTypes.string,
      geometry: PropTypes.shape({
        coordinates: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.number), PropTypes.array]),
        type: PropTypes.string
      }),
      properties: PropTypes.object
    }))
  }),
  sensorsGeoJSON: PropTypes.shape({
    type: PropTypes.string,
    features: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      type: PropTypes.string,
      geometry: PropTypes.shape({
        coordinates: PropTypes.arrayOf(PropTypes.number),
        type: PropTypes.string
      }),
      properties: PropTypes.object
    }))
  }),
  singleMarkerGeoJSON: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    type: PropTypes.string,
    geometry: PropTypes.shape({
      coordinates: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.number), PropTypes.array]),
      type: PropTypes.string
    }),
    properties: PropTypes.object
  }),
  mapBoxPadding: PropTypes.shape({
    top: PropTypes.number,
    bottom: PropTypes.number,
    left: PropTypes.number,
    right: PropTypes.number
  }),
  showPopUpOnMarkerClick: PropTypes.bool,
  // eslint-disable-next-line react/forbid-prop-types
  selectedSensor: PropTypes.any,
  isDataLoading: PropTypes.bool,
  onClickRanch: PropTypes.func,
  onClickBlock: PropTypes.func,
  onClickMap: PropTypes.func,
  onClickDynamicBounds: PropTypes.func,
  isShowingImagery: PropTypes.shape({
    visible: PropTypes.bool,
    data: PropTypes.any
  }),
  exposeZoomChange: PropTypes.func,
  colors: PropTypes.arrayOf(PropTypes.shape({})),
  anomalyGeoJSON: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    type: PropTypes.string,
    geometry: PropTypes.shape({
      coordinates: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.number), PropTypes.array]),
      type: PropTypes.string
    }),
    properties: PropTypes.object,
    zoom: PropTypes.number
  }),
  deleteAnomaly: PropTypes.shape({}),
  onSelectAnomaly: PropTypes.func,
  createAnomaly: PropTypes.shape(),
  onDrawAnomaly: PropTypes.func,
  userAreaUnit: PropTypes.string,
  showSideBySideMap: PropTypes.bool,
  layersControl: PropTypes.shape({}),
  plantsGeoJSON: PropTypes.shape({}),
  clusterGeoJSON: PropTypes.shape({}),
  mapRefElem: PropTypes.func,
  isBottomSheetVisible: PropTypes.bool,
  selectedColorValue: PropTypes.number,
  showPlants: PropTypes.bool,
  highlightPlant: PropTypes.bool,
  isGroundMissionPage: PropTypes.bool,
  isBlockType: PropTypes.bool,
  isSpinnerForMap: PropTypes.bool,
  isAllRanch: PropTypes.bool,
  selMapShowSoilType: PropTypes.bool
};
Map.defaultProps = {
  children: null,
  width: 500,
  height: 500,
  activePopUp: undefined,
  selectSensor: undefined,
  showAllSensorLabels: undefined,
  ranchesGeoJSON: undefined,
  dynamicBoundsGeoJSON: undefined,
  recenterGeoJSON: undefined,
  expandedGeoJSON: undefined,
  blocksGeoJSON: undefined,
  sensorsGeoJSON: undefined,
  presentationMode: undefined,
  singleMarkerGeoJSON: undefined,
  mapBoxPadding: {
    top: 100,
    bottom: 100,
    left: 100,
    right: 100
  },
  showPopUpOnMarkerClick: true,
  selectedSensor: undefined,
  isDataLoading: false,
  onClickRanch: undefined,
  onClickBlock: undefined,
  onClickMap: undefined,
  onClickDynamicBounds: undefined,
  isShowingImagery: {
    visible: false,
    data: undefined
  },
  exposeZoomChange: undefined,
  colors: null,
  anomalyGeoJSON: undefined,
  deleteAnomaly: undefined,
  onSelectAnomaly: null,
  createAnomaly: null,
  onDrawAnomaly: null,
  userAreaUnit: null,
  showSideBySideMap: false,
  layersControl: null,
  plantsGeoJSON: null,
  clusterGeoJSON: null,
  mapRefElem: null,
  isBottomSheetVisible: false,
  selectedColorValue: undefined,
  showPlants: true,
  highlightPlant: false,
  isGroundMissionPage: false,
  isBlockType: false,
  isSpinnerForMap: true,
  isAllRanch: false,
  selMapShowSoilType: false
};
function ResizeDetector(props) {
  var _useState5 = useState({
      width: 500,
      height: 500
    }),
    _useState6 = _slicedToArray(_useState5, 2),
    dimensions = _useState6[0],
    setDimensions = _useState6[1];
  return /*#__PURE__*/React.createElement("div", {
    className: "map-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "map-inner-container"
  }, /*#__PURE__*/React.createElement(ReactResizeDetector, {
    onResize: function onResize(width, height) {
      if (!isEqual(dimensions, {
        width: width,
        height: height
      })) {
        setDimensions({
          width: width,
          height: height
        });
      }
    },
    handleWidth: true,
    handleHeight: true,
    refreshMode: "debounce",
    refreshRate: 633
  }), /*#__PURE__*/React.createElement(Map, _extends({
    key: JSON.stringify(props === null || props === void 0 ? void 0 : props.sensorsGeoJSON)
  }, _objectSpread2({}, props), {
    width: Math.round(dimensions.width),
    height: Math.round(dimensions.height)
  }))));
}

// Accept geoJSONState sensors all, so it would fix the zero
function prepareZeroIslandSensors(sensorsGeoJSON) {
  var sensors = cloneDeep(sensorsGeoJSON);
  var zeroIslands = [];
  var gw = {};
  sensors.features.forEach(function (s, i) {
    var coordinates = s.geometry.coordinates;
    var _s$properties = s.properties,
      type = _s$properties.type,
      id = _s$properties.id;
    if (type === 'gateway') {
      gw[id] = coordinates;
    }
    if (!coordinates[0] && !coordinates[1]) {
      zeroIslands.push({
        gw: s.properties.gateway,
        idx: i
      });
    }
  });
  if (!zeroIslands.length) {
    return sensorsGeoJSON;
  }
  zeroIslands.forEach(function (z) {
    if (gw[z.gw]) {
      sensors.features[z.idx].geometry.coordinates = gw[z.gw];
    }
  });
  return sensors;
}

function prepareRanchMarker(feature, latlng, mapVar, onClick) {
  var _feature$properties, _feature$properties2;
  var opts = {
    markerColor: '#fff',
    iconColor: '#000'
  };
  var marker;
  if (feature !== null && feature !== void 0 && (_feature$properties = feature.properties) !== null && _feature$properties !== void 0 && (_feature$properties = _feature$properties.state) !== null && _feature$properties !== void 0 && _feature$properties.state) {
    var state = feature.properties.state.state; // convert from soil state to overall state
    var markerColor = stateColorCode[state].markerColor;
    opts.markerColor = markerColor;
    opts.iconColor = 'white';
  }
  var markerIcon = L$1.VectorMarkers.icon({
    icon: 'icon-ranch',
    prefix: 'icon',
    markerColor: opts.markerColor,
    iconColor: opts.iconColor,
    dataTestId: feature === null || feature === void 0 || (_feature$properties2 = feature.properties) === null || _feature$properties2 === void 0 ? void 0 : _feature$properties2.id,
    selected: false,
    selectedClass: ''
  });
  if (mapVar) {
    marker = prepareGlMarker(markerIcon === null || markerIcon === void 0 ? void 0 : markerIcon.options, feature, latlng, mapVar, onClick);
  }
  if (!mapVar) {
    // eslint-disable-next-line new-cap
    marker = new L$1.marker(latlng, {
      icon: markerIcon
    });
  }
  return marker;
}

function LogoutRedirect() {
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    processing = _useState2[0],
    setProcessing = _useState2[1];
  var dispatch = useDispatch();
  useEffect(function () {
    authService.logout(dispatch).then(function () {
      setProcessing(false);
    });
  }, [setProcessing, dispatch]);
  if (processing) return null;
  return /*#__PURE__*/React.createElement(Redirect, {
    to: "/"
  });
}

var changePassword = userApi.changePassword;
var layout = {
  labelCol: {
    span: 12
  },
  wrapperCol: {
    span: 16
  }
};
var tailLayout = {
  wrapperCol: {
    offset: 12,
    span: 16
  }
};
function ChangePasswordPage() {
  var history = useHistory();
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    alertData = _useState2[0],
    setAlertData = _useState2[1];
  function onFinish(_x) {
    return _onFinish.apply(this, arguments);
  }
  function _onFinish() {
    _onFinish = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(values) {
      var currentPassword, newPassword, response, _response, status;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            currentPassword = values.currentPassword, newPassword = values.newPassword;
            if (!(currentPassword === newPassword)) {
              _context.next = 4;
              break;
            }
            setAlertData({
              message: t('New password can not be same as the old password.'),
              type: 'error'
            });
            return _context.abrupt("return");
          case 4:
            _context.prev = 4;
            _context.next = 7;
            return changePassword(currentPassword, newPassword);
          case 7:
            response = _context.sent;
            if (response.status === 200) {
              setAlertData({
                message: t('Password changed'),
                type: 'success'
              });
              form.resetFields();
              setTimeout(function () {
                history.push('/logout');
              }, 1500);
            }
            _context.next = 16;
            break;
          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](4);
            _response = _context.t0.response;
            status = _response.status;
            if (status === 400) {
              setAlertData({
                message: t('Incorrect password'),
                type: 'error'
              });
            } else {
              setAlertData({
                message: t('Failed to change password'),
                type: 'error'
              });
            }
          case 16:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[4, 11]]);
    }));
    return _onFinish.apply(this, arguments);
  }
  function renderAlert() {
    if (!alertData) return null;
    var message = alertData.message,
      type = alertData.type;
    return /*#__PURE__*/React.createElement(Form.Item, {
      wrapperCol: {
        span: 28
      }
    }, /*#__PURE__*/React.createElement(Alert, {
      message: message,
      type: type,
      showIcon: true
    }));
  }
  return /*#__PURE__*/React.createElement(Form, _extends({
    className: "change-password-form",
    onFinish: onFinish,
    form: form
  }, layout), renderAlert(), /*#__PURE__*/React.createElement(Form.Item, {
    name: "currentPassword",
    label: t('Current Password'),
    rules: [{
      required: true,
      message: t('Please input your current password')
    }]
  }, /*#__PURE__*/React.createElement(Input.Password, {
    placeholder: t('Current Password'),
    autoComplete: "current-password"
  })), /*#__PURE__*/React.createElement(Form.Item, {
    name: "newPassword",
    label: t('New Password'),
    rules: [{
      required: true,
      message: t('Please input your new password')
    }]
  }, /*#__PURE__*/React.createElement(Input.Password, {
    placeholder: t('New Password'),
    autoComplete: "new-password"
  })), /*#__PURE__*/React.createElement(Form.Item, {
    name: "confirmNewPassword",
    dependencies: ['newPassword'],
    label: t('Confirm New Password'),
    rules: [{
      required: true,
      message: t('Please enter your new password again')
    }, function (_ref) {
      var getFieldValue = _ref.getFieldValue;
      return {
        validator: function validator(_, value) {
          if (!value || getFieldValue('newPassword') === value) {
            return Promise.resolve();
          }
          return Promise.reject(Error('The two passwords that you entered do not match!'));
        }
      };
    }]
  }, /*#__PURE__*/React.createElement(Input.Password, {
    placeholder: t('Confirm New Password'),
    autoComplete: "new-password"
  })), /*#__PURE__*/React.createElement(Form.Item, tailLayout, /*#__PURE__*/React.createElement(Button, {
    type: "primary",
    htmlType: "submit",
    className: "change-password-button",
    "data-test-id": "change-password-submit"
  }, t('Change Password'))));
}

// Class component created as per the link
// https://dhtmlx.com/blog/use-dhtmlx-scheduler-component-react-js-library-demo/
var _window$1 = window,
  scheduler$1 = _window$1.scheduler,
  dhtmlXTooltip$1 = _window$1.dhtmlXTooltip;
var Timeline = /*#__PURE__*/function (_Component) {
  function Timeline(props) {
    var _this;
    _classCallCheck(this, Timeline);
    _this = _callSuper(this, Timeline, [props]);
    _this.state = {
      intervalId: null,
      spanID: null,
      timeoutId: null
    };
    return _this;
  }
  _inherits(Timeline, _Component);
  return _createClass(Timeline, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$state = this.state,
        intervalId = _this$state.intervalId,
        timeoutId = _this$state.timeoutId,
        spanID = _this$state.spanID;
      this.createConfig();
      if (intervalId) {
        clearInterval(intervalId);
      }
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      if (spanID) {
        this.deleteCurrentDateIndicator();
      }
      this.customEventTextStyles();
      this.updateCurrentDateIndicator();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
        blocks = _this$props.blocks,
        scheduleData = _this$props.scheduleData,
        config = _this$props.config;
      var hasBlocksChanged = JSON.stringify(prevProps.blocks) !== JSON.stringify(blocks);

      // set the 1st day of the week
      if (config.x_length > 14) {
        scheduler$1.config.start_on_monday = true;
      } else {
        scheduler$1.config.start_on_monday = false;
      }
      scheduler$1.clearAll();
      if (hasBlocksChanged || scheduleData && scheduleData.length) {
        this.redrawChart();
      }
      this.customEventTextStyles();
      if (hasBlocksChanged) {
        this.deleteCurrentDateIndicator();
        this.updateCurrentDateIndicator();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this$state2 = this.state,
        intervalId = _this$state2.intervalId,
        timeoutId = _this$state2.timeoutId;
      if (intervalId) {
        clearInterval(intervalId);
      }
      if (timeoutId) {
        clearTimeout(timeoutId);
        this.setState({
          intervalId: null
        });
      }
      this.deleteCurrentDateIndicator();
    }
  }, {
    key: "currentDateIndicator",
    value: function currentDateIndicator() {
      var _this$props2 = this.props,
        scheduleData = _this$props2.scheduleData,
        initDate = _this$props2.initDate,
        blocks = _this$props2.blocks;
      moment.locale('en');

      // current date indicator
      var spanID = scheduler$1.addMarkedTimespan({
        start_date: new Date(),
        end_date: new Date(),
        html: "<span id=\"currTime\" class=\"currTime\">".concat(moment().format('YYYY-MM-DD HH:mm'), "</span>"),
        css: 'column_selection',
        type: 'indicator',
        sections: {
          timeline: scheduleData[0] ? [scheduleData[0].section_id] : [blocks[0]]
        }
      });
      this.setState({
        spanID: spanID
      });
      scheduler$1.setCurrentView(initDate);
    }
  }, {
    key: "deleteCurrentDateIndicator",
    value: function deleteCurrentDateIndicator() {
      var spanID = this.state.spanID;
      if (spanID) {
        scheduler$1.deleteMarkedTimespan(spanID);
      }
    }
  }, {
    key: "updateCurrentDateIndicator",
    value: function updateCurrentDateIndicator() {
      this.currentDateIndicator();
      var d = new Date();
      d.setTime(d.getTime() + 60000);
      var dms = d.getMilliseconds();
      var dh = d.getHours();
      var dm = d.getMinutes();
      var intervalTime = new Date().setHours(dh, dm, 0, dms) - new Date();
      var temp = this;
      var timeoutId = setTimeout(function () {
        temp.deleteCurrentDateIndicator();
        temp.currentDateIndicator();
        scheduler$1.updateView();
        var intervalId = setInterval(function () {
          temp.deleteCurrentDateIndicator();
          temp.currentDateIndicator();
          scheduler$1.updateView();
        }, 60000);
        temp.setState({
          intervalId: intervalId
        });
      }, intervalTime);
      temp.setState({
        timeoutId: timeoutId
      });
    }

    /*
    * Display text when event length is > 4 hours
    * for any screen above 14 inch (i.e. chart container width
    * > 1026 with sidebar ON).
    *
    * OR event length is > 7 hours for 14 inch screen(chart
    * container width = 1026)
    *
    * OR event length is > 9 hours for all tablet
    * screens (anything below 14 inch screen)
    *
    * These condition will make sure to show text with
    * atleast 3 digits in decimal number clearly
    *
    * If number of hours is increased,
    * more event bars will be empty and if reduced,
    * more event bars will display text
    *
    */
  }, {
    key: "customEventTextStyles",
    value: function customEventTextStyles() {
      var initDate = this.props.initDate;
      scheduler$1.templates.event_bar_text = function (startTime, endTime, ev) {
        var duration = null;
        var actualDuration = moment.duration(moment(endTime).diff(moment(startTime)));
        if (moment(startTime).isBefore(initDate)) {
          // special case when long event ending at
          // beginning of current date range
          duration = moment.duration(moment(endTime).diff(moment(initDate)));
        } else {
          duration = actualDuration;
        }
        var eventHours = duration.asHours();
        var divElem = document.getElementById('scheduler-container');
        var containerWidth;
        if (divElem) containerWidth = divElem.clientWidth;
        var displayText = Number(eventHours) > 4 && containerWidth > 1026 || Number(eventHours) > 7 && containerWidth === 1026 || Number(eventHours) > 9;
        return "<span class=".concat(Number(actualDuration) >= 10 ? 'event_text' : '', " id=").concat(ev.bid, ">\n        ").concat(displayText ? ev.text : '', "</span>");
      };
      scheduler$1.setCurrentView(initDate);
    }
  }, {
    key: "redrawChart",
    value: function redrawChart() {
      var _this$props3 = this.props,
        config = _this$props3.config,
        initDate = _this$props3.initDate,
        scheduleData = _this$props3.scheduleData;
      var timeline = scheduler$1.getView();
      timeline.x_date = config.x_date;
      timeline.x_unit = config.x_unit;
      timeline.x_length = config.x_length;
      timeline.x_start = config.x_start;
      timeline.x_size = config.x_size;
      timeline.second_scale = config.second_scale;
      timeline.y_unit = config.y_unit;
      scheduler$1.createTimelineView(timeline);
      scheduler$1.setCurrentView(initDate);
      scheduler$1.parse(scheduleData, 'json');
    }
  }, {
    key: "createConfig",
    value: function createConfig() {
      var _this$props4 = this.props,
        initDate = _this$props4.initDate,
        scheduleData = _this$props4.scheduleData,
        config = _this$props4.config,
        onClickChart = _this$props4.onClickChart,
        t = _this$props4.t;
      scheduler$1.skin = 'material';
      scheduler$1.config.header = [];

      // x-axis scale height
      scheduler$1.xy.scale_height = 20;

      // Initial Config
      scheduler$1.createTimelineView(config);

      // Event handling
      scheduler$1.attachEvent('onEmptyClick', function (date, e) {
        if (!e.target.innerHTML) {
          onClickChart({
            blockId: scheduler$1.getActionData(e).section,
            startDate: moment(date).format('YYYY-MM-DD HH:mm')
          });
        }
      });

      // onclick event on created schedule
      scheduler$1.attachEvent('onClick', function (id, e) {
        var eventObj = scheduler$1.getEvent(id);
        onClickChart({
          blockId: scheduler$1.getActionData(e).section,
          scheduleId: parseInt(id, 10),
          eventIndex: eventObj && eventObj.event_index
        });
        dhtmlXTooltip$1.hide();
        return true;
      });

      // disable drag feature
      scheduler$1.attachEvent('onBeforeDrag', function () {
        return false;
      });

      // Timeline custom config
      scheduler$1.config.xml_date = '%Y-%m-%d %h:%i';
      // drag event
      scheduler$1.config.drag_event_body = false;

      // resize the created event
      scheduler$1.config.drag_resize = false;

      // current date indicator line
      scheduler$1.config.mark_now = true;
      scheduler$1.config.full_day = true;
      scheduler$1.config.drag_move = false;
      scheduler$1.config.drag_resize = false;
      scheduler$1.locale.labels.timeline_scale_header = t('Blocks');

      // configure the timeline after it's created
      scheduler$1.config.dblclick_create = false;
      scheduler$1.locale.labels.icon_myicon = 'Text';
      scheduler$1.config.multisection = true;

      // Tooltip
      dhtmlXTooltip$1.config.className = 'dhtmlXTooltip tooltip';
      dhtmlXTooltip$1.config.timeout_to_display = 0;
      dhtmlXTooltip$1.config.timeout_to_hide = 10;
      dhtmlXTooltip$1.config.delta_x = 15;
      dhtmlXTooltip$1.config.delta_y = -20;
      var format = scheduler$1.date.date_to_str('%Y-%m-%d %H:%i');
      scheduler$1.templates.tooltip_text = function (start, end, event) {
        return "".concat(event.name, "<br/>").concat(t('Event'), ":\n     ").concat(event.text, "<br/>").concat(t('From'), ": ").concat(format(start), "<br/>").concat(t('To'), ":  ").concat(format(end), "<br/>").concat(t('Total runtime (in view)'), ":");
      };

      // To set position for tooltip based on event id
      scheduler$1.onMouseMoveEventId = 0;
      scheduler$1.attachEvent('onMouseMove', function (id, e) {
        if (scheduler$1.onMouseMoveEventId !== id) {
          scheduler$1.onMouseMoveEventId = id;
          scheduler$1.clientX = e.clientX;
          scheduler$1.clientY = e.clientY;
        }
      });

      // Inbuilt function to set position
      dhtmlXTooltip$1.position = function (e) {
        return {
          x: scheduler$1.clientX || e.clientX,
          y: scheduler$1.clientY || e.clientY
        };
      };

      // Initialization schedule container
      scheduler$1.init(this.schedulerContainer, initDate, 'timeline');

      // Loading Data
      scheduler$1.parse(scheduleData, 'json');
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      return /*#__PURE__*/React.createElement("div", {
        ref: function ref(input) {
          _this2.schedulerContainer = input;
        },
        style: {
          width: '100%',
          height: '100%'
        }
      });
    }
  }]);
}(Component);
Timeline.propTypes = {
  config: PropTypes.shape({
    x_date: PropTypes.string,
    x_length: PropTypes.number,
    x_unit: PropTypes.string,
    y_unit: PropTypes.arrayOf(PropTypes.any),
    x_start: PropTypes.number,
    x_size: PropTypes.number,
    second_scale: PropTypes.shape({})
  }),
  scheduleData: PropTypes.arrayOf(PropTypes.any),
  initDate: PropTypes.shape({}),
  onClickChart: PropTypes.func,
  blocks: PropTypes.arrayOf(PropTypes.any),
  t: PropTypes.func
};
Timeline.defaultProps = {
  config: {},
  scheduleData: [],
  initDate: null,
  onClickChart: function onClickChart() {
    return null;
  },
  blocks: []
};

function Schedule(props) {
  var dates = props.dates,
    blocks = props.blocks,
    onClickChart = props.onClickChart,
    scheduleData = props.scheduleData;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var selectClientTimeFormat = selectors.selectClientTimeFormat;
  var timeFormat = useSelector(selectClientTimeFormat);
  function getDateFormat(viewType, timeFormat) {
    var _formats$viewType, _formats$viewType2;
    var formats = {
      hour: {
        "default": '%H:%i'
      },
      day: {
        'YYYY/MM/DD': '%Y %m/%d',
        "default": '%d %M %Y'
      },
      week: {
        'YYYY/MM/DD': '%d/%m',
        "default": '%d %M'
      },
      month: {
        "default": '%d'
      },
      secondScale: {
        day: {
          'YYYY/MM/DD': '%d/%m %Y',
          "default": '%d %M %Y'
        },
        week: {
          "default": "".concat(t('Week'), " %W")
        }
      }
    };
    return ((_formats$viewType = formats[viewType]) === null || _formats$viewType === void 0 ? void 0 : _formats$viewType[timeFormat]) || ((_formats$viewType2 = formats[viewType]) === null || _formats$viewType2 === void 0 ? void 0 : _formats$viewType2["default"]) || '';
  }

  // x-axis config
  function getXaxisConfig(daterange) {
    var _getDateFormat;
    var dateDiff = 0;
    var startMoment = moment().locale('en');
    if (daterange && daterange.length) {
      dateDiff = daterange[1].diff(daterange[0], 'day');
      startMoment = moment(daterange[0]).locale('en');
    }
    var rangeSize = dateDiff + 1;
    var obj = {
      x_size: rangeSize,
      x_start: 0,
      x_length: rangeSize,
      x_unit: 'day',
      x_date: getDateFormat('day', timeFormat),
      second_scale: {
        x_unit: 'week',
        x_date: ((_getDateFormat = getDateFormat('secondScale', timeFormat)) === null || _getDateFormat === void 0 ? void 0 : _getDateFormat.week) || "".concat(t('Week'), " %W")
      }
    };
    var initDate = startMoment.clone();
    if (dateDiff > 7 && dateDiff <= 14) {
      var _getDateFormat2;
      initDate = startMoment.clone().startOf('week');
      obj.x_size = dateDiff + 1;
      obj.x_length = dateDiff + 1;
      obj.x_date = getDateFormat('week', timeFormat);
      obj.second_scale = {
        x_unit: 'week',
        x_date: ((_getDateFormat2 = getDateFormat('secondScale', timeFormat)) === null || _getDateFormat2 === void 0 ? void 0 : _getDateFormat2.week) || "".concat(t('Week'), " %W")
      };
    } else if (dateDiff > 14) {
      initDate = startMoment.clone().startOf('month');
      obj.x_size = dateDiff + 1;
      obj.x_length = dateDiff + 1;
      obj.x_date = getDateFormat('month', timeFormat);
    }
    if (!dateDiff) {
      var _getDateFormat3;
      initDate = startMoment.clone();
      var hourDiff = daterange[1].diff(daterange[0], 'hour');
      obj.x_size = hourDiff + 1;
      obj.x_start = 0;
      obj.x_length = hourDiff + 1;
      obj.x_unit = 'hour';
      obj.x_date = getDateFormat('hour', timeFormat);
      obj.second_scale = {
        x_unit: 'day',
        x_date: ((_getDateFormat3 = getDateFormat('secondScale', timeFormat)) === null || _getDateFormat3 === void 0 ? void 0 : _getDateFormat3.day) || getDateFormat('day', timeFormat)
      };
    } else {
      initDate = startMoment.clone().startOf('day');
    }
    return {
      configObj: obj,
      initDate: initDate.toDate()
    };
  }
  var callFunc = getXaxisConfig(dates);

  // Actual config to pass as props
  var config = _objectSpread2(_objectSpread2({
    name: 'timeline'
  }, callFunc.configObj), {}, {
    y_unit: scheduleData.sections,
    fit_events: true,
    y_property: 'section_id',
    render: 'bar',
    dy: 100,
    dx: 130,
    event_dy: 'full',
    section_autoheight: true,
    sort: function sort(a, b) {
      if (a.irrId > b.irrId) {
        return -1;
      }
      if (a.irrId < b.irrId) {
        return 1;
      }
      // https://docs.dhtmlx.com/scheduler/timeline_view.html -> Sorting events
      return +a.start_date > +b.start_date ? 1 : -1;
    }
  });
  function getClass(daterange) {
    var dateDiff = daterange[1].diff(daterange[0], 'day');
    var styleStr = '';
    if (dateDiff > 7 && dateDiff <= 14) {
      styleStr = 'twoweeks-mode';
    } else if (dateDiff > 14) {
      styleStr = 'month-mode';
    } else if (!dateDiff) {
      styleStr = 'day-mode';
    } else if (dateDiff && dateDiff <= 7) {
      styleStr = 'week-mode';
    }
    return styleStr;
  }
  var customClass = getClass(dates);
  return /*#__PURE__*/React.createElement("div", {
    className: "scheduler-container ".concat(customClass),
    id: "scheduler-container"
  }, /*#__PURE__*/React.createElement(Timeline, {
    config: config,
    scheduleData: scheduleData.data,
    initDate: callFunc.initDate,
    onClickChart: onClickChart,
    blocks: blocks,
    t: t
  }));
}
Schedule.propTypes = {
  blocks: PropTypes.arrayOf(PropTypes.any),
  dates: PropTypes.arrayOf(PropTypes.any),
  onClickChart: PropTypes.func,
  scheduleData: PropTypes.shape({
    data: PropTypes.arrayOf(PropTypes.any),
    sections: PropTypes.arrayOf(PropTypes.any)
  })
};
Schedule.defaultProps = {
  blocks: null,
  dates: null,
  onClickChart: function onClickChart() {
    return null;
  },
  scheduleData: {
    data: [],
    sections: []
  }
};

// Class component created as per the link
// https://dhtmlx.com/blog/use-dhtmlx-scheduler-component-react-js-library-demo/
var _window = window,
  scheduler = _window.scheduler,
  dhtmlXTooltip = _window.dhtmlXTooltip;
var SWIPE_SIZE = 40;
var EventCalendar = /*#__PURE__*/function (_Component) {
  function EventCalendar() {
    _classCallCheck(this, EventCalendar);
    return _callSuper(this, EventCalendar, arguments);
  }
  _inherits(EventCalendar, _Component);
  return _createClass(EventCalendar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
        scheduleData = _this$props.scheduleData,
        schedulerObject = _this$props.schedulerObject,
        onModechange = _this$props.onModechange,
        hourFormat = _this$props.hourFormat,
        onClickChart = _this$props.onClickChart;
      this.getHeader();
      var schedulerMode = schedulerObject.schedulerMode,
        schedulerStartDate = schedulerObject.schedulerStartDate;
      scheduler.skin = 'material';
      scheduler.config.hour_date = hourFormat;
      scheduler.xy.min_event_height = 1;
      scheduler.xy.scale_width = 20;
      var height = document.querySelector('.scheduler-container-mobile');
      // 500 is min-height of chart container
      var screenHeight = window.screen.availHeight;
      if (height && height.clientHeight >= 500) {
        scheduler.chartDivHeight = height.clientHeight;
      } else if (!scheduler.chartDivHeight && screenHeight !== window.innerHeight) {
        scheduler.chartDivHeight = screenHeight - Math.round(screenHeight * 0.33);
      } else {
        scheduler.chartDivHeight = window.innerHeight - Math.round(window.innerHeight * 0.25);
      }

      // 83 is height of chart x-scale
      scheduler.config.hour_size_px = (scheduler.chartDivHeight - 83) / 24;
      scheduler.config.all_timed = true;
      scheduler.config.icons_select = ['icon_details', 'icon_edit'];
      scheduler.attachEvent('onBeforeLightbox', function () {
        return false;
      });
      scheduler.attachEvent('onBeforeTooltip', function () {
        return false;
      });
      scheduler.templates.event_class = function () {
        return 'my_event';
      };
      scheduler.xy.scale_height = 40;
      scheduler.xy.nav_height = 40;
      scheduler.config.start_on_monday = false;
      scheduler.config.touch_swipe_dates = true;
      var headerDate = scheduler.date.date_to_str('%F');
      var formatMonthScale = scheduler.date.date_to_str('%D');
      var formatDayScale = scheduler.date.date_to_str('%l, %F %j, %Y');
      scheduler.xy.menu_width = 0;
      // drag event
      scheduler.config.drag_event_body = false;
      // resize the created event
      scheduler.config.drag_resize = false;
      scheduler.config.drag_move = false;
      scheduler.config.drag_create = false;
      scheduler.config.drag_lightbox = false;
      scheduler.config.touch_tip = false;
      scheduler.config.touch_tooltip = false;
      scheduler.config.dblclick_create = false;
      scheduler.config.detail_on_dblclick = false;
      scheduler.onEmptyClick = scheduler.attachEvent('onEmptyClick', function (date) {
        scheduler.detachEvent(scheduler.onClick);
        var _scheduler$getState = scheduler.getState(),
          mode = _scheduler$getState.mode;
        if (mode === 'day' || mode === 'week') {
          onClickChart({
            blockId: [],
            startDate: moment(date).format('YYYY-MM-DD HH:mm')
          });
          onModechange({
            mode: mode,
            date: date
          });
        } else {
          onModechange({
            mode: 'day',
            date: date
          });
          scheduler.setCurrentView(date, 'day');
        }
      });
      scheduler.attachEvent('onClick', function (id) {
        var eventObj = scheduler.getEvent(id);
        onClickChart(eventObj);
        return true;
      });

      // remove text for week scheduleData
      scheduler.templates.event_header = function (start, end, event) {
        var _scheduler$getState2 = scheduler.getState(),
          mode = _scheduler$getState2.mode;
        if (mode === 'day') {
          var diff = moment.duration(moment(end).diff(moment(start))).asHours();
          if (diff >= 1) {
            return event.text;
          }
        }
        return '';
      };
      scheduler.templates.day_scale_date = function (date) {
        return formatDayScale(date);
      };

      // Week View
      scheduler.templates.week_date = function (date) {
        if (scheduler.getState().mode === 'week') {
          scheduler.detachEvent(scheduler.onClick);
        }
        return headerDate(date);
      };

      // Day View
      scheduler.templates.day_date = function (date) {
        if (scheduler.getState().mode === 'day') {
          scheduler.detachEvent(scheduler.onClick);
        }
        return headerDate(date);
      };

      // Month View
      scheduler.templates.month_date = function (date) {
        document.querySelector('.dhx_minical_icon').style.display = 'none';
        if (scheduler.getState().mode === 'month') {
          scheduler.detachEvent(scheduler.onClick);
          scheduler.onClick = scheduler.attachEvent('onClick', function (id) {
            if (scheduler.getState().mode === 'month') {
              var eventObj = scheduler.getEvent(id);
              var sDate = eventObj.start_date;
              onModechange({
                mode: 'day',
                sDate: sDate
              });
              scheduler.setCurrentView(new Date(eventObj.start_date), 'day');
            }
          });
        }
        return headerDate(date);
      };
      scheduler.templates.month_scale_date = function monthScaleDate(date) {
        return formatMonthScale(date)[0];
      };
      scheduler.attachEvent('onBeforeViewChange', function () {
        scheduler.deleteMarkedTimespan();
        return true;
      });
      function addEvCount() {
        var startDate = scheduler.getState().min_date;
        var endMonthDate = scheduler.getState().max_date;
        while (startDate.getTime() < endMonthDate.getTime()) {
          var endDayDate = scheduler.date.add(startDate, 1, 'day');
          var evs = scheduler.getEvents(startDate, endDayDate);
          if (evs.length) {
            scheduler.addMarkedTimespan({
              start_date: startDate,
              end_date: endDayDate,
              html: "<div style=\"text-align:center;\"><b>".concat(evs.length, "</b><svg height=\"30px\" width=\"30px\"  fill=\"#1890ff\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" version=\"1.1\" x=\"0px\" y=\"0px\" viewBox=\"0 0 100 100\" enable-background=\"new 0 0 100 100\" xml:space=\"preserve\"><path d=\"M82.66,62.34C82.66,80.378,68.037,95,50,95c-18.038,0-32.66-14.622-32.66-32.66C17.34,34.309,50,5,50,5  S82.66,34.309,82.66,62.34z\"></path></svg></div>")
            });
          }
          startDate = endDayDate;
        }
        scheduler.updateView();
      }
      scheduler.attachEvent('onViewChange', function (newMode) {
        if (newMode === 'month') {
          addEvCount();
        }
      });
      scheduler.filter_month = function () {
        return false;
      };
      scheduler.templates.event_bar_date = function () {
        return '';
      };
      var dateFormat = scheduler.date.date_to_str('%j');
      var formatweekScale = scheduler.date.date_to_str('%D');
      scheduler.templates.week_scale_date = function (date) {
        var today = scheduler.date.date_part(new Date());
        if (date.valueOf() === today.valueOf()) {
          return " <div><span>".concat(formatweekScale(date)[0], "<span>\n        <br>\n        <span\n        style='border-radius: 50%;\n        justify-content: center;\n        background: #1890ff;\n        border: 1px solid #1890ff;\n        color: white;\n        display:flex;\n        align-items:center;\n        height: 22px;\n        width: 22px;'\n        >").concat(dateFormat(date), "</span></div>");
        }
        return " <div><span>".concat(formatweekScale(date)[0], "<span><br>\n      <span>").concat(dateFormat(date), "</span></div>");
      };
      scheduler.init(this.schedulerContainer, new Date(moment(schedulerStartDate)), schedulerMode);
      scheduler.clearAll();
      scheduler.parse(scheduleData);
      scheduler.config.max_month_events = 1;

      // Below code for add swipe events to chart area and set values to state
      var xStart = null;
      var xEnd = null;
      var yStart = null;
      var yEnd = null;
      scheduler.touchStart = function handleTouchStart(evt) {
        xStart = evt.targetTouches[0].clientX;
        yStart = evt.targetTouches[0].clientY;
      };
      scheduler.touchMove = function handleTouchMove(evt) {
        xEnd = evt.targetTouches[0].clientX;
        yEnd = evt.targetTouches[0].clientY;
      };
      scheduler.touchEnd = function handleTouchEnd() {
        var _scheduler$getState3 = scheduler.getState(),
          mode = _scheduler$getState3.mode;
        var xScale = xStart - xEnd;
        var yScale = yStart - yEnd;
        // SWIPE_SIZE is the optimized swipe length
        if (xStart && xEnd && xScale > SWIPE_SIZE && xScale > yScale) {
          // Left swipe
          var newDate = moment(scheduler.currDate).add(1, mode);
          onModechange({
            date: newDate,
            mode: mode
          });
        }
        if (xStart && xEnd && xScale < -SWIPE_SIZE && xScale < -yScale) {
          // Right swipe
          var _newDate = moment(scheduler.currDate).subtract(1, mode);
          onModechange({
            date: _newDate,
            mode: mode
          });
        }

        // Reset values
        xStart = null;
        xEnd = null;
        yStart = null;
        yEnd = null;
      };

      // Adding listeners
      this.addTouchEvent();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      // Remove listeners
      this.removeTouchEvent();

      // 83 is height of chart x-scale
      if (scheduler.chartDivHeight) {
        scheduler.config.hour_size_px = (scheduler.chartDivHeight - 83) / 24;
      }
      scheduler.detachEvent(scheduler.onClick);
      scheduler.clearAll();
      var allEvents = scheduler.getEvents();
      var allSectionIds = allEvents.map(function (item) {
        return item.section_id;
      }).filter(function (v, i, a) {
        return a.indexOf(v) === i;
      });
      var _this$props2 = this.props,
        scheduleData = _this$props2.scheduleData,
        schedulerObject = _this$props2.schedulerObject;
      var schedulerMode = schedulerObject.schedulerMode,
        schedulerStartDate = schedulerObject.schedulerStartDate;
      var newSectionIds = scheduleData.map(function (item) {
        return item.section_id;
      }).filter(function (v, i, a) {
        return a.indexOf(v) === i;
      });
      if (newSectionIds.length > 0) {
        var idsToDelete = allSectionIds.filter(function (element) {
          return !newSectionIds.includes(element);
        });
        var eventsToDelete = allEvents.filter(function (d) {
          return d.section_id === idsToDelete[0];
        });
        if (idsToDelete.length === 1) {
          for (var i = 0; i < eventsToDelete.length; i += 1) {
            scheduler.deleteEvent(eventsToDelete[i].id, true);
          }
        }
      }
      scheduler.init(this.schedulerContainer, new Date(moment(schedulerStartDate)), schedulerMode);
      this.getHeader();
      scheduler.parse(scheduleData);
      scheduler.render();
      scheduler.attachEvent('onBeforeViewChange', function () {
        scheduler.deleteMarkedTimespan();
        return true;
      });

      // Adding listeners
      this.addTouchEvent();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      dhtmlXTooltip.hide();
      scheduler.detachEvent(scheduler.onEmptyClick);
      scheduler.detachEvent(scheduler.onClick);
      scheduler.chartDivHeight = 0;
    }
  }, {
    key: "setTimeFormat",
    value: function setTimeFormat() {
      var hourFormat = this.props.hourFormat;
      scheduler.config.hour_date = hourFormat;
      scheduler.templates.hour_scale = scheduler.date.date_to_str(scheduler.config.hour_date);
    }
  }, {
    key: "getHeader",
    value: function getHeader() {
      var _this$props3 = this.props,
        schedulerObject = _this$props3.schedulerObject,
        onModechange = _this$props3.onModechange;
      var schedulerMode = schedulerObject.schedulerMode;
      function customModeChange(mode) {
        onModechange({
          mode: mode,
          date: scheduler.getState().date
        });
      }
      scheduler.config.header = [{
        html: "<text class=".concat(schedulerMode === 'day' ? 'selected' : '', ">day</text>"),
        click: function click() {
          customModeChange('day');
        }
      }, {
        html: "<text class=".concat(schedulerMode === 'week' ? 'selected' : '', ">week</text>"),
        click: function click() {
          customModeChange('week');
        }
      }, {
        html: "<text class=".concat(schedulerMode === 'month' ? 'selected' : '', ">month</text>"),
        click: function click() {
          customModeChange('month');
        }
      }, {
        view: 'minicalendar',
        click: function click() {
          if (scheduler.isCalendarVisible()) {
            scheduler.destroyCalendar();
          } else {
            scheduler.renderCalendar({
              position: this,
              date: scheduler.getState().date,
              navigation: true,
              handler: function handler(date) {
                scheduler.setCurrentView(date);
                scheduler.destroyCalendar();
              }
            });
          }
        }
      }, 'date'];
    }
  }, {
    key: "addTouchEvent",
    value: function addTouchEvent() {
      if (this.schedulerContainer) {
        var divElem = this.schedulerContainer.lastChild;
        divElem.addEventListener('touchstart', scheduler.touchStart, false);
        divElem.addEventListener('touchmove', scheduler.touchMove, false);
        divElem.addEventListener('touchend', scheduler.touchEnd, false);
      }
    }
  }, {
    key: "removeTouchEvent",
    value: function removeTouchEvent() {
      if (this.schedulerContainer) {
        var divElem = this.schedulerContainer.lastChild;
        divElem.removeEventListener('touchstart', scheduler.touchStart, false);
        divElem.removeEventListener('touchmove', scheduler.touchMove, false);
        divElem.removeEventListener('touchend', scheduler.touchEnd, false);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;
      var schedulerObject = this.props.schedulerObject;
      var schedulerStartDate = schedulerObject.schedulerStartDate;
      scheduler.currDate = schedulerStartDate;
      this.setTimeFormat();
      return /*#__PURE__*/React.createElement("div", {
        ref: function ref(input) {
          _this.schedulerContainer = input;
        },
        style: {
          width: '100%',
          height: '100%'
        }
      });
    }
  }]);
}(Component);
EventCalendar.propTypes = {
  scheduleData: PropTypes.arrayOf(PropTypes.any),
  hourFormat: PropTypes.string,
  onClickChart: PropTypes.func,
  schedulerObject: PropTypes.shape({
    schedulerMode: PropTypes.string,
    schedulerStartDate: PropTypes.any
  }),
  onModechange: PropTypes.func
};
EventCalendar.defaultProps = {
  scheduleData: null,
  hourFormat: '',
  onClickChart: function onClickChart() {
    return null;
  },
  schedulerObject: {},
  onModechange: function onModechange() {
    return null;
  }
};

var initialMobileScheduler = {
  schedulerMode: 'week',
  schedulerStartDate: new Date()
};
function SchedulerMobile(props) {
  var dates = props.dates,
    onClickChart = props.onClickChart,
    scheduleData = props.scheduleData,
    is24Hour = props.is24Hour;
  var hourFormat = is24Hour ? '%G' : '%g';
  var _useState = useState(initialMobileScheduler),
    _useState2 = _slicedToArray(_useState, 2),
    mobileScheduler = _useState2[0],
    setMobileScheduler = _useState2[1];
  function onModeChange(obj) {
    var mode = obj.mode,
      date = obj.date;
    var dataObj = {
      schedulerMode: mode,
      schedulerStartDate: new Date(date)
    };
    setMobileScheduler(dataObj);
    props.setScheduler(dataObj);
    props.onModeChange(obj);
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "scheduler-container-mobile"
  }, /*#__PURE__*/React.createElement(EventCalendar, {
    scheduleData: scheduleData,
    dates: dates,
    hourFormat: hourFormat,
    onClickChart: onClickChart,
    schedulerObject: mobileScheduler,
    onModechange: onModeChange
  }));
}
SchedulerMobile.propTypes = {
  dates: PropTypes.arrayOf(PropTypes.any),
  onClickChart: PropTypes.func,
  colorObj: PropTypes.shape({}),
  scheduleData: PropTypes.arrayOf(PropTypes.any),
  is24Hour: PropTypes.bool,
  onModeChange: PropTypes.func,
  setScheduler: PropTypes.func
};
SchedulerMobile.defaultProps = {
  dates: null,
  onClickChart: function onClickChart() {
    return null;
  },
  colorObj: {},
  scheduleData: [],
  is24Hour: true,
  onModeChange: function onModeChange() {
    return null;
  },
  setScheduler: function setScheduler() {
    return null;
  }
};

var styles$1 = {"entity-header":"RanchBlockStyles_entity-header__-bdeO","ranch-header":"RanchBlockStyles_ranch-header__3mQHa","block-header":"RanchBlockStyles_block-header__Ni1eQ","block-name":"RanchBlockStyles_block-name__3b-d9","select-all":"RanchBlockStyles_select-all__lXuLK","ant-typography":"RanchBlockStyles_ant-typography__vo-9V","no-block":"RanchBlockStyles_no-block__0WuvI","no-ranch":"RanchBlockStyles_no-ranch__v5AQ4","selected":"RanchBlockStyles_selected__wq8CS"};

var TreeNode = TreeSelect.TreeNode;
var Text = Typography.Text;
var mobileScreen = window.innerWidth < 599;
var setUrlLoad = actions.setUrlLoad;
var useEntityRanchBlock = hooks.useEntityRanchBlock;
function getTreeNode(tnValue, tnKey, tnName, titleKey, titleClass, titleContent, selectable, tnContent, tnId) {
  return /*#__PURE__*/React.createElement(TreeNode, {
    key: tnValue || tnKey,
    value: tnValue || tnKey,
    name: tnName,
    title: /*#__PURE__*/React.createElement(Text, {
      key: titleKey,
      id: tnId,
      className: titleClass
    }, titleContent),
    selectable: selectable
  }, tnContent);
}
function getClassName(id, index, selectedValue) {
  var stylestr = '';
  if (index % 2 && selectedValue && selectedValue === String(id)) {
    stylestr = "".concat(styles$1['block-header'], " ").concat(styles$1.selected);
  } else if (index % 2 && selectedValue && selectedValue !== String(id)) {
    stylestr = styles$1['block-header'];
  } else if (!(index % 2) && selectedValue && selectedValue === String(id)) {
    stylestr = "".concat(styles$1['block-name'], " ").concat(styles$1.selected);
  } else if (!(index % 2) && selectedValue && selectedValue !== String(id)) {
    stylestr = styles$1['block-name'];
  }
  return stylestr;
}
function getNoRanchTreeNode(data, t) {
  var expandKeys = [];
  var nrKey = "No_Ranch_".concat(data[0].id, "_").concat(data[0].name);
  expandKeys.push(nrKey);
  return {
    nodes: getTreeNode(null, nrKey, 'No Ranch', "No_Ranch_".concat(data[0].ranches.length, "_").concat(data[0].name), styles$1['no-ranch'], t('No Ranch'), false, undefined, "No_Ranch_".concat(data[0].id)),
    expandKeys: expandKeys
  };
}

// Returns TreeNodes and keys for blocks
function getBlockContent() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var rIndex = arguments.length > 1 ? arguments[1] : undefined;
  var selectedValue = arguments.length > 2 ? arguments[2] : undefined;
  var expandKeys = [];
  return {
    nodes: data.map(function (block, bIndex) {
      if (block && block.id) {
        var bKey = "".concat(block.id);
        expandKeys.push(bKey);
        return getTreeNode(bKey, null, block.name, "".concat(String(rIndex), "_").concat(block.id), getClassName(block.id, bIndex, selectedValue), block.name, true, undefined, "Block_".concat(block.id));
      }
      return null;
    }),
    expandKeys: expandKeys
  };
}

// Returns TreeNodes and keys for ranches and blocks
// It calls getBlockContent() to get block tree nodes
function getRanchContent() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var eId = arguments.length > 1 ? arguments[1] : undefined;
  var eIndex = arguments.length > 2 ? arguments[2] : undefined;
  var selectedValue = arguments.length > 3 ? arguments[3] : undefined;
  var t = arguments.length > 4 ? arguments[4] : undefined;
  var expandKeys = [];
  return {
    nodes: data.map(function (ranch, rIndex) {
      if (ranch && ranch.id) {
        var rKey = "".concat(eId, "_").concat(ranch.id);
        var blockTreeNodes = getBlockContent(ranch.blocks, rIndex, selectedValue);
        expandKeys.push(rKey);
        expandKeys = [].concat(_toConsumableArray(expandKeys), _toConsumableArray(blockTreeNodes.expandKeys));
        return getTreeNode(rKey, null, ranch.name, "".concat(eId, "_").concat(String(eIndex), "_").concat(ranch.id), selectedValue && [selectedValue].includes(String(ranch.id)) ? "".concat(styles$1['ranch-header'], " ").concat(styles$1.selected) : styles$1['ranch-header'], ranch.name, true, ranch.blocks.length ? blockTreeNodes.nodes : getTreeNode(null, "No_Block_".concat(String(eIndex), "_").concat(String(rIndex)), 'No Block', "".concat(String(eIndex), "_").concat(String(rIndex)), styles$1['no-block'], t('No Block'), false, undefined, "No_Block_".concat(String(eIndex), "_").concat(String(rIndex))), "Ranch_".concat(ranch.id));
      }
      return null;
    }),
    expandKeys: expandKeys
  };
}

// Returns TreeNodes and keys for entity, ranch, block
// It calls getRanchContent() to get ranch tree nodes
function getEntityLevelHierarchy() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var selectedValue = arguments.length > 1 ? arguments[1] : undefined;
  var t = arguments.length > 2 ? arguments[2] : undefined;
  var expandKeys = [];
  return {
    nodes: data.map(function (entity, eIndex) {
      if (entity && entity.id) {
        var eKey = "".concat(entity.name, "_").concat(entity.id, "_").concat(String(eIndex));
        var ranchTreeNodes = getRanchContent(entity.ranches, entity.id, eIndex, selectedValue, t);
        expandKeys.push(eKey);
        expandKeys = [].concat(_toConsumableArray(expandKeys), _toConsumableArray(ranchTreeNodes.expandKeys));
        return getTreeNode(null, eKey, entity.name, "".concat(entity.id, "_").concat(String(eIndex)), styles$1['entity-header'], entity.name, false, entity.ranches.length ? ranchTreeNodes.nodes : getTreeNode(null, "No_Ranch_".concat(entity.id, "_").concat(entity.name), 'No Ranch', "".concat(String(eIndex)), styles$1['no-ranch'], t('No Ranch'), false, undefined, "No_Ranch_".concat(entity.id, "_").concat(entity.name)), "Entity_".concat(entity.id));
      }
      return null;
    }),
    expandKeys: expandKeys
  };
}

// Returns TreeNodes and keys for single entity, ranch, block
function getRanchLevelHierarchy() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var selectedValue = arguments.length > 1 ? arguments[1] : undefined;
  var t = arguments.length > 2 ? arguments[2] : undefined;
  var expandKeys = [];
  return {
    nodes: data.map(function (ranch, rIndex) {
      if (ranch && ranch.id) {
        var rKey = "".concat(String(rIndex), "_").concat(ranch.id);
        var ranchTreeNodes = getRanchContent(data[0].ranches, data[0].id, 0, selectedValue, t);
        expandKeys.push(rKey);
        expandKeys = [].concat(_toConsumableArray(expandKeys), _toConsumableArray(ranchTreeNodes.expandKeys));
        return ranchTreeNodes.nodes;
      }
      return null;
    }),
    expandKeys: expandKeys
  };
}
function getCustomSelectOption(data, selectedValue, t) {
  var processedData = {};
  if (data && data.length) {
    if (data.length > 1) {
      processedData = getEntityLevelHierarchy(data, selectedValue, t);
    } else if (data[0] && data[0].ranches.length) {
      processedData = getRanchLevelHierarchy(data, selectedValue, t);
    } else {
      processedData = getNoRanchTreeNode(data, t);
    }
  }
  return processedData;
}
var RanchBlockSelect = function RanchBlockSelect(_ref) {
  var onSelect = _ref.onSelect,
    selected = _ref.selected,
    getSelectedRanchBlock = _ref.getSelectedRanchBlock,
    title = _ref.title;
    _ref.admin;
    var showFullHeight = _ref.showFullHeight;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    modal = _useState2[0],
    setModalState = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showSearch = _useState4[0],
    setShowSearch = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    searchText = _useState6[0],
    setSearchText = _useState6[1]; // state to maintain search text
  var dispatch = useDispatch();
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    options = _useState8[0],
    setOptions = _useState8[1]; // state to maintain select options

  // Load all entities, blocks and ranches
  // TODO: Remove it after PR-993 is merged
  // useEffect(() => {
  //   if (localStorage.getItem('refreshToken')) {
  //     setTimeout(() => { dispatch(loadFarmData(true)); }, 0);
  //   }
  // }, [dispatch]);

  // Get data as array of object format
  var finalData = useEntityRanchBlock(options);
  useEffect(function () {
    if (JSON.stringify(finalData) !== JSON.stringify(options)) {
      setOptions(finalData);
    }
  }, [finalData, options]);
  var onChange = function onChange(value) {
    if (!mobileScreen) dispatch(setUrlLoad(false));
    if (value === 'All Ranches') {
      var obj = {
        key: 'All Ranches',
        value: value,
        type: 'All Ranches'
      };
      if (onSelect) onSelect(obj);
      if (getSelectedRanchBlock instanceof Function) {
        getSelectedRanchBlock(obj);
      }
      return;
    }
    if (value) {
      var ids = value.split('_');
      var _obj = {
        key: value,
        value: ids[ids.length - 1],
        type: ids.length === 2 ? 'ranch' : 'block'
      };
      if (onSelect) onSelect(_obj);
      if (getSelectedRanchBlock instanceof Function) {
        getSelectedRanchBlock(_obj);
      }
    }
  };

  // To get the scrollable element by Id
  var scrollElementId;
  if (selected.type && selected.type === 'ranch') scrollElementId = "Ranch_".concat(selected.value);
  if (selected.type && selected.type === 'block') scrollElementId = "Block_".concat(selected.value);
  var scrollElem;
  var filterTreeNode = function filterTreeNode(txt, node) {
    var filterTitle = node.title.props.children;
    var result = !!(filterTitle && String(filterTitle).toLowerCase().indexOf(txt.toLowerCase()) !== -1);

    // To get the element when change the search text
    scrollElem = document.getElementById(scrollElementId);
    return result;
  };

  // To scroll the element to top when change text
  useEffect(function () {
    if (scrollElem) scrollElem.scrollIntoView({
      block: 'start'
    });
  });
  var handleOnClick = function handleOnClick(d) {
    if (d.target && !d.target.id.includes('Entity') && !d.target.id.includes('No_')) {
      setModalState(false);
      setSearchText();
      setShowSearch(false);
    }
  };

  // Get TreeNodes and expandKeys
  var selectObj = getCustomSelectOption(options, selected.value || [], t);
  var listHeight = calculatedHeightForMobile();
  var selectedValue = selected.key && selected.key.toLowerCase() === 'all ranches' ? t('All Ranches') : selected.key;
  var changedListHeight = 330;
  if (mobileScreen) changedListHeight = listHeight - 70;
  if (showFullHeight) changedListHeight = listHeight - 180;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      margin: 2
    }
  }, /*#__PURE__*/React.createElement(TreeSelect, {
    showSearch: mobileScreen || showFullHeight ? showSearch : !showSearch,
    style: {
      width: '100%'
    },
    bordered: false,
    value: selectedValue,
    placeholder: t('Please select'),
    multiple: false,
    treeDefaultExpandAll: true,
    onChange: onChange,
    onSearch: function onSearch(d) {
      return setSearchText(d);
    },
    listHeight: changedListHeight,
    onDropdownVisibleChange: function onDropdownVisibleChange(d) {
      if (mobileScreen) setModalState(true);else setModalState(d);
    },
    open: modal,
    filterTreeNode: filterTreeNode,
    treeNodeFilterProp: "value",
    treeNodeLabelProp: "name",
    searchValue: searchText,
    treeExpandedKeys: selectObj.expandKeys,
    dropdownRender: mobileScreen || showFullHeight ? function (menu) {
      return /*#__PURE__*/React.createElement(DropdownModal, {
        title: title || 'Select Ranch or Block',
        displayOptions: menu,
        mobileScreen: mobileScreen || showFullHeight,
        onClick: handleOnClick,
        onChange: function onChange(d) {
          setSearchText(d.target.value);
          setShowSearch(true);
        },
        displaySearch: true,
        buttonText: "cancel",
        size: mobileScreen || showFullHeight ? 'large' : 'middle',
        showFullHeight: showFullHeight
      });
    } : undefined,
    dropdownClassName: showFullHeight && !mobileScreen ? 'desktop-sidebar-container' : undefined,
    getPopupContainer: mobileScreen || showFullHeight ? null : function (triggerNode) {
      return triggerNode.parentNode;
    }
  }, /*#__PURE__*/React.createElement(TreeNode, {
    value: "All Ranches",
    name: "All Ranches",
    key: "All Ranches",
    title: /*#__PURE__*/React.createElement(Text, {
      key: "all_ranches",
      className: selected.value === null ? "".concat(styles$1['select-all'], " ").concat(styles$1.selected) : styles$1['select-all']
    }, t('All Ranches'))
  }), selectObj.nodes));
};
RanchBlockSelect.propTypes = {
  getSelectedRanchBlock: PropTypes.func,
  onSelect: PropTypes.func,
  selected: PropTypes.shape({
    value: PropTypes.any,
    key: PropTypes.any,
    type: PropTypes.any
  }),
  title: PropTypes.string,
  admin: PropTypes.bool,
  showFullHeight: PropTypes.bool
};
RanchBlockSelect.defaultProps = {
  getSelectedRanchBlock: null,
  onSelect: null,
  selected: {},
  title: null,
  admin: false,
  showFullHeight: false
};

NoDataToDisplay(Highcharts);
var defaultOptions = {
  title: null,
  chart: {
    type: 'column'
  },
  xAxis: {},
  yAxis: {},
  series: [],
  credits: {
    enabled: false
  },
  lang: {
    noData: 'No data'
  },
  noData: {
    style: {
      fontWeight: 'bold',
      fontSize: '15px',
      color: '#303030'
    }
  },
  time: {
    useUTC: false
  }
};
function BarHighchart(props) {
  var highchartsComponentRef = /*#__PURE__*/React.createRef();
  var options = props.options,
    constructorType = props.constructorType,
    chartElem = props.chartElem;
  var plotLineId = 'y2';
  var draggablePlotLine = useCallback(function (axis) {
    var clickY;
    var getPlotLine = function getPlotLine() {
      for (var i = 0; i < axis.plotLinesAndBands.length; i += 1) {
        if (axis.plotLinesAndBands[i].id === plotLineId) {
          return axis.plotLinesAndBands[i];
        }
      }
      return null;
    };
    var getValue = function getValue() {
      var plotLine = getPlotLine();
      var translation = plotLine.svgElem.translateY;
      var newValue = axis.toValue(translation) - axis.toValue(0) + plotLine.options.value;
      newValue = Math.max(axis.min, Math.min(axis.max, newValue));
      return newValue;
    };
    var dragStep = function dragStep(e) {
      var plotLine = getPlotLine();
      var newTranslation = e.pageY ? e.pageY - clickY : e.changedTouches['0'].pageY - clickY;
      var newValue = axis.toValue(newTranslation) - axis.toValue(0) + plotLine.options.value;
      newValue = Math.max(axis.min, Math.min(axis.max, newValue));
      newTranslation = axis.toPixels(newValue + axis.toValue(0) - plotLine.options.value);
      plotLine.svgElem.translate(0, newTranslation);
      if (getPlotLine().label) {
        plotLine.label.translate(0, newTranslation);
      }
      if (plotLine.options.onDragChange) {
        plotLine.options.onDragChange(newValue);
      }
      if (plotLine.label && Math.round(newValue) > axis.min && Math.round(newValue) < axis.max) {
        plotLine.label.attr({
          y: (e.pageY ? e.pageY : e.changedTouches['0'].pageY) - newValue
        });
      }
    };
    var _dragStop = null;
    var dragStart = function dragStart(e) {
      document.addEventListener('mousemove', dragStep, false);
      document.addEventListener('mouseup', _dragStop, false);
      document.addEventListener('touchstart', dragStep, false);
      document.addEventListener('touchmove', dragStep, false);
      document.addEventListener('touchend', _dragStop, false);
      var plotLine = getPlotLine();
      clickY = (e.pageY ? e.pageY : e.changedTouches['0'].pageY) - plotLine.svgElem.translateY;
      if (plotLine.options.onDragStart) {
        plotLine.options.onDragStart(getValue());
      }
    };
    _dragStop = function dragStop(e) {
      document.removeEventListener('mousemove', dragStep, false);
      document.removeEventListener('mouseup', _dragStop, false);
      document.removeEventListener('touchstart', dragStep, false);
      document.removeEventListener('touchmove', dragStep, false);
      document.removeEventListener('touchend', _dragStop, false);
      var plotLine = getPlotLine();
      if (plotLine) {
        var plotLineOptions = plotLine.options;
        // Remove + Re-insert plot line
        // Otherwise it gets messed up when chart is resized
        if (Object.prototype.hasOwnProperty.call(plotLine.svgElem, 'translateX')) {
          plotLineOptions.value = getValue();
          axis.removePlotLine(plotLineOptions.id);
          axis.addPlotLine(plotLineOptions);
          if (plotLineOptions.onDragFinish) {
            plotLineOptions.onDragFinish(plotLineOptions.value);
          }
        }
        var range = getValue();
        if (plotLine.label && range < axis.max && range > axis.min) {
          plotLine.label.attr({
            y: (e.pageY ? e.pageY : e.changedTouches['0'].pageY) - range
          });
        }
        getPlotLine().svgElem.css({
          cursor: 'pointer'
        }).translate(0, 0).on('touchstart', dragStart).on('mousedown', dragStart);
        if (getPlotLine().label) {
          getPlotLine().label.css({
            cursor: 'pointer'
          }).translate(0, 0).on('touchstart', dragStart).on('mousedown', dragStart);
        }
      }
    };
    _dragStop();
  }, []);
  useEffect(function () {
    var chart = highchartsComponentRef.current.chart;
    if (chart && chart.yAxis[0]) {
      draggablePlotLine(chart.yAxis[0]);
      chartElem(highchartsComponentRef.current);
    }
  }, [highchartsComponentRef, chartElem, draggablePlotLine]);
  return /*#__PURE__*/React.createElement(HighchartsReact, {
    constructorType: constructorType || 'chart',
    containerProps: {
      style: {
        height: '100%'
      }
    },
    highcharts: Highcharts,
    options: _objectSpread2(_objectSpread2({}, defaultOptions), options),
    ref: highchartsComponentRef
  });
}
BarHighchart.propTypes = {
  options: PropTypes.shape({}),
  constructorType: PropTypes.string,
  chartElem: PropTypes.func,
  chartRef: PropTypes.shape({
    current: PropTypes.any
  })
};
BarHighchart.defaultProps = {
  options: null,
  chartElem: null,
  constructorType: null,
  chartRef: null
};

var styles = {"icon":"BarChart_icon__byDDC"};

// BarChart component will receive the chartData, xCategories, onchange
// onChange: callback function to return 'yAxis' value when drag the horizontal line
// sample data:
// chartData: [1, 2, 5] (OR) [{y: 1, color: 'red'}, {y: 3, color: 'blue'}]
// xCategories: ['Jan', 'Feb'] || [10, 20, 30] || ['2021', '2022'] || ['2022/01/02', '2022/01/05']
// Render from web-ui/example/App.js
// import { BarChart } from 'farmx-web-ui';
// return (<BarChart chartData={[10,4,3]} xCategories={['Jan', 'Feb', 'Mar']} />)
function BarChart(props) {
  var chartData = props.chartData,
    xCategories = props.xCategories,
    onChange = props.onChange;
  var chartRef = useRef(null);
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    options = _useState2[0],
    setOptions = _useState2[1];
  var _useState3 = useState(chartData),
    _useState4 = _slicedToArray(_useState3, 2),
    newData = _useState4[0],
    setNewData = _useState4[1];
  var handleOnChange = useCallback(function (d) {
    if (onChange) onChange(d);
    var changedData = newData.map(function (e) {
      var obj = {};
      if (_typeof(e) === 'object' && e.y <= d) {
        obj = e;
        obj.color = 'pink';
        return obj;
      }
      if (e.y > d) {
        obj = e;
        obj.color = '#7cb5ec';
        return obj;
      }
      obj = {
        y: e,
        color: e <= d ? 'pink' : '#7cb5ec'
      };
      return obj;
    });
    setNewData(changedData);
  }, [newData, onChange]);
  var chartConfig = useCallback(function () {
    return {
      title: 'Bar Chart With Draggable Line',
      chart: {
        type: 'column'
      },
      legend: {
        enabled: false
      },
      xAxis: {
        categories: xCategories
      },
      yAxis: {
        plotLines: [{
          id: 'y2',
          color: 'skyblue',
          width: 2,
          value: 1,
          zIndex: 5,
          dashStyle: 'dash',
          label: {
            align: 'right',
            y: -12,
            x: 7,
            useHTML: true,
            text: "<svg class=".concat(styles.icon, ">\n              <path style=\" stroke:none;fill-rule:nonzero;\n              fill:rgb(29.019608%,16.470588%,78.039216%);fill-opacity:1;\" \n              d=\"M 9.179688 49.894531 L 9.179688 0.09375 L 41.976562 0.09375 L 41.976562 \n              49.894531 Z M 9.179688 49.894531 \"/>\n              <path style=\" stroke:none;fill-rule:evenodd;\n              fill:rgb(100%,100%,100%);fill-opacity:1;\" \n              d=\"M 33.53125 20.722656 L 17.359375 20.722656 L 25.445312 6.636719 Z M \n              33.53125 20.722656 \"/>\n              <path style=\" stroke:none;fill-rule:evenodd;\n              fill:rgb(100%,100%,100%);fill-opacity:1;\" \n              d=\"M 33.433594 29.132812 L 17.722656 29.132812 L 25.578125 42.683594 Z M \n              33.433594 29.132812 \"/>\n              <path style=\" stroke:none;fill-rule:nonzero;\n              fill:rgb(100%,100%,100%);fill-opacity:1;\" \n              d=\"M 15.355469 25.492188 L 35.800781 25.492188 L 35.800781 24.507812 L \n              15.355469 24.507812 Z M 15.355469 25.492188 \"/>\n              </svg>")
          },
          onDragStart: function onDragStart() {
            return null;
          },
          onDragChange: function onDragChange() {
            return null;
          },
          onDragFinish: function onDragFinish(newValue) {
            handleOnChange(newValue);
          }
        }]
      },
      plotOptions: {
        series: {
          borderRadius: 8
        }
      },
      series: [{
        showInLegend: 'false',
        data: newData
      }]
    };
  }, [newData, handleOnChange, xCategories]);
  function getChartElem(chartElem) {
    chartRef.current = chartElem;
  }
  useEffect(function () {
    if (chartRef.current) {
      var chart = chartRef.current.chart;
      if (chart) {
        chart.update({
          series: [{
            data: newData
          }],
          xAxis: {
            categories: xCategories
          }
        });
      }
    }
  }, [newData, xCategories]);
  useEffect(function () {
    var config = chartConfig();
    if (config && !options) {
      setOptions(config);
    }
  }, [options, chartConfig]);
  return /*#__PURE__*/React.createElement(BarHighchart, {
    options: options,
    chartElem: getChartElem
  });
}
BarChart.propTypes = {
  chartData: PropTypes.arrayOf(PropTypes.any),
  onChange: PropTypes.func,
  xCategories: PropTypes.arrayOf(PropTypes.any)
};
BarChart.defaultProps = {
  chartData: null,
  onChange: null,
  xCategories: null
};

function TreeSelectList(props) {
  var data = props.data,
    value = props.value,
    onSelect = props.onSelect;
  return data.map(function (entity, index) {
    var _entity$ranches;
    return /*#__PURE__*/React.createElement("div", {
      key: "option_".concat(String(index)),
      id: "option_".concat(index)
    }, (entity === null || entity === void 0 ? void 0 : entity.name) === 'All Ranches' ? /*#__PURE__*/React.createElement("li", {
      id: entity.id,
      value: null,
      onClick: function onClick(e) {
        return onSelect(e);
      },
      "aria-hidden": "true",
      className: !value ? "".concat(styles$1['select-all'], " ").concat(styles$1.selected) : "".concat(styles$1['select-all'])
    }, "All Ranches") : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("li", {
      id: entity === null || entity === void 0 ? void 0 : entity.id,
      onClick: function onClick(e) {
        return onSelect(e);
      },
      "aria-hidden": "true",
      type: "entity",
      className: "".concat(styles$1['entity-header'])
    }, entity.name), entity !== null && entity !== void 0 && (_entity$ranches = entity.ranches) !== null && _entity$ranches !== void 0 && _entity$ranches.length ? entity.ranches.map(function (ranch) {
      var _ranch$blocks;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("li", {
        key: "".concat(entity === null || entity === void 0 ? void 0 : entity.id, "_").concat(ranch === null || ranch === void 0 ? void 0 : ranch.id),
        id: ranch.id,
        onClick: function onClick(e) {
          return onSelect(e);
        },
        "aria-hidden": "true",
        type: "ranch",
        className: value === ranch.id ? "".concat(styles$1['ranch-header'], " ").concat(styles$1.selected) : "".concat(styles$1['ranch-header'])
      }, ranch.name), ranch !== null && ranch !== void 0 && (_ranch$blocks = ranch.blocks) !== null && _ranch$blocks !== void 0 && _ranch$blocks.length ? ranch.blocks.map(function (block) {
        return /*#__PURE__*/React.createElement("li", {
          id: block.id,
          key: "".concat(block.id),
          onClick: function onClick(e) {
            return onSelect(e);
          },
          "aria-hidden": "true",
          type: "block",
          className: value === block.id ? "".concat(styles$1['block-header'], " ").concat(styles$1.selected) : "".concat(styles$1['block-header'])
        }, block.name);
      }) : /*#__PURE__*/React.createElement("li", {
        id: "No_Block",
        onClick: function onClick(e) {
          return onSelect(e);
        },
        "aria-hidden": "true",
        type: "no_block",
        className: "".concat(styles$1['no-block'])
      }, "No Block"));
    }) : /*#__PURE__*/React.createElement("li", {
      id: "No_Ranch",
      onClick: function onClick(e) {
        return onSelect(e);
      },
      "aria-hidden": "true",
      type: "no_ranch",
      className: "".concat(styles$1['no-ranch'])
    }, "No Ranch")));
  });
}

var useBlockNames = hooks.useBlockNames,
  useRanchNames = hooks.useRanchNames;
var blockTagRender = function blockTagRender(args) {
  var label = args.label,
    _onClose = args.onClose,
    closable = args.closable;
  return /*#__PURE__*/React.createElement(Tag, {
    closable: closable,
    onClose: function onClose(e) {
      e.preventDefault();
      _onClose(e);
    }
  }, label.props ? label.props.block.name : label);
};
var ModalSelect = function ModalSelect(props) {
  var defaultOption = props.defaultOption,
    onSelect = props.onSelect,
    type = props.type,
    mode = props.mode,
    data = props.data,
    title = props.title,
    placeholder = props.placeholder,
    selected = props.selected;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(defaultOption),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  var _useState3 = useState(Number(selected === null || selected === void 0 ? void 0 : selected.value)),
    _useState4 = _slicedToArray(_useState3, 2),
    rbValue = _useState4[0],
    setRBValue = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    searchText = _useState6[0],
    setSearchText = _useState6[1];
  var allRanches = !title ? {
    name: 'All Ranches',
    id: 'null',
    isLoading: false
  } : null;
  var originalData = useRef([]);
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    modal = _useState8[0],
    setModal = _useState8[1];
  var blockNames = useBlockNames(value.length ? value.map(function (d) {
    return Number(d);
  }) : [rbValue]);
  var ranchNames = useRanchNames(value.length ? value.map(function (d) {
    return Number(d);
  }) : [rbValue]);
  var selectedName;
  if ((selected === null || selected === void 0 ? void 0 : selected.type) === 'block') selectedName = blockNames[rbValue];
  if ((selected === null || selected === void 0 ? void 0 : selected.type) === 'ranch') selectedName = ranchNames[rbValue];
  if (['All Ranches', 'entity'].includes(selected === null || selected === void 0 ? void 0 : selected.type)) selectedName = 'All Ranches';
  useEffect(function () {
    var allData = allRanches ? [allRanches].concat(_toConsumableArray(data)) : data;
    if (JSON.stringify(originalData.current) !== JSON.stringify(allData)) {
      originalData.current = allData;
    }
  }, [allRanches, data]);
  useEffect(function () {
    if (selected.value) setRBValue(Number(selected === null || selected === void 0 ? void 0 : selected.value));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selected === null || selected === void 0 ? void 0 : selected.value]);
  var RBSelect = type === 'RanchBlockSelect';
  var onChange = function onChange(d) {
    var _d$target, _d$target2, _d$target3;
    var val = [d.target.id];
    var conditionCheck = (d === null || d === void 0 || (_d$target = d.target) === null || _d$target === void 0 ? void 0 : _d$target.type) !== 'entity' && (d === null || d === void 0 || (_d$target2 = d.target) === null || _d$target2 === void 0 ? void 0 : _d$target2.type) !== 'no_ranch' && (d === null || d === void 0 || (_d$target3 = d.target) === null || _d$target3 === void 0 ? void 0 : _d$target3.type) !== 'no_block';
    if (RBSelect && conditionCheck) {
      setRBValue(Number(d.target.id));
      val = {
        type: d.target.type,
        value: d.target.id,
        key: d.target.key
      };
      setModal(false);
    }
    setSearchText('');
    if (onSelect && conditionCheck) onSelect(val);
  };
  var onButtonClick = function onButtonClick(val) {
    setModal(val);
  };
  function isStringExists(name, filterText) {
    return (name === null || name === void 0 ? void 0 : name.toLowerCase().indexOf(filterText)) > -1;
  }

  // To get the scrollable element by Id
  var scrollElementId = "".concat(selected.value);
  var scrollElem;
  function customFilter(input) {
    var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    // To get the element when change the search text
    scrollElem = document.getElementById(scrollElementId);
    var str = input === null || input === void 0 ? void 0 : input.toLowerCase();
    if (RBSelect) {
      if (str !== null && str !== void 0 && str.length) {
        var finalData = [];
        var allData = originalData.current;
        allData.forEach(function (d) {
          var obj = {
            id: d.id,
            name: d.name,
            isLoading: d.isLoading,
            ranches: []
          };
          if (isStringExists(d.name, str)) {
            obj.ranches = d.ranches;
            finalData.push(obj);
            return;
          }
          if (d.ranches && d.ranches.length) {
            d.ranches.forEach(function (ra) {
              var rObj = {
                id: ra.id,
                name: ra.name,
                isLoading: ra.isLoading,
                blocks: []
              };
              if (isStringExists(ra.name, str)) {
                rObj.blocks = ra.blocks;
                obj.ranches.push(rObj);
                finalData.push(obj);
              } else if (ra.blocks && ra.blocks.length) {
                var blocks = ra.blocks.filter(function (b) {
                  return isStringExists(b.name, str);
                });
                if (blocks.length) {
                  rObj.blocks = blocks;
                  obj.ranches.push(rObj);
                  finalData.push(obj);
                }
              }
            });
          }
        });
        return finalData.filter(function (v, i, a) {
          return a.indexOf(v) === i;
        });
      }
      return option;
    }
    return option;
  }

  // To scroll the element to top when change text
  useEffect(function () {
    if (scrollElem) scrollElem.scrollIntoView({
      block: 'start'
    });
  });
  var listHeight = calculatedHeightForMobile();
  var divHeight = "".concat(listHeight - 70, "px");
  function getOptions() {
    var lastY = 0;
    return /*#__PURE__*/React.createElement("div", {
      className: "".concat(styles$7['flex-container'], " ").concat(styles$7['tree-select-dropdown'])
    }, isMobile && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: styles$7['modal-select-header']
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$7['modal-select-header-text']
    }, t(title !== null && title !== void 0 && title.length ? title : t('Select Ranch or Block')))), /*#__PURE__*/React.createElement(Input, {
      className: styles$7['search-box'],
      placeholder: "".concat(t('Type to Search'), "..."),
      onChange: function onChange(d) {
        var _d$target4;
        return setSearchText(d === null || d === void 0 || (_d$target4 = d.target) === null || _d$target4 === void 0 ? void 0 : _d$target4.value);
      },
      onKeyDown: function onKeyDown(e) {
        return e.stopPropagation();
      },
      ref: function ref(input) {
        return input && input.focus();
      },
      allowClear: true
    })), /*#__PURE__*/React.createElement("div", {
      className: "".concat(styles$7['sensor-option-div'], " ").concat(styles$7['mobile-select-scrollable-div']),
      style: {
        height: divHeight
      },
      onTouchStart: function onTouchStart(e) {
        e.currentTarget.style.touchAction = 'manipulation';
        lastY = e.touches[0].clientY;
      },
      onTouchMove: function onTouchMove(e) {
        var top = e.touches[0].clientY;
        var _e$currentTarget = e.currentTarget,
          scrollTop = _e$currentTarget.scrollTop,
          scrollHeight = _e$currentTarget.scrollHeight,
          offsetHeight = _e$currentTarget.offsetHeight;
        var maxScrollTop = scrollHeight - offsetHeight;
        var direction = lastY - top < 0 ? 'up' : 'down';
        if (scrollTop === 0 && direction === 'up' || scrollTop >= maxScrollTop && direction === 'down') {
          e.preventDefault();
          if (e.currentTarget.style.touchAction !== 'none') {
            e.currentTarget.style.touchAction = 'none';
          }
        }
        lastY = top;
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        height: divHeight
      }
    }, /*#__PURE__*/React.createElement(TreeSelectList, {
      data: customFilter(searchText, originalData.current),
      onSelect: onChange,
      value: rbValue
    }))), isMobile && /*#__PURE__*/React.createElement("div", {
      className: "".concat(styles$7['button-centered'], " ").concat(styles$7['modal-custom-button'])
    }, /*#__PURE__*/React.createElement(Button, {
      type: "primary",
      onClick: function onClick() {
        return onButtonClick(false);
      },
      className: "".concat(styles$7['cancel-button-color'], " \n            ").concat(styles$7['mobile-dropdown-modal-button']),
      size: "middle",
      block: true
    }, mode !== 'multiple' && RBSelect ? 'Cancel' : 'Done')));
  }
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Select, {
    showSearch: true,
    onSearch: function onSearch(d) {
      return setSearchText(d);
    },
    mode: mode,
    allowClear: !RBSelect,
    style: {
      width: '100%'
    },
    placeholder: t(placeholder || 'Please select'),
    value: selectedName,
    onChange: function onChange(d) {
      if (!RBSelect) {
        if (!d) setValue([]);else setValue(d);
      }
    },
    onMouseDown: function onMouseDown(e) {
      e.preventDefault();
      e.stopPropagation();
    },
    tagRender: blockTagRender,
    dropdownClassName: styles$7['mobile-select-dropdown-style'],
    bordered: false,
    open: modal,
    onDropdownVisibleChange: function onDropdownVisibleChange() {
      return setModal(true);
    },
    dropdownRender: function dropdownRender() {
      return getOptions();
    },
    dropdownStyle: {
      height: "".concat(divHeight, "px")
    }
  })));
};
ModalSelect.propTypes = {
  mode: PropTypes.string,
  data: PropTypes.arrayOf(PropTypes.object),
  onSelect: PropTypes.func,
  placeholder: PropTypes.string,
  defaultOption: PropTypes.arrayOf(PropTypes.any),
  title: PropTypes.string,
  type: PropTypes.string,
  selected: PropTypes.shape({
    value: PropTypes.any,
    key: PropTypes.any,
    type: PropTypes.any
  })
};
ModalSelect.defaultProps = {
  mode: null,
  data: null,
  onSelect: null,
  placeholder: null,
  defaultOption: [],
  title: '',
  type: null,
  selected: {}
};

var useEntities = hooks.useEntities;
var RanchBlockWrapper = function RanchBlockWrapper(props) {
  var mode = props.mode;
    props.items;
    var loadItems = props.loadItems,
    type = props.type,
    placeholder = props.placeholder,
    onSelect = props.onSelect,
    value = props.value,
    title = props.title,
    defaultOption = props.defaultOption,
    selected = props.selected,
    getSelectedRanchBlock = props.getSelectedRanchBlock;
    props.onChange;
  var dispatch = useDispatch();
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    options = _useState2[0],
    setOptions = _useState2[1]; // state to maintain select options
  var isRanchBlockSelect = type === 'RanchBlockSelect';
  var _useEntities = useEntities(),
    selectedEntity = _useEntities.selectedEntity;
  useEffect(function () {
    if (loadItems) loadItems();
    // TODO: Remove it after PR-993 is merged
    // else dispatch(loadFarmData());
  }, [dispatch, loadItems]);
  useEffect(function () {
    // set options whenever entity is changed
    if (JSON.stringify(selectedEntity) !== JSON.stringify(options) && selectedEntity) {
      setOptions([selectedEntity]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedEntity === null || selectedEntity === void 0 ? void 0 : selectedEntity.id]);
  var customOnSelect = function customOnSelect(val) {
    if (isRanchBlockSelect) {
      var id = val.value;
      var obj = {
        key: val[0],
        value: id,
        type: val.type
      };
      if (val.value === 'null') {
        obj = {
          key: 'All Ranches',
          value: null,
          type: 'All Ranches'
        };
      }
      if (onSelect) onSelect(obj);
      if (getSelectedRanchBlock instanceof Function) {
        getSelectedRanchBlock(obj);
      }
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "mobile-select-modal"
  }, /*#__PURE__*/React.createElement(ModalSelect, {
    data: isRanchBlockSelect ? options : [],
    defaultOption: defaultOption || [],
    onSelect: customOnSelect,
    placeholder: placeholder,
    value: value || [],
    title: title,
    type: type,
    mode: mode,
    selected: selected
  }));
};
RanchBlockWrapper.propTypes = {
  mode: PropTypes.string,
  loadItems: PropTypes.func,
  items: PropTypes.arrayOf(PropTypes.object),
  onSelect: PropTypes.func,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  defaultOption: PropTypes.arrayOf(PropTypes.any),
  value: PropTypes.arrayOf(PropTypes.any),
  title: PropTypes.string,
  type: PropTypes.string,
  selected: PropTypes.shape({
    value: PropTypes.any,
    key: PropTypes.any,
    type: PropTypes.any
  }),
  getSelectedRanchBlock: PropTypes.func
};
RanchBlockWrapper.defaultProps = {
  mode: 'single',
  loadItems: null,
  items: null,
  onSelect: null,
  onChange: null,
  placeholder: null,
  defaultOption: [],
  value: null,
  title: '',
  type: 'RanchBlockSelect',
  selected: {},
  getSelectedRanchBlock: null
};

var getColorForValue = function getColorForValue(value) {
  if (value) return 'green';
  return 'default';
};
var ActiveTag = function ActiveTag(_ref) {
  var value = _ref.value;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  if (value === undefined || value === null) return null;
  return /*#__PURE__*/React.createElement(Tag, {
    color: getColorForValue(value)
  }, value ? t('active') : t('inactive'));
};
ActiveTag.propTypes = {
  value: PropTypes.bool
};
ActiveTag.defaultProps = {
  value: undefined
};

var RanchBlockTag = function RanchBlockTag(_ref) {
  var ranchName = _ref.ranchName,
    blockName = _ref.blockName;
  if (!ranchName) return null;
  return /*#__PURE__*/React.createElement(Tag, {
    color: "default"
  }, "".concat(ranchName, " / ").concat(blockName));
};
RanchBlockTag.propTypes = {
  ranchName: PropTypes.string,
  blockName: PropTypes.string
};
RanchBlockTag.defaultProps = {
  ranchName: undefined,
  blockName: undefined
};

var EventCategorySelect = function EventCategorySelect(_ref) {
  var onChange = _ref.onChange,
    value = _ref.value,
    placeholder = _ref.placeholder;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var options = [{
    value: "control",
    label: t("Control")
  }, {
    value: "data",
    label: t("Data")
  }, {
    value: "network",
    label: t("Network")
  }];
  return /*#__PURE__*/React.createElement(Select, {
    value: value,
    placeholder: placeholder || t("Event Category"),
    options: options,
    onChange: onChange,
    allowClear: true,
    dropdownMatchSelectWidth: false,
    getPopupContainer: function getPopupContainer(trigger) {
      return trigger.parentNode;
    }
  });
};
EventCategorySelect.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.oneOf([null, undefined, 'control', 'data', 'network']),
  placeholder: PropTypes.string
};
EventCategorySelect.defaultProps = {
  onChange: function onChange() {},
  value: null,
  placeholder: null
};

var EventCategoryTag = function EventCategoryTag(_ref) {
  var value = _ref.value;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(Tag, {
    color: "default"
  }, t(value));
};
EventCategoryTag.propTypes = {
  value: PropTypes.string.isRequired
};

var iconSize = 24;
var EventLogLevelIcon = function EventLogLevelIcon(_ref) {
  var value = _ref.value;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  function getIcon() {
    if (value === 'info') {
      return /*#__PURE__*/React.createElement(FaInfoCircle, {
        color: "grey",
        size: iconSize
      });
    }
    if (value === 'warning') {
      return /*#__PURE__*/React.createElement(FaExclamationTriangle, {
        color: "orange",
        size: iconSize
      });
    }
    if (value === 'error') {
      return /*#__PURE__*/React.createElement(FaTimesCircle, {
        color: "red",
        size: iconSize
      });
    }
    return null;
  }
  var icon = getIcon();
  if (!icon) return null;
  return /*#__PURE__*/React.createElement(Tooltip, {
    title: t(value),
    placement: "bottom"
  }, icon);
};
EventLogLevelIcon.propTypes = {
  value: PropTypes.string.isRequired
};

var EventTypeSelect = function EventTypeSelect(_ref) {
  var onChange = _ref.onChange,
    value = _ref.value,
    placeholder = _ref.placeholder;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var options = [{
    value: 'anomaly',
    label: t('Anomaly')
  }, {
    value: 'battery',
    label: t('Battery')
  }, {
    value: 'connectivity',
    label: t('Connectivity')
  }, {
    value: 'override',
    label: t('Override')
  }, {
    value: 'schedule',
    label: t('Schedule')
  }, {
    value: 'status',
    label: t('Status')
  }];
  return /*#__PURE__*/React.createElement(Select, {
    value: value,
    placeholder: placeholder || t('Event Type'),
    options: options,
    onChange: onChange,
    allowClear: true,
    dropdownMatchSelectWidth: false,
    getPopupContainer: function getPopupContainer(trigger) {
      return trigger.parentNode;
    }
  });
};
EventTypeSelect.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.oneOf([null, undefined, 'anomaly', 'battery', 'connectivity', 'override', 'schedule', 'status']),
  placeholder: PropTypes.string
};
EventTypeSelect.defaultProps = {
  onChange: function onChange() {},
  value: null,
  placeholder: null
};

var EventTypeTag = function EventTypeTag(_ref) {
  var value = _ref.value;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(Tag, {
    color: "default"
  }, t(value));
};
EventTypeTag.propTypes = {
  value: PropTypes.string.isRequired
};

var LogLevelSelect = function LogLevelSelect(_ref) {
  var onChange = _ref.onChange,
    value = _ref.value,
    placeholder = _ref.placeholder;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var options = [{
    value: "error",
    label: t("Error")
  }, {
    value: "warning",
    label: t("Warning")
  }, {
    value: "info",
    label: t("Info")
  }];
  return /*#__PURE__*/React.createElement(Select, {
    value: value,
    placeholder: placeholder || t("Log level"),
    options: options,
    onChange: onChange,
    allowClear: true,
    dropdownMatchSelectWidth: false,
    getPopupContainer: function getPopupContainer(trigger) {
      return trigger.parentNode;
    }
  });
};
LogLevelSelect.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.oneOf([null, undefined, 'error', 'warning', 'info']),
  placeholder: PropTypes.string
};
LogLevelSelect.defaultProps = {
  onChange: function onChange() {},
  value: null,
  placeholder: null
};

export { ActiveTag, AdminRoute, AppTemplate, BarChart, BlockControlList, BlockSelect, BooleanTag, ChangePasswordPage as ChangePasswordForm, ChartComponent, CollapsableSidebar, RefreshContext as ControlSummaryRefreshContext, ControlSystemStatus, EntityList, EntitySelect, EventCategorySelect, EventCategoryTag, EventLogLevelIcon, EventTypeSelect, EventTypeTag, FilterListItem, HighchartsSchedule, InputTime, InputVolume, InstallStateTag, LatLngButton, LogLevelSelect, LogoutRedirect, ResizeDetector as Map, MapSettingsMenu, PrivateRoute, PumpControlList, RanchBlockSelect, RanchBlockWrapper as RanchBlockSelectMobile, RanchBlockTag, RanchSelect, SchedulerMobile, Schedule as SchedulerTimeline, Searchbox, SensorAlarmButton, SensorSelect, SensorTypeSelect, SensorTypeTag, Slider, StoplightTag, UserMenu, UserMenuOptions, ValveControlList, buildConfigV1, excludedNodeKeys, getAnomalyIcon, getAnomalyIconColor, getColorCodeForIrrigationState, getMarkerTooltipByPresentationMode, icons, mapPresentationModes, monitoringTableFieldNames, newApiCallNeeded, nodeOperationsTableFieldNames, nodeStatusKeys, nodeStatusUnits, prepareGraphData, prepareMarker, prepareMarkerClusterIcon, prepareMarkerClusterIconColor, prepareNodeHealthGraphData, prepareNumberForDisplay, prepareRanchMarker, prepareZeroIslandSensors, processDataGap, sensorTitles, sensorTypeAllowedForMode, stateColorCode, stateTagColorCodes, stateTagTextColorCodes, useGetSensorData, useWindowSize };
